// grip-specs.js -- Grips4Less grip recommendation dataset
window.GRIP_SPECS = [
  {
    "id": "alpha-golf-alpha-full-cord",
    "brand": "Alpha Golf",
    "model": "Alpha Full-Cord",
    "type": "club",
    "spec_confidence": "derived",
    "material": "full cord",
    "texture": "corded",
    "feel": "medium",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Cord Standard Grip"
    ],
    "weight_g_by_size": {
      "Standard": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 1.75,
    "price_max": 1.75,
    "single_price_min": 1.75,
    "single_price_max": 1.75,
    "normalized_price_per_grip": 1.75,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/alpha-full-cord-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/alpha-cord-grip.jpg?v=1636059859",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Cord Standard Grip"
        ],
        "price": 1.75,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/alpha-full-cord-standard-grip",
        "handle": "alpha-full-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "39461739036733",
            "gid": "gid://shopify/ProductVariant/39461739036733",
            "sku": "AXLF-M58R",
            "color": "Cord Standard Grip",
            "size": "Standard",
            "selected_options": {
              "Title": "Alpha FC Grip"
            },
            "available": true,
            "price": 1.75,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/alpha-full-cord-standard-grip?variant=39461739036733"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Alpha FC Grip"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "49 under, 58 core, All products, Alpha, alpha-golf, cord, cord-golf-grips, full cord, iron/wood, medium firm, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Cord Standard Grip"
    ]
  },
  {
    "id": "avon-chamois",
    "brand": "Avon",
    "model": "Chamois",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Ladies",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Ladies",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "Blue"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Undersize": 63.5,
      "Ladies": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 4.43,
    "price_max": 84.5,
    "single_price_min": 4.43,
    "single_price_max": 6.5,
    "normalized_price_per_grip": 3.99,
    "bundle_price_min": 35.88,
    "kit_price_min": 67.52,
    "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/avon-chamois-jumbo-2colors.jpg?v=1766011452",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 10,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 84.5,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black-bundle-13pcs",
        "handle": "avon-chamois-jumbo-grip-black-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398926000498",
            "gid": "gid://shopify/ProductVariant/61398926000498",
            "sku": "SET-13x1014",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 84.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black-bundle-13pcs?variant=61398926000498"
          },
          {
            "id": "61398926033266",
            "gid": "gid://shopify/ProductVariant/61398926033266",
            "sku": "SET-13x1014A",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 84.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black-bundle-13pcs?variant=61398926033266"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 35.88,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/avon-chamois-standard-grip-black-grip-bundle-set",
        "handle": "avon-chamois-standard-grip-black-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976346685",
            "gid": "gid://shopify/ProductVariant/41021976346685",
            "sku": "SET-9x1016",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 35.88,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/avon-chamois-standard-grip-black-grip-bundle-set?variant=41021976346685"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 52.65,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black-grip-bundle-set",
        "handle": "avon-chamois-jumbo-grip-black-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021976248381",
            "gid": "gid://shopify/ProductVariant/41021976248381",
            "sku": "SET-9x1014",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 52.65,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black-grip-bundle-set?variant=41021976248381"
          },
          {
            "id": "41021976281149",
            "gid": "gid://shopify/ProductVariant/41021976281149",
            "sku": "SET-9x1014A",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 52.65,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black-grip-bundle-set?variant=41021976281149"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 43.34,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black-grip-bundle-set",
        "handle": "avon-chamois-lady-grip-black-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Pink",
              "Purple"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021973233725",
            "gid": "gid://shopify/ProductVariant/41021973233725",
            "sku": "SET-9x1017",
            "color": "Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 43.34,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black-grip-bundle-set?variant=41021973233725"
          },
          {
            "id": "41021973266493",
            "gid": "gid://shopify/ProductVariant/41021973266493",
            "sku": "SET-9x1015PK",
            "color": "Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 43.34,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black-grip-bundle-set?variant=41021973266493"
          },
          {
            "id": "41021973299261",
            "gid": "gid://shopify/ProductVariant/41021973299261",
            "sku": "SET-9x1015F",
            "color": "Purple",
            "size": "Undersize",
            "selected_options": {
              "Color": "Purple",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 43.34,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black-grip-bundle-set?variant=41021973299261"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 67.52,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/avon-chamois-standard-grip-black-13pcs-golf-grip-kit",
        "handle": "avon-chamois-standard-grip-black-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007850295357",
            "gid": "gid://shopify/ProductVariant/32007850295357",
            "sku": "KIT+13x1016",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 67.52,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/avon-chamois-standard-grip-black-13pcs-golf-grip-kit?variant=32007850295357"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 70.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black-13pcs-golf-grip-kit",
        "handle": "avon-chamois-jumbo-grip-black-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007850229821",
            "gid": "gid://shopify/ProductVariant/32007850229821",
            "sku": "KIT+13x1014",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 70.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black-13pcs-golf-grip-kit?variant=32007850229821"
          },
          {
            "id": "32007850262589",
            "gid": "gid://shopify/ProductVariant/32007850262589",
            "sku": "KIT+13x1014A",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 70.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black-13pcs-golf-grip-kit?variant=32007850262589"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Ladies"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 71.07,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black-13pcs-golf-grip-kit",
        "handle": "avon-chamois-lady-grip-black-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007849639997",
            "gid": "gid://shopify/ProductVariant/32007849639997",
            "sku": "KIT+13x1015",
            "color": "Black",
            "size": "Ladies",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 71.07,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black-13pcs-golf-grip-kit?variant=32007849639997"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 5.35,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black",
        "handle": "avon-chamois-lady-grip-black",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Pink",
              "Purple"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40369955766333",
            "gid": "gid://shopify/ProductVariant/40369955766333",
            "sku": "1017",
            "color": "Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 5.35,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black?variant=40369955766333"
          },
          {
            "id": "40369955799101",
            "gid": "gid://shopify/ProductVariant/40369955799101",
            "sku": "1015PK",
            "color": "Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 5.35,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black?variant=40369955799101"
          },
          {
            "id": "40369955831869",
            "gid": "gid://shopify/ProductVariant/40369955831869",
            "sku": "1015F",
            "color": "Purple",
            "size": "Undersize",
            "selected_options": {
              "Color": "Purple",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 5.35,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-lady-grip-black?variant=40369955831869"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black",
        "handle": "avon-chamois-jumbo-grip-black",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "123642692",
            "gid": "gid://shopify/ProductVariant/123642692",
            "sku": "1014",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 6.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black?variant=123642692"
          },
          {
            "id": "12851554779197",
            "gid": "gid://shopify/ProductVariant/12851554779197",
            "sku": "1014A",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 6.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-jumbo-grip-black?variant=12851554779197"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 4.43,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/avon-chamois-standard-grip-black",
        "handle": "avon-chamois-standard-grip-black",
        "shopify_variants": [
          {
            "id": "40682621370429",
            "gid": "gid://shopify/ProductVariant/40682621370429",
            "sku": "1016",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 4.43,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/avon-chamois-standard-grip-black?variant=40682621370429"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, arthritic, arthritic-golf-grips, avon, Chamois, golf-grips, grip bundle, iron/wood, jumbo/oversize, Most Popular Discount Golf Grips, new-add-12172025, oversize, oversize-jumbo-golf-grips, overstock-mar2024, single-golf-grips, single-grip, soft, under-15",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Blue",
      "Purple"
    ]
  },
  {
    "id": "avon-chamois-ii",
    "brand": "Avon",
    "model": "Chamois II",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Jumbo/Oversize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.03,
    "price_max": 82.64,
    "single_price_min": 5.03,
    "single_price_max": 5.32,
    "normalized_price_per_grip": 4.53,
    "bundle_price_min": 40.74,
    "kit_price_min": 78.87,
    "url": "https://www.grips4less.com/products/avon-chamois-ii-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/avon-chamois-ii_091b7d8d-c72c-49b2-bfec-36fcd4240530.jpg?v=1735455624",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 5,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 40.74,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/avon-chamois-ii-standard-grip-grip-bundle-set",
        "handle": "avon-chamois-ii-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967925309",
            "gid": "gid://shopify/ProductVariant/41021967925309",
            "sku": "SET-9x1028",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 40.74,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/avon-chamois-ii-standard-grip-grip-bundle-set?variant=41021967925309"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 82.64,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/avon-chamois-ii-jumbo-grip-13pcs-golf-grip-kit",
        "handle": "avon-chamois-ii-jumbo-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007847280701",
            "gid": "gid://shopify/ProductVariant/32007847280701",
            "sku": "KIT+13x1029",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 82.64,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-ii-jumbo-grip-13pcs-golf-grip-kit?variant=32007847280701"
          },
          {
            "id": "32007847313469",
            "gid": "gid://shopify/ProductVariant/32007847313469",
            "sku": "KIT+13x1029A",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 82.64,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-chamois-ii-jumbo-grip-13pcs-golf-grip-kit?variant=32007847313469"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 78.87,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/avon-chamois-ii-standard-grip-13pcs-golf-grip-kit",
        "handle": "avon-chamois-ii-standard-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007847247933",
            "gid": "gid://shopify/ProductVariant/32007847247933",
            "sku": "KIT+13x1028",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 78.87,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/avon-chamois-ii-standard-grip-13pcs-golf-grip-kit?variant=32007847247933"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 5.03,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/avon-chamois-ii-standard-grip",
        "handle": "avon-chamois-ii-standard-grip",
        "shopify_variants": [
          {
            "id": "41088045678653",
            "gid": "gid://shopify/ProductVariant/41088045678653",
            "sku": "1028",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 5.03,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/avon-chamois-ii-standard-grip?variant=41088045678653"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.32,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/avon-chamois-ii-jumbo-grip",
        "handle": "avon-chamois-ii-jumbo-grip",
        "shopify_variants": [
          {
            "id": "5417757185",
            "gid": "gid://shopify/ProductVariant/5417757185",
            "sku": "1029",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 5.32,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/avon-chamois-ii-jumbo-grip?variant=5417757185"
          },
          {
            "id": "8838040682557",
            "gid": "gid://shopify/ProductVariant/8838040682557",
            "sku": "1029A",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 5.32,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/avon-chamois-ii-jumbo-grip?variant=8838040682557"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "49 under, All Products, arthritic, arthritic-golf-grips, avon, Chamois II, golf-grips, grip bundle, iron/wood, new-bundle-set, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "avon-tacki-mac-pro-d2x-dual-molded",
    "brand": "Avon",
    "model": "Tacki-Mac Pro D2X Dual Molded",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black/Blue"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.99,
    "price_max": 83.57,
    "single_price_min": 5.99,
    "single_price_max": 5.99,
    "normalized_price_per_grip": 5.39,
    "bundle_price_min": 48.52,
    "kit_price_min": 83.57,
    "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/avon-pro-d2x-red-and-blue_09766069-ff91-403f-b5ed-01ec178030a9.jpg?v=1735455603",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black/Blue"
        ],
        "price": 48.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard-grip-bundle-set",
        "handle": "tacki-mac-dual-molded-red-black-standard-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/Blue",
              "Black/Red"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021971824701",
            "gid": "gid://shopify/ProductVariant/41021971824701",
            "sku": "SET-9x1011-BPRO-D2X-U",
            "color": "Black/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard-grip-bundle-set?variant=41021971824701"
          },
          {
            "id": "41021971857469",
            "gid": "gid://shopify/ProductVariant/41021971857469",
            "sku": "SET-9x1011-BPRO-D2X",
            "color": "Black/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/Red",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard-grip-bundle-set?variant=41021971857469"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black/Blue"
        ],
        "price": 83.57,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard-13pcs-golf-grip-kit",
        "handle": "tacki-mac-dual-molded-red-black-standard-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/Blue",
              "Black/Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007848001597",
            "gid": "gid://shopify/ProductVariant/32007848001597",
            "sku": "KIT+13x1011-BPRO-D2X-U",
            "color": "Black/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/Blue"
            },
            "available": false,
            "price": 83.57,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard-13pcs-golf-grip-kit?variant=32007848001597"
          },
          {
            "id": "32007848034365",
            "gid": "gid://shopify/ProductVariant/32007848034365",
            "sku": "KIT+13x1011-BPRO-D2X",
            "color": "Black/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/Red"
            },
            "available": false,
            "price": 83.57,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard-13pcs-golf-grip-kit?variant=32007848034365"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black/Blue"
        ],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard",
        "handle": "tacki-mac-dual-molded-red-black-standard",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/Blue",
              "Black/Red"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13970383601725",
            "gid": "gid://shopify/ProductVariant/13970383601725",
            "sku": "1011-BPRO-D2X-U",
            "color": "Black/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/Blue"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard?variant=13970383601725"
          },
          {
            "id": "13184903970877",
            "gid": "gid://shopify/ProductVariant/13184903970877",
            "sku": "1011-BPRO-D2X",
            "color": "Black/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/Red"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-dual-molded-red-black-standard?variant=13184903970877"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, avon, dual molded, golf-grips, grip bundle, iron/wood, new-bundle-set, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "avon-training",
    "brand": "Avon",
    "model": "Training",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "training_only",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 9.99,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/avon-training-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/LEFT_HANDED_TRAINING_M08_1.jpg?v=1750304225",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/avon-training-grip",
        "handle": "avon-training-grip",
        "shopify_options": [
          {
            "name": "Hand",
            "values": [
              "For Right Handed Players",
              "For Left Handed Players"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52335148925298",
            "gid": "gid://shopify/ProductVariant/52335148925298",
            "sku": "AV-M07",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Right Handed Players",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-training-grip?variant=52335148925298"
          },
          {
            "id": "52335148958066",
            "gid": "gid://shopify/ProductVariant/52335148958066",
            "sku": "AV-M08",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Left Handed Players",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/avon-training-grip?variant=52335148958066"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, lamkin, Lamkin Training, single-golf-grips, single-grip, training, training-beginner-practice, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-align-max-z-grip",
    "brand": "Golf Pride",
    "model": "ALIGN Max Z-Grip",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "ALIGN ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ALIGN",
    "alignment_description": "Raised ridge along the underside designed to promote consistent hand placement.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Grip Midsize",
      "Grip Standard"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 15.99,
    "price_max": 15.99,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-align-max-z-grip-standard",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ALIGN_Max_ZGRIP_bothview.jpg?v=1774025142",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Grip Standard"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-align-max-z-grip-standard",
        "handle": "golf-pride-align-max-z-grip-standard",
        "shopify_variants": [
          {
            "id": "61618542838130",
            "gid": "gid://shopify/ProductVariant/61618542838130",
            "sku": "GRZS-60R-C04-XA",
            "color": "Grip Standard",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-align-max-z-grip-standard?variant=61618542838130"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Grip Midsize"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-align-max-z-grip-midsize",
        "handle": "golf-pride-align-max-z-grip-midsize",
        "shopify_variants": [
          {
            "id": "61502762221938",
            "gid": "gid://shopify/ProductVariant/61502762221938",
            "sku": "GRZM-60R-C05-XA",
            "color": "Grip Midsize",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-align-max-z-grip-midsize?variant=61502762221938"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "49 under, Alignment golf grip, alignment-golf-grips, All Products, all-weather, cord, cord-golf-grips, firm, full cord, Golf Pride Align, Golf Pride Align MAX, Golf Pride Cord Grips, golf pride single grip, Golf Pride Z-Grip, golf-grips, golf-pride, iron/wood, New 2019 Golf Grips, NEW Golf Pride 201",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Grip Standard",
      "Grip Midsize"
    ]
  },
  {
    "id": "golf-pride-cp2-pro",
    "brand": "Golf Pride",
    "model": "CP2 Pro",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (soft compound)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.99,
    "price_max": 153.37,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 10.99,
    "bundle_price_min": 87.92,
    "kit_price_min": 153.37,
    "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/print-cp2-pro_front-1700_55f5855e-723e-4ad1-bf0d-6e1e73a5515c.jpg?v=1761759892",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 20,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-pro-undersize-grip",
        "handle": "8pc-bundle-golf-pride-cp2-pro-undersize-grip",
        "shopify_variants": [
          {
            "id": "61638714229106",
            "gid": "gid://shopify/ProductVariant/61638714229106",
            "sku": "SET-8xCCPU-58R-H19-X04",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-pro-undersize-grip?variant=61638714229106"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-pro-jumbo-grip",
        "handle": "8pc-bundle-golf-pride-cp2-pro-jumbo-grip",
        "shopify_variants": [
          {
            "id": "61638713737586",
            "gid": "gid://shopify/ProductVariant/61638713737586",
            "sku": "SET-8xCCPJ-60R-H19-X04",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-pro-jumbo-grip?variant=61638713737586"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-standard-grip",
        "handle": "8pc-bundle-golf-pride-cp2-standard-grip",
        "shopify_variants": [
          {
            "id": "61638713442674",
            "gid": "gid://shopify/ProductVariant/61638713442674",
            "sku": "SET-8xCCPS-60R-H19-X04",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-standard-grip?variant=61638713442674"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-midsize-grip",
        "handle": "8pc-bundle-golf-pride-cp2-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638713344370",
            "gid": "gid://shopify/ProductVariant/61638713344370",
            "sku": "SET-8xCCPM-60R-H19-X04",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-midsize-grip?variant=61638713344370"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-midsize-grip",
        "handle": "13pc-bundle-golf-pride-cp2-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791466000754",
            "gid": "gid://shopify/ProductVariant/60791466000754",
            "sku": "SET-13xCCPM-60R-H19-X04",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-midsize-grip?variant=60791466000754"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-standard-grip",
        "handle": "13pc-bundle-golf-pride-cp2-standard-grip",
        "shopify_variants": [
          {
            "id": "60791465836914",
            "gid": "gid://shopify/ProductVariant/60791465836914",
            "sku": "SET-13xCCPS-60R-H19-X04",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-standard-grip?variant=60791465836914"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-pro-jumbo-grip",
        "handle": "13pc-bundle-golf-pride-cp2-pro-jumbo-grip",
        "shopify_variants": [
          {
            "id": "60791465509234",
            "gid": "gid://shopify/ProductVariant/60791465509234",
            "sku": "SET-13xCCPJ-60R-H19-X04",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-pro-jumbo-grip?variant=60791465509234"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-pro-undersize-grip",
        "handle": "13pc-bundle-golf-pride-cp2-pro-undersize-grip",
        "shopify_variants": [
          {
            "id": "60791464722802",
            "gid": "gid://shopify/ProductVariant/60791464722802",
            "sku": "SET-13xCCPU-58R-H19-X04",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-pro-undersize-grip?variant=60791464722802"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-cp2-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021969629245",
            "gid": "gid://shopify/ProductVariant/41021969629245",
            "sku": "SET-10xCCPM-60R-H19-X04",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-midsize-grip-grip-bundle-set?variant=41021969629245"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-standard-grip-grip-bundle-set",
        "handle": "golf-pride-cp2-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021969530941",
            "gid": "gid://shopify/ProductVariant/41021969530941",
            "sku": "SET-10xCCPS-60R-H19-X04",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-standard-grip-grip-bundle-set?variant=41021969530941"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-jumbo-grip-grip-bundle-set",
        "handle": "golf-pride-cp2-pro-jumbo-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021969236029",
            "gid": "gid://shopify/ProductVariant/41021969236029",
            "sku": "SET-10xCCPJ-60R-H19-X04",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-jumbo-grip-grip-bundle-set?variant=41021969236029"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-undersize-grip-grip-bundle-set",
        "handle": "golf-pride-cp2-pro-undersize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967401021",
            "gid": "gid://shopify/ProductVariant/41021967401021",
            "sku": "SET-10xCCPU-58R-H19-X04",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-undersize-grip-grip-bundle-set?variant=41021967401021"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-jumbo-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-cp2-pro-jumbo-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828641853",
            "gid": "gid://shopify/ProductVariant/39915828641853",
            "sku": "KIT+13xCCPJ-60R-H19-X04",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-jumbo-grip-13pcs-golf-grip-kit?variant=39915828641853"
          },
          {
            "id": "39915828674621",
            "gid": "gid://shopify/ProductVariant/39915828674621",
            "sku": "KIT(8oz)+13xCCPJ-60R-H19-X04",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-jumbo-grip-13pcs-golf-grip-kit?variant=39915828674621"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-undersize-13pcs-golf-grip-kit",
        "handle": "golf-pride-cp2-pro-undersize-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829297213",
            "gid": "gid://shopify/ProductVariant/39915829297213",
            "sku": "KIT+13xCCPU-58R-H19-X04",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-undersize-13pcs-golf-grip-kit?variant=39915829297213"
          },
          {
            "id": "39915829329981",
            "gid": "gid://shopify/ProductVariant/39915829329981",
            "sku": "KIT(8oz)+13xCCPU-58R-H19-X04",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-undersize-13pcs-golf-grip-kit?variant=39915829329981"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-undersize-grip",
        "handle": "golf-pride-cp2-pro-undersize-grip",
        "shopify_variants": [
          {
            "id": "40683322802237",
            "gid": "gid://shopify/ProductVariant/40683322802237",
            "sku": "CCPU-58R-H19-X04",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-undersize-grip?variant=40683322802237"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-pro-standard-grips",
        "handle": "grip-kit-13x-golf-pride-cp2-pro-standard-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831590973",
            "gid": "gid://shopify/ProductVariant/39915831590973",
            "sku": "KIT+13xCCPS-60R-H19-X04",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-pro-standard-grips?variant=39915831590973"
          },
          {
            "id": "39915831623741",
            "gid": "gid://shopify/ProductVariant/39915831623741",
            "sku": "KIT(8oz)+13xCCPS-60R-H19-X04",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-pro-standard-grips?variant=39915831623741"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-pro-midsize-grips",
        "handle": "grip-kit-13x-golf-pride-cp2-pro-midsize-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831656509",
            "gid": "gid://shopify/ProductVariant/39915831656509",
            "sku": "KIT+13xCCPM-60R-H19-X04",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-pro-midsize-grips?variant=39915831656509"
          },
          {
            "id": "39915831689277",
            "gid": "gid://shopify/ProductVariant/39915831689277",
            "sku": "KIT(8oz)+13xCCPM-60R-H19-X04",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-pro-midsize-grips?variant=39915831689277"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-jumbo-grip",
        "handle": "golf-pride-cp2-pro-jumbo-grip",
        "shopify_variants": [
          {
            "id": "40683322540093",
            "gid": "gid://shopify/ProductVariant/40683322540093",
            "sku": "CCPJ-60R-H19-X04",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-pro-jumbo-grip?variant=40683322540093"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-standard-grip",
        "handle": "golf-pride-cp2-standard-grip",
        "shopify_variants": [
          {
            "id": "40683322736701",
            "gid": "gid://shopify/ProductVariant/40683322736701",
            "sku": "CCPS-60R-H19-X04",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-standard-grip?variant=40683322736701"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-midsize-grip",
        "handle": "golf-pride-cp2-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683322638397",
            "gid": "gid://shopify/ProductVariant/40683322638397",
            "sku": "CCPM-60R-H19-X04",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-midsize-grip?variant=40683322638397"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, CP2, CP2 Pro, gifts-for-her, golf pride bundle, Golf Pride CP2, golf pride single grip, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, ladies, single-golf-grips, soft, tacky, under-150, under-300, undersize, undersize-golf-grips, video=41FE3xRCDLw",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-cp2-wrap",
    "brand": "Golf Pride",
    "model": "CP2 Wrap",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (soft compound)",
    "texture": "wrap-style",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "Blue",
      "Pink"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.99,
    "price_max": 153.37,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 10.99,
    "bundle_price_min": 87.92,
    "kit_price_min": 153.37,
    "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/cp2-pink-diag-1300_e21efa27-c54d-494d-b464-9ebffac14b94.jpg?v=1761759755",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 26,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Pink"
        ],
        "price": 87.92,
        "per_grip_g": 5.7,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-undersize-grip-pink",
        "handle": "8pc-bundle-golf-pride-cp2-wrap-undersize-grip-pink",
        "shopify_variants": [
          {
            "id": "61638733529458",
            "gid": "gid://shopify/ProductVariant/61638733529458",
            "sku": "SET-8xCCWU-58R-H1B-X04",
            "color": "Pink",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-undersize-grip-pink?variant=61638733529458"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Pink"
        ],
        "price": 87.92,
        "per_grip_g": 5.7,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-standard-grip-pink",
        "handle": "8pc-bundle-golf-pride-cp2-wrap-standard-grip-pink",
        "shopify_variants": [
          {
            "id": "61638733136242",
            "gid": "gid://shopify/ProductVariant/61638733136242",
            "sku": "SET-8xCCWS-60R-H1B-X04",
            "color": "Pink",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-standard-grip-pink?variant=61638733136242"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 87.92,
        "per_grip_g": 5.7,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-undersize-grip",
        "handle": "8pc-bundle-golf-pride-cp2-wrap-undersize-grip",
        "shopify_variants": [
          {
            "id": "61638714261874",
            "gid": "gid://shopify/ProductVariant/61638714261874",
            "sku": "SET-8xCCWU-58R-H2L-X02",
            "color": "Blue",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-undersize-grip?variant=61638714261874"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 87.92,
        "per_grip_g": 5.7,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-standard-grip",
        "handle": "8pc-bundle-golf-pride-cp2-wrap-standard-grip",
        "shopify_variants": [
          {
            "id": "61638713999730",
            "gid": "gid://shopify/ProductVariant/61638713999730",
            "sku": "SET-8xCCWS-60R-H2L-X02",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-standard-grip?variant=61638713999730"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 87.92,
        "per_grip_g": 5.7,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-midsize-grip",
        "handle": "8pc-bundle-golf-pride-cp2-wrap-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638713934194",
            "gid": "gid://shopify/ProductVariant/61638713934194",
            "sku": "SET-8xCCWM-60R-H2L-X02",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-wrap-midsize-grip?variant=61638713934194"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-jumbo-grip",
        "handle": "8pc-bundle-golf-pride-cp2-jumbo-grip",
        "shopify_variants": [
          {
            "id": "61638713147762",
            "gid": "gid://shopify/ProductVariant/61638713147762",
            "sku": "SET-8xCCWJ-60R-H2L-X02",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cp2-jumbo-grip?variant=61638713147762"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-jumbo-grip",
        "handle": "13pc-bundle-golf-pride-cp2-jumbo-grip",
        "shopify_variants": [
          {
            "id": "60791466164594",
            "gid": "gid://shopify/ProductVariant/60791466164594",
            "sku": "SET-13xCCWJ-60R-H2L-X02",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-jumbo-grip?variant=60791466164594"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 142.87,
        "per_grip_g": 3.5,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-midsize-grip",
        "handle": "13pc-bundle-golf-pride-cp2-wrap-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791465476466",
            "gid": "gid://shopify/ProductVariant/60791465476466",
            "sku": "SET-13xCCWM-60R-H2L-X02",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-midsize-grip?variant=60791465476466"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 142.87,
        "per_grip_g": 3.5,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-standard-grip",
        "handle": "13pc-bundle-golf-pride-cp2-wrap-standard-grip",
        "shopify_variants": [
          {
            "id": "60791465378162",
            "gid": "gid://shopify/ProductVariant/60791465378162",
            "sku": "SET-13xCCWS-60R-H2L-X02",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-standard-grip?variant=60791465378162"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 142.87,
        "per_grip_g": 3.5,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-undersize-grip",
        "handle": "13pc-bundle-golf-pride-cp2-wrap-undersize-grip",
        "shopify_variants": [
          {
            "id": "60791464526194",
            "gid": "gid://shopify/ProductVariant/60791464526194",
            "sku": "SET-13xCCWU-58R-H2L-X02",
            "color": "Blue",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-undersize-grip?variant=60791464526194"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Pink"
        ],
        "price": 142.87,
        "per_grip_g": 3.5,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-standard-grip-pink",
        "handle": "13pc-bundle-golf-pride-cp2-wrap-standard-grip-pink",
        "shopify_variants": [
          {
            "id": "60791453417842",
            "gid": "gid://shopify/ProductVariant/60791453417842",
            "sku": "SET-13xCCWS-60R-H1B-X04",
            "color": "Pink",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-standard-grip-pink?variant=60791453417842"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Pink"
        ],
        "price": 142.87,
        "per_grip_g": 3.5,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-undersize-grip-pink",
        "handle": "13pc-bundle-golf-pride-cp2-wrap-undersize-grip-pink",
        "shopify_variants": [
          {
            "id": "60791453254002",
            "gid": "gid://shopify/ProductVariant/60791453254002",
            "sku": "SET-13xCCWU-58R-H1B-X04",
            "color": "Pink",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cp2-wrap-undersize-grip-pink?variant=60791453254002"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Pink"
        ],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-undersize-grip-pink",
        "handle": "golf-pride-cp2-wrap-undersize-grip-pink",
        "shopify_variants": [
          {
            "id": "41151806079037",
            "gid": "gid://shopify/ProductVariant/41151806079037",
            "sku": "CCWU-58R-H1B-X04",
            "color": "Pink",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-undersize-grip-pink?variant=41151806079037"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Pink"
        ],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-standard-grip-pink",
        "handle": "golf-pride-cp2-wrap-standard-grip-pink",
        "shopify_variants": [
          {
            "id": "41151792185405",
            "gid": "gid://shopify/ProductVariant/41151792185405",
            "sku": "CCWS-60R-H1B-X04",
            "color": "Pink",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-standard-grip-pink?variant=41151792185405"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-jumbo-grip-grip-bundle-set",
        "handle": "golf-pride-cp2-jumbo-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021969825853",
            "gid": "gid://shopify/ProductVariant/41021969825853",
            "sku": "SET-10xCCWJ-60R-H2L-X02",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-jumbo-grip-grip-bundle-set?variant=41021969825853"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 109.9,
        "per_grip_g": 40.8,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-cp2-wrap-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021968973885",
            "gid": "gid://shopify/ProductVariant/41021968973885",
            "sku": "SET-10xCCWM-60R-H2L-X02",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 408.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-midsize-grip-grip-bundle-set?variant=41021968973885"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 109.9,
        "per_grip_g": 40.8,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-standard-grip-grip-bundle-set",
        "handle": "golf-pride-cp2-wrap-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021968875581",
            "gid": "gid://shopify/ProductVariant/41021968875581",
            "sku": "SET-10xCCWS-60R-H2L-X02",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 408.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-standard-grip-grip-bundle-set?variant=41021968875581"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 109.9,
        "per_grip_g": 40.8,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-undersize-grip-grip-bundle-set",
        "handle": "golf-pride-cp2-wrap-undersize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967335485",
            "gid": "gid://shopify/ProductVariant/41021967335485",
            "sku": "SET-10xCCWU-58R-H2L-X02",
            "color": "Blue",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 408.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-undersize-grip-grip-bundle-set?variant=41021967335485"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Blue"
        ],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-undersize-13pcs-golf-grip-kit",
        "handle": "golf-pride-cp2-wrap-undersize-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829231677",
            "gid": "gid://shopify/ProductVariant/39915829231677",
            "sku": "KIT+13xCCWU-58R-H2L-X02",
            "color": "Blue",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-undersize-13pcs-golf-grip-kit?variant=39915829231677"
          },
          {
            "id": "39915829264445",
            "gid": "gid://shopify/ProductVariant/39915829264445",
            "sku": "KIT(8oz)+13xCCWU-58R-H2L-X02",
            "color": "Blue",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-undersize-13pcs-golf-grip-kit?variant=39915829264445"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Blue"
        ],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-jumbo-13pcs-golf-grip-kit",
        "handle": "golf-pride-cp2-wrap-jumbo-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829493821",
            "gid": "gid://shopify/ProductVariant/39915829493821",
            "sku": "KIT+13xCCWJ-60R-H2L-X02",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-jumbo-13pcs-golf-grip-kit?variant=39915829493821"
          },
          {
            "id": "39915829526589",
            "gid": "gid://shopify/ProductVariant/39915829526589",
            "sku": "KIT(8oz)+13xCCWJ-60R-H2L-X02",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-jumbo-13pcs-golf-grip-kit?variant=39915829526589"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-undersize-grip",
        "handle": "golf-pride-cp2-wrap-undersize-grip",
        "shopify_variants": [
          {
            "id": "40683323424829",
            "gid": "gid://shopify/ProductVariant/40683323424829",
            "sku": "CCWU-58R-H2L-X02",
            "color": "Blue",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-undersize-grip?variant=40683323424829"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Blue"
        ],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-wrap-midsize-grips",
        "handle": "grip-kit-13x-golf-pride-cp2-wrap-midsize-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830607933",
            "gid": "gid://shopify/ProductVariant/39915830607933",
            "sku": "KIT+13xCCWM-60R-H2L-X02",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-wrap-midsize-grips?variant=39915830607933"
          },
          {
            "id": "39915830640701",
            "gid": "gid://shopify/ProductVariant/39915830640701",
            "sku": "KIT(8oz)+13xCCWM-60R-H2L-X02",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-wrap-midsize-grips?variant=39915830640701"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Blue"
        ],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-wrap-standard-grips",
        "handle": "grip-kit-13x-golf-pride-cp2-wrap-standard-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830673469",
            "gid": "gid://shopify/ProductVariant/39915830673469",
            "sku": "KIT+13xCCWS-60R-H2L-X02",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-wrap-standard-grips?variant=39915830673469"
          },
          {
            "id": "39915830706237",
            "gid": "gid://shopify/ProductVariant/39915830706237",
            "sku": "KIT(8oz)+13xCCWS-60R-H2L-X02",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-cp2-wrap-standard-grips?variant=39915830706237"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-standard-grip",
        "handle": "golf-pride-cp2-wrap-standard-grip",
        "shopify_variants": [
          {
            "id": "40683323392061",
            "gid": "gid://shopify/ProductVariant/40683323392061",
            "sku": "CCWS-60R-H2L-X02",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-standard-grip?variant=40683323392061"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-midsize-grip",
        "handle": "golf-pride-cp2-wrap-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683323293757",
            "gid": "gid://shopify/ProductVariant/40683323293757",
            "sku": "CCWM-60R-H2L-X02",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-wrap-midsize-grip?variant=40683323293757"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-cp2-jumbo-grip",
        "handle": "golf-pride-cp2-jumbo-grip",
        "shopify_variants": [
          {
            "id": "40683323260989",
            "gid": "gid://shopify/ProductVariant/40683323260989",
            "sku": "CCWJ-60R-H2L-X02",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cp2-jumbo-grip?variant=40683323260989"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2024 new products, 8pc bundle, 8pc golf pride, All Products, CP2, cp2 pink, CP2 Wrap, gifts-for-her, golf pride bundle, Golf Pride CP2, golf pride pink, golf pride single grip, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, ladies, single-golf-grips, soft, tacky, under-150, under-300, und",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Normal CP2 Wrap color corrected to Blue; Pink retained only for explicitly pink product pages. Color is now assigned per variant and per size.",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {
      "Undersize": "Blue",
      "Standard": "Blue",
      "Midsize": "Blue",
      "Jumbo/Oversize": "Blue"
    },
    "live_colors_available": [
      "Blue",
      "Pink"
    ]
  },
  {
    "id": "golf-pride-cpx",
    "brand": "Golf Pride",
    "model": "CPx",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid rubber (control + comfort)",
    "texture": "textured hybrid",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "hybrid",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.99,
    "price_max": 153.37,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 10.99,
    "bundle_price_min": 87.92,
    "kit_price_min": 153.37,
    "url": "https://www.grips4less.com/products/golf-pride-cpx-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/golf-pride-cpx-grip_00094922-260b-4efa-b5fd-c525591a8b17.jpg?v=1761759773",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 20,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 5.7,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cpx-midsize-grip",
        "handle": "8pc-bundle-golf-pride-cpx-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638730580338",
            "gid": "gid://shopify/ProductVariant/61638730580338",
            "sku": "SET-8xCPXM-60R-H2R-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cpx-midsize-grip?variant=61638730580338"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 5.7,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cpx-undersize-grip",
        "handle": "8pc-bundle-golf-pride-cpx-undersize-grip",
        "shopify_variants": [
          {
            "id": "61638730187122",
            "gid": "gid://shopify/ProductVariant/61638730187122",
            "sku": "SET-8xCPXU-58R-H2R-XA",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 87.92,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cpx-undersize-grip?variant=61638730187122"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 5.7,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cpx-standard-grip",
        "handle": "8pc-bundle-golf-pride-cpx-standard-grip",
        "shopify_variants": [
          {
            "id": "61638729335154",
            "gid": "gid://shopify/ProductVariant/61638729335154",
            "sku": "SET-8xCPXS-60R-H2R-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cpx-standard-grip?variant=61638729335154"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cpx-jumbo-grip",
        "handle": "8pc-bundle-golf-pride-cpx-jumbo-grip",
        "shopify_variants": [
          {
            "id": "61638728614258",
            "gid": "gid://shopify/ProductVariant/61638728614258",
            "sku": "SET-8xCPXJ-60R-H2R-XA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-cpx-jumbo-grip?variant=61638728614258"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cpx-jumbo-grip",
        "handle": "13pc-bundle-golf-pride-cpx-jumbo-grip",
        "shopify_variants": [
          {
            "id": "60791454499186",
            "gid": "gid://shopify/ProductVariant/60791454499186",
            "sku": "SET-13xCPXJ-60R-H2R-XA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cpx-jumbo-grip?variant=60791454499186"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 3.5,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cpx-standard-grip",
        "handle": "13pc-bundle-golf-pride-cpx-standard-grip",
        "shopify_variants": [
          {
            "id": "60791454335346",
            "gid": "gid://shopify/ProductVariant/60791454335346",
            "sku": "SET-13xCPXS-60R-H2R-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cpx-standard-grip?variant=60791454335346"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 3.5,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cpx-undersize-grip",
        "handle": "13pc-bundle-golf-pride-cpx-undersize-grip",
        "shopify_variants": [
          {
            "id": "60791454073202",
            "gid": "gid://shopify/ProductVariant/60791454073202",
            "sku": "SET-13xCPXU-58R-H2R-XA",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 142.87,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cpx-undersize-grip?variant=60791454073202"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 3.5,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cpx-midsize-grip",
        "handle": "13pc-bundle-golf-pride-cpx-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791453876594",
            "gid": "gid://shopify/ProductVariant/60791453876594",
            "sku": "SET-13xCPXM-60R-H2R-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-cpx-midsize-grip?variant=60791453876594"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-jumbo-grip-grip-bundle-set",
        "handle": "golf-pride-cpx-jumbo-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954588733",
            "gid": "gid://shopify/ProductVariant/41021954588733",
            "sku": "SET-10xCPXJ-60R-H2R-XA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-jumbo-grip-grip-bundle-set?variant=41021954588733"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 40.8,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-standard-grip-grip-bundle-set",
        "handle": "golf-pride-cpx-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954555965",
            "gid": "gid://shopify/ProductVariant/41021954555965",
            "sku": "SET-10xCPXS-60R-H2R-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 408.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-standard-grip-grip-bundle-set?variant=41021954555965"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 40.8,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-undersize-grip-grip-bundle-set",
        "handle": "golf-pride-cpx-undersize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954490429",
            "gid": "gid://shopify/ProductVariant/41021954490429",
            "sku": "SET-10xCPXU-58R-H2R-XA",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 109.9,
            "weight_g": 408.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-undersize-grip-grip-bundle-set?variant=41021954490429"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 40.8,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-cpx-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954457661",
            "gid": "gid://shopify/ProductVariant/41021954457661",
            "sku": "SET-10xCPXM-60R-H2R-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 408.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-midsize-grip-grip-bundle-set?variant=41021954457661"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-midsize-grip-13pcs-grip-kit",
        "handle": "golf-pride-cpx-midsize-grip-13pcs-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915825528893",
            "gid": "gid://shopify/ProductVariant/39915825528893",
            "sku": "KIT+13xCPXM-60R-H2R-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-midsize-grip-13pcs-grip-kit?variant=39915825528893"
          },
          {
            "id": "39915825561661",
            "gid": "gid://shopify/ProductVariant/39915825561661",
            "sku": "KIT(8oz)+13xCPXM-60R-H2R-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-midsize-grip-13pcs-grip-kit?variant=39915825561661"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-undersize-grip-13pcs-grip-kit",
        "handle": "golf-pride-cpx-undersize-grip-13pcs-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915825594429",
            "gid": "gid://shopify/ProductVariant/39915825594429",
            "sku": "KIT+13xCPXU-58R-H2R-XA",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-undersize-grip-13pcs-grip-kit?variant=39915825594429"
          },
          {
            "id": "39915825627197",
            "gid": "gid://shopify/ProductVariant/39915825627197",
            "sku": "KIT(8oz)+13xCPXU-58R-H2R-XA",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-undersize-grip-13pcs-grip-kit?variant=39915825627197"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-standard-grip-13pcs-grip-kit",
        "handle": "golf-pride-cpx-standard-grip-13pcs-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915825659965",
            "gid": "gid://shopify/ProductVariant/39915825659965",
            "sku": "KIT+13xCPXS-60R-H2R-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-standard-grip-13pcs-grip-kit?variant=39915825659965"
          },
          {
            "id": "39915825692733",
            "gid": "gid://shopify/ProductVariant/39915825692733",
            "sku": "KIT(8oz)+13xCPXS-60R-H2R-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-standard-grip-13pcs-grip-kit?variant=39915825692733"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-jumbo-grip-13pcs-grip-kit",
        "handle": "golf-pride-cpx-jumbo-grip-13pcs-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915825725501",
            "gid": "gid://shopify/ProductVariant/39915825725501",
            "sku": "KIT+13xCPXJ-60R-H2R-XA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-jumbo-grip-13pcs-grip-kit?variant=39915825725501"
          },
          {
            "id": "39915825758269",
            "gid": "gid://shopify/ProductVariant/39915825758269",
            "sku": "KIT(8oz)+13xCPXJ-60R-H2R-XA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-jumbo-grip-13pcs-grip-kit?variant=39915825758269"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-midsize-grip",
        "handle": "golf-pride-cpx-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683324080189",
            "gid": "gid://shopify/ProductVariant/40683324080189",
            "sku": "CPXM-60R-H2R-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-midsize-grip?variant=40683324080189"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-undersize-grip",
        "handle": "golf-pride-cpx-undersize-grip",
        "shopify_variants": [
          {
            "id": "40683324997693",
            "gid": "gid://shopify/ProductVariant/40683324997693",
            "sku": "CPXU-58R-H2R-XA",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-undersize-grip?variant=40683324997693"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-standard-grip",
        "handle": "golf-pride-cpx-standard-grip",
        "shopify_variants": [
          {
            "id": "40683324244029",
            "gid": "gid://shopify/ProductVariant/40683324244029",
            "sku": "CPXS-60R-H2R-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-standard-grip?variant=40683324244029"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-cpx-jumbo-grip",
        "handle": "golf-pride-cpx-jumbo-grip",
        "shopify_variants": [
          {
            "id": "40683324047421",
            "gid": "gid://shopify/ProductVariant/40683324047421",
            "sku": "CPXJ-60R-H2R-XA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-cpx-jumbo-grip?variant=40683324047421"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, Brand_Golf Pride, cp2-replacement, CPx, golf pride bundle, Golf Pride CPx, golf pride single grip, golf-grips, golf-pride, golf-pride-cp2-replacement, grip bundle, grip kit, iron/wood, midsize, midsize-golf-grips, Model_Golf Pride CPx, single-golf-grips, sof",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-david-leadbetter-training",
    "brand": "Golf Pride",
    "model": "David Leadbetter Training",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "training_only",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 13.49,
    "price_max": 175.85,
    "single_price_min": 13.49,
    "single_price_max": 13.49,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": null,
    "kit_price_min": 175.85,
    "url": "https://www.grips4less.com/products/golf-pride-david-leadbetter-training-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/golfpride-david-leadbetter-training-grip_26293d7a-40e5-4c78-ba86-1ef801ef9ec0.jpg?v=1751587482",
    "fit_tags": [],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 175.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-david-leadbetter-training-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-david-leadbetter-training-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007847772221",
            "gid": "gid://shopify/ProductVariant/32007847772221",
            "sku": "KIT+13xDMT -60R-20 -X0",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Hand": "Right Hand"
            },
            "available": false,
            "price": 175.85,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-david-leadbetter-training-grip-13pcs-golf-grip-kit?variant=32007847772221"
          }
        ],
        "shopify_options": [
          {
            "name": "Hand",
            "values": [
              "Right Hand"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-david-leadbetter-training-grip",
        "handle": "golf-pride-david-leadbetter-training-grip",
        "shopify_variants": [
          {
            "id": "403204101",
            "gid": "gid://shopify/ProductVariant/403204101",
            "sku": "DMT -60R-20 -X0",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Hand": "Right Hand"
            },
            "available": false,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-david-leadbetter-training-grip?variant=403204101"
          }
        ],
        "shopify_options": [
          {
            "name": "Hand",
            "values": [
              "Right Hand"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, Golf Pride Training, golf-pride, gp-gift-2025, grip kit, grip kits, grip set, grip sets, KIT-added0",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-dual-durometer",
    "brand": "Golf Pride",
    "model": "Dual Durometer",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (dual durometer)",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 91,
      "Standard": 91,
      "Undersize": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 3.99,
    "price_max": 6.9,
    "single_price_min": 3.99,
    "single_price_max": 6.9,
    "normalized_price_per_grip": 3.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-midsize-dual-durometer",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Golf_Pride_Midsize_Dual_Durometer_7070f60f-2a61-43ca-a4c0-dab79d75128c.jpg?v=1636051697",
    "fit_tags": [],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 6.9,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-dual-durometer",
        "handle": "golf-pride-midsize-dual-durometer",
        "shopify_variants": [
          {
            "id": "39461787238461",
            "gid": "gid://shopify/ProductVariant/39461787238461",
            "sku": "MSM-60R-RV4-X9",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default"
            },
            "available": true,
            "price": 6.9,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-dual-durometer?variant=39461787238461"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 6.38,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/golf-pride-mens-dual-durometer",
        "handle": "golf-pride-mens-dual-durometer",
        "shopify_variants": [
          {
            "id": "39461787172925",
            "gid": "gid://shopify/ProductVariant/39461787172925",
            "sku": "DDM-60R-RV3-X4",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default"
            },
            "available": true,
            "price": 6.38,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-dual-durometer?variant=39461787172925"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 3.99,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/golf-pride-dual-durometer-putter",
        "handle": "golf-pride-dual-durometer-putter",
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Pink grip / Gray cap",
              "Yellow grip / Black cap"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461787074621",
            "gid": "gid://shopify/ProductVariant/39461787074621",
            "sku": "DDP 581-H45-X0",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Title": "Pink grip / Gray cap"
            },
            "available": true,
            "price": 3.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-dual-durometer-putter?variant=39461787074621"
          },
          {
            "id": "39461787107389",
            "gid": "gid://shopify/ProductVariant/39461787107389",
            "sku": "DDP 581-H70-X1",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Title": "Yellow grip / Black cap"
            },
            "available": true,
            "price": 3.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-dual-durometer-putter?variant=39461787107389"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_Golf Pride, dual durometer, golf pride single grip, golf-pride, iron/wood, midsize, midsize-golf-grips, rubber, single-golf-grips, single-grip, Size_Midsize, soft, Style_Swing Grip, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-honorary-starter",
    "brand": "Golf Pride",
    "model": "Honorary Starter",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Green/Yellow"
    ],
    "weight_g_by_size": {
      "Midsize": 65.3,
      "Standard": 57.2
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 12.99,
    "price_max": 182.35,
    "single_price_min": 12.99,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 12.99,
    "bundle_price_min": 129.9,
    "kit_price_min": 182.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-honorary-starter-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/gp-honorary-starter-1.jpg?v=1751587327",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Green/Yellow"
        ],
        "price": 129.9,
        "per_grip_g": 65.3,
        "total_g": 653.1730128,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-midsize-grip-honorary-starter-grip-bundle-set",
        "handle": "golf-pride-mcc-plus4-midsize-grip-honorary-starter-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41126802554941",
            "gid": "gid://shopify/ProductVariant/41126802554941",
            "sku": "SET-10xM4HM-60R-M3P-XA",
            "color": "Green/Yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green/Yellow",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 653.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-midsize-grip-honorary-starter-grip-bundle-set?variant=41126802554941"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green/Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 182.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-honorary-starter-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-midsize-honorary-starter-grips",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41126802489405",
            "gid": "gid://shopify/ProductVariant/41126802489405",
            "sku": "KIT+13xM4HM-60R-M3P-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 182.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-honorary-starter-grips?variant=41126802489405"
          },
          {
            "id": "41126802522173",
            "gid": "gid://shopify/ProductVariant/41126802522173",
            "sku": "KIT(8oz)+13xM4HM-60R-M3P-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 187.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-honorary-starter-grips?variant=41126802522173"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Green/Yellow"
        ],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip-honorary-starter-bundle-set",
        "handle": "golf-pride-mcc-plus4-standard-grip-honorary-starter-bundle-set",
        "shopify_variants": [
          {
            "id": "41126802456637",
            "gid": "gid://shopify/ProductVariant/41126802456637",
            "sku": "SET-10xM4HS-60R-M3P-XA",
            "color": "Green/Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "Green/Yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip-honorary-starter-bundle-set?variant=41126802456637"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green/Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 182.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-honorary-starter-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-standard-honorary-starter-grips",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41126802325565",
            "gid": "gid://shopify/ProductVariant/41126802325565",
            "sku": "KIT+13xM4HS-60R-M3P-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 182.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-honorary-starter-grips?variant=41126802325565"
          },
          {
            "id": "41126802358333",
            "gid": "gid://shopify/ProductVariant/41126802358333",
            "sku": "KIT(8oz)+13xM4HS-60R-M3P-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 187.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-honorary-starter-grips?variant=41126802358333"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Green/Yellow"
        ],
        "price": 12.99,
        "per_grip_g": 72.6,
        "total_g": 72.5747792,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-honorary-starter-midsize-grip",
        "handle": "golf-pride-mcc-plus4-honorary-starter-midsize-grip",
        "shopify_variants": [
          {
            "id": "41126750191677",
            "gid": "gid://shopify/ProductVariant/41126750191677",
            "sku": "M4HM-60R-M3P-XA",
            "color": "Green/Yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green/Yellow",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 72.6,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-honorary-starter-midsize-grip?variant=41126750191677"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green/Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green/Yellow"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-honorary-starter-standard-grip",
        "handle": "golf-pride-mcc-plus4-honorary-starter-standard-grip",
        "shopify_variants": [
          {
            "id": "41126750158909",
            "gid": "gid://shopify/ProductVariant/41126750158909",
            "sku": "M4HS-60R-M3P-XA",
            "color": "Green/Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "Green/Yellow",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-honorary-starter-standard-grip?variant=41126750158909"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green/Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2024 new products, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pride MCC Plus4, golf pride starter, golf-grips, golf-pride, go",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "MCC Plus4-based bundle",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Green/Yellow"
    ]
  },
  {
    "id": "golf-pride-honorary-starter-tour-velvet",
    "brand": "Golf Pride",
    "model": "Honorary Starter Tour Velvet",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber blend",
    "texture": "textured (+ pattern)",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/tour-velvet-collection/tour-velvet.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Green/White"
    ],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 8.49,
    "price_max": 123.85,
    "single_price_min": 8.49,
    "single_price_max": 8.49,
    "normalized_price_per_grip": 8.49,
    "bundle_price_min": null,
    "kit_price_min": 123.85,
    "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-honorary-starter-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/gp-starter-tv-kit.jpg?v=1751587316",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-midsize-honorary-starter-grips",
        "handle": "grip-kit-13x-golf-pride-tour-velvet-midsize-honorary-starter-grips",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51834971554162",
            "gid": "gid://shopify/ProductVariant/51834971554162",
            "sku": "KIT+13xHS1M-60R-23J-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 123.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-midsize-honorary-starter-grips?variant=51834971554162"
          },
          {
            "id": "51834971586930",
            "gid": "gid://shopify/ProductVariant/51834971586930",
            "sku": "KIT(8oz)+13xHS1M-60R-23J-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 129.95,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-midsize-honorary-starter-grips?variant=51834971586930"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-standard-honorary-starter-grips",
        "handle": "grip-kit-13x-golf-pride-tour-velvet-standard-honorary-starter-grips",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51834971488626",
            "gid": "gid://shopify/ProductVariant/51834971488626",
            "sku": "KIT+13xHS1S-60R-23H-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 123.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-standard-honorary-starter-grips?variant=51834971488626"
          },
          {
            "id": "51834971521394",
            "gid": "gid://shopify/ProductVariant/51834971521394",
            "sku": "KIT(8oz)+13xHS1S-60R-23H-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 129.95,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-standard-honorary-starter-grips?variant=51834971521394"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Green/White"
        ],
        "price": 8.49,
        "per_grip_g": 72.6,
        "total_g": 72.5747792,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-honorary-starter-midsize-grip",
        "handle": "golf-pride-tour-velvet-honorary-starter-midsize-grip",
        "shopify_variants": [
          {
            "id": "51834971455858",
            "gid": "gid://shopify/ProductVariant/51834971455858",
            "sku": "HS1M-60R-23J-XA",
            "color": "Green/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green/White",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 72.6,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-honorary-starter-midsize-grip?variant=51834971455858"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green/White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green/White"
        ],
        "price": 8.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-honorary-starter-standard-grip",
        "handle": "golf-pride-tour-velvet-honorary-starter-standard-grip",
        "shopify_variants": [
          {
            "id": "51834971423090",
            "gid": "gid://shopify/ProductVariant/51834971423090",
            "sku": "HS1S-60R-23H-XA",
            "color": "Green/White",
            "size": "Standard",
            "selected_options": {
              "Color": "Green/White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-honorary-starter-standard-grip?variant=51834971423090"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green/White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, best-sellers, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, golf-grips, golf-pride, golf-pride-model_tour-velvet, gp-gift-2025, grip kit, grip kits, grip set, grip sets, iron/wood, lab",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-align-max",
    "brand": "Golf Pride",
    "model": "MCC ALIGN Max",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "ALIGN ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ALIGN",
    "alignment_description": "Raised ridge along the underside designed to promote consistent hand placement.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "8pc bundle"
    ],
    "colors_available": [
      "Grey"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": 127.92,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-align-max-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/gp-mccalign-max_ad82284e-db48-4335-854d-c2deedeef32d.jpg?v=1761759719",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 127.92,
        "per_grip_g": 9.6,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-align-max-midsize-grip",
        "handle": "8pc-bundle-golf-pride-mcc-align-max-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638735266162",
            "gid": "gid://shopify/ProductVariant/61638735266162",
            "sku": "SET-8xMCZM-60R-ML0-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 127.92,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-align-max-midsize-grip?variant=61638735266162"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 127.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-align-max-standard-grip",
        "handle": "8pc-bundle-golf-pride-mcc-align-max-standard-grip",
        "shopify_variants": [
          {
            "id": "61638734938482",
            "gid": "gid://shopify/ProductVariant/61638734938482",
            "sku": "SET-8xMCZS-60R-MK0-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 127.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-align-max-standard-grip?variant=61638734938482"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-align-max-standard-grip",
        "handle": "13pc-bundle-golf-pride-mcc-align-max-standard-grip",
        "shopify_variants": [
          {
            "id": "60791452565874",
            "gid": "gid://shopify/ProductVariant/60791452565874",
            "sku": "SET-13xMCZS-60R-MK0-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-align-max-standard-grip?variant=60791452565874"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 207.87,
        "per_grip_g": 5.9,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-align-max-midsize-grip",
        "handle": "13pc-bundle-golf-pride-mcc-align-max-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791452369266",
            "gid": "gid://shopify/ProductVariant/60791452369266",
            "sku": "SET-13xMCZM-60R-ML0-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-align-max-midsize-grip?variant=60791452369266"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 15.99,
        "per_grip_g": 77.1,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-align-max-midsize-grip",
        "handle": "golf-pride-mcc-align-max-midsize-grip",
        "shopify_variants": [
          {
            "id": "51779876061554",
            "gid": "gid://shopify/ProductVariant/51779876061554",
            "sku": "MCZM-60R-ML0-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-align-max-midsize-grip?variant=51779876061554"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-align-max-standard-grip",
        "handle": "golf-pride-mcc-align-max-standard-grip",
        "shopify_variants": [
          {
            "id": "51779876028786",
            "gid": "gid://shopify/ProductVariant/51779876028786",
            "sku": "MCZS-60R-MK0-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-align-max-standard-grip?variant=51779876028786"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, Alignment golf grip, Alignment-golf-grips, All Products, all-weather, bct cord, Golf Pride Align MAX, golf pride bundle, golf pride single grip, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, grip bundle, grip kit, hybrid, hybrid-golf-grips, iron/wood, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Grey"
    ]
  },
  {
    "id": "golf-pride-mcc-classic-align",
    "brand": "Golf Pride",
    "model": "MCC CLASSIC ALIGN",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "ALIGN ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ALIGN",
    "alignment_description": "Raised ridge along the underside designed to promote consistent hand placement.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "Black / White",
      "Green Align",
      "Red Align"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 12.49,
    "price_max": 209.19,
    "single_price_min": 12.49,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 12.49,
    "bundle_price_min": 119.92,
    "kit_price_min": 209.19,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-classic-align-standard-grip-green-align",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/mcc-align_0ea51926-9721-494a-873f-af5a0264a688.jpg?v=1761759862",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 11,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black / White"
        ],
        "price": 119.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-align-midsize-grip",
        "handle": "8pc-bundle-golf-pride-mcc-align-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638719275378",
            "gid": "gid://shopify/ProductVariant/61638719275378",
            "sku": "SET-8xMCXM-60X-M16-XA",
            "color": "Black / White",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 119.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-align-midsize-grip?variant=61638719275378"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Red Align"
        ],
        "price": 119.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-align-standard-grip",
        "handle": "8pc-bundle-golf-pride-mcc-align-standard-grip",
        "shopify_variants": [
          {
            "id": "61638719144306",
            "gid": "gid://shopify/ProductVariant/61638719144306",
            "sku": "SET-8xMCXS-60X-M16-XA",
            "color": "Red Align",
            "size": "Standard",
            "selected_options": {
              "Color": "Red Align",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 119.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-align-standard-grip?variant=61638719144306"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Align"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Red Align"
        ],
        "price": 194.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-align-standard-grip",
        "handle": "13pc-bundle-golf-pride-mcc-align-standard-grip",
        "shopify_variants": [
          {
            "id": "60791463281010",
            "gid": "gid://shopify/ProductVariant/60791463281010",
            "sku": "SET-13xMCXS-60X-M16-XA",
            "color": "Red Align",
            "size": "Standard",
            "selected_options": {
              "Color": "Red Align",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-align-standard-grip?variant=60791463281010"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Align"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / White"
        ],
        "price": 194.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-align-midsize-grip",
        "handle": "13pc-bundle-golf-pride-mcc-align-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791463117170",
            "gid": "gid://shopify/ProductVariant/60791463117170",
            "sku": "SET-13xMCXM-60X-M16-XA",
            "color": "Black / White",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-align-midsize-grip?variant=60791463117170"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Red Align"
        ],
        "price": 149.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-align-standard-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-align-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021966286909",
            "gid": "gid://shopify/ProductVariant/41021966286909",
            "sku": "SET-10xMCXS-60X-M16-XA",
            "color": "Red Align",
            "size": "Standard",
            "selected_options": {
              "Color": "Red Align",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 149.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-align-standard-grip-grip-bundle-set?variant=41021966286909"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Align"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black / White"
        ],
        "price": 149.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-align-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-align-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021966254141",
            "gid": "gid://shopify/ProductVariant/41021966254141",
            "sku": "SET-10xMCXM-60X-M16-XA",
            "color": "Black / White",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 149.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-align-midsize-grip-grip-bundle-set?variant=41021966254141"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green Align"
        ],
        "price": 12.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-classic-align-standard-grip-green-align",
        "handle": "golf-pride-mcc-classic-align-standard-grip-green-align",
        "shopify_variants": [
          {
            "id": "14159637348413",
            "gid": "gid://shopify/ProductVariant/14159637348413",
            "sku": "SET-1xMCXS-60X-M19-XA",
            "color": "Green Align",
            "size": "Standard",
            "selected_options": {
              "Color": "Green Align"
            },
            "available": false,
            "price": 12.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-classic-align-standard-grip-green-align?variant=14159637348413"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green Align"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 209.19,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-classic-align-standard-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-classic-align-standard-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829887037",
            "gid": "gid://shopify/ProductVariant/39915829887037",
            "sku": "KIT+13xMCXS-60X-M16-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 209.19,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-classic-align-standard-grips?variant=39915829887037"
          },
          {
            "id": "39915829919805",
            "gid": "gid://shopify/ProductVariant/39915829919805",
            "sku": "KIT(8oz)+13xMCXS-60X-M16-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 212.9,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-classic-align-standard-grips?variant=39915829919805"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 209.19,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-classic-align-midsize-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-classic-align-midsize-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829952573",
            "gid": "gid://shopify/ProductVariant/39915829952573",
            "sku": "KIT+13xMCXM-60X-M16-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 209.19,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-classic-align-midsize-grips?variant=39915829952573"
          },
          {
            "id": "39915829985341",
            "gid": "gid://shopify/ProductVariant/39915829985341",
            "sku": "KIT(8oz)+13xMCXM-60X-M16-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 212.9,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-classic-align-midsize-grips?variant=39915829985341"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black / White"
        ],
        "price": 14.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-align-midsize-grip",
        "handle": "golf-pride-mcc-align-midsize-grip",
        "shopify_variants": [
          {
            "id": "42421620115",
            "gid": "gid://shopify/ProductVariant/42421620115",
            "sku": "MCXM-60X-M16-XA",
            "color": "Black / White",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-align-midsize-grip?variant=42421620115"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Red Align"
        ],
        "price": 14.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-align-standard-grip",
        "handle": "golf-pride-mcc-align-standard-grip",
        "shopify_variants": [
          {
            "id": "42421617171",
            "gid": "gid://shopify/ProductVariant/42421617171",
            "sku": "MCXS-60X-M16-XA",
            "color": "Red Align",
            "size": "Standard",
            "selected_options": {
              "Color": "Red Align",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-align-standard-grip?variant=42421617171"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Align"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, Alignment golf grip, alignment-golf-grips, All Products, all-weather, bct cord, Golf Pride Align, golf pride bundle, golf pride single grip, golf-grips, golf-pride, golf-pride-model_mcc-classic-standard-taper, grip bundle, grip kit, hybrid, hybrid-golf-grips, iron/wood, m",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / White",
      "Red Align"
    ]
  },
  {
    "id": "golf-pride-mcc-classic-align-green-align",
    "brand": "Golf Pride",
    "model": "MCC CLASSIC ALIGN (Green ALIGN)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "ALIGN ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ALIGN",
    "alignment_description": "Raised ridge along the underside designed to promote consistent hand placement.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Green Align"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 162.85,
    "price_max": 162.85,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 12.53,
    "bundle_price_min": null,
    "kit_price_min": 162.85,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-classic-align-standard-grip-green-align-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/web-mcc-align-green_back_ef3a8049-3c34-4692-9d2c-522678feb4c2.jpg?v=1751587534",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Green Align"
        ],
        "price": 162.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-classic-align-standard-grip-green-align-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-classic-align-standard-grip-green-align-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "31934154014781",
            "gid": "gid://shopify/ProductVariant/31934154014781",
            "sku": "KIT+13xMCXS-60X-M19-XA",
            "color": "Green Align",
            "size": "Standard",
            "selected_options": {
              "Color": "Green Align"
            },
            "available": false,
            "price": 162.85,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-classic-align-standard-grip-green-align-13pcs-golf-grip-kit?variant=31934154014781"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green Align"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, Align Green, Alignment golf grip, alignment-golf-grips, All Products, all-weather, bct cord, blackfriday2020, bundle, bundles-asbl-driver-only, classic align, firm, free-rog-momentum-glove, Golf Pride Align, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4",
    "brand": "Golf Pride",
    "model": "MCC PLUS4",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "Black / Grey",
      "Blue",
      "Grey"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 12.99,
    "price_max": 181.28,
    "single_price_min": 12.99,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 12.31,
    "bundle_price_min": 103.92,
    "kit_price_min": 159.99,
    "url": "https://www.grips4less.com/products/limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/print-mcc-plus4-grey_front-1500_56db0559-4364-43fd-b14c-a3576e11bddc.jpg?v=1761759847",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 23,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-jumbo-golf-grip",
        "handle": "8pc-bundle-golf-pride-mcc-plus4-jumbo-golf-grip",
        "shopify_variants": [
          {
            "id": "61638719570290",
            "gid": "gid://shopify/ProductVariant/61638719570290",
            "sku": "SET-8xMCCJ-60R-M0N-XA",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-jumbo-golf-grip?variant=61638719570290"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-undersize-grip",
        "handle": "8pc-bundle-golf-pride-mcc-plus4-undersize-grip",
        "shopify_variants": [
          {
            "id": "61638714786162",
            "gid": "gid://shopify/ProductVariant/61638714786162",
            "sku": "SET-8xMCCU-58R-M0N-X10",
            "color": "Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-undersize-grip?variant=61638714786162"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 103.92,
        "per_grip_g": 9.1,
        "total_g": 72.5747792,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-midsize-grip-grey",
        "handle": "8pc-bundle-golf-pride-mcc-plus4-midsize-grip-grey",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638714163570",
            "gid": "gid://shopify/ProductVariant/61638714163570",
            "sku": "SET-8xMCCM-60R-M2E-X10",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 72.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-midsize-grip-grey?variant=61638714163570"
          },
          {
            "id": "61638714196338",
            "gid": "gid://shopify/ProductVariant/61638714196338",
            "sku": "SET-8xMCCM-60R-M0N-X10",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 72.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-midsize-grip-grey?variant=61638714196338"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-standard-grip",
        "handle": "8pc-bundle-golf-pride-mcc-plus4-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Orange",
              "Red",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638714032498",
            "gid": "gid://shopify/ProductVariant/61638714032498",
            "sku": "SET-8xMCCS-60R-M2E-X10",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-standard-grip?variant=61638714032498"
          },
          {
            "id": "61638714065266",
            "gid": "gid://shopify/ProductVariant/61638714065266",
            "sku": "SET-8xMCCS-60R-M77-X10",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-standard-grip?variant=61638714065266"
          },
          {
            "id": "61638714098034",
            "gid": "gid://shopify/ProductVariant/61638714098034",
            "sku": "SET-8xMCCS-60R-M4H-X10",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-standard-grip?variant=61638714098034"
          },
          {
            "id": "61638714130802",
            "gid": "gid://shopify/ProductVariant/61638714130802",
            "sku": "SET-8xMCCS-60R-M0N-X10",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-standard-grip?variant=61638714130802"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-standard-grip",
        "handle": "13pc-bundle-golf-pride-mcc-plus4-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Orange",
              "Red",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791465116018",
            "gid": "gid://shopify/ProductVariant/60791465116018",
            "sku": "SET-13xMCCS-60R-M2E-X10",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-standard-grip?variant=60791465116018"
          },
          {
            "id": "60791465148786",
            "gid": "gid://shopify/ProductVariant/60791465148786",
            "sku": "SET-13xMCCS-60R-M77-X10",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-standard-grip?variant=60791465148786"
          },
          {
            "id": "60791465181554",
            "gid": "gid://shopify/ProductVariant/60791465181554",
            "sku": "SET-13xMCCS-60R-M4H-X10",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-standard-grip?variant=60791465181554"
          },
          {
            "id": "60791465214322",
            "gid": "gid://shopify/ProductVariant/60791465214322",
            "sku": "SET-13xMCCS-60R-M0N-X10",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-standard-grip?variant=60791465214322"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 168.87,
        "per_grip_g": 5.6,
        "total_g": 72.5747792,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-midsize-grip-grey",
        "handle": "13pc-bundle-golf-pride-mcc-plus4-midsize-grip-grey",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791464952178",
            "gid": "gid://shopify/ProductVariant/60791464952178",
            "sku": "SET-13xMCCM-60R-M2E-X10",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 72.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-midsize-grip-grey?variant=60791464952178"
          },
          {
            "id": "60791464984946",
            "gid": "gid://shopify/ProductVariant/60791464984946",
            "sku": "SET-13xMCCM-60R-M0N-X10",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 72.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-midsize-grip-grey?variant=60791464984946"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-undersize-grip",
        "handle": "13pc-bundle-golf-pride-mcc-plus4-undersize-grip",
        "shopify_variants": [
          {
            "id": "60791464395122",
            "gid": "gid://shopify/ProductVariant/60791464395122",
            "sku": "SET-13xMCCU-58R-M0N-X10",
            "color": "Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-undersize-grip?variant=60791464395122"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-jumbo-golf-grip",
        "handle": "13pc-bundle-golf-pride-mcc-plus4-jumbo-golf-grip",
        "shopify_variants": [
          {
            "id": "60791459185010",
            "gid": "gid://shopify/ProductVariant/60791459185010",
            "sku": "SET-13xMCCJ-60R-M0N-XA",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-jumbo-golf-grip?variant=60791459185010"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Grey"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-standard-grip",
        "handle": "13pc-bundle-limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-standard-grip",
        "shopify_variants": [
          {
            "id": "60791453057394",
            "gid": "gid://shopify/ProductVariant/60791453057394",
            "sku": "SET-13xSC4S-60R-MGY-XA",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-standard-grip?variant=60791453057394"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Grey"
        ],
        "price": 168.87,
        "per_grip_g": 5.6,
        "total_g": 72.5747792,
        "url": "https://www.grips4less.com/products/13pc-bundle-limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip",
        "handle": "13pc-bundle-limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791452893554",
            "gid": "gid://shopify/ProductVariant/60791452893554",
            "sku": "SET-13xSC4M-60R-MGY-XA",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 72.6,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip?variant=60791452893554"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Grey"
        ],
        "price": 159.99,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-standard-grip-kit",
        "handle": "limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-standard-grip-kit",
        "shopify_variants": [
          {
            "id": "51710430019954",
            "gid": "gid://shopify/ProductVariant/51710430019954",
            "sku": "SC4S-60R-MGY-A-KTS",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 159.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-standard-grip-kit?variant=51710430019954"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Grey"
        ],
        "price": 159.99,
        "per_grip_g": 5.6,
        "total_g": 72.5747792,
        "url": "https://www.grips4less.com/products/limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip-kit",
        "handle": "limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip-kit",
        "shopify_variants": [
          {
            "id": "51710429692274",
            "gid": "gid://shopify/ProductVariant/51710429692274",
            "sku": "SC4M-60R-MGY-A-KTS",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 159.99,
            "weight_g": 72.6,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip-kit?variant=51710429692274"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black / Grey"
        ],
        "price": 12.99,
        "per_grip_g": 72.6,
        "total_g": 72.5747792,
        "url": "https://www.grips4less.com/products/limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip",
        "handle": "limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip",
        "shopify_variants": [
          {
            "id": "51710375231858",
            "gid": "gid://shopify/ProductVariant/51710375231858",
            "sku": "SC4M-60R-MGY-XA",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 72.6,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-midsize-grip?variant=51710375231858"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black / Grey"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-standard-grip",
        "handle": "limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-standard-grip",
        "shopify_variants": [
          {
            "id": "51710365565298",
            "gid": "gid://shopify/ProductVariant/51710365565298",
            "sku": "SC4S-60R-MGY-XA",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-underrated-golf-pride-x-steph-curry-mcc-plus4-standard-grip?variant=51710365565298"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-plus4-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Orange",
              "Red",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021968416829",
            "gid": "gid://shopify/ProductVariant/41021968416829",
            "sku": "SET-10xMCCS-60R-M2E-X10",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip-grip-bundle-set?variant=41021968416829"
          },
          {
            "id": "41021968449597",
            "gid": "gid://shopify/ProductVariant/41021968449597",
            "sku": "SET-10xMCCS-60R-M77-X10",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip-grip-bundle-set?variant=41021968449597"
          },
          {
            "id": "41021968482365",
            "gid": "gid://shopify/ProductVariant/41021968482365",
            "sku": "SET-10xMCCS-60R-M4H-X10",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip-grip-bundle-set?variant=41021968482365"
          },
          {
            "id": "41021968515133",
            "gid": "gid://shopify/ProductVariant/41021968515133",
            "sku": "SET-10xMCCS-60R-M0N-X10",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 576.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip-grip-bundle-set?variant=41021968515133"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 129.9,
        "per_grip_g": 65.3,
        "total_g": 653.1730128,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-midsize-grip-grey-grip-bundle-set",
        "handle": "golf-pride-mcc-plus4-midsize-grip-grey-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021968351293",
            "gid": "gid://shopify/ProductVariant/41021968351293",
            "sku": "SET-10xMCCM-60R-M2E-X10",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 653.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-midsize-grip-grey-grip-bundle-set?variant=41021968351293"
          },
          {
            "id": "41021968384061",
            "gid": "gid://shopify/ProductVariant/41021968384061",
            "sku": "SET-10xMCCM-60R-M0N-X10",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 653.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-midsize-grip-grey-grip-bundle-set?variant=41021968384061"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-undersize-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-plus4-undersize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967138877",
            "gid": "gid://shopify/ProductVariant/41021967138877",
            "sku": "SET-10xMCCU-58R-M0N-X10",
            "color": "Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-undersize-grip-grip-bundle-set?variant=41021967138877"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-jumbo-golf-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-plus4-jumbo-golf-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965172797",
            "gid": "gid://shopify/ProductVariant/41021965172797",
            "sku": "SET-10xMCCJ-60R-M0N-XA",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-jumbo-golf-grip-grip-bundle-set?variant=41021965172797"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-jumbo-golf-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-plus4-jumbo-golf-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828707389",
            "gid": "gid://shopify/ProductVariant/39915828707389",
            "sku": "KIT+13xMCCJ-60R-M0N-XA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-jumbo-golf-grip-13pcs-golf-grip-kit?variant=39915828707389"
          },
          {
            "id": "39915828740157",
            "gid": "gid://shopify/ProductVariant/39915828740157",
            "sku": "KIT(8oz)+13xMCCJ-60R-M0N-XA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-jumbo-golf-grip-13pcs-golf-grip-kit?variant=39915828740157"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-jumbo-golf-grip",
        "handle": "golf-pride-mcc-plus4-jumbo-golf-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey",
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "6973944430653",
            "gid": "gid://shopify/ProductVariant/6973944430653",
            "sku": "MCCJ-60R-M0N-XA",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-jumbo-golf-grip?variant=6973944430653"
          },
          {
            "id": "61544416641394",
            "gid": "gid://shopify/ProductVariant/61544416641394",
            "sku": "MCCJ-60R-M2S-XA",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-jumbo-golf-grip?variant=61544416641394"
          },
          {
            "id": "61544416772466",
            "gid": "gid://shopify/ProductVariant/61544416772466",
            "sku": "MCCJ-60R-M4Y-XA",
            "color": "Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-jumbo-golf-grip?variant=61544416772466"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-undersize-grip",
        "handle": "golf-pride-mcc-plus4-undersize-grip",
        "shopify_variants": [
          {
            "id": "23785880583",
            "gid": "gid://shopify/ProductVariant/23785880583",
            "sku": "MCCU-58R-M0N-X10",
            "color": "Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-undersize-grip?variant=23785880583"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 12.99,
        "per_grip_g": 72.6,
        "total_g": 72.5747792,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-midsize-grip-grey",
        "handle": "golf-pride-mcc-plus4-midsize-grip-grey",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Grey",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "25126426375",
            "gid": "gid://shopify/ProductVariant/25126426375",
            "sku": "MCCM-60R-M2E-X10",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 72.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-midsize-grip-grey?variant=25126426375"
          },
          {
            "id": "51709356278130",
            "gid": "gid://shopify/ProductVariant/51709356278130",
            "sku": "MCCM-60R-M0N-X10",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 72.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-midsize-grip-grey?variant=51709356278130"
          },
          {
            "id": "61544437154162",
            "gid": "gid://shopify/ProductVariant/61544437154162",
            "sku": "MCCM-60R-M4Y-XA",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 72.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-midsize-grip-grey?variant=61544437154162"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip",
        "handle": "golf-pride-mcc-plus4-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Orange",
              "Red",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51709356081522",
            "gid": "gid://shopify/ProductVariant/51709356081522",
            "sku": "MCCS-60R-M2E-X10",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip?variant=51709356081522"
          },
          {
            "id": "51709356114290",
            "gid": "gid://shopify/ProductVariant/51709356114290",
            "sku": "MCCS-60R-M77-X10",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip?variant=51709356114290"
          },
          {
            "id": "51709356147058",
            "gid": "gid://shopify/ProductVariant/51709356147058",
            "sku": "MCCS-60R-M4H-X10",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip?variant=51709356147058"
          },
          {
            "id": "51709356179826",
            "gid": "gid://shopify/ProductVariant/51709356179826",
            "sku": "MCCS-60R-M0N-X10",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-grip?variant=51709356179826"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, all-weather, bct cord, golf pride bundle, Golf Pride MCC Plus4, golf pride single grip, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, grip bundle, grip kit, hybrid, hybrid-golf-grips, iron/wood, jumbo, jumbo/oversize, Less Tapered, MCC PL",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "Grey",
      "Orange",
      "Red"
    ]
  },
  {
    "id": "golf-pride-mcc-plus4-align",
    "brand": "Golf Pride",
    "model": "MCC PLUS4 ALIGN",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "ALIGN ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ALIGN",
    "alignment_description": "Raised ridge along the underside designed to promote consistent hand placement.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "Grey"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14.99,
    "price_max": 209.19,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 14.99,
    "bundle_price_min": 119.92,
    "kit_price_min": 209.19,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/mcc-plus4-align_904707fe-3954-47ff-963e-8a247204d010.jpg?v=1761759872",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 10,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 119.92,
        "per_grip_g": 9.6,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-align-midsize-grip",
        "handle": "8pc-bundle-golf-pride-mcc-plus4-align-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638718882162",
            "gid": "gid://shopify/ProductVariant/61638718882162",
            "sku": "SET-8xM4XM-60X-M0T-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 119.92,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-align-midsize-grip?variant=61638718882162"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 119.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-align-standard-grip",
        "handle": "8pc-bundle-golf-pride-mcc-plus4-align-standard-grip",
        "shopify_variants": [
          {
            "id": "61638718783858",
            "gid": "gid://shopify/ProductVariant/61638718783858",
            "sku": "SET-8xM4XS-60X-M0T-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 119.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-align-standard-grip?variant=61638718783858"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 194.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-align-standard-grip",
        "handle": "13pc-bundle-golf-pride-mcc-plus4-align-standard-grip",
        "shopify_variants": [
          {
            "id": "60791463870834",
            "gid": "gid://shopify/ProductVariant/60791463870834",
            "sku": "SET-13xM4XS-60X-M0T-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-align-standard-grip?variant=60791463870834"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 194.87,
        "per_grip_g": 5.9,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-align-midsize-grip",
        "handle": "13pc-bundle-golf-pride-mcc-plus4-align-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791463739762",
            "gid": "gid://shopify/ProductVariant/60791463739762",
            "sku": "SET-13xM4XM-60X-M0T-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-align-midsize-grip?variant=60791463739762"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 149.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-standard-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-plus4-align-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021966352445",
            "gid": "gid://shopify/ProductVariant/41021966352445",
            "sku": "SET-10xM4XS-60X-M0T-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 149.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-standard-grip-grip-bundle-set?variant=41021966352445"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 149.9,
        "per_grip_g": 69.4,
        "total_g": 693.9963261,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-plus4-align-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021966319677",
            "gid": "gid://shopify/ProductVariant/41021966319677",
            "sku": "SET-10xM4XM-60X-M0T-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 149.9,
            "weight_g": 694,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-midsize-grip-grip-bundle-set?variant=41021966319677"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 209.19,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-align-midsize-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-align-midsize-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830018109",
            "gid": "gid://shopify/ProductVariant/39915830018109",
            "sku": "KIT+13xM4XM-60X-M0T-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 209.19,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-align-midsize-grips?variant=39915830018109"
          },
          {
            "id": "39915830050877",
            "gid": "gid://shopify/ProductVariant/39915830050877",
            "sku": "KIT(8oz)+13xM4XM-60X-M0T-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 212.9,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-align-midsize-grips?variant=39915830050877"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 209.19,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-align-standard-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-align-standard-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830083645",
            "gid": "gid://shopify/ProductVariant/39915830083645",
            "sku": "KIT+13xM4XS-60X-M0T-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 209.19,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-align-standard-grips?variant=39915830083645"
          },
          {
            "id": "39915830116413",
            "gid": "gid://shopify/ProductVariant/39915830116413",
            "sku": "KIT(8oz)+13xM4XS-60X-M0T-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 212.9,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-align-standard-grips?variant=39915830116413"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 14.99,
        "per_grip_g": 77.1,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-midsize-grip",
        "handle": "golf-pride-mcc-plus4-align-midsize-grip",
        "shopify_variants": [
          {
            "id": "42421605267",
            "gid": "gid://shopify/ProductVariant/42421605267",
            "sku": "M4XM-60X-M0T-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-midsize-grip?variant=42421605267"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 14.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-standard-grip",
        "handle": "golf-pride-mcc-plus4-align-standard-grip",
        "shopify_variants": [
          {
            "id": "42421603475",
            "gid": "gid://shopify/ProductVariant/42421603475",
            "sku": "M4XS-60X-M0T-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-standard-grip?variant=42421603475"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, Alignment golf grip, alignment-golf-grips, All Products, all-weather, bct cord, Golf Pride Align, golf pride bundle, golf pride single grip, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, grip bundle, grip kit, hybrid, hybrid-golf-grips, iron/wood, Less",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Grey"
    ]
  },
  {
    "id": "golf-pride-mcc-plus4-align-max",
    "brand": "Golf Pride",
    "model": "MCC PLUS4 ALIGN Max",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "ALIGN ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ALIGN",
    "alignment_description": "Raised ridge along the underside designed to promote consistent hand placement.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "8pc bundle"
    ],
    "colors_available": [
      "Grey"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 77.1
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": 127.92,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-max-jumbo-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/gp-mccplusalign-max_29b01235-8678-4524-a636-a43170f080a5.jpg?v=1761759733",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 7,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 127.92,
        "per_grip_g": 9.6,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-align-max-midsize-grip",
        "handle": "8pc-bundle-golf-pride-mcc-plus4-align-max-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638734676338",
            "gid": "gid://shopify/ProductVariant/61638734676338",
            "sku": "SET-8xM4ZM-60R-MJ0-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 127.92,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-align-max-midsize-grip?variant=61638734676338"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 127.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-align-max-standard-grip",
        "handle": "8pc-bundle-golf-pride-mcc-plus4-align-max-standard-grip",
        "shopify_variants": [
          {
            "id": "61638734610802",
            "gid": "gid://shopify/ProductVariant/61638734610802",
            "sku": "SET-8xM4ZS-60R-MH0-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 127.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-plus4-align-max-standard-grip?variant=61638734610802"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 15.99,
        "per_grip_g": 77.1,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-max-jumbo-grip",
        "handle": "golf-pride-mcc-plus4-align-max-jumbo-grip",
        "shopify_variants": [
          {
            "id": "61502841651570",
            "gid": "gid://shopify/ProductVariant/61502841651570",
            "sku": "M4ZJ-60R-MJ0-XA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-max-jumbo-grip?variant=61502841651570"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-align-max-standard-grip",
        "handle": "13pc-bundle-golf-pride-mcc-plus4-align-max-standard-grip",
        "shopify_variants": [
          {
            "id": "60791452762482",
            "gid": "gid://shopify/ProductVariant/60791452762482",
            "sku": "SET-13xM4ZS-60R-MH0-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-align-max-standard-grip?variant=60791452762482"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 207.87,
        "per_grip_g": 5.9,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-align-max-midsize-grip",
        "handle": "13pc-bundle-golf-pride-mcc-plus4-align-max-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791452696946",
            "gid": "gid://shopify/ProductVariant/60791452696946",
            "sku": "SET-13xM4ZM-60R-MJ0-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-plus4-align-max-midsize-grip?variant=60791452696946"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 15.99,
        "per_grip_g": 77.1,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-max-midsize-grip",
        "handle": "golf-pride-mcc-plus4-align-max-midsize-grip",
        "shopify_variants": [
          {
            "id": "51779875963250",
            "gid": "gid://shopify/ProductVariant/51779875963250",
            "sku": "M4ZM-60R-MJ0-XA",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 77.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-max-midsize-grip?variant=51779875963250"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-max-standard-grip",
        "handle": "golf-pride-mcc-plus4-align-max-standard-grip",
        "shopify_variants": [
          {
            "id": "51779875930482",
            "gid": "gid://shopify/ProductVariant/51779875930482",
            "sku": "M4ZS-60R-MH0-XA",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-align-max-standard-grip?variant=51779875930482"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, Alignment golf grip, Alignment-golf-grips, All Products, all-weather, bct cord, Golf Pride Align MAX, golf pride bundle, golf pride single grip, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, grip bundle, grip kit, hybrid, hybrid-golf-grips, iron/wood, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Grey"
    ]
  },
  {
    "id": "golf-pride-mcc-plus4-blue",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Blue",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-blue-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-mccplus4-blue-nwm_grande2_grande_4fc7c61b-e69e-4aa7-947c-653cde8963f1.jpg?v=1751587587",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-blue-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-midsize-blue-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830280253",
            "gid": "gid://shopify/ProductVariant/39915830280253",
            "sku": "KIT+13xMCCM-60R-M2E-X10",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-blue-grips?variant=39915830280253"
          },
          {
            "id": "39915830313021",
            "gid": "gid://shopify/ProductVariant/39915830313021",
            "sku": "KIT(8oz)+13xMCCM-60R-M2E-X10",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-blue-grips?variant=39915830313021"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-blue-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-standard-blue-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831951421",
            "gid": "gid://shopify/ProductVariant/39915831951421",
            "sku": "KIT+13xMCCS-60R-M2E-X10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-blue-grips?variant=39915831951421"
          },
          {
            "id": "39915831984189",
            "gid": "gid://shopify/ProductVariant/39915831984189",
            "sku": "KIT(8oz)+13xMCCS-60R-M2E-X10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-blue-grips?variant=39915831984189"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf grip kit gift,",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-green",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Green",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Standard / Green"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-green-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-mcc-plus4-green.jpg?v=1751587569",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Green"
        ],
        "price": 169.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-green-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-plus4-standard-green-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "39915829624893",
            "gid": "gid://shopify/ProductVariant/39915829624893",
            "sku": "KIT+13xMCCS-60R-M39-X10",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Green",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-green-13pcs-golf-grip-kit?variant=39915829624893"
          },
          {
            "id": "39915829657661",
            "gid": "gid://shopify/ProductVariant/39915829657661",
            "sku": "KIT(8oz)+13xMCCS-60R-M39-X10",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Green",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-green-13pcs-golf-grip-kit?variant=39915829657661"
          }
        ],
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Standard / Green"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2021-endofyear, 2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, blackfriday2020, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Grip Kits, golf-pride, golf-pride-model_mcc",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-grey",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Grey",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Undersize": 71.9,
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-undersize-grey-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-mccplus4-grey_99787ddb-60cc-4775-a616-bef975226e29.jpg?v=1751587595",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-undersize-grey-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-undersize-grey-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830476861",
            "gid": "gid://shopify/ProductVariant/39915830476861",
            "sku": "KIT+13xMCCU-58R-M0N-X10",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-undersize-grey-grips?variant=39915830476861"
          },
          {
            "id": "39915830509629",
            "gid": "gid://shopify/ProductVariant/39915830509629",
            "sku": "KIT(8oz)+13xMCCU-58R-M0N-X10",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-undersize-grey-grips?variant=39915830509629"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-grey-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-midsize-grey-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831820349",
            "gid": "gid://shopify/ProductVariant/39915831820349",
            "sku": "KIT+13xMCCM-60R-M0N-X10",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-grey-grips?variant=39915831820349"
          },
          {
            "id": "39915831853117",
            "gid": "gid://shopify/ProductVariant/39915831853117",
            "sku": "KIT(8oz)+13xMCCM-60R-M0N-X10",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-midsize-grey-grips?variant=39915831853117"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-grey-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-standard-grey-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831885885",
            "gid": "gid://shopify/ProductVariant/39915831885885",
            "sku": "KIT+13xMCCS-60R-M0N-X10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-grey-grips?variant=39915831885885"
          },
          {
            "id": "39915831918653",
            "gid": "gid://shopify/ProductVariant/39915831918653",
            "sku": "KIT(8oz)+13xMCCS-60R-M0N-X10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-grey-grips?variant=39915831918653"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, gifts-for-her, golf grip kit gift, g",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-grip-dark-green-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Grip (Dark Green/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Standard / TEAM Dark Green/White"
    ],
    "weight_g_by_size": {
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-green-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-darkgreen-white.jpg?v=1751587474",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / TEAM Dark Green/White"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-green-white",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-dark-green-white",
        "shopify_variants": [
          {
            "id": "39915827331133",
            "gid": "gid://shopify/ProductVariant/39915827331133",
            "sku": "KIT+13xM4TS-60R-M3M-XA",
            "color": "TEAM Dark Green / White",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / TEAM Dark Green/White",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-green-white?variant=39915827331133"
          },
          {
            "id": "39915827363901",
            "gid": "gid://shopify/ProductVariant/39915827363901",
            "sku": "KIT(8oz)+13xM4TS-60R-M3M-XA",
            "color": "TEAM Dark Green / White",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / TEAM Dark Green/White",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-green-white?variant=39915827363901"
          }
        ],
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Standard / TEAM Dark Green/White"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, Golf Pride Teams, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, gp-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-orange",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Orange",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-orange-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-mcc-plus4-orange.jpg?v=1751587567",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-orange-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-plus4-standard-orange-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829559357",
            "gid": "gid://shopify/ProductVariant/39915829559357",
            "sku": "KIT+13xMCCS-60R-M77-X10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-orange-13pcs-golf-grip-kit?variant=39915829559357"
          },
          {
            "id": "39915829592125",
            "gid": "gid://shopify/ProductVariant/39915829592125",
            "sku": "KIT(8oz)+13xMCCS-60R-M77-X10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-plus4-standard-orange-13pcs-golf-grip-kit?variant=39915829592125"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf pride bundle, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-red",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Red",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-red-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-mccplus4-red-nwm_grande2_e0bce26f-9cd7-4f62-8587-6e4c2a43ee32.jpg?v=1751587629",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-red-grips",
        "handle": "grip-kit-13x-golf-pride-mcc-plus4-standard-red-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915832049725",
            "gid": "gid://shopify/ProductVariant/39915832049725",
            "sku": "KIT+13xMCCS-60R-M4H-X10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-red-grips?variant=39915832049725"
          },
          {
            "id": "39915832082493",
            "gid": "gid://shopify/ProductVariant/39915832082493",
            "sku": "KIT(8oz)+13xMCCS-60R-M4H-X10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-mcc-plus4-standard-red-grips?variant=39915832082493"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift c",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "8pc bundle"
    ],
    "colors_available": [
      "TEAM Black/Gold"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 12.99,
    "price_max": 168.87,
    "single_price_min": 12.99,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 12.99,
    "bundle_price_min": 103.92,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/gp-mccteamsplus4.jpg?v=1761759798",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 8,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "TEAM Black/Gold"
        ],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip",
        "handle": "8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Black/Gold",
              "TEAM Dark Orange/White",
              "TEAM Dark Red/White",
              "TEAM Dark Red/Yellow",
              "TEAM Green/Gold",
              "TEAM Grey/Red",
              "TEAM Light Blue/White",
              "TEAM Navy/Orange",
              "TEAM Navy/Red",
              "TEAM Orange/White",
              "TEAM Purple/White",
              "TEAM Purple/yellow",
              "TEAM Royal/Orange",
              "TEAM Royal/White",
              "TEAM Royal/Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638727074162",
            "gid": "gid://shopify/ProductVariant/61638727074162",
            "sku": "SET-8xM4TM-60R-M1P-XA",
            "color": "TEAM Black/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Black/Gold",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727074162"
          },
          {
            "id": "61638727106930",
            "gid": "gid://shopify/ProductVariant/61638727106930",
            "sku": "SET-8xM4TM-60R-M4U-XA",
            "color": "TEAM Dark Orange/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Orange/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727106930"
          },
          {
            "id": "61638727139698",
            "gid": "gid://shopify/ProductVariant/61638727139698",
            "sku": "SET-8xM4TM-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727139698"
          },
          {
            "id": "61638727172466",
            "gid": "gid://shopify/ProductVariant/61638727172466",
            "sku": "SET-8xM4TM-60R-M4S-XA",
            "color": "TEAM Dark Red/Yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Red/Yellow",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727172466"
          },
          {
            "id": "61638727205234",
            "gid": "gid://shopify/ProductVariant/61638727205234",
            "sku": "SET-8xM4TM-60R-M3L-XA",
            "color": "TEAM Green/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Green/Gold",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727205234"
          },
          {
            "id": "61638727238002",
            "gid": "gid://shopify/ProductVariant/61638727238002",
            "sku": "SET-8xM4TM-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727238002"
          },
          {
            "id": "61638727270770",
            "gid": "gid://shopify/ProductVariant/61638727270770",
            "sku": "SET-8xM4TM-60R-M2K-XA",
            "color": "TEAM Light Blue/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Light Blue/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727270770"
          },
          {
            "id": "61638727303538",
            "gid": "gid://shopify/ProductVariant/61638727303538",
            "sku": "SET-8xM4TM-60R-M2L-XC",
            "color": "TEAM Navy/Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Orange",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727303538"
          },
          {
            "id": "61638727336306",
            "gid": "gid://shopify/ProductVariant/61638727336306",
            "sku": "SET-8xM4TM-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727336306"
          },
          {
            "id": "61638727369074",
            "gid": "gid://shopify/ProductVariant/61638727369074",
            "sku": "SET-8xM4TM-60R-M4V-XA",
            "color": "TEAM Orange/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Orange/White",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727369074"
          },
          {
            "id": "61638727401842",
            "gid": "gid://shopify/ProductVariant/61638727401842",
            "sku": "SET-8xM4TM-60R-M4W-XA",
            "color": "TEAM Purple/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Purple/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727401842"
          },
          {
            "id": "61638727434610",
            "gid": "gid://shopify/ProductVariant/61638727434610",
            "sku": "SET-8xM4TM-60R-M4W-XB",
            "color": "TEAM Purple/yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Purple/yellow",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727434610"
          },
          {
            "id": "61638727467378",
            "gid": "gid://shopify/ProductVariant/61638727467378",
            "sku": "SET-8xM4TM-60R-M2M-XA",
            "color": "TEAM Royal/Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Royal/Orange",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727467378"
          },
          {
            "id": "61638727500146",
            "gid": "gid://shopify/ProductVariant/61638727500146",
            "sku": "SET-8xM4TM-60R-M2M-XB",
            "color": "TEAM Royal/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Royal/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727500146"
          },
          {
            "id": "61638727532914",
            "gid": "gid://shopify/ProductVariant/61638727532914",
            "sku": "SET-8xM4TM-60R-M2M-XC",
            "color": "TEAM Royal/Yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Royal/Yellow",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=61638727532914"
          }
        ],
        "shopify_variant_count": 15,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "TEAM Black/Gold"
        ],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip",
        "handle": "8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Black/Gold",
              "TEAM Dark Orange/White",
              "TEAM Dark Red/White",
              "TEAM Dark Red/Yellow",
              "TEAM Green/Gold",
              "TEAM Grey/Red",
              "TEAM Light Blue/White",
              "TEAM Navy/Orange",
              "TEAM Navy/Red",
              "TEAM Orange/White",
              "TEAM Purple/White",
              "TEAM Royal/Orange",
              "TEAM Royal/White",
              "TEAM Royal/Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638725534066",
            "gid": "gid://shopify/ProductVariant/61638725534066",
            "sku": "SET-8xM4TS-60R-M1P-XA",
            "color": "TEAM Black/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Black/Gold",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725534066"
          },
          {
            "id": "61638725566834",
            "gid": "gid://shopify/ProductVariant/61638725566834",
            "sku": "SET-8xM4TS-60R-M4U-XA",
            "color": "TEAM Dark Orange/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Orange/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725566834"
          },
          {
            "id": "61638725599602",
            "gid": "gid://shopify/ProductVariant/61638725599602",
            "sku": "SET-8xM4TS-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725599602"
          },
          {
            "id": "61638725632370",
            "gid": "gid://shopify/ProductVariant/61638725632370",
            "sku": "SET-8xM4TS-60R-M4S-XA",
            "color": "TEAM Dark Red/Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Red/Yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725632370"
          },
          {
            "id": "61638725665138",
            "gid": "gid://shopify/ProductVariant/61638725665138",
            "sku": "SET-8xM4TS-60R-M3L-XA",
            "color": "TEAM Green/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Green/Gold",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725665138"
          },
          {
            "id": "61638725697906",
            "gid": "gid://shopify/ProductVariant/61638725697906",
            "sku": "SET-8xM4TS-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725697906"
          },
          {
            "id": "61638725730674",
            "gid": "gid://shopify/ProductVariant/61638725730674",
            "sku": "SET-8xM4TS-60R-M2K-XA",
            "color": "TEAM Light Blue/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Light Blue/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725730674"
          },
          {
            "id": "61638725763442",
            "gid": "gid://shopify/ProductVariant/61638725763442",
            "sku": "SET-8xM4TS-60R-M2L-XC",
            "color": "TEAM Navy/Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725763442"
          },
          {
            "id": "61638725796210",
            "gid": "gid://shopify/ProductVariant/61638725796210",
            "sku": "SET-8xM4TS-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725796210"
          },
          {
            "id": "61638725828978",
            "gid": "gid://shopify/ProductVariant/61638725828978",
            "sku": "SET-8xM4TS-60R-M4V-XA",
            "color": "TEAM Orange/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Orange/White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725828978"
          },
          {
            "id": "61638725861746",
            "gid": "gid://shopify/ProductVariant/61638725861746",
            "sku": "SET-8xM4TS-60R-M4W-XA",
            "color": "TEAM Purple/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Purple/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725861746"
          },
          {
            "id": "61638725894514",
            "gid": "gid://shopify/ProductVariant/61638725894514",
            "sku": "SET-8xM4TS-60R-M2M-XA",
            "color": "TEAM Royal/Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Royal/Orange",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725894514"
          },
          {
            "id": "61638725927282",
            "gid": "gid://shopify/ProductVariant/61638725927282",
            "sku": "SET-8xM4TS-60R-M2M-XB",
            "color": "TEAM Royal/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Royal/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725927282"
          },
          {
            "id": "61638725960050",
            "gid": "gid://shopify/ProductVariant/61638725960050",
            "sku": "SET-8xM4TS-60R-M2M-XC",
            "color": "TEAM Royal/Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Royal/Yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=61638725960050"
          }
        ],
        "shopify_variant_count": 14,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "TEAM Black/Gold"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip",
        "handle": "13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Black/Gold",
              "TEAM Dark Orange/White",
              "TEAM Dark Red/White",
              "TEAM Dark Red/Yellow",
              "TEAM Green/Gold",
              "TEAM Grey/Red",
              "TEAM Light Blue/White",
              "TEAM Navy/Orange",
              "TEAM Navy/Red",
              "TEAM Orange/White",
              "TEAM Purple/White",
              "TEAM Royal/Orange",
              "TEAM Royal/White",
              "TEAM Royal/Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791455940978",
            "gid": "gid://shopify/ProductVariant/60791455940978",
            "sku": "SET-13xM4TS-60R-M1P-XA",
            "color": "TEAM Black/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Black/Gold",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791455940978"
          },
          {
            "id": "60791455973746",
            "gid": "gid://shopify/ProductVariant/60791455973746",
            "sku": "SET-13xM4TS-60R-M4U-XA",
            "color": "TEAM Dark Orange/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Orange/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791455973746"
          },
          {
            "id": "60791456006514",
            "gid": "gid://shopify/ProductVariant/60791456006514",
            "sku": "SET-13xM4TS-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456006514"
          },
          {
            "id": "60791456039282",
            "gid": "gid://shopify/ProductVariant/60791456039282",
            "sku": "SET-13xM4TS-60R-M4S-XA",
            "color": "TEAM Dark Red/Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Red/Yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456039282"
          },
          {
            "id": "60791456072050",
            "gid": "gid://shopify/ProductVariant/60791456072050",
            "sku": "SET-13xM4TS-60R-M3L-XA",
            "color": "TEAM Green/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Green/Gold",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456072050"
          },
          {
            "id": "60791456104818",
            "gid": "gid://shopify/ProductVariant/60791456104818",
            "sku": "SET-13xM4TS-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456104818"
          },
          {
            "id": "60791456137586",
            "gid": "gid://shopify/ProductVariant/60791456137586",
            "sku": "SET-13xM4TS-60R-M2K-XA",
            "color": "TEAM Light Blue/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Light Blue/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456137586"
          },
          {
            "id": "60791456170354",
            "gid": "gid://shopify/ProductVariant/60791456170354",
            "sku": "SET-13xM4TS-60R-M2L-XC",
            "color": "TEAM Navy/Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456170354"
          },
          {
            "id": "60791456203122",
            "gid": "gid://shopify/ProductVariant/60791456203122",
            "sku": "SET-13xM4TS-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456203122"
          },
          {
            "id": "60791456235890",
            "gid": "gid://shopify/ProductVariant/60791456235890",
            "sku": "SET-13xM4TS-60R-M4V-XA",
            "color": "TEAM Orange/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Orange/White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456235890"
          },
          {
            "id": "60791456268658",
            "gid": "gid://shopify/ProductVariant/60791456268658",
            "sku": "SET-13xM4TS-60R-M4W-XA",
            "color": "TEAM Purple/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Purple/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456268658"
          },
          {
            "id": "60791456301426",
            "gid": "gid://shopify/ProductVariant/60791456301426",
            "sku": "SET-13xM4TS-60R-M2M-XA",
            "color": "TEAM Royal/Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Royal/Orange",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456301426"
          },
          {
            "id": "60791456334194",
            "gid": "gid://shopify/ProductVariant/60791456334194",
            "sku": "SET-13xM4TS-60R-M2M-XB",
            "color": "TEAM Royal/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Royal/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456334194"
          },
          {
            "id": "60791456366962",
            "gid": "gid://shopify/ProductVariant/60791456366962",
            "sku": "SET-13xM4TS-60R-M2M-XC",
            "color": "TEAM Royal/Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Royal/Yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-standard-grip?variant=60791456366962"
          }
        ],
        "shopify_variant_count": 14,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "TEAM Black/Gold"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip",
        "handle": "13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Black/Gold",
              "TEAM Dark Orange/White",
              "TEAM Dark Red/White",
              "TEAM Green/Gold",
              "TEAM Grey/Red",
              "TEAM Light Blue/White",
              "TEAM Navy/Orange",
              "TEAM Navy/Red",
              "TEAM Purple/White",
              "TEAM Royal/White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791455285618",
            "gid": "gid://shopify/ProductVariant/60791455285618",
            "sku": "SET-13xM4TM-60R-M1P-XA",
            "color": "TEAM Black/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Black/Gold",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455285618"
          },
          {
            "id": "60791455318386",
            "gid": "gid://shopify/ProductVariant/60791455318386",
            "sku": "SET-13xM4TM-60R-M4U-XA",
            "color": "TEAM Dark Orange/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Orange/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455318386"
          },
          {
            "id": "60791455351154",
            "gid": "gid://shopify/ProductVariant/60791455351154",
            "sku": "SET-13xM4TM-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455351154"
          },
          {
            "id": "60791455416690",
            "gid": "gid://shopify/ProductVariant/60791455416690",
            "sku": "SET-13xM4TM-60R-M3L-XA",
            "color": "TEAM Green/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Green/Gold",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455416690"
          },
          {
            "id": "60791455449458",
            "gid": "gid://shopify/ProductVariant/60791455449458",
            "sku": "SET-13xM4TM-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455449458"
          },
          {
            "id": "60791455482226",
            "gid": "gid://shopify/ProductVariant/60791455482226",
            "sku": "SET-13xM4TM-60R-M2K-XA",
            "color": "TEAM Light Blue/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Light Blue/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455482226"
          },
          {
            "id": "60791455514994",
            "gid": "gid://shopify/ProductVariant/60791455514994",
            "sku": "SET-13xM4TM-60R-M2L-XC",
            "color": "TEAM Navy/Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Orange",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455514994"
          },
          {
            "id": "60791455547762",
            "gid": "gid://shopify/ProductVariant/60791455547762",
            "sku": "SET-13xM4TM-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455547762"
          },
          {
            "id": "60791455613298",
            "gid": "gid://shopify/ProductVariant/60791455613298",
            "sku": "SET-13xM4TM-60R-M4W-XA",
            "color": "TEAM Purple/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Purple/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455613298"
          },
          {
            "id": "60791455711602",
            "gid": "gid://shopify/ProductVariant/60791455711602",
            "sku": "SET-13xM4TM-60R-M2M-XB",
            "color": "TEAM Royal/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Royal/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=60791455711602"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "TEAM Black/Gold"
        ],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Black/Gold",
              "TEAM Dark Orange/White",
              "TEAM Dark Red/White",
              "TEAM Dark Red/Yellow",
              "TEAM Green/Gold",
              "TEAM Grey/Red",
              "TEAM Light Blue/White",
              "TEAM Navy/Orange",
              "TEAM Navy/Red",
              "TEAM Orange/White",
              "TEAM Purple/White",
              "TEAM Purple/yellow",
              "TEAM Royal/Orange",
              "TEAM Royal/White",
              "TEAM Royal/Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021955997757",
            "gid": "gid://shopify/ProductVariant/41021955997757",
            "sku": "SET-10xM4TS-60R-M1P-XA",
            "color": "TEAM Black/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Black/Gold",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021955997757"
          },
          {
            "id": "41021956030525",
            "gid": "gid://shopify/ProductVariant/41021956030525",
            "sku": "SET-10xM4TS-60R-M4U-XA",
            "color": "TEAM Dark Orange/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Orange/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956030525"
          },
          {
            "id": "41021956063293",
            "gid": "gid://shopify/ProductVariant/41021956063293",
            "sku": "SET-10xM4TS-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956063293"
          },
          {
            "id": "41021956096061",
            "gid": "gid://shopify/ProductVariant/41021956096061",
            "sku": "SET-10xM4TS-60R-M4S-XA",
            "color": "TEAM Dark Red/Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Red/Yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956096061"
          },
          {
            "id": "41021956128829",
            "gid": "gid://shopify/ProductVariant/41021956128829",
            "sku": "SET-10xM4TS-60R-M3L-XA",
            "color": "TEAM Green/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Green/Gold",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956128829"
          },
          {
            "id": "41021956161597",
            "gid": "gid://shopify/ProductVariant/41021956161597",
            "sku": "SET-10xM4TS-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956161597"
          },
          {
            "id": "41021956194365",
            "gid": "gid://shopify/ProductVariant/41021956194365",
            "sku": "SET-10xM4TS-60R-M2K-XA",
            "color": "TEAM Light Blue/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Light Blue/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956194365"
          },
          {
            "id": "41021956227133",
            "gid": "gid://shopify/ProductVariant/41021956227133",
            "sku": "SET-10xM4TS-60R-M2L-XC",
            "color": "TEAM Navy/Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956227133"
          },
          {
            "id": "41021956259901",
            "gid": "gid://shopify/ProductVariant/41021956259901",
            "sku": "SET-10xM4TS-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956259901"
          },
          {
            "id": "41021956292669",
            "gid": "gid://shopify/ProductVariant/41021956292669",
            "sku": "SET-10xM4TS-60R-M4V-XA",
            "color": "TEAM Orange/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Orange/White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956292669"
          },
          {
            "id": "41021956325437",
            "gid": "gid://shopify/ProductVariant/41021956325437",
            "sku": "SET-10xM4TS-60R-M4W-XA",
            "color": "TEAM Purple/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Purple/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956325437"
          },
          {
            "id": "41021956358205",
            "gid": "gid://shopify/ProductVariant/41021956358205",
            "sku": "SET-10xM4TS-60R-M4W-XB",
            "color": "TEAM Purple/yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Purple/yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956358205"
          },
          {
            "id": "41021956390973",
            "gid": "gid://shopify/ProductVariant/41021956390973",
            "sku": "SET-10xM4TS-60R-M2M-XA",
            "color": "TEAM Royal/Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Royal/Orange",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956390973"
          },
          {
            "id": "41021956423741",
            "gid": "gid://shopify/ProductVariant/41021956423741",
            "sku": "SET-10xM4TS-60R-M2M-XB",
            "color": "TEAM Royal/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Royal/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956423741"
          },
          {
            "id": "41021956456509",
            "gid": "gid://shopify/ProductVariant/41021956456509",
            "sku": "SET-10xM4TS-60R-M2M-XC",
            "color": "TEAM Royal/Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Royal/Yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-grip-bundle-set?variant=41021956456509"
          }
        ],
        "shopify_variant_count": 15,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "TEAM Black/Gold"
        ],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Black/Gold",
              "TEAM Dark Orange/White",
              "TEAM Dark Red/White",
              "TEAM Dark Red/Yellow",
              "TEAM Green/Gold",
              "TEAM Grey/Red",
              "TEAM Light Blue/White",
              "TEAM Navy/Orange",
              "TEAM Navy/Red",
              "TEAM Orange/White",
              "TEAM Purple/White",
              "TEAM Purple/yellow",
              "TEAM Royal/Orange",
              "TEAM Royal/White",
              "TEAM Royal/Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021955014717",
            "gid": "gid://shopify/ProductVariant/41021955014717",
            "sku": "SET-10xM4TM-60R-M1P-XA",
            "color": "TEAM Black/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Black/Gold",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955014717"
          },
          {
            "id": "41021955047485",
            "gid": "gid://shopify/ProductVariant/41021955047485",
            "sku": "SET-10xM4TM-60R-M4U-XA",
            "color": "TEAM Dark Orange/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Orange/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955047485"
          },
          {
            "id": "41021955080253",
            "gid": "gid://shopify/ProductVariant/41021955080253",
            "sku": "SET-10xM4TM-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955080253"
          },
          {
            "id": "41021955113021",
            "gid": "gid://shopify/ProductVariant/41021955113021",
            "sku": "SET-10xM4TM-60R-M4S-XA",
            "color": "TEAM Dark Red/Yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Red/Yellow",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955113021"
          },
          {
            "id": "41021955145789",
            "gid": "gid://shopify/ProductVariant/41021955145789",
            "sku": "SET-10xM4TM-60R-M3L-XA",
            "color": "TEAM Green/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Green/Gold",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955145789"
          },
          {
            "id": "41021955178557",
            "gid": "gid://shopify/ProductVariant/41021955178557",
            "sku": "SET-10xM4TM-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955178557"
          },
          {
            "id": "41021955211325",
            "gid": "gid://shopify/ProductVariant/41021955211325",
            "sku": "SET-10xM4TM-60R-M2K-XA",
            "color": "TEAM Light Blue/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Light Blue/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955211325"
          },
          {
            "id": "41021955244093",
            "gid": "gid://shopify/ProductVariant/41021955244093",
            "sku": "SET-10xM4TM-60R-M2L-XC",
            "color": "TEAM Navy/Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Orange",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955244093"
          },
          {
            "id": "41021955276861",
            "gid": "gid://shopify/ProductVariant/41021955276861",
            "sku": "SET-10xM4TM-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955276861"
          },
          {
            "id": "41021955309629",
            "gid": "gid://shopify/ProductVariant/41021955309629",
            "sku": "SET-10xM4TM-60R-M4V-XA",
            "color": "TEAM Orange/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Orange/White",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955309629"
          },
          {
            "id": "41021955342397",
            "gid": "gid://shopify/ProductVariant/41021955342397",
            "sku": "SET-10xM4TM-60R-M4W-XA",
            "color": "TEAM Purple/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Purple/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955342397"
          },
          {
            "id": "41021955375165",
            "gid": "gid://shopify/ProductVariant/41021955375165",
            "sku": "SET-10xM4TM-60R-M4W-XB",
            "color": "TEAM Purple/yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Purple/yellow",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955375165"
          },
          {
            "id": "41021955407933",
            "gid": "gid://shopify/ProductVariant/41021955407933",
            "sku": "SET-10xM4TM-60R-M2M-XA",
            "color": "TEAM Royal/Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Royal/Orange",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955407933"
          },
          {
            "id": "41021955440701",
            "gid": "gid://shopify/ProductVariant/41021955440701",
            "sku": "SET-10xM4TM-60R-M2M-XB",
            "color": "TEAM Royal/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Royal/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955440701"
          },
          {
            "id": "41021955473469",
            "gid": "gid://shopify/ProductVariant/41021955473469",
            "sku": "SET-10xM4TM-60R-M2M-XC",
            "color": "TEAM Royal/Yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Royal/Yellow",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grip-bundle-set?variant=41021955473469"
          }
        ],
        "shopify_variant_count": 15,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "TEAM Black/Gold"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Black/Gold",
              "TEAM Dark Orange/White",
              "TEAM Dark Red/White",
              "TEAM Green/Gold",
              "TEAM Grey/Red",
              "TEAM Light Blue/White",
              "TEAM Navy/Orange",
              "TEAM Navy/Red",
              "TEAM Purple/White",
              "TEAM Royal/White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39669715042365",
            "gid": "gid://shopify/ProductVariant/39669715042365",
            "sku": "M4TM-60R-M1P-XA",
            "color": "TEAM Black/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Black/Gold",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715042365"
          },
          {
            "id": "39669715107901",
            "gid": "gid://shopify/ProductVariant/39669715107901",
            "sku": "M4TM-60R-M4U-XA",
            "color": "TEAM Dark Orange/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Orange/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715107901"
          },
          {
            "id": "39669715140669",
            "gid": "gid://shopify/ProductVariant/39669715140669",
            "sku": "M4TM-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715140669"
          },
          {
            "id": "39669715206205",
            "gid": "gid://shopify/ProductVariant/39669715206205",
            "sku": "M4TM-60R-M3L-XA",
            "color": "TEAM Green/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Green/Gold",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715206205"
          },
          {
            "id": "39669715238973",
            "gid": "gid://shopify/ProductVariant/39669715238973",
            "sku": "M4TM-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715238973"
          },
          {
            "id": "39669715271741",
            "gid": "gid://shopify/ProductVariant/39669715271741",
            "sku": "M4TM-60R-M2K-XA",
            "color": "TEAM Light Blue/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Light Blue/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715271741"
          },
          {
            "id": "39669715370045",
            "gid": "gid://shopify/ProductVariant/39669715370045",
            "sku": "M4TM-60R-M2L-XC",
            "color": "TEAM Navy/Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Orange",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715370045"
          },
          {
            "id": "39669715402813",
            "gid": "gid://shopify/ProductVariant/39669715402813",
            "sku": "M4TM-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715402813"
          },
          {
            "id": "39669715533885",
            "gid": "gid://shopify/ProductVariant/39669715533885",
            "sku": "M4TM-60R-M4W-XA",
            "color": "TEAM Purple/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Purple/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715533885"
          },
          {
            "id": "39669715632189",
            "gid": "gid://shopify/ProductVariant/39669715632189",
            "sku": "M4TM-60R-M2M-XB",
            "color": "TEAM Royal/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Royal/White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip?variant=39669715632189"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "TEAM Black/Gold"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Black/Gold",
              "TEAM Dark Red/White",
              "TEAM Green/Gold",
              "TEAM Grey/Red",
              "TEAM Light Blue/White",
              "TEAM Navy/Orange",
              "TEAM Navy/Red",
              "TEAM Purple/White",
              "TEAM Dark Orange/White",
              "TEAM Black/Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39669713666109",
            "gid": "gid://shopify/ProductVariant/39669713666109",
            "sku": "M4TS-60R-M1P-XA",
            "color": "TEAM Black/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Black/Gold",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=39669713666109"
          },
          {
            "id": "39669713764413",
            "gid": "gid://shopify/ProductVariant/39669713764413",
            "sku": "M4TS-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=39669713764413"
          },
          {
            "id": "39669713829949",
            "gid": "gid://shopify/ProductVariant/39669713829949",
            "sku": "M4TS-60R-M3L-XA",
            "color": "TEAM Green/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Green/Gold",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=39669713829949"
          },
          {
            "id": "39669713862717",
            "gid": "gid://shopify/ProductVariant/39669713862717",
            "sku": "M4TS-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=39669713862717"
          },
          {
            "id": "39669713895485",
            "gid": "gid://shopify/ProductVariant/39669713895485",
            "sku": "M4TS-60R-M2K-XA",
            "color": "TEAM Light Blue/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Light Blue/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=39669713895485"
          },
          {
            "id": "39669713993789",
            "gid": "gid://shopify/ProductVariant/39669713993789",
            "sku": "M4TS-60R-M2L-XC",
            "color": "TEAM Navy/Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=39669713993789"
          },
          {
            "id": "39669714059325",
            "gid": "gid://shopify/ProductVariant/39669714059325",
            "sku": "M4TS-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=39669714059325"
          },
          {
            "id": "39669714190397",
            "gid": "gid://shopify/ProductVariant/39669714190397",
            "sku": "M4TS-60R-M4W-XA",
            "color": "TEAM Purple/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Purple/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=39669714190397"
          },
          {
            "id": "61681993122162",
            "gid": "gid://shopify/ProductVariant/61681993122162",
            "sku": "M4TS-60R-M4U-XA",
            "color": "TEAM Dark Orange/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Orange/White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=61681993122162"
          },
          {
            "id": "61681993154930",
            "gid": "gid://shopify/ProductVariant/61681993154930",
            "sku": "M4TS-60R-M1R-XA",
            "color": "TEAM Black/Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Black/Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip?variant=61681993154930"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, bct cord, Brand_Golf Pride, cord, firm, golf pride bundle, golf pride single grip, Golf Pride Team, Golf Pride Teams, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, grip bundle, grip kit, hybrid, hybrid-golf-grips, iron/wood, mcc, mcc mult",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "TEAM Black/Gold",
      "TEAM Dark Orange/White",
      "TEAM Dark Red/White",
      "TEAM Green/Gold",
      "TEAM Grey/Red",
      "TEAM Light Blue/White",
      "TEAM Navy/Orange",
      "TEAM Navy/Red",
      "TEAM Purple/White",
      "TEAM Royal/White",
      "TEAM Black/Grey"
    ]
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-black-gold-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Black/Gold) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 182.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-black-gold",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-black-gold.jpg?v=1751587447",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 182.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-black-gold",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-black-gold",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826610237",
            "gid": "gid://shopify/ProductVariant/39915826610237",
            "sku": "KIT+13xM4TM-60R-M1P-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 182.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-black-gold?variant=39915826610237"
          },
          {
            "id": "39915826643005",
            "gid": "gid://shopify/ProductVariant/39915826643005",
            "sku": "KIT(8oz)+13xM4TM-60R-M1P-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 187.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-black-gold?variant=39915826643005"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-black-gold",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-black-gold",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827396669",
            "gid": "gid://shopify/ProductVariant/39915827396669",
            "sku": "KIT+13xM4TS-60R-M1P-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-black-gold?variant=39915827396669"
          },
          {
            "id": "39915827429437",
            "gid": "gid://shopify/ProductVariant/39915827429437",
            "sku": "KIT(8oz)+13xM4TS-60R-M1P-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-black-gold?variant=39915827429437"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-dark-orange-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Dark Orange/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-orange-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-darkorange-white.jpg?v=1751587445",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-orange-white",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-orange-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826544701",
            "gid": "gid://shopify/ProductVariant/39915826544701",
            "sku": "KIT+13xM4TM-60R-M4U-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-orange-white?variant=39915826544701"
          },
          {
            "id": "39915826577469",
            "gid": "gid://shopify/ProductVariant/39915826577469",
            "sku": "KIT(8oz)+13xM4TM-60R-M4U-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-orange-white?variant=39915826577469"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-orange-white",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-dark-orange-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827265597",
            "gid": "gid://shopify/ProductVariant/39915827265597",
            "sku": "KIT+13xM4TS-60R-M4U-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-orange-white?variant=39915827265597"
          },
          {
            "id": "39915827298365",
            "gid": "gid://shopify/ProductVariant/39915827298365",
            "sku": "KIT(8oz)+13xM4TS-60R-M4U-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-orange-white?variant=39915827298365"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf grip kit gift, golf pride bundle, golf pride gift",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-dark-red-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Dark Red/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Dark Red/White"
    ],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 182.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/mcc-plus4-teams-grip-kit-dark-red-white.jpg?v=1751587443",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Dark Red/White"
        ],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-white",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-white",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Dark Red/White"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39669821800509",
            "gid": "gid://shopify/ProductVariant/39669821800509",
            "sku": "KIT+13xM4TM-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-white?variant=39669821800509"
          },
          {
            "id": "40869652135997",
            "gid": "gid://shopify/ProductVariant/40869652135997",
            "sku": "KIT(8oz)+13xM4TM-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-white?variant=40869652135997"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Dark Red/White"
        ],
        "price": 182.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-red-white",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-dark-red-white",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Dark Red/White"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39669819310141",
            "gid": "gid://shopify/ProductVariant/39669819310141",
            "sku": "KIT+13xM4TS-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 182.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-red-white?variant=39669819310141"
          },
          {
            "id": "40869661769789",
            "gid": "gid://shopify/ProductVariant/40869661769789",
            "sku": "KIT(8oz)+13xM4TS-60R-M4S-XB",
            "color": "TEAM Dark Red/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Dark Red/White",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 187.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-red-white?variant=40869661769789"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "TEAM Dark Red/White"
    ]
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-dark-red-yellow-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Dark Red/Yellow) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 167.32,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 12.87,
    "bundle_price_min": null,
    "kit_price_min": 167.32,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-yellow",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-darkred-yellow.jpg?v=1751587442",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-yellow",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-yellow",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826479165",
            "gid": "gid://shopify/ProductVariant/39915826479165",
            "sku": "KIT+13xM4TM-60R-M4S-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-yellow?variant=39915826479165"
          },
          {
            "id": "39915826511933",
            "gid": "gid://shopify/ProductVariant/39915826511933",
            "sku": "KIT(8oz)+13xM4TM-60R-M4S-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-red-yellow?variant=39915826511933"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 167.32,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-red-yellow",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-dark-red-yellow",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827200061",
            "gid": "gid://shopify/ProductVariant/39915827200061",
            "sku": "KIT+13xM4TS-60R-M4S-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 167.32,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-red-yellow?variant=39915827200061"
          },
          {
            "id": "39915827232829",
            "gid": "gid://shopify/ProductVariant/39915827232829",
            "sku": "KIT(8oz)+13xM4TS-60R-M4S-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 170.29,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-dark-red-yellow?variant=39915827232829"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, Golf Pride Teams, golf-grips, golf-pride, golf-pride-model_mc",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-green-gold-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Green/Gold) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-green-gold",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-green-gold.jpg?v=1751587440",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-green-gold",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-green-gold",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826413629",
            "gid": "gid://shopify/ProductVariant/39915826413629",
            "sku": "KIT+13xM4TM-60R-M3L-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-green-gold?variant=39915826413629"
          },
          {
            "id": "39915826446397",
            "gid": "gid://shopify/ProductVariant/39915826446397",
            "sku": "KIT(8oz)+13xM4TM-60R-M3L-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-green-gold?variant=39915826446397"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-green-gold",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-green-gold",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827134525",
            "gid": "gid://shopify/ProductVariant/39915827134525",
            "sku": "KIT+13xM4TS-60R-M3L-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-green-gold?variant=39915827134525"
          },
          {
            "id": "39915827167293",
            "gid": "gid://shopify/ProductVariant/39915827167293",
            "sku": "KIT(8oz)+13xM4TS-60R-M3L-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-green-gold?variant=39915827167293"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf grip kit gift, golf pride bundle, golf pride gift",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-grey-red-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Grey/Red) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 182.35,
    "price_max": 182.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.03,
    "bundle_price_min": null,
    "kit_price_min": 182.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grey-red",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-grey-red.jpg?v=1751587438",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 182.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grey-red",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grey-red",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826348093",
            "gid": "gid://shopify/ProductVariant/39915826348093",
            "sku": "KIT+13xM4TM-60R-MC0-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 182.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grey-red?variant=39915826348093"
          },
          {
            "id": "39915826380861",
            "gid": "gid://shopify/ProductVariant/39915826380861",
            "sku": "KIT(8oz)+13xM4TM-60R-MC0-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 187.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-grey-red?variant=39915826380861"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, Golf Pride Teams, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-light-blue-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Light Blue/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-light-blue-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-lightblue-white.jpg?v=1751587436",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-light-blue-white",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-light-blue-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826249789",
            "gid": "gid://shopify/ProductVariant/39915826249789",
            "sku": "KIT+13xM4TM-60R-M2K-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-light-blue-white?variant=39915826249789"
          },
          {
            "id": "39915826282557",
            "gid": "gid://shopify/ProductVariant/39915826282557",
            "sku": "KIT(8oz)+13xM4TM-60R-M2K-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-light-blue-white?variant=39915826282557"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-light-blue-white",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-light-blue-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827068989",
            "gid": "gid://shopify/ProductVariant/39915827068989",
            "sku": "KIT+13xM4TS-60R-M2K-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-light-blue-white?variant=39915827068989"
          },
          {
            "id": "39915827101757",
            "gid": "gid://shopify/ProductVariant/39915827101757",
            "sku": "KIT(8oz)+13xM4TS-60R-M2K-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-light-blue-white?variant=39915827101757"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-maroon-gold-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Maroon/Gold) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Maroon/Gold"
    ],
    "weight_g_by_size": {
      "Midsize": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-maroon-gold",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/mcc-teams-plus4-maroon-gold_ce483917-5b4a-4be3-9d91-879d47eba0ee.jpg?v=1751587436",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Maroon/Gold"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-maroon-gold",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-maroon-gold",
        "shopify_variants": [
          {
            "id": "39669822259261",
            "gid": "gid://shopify/ProductVariant/39669822259261",
            "sku": "KIT+13xM4TM-60R-M4T-XA",
            "color": "TEAM Maroon/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Maroon/Gold",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-maroon-gold?variant=39669822259261"
          },
          {
            "id": "40869658263613",
            "gid": "gid://shopify/ProductVariant/40869658263613",
            "sku": "KIT(8oz)+13xM4TM-60R-M4T-XA",
            "color": "TEAM Maroon/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Maroon/Gold",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-maroon-gold?variant=40869658263613"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Maroon/Gold"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2025-black-friday, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, gp-gift-2025, grip kit, grip kit",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-navy-orange-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Navy/Orange) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-orange",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-navy-orange.jpg?v=1751587433",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-orange",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-orange",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826184253",
            "gid": "gid://shopify/ProductVariant/39915826184253",
            "sku": "KIT+13xM4TM-60R-M2L-XC",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-orange?variant=39915826184253"
          },
          {
            "id": "39915826217021",
            "gid": "gid://shopify/ProductVariant/39915826217021",
            "sku": "KIT(8oz)+13xM4TM-60R-M2L-XC",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-orange?variant=39915826217021"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-orange",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-navy-orange",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827003453",
            "gid": "gid://shopify/ProductVariant/39915827003453",
            "sku": "KIT+13xM4TS-60R-M2L-XC",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-orange?variant=39915827003453"
          },
          {
            "id": "39915827036221",
            "gid": "gid://shopify/ProductVariant/39915827036221",
            "sku": "KIT(8oz)+13xM4TS-60R-M2L-XC",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-orange?variant=39915827036221"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-navy-red-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Navy/Red) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Navy/Red"
    ],
    "weight_g_by_size": {
      "Midsize": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-red",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/mcc-plus4-teams-grip-kit-navy-red.jpg?v=1751587430",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Navy/Red"
        ],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-red",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-red",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Navy/Red"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39669822652477",
            "gid": "gid://shopify/ProductVariant/39669822652477",
            "sku": "KIT+13xM4TM-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-red?variant=39669822652477"
          },
          {
            "id": "40869641060413",
            "gid": "gid://shopify/ProductVariant/40869641060413",
            "sku": "KIT(8oz)+13xM4TM-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-red?variant=40869641060413"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "TEAM Navy/Red"
    ]
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-orange-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Orange/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-orange-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-orange-white.jpg?v=1751587425",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-orange-white",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-orange-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826118717",
            "gid": "gid://shopify/ProductVariant/39915826118717",
            "sku": "KIT+13xM4TM-60R-M4V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-orange-white?variant=39915826118717"
          },
          {
            "id": "39915826151485",
            "gid": "gid://shopify/ProductVariant/39915826151485",
            "sku": "KIT(8oz)+13xM4TM-60R-M4V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-orange-white?variant=39915826151485"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-orange-white",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-orange-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826937917",
            "gid": "gid://shopify/ProductVariant/39915826937917",
            "sku": "KIT+13xM4TS-60R-M4V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-orange-white?variant=39915826937917"
          },
          {
            "id": "39915826970685",
            "gid": "gid://shopify/ProductVariant/39915826970685",
            "sku": "KIT(8oz)+13xM4TS-60R-M4V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-orange-white?variant=39915826970685"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, Golf Pride Teams, golf-grips, golf-pride, golf-pride-model_mc",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-purple-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Purple/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-purple-white.jpg?v=1751587423",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-white",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826053181",
            "gid": "gid://shopify/ProductVariant/39915826053181",
            "sku": "KIT+13xM4TM-60R-M4W-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-white?variant=39915826053181"
          },
          {
            "id": "39915826085949",
            "gid": "gid://shopify/ProductVariant/39915826085949",
            "sku": "KIT(8oz)+13xM4TM-60R-M4W-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-white?variant=39915826085949"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-purple-white",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-purple-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826872381",
            "gid": "gid://shopify/ProductVariant/39915826872381",
            "sku": "KIT+13xM4TS-60R-M4W-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-purple-white?variant=39915826872381"
          },
          {
            "id": "39915826905149",
            "gid": "gid://shopify/ProductVariant/39915826905149",
            "sku": "KIT(8oz)+13xM4TS-60R-M4W-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-purple-white?variant=39915826905149"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-purple-yellow-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Purple/yellow) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-yellow",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-purple-yellow.jpg?v=1751587421",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-yellow",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-yellow",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915825987645",
            "gid": "gid://shopify/ProductVariant/39915825987645",
            "sku": "KIT+13xM4TM-60R-M4W-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-yellow?variant=39915825987645"
          },
          {
            "id": "39915826020413",
            "gid": "gid://shopify/ProductVariant/39915826020413",
            "sku": "KIT(8oz)+13xM4TM-60R-M4W-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-purple-yellow?variant=39915826020413"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-purple-yellow",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-purple-yellow",
        "shopify_variants": [
          {
            "id": "39915826806845",
            "gid": "gid://shopify/ProductVariant/39915826806845",
            "sku": "KIT+13xM4TS-60R-M4W-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-purple-yellow?variant=39915826806845"
          },
          {
            "id": "39915826839613",
            "gid": "gid://shopify/ProductVariant/39915826839613",
            "sku": "KIT(8oz)+13xM4TS-60R-M4W-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-purple-yellow?variant=39915826839613"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, Golf Pride Teams, golf-grips, golf-pride, golf-pride-model_mc",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-royal-blue-orange-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Royal Blue/Orange) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-orange",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-royalblue-orange.jpg?v=1751587419",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-orange",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-orange",
        "shopify_variants": [
          {
            "id": "39915825922109",
            "gid": "gid://shopify/ProductVariant/39915825922109",
            "sku": "KIT+13xM4TM-60R-M2M-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-orange?variant=39915825922109"
          },
          {
            "id": "39915825954877",
            "gid": "gid://shopify/ProductVariant/39915825954877",
            "sku": "KIT(8oz)+13xM4TM-60R-M2M-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-orange?variant=39915825954877"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf grip gift, golf grip kit gift, golf pride bundle, Golf Pride Team, Golf Pride Teams, golf-gr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-royal-blue-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Royal Blue/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-royalblue-white.jpg?v=1751587417",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-white",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915825856573",
            "gid": "gid://shopify/ProductVariant/39915825856573",
            "sku": "KIT+13xM4TM-60R-M2M-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-white?variant=39915825856573"
          },
          {
            "id": "39915825889341",
            "gid": "gid://shopify/ProductVariant/39915825889341",
            "sku": "KIT(8oz)+13xM4TM-60R-M2M-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-white?variant=39915825889341"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, Golf Pride Teams, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-royal-blue-yellow-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Royal Blue/Yellow) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-yellow",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-royalblue-yellow.jpg?v=1751587415",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-yellow",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-yellow",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915825791037",
            "gid": "gid://shopify/ProductVariant/39915825791037",
            "sku": "KIT+13xM4TM-60R-M2M-XC",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-yellow?variant=39915825791037"
          },
          {
            "id": "39915825823805",
            "gid": "gid://shopify/ProductVariant/39915825823805",
            "sku": "KIT(8oz)+13xM4TM-60R-M2M-XC",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-royal-yellow?variant=39915825823805"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-yellow",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-royal-yellow",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826675773",
            "gid": "gid://shopify/ProductVariant/39915826675773",
            "sku": "KIT+13xM4TS-60R-M2M-XC",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-yellow?variant=39915826675773"
          },
          {
            "id": "39915826708541",
            "gid": "gid://shopify/ProductVariant/39915826708541",
            "sku": "KIT(8oz)+13xM4TS-60R-M2M-XC",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-yellow?variant=39915826708541"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, Golf Pride Teams, golf-grips, golf-pride, golf-pride-model_mc",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-royal-orange-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Royal/Orange) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-orange",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-royalblue-orange_7a24cda8-ed9d-4eb7-b160-923432af9ad8.jpg?v=1751587452",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-orange",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-royal-orange",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915826741309",
            "gid": "gid://shopify/ProductVariant/39915826741309",
            "sku": "KIT+13xM4TS-60R-M2M-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-orange?variant=39915826741309"
          },
          {
            "id": "39915826774077",
            "gid": "gid://shopify/ProductVariant/39915826774077",
            "sku": "KIT(8oz)+13xM4TS-60R-M2M-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-orange?variant=39915826774077"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pride Team, Golf Pr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-plus4-teams-grip-royal-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC Plus4 Teams Grip (Royal/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit_3xmcc-teams-plus4-royalblue-white_ab400af9-ca6d-4df4-adba-2a7125f94634.jpg?v=1751587450",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-white",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-royal-white",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39669821571133",
            "gid": "gid://shopify/ProductVariant/39669821571133",
            "sku": "KIT+13xM4TS-60R-M2M-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-white?variant=39669821571133"
          },
          {
            "id": "39982839005245",
            "gid": "gid://shopify/ProductVariant/39982839005245",
            "sku": "KIT(8oz)+13xM4TS-60R-M2M-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-royal-white?variant=39982839005245"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-teams-new-decade",
    "brand": "Golf Pride",
    "model": "MCC TEAMS (New Decade)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "style_forward",
    "non_black_color_count": 15,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM BLACK/GOLD",
      "TEAM BLUE/ORANGE",
      "TEAM BLUE/WHITE",
      "TEAM BLUE/YELLOW",
      "TEAM DARK ORANGE/WHITE",
      "TEAM DARK RED/WHITE",
      "TEAM DARK RED/YELLOW",
      "TEAM GREEN/GOLD",
      "TEAM GREY/RED",
      "TEAM LIGHT BLUE/WHITE",
      "TEAM MAROON/GOLD",
      "TEAM NAVY/GOLD",
      "TEAM NAVY/ORANGE",
      "TEAM NAVY/RED",
      "TEAM NAVY/YELLOW"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 138.69,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 10.67,
    "bundle_price_min": null,
    "kit_price_min": 138.69,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-yellow-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2020-gp-kits-mcc-teams-blue-yellow_dffcc39e-98fc-444f-8500-79521f5d8331.jpg?v=1751587486",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 17,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM BLUE/YELLOW"
        ],
        "price": 169.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-yellow-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-team-blue-yellow-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "31940012343357",
            "gid": "gid://shopify/ProductVariant/31940012343357",
            "sku": "KIT+13xMCTS-60R-M2G-XC",
            "color": "TEAM BLUE/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/YELLOW"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-yellow-13pcs-golf-grip-kit?variant=31940012343357"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/YELLOW"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM NAVY/GOLD"
        ],
        "price": 169.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-gold-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-navy-gold-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "31940010901565",
            "gid": "gid://shopify/ProductVariant/31940010901565",
            "sku": "KIT+13xMCTS-60R-M2J-XA",
            "color": "TEAM NAVY/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/GOLD"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-gold-13pcs-golf-grip-kit?variant=31940010901565"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM NAVY/GOLD"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM NAVY/YELLOW"
        ],
        "price": 145.99,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-yellow-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-navy-yellow-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934112104509",
            "gid": "gid://shopify/ProductVariant/31934112104509",
            "sku": "KIT+13xMCTS-60R-M2F-XB",
            "color": "TEAM NAVY/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/YELLOW"
            },
            "available": false,
            "price": 145.99,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-yellow-13pcs-golf-grip-kit-free-20-gift-card?variant=31934112104509"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM NAVY/YELLOW"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM NAVY/RED"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-red-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-navy-red-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934110761021",
            "gid": "gid://shopify/ProductVariant/31934110761021",
            "sku": "KIT+13xMCTS-60R-M2F-XD",
            "color": "TEAM NAVY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/RED"
            },
            "available": false,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-red-13pcs-golf-grip-kit-free-20-gift-card?variant=31934110761021"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM NAVY/RED"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM NAVY/ORANGE"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-orange-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-navy-orange-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934109810749",
            "gid": "gid://shopify/ProductVariant/31934109810749",
            "sku": "KIT+13xMCTS-60R-M2F-XC",
            "color": "TEAM NAVY/ORANGE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/ORANGE"
            },
            "available": true,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-orange-13pcs-golf-grip-kit-free-20-gift-card?variant=31934109810749"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM NAVY/ORANGE"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM NAVY/GOLD"
        ],
        "price": 145.99,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-gold-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-navy-gold-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934109155389",
            "gid": "gid://shopify/ProductVariant/31934109155389",
            "sku": "KIT+13xMCTS-60R-M2J-XA",
            "color": "TEAM NAVY/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/GOLD"
            },
            "available": false,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-gold-13pcs-golf-grip-kit-free-20-gift-card?variant=31934109155389"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM NAVY/GOLD"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM MAROON/GOLD"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-maroon-gold-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-maroon-gold-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934107844669",
            "gid": "gid://shopify/ProductVariant/31934107844669",
            "sku": "KIT+13xMCTS-60R-M4Q-XA",
            "color": "TEAM MAROON/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM MAROON/GOLD"
            },
            "available": false,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-maroon-gold-13pcs-golf-grip-kit-free-20-gift-card?variant=31934107844669"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM MAROON/GOLD"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM LIGHT BLUE/WHITE"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-light-blue-white-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-light-blue-white-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934105878589",
            "gid": "gid://shopify/ProductVariant/31934105878589",
            "sku": "KIT+13xMCTS-60R-M2H-XA",
            "color": "TEAM LIGHT BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM LIGHT BLUE/WHITE"
            },
            "available": true,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-light-blue-white-13pcs-golf-grip-kit-free-20-gift-card?variant=31934105878589"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM LIGHT BLUE/WHITE"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM GREY/RED"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-grey-red-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-grey-red-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934105157693",
            "gid": "gid://shopify/ProductVariant/31934105157693",
            "sku": "KIT+13xMCTS-60R-M0V-XA",
            "color": "TEAM GREY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREY/RED"
            },
            "available": false,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-grey-red-13pcs-golf-grip-kit-free-20-gift-card?variant=31934105157693"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM GREY/RED"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM GREEN/GOLD"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-green-gold-13pcs-golf-grip-kit-free-20-gift-card-1",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-green-gold-13pcs-golf-grip-kit-free-20-gift-card-1",
        "shopify_variants": [
          {
            "id": "31934104404029",
            "gid": "gid://shopify/ProductVariant/31934104404029",
            "sku": "KIT+13xMCTS-60R-M3K-XA",
            "color": "TEAM GREEN/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREEN/GOLD"
            },
            "available": false,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-green-gold-13pcs-golf-grip-kit-free-20-gift-card-1?variant=31934104404029"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM GREEN/GOLD"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM DARK RED/YELLOW"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-yellow-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-dark-red-yellow-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934102732861",
            "gid": "gid://shopify/ProductVariant/31934102732861",
            "sku": "KIT+13xMCTS-60R-M4P-XC",
            "color": "TEAM DARK RED/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/YELLOW"
            },
            "available": true,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-yellow-13pcs-golf-grip-kit-free-20-gift-card?variant=31934102732861"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM DARK RED/YELLOW"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM DARK RED/WHITE"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-white-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-dark-red-white-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934102011965",
            "gid": "gid://shopify/ProductVariant/31934102011965",
            "sku": "KIT+13xMCTS-60R-M4P-XB",
            "color": "TEAM DARK RED/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/WHITE"
            },
            "available": true,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-white-13pcs-golf-grip-kit-free-20-gift-card?variant=31934102011965"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM DARK RED/WHITE"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM DARK ORANGE/WHITE"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-orange-white-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-dark-orange-white-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934101094461",
            "gid": "gid://shopify/ProductVariant/31934101094461",
            "sku": "KIT+13xMCTS-60R-M4R-XA",
            "color": "TEAM DARK ORANGE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK ORANGE/WHITE"
            },
            "available": false,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-orange-white-13pcs-golf-grip-kit-free-20-gift-card?variant=31934101094461"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM DARK ORANGE/WHITE"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM BLUE/WHITE"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-white-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-team-blue-white-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934100734013",
            "gid": "gid://shopify/ProductVariant/31934100734013",
            "sku": "KIT+13xMCTS-60R-M2G-XB",
            "color": "TEAM BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/WHITE"
            },
            "available": true,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-white-13pcs-golf-grip-kit-free-20-gift-card?variant=31934100734013"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/WHITE"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM BLUE/YELLOW"
        ],
        "price": 145.99,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-yellow-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-team-blue-yellow-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934099685437",
            "gid": "gid://shopify/ProductVariant/31934099685437",
            "sku": "KIT+13xMCTS-60R-M2G-XC",
            "color": "TEAM BLUE/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/YELLOW"
            },
            "available": false,
            "price": 145.99,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-yellow-13pcs-golf-grip-kit-free-20-gift-card?variant=31934099685437"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/YELLOW"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM BLACK/GOLD"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-black-gold-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-team-black-gold-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934098145341",
            "gid": "gid://shopify/ProductVariant/31934098145341",
            "sku": "KIT+13xMCTS-60R-M1L-XA",
            "color": "TEAM BLACK/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLACK/GOLD"
            },
            "available": false,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-black-gold-13pcs-golf-grip-kit-free-20-gift-card?variant=31934098145341"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLACK/GOLD"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM BLUE/ORANGE"
        ],
        "price": 138.69,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-orange-13pcs-golf-grip-kit-free-20-gift-card",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-team-blue-orange-13pcs-golf-grip-kit-free-20-gift-card",
        "shopify_variants": [
          {
            "id": "31934095720509",
            "gid": "gid://shopify/ProductVariant/31934095720509",
            "sku": "KIT+13xMCTS-60R-M2G-XA",
            "color": "TEAM BLUE/ORANGE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/ORANGE"
            },
            "available": false,
            "price": 138.69,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-orange-13pcs-golf-grip-kit-free-20-gift-card?variant=31934095720509"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/ORANGE"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, blackfriday2020, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Grip Kits, golf-pride, golf-pride-model_mcc-classic-standar",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "Teams = New Decade MCC dual-color",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "TEAM NAVY/ORANGE",
      "TEAM LIGHT BLUE/WHITE",
      "TEAM DARK RED/YELLOW",
      "TEAM DARK RED/WHITE",
      "TEAM BLUE/WHITE"
    ]
  },
  {
    "id": "golf-pride-mcc-teams-plus4-grip-dark-green-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC TEAMS Plus4 Grip (Dark Green/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Dark Green/White"
    ],
    "weight_g_by_size": {
      "Midsize": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-green-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/mcc-teams-plus4-darkgreen-white_9e0026ec-8be9-41ad-99b7-401eaa1516a1.jpg?v=1751587446",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Dark Green/White"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-green-white",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-green-white",
        "shopify_variants": [
          {
            "id": "39669821702205",
            "gid": "gid://shopify/ProductVariant/39669821702205",
            "sku": "KIT+13xM4TM-60R-M3M-XA",
            "color": "TEAM Dark Green/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Dark Green/White"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-dark-green-white?variant=39669821702205"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Dark Green/White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2025-black-friday, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, gp-gift-2025, grip kit, grip kit",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-teams-plus4-grip-grey-red-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC TEAMS Plus4 Grip (Grey/Red) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Grey/Red"
    ],
    "weight_g_by_size": {
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-grey-red",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/mcc-plus4-teams-grip-kit-grey-red.jpg?v=1751587466",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Grey/Red"
        ],
        "price": 181.28,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-grey-red",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-grey-red",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Grey/Red"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39669819637821",
            "gid": "gid://shopify/ProductVariant/39669819637821",
            "sku": "KIT+13xM4TS-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-grey-red?variant=39669819637821"
          },
          {
            "id": "40869675171901",
            "gid": "gid://shopify/ProductVariant/40869675171901",
            "sku": "KIT(8oz)+13xM4TS-60R-MC0-XA",
            "color": "TEAM Grey/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Grey/Red",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-grey-red?variant=40869675171901"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pride Team, golf-grips, golf",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "TEAM Grey/Red"
    ]
  },
  {
    "id": "golf-pride-mcc-teams-plus4-grip-maroon-gold-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC TEAMS Plus4 Grip (Maroon/Gold) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Maroon/Gold"
    ],
    "weight_g_by_size": {
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-maroon-gold",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/mcc-teams-plus4-maroon-gold_f9e2c6d2-f7b6-42e8-9cf2-dd66b4b43442.jpg?v=1751587463",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Maroon/Gold"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-maroon-gold",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-maroon-gold",
        "shopify_variants": [
          {
            "id": "39669819965501",
            "gid": "gid://shopify/ProductVariant/39669819965501",
            "sku": "KIT+13xM4TS-60R-M4T-XA",
            "color": "TEAM Maroon/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Maroon/Gold"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-maroon-gold?variant=39669819965501"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Maroon/Gold"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2025-black-friday, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, gp-gift-2025, grip kit, grip kit",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-teams-plus4-grip-navy-gold-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC TEAMS Plus4 Grip (Navy/Gold) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Navy/Gold"
    ],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-gold",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/mcc-teams-plus4-navy-gold_0d687c5d-6408-4e0d-bc90-095db6283022.jpg?v=1751587435",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Navy/Gold"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-gold",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-gold",
        "shopify_variants": [
          {
            "id": "39669822324797",
            "gid": "gid://shopify/ProductVariant/39669822324797",
            "sku": "KIT+13xM4TM-60R-M2Q-XA",
            "color": "TEAM Navy/Gold",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Gold"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-gold?variant=39669822324797"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Navy/Gold"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Navy/Gold"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-gold",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-navy-gold",
        "shopify_variants": [
          {
            "id": "39669820227645",
            "gid": "gid://shopify/ProductVariant/39669820227645",
            "sku": "KIT+13xM4TS-60R-M2Q-XA",
            "color": "TEAM Navy/Gold",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Gold"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-gold?variant=39669820227645"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Navy/Gold"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2025-black-friday, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, gp-gift-2025, grip kit, grip kit",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-teams-plus4-grip-navy-red-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC TEAMS Plus4 Grip (Navy/Red) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Navy/Red"
    ],
    "weight_g_by_size": {
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 182.35,
    "price_max": 182.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.03,
    "bundle_price_min": null,
    "kit_price_min": 182.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-red",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/mcc-plus4-teams-grip-kit-navy-red_eb5133f5-29b2-47b8-a54c-47a1ed8047fe.jpg?v=1751587459",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Navy/Red"
        ],
        "price": 182.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-red",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-navy-red",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Navy/Red"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39669820850237",
            "gid": "gid://shopify/ProductVariant/39669820850237",
            "sku": "KIT+13xM4TS-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 182.35,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-red?variant=39669820850237"
          },
          {
            "id": "40869676056637",
            "gid": "gid://shopify/ProductVariant/40869676056637",
            "sku": "KIT(8oz)+13xM4TS-60R-M2L-XD",
            "color": "TEAM Navy/Red",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Red",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 187.55,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-red?variant=40869676056637"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "150-200, 2023-sale, 2025-black-friday, 2025-winter-sale-no-fuj, All products, bct cord, bf-nonassembled, bf-sale, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pride Team, golf-grips, golf-pride, golf-prid",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-teams-plus4-grip-navy-white-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC TEAMS Plus4 Grip (Navy/White) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Navy/White"
    ],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/mcc-teams-plus4-navy-white_7bd58f8f-ad13-48f7-a0e6-32ff125509c1.jpg?v=1751587429",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Navy/White"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-white",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-white",
        "shopify_variants": [
          {
            "id": "39669822718013",
            "gid": "gid://shopify/ProductVariant/39669822718013",
            "sku": "KIT+13xM4TM-60R-M2L-XA",
            "color": "TEAM Navy/White",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/White"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-white?variant=39669822718013"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Navy/White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Navy/White"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-white",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-navy-white",
        "shopify_variants": [
          {
            "id": "39669820883005",
            "gid": "gid://shopify/ProductVariant/39669820883005",
            "sku": "KIT+13xM4TS-60R-M2L-XA",
            "color": "TEAM Navy/White",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/White"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-white?variant=39669820883005"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Navy/White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2025-black-friday, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, gp-gift-2025, grip kit, grip kit",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-teams-plus4-grip-navy-yellow-13pcs-golf-grip-kit",
    "brand": "Golf Pride",
    "model": "MCC TEAMS Plus4 Grip (Navy/Yellow) - 13pcs + Golf Grip Kit",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "TEAM Navy/Yellow"
    ],
    "weight_g_by_size": {
      "Midsize": 69.8,
      "Standard": 69.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 169.35,
    "price_max": 169.35,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.03,
    "bundle_price_min": null,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-yellow",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/mcc-teams-plus4-navy-yellow_2d25376b-9f14-495c-8a4d-38958c38c6ab.jpg?v=1751587428",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Navy/Yellow"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-yellow",
        "handle": "golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-yellow",
        "shopify_variants": [
          {
            "id": "39669822881853",
            "gid": "gid://shopify/ProductVariant/39669822881853",
            "sku": "KIT+13xM4TM-60R-M2L-XB",
            "color": "TEAM Navy/Yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM Navy/Yellow"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-new-decade-midsize-grip-navy-yellow?variant=39669822881853"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Navy/Yellow"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "TEAM Navy/Yellow"
        ],
        "price": 169.35,
        "per_grip_g": 69.8,
        "total_g": 908.001206266,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-yellow",
        "handle": "golf-pride-mcc-teams-plus4-standard-grip-team-navy-yellow",
        "shopify_variants": [
          {
            "id": "39669820915773",
            "gid": "gid://shopify/ProductVariant/39669820915773",
            "sku": "KIT+13xM4TS-60R-M2L-XB",
            "color": "TEAM Navy/Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM Navy/Yellow"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-plus4-standard-grip-team-navy-yellow?variant=39669820915773"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM Navy/Yellow"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2025-black-friday, 2025-winter-sale-no-fuj, All products, bct cord, Brand_Golf Pride, bundle, bundles-asbl-driver-only, cord, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Team, golf-grips, golf-pride, golf-pride-model_mcc-plus4-reduced-taper, gp-gift-2025, grip kit, grip kit",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Plus4 = larger lower hand, lighter pressure",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-mcc-teams",
    "brand": "Golf Pride",
    "model": "MCC Teams",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/mcc-collection/mcc-plus4.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "TEAM BLACK/GOLD",
      "TEAM BLUE/ORANGE",
      "TEAM BLUE/WHITE"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 12.99,
    "price_max": 182.35,
    "single_price_min": 12.99,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 11.99,
    "bundle_price_min": 103.92,
    "kit_price_min": 167.32,
    "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/mcc-teams-front_fe6ad3bf-7a97-4eaa-a6dd-d5820f41059c.jpg?v=1761759809",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 31,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "TEAM BLUE/WHITE"
        ],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip",
        "handle": "8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/WHITE",
              "TEAM DARK ORANGE/WHITE",
              "TEAM LIGHT BLUE/WHITE",
              "TEAM NAVY/RED",
              "TEAM BLACK/GOLD",
              "TEAM GREY/RED",
              "TEAM NAVY/ORANGE",
              "TEAM GREEN/GOLD",
              "TEAM DARK RED/WHITE"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638723993970",
            "gid": "gid://shopify/ProductVariant/61638723993970",
            "sku": "SET-8xMCTM-60R-M2G-XB",
            "color": "TEAM BLUE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM BLUE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=61638723993970"
          },
          {
            "id": "61638724026738",
            "gid": "gid://shopify/ProductVariant/61638724026738",
            "sku": "SET-8xMCTM-60R-M4R-XA",
            "color": "TEAM DARK ORANGE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM DARK ORANGE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=61638724026738"
          },
          {
            "id": "61638724059506",
            "gid": "gid://shopify/ProductVariant/61638724059506",
            "sku": "SET-8xMCTM-60R-M2H-XA",
            "color": "TEAM LIGHT BLUE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM LIGHT BLUE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=61638724059506"
          },
          {
            "id": "61638724092274",
            "gid": "gid://shopify/ProductVariant/61638724092274",
            "sku": "SET-8xMCTM-60R-M2F-XD",
            "color": "TEAM NAVY/RED",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM NAVY/RED",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=61638724092274"
          },
          {
            "id": "61638724125042",
            "gid": "gid://shopify/ProductVariant/61638724125042",
            "sku": "SET-8xMCTM-60R-M1L-XA",
            "color": "TEAM BLACK/GOLD",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM BLACK/GOLD",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=61638724125042"
          },
          {
            "id": "61638724157810",
            "gid": "gid://shopify/ProductVariant/61638724157810",
            "sku": "SET-8xMCTM-60R-M0V-XA",
            "color": "TEAM GREY/RED",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM GREY/RED",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=61638724157810"
          },
          {
            "id": "61638724190578",
            "gid": "gid://shopify/ProductVariant/61638724190578",
            "sku": "SET-8xMCTM-60R-M2F-XC",
            "color": "TEAM NAVY/ORANGE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM NAVY/ORANGE",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=61638724190578"
          },
          {
            "id": "61638724223346",
            "gid": "gid://shopify/ProductVariant/61638724223346",
            "sku": "SET-8xMCTM-60R-M3K-XA",
            "color": "TEAM GREEN/GOLD",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM GREEN/GOLD",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=61638724223346"
          },
          {
            "id": "61638724256114",
            "gid": "gid://shopify/ProductVariant/61638724256114",
            "sku": "SET-8xMCTM-60R-M4P-XB",
            "color": "TEAM DARK RED/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM DARK RED/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=61638724256114"
          }
        ],
        "shopify_variant_count": 9,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "TEAM BLUE/ORANGE"
        ],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip",
        "handle": "8pc-bundle-golf-pride-mcc-team-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/ORANGE",
              "TEAM BLACK/GOLD",
              "TEAM BLUE/WHITE",
              "TEAM DARK ORANGE/WHITE",
              "TEAM DARK RED/WHITE",
              "TEAM DARK RED/YELLOW",
              "TEAM GREEN/GOLD",
              "TEAM GREY/RED",
              "TEAM LIGHT BLUE/WHITE",
              "TEAM MAROON/GOLD",
              "TEAM NAVY/ORANGE",
              "TEAM NAVY/RED",
              "TEAM NAVY/YELLOW"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638723535218",
            "gid": "gid://shopify/ProductVariant/61638723535218",
            "sku": "SET-8xMCTS-60R-M2G-XA",
            "color": "TEAM BLUE/ORANGE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/ORANGE",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723535218"
          },
          {
            "id": "61638723567986",
            "gid": "gid://shopify/ProductVariant/61638723567986",
            "sku": "SET-8xMCTS-60R-M1L-XA",
            "color": "TEAM BLACK/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLACK/GOLD",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723567986"
          },
          {
            "id": "61638723600754",
            "gid": "gid://shopify/ProductVariant/61638723600754",
            "sku": "SET-8xMCTS-60R-M2G-XB",
            "color": "TEAM BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/WHITE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723600754"
          },
          {
            "id": "61638723633522",
            "gid": "gid://shopify/ProductVariant/61638723633522",
            "sku": "SET-8xMCTS-60R-M4R-XA",
            "color": "TEAM DARK ORANGE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK ORANGE/WHITE",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723633522"
          },
          {
            "id": "61638723666290",
            "gid": "gid://shopify/ProductVariant/61638723666290",
            "sku": "SET-8xMCTS-60R-M4P-XB",
            "color": "TEAM DARK RED/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/WHITE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723666290"
          },
          {
            "id": "61638723699058",
            "gid": "gid://shopify/ProductVariant/61638723699058",
            "sku": "SET-8xMCTS-60R-M4P-XC",
            "color": "TEAM DARK RED/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/YELLOW",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723699058"
          },
          {
            "id": "61638723731826",
            "gid": "gid://shopify/ProductVariant/61638723731826",
            "sku": "SET-8xMCTS-60R-M3K-XA",
            "color": "TEAM GREEN/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREEN/GOLD",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723731826"
          },
          {
            "id": "61638723764594",
            "gid": "gid://shopify/ProductVariant/61638723764594",
            "sku": "SET-8xMCTS-60R-M0V-XA",
            "color": "TEAM GREY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREY/RED",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723764594"
          },
          {
            "id": "61638723797362",
            "gid": "gid://shopify/ProductVariant/61638723797362",
            "sku": "SET-8xMCTS-60R-M2H-XA",
            "color": "TEAM LIGHT BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM LIGHT BLUE/WHITE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723797362"
          },
          {
            "id": "61638723830130",
            "gid": "gid://shopify/ProductVariant/61638723830130",
            "sku": "SET-8xMCTS-60R-M4Q-XA",
            "color": "TEAM MAROON/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM MAROON/GOLD",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723830130"
          },
          {
            "id": "61638723862898",
            "gid": "gid://shopify/ProductVariant/61638723862898",
            "sku": "SET-8xMCTS-60R-M2F-XC",
            "color": "TEAM NAVY/ORANGE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/ORANGE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723862898"
          },
          {
            "id": "61638723895666",
            "gid": "gid://shopify/ProductVariant/61638723895666",
            "sku": "SET-8xMCTS-60R-M2F-XD",
            "color": "TEAM NAVY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/RED",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723895666"
          },
          {
            "id": "61638723928434",
            "gid": "gid://shopify/ProductVariant/61638723928434",
            "sku": "SET-8xMCTS-60R-M2F-XB",
            "color": "TEAM NAVY/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/YELLOW",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mcc-team-standard-grip?variant=61638723928434"
          }
        ],
        "shopify_variant_count": 13,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "TEAM BLUE/ORANGE"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip",
        "handle": "13pc-bundle-golf-pride-mcc-team-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/ORANGE",
              "TEAM BLACK/GOLD",
              "TEAM BLUE/WHITE",
              "TEAM DARK ORANGE/WHITE",
              "TEAM DARK RED/WHITE",
              "TEAM DARK RED/YELLOW",
              "TEAM GREEN/GOLD",
              "TEAM GREY/RED",
              "TEAM LIGHT BLUE/WHITE",
              "TEAM MAROON/GOLD",
              "TEAM NAVY/ORANGE",
              "TEAM NAVY/RED",
              "TEAM NAVY/YELLOW"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791457022322",
            "gid": "gid://shopify/ProductVariant/60791457022322",
            "sku": "SET-13xMCTS-60R-M2G-XA",
            "color": "TEAM BLUE/ORANGE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/ORANGE",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457022322"
          },
          {
            "id": "60791457055090",
            "gid": "gid://shopify/ProductVariant/60791457055090",
            "sku": "SET-13xMCTS-60R-M1L-XA",
            "color": "TEAM BLACK/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLACK/GOLD",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457055090"
          },
          {
            "id": "60791457087858",
            "gid": "gid://shopify/ProductVariant/60791457087858",
            "sku": "SET-13xMCTS-60R-M2G-XB",
            "color": "TEAM BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/WHITE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457087858"
          },
          {
            "id": "60791457120626",
            "gid": "gid://shopify/ProductVariant/60791457120626",
            "sku": "SET-13xMCTS-60R-M4R-XA",
            "color": "TEAM DARK ORANGE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK ORANGE/WHITE",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457120626"
          },
          {
            "id": "60791457153394",
            "gid": "gid://shopify/ProductVariant/60791457153394",
            "sku": "SET-13xMCTS-60R-M4P-XB",
            "color": "TEAM DARK RED/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/WHITE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457153394"
          },
          {
            "id": "60791457186162",
            "gid": "gid://shopify/ProductVariant/60791457186162",
            "sku": "SET-13xMCTS-60R-M4P-XC",
            "color": "TEAM DARK RED/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/YELLOW",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457186162"
          },
          {
            "id": "60791457218930",
            "gid": "gid://shopify/ProductVariant/60791457218930",
            "sku": "SET-13xMCTS-60R-M3K-XA",
            "color": "TEAM GREEN/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREEN/GOLD",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457218930"
          },
          {
            "id": "60791457251698",
            "gid": "gid://shopify/ProductVariant/60791457251698",
            "sku": "SET-13xMCTS-60R-M0V-XA",
            "color": "TEAM GREY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREY/RED",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457251698"
          },
          {
            "id": "60791457284466",
            "gid": "gid://shopify/ProductVariant/60791457284466",
            "sku": "SET-13xMCTS-60R-M2H-XA",
            "color": "TEAM LIGHT BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM LIGHT BLUE/WHITE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457284466"
          },
          {
            "id": "60791457317234",
            "gid": "gid://shopify/ProductVariant/60791457317234",
            "sku": "SET-13xMCTS-60R-M4Q-XA",
            "color": "TEAM MAROON/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM MAROON/GOLD",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457317234"
          },
          {
            "id": "60791457350002",
            "gid": "gid://shopify/ProductVariant/60791457350002",
            "sku": "SET-13xMCTS-60R-M2F-XC",
            "color": "TEAM NAVY/ORANGE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/ORANGE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457350002"
          },
          {
            "id": "60791457382770",
            "gid": "gid://shopify/ProductVariant/60791457382770",
            "sku": "SET-13xMCTS-60R-M2F-XD",
            "color": "TEAM NAVY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/RED",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457382770"
          },
          {
            "id": "60791457415538",
            "gid": "gid://shopify/ProductVariant/60791457415538",
            "sku": "SET-13xMCTS-60R-M2F-XB",
            "color": "TEAM NAVY/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/YELLOW",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-team-standard-grip?variant=60791457415538"
          }
        ],
        "shopify_variant_count": 13,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "TEAM BLUE/WHITE"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip",
        "handle": "13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/WHITE",
              "TEAM DARK ORANGE/WHITE",
              "TEAM LIGHT BLUE/WHITE",
              "TEAM NAVY/RED",
              "TEAM BLACK/GOLD",
              "TEAM GREY/RED",
              "TEAM NAVY/ORANGE",
              "TEAM GREEN/GOLD",
              "TEAM DARK RED/WHITE"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791456563570",
            "gid": "gid://shopify/ProductVariant/60791456563570",
            "sku": "SET-13xMCTM-60R-M2G-XB",
            "color": "TEAM BLUE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM BLUE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=60791456563570"
          },
          {
            "id": "60791456596338",
            "gid": "gid://shopify/ProductVariant/60791456596338",
            "sku": "SET-13xMCTM-60R-M4R-XA",
            "color": "TEAM DARK ORANGE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM DARK ORANGE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=60791456596338"
          },
          {
            "id": "60791456629106",
            "gid": "gid://shopify/ProductVariant/60791456629106",
            "sku": "SET-13xMCTM-60R-M2H-XA",
            "color": "TEAM LIGHT BLUE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM LIGHT BLUE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=60791456629106"
          },
          {
            "id": "60791456661874",
            "gid": "gid://shopify/ProductVariant/60791456661874",
            "sku": "SET-13xMCTM-60R-M2F-XD",
            "color": "TEAM NAVY/RED",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM NAVY/RED",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=60791456661874"
          },
          {
            "id": "60791456694642",
            "gid": "gid://shopify/ProductVariant/60791456694642",
            "sku": "SET-13xMCTM-60R-M1L-XA",
            "color": "TEAM BLACK/GOLD",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM BLACK/GOLD",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=60791456694642"
          },
          {
            "id": "60791456727410",
            "gid": "gid://shopify/ProductVariant/60791456727410",
            "sku": "SET-13xMCTM-60R-M0V-XA",
            "color": "TEAM GREY/RED",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM GREY/RED",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=60791456727410"
          },
          {
            "id": "60791456760178",
            "gid": "gid://shopify/ProductVariant/60791456760178",
            "sku": "SET-13xMCTM-60R-M2F-XC",
            "color": "TEAM NAVY/ORANGE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM NAVY/ORANGE",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=60791456760178"
          },
          {
            "id": "60791456792946",
            "gid": "gid://shopify/ProductVariant/60791456792946",
            "sku": "SET-13xMCTM-60R-M3K-XA",
            "color": "TEAM GREEN/GOLD",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM GREEN/GOLD",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=60791456792946"
          },
          {
            "id": "60791456825714",
            "gid": "gid://shopify/ProductVariant/60791456825714",
            "sku": "SET-13xMCTM-60R-M4P-XB",
            "color": "TEAM DARK RED/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM DARK RED/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mcc-teams-new-decade-midsize-grip?variant=60791456825714"
          }
        ],
        "shopify_variant_count": 9,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 182.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-navy-orange-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-midsize-grip-navy-orange-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51964863185266",
            "gid": "gid://shopify/ProductVariant/51964863185266",
            "sku": "KIT+13xMCTM-60R-M2F-XC",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 182.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-navy-orange-13pcs-golf-grip-kit?variant=51964863185266"
          },
          {
            "id": "51964863218034",
            "gid": "gid://shopify/ProductVariant/51964863218034",
            "sku": "KIT(8oz)+13xMCTM-60R-M2F-XC",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 187.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-navy-orange-13pcs-golf-grip-kit?variant=51964863218034"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-grey-red-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-midsize-grip-grey-red-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51964859810162",
            "gid": "gid://shopify/ProductVariant/51964859810162",
            "sku": "KIT+13xMCTM-60R-M0V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-grey-red-13pcs-golf-grip-kit?variant=51964859810162"
          },
          {
            "id": "51964858794354",
            "gid": "gid://shopify/ProductVariant/51964858794354",
            "sku": "KIT(8oz)+13xMCTM-60R-M0V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-grey-red-13pcs-golf-grip-kit?variant=51964858794354"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-dark-red-white-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-midsize-grip-dark-red-white-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51964856762738",
            "gid": "gid://shopify/ProductVariant/51964856762738",
            "sku": "KIT+13xMCTM-60R-M4P-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-dark-red-white-13pcs-golf-grip-kit?variant=51964856762738"
          },
          {
            "id": "51964856795506",
            "gid": "gid://shopify/ProductVariant/51964856795506",
            "sku": "KIT(8oz)+13xMCTM-60R-M4P-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-dark-red-white-13pcs-golf-grip-kit?variant=51964856795506"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-standard-grip-dark-red-white-13pcs-golf-grip-kit-copy",
        "handle": "golf-pride-mcc-teams-standard-grip-dark-red-white-13pcs-golf-grip-kit-copy",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51964855452018",
            "gid": "gid://shopify/ProductVariant/51964855452018",
            "sku": "KIT+13xMCTS-60R-M4P-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-standard-grip-dark-red-white-13pcs-golf-grip-kit-copy?variant=51964855452018"
          },
          {
            "id": "51964855484786",
            "gid": "gid://shopify/ProductVariant/51964855484786",
            "sku": "KIT(8oz)+13xMCTS-60R-M4P-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-standard-grip-dark-red-white-13pcs-golf-grip-kit-copy?variant=51964855484786"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-green-gold-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-midsize-grip-green-gold-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51964842606962",
            "gid": "gid://shopify/ProductVariant/51964842606962",
            "sku": "KIT+13xMCTM-60R-M3K-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-green-gold-13pcs-golf-grip-kit?variant=51964842606962"
          },
          {
            "id": "51964842639730",
            "gid": "gid://shopify/ProductVariant/51964842639730",
            "sku": "KIT(8oz)+13xMCTM-60R-M3K-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-green-gold-13pcs-golf-grip-kit?variant=51964842639730"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-team-black-gold-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-midsize-grip-team-black-gold-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51964841886066",
            "gid": "gid://shopify/ProductVariant/51964841886066",
            "sku": "KIT+13xMCTM-60R-M1L-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-team-black-gold-13pcs-golf-grip-kit?variant=51964841886066"
          },
          {
            "id": "51964841918834",
            "gid": "gid://shopify/ProductVariant/51964841918834",
            "sku": "KIT(8oz)+13xMCTM-60R-M1L-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-midsize-grip-team-black-gold-13pcs-golf-grip-kit?variant=51964841918834"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "TEAM BLUE/ORANGE"
        ],
        "price": 119.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-team-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/ORANGE",
              "TEAM BLACK/GOLD",
              "TEAM BLUE/WHITE",
              "TEAM DARK ORANGE/WHITE",
              "TEAM DARK RED/WHITE",
              "TEAM DARK RED/YELLOW",
              "TEAM GREEN/GOLD",
              "TEAM GREY/RED",
              "TEAM LIGHT BLUE/WHITE",
              "TEAM MAROON/GOLD",
              "TEAM NAVY/ORANGE",
              "TEAM NAVY/RED",
              "TEAM NAVY/YELLOW"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021960224829",
            "gid": "gid://shopify/ProductVariant/41021960224829",
            "sku": "SET-10xMCTS-60R-M2G-XA",
            "color": "TEAM BLUE/ORANGE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/ORANGE",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960224829"
          },
          {
            "id": "41021960257597",
            "gid": "gid://shopify/ProductVariant/41021960257597",
            "sku": "SET-10xMCTS-60R-M1L-XA",
            "color": "TEAM BLACK/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLACK/GOLD",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960257597"
          },
          {
            "id": "41021960290365",
            "gid": "gid://shopify/ProductVariant/41021960290365",
            "sku": "SET-10xMCTS-60R-M2G-XB",
            "color": "TEAM BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/WHITE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960290365"
          },
          {
            "id": "41021960323133",
            "gid": "gid://shopify/ProductVariant/41021960323133",
            "sku": "SET-10xMCTS-60R-M4R-XA",
            "color": "TEAM DARK ORANGE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK ORANGE/WHITE",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960323133"
          },
          {
            "id": "41021960355901",
            "gid": "gid://shopify/ProductVariant/41021960355901",
            "sku": "SET-10xMCTS-60R-M4P-XB",
            "color": "TEAM DARK RED/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/WHITE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960355901"
          },
          {
            "id": "41021960388669",
            "gid": "gid://shopify/ProductVariant/41021960388669",
            "sku": "SET-10xMCTS-60R-M4P-XC",
            "color": "TEAM DARK RED/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/YELLOW",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960388669"
          },
          {
            "id": "41021960421437",
            "gid": "gid://shopify/ProductVariant/41021960421437",
            "sku": "SET-10xMCTS-60R-M3K-XA",
            "color": "TEAM GREEN/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREEN/GOLD",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960421437"
          },
          {
            "id": "41021960454205",
            "gid": "gid://shopify/ProductVariant/41021960454205",
            "sku": "SET-10xMCTS-60R-M0V-XA",
            "color": "TEAM GREY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREY/RED",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960454205"
          },
          {
            "id": "41021960486973",
            "gid": "gid://shopify/ProductVariant/41021960486973",
            "sku": "SET-10xMCTS-60R-M2H-XA",
            "color": "TEAM LIGHT BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM LIGHT BLUE/WHITE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960486973"
          },
          {
            "id": "41021960519741",
            "gid": "gid://shopify/ProductVariant/41021960519741",
            "sku": "SET-10xMCTS-60R-M4Q-XA",
            "color": "TEAM MAROON/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM MAROON/GOLD",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960519741"
          },
          {
            "id": "41021960552509",
            "gid": "gid://shopify/ProductVariant/41021960552509",
            "sku": "SET-10xMCTS-60R-M2F-XC",
            "color": "TEAM NAVY/ORANGE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/ORANGE",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960552509"
          },
          {
            "id": "41021960585277",
            "gid": "gid://shopify/ProductVariant/41021960585277",
            "sku": "SET-10xMCTS-60R-M2F-XD",
            "color": "TEAM NAVY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/RED",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960585277"
          },
          {
            "id": "41021960618045",
            "gid": "gid://shopify/ProductVariant/41021960618045",
            "sku": "SET-10xMCTS-60R-M2F-XB",
            "color": "TEAM NAVY/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/YELLOW",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip-grip-bundle-set?variant=41021960618045"
          }
        ],
        "shopify_variant_count": 13,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "TEAM BLUE/WHITE"
        ],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-mcc-teams-new-decade-midsize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/WHITE",
              "TEAM DARK ORANGE/WHITE",
              "TEAM LIGHT BLUE/WHITE",
              "TEAM NAVY/RED",
              "TEAM BLACK/GOLD"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021957963837",
            "gid": "gid://shopify/ProductVariant/41021957963837",
            "sku": "SET-10xMCTM-60R-M2G-XB",
            "color": "TEAM BLUE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM BLUE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-grip-bundle-set?variant=41021957963837"
          },
          {
            "id": "41021957996605",
            "gid": "gid://shopify/ProductVariant/41021957996605",
            "sku": "SET-10xMCTM-60R-M4R-XA",
            "color": "TEAM DARK ORANGE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM DARK ORANGE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-grip-bundle-set?variant=41021957996605"
          },
          {
            "id": "41021958029373",
            "gid": "gid://shopify/ProductVariant/41021958029373",
            "sku": "SET-10xMCTM-60R-M2H-XA",
            "color": "TEAM LIGHT BLUE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM LIGHT BLUE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-grip-bundle-set?variant=41021958029373"
          },
          {
            "id": "41021958062141",
            "gid": "gid://shopify/ProductVariant/41021958062141",
            "sku": "SET-10xMCTM-60R-M2F-XD",
            "color": "TEAM NAVY/RED",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM NAVY/RED",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-grip-bundle-set?variant=41021958062141"
          },
          {
            "id": "41021958094909",
            "gid": "gid://shopify/ProductVariant/41021958094909",
            "sku": "SET-10xMCTM-60R-M1L-XA",
            "color": "TEAM BLACK/GOLD",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM BLACK/GOLD",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-grip-bundle-set?variant=41021958094909"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-team-blue-white-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-midsize-grip-team-blue-white-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827462205",
            "gid": "gid://shopify/ProductVariant/39915827462205",
            "sku": "KIT+13xMCTM-60R-M2G-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-team-blue-white-13pcs-golf-grip-kit?variant=39915827462205"
          },
          {
            "id": "39915827494973",
            "gid": "gid://shopify/ProductVariant/39915827494973",
            "sku": "KIT(8oz)+13xMCTM-60R-M2G-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-team-blue-white-13pcs-golf-grip-kit?variant=39915827494973"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-dark-orange-white-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-midsize-grip-dark-orange-white-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827527741",
            "gid": "gid://shopify/ProductVariant/39915827527741",
            "sku": "KIT+13xMCTM-60R-M4R-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-dark-orange-white-13pcs-golf-grip-kit?variant=39915827527741"
          },
          {
            "id": "39915827560509",
            "gid": "gid://shopify/ProductVariant/39915827560509",
            "sku": "KIT(8oz)+13xMCTM-60R-M4R-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-dark-orange-white-13pcs-golf-grip-kit?variant=39915827560509"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-light-blue-white-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-midsize-grip-light-blue-white-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827593277",
            "gid": "gid://shopify/ProductVariant/39915827593277",
            "sku": "KIT+13xMCTM-60R-M2H-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-light-blue-white-13pcs-golf-grip-kit?variant=39915827593277"
          },
          {
            "id": "39915827626045",
            "gid": "gid://shopify/ProductVariant/39915827626045",
            "sku": "KIT(8oz)+13xMCTM-60R-M2H-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-light-blue-white-13pcs-golf-grip-kit?variant=39915827626045"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 182.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-navy-red-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-midsize-grip-navy-red-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827658813",
            "gid": "gid://shopify/ProductVariant/39915827658813",
            "sku": "KIT+13xMCTM-60R-M2F-XD",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 182.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-navy-red-13pcs-golf-grip-kit?variant=39915827658813"
          },
          {
            "id": "39915827691581",
            "gid": "gid://shopify/ProductVariant/39915827691581",
            "sku": "KIT(8oz)+13xMCTM-60R-M2F-XD",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 187.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip-navy-red-13pcs-golf-grip-kit?variant=39915827691581"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "TEAM BLUE/WHITE"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip",
        "handle": "golf-pride-mcc-teams-new-decade-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLUE/WHITE",
              "TEAM DARK ORANGE/WHITE",
              "TEAM LIGHT BLUE/WHITE",
              "TEAM NAVY/RED",
              "TEAM BLACK/GOLD",
              "TEAM GREY/RED",
              "TEAM NAVY/ORANGE",
              "TEAM GREEN/GOLD",
              "TEAM DARK RED/WHITE",
              "TEAM BLACK/GREY"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39668643659837",
            "gid": "gid://shopify/ProductVariant/39668643659837",
            "sku": "MCTM-60R-M2G-XB",
            "color": "TEAM BLUE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM BLUE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=39668643659837"
          },
          {
            "id": "39668643692605",
            "gid": "gid://shopify/ProductVariant/39668643692605",
            "sku": "MCTM-60R-M4R-XA",
            "color": "TEAM DARK ORANGE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM DARK ORANGE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=39668643692605"
          },
          {
            "id": "39668643725373",
            "gid": "gid://shopify/ProductVariant/39668643725373",
            "sku": "MCTM-60R-M2H-XA",
            "color": "TEAM LIGHT BLUE/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM LIGHT BLUE/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=39668643725373"
          },
          {
            "id": "39668643758141",
            "gid": "gid://shopify/ProductVariant/39668643758141",
            "sku": "MCTM-60R-M2F-XD",
            "color": "TEAM NAVY/RED",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM NAVY/RED",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=39668643758141"
          },
          {
            "id": "40820578680893",
            "gid": "gid://shopify/ProductVariant/40820578680893",
            "sku": "MCTM-60R-M1L-XA",
            "color": "TEAM BLACK/GOLD",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM BLACK/GOLD",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=40820578680893"
          },
          {
            "id": "41510905282621",
            "gid": "gid://shopify/ProductVariant/41510905282621",
            "sku": "MCTM-60R-M0V-XA",
            "color": "TEAM GREY/RED",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM GREY/RED",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=41510905282621"
          },
          {
            "id": "41510906757181",
            "gid": "gid://shopify/ProductVariant/41510906757181",
            "sku": "MCTM-60R-M2F-XC",
            "color": "TEAM NAVY/ORANGE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM NAVY/ORANGE",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=41510906757181"
          },
          {
            "id": "41510908035133",
            "gid": "gid://shopify/ProductVariant/41510908035133",
            "sku": "MCTM-60R-M3K-XA",
            "color": "TEAM GREEN/GOLD",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM GREEN/GOLD",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=41510908035133"
          },
          {
            "id": "41510908723261",
            "gid": "gid://shopify/ProductVariant/41510908723261",
            "sku": "MCTM-60R-M4P-XB",
            "color": "TEAM DARK RED/WHITE",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM DARK RED/WHITE",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=41510908723261"
          },
          {
            "id": "61544382497138",
            "gid": "gid://shopify/ProductVariant/61544382497138",
            "sku": "MCTM-60R-M1M-XA",
            "color": "TEAM BLACK/GREY",
            "size": "Midsize",
            "selected_options": {
              "Color": "TEAM BLACK/GREY",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-midsize-grip?variant=61544382497138"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-orange-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-team-blue-orange-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "31940012638269",
            "gid": "gid://shopify/ProductVariant/31940012638269",
            "sku": "KIT+13xMCTS-60R-M2G-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-orange-13pcs-golf-grip-kit?variant=31940012638269"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-black-gold-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-team-black-gold-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31940012441661",
            "gid": "gid://shopify/ProductVariant/31940012441661",
            "sku": "KIT+13xMCTS-60R-M1L-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-black-gold-13pcs-golf-grip-kit?variant=31940012441661"
          },
          {
            "id": "39982852177981",
            "gid": "gid://shopify/ProductVariant/39982852177981",
            "sku": "KIT(8oz)+13xMCTS-60R-M1L-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-black-gold-13pcs-golf-grip-kit?variant=39982852177981"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-white-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-team-blue-white-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31940012212285",
            "gid": "gid://shopify/ProductVariant/31940012212285",
            "sku": "KIT+13xMCTS-60R-M2G-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-white-13pcs-golf-grip-kit?variant=31940012212285"
          },
          {
            "id": "39982862270525",
            "gid": "gid://shopify/ProductVariant/39982862270525",
            "sku": "KIT(8oz)+13xMCTS-60R-M2G-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-team-blue-white-13pcs-golf-grip-kit?variant=39982862270525"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-orange-white-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-dark-orange-white-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31940012113981",
            "gid": "gid://shopify/ProductVariant/31940012113981",
            "sku": "KIT+13xMCTS-60R-M4R-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-orange-white-13pcs-golf-grip-kit?variant=31940012113981"
          },
          {
            "id": "39963535966269",
            "gid": "gid://shopify/ProductVariant/39963535966269",
            "sku": "KIT(8oz)+13xMCTS-60R-M4R-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-orange-white-13pcs-golf-grip-kit?variant=39963535966269"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-white-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-dark-red-white-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31940011950141",
            "gid": "gid://shopify/ProductVariant/31940011950141",
            "sku": "KIT+13xMCTS-60R-M4P-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-white-13pcs-golf-grip-kit?variant=31940011950141"
          },
          {
            "id": "39982866235453",
            "gid": "gid://shopify/ProductVariant/39982866235453",
            "sku": "KIT(8oz)+13xMCTS-60R-M4P-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-white-13pcs-golf-grip-kit?variant=39982866235453"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 167.32,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-yellow-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-dark-red-yellow-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827724349",
            "gid": "gid://shopify/ProductVariant/39915827724349",
            "sku": "KIT+13xMCTS-60R-M4P-XC",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 167.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-yellow-13pcs-golf-grip-kit?variant=39915827724349"
          },
          {
            "id": "39915827757117",
            "gid": "gid://shopify/ProductVariant/39915827757117",
            "sku": "KIT(8oz)+13xMCTS-60R-M4P-XC",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 170.29,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-dark-red-yellow-13pcs-golf-grip-kit?variant=39915827757117"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-green-gold-13pcs-golf-grip-kit-1",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-green-gold-13pcs-golf-grip-kit-1",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31940011589693",
            "gid": "gid://shopify/ProductVariant/31940011589693",
            "sku": "KIT+13xMCTS-60R-M3K-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-green-gold-13pcs-golf-grip-kit-1?variant=31940011589693"
          },
          {
            "id": "39982872625213",
            "gid": "gid://shopify/ProductVariant/39982872625213",
            "sku": "KIT(8oz)+13xMCTS-60R-M3K-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-green-gold-13pcs-golf-grip-kit-1?variant=39982872625213"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-grey-red-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-grey-red-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31940011524157",
            "gid": "gid://shopify/ProductVariant/31940011524157",
            "sku": "KIT+13xMCTS-60R-M0V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-grey-red-13pcs-golf-grip-kit?variant=31940011524157"
          },
          {
            "id": "39982881472573",
            "gid": "gid://shopify/ProductVariant/39982881472573",
            "sku": "KIT(8oz)+13xMCTS-60R-M0V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-grey-red-13pcs-golf-grip-kit?variant=39982881472573"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-light-blue-white-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-light-blue-white-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31940011458621",
            "gid": "gid://shopify/ProductVariant/31940011458621",
            "sku": "KIT+13xMCTS-60R-M2H-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-light-blue-white-13pcs-golf-grip-kit?variant=31940011458621"
          },
          {
            "id": "39982883668029",
            "gid": "gid://shopify/ProductVariant/39982883668029",
            "sku": "KIT(8oz)+13xMCTS-60R-M2H-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-light-blue-white-13pcs-golf-grip-kit?variant=39982883668029"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 167.32,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-maroon-gold-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-maroon-gold-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827789885",
            "gid": "gid://shopify/ProductVariant/39915827789885",
            "sku": "KIT+13xMCTS-60R-M4Q-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 167.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-maroon-gold-13pcs-golf-grip-kit?variant=39915827789885"
          },
          {
            "id": "39915827822653",
            "gid": "gid://shopify/ProductVariant/39915827822653",
            "sku": "KIT(8oz)+13xMCTS-60R-M4Q-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 170.29,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-maroon-gold-13pcs-golf-grip-kit?variant=39915827822653"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-orange-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-navy-orange-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827855421",
            "gid": "gid://shopify/ProductVariant/39915827855421",
            "sku": "KIT+13xMCTS-60R-M2F-XC",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-orange-13pcs-golf-grip-kit?variant=39915827855421"
          },
          {
            "id": "39915827888189",
            "gid": "gid://shopify/ProductVariant/39915827888189",
            "sku": "KIT(8oz)+13xMCTS-60R-M2F-XC",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-orange-13pcs-golf-grip-kit?variant=39915827888189"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-red-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-navy-red-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827920957",
            "gid": "gid://shopify/ProductVariant/39915827920957",
            "sku": "KIT+13xMCTS-60R-M2F-XD",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-red-13pcs-golf-grip-kit?variant=39915827920957"
          },
          {
            "id": "39915827953725",
            "gid": "gid://shopify/ProductVariant/39915827953725",
            "sku": "KIT(8oz)+13xMCTS-60R-M2F-XD",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-red-13pcs-golf-grip-kit?variant=39915827953725"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 169.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-yellow-13pcs-golf-grip-kit",
        "handle": "golf-pride-mcc-teams-new-decade-standard-grip-navy-yellow-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915827986493",
            "gid": "gid://shopify/ProductVariant/39915827986493",
            "sku": "KIT+13xMCTS-60R-M2F-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-yellow-13pcs-golf-grip-kit?variant=39915827986493"
          },
          {
            "id": "39915828019261",
            "gid": "gid://shopify/ProductVariant/39915828019261",
            "sku": "KIT(8oz)+13xMCTS-60R-M2F-XB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-teams-new-decade-standard-grip-navy-yellow-13pcs-golf-grip-kit?variant=39915828019261"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "TEAM BLACK/GOLD"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip",
        "handle": "golf-pride-mcc-team-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "TEAM BLACK/GOLD",
              "TEAM BLUE/WHITE",
              "TEAM DARK ORANGE/WHITE",
              "TEAM DARK RED/WHITE",
              "TEAM DARK RED/YELLOW",
              "TEAM GREEN/GOLD",
              "TEAM GREY/RED",
              "TEAM LIGHT BLUE/WHITE",
              "TEAM MAROON/GOLD",
              "TEAM NAVY/ORANGE",
              "TEAM NAVY/RED",
              "TEAM BLACK/GREY"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31878165725245",
            "gid": "gid://shopify/ProductVariant/31878165725245",
            "sku": "MCTS-60R-M1L-XA",
            "color": "TEAM BLACK/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLACK/GOLD"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878165725245"
          },
          {
            "id": "31878165790781",
            "gid": "gid://shopify/ProductVariant/31878165790781",
            "sku": "MCTS-60R-M2G-XB",
            "color": "TEAM BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLUE/WHITE"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878165790781"
          },
          {
            "id": "31878165823549",
            "gid": "gid://shopify/ProductVariant/31878165823549",
            "sku": "MCTS-60R-M4R-XA",
            "color": "TEAM DARK ORANGE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK ORANGE/WHITE"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878165823549"
          },
          {
            "id": "31878165856317",
            "gid": "gid://shopify/ProductVariant/31878165856317",
            "sku": "MCTS-60R-M4P-XB",
            "color": "TEAM DARK RED/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/WHITE"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878165856317"
          },
          {
            "id": "31878165889085",
            "gid": "gid://shopify/ProductVariant/31878165889085",
            "sku": "MCTS-60R-M4P-XC",
            "color": "TEAM DARK RED/YELLOW",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM DARK RED/YELLOW"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878165889085"
          },
          {
            "id": "31878165921853",
            "gid": "gid://shopify/ProductVariant/31878165921853",
            "sku": "MCTS-60R-M3K-XA",
            "color": "TEAM GREEN/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREEN/GOLD"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878165921853"
          },
          {
            "id": "31878165954621",
            "gid": "gid://shopify/ProductVariant/31878165954621",
            "sku": "MCTS-60R-M0V-XA",
            "color": "TEAM GREY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM GREY/RED"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878165954621"
          },
          {
            "id": "31878165987389",
            "gid": "gid://shopify/ProductVariant/31878165987389",
            "sku": "MCTS-60R-M2H-XA",
            "color": "TEAM LIGHT BLUE/WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM LIGHT BLUE/WHITE"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878165987389"
          },
          {
            "id": "31878166020157",
            "gid": "gid://shopify/ProductVariant/31878166020157",
            "sku": "MCTS-60R-M4Q-XA",
            "color": "TEAM MAROON/GOLD",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM MAROON/GOLD"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878166020157"
          },
          {
            "id": "31878166085693",
            "gid": "gid://shopify/ProductVariant/31878166085693",
            "sku": "MCTS-60R-M2F-XC",
            "color": "TEAM NAVY/ORANGE",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/ORANGE"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878166085693"
          },
          {
            "id": "31878166118461",
            "gid": "gid://shopify/ProductVariant/31878166118461",
            "sku": "MCTS-60R-M2F-XD",
            "color": "TEAM NAVY/RED",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM NAVY/RED"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=31878166118461"
          },
          {
            "id": "61544402387314",
            "gid": "gid://shopify/ProductVariant/61544402387314",
            "sku": "MCTS-60R-M1M-XA",
            "color": "TEAM BLACK/GREY",
            "size": "Standard",
            "selected_options": {
              "Color": "TEAM BLACK/GREY"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mcc-team-standard-grip?variant=61544402387314"
          }
        ],
        "shopify_variant_count": 12,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, bct cord, Brand_Golf Pride, cord, firm, golf pride bundle, golf pride single grip, Golf Pride Team, Golf Pride Teams, golf-grips, golf-pride, golf-pride-model_mcc-classic-standard-taper, grip bundle, grip kit, hybrid, hybrid-golf-grips, iron/wood, mcc, mcc m",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "Teams = New Decade MCC dual-color",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "TEAM BLUE/WHITE",
      "TEAM LIGHT BLUE/WHITE",
      "TEAM BLACK/GOLD",
      "TEAM GREEN/GOLD",
      "TEAM DARK RED/WHITE",
      "TEAM DARK RED/YELLOW",
      "TEAM NAVY/ORANGE",
      "TEAM BLACK/GREY"
    ]
  },
  {
    "id": "golf-pride-multicompound-platinum",
    "brand": "Golf Pride",
    "model": "Multicompound Platinum",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "WHITE",
      "White"
    ],
    "weight_g_by_size": {
      "Standard": 71.9,
      "Midsize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 149.85,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": null,
    "kit_price_min": 149.85,
    "url": "https://www.grips4less.com/products/golf-pride-multicompound-platinum-midsize",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gripkit-13mccplatite.jpg?v=1751587630",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "WHITE"
        ],
        "price": 149.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-multicompound-platinum-standard-grips",
        "handle": "grip-kit-13x-golf-pride-multicompound-platinum-standard-grips",
        "shopify_variants": [
          {
            "id": "915404805",
            "gid": "gid://shopify/ProductVariant/915404805",
            "sku": "KIT+13xMCC -60R-MG0-24",
            "color": "WHITE",
            "size": "Standard",
            "selected_options": {
              "Color": "WHITE"
            },
            "available": true,
            "price": 149.85,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-multicompound-platinum-standard-grips?variant=915404805"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "WHITE"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "White"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-multicompound-platinum-midsize",
        "handle": "golf-pride-multicompound-platinum-midsize",
        "shopify_variants": [
          {
            "id": "794977593",
            "gid": "gid://shopify/ProductVariant/794977593",
            "sku": "MSC-60R-MG0-24",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-multicompound-platinum-midsize?variant=794977593"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf pride bundle, Golf Pride Grip Kits, golf-pride, gp-gift-2025, grip kit, grip kits, grip set, grip sets, hybrid",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "WHITE",
      "White"
    ]
  },
  {
    "id": "golf-pride-multicompound-whiteout",
    "brand": "Golf Pride",
    "model": "Multicompound Whiteout",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 7.84,
    "price_max": 7.84,
    "single_price_min": 7.84,
    "single_price_max": 7.84,
    "normalized_price_per_grip": 7.84,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-multicompound-whiteout-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/mcc-whiteout-red-diag.jpg?v=1636051729",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 7.84,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/golf-pride-multicompound-whiteout-black",
        "handle": "golf-pride-multicompound-whiteout-black",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red",
              "Blue",
              "Black"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461786943549",
            "gid": "gid://shopify/ProductVariant/39461786943549",
            "sku": "WMCS-60R-MW4-00",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 7.84,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-multicompound-whiteout-black?variant=39461786943549"
          },
          {
            "id": "39461786976317",
            "gid": "gid://shopify/ProductVariant/39461786976317",
            "sku": "WMCS-60R-MW2-00",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 7.84,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-multicompound-whiteout-black?variant=39461786976317"
          },
          {
            "id": "39461787009085",
            "gid": "gid://shopify/ProductVariant/39461787009085",
            "sku": "WMCS-60R-MW1-00",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 7.84,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-multicompound-whiteout-black?variant=39461787009085"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, bct cord, Brand_Golf Pride, cord, firm, golf pride single grip, golf-pride, hybrid, hybrid-golf-grips, iron/wood, new decade, new decade whiteout, rubber, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150, video=Hks",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red",
      "Blue",
      "Black"
    ]
  },
  {
    "id": "golf-pride-new-decade",
    "brand": "Golf Pride",
    "model": "New Decade",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-black-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gripkit-13mccblk_grande_985a4062-00ad-4653-9f0f-75ab0c2e3659.jpg?v=1751587570",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-black-13pcs-golf-grip-kit",
        "handle": "golf-pride-new-decade-midsize-black-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829690429",
            "gid": "gid://shopify/ProductVariant/39915829690429",
            "sku": "KIT+13xMSC -60R-M10-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-black-13pcs-golf-grip-kit?variant=39915829690429"
          },
          {
            "id": "39915829723197",
            "gid": "gid://shopify/ProductVariant/39915829723197",
            "sku": "KIT(8oz)+13xMSC -60R-M10-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-black-13pcs-golf-grip-kit?variant=39915829723197"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-blue-13pcs-golf-grip-kit",
        "handle": "golf-pride-new-decade-midsize-blue-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829755965",
            "gid": "gid://shopify/ProductVariant/39915829755965",
            "sku": "KIT+13xMSC -60R-M22-10",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-blue-13pcs-golf-grip-kit?variant=39915829755965"
          },
          {
            "id": "39915829788733",
            "gid": "gid://shopify/ProductVariant/39915829788733",
            "sku": "KIT(8oz)+13xMSC -60R-M22-10",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-blue-13pcs-golf-grip-kit?variant=39915829788733"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-red-13pcs-golf-grip-kit",
        "handle": "golf-pride-new-decade-midsize-red-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829821501",
            "gid": "gid://shopify/ProductVariant/39915829821501",
            "sku": "KIT+13xMSC -60R-12 -X4",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-red-13pcs-golf-grip-kit?variant=39915829821501"
          },
          {
            "id": "39915829854269",
            "gid": "gid://shopify/ProductVariant/39915829854269",
            "sku": "KIT(8oz)+13xMSC -60R-12 -X4",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-midsize-red-13pcs-golf-grip-kit?variant=39915829854269"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-midsize-grips-white",
        "handle": "grip-kit-13x-golf-pride-new-decade-midsize-grips-white",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831132221",
            "gid": "gid://shopify/ProductVariant/39915831132221",
            "sku": "KIT+13xMSC -60R-M07-X9",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-midsize-grips-white?variant=39915831132221"
          },
          {
            "id": "39915831164989",
            "gid": "gid://shopify/ProductVariant/39915831164989",
            "sku": "KIT(8oz)+13xMSC -60R-M07-X9",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-midsize-grips-white?variant=39915831164989"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-grips-white",
        "handle": "grip-kit-13x-golf-pride-new-decade-standard-grips-white",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831197757",
            "gid": "gid://shopify/ProductVariant/39915831197757",
            "sku": "KIT+13xMCC -60R-M07-X9",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-grips-white?variant=39915831197757"
          },
          {
            "id": "39915831230525",
            "gid": "gid://shopify/ProductVariant/39915831230525",
            "sku": "KIT(8oz)+13xMCC -60R-M07-X9",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-grips-white?variant=39915831230525"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-grip-kit",
        "handle": "golf-pride-new-decade-multicompound-grip-kit",
        "shopify_options": [],
        "shopify_variants": [
          {
            "id": "39915832180797",
            "gid": "gid://shopify/ProductVariant/39915832180797",
            "sku": "KIT+13xMCC -60R-12 -X4",
            "color": "",
            "size": "Standard",
            "selected_options": {},
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-grip-kit?variant=39915832180797"
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf pride bundle, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-new-decade-black",
    "brand": "Golf Pride",
    "model": "New Decade Black",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-black-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2020-gp-kits-mcc-black.jpg?v=1751587631",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-black-grips",
        "handle": "grip-kit-13x-golf-pride-new-decade-standard-black-grips",
        "shopify_options": [],
        "shopify_variants": [
          {
            "id": "39915832115261",
            "gid": "gid://shopify/ProductVariant/39915832115261",
            "sku": "KIT+13xMCC -60R-M10-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {},
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-black-grips?variant=39915832115261"
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf pride bundle, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-new-decade-blue",
    "brand": "Golf Pride",
    "model": "New Decade Blue",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-blue-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2020-gp-kits-mcc-blue.jpg?v=1751587623",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-blue-grips",
        "handle": "grip-kit-13x-golf-pride-new-decade-standard-blue-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831722045",
            "gid": "gid://shopify/ProductVariant/39915831722045",
            "sku": "KIT+13xMCC -60R-M22-10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-blue-grips?variant=39915831722045"
          },
          {
            "id": "39915831754813",
            "gid": "gid://shopify/ProductVariant/39915831754813",
            "sku": "KIT(8oz)+13xMCC -60R-M22-10",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-new-decade-standard-blue-grips?variant=39915831754813"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bct cord, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf pride bundle, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-new-decade-multicompound",
    "brand": "Golf Pride",
    "model": "New Decade Multicompound",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Red - Standard 60 Round",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "Black",
      "Red",
      "Standard / Black / Yellow",
      "White"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 8.15,
    "price_max": 169.35,
    "single_price_min": 8.15,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 8.15,
    "bundle_price_min": 103.92,
    "kit_price_min": 169.35,
    "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-red-choose-58-or-60",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/mcc-new-decade-2023-4colors-MID.jpg?v=1761759943",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 10,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound-midsize",
        "handle": "8pc-bundle-golf-pride-new-decade-multicompound-midsize",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638712918386",
            "gid": "gid://shopify/ProductVariant/61638712918386",
            "sku": "SET-8xMSC -60R-M10-XA",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound-midsize?variant=61638712918386"
          },
          {
            "id": "61638712951154",
            "gid": "gid://shopify/ProductVariant/61638712951154",
            "sku": "SET-8xMSC -60R-M22-10",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound-midsize?variant=61638712951154"
          },
          {
            "id": "61638712983922",
            "gid": "gid://shopify/ProductVariant/61638712983922",
            "sku": "SET-8xMSC -60R-12 -X4",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound-midsize?variant=61638712983922"
          },
          {
            "id": "61638713016690",
            "gid": "gid://shopify/ProductVariant/61638713016690",
            "sku": "SET-8xMSC -60R-M07-X9",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound-midsize?variant=61638713016690"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "White"
        ],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound",
        "handle": "8pc-bundle-golf-pride-new-decade-multicompound",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White",
              "Red",
              "Black",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638701941106",
            "gid": "gid://shopify/ProductVariant/61638701941106",
            "sku": "SET-8xMCC -60R-M07-X9",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound?variant=61638701941106"
          },
          {
            "id": "61638701973874",
            "gid": "gid://shopify/ProductVariant/61638701973874",
            "sku": "SET-8xMCC -60R-12 -X4",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound?variant=61638701973874"
          },
          {
            "id": "61638702006642",
            "gid": "gid://shopify/ProductVariant/61638702006642",
            "sku": "SET-8xMCC -60R-M10-XA",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound?variant=61638702006642"
          },
          {
            "id": "61638702039410",
            "gid": "gid://shopify/ProductVariant/61638702039410",
            "sku": "SET-8xMCC -60R-M22-10",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-new-decade-multicompound?variant=61638702039410"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "White"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound",
        "handle": "13pc-bundle-golf-pride-new-decade-multicompound",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White",
              "Red",
              "Black",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791468622194",
            "gid": "gid://shopify/ProductVariant/60791468622194",
            "sku": "SET-13xMCC -60R-M07-X9",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound?variant=60791468622194"
          },
          {
            "id": "60791468654962",
            "gid": "gid://shopify/ProductVariant/60791468654962",
            "sku": "SET-13xMCC -60R-12 -X4",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound?variant=60791468654962"
          },
          {
            "id": "60791468687730",
            "gid": "gid://shopify/ProductVariant/60791468687730",
            "sku": "SET-13xMCC -60R-M10-XA",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound?variant=60791468687730"
          },
          {
            "id": "60791468720498",
            "gid": "gid://shopify/ProductVariant/60791468720498",
            "sku": "SET-13xMCC -60R-M22-10",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound?variant=60791468720498"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound-midsize",
        "handle": "13pc-bundle-golf-pride-new-decade-multicompound-midsize",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791466361202",
            "gid": "gid://shopify/ProductVariant/60791466361202",
            "sku": "SET-13xMSC -60R-M10-XA",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound-midsize?variant=60791466361202"
          },
          {
            "id": "60791466393970",
            "gid": "gid://shopify/ProductVariant/60791466393970",
            "sku": "SET-13xMSC -60R-M22-10",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound-midsize?variant=60791466393970"
          },
          {
            "id": "60791466426738",
            "gid": "gid://shopify/ProductVariant/60791466426738",
            "sku": "SET-13xMSC -60R-12 -X4",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound-midsize?variant=60791466426738"
          },
          {
            "id": "60791466459506",
            "gid": "gid://shopify/ProductVariant/60791466459506",
            "sku": "SET-13xMSC -60R-M07-X9",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-new-decade-multicompound-midsize?variant=60791466459506"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "White"
        ],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-grip-bundle-set",
        "handle": "golf-pride-new-decade-multicompound-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White",
              "Red",
              "Black",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021978116157",
            "gid": "gid://shopify/ProductVariant/41021978116157",
            "sku": "SET-10xMCC -60R-M07-X9",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-grip-bundle-set?variant=41021978116157"
          },
          {
            "id": "41021978148925",
            "gid": "gid://shopify/ProductVariant/41021978148925",
            "sku": "SET-10xMCC -60R-12 -X4",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-grip-bundle-set?variant=41021978148925"
          },
          {
            "id": "41021978181693",
            "gid": "gid://shopify/ProductVariant/41021978181693",
            "sku": "SET-10xMCC -60R-M10-XA",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-grip-bundle-set?variant=41021978181693"
          },
          {
            "id": "41021978214461",
            "gid": "gid://shopify/ProductVariant/41021978214461",
            "sku": "SET-10xMCC -60R-M22-10",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-grip-bundle-set?variant=41021978214461"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize-grip-bundle-set",
        "handle": "golf-pride-new-decade-multicompound-midsize-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021972578365",
            "gid": "gid://shopify/ProductVariant/41021972578365",
            "sku": "SET-10xMSC -60R-M10-XA",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize-grip-bundle-set?variant=41021972578365"
          },
          {
            "id": "41021972611133",
            "gid": "gid://shopify/ProductVariant/41021972611133",
            "sku": "SET-10xMSC -60R-M22-10",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize-grip-bundle-set?variant=41021972611133"
          },
          {
            "id": "41021972643901",
            "gid": "gid://shopify/ProductVariant/41021972643901",
            "sku": "SET-10xMSC -60R-12 -X4",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize-grip-bundle-set?variant=41021972643901"
          },
          {
            "id": "41021972676669",
            "gid": "gid://shopify/ProductVariant/41021972676669",
            "sku": "SET-10xMSC -60R-M07-X9",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize-grip-bundle-set?variant=41021972676669"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 8.15,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-red-choose-58-or-60",
        "handle": "golf-pride-new-decade-multicompound-red-choose-58-or-60",
        "shopify_variants": [
          {
            "id": "39461786878013",
            "gid": "gid://shopify/ProductVariant/39461786878013",
            "sku": "WEB ONLY: MCC-60R-12-X4 (RED)",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Size": "Red - Standard 60 Round"
            },
            "available": true,
            "price": 8.15,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-red-choose-58-or-60?variant=39461786878013"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Red - Standard 60 Round"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Black / Yellow"
        ],
        "price": 169.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-13pcs-golf-grip-kit",
        "handle": "golf-pride-new-decade-multicompound-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "39915828052029",
            "gid": "gid://shopify/ProductVariant/39915828052029",
            "sku": "KIT+13xMCC-60R-M71-X9",
            "color": "Black / Yellow",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black / Yellow",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 169.35,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-13pcs-golf-grip-kit?variant=39915828052029"
          },
          {
            "id": "39915828084797",
            "gid": "gid://shopify/ProductVariant/39915828084797",
            "sku": "KIT(8oz)+13xMCC-60R-M71-X9",
            "color": "Black / Yellow",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black / Yellow",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 174.55,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-13pcs-golf-grip-kit?variant=39915828084797"
          }
        ],
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Standard / Black / Yellow"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize",
        "handle": "golf-pride-new-decade-multicompound-midsize",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "277996226",
            "gid": "gid://shopify/ProductVariant/277996226",
            "sku": "MSC -60R-M10-XA",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize?variant=277996226"
          },
          {
            "id": "309242571",
            "gid": "gid://shopify/ProductVariant/309242571",
            "sku": "MSC -60R-M22-10",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize?variant=309242571"
          },
          {
            "id": "309242705",
            "gid": "gid://shopify/ProductVariant/309242705",
            "sku": "MSC -60R-12 -X4",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize?variant=309242705"
          },
          {
            "id": "309242759",
            "gid": "gid://shopify/ProductVariant/309242759",
            "sku": "MSC -60R-M07-X9",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-midsize?variant=309242759"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "White"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound",
        "handle": "golf-pride-new-decade-multicompound",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White",
              "Red",
              "Black",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "308872295",
            "gid": "gid://shopify/ProductVariant/308872295",
            "sku": "MCC -60R-M07-X9",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound?variant=308872295"
          },
          {
            "id": "116723522",
            "gid": "gid://shopify/ProductVariant/116723522",
            "sku": "MCC -60R-12 -X4",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound?variant=116723522"
          },
          {
            "id": "308870685",
            "gid": "gid://shopify/ProductVariant/308870685",
            "sku": "MCC -60R-M10-XA",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound?variant=308870685"
          },
          {
            "id": "308871121",
            "gid": "gid://shopify/ProductVariant/308871121",
            "sku": "MCC -60R-M22-10",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound?variant=308871121"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, all-weather, bct cord, firm, golf pride bundle, Golf Pride New Decade, golf pride single grip, golf-grips, golf-pride, golf-pride-model_mcc-classic-standard-taper, grip bundle, grip kit, hybrid, hybrid-golf-grips, iron/wood, mcc multicompound, mcc-classic-st",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "Original MCC / New Decade MultiCompound",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Blue",
      "Red",
      "White"
    ]
  },
  {
    "id": "golf-pride-new-decade-multicompound-platinum",
    "brand": "Golf Pride",
    "model": "New Decade Multicompound Platinum",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White"
    ],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 9.99,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-platinum",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/mcc-platinum.jpg?v=1636052664",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White"
        ],
        "price": 9.99,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-platinum",
        "handle": "golf-pride-new-decade-multicompound-platinum",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White",
              "Scarlet"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "20986866631",
            "gid": "gid://shopify/ProductVariant/20986866631",
            "sku": "MCC -60R-MG0-24",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-platinum?variant=20986866631"
          },
          {
            "id": "20986866887",
            "gid": "gid://shopify/ProductVariant/20986866887",
            "sku": "MCC -60R-MG4-00",
            "color": "Scarlet",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Scarlet"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-platinum?variant=20986866887"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, bct cord, Brand_Golf Pride, cord, firm, golf pride single grip, golf-pride, hybrid, hybrid-golf-grips, iron/wood, mcc multicompound, Model_Golf Pride MCC (New Decade), new decade, New for 2014, rubber, single-golf-grips, single-grip, Size_Standard, standard, standard-size-gol",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "Original MCC / New Decade MultiCompound",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "White",
      "Scarlet"
    ]
  },
  {
    "id": "golf-pride-new-decade-multicompound-sky-blue",
    "brand": "Golf Pride",
    "model": "New Decade Multicompound Sky Blue",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.98,
    "price_max": 6.98,
    "single_price_min": 6.98,
    "single_price_max": 6.98,
    "normalized_price_per_grip": 6.98,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-skyblue",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Golf_Pride_New_Decade_Multicompound_Sky_Blue_dfcab18e-ca6d-4c59-8223-cecca919231e.jpg?v=1735455956",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 6.98,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-skyblue",
        "handle": "golf-pride-new-decade-multicompound-skyblue",
        "shopify_variants": [
          {
            "id": "39461786845245",
            "gid": "gid://shopify/ProductVariant/39461786845245",
            "sku": "MCC-60R-M27-10",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Sky Blue"
            },
            "available": true,
            "price": 6.98,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-new-decade-multicompound-skyblue?variant=39461786845245"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Sky Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2023-sale, 49 under, All products, bf-nonassembled, Brand_Golf Pride, cord, firm, golf pride single grip, golf-pride, hybrid, hybrid-golf-grips, iron/wood, mem25, new decade, prime-2025, rubber, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, unde",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "Original MCC / New Decade MultiCompound",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-25-lightweight",
    "brand": "Golf Pride",
    "model": "Tour 25 (Lightweight)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (lightweight)",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Standard / Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 162.85,
    "price_max": 162.85,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 12.53,
    "bundle_price_min": null,
    "kit_price_min": 162.85,
    "url": "https://www.grips4less.com/products/golf-pride-tour-25-std-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2020-gp-kits-tour-25.jpg?v=1751587514",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Black"
        ],
        "price": 162.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-25-std-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-25-std-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Standard / Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828379709",
            "gid": "gid://shopify/ProductVariant/39915828379709",
            "sku": "KIT+13xLTTS-60R-A08-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 162.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-25-std-13pcs-golf-grip-kit?variant=39915828379709"
          },
          {
            "id": "39915828412477",
            "gid": "gid://shopify/ProductVariant/39915828412477",
            "sku": "KIT(8oz)+13xLTTS-60R-A08-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 168.05,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-25-std-13pcs-golf-grip-kit?variant=39915828412477"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "150-200, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, Golf Pride Grip Kits, Golf Pride Tour25, golf-pride, gp-gift-2025, grip kit, grip kits, g",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-25-grip-lightweight",
    "brand": "Golf Pride",
    "model": "Tour 25 Grip (Lightweight)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (lightweight)",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 11.49,
    "price_max": 11.49,
    "single_price_min": 11.49,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 11.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-25-std",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gp-tour25.jpg?v=1627086485",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 11.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-25-std",
        "handle": "golf-pride-tour-25-std",
        "shopify_variants": [
          {
            "id": "193475222",
            "gid": "gid://shopify/ProductVariant/193475222",
            "sku": "LTTS-60R-A08-X00",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-25-std?variant=193475222"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "49 under, All Products, golf pride single grip, Golf Pride Tour25, golf-grips, golf-pride, iron/wood, light weight, light-weight-grips, medium firm, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, tour 25, tour velvet, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-tac",
    "brand": "Golf Pride",
    "model": "Tour Tac",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.99,
    "price_max": 153.37,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 10.99,
    "bundle_price_min": 87.92,
    "kit_price_min": 153.37,
    "url": "https://www.grips4less.com/products/golf-pride-tour-tac-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/golf-pride-tour-tac-grip_f773ca54-aa37-483a-8b53-6aa02ccea45a.jpg?v=1761759692",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 10,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-tac-midsize-grip",
        "handle": "8pc-bundle-golf-pride-tour-tac-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638735626610",
            "gid": "gid://shopify/ProductVariant/61638735626610",
            "sku": "SET-8xTOSM-60R-21V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-tac-midsize-grip?variant=61638735626610"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-tac-standard-grip",
        "handle": "8pc-bundle-golf-pride-tour-tac-standard-grip",
        "shopify_variants": [
          {
            "id": "61638735528306",
            "gid": "gid://shopify/ProductVariant/61638735528306",
            "sku": "SET-8xTOUS-60R-21V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-tac-standard-grip?variant=61638735528306"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-tac-standard-grip",
        "handle": "13pc-bundle-golf-pride-tour-tac-standard-grip",
        "shopify_variants": [
          {
            "id": "60791451713906",
            "gid": "gid://shopify/ProductVariant/60791451713906",
            "sku": "SET-13xTOUS-60R-21V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-tac-standard-grip?variant=60791451713906"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-tac-midsize-grip",
        "handle": "13pc-bundle-golf-pride-tour-tac-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791451517298",
            "gid": "gid://shopify/ProductVariant/60791451517298",
            "sku": "SET-13xTOSM-60R-21V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-tac-midsize-grip?variant=60791451517298"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 81.6,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-tac-grip-bundle-set",
        "handle": "golf-pride-midsize-tour-tac-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "52290834432370",
            "gid": "gid://shopify/ProductVariant/52290834432370",
            "sku": "SET-10xTOSM-60R-21V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-tac-grip-bundle-set?variant=52290834432370"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-tac-midsize-grips",
        "handle": "grip-kit-13x-golf-pride-tour-tac-midsize-grips",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52290834366834",
            "gid": "gid://shopify/ProductVariant/52290834366834",
            "sku": "KIT+13xTOSM-60R-21V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-tac-midsize-grips?variant=52290834366834"
          },
          {
            "id": "52290834399602",
            "gid": "gid://shopify/ProductVariant/52290834399602",
            "sku": "KIT(8oz)+13xTOSM-60R-21V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-tac-midsize-grips?variant=52290834399602"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-tac-grip-bundle-set",
        "handle": "golf-pride-mens-tour-tac-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "52290834334066",
            "gid": "gid://shopify/ProductVariant/52290834334066",
            "sku": "SET-10xTOUS-60R-21V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-tac-grip-bundle-set?variant=52290834334066"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-tac-standard-grips",
        "handle": "grip-kit-13x-golf-pride-tour-tac-standard-grips",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52290834268530",
            "gid": "gid://shopify/ProductVariant/52290834268530",
            "sku": "KIT+13xTOUS-60R-21V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-tac-standard-grips?variant=52290834268530"
          },
          {
            "id": "52290834301298",
            "gid": "gid://shopify/ProductVariant/52290834301298",
            "sku": "KIT(8oz)+13xTOUS-60R-21V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-tac-standard-grips?variant=52290834301298"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-tac-midsize-grip",
        "handle": "golf-pride-tour-tac-midsize-grip",
        "shopify_variants": [
          {
            "id": "52008679702898",
            "gid": "gid://shopify/ProductVariant/52008679702898",
            "sku": "TOSM-60R-21V-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-tac-midsize-grip?variant=52008679702898"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-tac-standard-grip",
        "handle": "golf-pride-tour-tac-standard-grip",
        "shopify_variants": [
          {
            "id": "52008284225906",
            "gid": "gid://shopify/ProductVariant/52008284225906",
            "sku": "TOUS-60R-21V-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-tac-standard-grip?variant=52008284225906"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, golf pride bundle, golf pride single grip, golf pride tour tac, Golf Pride Tour Velvet, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, medium firm, midsize, midsize-golf-grips, midsize-size-golf-grips, non-cord, rubber, single-golf-grips, Size_Mid",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-velvet",
    "brand": "Golf Pride",
    "model": "Tour Velvet",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber blend",
    "texture": "textured (+ pattern)",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/tour-velvet-collection/tour-velvet.html"
    ],
    "sizes_available": [
      "Junior",
      "Jumbo/Oversize",
      "Midsize",
      "Undersize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Junior",
      "Midsize",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "8pc bundle",
      "13pc bundle",
      "10pc bundle",
      "13pc kit",
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 6.99,
    "price_max": 97.55,
    "single_price_min": 6.99,
    "single_price_max": 6.99,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": 55.92,
    "kit_price_min": 97.55,
    "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/golf-pride-tour-velvet_1b830bb7-9232-435b-9566-83a7240e3c05.jpg?v=1761759959",
    "fit_tags": [],
    "product_count": 35,
    "variants": [
      {
        "size": [
          "Junior"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-junior-tour-velvet",
        "handle": "8pc-bundle-golf-pride-junior-tour-velvet",
        "shopify_variants": [
          {
            "id": "61638708396402",
            "gid": "gid://shopify/ProductVariant/61638708396402",
            "sku": "SET-8xTVJ -50X-11 -X00",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-junior-tour-velvet?variant=61638708396402"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-jumbo-tour-velvet",
        "handle": "8pc-bundle-golf-pride-jumbo-tour-velvet",
        "shopify_variants": [
          {
            "id": "61638704169330",
            "gid": "gid://shopify/ProductVariant/61638704169330",
            "sku": "SET-8xJTV -60R-16 -X00",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-jumbo-tour-velvet?variant=61638704169330"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 11.3,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-midsize-tour-velvet",
        "handle": "8pc-bundle-golf-pride-midsize-tour-velvet",
        "shopify_variants": [
          {
            "id": "61638704038258",
            "gid": "gid://shopify/ProductVariant/61638704038258",
            "sku": "SET-8xVMM -60R-16 -X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-midsize-tour-velvet?variant=61638704038258"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-undersize-tour-velvet",
        "handle": "8pc-bundle-golf-pride-undersize-tour-velvet",
        "shopify_variants": [
          {
            "id": "61638703087986",
            "gid": "gid://shopify/ProductVariant/61638703087986",
            "sku": "SET-8xVTL -58X-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size": "58 Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-undersize-tour-velvet?variant=61638703087986"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mens-tour-velvet",
        "handle": "8pc-bundle-golf-pride-mens-tour-velvet",
        "shopify_variants": [
          {
            "id": "61638702530930",
            "gid": "gid://shopify/ProductVariant/61638702530930",
            "sku": "SET-8xVTM -60R-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mens-tour-velvet?variant=61638702530930"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-junior-tour-velvet-bundle-8pcs",
        "handle": "golf-pride-junior-tour-velvet-bundle-8pcs",
        "shopify_variants": [
          {
            "id": "61638701220210",
            "gid": "gid://shopify/ProductVariant/61638701220210",
            "sku": "SET-8xTVJ -50X-11 -X00",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-junior-tour-velvet-bundle-8pcs?variant=61638701220210"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-velvet-bundle-8pcs",
        "handle": "golf-pride-jumbo-tour-velvet-bundle-8pcs",
        "shopify_variants": [
          {
            "id": "61638700794226",
            "gid": "gid://shopify/ProductVariant/61638700794226",
            "sku": "SET-8xJTV -60R-16 -X00",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-velvet-bundle-8pcs?variant=61638700794226"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 11.3,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-velvet-bundle-8pcs",
        "handle": "golf-pride-midsize-tour-velvet-bundle-8pcs",
        "shopify_variants": [
          {
            "id": "61638700302706",
            "gid": "gid://shopify/ProductVariant/61638700302706",
            "sku": "SET-8xVMM -60R-16 -X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-velvet-bundle-8pcs?variant=61638700302706"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-velvet-bundle-8pcs",
        "handle": "golf-pride-undersize-tour-velvet-bundle-8pcs",
        "shopify_variants": [
          {
            "id": "61638696337778",
            "gid": "gid://shopify/ProductVariant/61638696337778",
            "sku": "SET-8xVTL -58X-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size": "58 Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-velvet-bundle-8pcs?variant=61638696337778"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bundle-8pcs",
        "handle": "golf-pride-mens-tour-velvet-bundle-8pcs",
        "shopify_variants": [
          {
            "id": "61638695682418",
            "gid": "gid://shopify/ProductVariant/61638695682418",
            "sku": "SET-8xVTM -60R-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bundle-8pcs?variant=61638695682418"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bundle-13pcs",
        "handle": "golf-pride-mens-tour-velvet-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398927671666",
            "gid": "gid://shopify/ProductVariant/61398927671666",
            "sku": "SET-13xVTM -60R-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bundle-13pcs?variant=61398927671666"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-velvet-bundle-13pcs",
        "handle": "golf-pride-undersize-tour-velvet-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398926229874",
            "gid": "gid://shopify/ProductVariant/61398926229874",
            "sku": "SET-13xVTL -58X-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size": "58 Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-velvet-bundle-13pcs?variant=61398926229874"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-velvet-bundle-13pcs",
        "handle": "golf-pride-midsize-tour-velvet-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398926131570",
            "gid": "gid://shopify/ProductVariant/61398926131570",
            "sku": "SET-13xVMM -60R-16 -X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-velvet-bundle-13pcs?variant=61398926131570"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-velvet-bundle-13pcs",
        "handle": "golf-pride-jumbo-tour-velvet-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398926098802",
            "gid": "gid://shopify/ProductVariant/61398926098802",
            "sku": "SET-13xJTV -60R-16 -X00",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-velvet-bundle-13pcs?variant=61398926098802"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-junior-tour-velvet-bundle-13pcs",
        "handle": "golf-pride-junior-tour-velvet-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398926066034",
            "gid": "gid://shopify/ProductVariant/61398926066034",
            "sku": "SET-13xTVJ -50X-11 -X00",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-junior-tour-velvet-bundle-13pcs?variant=61398926066034"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mens-tour-velvet",
        "handle": "13pc-bundle-golf-pride-mens-tour-velvet",
        "shopify_variants": [
          {
            "id": "60791468491122",
            "gid": "gid://shopify/ProductVariant/60791468491122",
            "sku": "SET-13xVTM -60R-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mens-tour-velvet?variant=60791468491122"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-undersize-tour-velvet",
        "handle": "13pc-bundle-golf-pride-undersize-tour-velvet",
        "shopify_variants": [
          {
            "id": "60791468130674",
            "gid": "gid://shopify/ProductVariant/60791468130674",
            "sku": "SET-13xVTL -58X-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size": "58 Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-undersize-tour-velvet?variant=60791468130674"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-midsize-tour-velvet",
        "handle": "13pc-bundle-golf-pride-midsize-tour-velvet",
        "shopify_variants": [
          {
            "id": "60791467802994",
            "gid": "gid://shopify/ProductVariant/60791467802994",
            "sku": "SET-13xVMM -60R-16 -X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-midsize-tour-velvet?variant=60791467802994"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-jumbo-tour-velvet",
        "handle": "13pc-bundle-golf-pride-jumbo-tour-velvet",
        "shopify_variants": [
          {
            "id": "60791467671922",
            "gid": "gid://shopify/ProductVariant/60791467671922",
            "sku": "SET-13xJTV -60R-16 -X00",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-jumbo-tour-velvet?variant=60791467671922"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-junior-tour-velvet",
        "handle": "13pc-bundle-golf-pride-junior-tour-velvet",
        "shopify_variants": [
          {
            "id": "60791467082098",
            "gid": "gid://shopify/ProductVariant/60791467082098",
            "sku": "SET-13xTVJ -50X-11 -X00",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-junior-tour-velvet?variant=60791467082098"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 69.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-grip-bundle-set",
        "handle": "golf-pride-mens-tour-velvet-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021978017853",
            "gid": "gid://shopify/ProductVariant/41021978017853",
            "sku": "SET-10xVTM -60R-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-grip-bundle-set?variant=41021978017853"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 69.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-velvet-grip-bundle-set",
        "handle": "golf-pride-undersize-tour-velvet-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021977722941",
            "gid": "gid://shopify/ProductVariant/41021977722941",
            "sku": "SET-10xVTL -58X-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size": "58 Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-velvet-grip-bundle-set?variant=41021977722941"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 69.9,
        "per_grip_g": 81.6,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-velvet-grip-bundle-set",
        "handle": "golf-pride-midsize-tour-velvet-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021977591869",
            "gid": "gid://shopify/ProductVariant/41021977591869",
            "sku": "SET-10xVMM -60R-16 -X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-velvet-grip-bundle-set?variant=41021977591869"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 69.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-velvet-grip-bundle-set",
        "handle": "golf-pride-jumbo-tour-velvet-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021977559101",
            "gid": "gid://shopify/ProductVariant/41021977559101",
            "sku": "SET-10xJTV -60R-16 -X00",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-velvet-grip-bundle-set?variant=41021977559101"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 69.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-junior-tour-velvet-grip-bundle-set",
        "handle": "golf-pride-junior-tour-velvet-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021977296957",
            "gid": "gid://shopify/ProductVariant/41021977296957",
            "sku": "SET-10xTVJ -50X-11 -X00",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-junior-tour-velvet-grip-bundle-set?variant=41021977296957"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 97.55,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-junior-grips",
        "handle": "grip-kit-13x-golf-pride-tour-velvet-junior-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830345789",
            "gid": "gid://shopify/ProductVariant/39915830345789",
            "sku": "KIT+13xTVJ -50X-11 -X00",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-junior-grips?variant=39915830345789"
          },
          {
            "id": "39915830378557",
            "gid": "gid://shopify/ProductVariant/39915830378557",
            "sku": "KIT(8oz)+13xTVJ -50X-11 -X00",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 99.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-junior-grips?variant=39915830378557"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 97.55,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-undersize-grips",
        "handle": "grip-kit-13x-golf-pride-tour-velvet-undersize-grips",
        "shopify_variants": [
          {
            "id": "40510626631",
            "gid": "gid://shopify/ProductVariant/40510626631",
            "sku": "KIT+13xVTL -58X-11 -X00",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Shape": "58 Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-undersize-grips?variant=40510626631"
          }
        ],
        "shopify_options": [
          {
            "name": "Shape",
            "values": [
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 97.55,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-jumbo-grips",
        "handle": "grip-kit-13x-golf-pride-tour-velvet-jumbo-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830411325",
            "gid": "gid://shopify/ProductVariant/39915830411325",
            "sku": "KIT+13xJTV -60R-16 -X00",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-jumbo-grips?variant=39915830411325"
          },
          {
            "id": "39915830444093",
            "gid": "gid://shopify/ProductVariant/39915830444093",
            "sku": "KIT(8oz)+13xJTV -60R-16 -X00",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 99.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-jumbo-grips?variant=39915830444093"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 97.55,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-midsize-grips",
        "handle": "grip-kit-13x-golf-pride-tour-velvet-midsize-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830739005",
            "gid": "gid://shopify/ProductVariant/39915830739005",
            "sku": "KIT+13xVMM -60R-16 -X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-midsize-grips?variant=39915830739005"
          },
          {
            "id": "39915830771773",
            "gid": "gid://shopify/ProductVariant/39915830771773",
            "sku": "KIT(8oz)+13xVMM -60R-16 -X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 99.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-midsize-grips?variant=39915830771773"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 97.55,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-standard-grips",
        "handle": "grip-kit-13x-golf-pride-tour-velvet-standard-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830804541",
            "gid": "gid://shopify/ProductVariant/39915830804541",
            "sku": "KIT+13xVTM -60R-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-standard-grips?variant=39915830804541"
          },
          {
            "id": "39915830870077",
            "gid": "gid://shopify/ProductVariant/39915830870077",
            "sku": "KIT(8oz)+13xVTM -60R-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 99.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-velvet-standard-grips?variant=39915830870077"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-junior-tour-velvet",
        "handle": "golf-pride-junior-tour-velvet",
        "shopify_variants": [
          {
            "id": "116724162",
            "gid": "gid://shopify/ProductVariant/116724162",
            "sku": "TVJ -50X-11 -X00",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-junior-tour-velvet?variant=116724162"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-velvet",
        "handle": "golf-pride-jumbo-tour-velvet",
        "shopify_variants": [
          {
            "id": "40683335778365",
            "gid": "gid://shopify/ProductVariant/40683335778365",
            "sku": "JTV -60R-16 -X00",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-velvet?variant=40683335778365"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-velvet",
        "handle": "golf-pride-midsize-tour-velvet",
        "shopify_variants": [
          {
            "id": "40683339808829",
            "gid": "gid://shopify/ProductVariant/40683339808829",
            "sku": "VMM -60R-16 -X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-velvet?variant=40683339808829"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-velvet",
        "handle": "golf-pride-undersize-tour-velvet",
        "shopify_variants": [
          {
            "id": "116723942",
            "gid": "gid://shopify/ProductVariant/116723942",
            "sku": "VTL -58X-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size": "58 Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-velvet?variant=116723942"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet",
        "handle": "golf-pride-mens-tour-velvet",
        "shopify_variants": [
          {
            "id": "116723792",
            "gid": "gid://shopify/ProductVariant/116723792",
            "sku": "VTM -60R-11 -X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet?variant=116723792"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, golf pride bundle, golf pride single grip, Golf Pride Tour Velvet, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, junior, junior-golf-grips, medium firm, ribbed, rubber, single-golf-grips, tour velvet, under-150, under-300, video=9LLEvmz-erQ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Round Tour Velvet family only. The physical reminder-rib version is stored separately as Tour Velvet Ribbed so it cannot be mistaken for Tour Velvet ALIGN or standard round Tour Velvet.",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {
      "Junior": "Black",
      "Jumbo/Oversize": "Black",
      "Midsize": "Black",
      "Undersize": "Black",
      "Standard": "Black"
    },
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "golf-pride-tour-velvet-ribbed",
    "brand": "Golf Pride",
    "model": "Tour Velvet Ribbed",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber blend",
    "texture": "textured (+ pattern)",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "ribbed reminder ridge",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/tour-velvet-collection/tour-velvet.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard Ribbed"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 5.99,
    "price_max": 5.99,
    "single_price_min": 5.99,
    "single_price_max": 5.99,
    "normalized_price_per_grip": 5.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-standard-grip-ribbed",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/golf-pride-tour-velvet_1b830bb7-9232-435b-9566-83a7240e3c05.jpg?v=1761759959",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-standard-grip-ribbed",
        "handle": "golf-pride-tour-velvet-standard-grip-ribbed",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard 60 Ribbed (most popular)",
              "Standard 58 Ribbed"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "18408143303",
            "gid": "gid://shopify/ProductVariant/18408143303",
            "sku": "WEB ONLY: RIBBED-VTM-60X-11-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 60 Ribbed (most popular)"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-standard-grip-ribbed?variant=18408143303"
          },
          {
            "id": "18408143239",
            "gid": "gid://shopify/ProductVariant/18408143239",
            "sku": "WEB ONLY: RIBBED-VTM-58X-11-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 58 Ribbed"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-standard-grip-ribbed?variant=18408143239"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, golf pride bundle, golf pride single grip, Golf Pride Tour Velvet, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, junior, junior-golf-grips, medium firm, ribbed, rubber, single-golf-grips, tour velvet, under-150, under-300, video=9LLEvmz-erQ, ribbed, reminder, alignment aid",
    "source_quality": "manufacturer_model",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "Separated from standard round Tour Velvet. This record represents only the physical reminder-rib version.",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {
      "Standard": "Black"
    },
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-velvet-360",
    "brand": "Golf Pride",
    "model": "Tour Velvet 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber blend",
    "texture": "textured (+ pattern)",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/tour-velvet-collection/tour-velvet.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "Black",
      "White/Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 6.99,
    "price_max": 97.55,
    "single_price_min": 6.99,
    "single_price_max": 6.99,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": 55.92,
    "kit_price_min": 97.55,
    "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/tour-velvet-360-mid_a389a4ae-0a13-45ab-9d57-cb883614e2c4.jpg?v=1761759842",
    "fit_tags": [
      "best_for_arthritis",
      "soft_feel"
    ],
    "product_count": 12,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "White/Black"
        ],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-360-midsize-grip",
        "handle": "8pc-bundle-golf-pride-tour-velvet-360-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638719734130",
            "gid": "gid://shopify/ProductVariant/61638719734130",
            "sku": "SET-8xGTMM-60R-16A-XB",
            "color": "White/Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-360-midsize-grip?variant=61638719734130"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 6.2,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-360-std",
        "handle": "8pc-bundle-golf-pride-tour-velvet-360-std",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638708461938",
            "gid": "gid://shopify/ProductVariant/61638708461938",
            "sku": "SET-8xGTSS-60R-07 -XX0",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-360-std?variant=61638708461938"
          },
          {
            "id": "61638708494706",
            "gid": "gid://shopify/ProductVariant/61638708494706",
            "sku": "SET-8xGTS1-60R-07 -XB",
            "color": "White/Black",
            "size": "Standard",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-360-std?variant=61638708494706"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 55.92,
        "per_grip_g": 6.2,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-bundle-8pcs",
        "handle": "golf-pride-tour-velvet-360-std-bundle-8pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638701580658",
            "gid": "gid://shopify/ProductVariant/61638701580658",
            "sku": "SET-8xGTSS-60R-07 -XX0",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-bundle-8pcs?variant=61638701580658"
          },
          {
            "id": "61638701613426",
            "gid": "gid://shopify/ProductVariant/61638701613426",
            "sku": "SET-8xGTS1-60R-07 -XB",
            "color": "White/Black",
            "size": "Standard",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-bundle-8pcs?variant=61638701613426"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 3.8,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-bundle-13pcs",
        "handle": "golf-pride-tour-velvet-360-std-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398925934962",
            "gid": "gid://shopify/ProductVariant/61398925934962",
            "sku": "SET-13xGTSS-60R-07 -XX0",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-bundle-13pcs?variant=61398925934962"
          },
          {
            "id": "61398925967730",
            "gid": "gid://shopify/ProductVariant/61398925967730",
            "sku": "SET-13xGTS1-60R-07 -XB",
            "color": "White/Black",
            "size": "Standard",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-bundle-13pcs?variant=61398925967730"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 3.8,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-360-std",
        "handle": "13pc-bundle-golf-pride-tour-velvet-360-std",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791466852722",
            "gid": "gid://shopify/ProductVariant/60791466852722",
            "sku": "SET-13xGTSS-60R-07 -XX0",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-360-std?variant=60791466852722"
          },
          {
            "id": "60791466885490",
            "gid": "gid://shopify/ProductVariant/60791466885490",
            "sku": "SET-13xGTS1-60R-07 -XB",
            "color": "White/Black",
            "size": "Standard",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-360-std?variant=60791466885490"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "White/Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-360-midsize-grip",
        "handle": "13pc-bundle-golf-pride-tour-velvet-360-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791458627954",
            "gid": "gid://shopify/ProductVariant/60791458627954",
            "sku": "SET-13xGTMM-60R-16A-XB",
            "color": "White/Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-360-midsize-grip?variant=60791458627954"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 69.9,
        "per_grip_g": 44.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-grip-bundle-set",
        "handle": "golf-pride-tour-velvet-360-std-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021975724093",
            "gid": "gid://shopify/ProductVariant/41021975724093",
            "sku": "SET-10xGTSS-60R-07 -XX0",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 449.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-grip-bundle-set?variant=41021975724093"
          },
          {
            "id": "41021975756861",
            "gid": "gid://shopify/ProductVariant/41021975756861",
            "sku": "SET-10xGTS1-60R-07 -XB",
            "color": "White/Black",
            "size": "Standard",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 449.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-grip-bundle-set?variant=41021975756861"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "White/Black"
        ],
        "price": 69.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-tour-velvet-360-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965074493",
            "gid": "gid://shopify/ProductVariant/41021965074493",
            "sku": "SET-10xGTMM-60R-16A-XB",
            "color": "White/Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-midsize-grip-grip-bundle-set?variant=41021965074493"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 97.55,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-velvet-360-std-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31934154637373",
            "gid": "gid://shopify/ProductVariant/31934154637373",
            "sku": "KIT+13xGTSS-60R-07 -XX0",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-13pcs-golf-grip-kit?variant=31934154637373"
          },
          {
            "id": "31934154670141",
            "gid": "gid://shopify/ProductVariant/31934154670141",
            "sku": "KIT+13xGTS1-60R-07 -XB",
            "color": "White/Black",
            "size": "Standard",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std-13pcs-golf-grip-kit?variant=31934154670141"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 97.55,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-midsize-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-velvet-360-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828772925",
            "gid": "gid://shopify/ProductVariant/39915828772925",
            "sku": "KIT+13xGTMM-60R-16A-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-midsize-grip-13pcs-golf-grip-kit?variant=39915828772925"
          },
          {
            "id": "39915828805693",
            "gid": "gid://shopify/ProductVariant/39915828805693",
            "sku": "KIT(8oz)+13xGTMM-60R-16A-XB",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 99.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-midsize-grip-13pcs-golf-grip-kit?variant=39915828805693"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-midsize-grip",
        "handle": "golf-pride-tour-velvet-360-midsize-grip",
        "shopify_variants": [
          {
            "id": "7972479336509",
            "gid": "gid://shopify/ProductVariant/7972479336509",
            "sku": "GTMM-60R-16A-XB",
            "color": "White/Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-midsize-grip?variant=7972479336509"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.99,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std",
        "handle": "golf-pride-tour-velvet-360-std",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White/Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "193493802",
            "gid": "gid://shopify/ProductVariant/193493802",
            "sku": "GTSS-60R-07 -XX0",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std?variant=193493802"
          },
          {
            "id": "7972388765757",
            "gid": "gid://shopify/ProductVariant/7972388765757",
            "sku": "GTS1-60R-07 -XB",
            "color": "White/Black",
            "size": "Standard",
            "selected_options": {
              "Color": "White/Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-360-std?variant=7972388765757"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, 8pc bundle, 8pc golf pride, All Products, asbl-grip-option, golf pride bundle, golf pride single grip, Golf Pride Tour Velvet, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, medium firm, midsize, midsize-golf-grips, New for 2018, no logo, rubber, single-golf",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "360 = full-round, no reminder",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "White/Black"
    ]
  },
  {
    "id": "golf-pride-tour-velvet-align",
    "brand": "Golf Pride",
    "model": "Tour Velvet ALIGN",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber blend",
    "texture": "textured (+ pattern)",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "ALIGN ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ALIGN",
    "alignment_description": "Raised ridge along the underside designed to promote consistent hand placement.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/tour-velvet-collection/tour-velvet.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "Black Grip / Red Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14.99,
    "price_max": 209.19,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 14.99,
    "bundle_price_min": 119.92,
    "kit_price_min": 209.19,
    "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/tour-velvet-align_a9d98dd3-9942-4aab-819d-f715f177afd6.jpg?v=1761759851",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 10,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 119.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-align-midsize-grip",
        "handle": "8pc-bundle-golf-pride-tour-velvet-align-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638719537522",
            "gid": "gid://shopify/ProductVariant/61638719537522",
            "sku": "SET-8xVTXM-60X-N4M-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 119.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-align-midsize-grip?variant=61638719537522"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black Grip / Red Cap"
        ],
        "price": 119.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-align-standard-grip",
        "handle": "8pc-bundle-golf-pride-tour-velvet-align-standard-grip",
        "shopify_variants": [
          {
            "id": "61638719471986",
            "gid": "gid://shopify/ProductVariant/61638719471986",
            "sku": "SET-8xVTXS-60X-N4M-XA",
            "color": "Black Grip / Red Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 119.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-align-standard-grip?variant=61638719471986"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Red Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black Grip / Red Cap"
        ],
        "price": 194.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-align-standard-grip",
        "handle": "13pc-bundle-golf-pride-tour-velvet-align-standard-grip",
        "shopify_variants": [
          {
            "id": "60791462035826",
            "gid": "gid://shopify/ProductVariant/60791462035826",
            "sku": "SET-13xVTXS-60X-N4M-XA",
            "color": "Black Grip / Red Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-align-standard-grip?variant=60791462035826"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Red Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 194.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-align-midsize-grip",
        "handle": "13pc-bundle-golf-pride-tour-velvet-align-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791460168050",
            "gid": "gid://shopify/ProductVariant/60791460168050",
            "sku": "SET-13xVTXM-60X-N4M-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-align-midsize-grip?variant=60791460168050"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black Grip / Red Cap"
        ],
        "price": 149.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-standard-grip-grip-bundle-set",
        "handle": "golf-pride-tour-velvet-align-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965434941",
            "gid": "gid://shopify/ProductVariant/41021965434941",
            "sku": "SET-10xVTXS-60X-N4M-XA",
            "color": "Black Grip / Red Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 149.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-standard-grip-grip-bundle-set?variant=41021965434941"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Red Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 149.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-tour-velvet-align-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965402173",
            "gid": "gid://shopify/ProductVariant/41021965402173",
            "sku": "SET-10xVTXM-60X-N4M-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 149.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-midsize-grip-grip-bundle-set?variant=41021965402173"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 209.19,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-midsize-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-velvet-align-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829362749",
            "gid": "gid://shopify/ProductVariant/39915829362749",
            "sku": "KIT+13xVTXM-60X-N4M-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 209.19,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-midsize-grip-13pcs-golf-grip-kit?variant=39915829362749"
          },
          {
            "id": "39915829395517",
            "gid": "gid://shopify/ProductVariant/39915829395517",
            "sku": "KIT(8oz)+13xVTXM-60X-N4M-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 212.9,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-midsize-grip-13pcs-golf-grip-kit?variant=39915829395517"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 209.19,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-standard-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-velvet-align-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829428285",
            "gid": "gid://shopify/ProductVariant/39915829428285",
            "sku": "kIT+13xVTXS-60X-N4M-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 209.19,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-standard-grip-13pcs-golf-grip-kit?variant=39915829428285"
          },
          {
            "id": "39915829461053",
            "gid": "gid://shopify/ProductVariant/39915829461053",
            "sku": "KIT(8oz)+13xVTXS-60X-N4M-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 212.9,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-standard-grip-13pcs-golf-grip-kit?variant=39915829461053"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 14.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-midsize-grip",
        "handle": "golf-pride-tour-velvet-align-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683335745597",
            "gid": "gid://shopify/ProductVariant/40683335745597",
            "sku": "VTXM-60X-N4M-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-midsize-grip?variant=40683335745597"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black Grip / Red Cap"
        ],
        "price": 14.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-standard-grip",
        "handle": "golf-pride-tour-velvet-align-standard-grip",
        "shopify_variants": [
          {
            "id": "1053625679891",
            "gid": "gid://shopify/ProductVariant/1053625679891",
            "sku": "VTXS-60X-N4M-XA",
            "color": "Black Grip / Red Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-align-standard-grip?variant=1053625679891"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Red Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, Alignment golf grip, alignment-golf-grips, All Products, firm, golf pride align, golf pride bundle, golf pride single grip, Golf Pride Tour Velvet, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, midsize, midsize-golf-grips, New for 2018, non-cord, reminder, rib",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black Grip / Red Cap"
    ]
  },
  {
    "id": "golf-pride-tour-velvet-bct-cord",
    "brand": "Golf Pride",
    "model": "Tour Velvet BCT Cord",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/blog/full-cord-grips-what-are-they-and-why-play-them.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard",
      "Standard 60 Ribbed (most popular)"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "Ribbed"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 11.49,
    "price_max": 181.28,
    "single_price_min": 11.49,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 11.49,
    "bundle_price_min": 103.92,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/tour-velvet-cord_c0a40dd9-8b2a-498e-88cd-15859368b8a2.jpg?v=1761759766",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 14,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-bct-cord-midsize-grip",
        "handle": "8pc-bundle-golf-pride-tour-velvet-bct-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638732808562",
            "gid": "gid://shopify/ProductVariant/61638732808562",
            "sku": "SET-8xMMC -60R-12 -X00",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-bct-cord-midsize-grip?variant=61638732808562"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mens-tour-velvet-bct-cord",
        "handle": "8pc-bundle-golf-pride-mens-tour-velvet-bct-cord",
        "shopify_variants": [
          {
            "id": "61638702399858",
            "gid": "gid://shopify/ProductVariant/61638702399858",
            "sku": "SET-8xVTC -60R-12 -X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mens-tour-velvet-bct-cord?variant=61638702399858"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-midsize-grip-bundle-8pcs",
        "handle": "golf-pride-tour-velvet-bct-cord-midsize-grip-bundle-8pcs",
        "shopify_variants": [
          {
            "id": "61638701744498",
            "gid": "gid://shopify/ProductVariant/61638701744498",
            "sku": "SET-8xMMC -60R-12 -X00",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-midsize-grip-bundle-8pcs?variant=61638701744498"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord-bundle-8pcs",
        "handle": "golf-pride-mens-tour-velvet-bct-cord-bundle-8pcs",
        "shopify_variants": [
          {
            "id": "61638695551346",
            "gid": "gid://shopify/ProductVariant/61638695551346",
            "sku": "SET-8xVTC -60R-12 -X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord-bundle-8pcs?variant=61638695551346"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord-bundle-13pcs",
        "handle": "golf-pride-mens-tour-velvet-bct-cord-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398927704434",
            "gid": "gid://shopify/ProductVariant/61398927704434",
            "sku": "SET-13xVTC -60R-12 -X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord-bundle-13pcs?variant=61398927704434"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-midsize-grip-bundle-13pcs",
        "handle": "golf-pride-tour-velvet-bct-cord-midsize-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398910534002",
            "gid": "gid://shopify/ProductVariant/61398910534002",
            "sku": "SET-13xMMC -60R-12 -X00",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-midsize-grip-bundle-13pcs?variant=61398910534002"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mens-tour-velvet-bct-cord",
        "handle": "13pc-bundle-golf-pride-mens-tour-velvet-bct-cord",
        "shopify_variants": [
          {
            "id": "60791468556658",
            "gid": "gid://shopify/ProductVariant/60791468556658",
            "sku": "SET-13xVTC -60R-12 -X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mens-tour-velvet-bct-cord?variant=60791468556658"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-bct-cord-midsize-grip",
        "handle": "13pc-bundle-golf-pride-tour-velvet-bct-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791453581682",
            "gid": "gid://shopify/ProductVariant/60791453581682",
            "sku": "SET-13xMMC -60R-12 -X00",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-bct-cord-midsize-grip?variant=60791453581682"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord-grip-bundle-set",
        "handle": "golf-pride-mens-tour-velvet-bct-cord-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021978050621",
            "gid": "gid://shopify/ProductVariant/41021978050621",
            "sku": "SET-10xVTC -60R-12 -X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord-grip-bundle-set?variant=41021978050621"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-tour-velvet-bct-cord-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952655421",
            "gid": "gid://shopify/ProductVariant/41021952655421",
            "sku": "SET-10xMMC -60R-12 -X00",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-midsize-grip-grip-bundle-set?variant=41021952655421"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-midsize-grip",
        "handle": "golf-pride-tour-velvet-bct-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "40582157860925",
            "gid": "gid://shopify/ProductVariant/40582157860925",
            "sku": "MMC -60R-12 -X00",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-midsize-grip?variant=40582157860925"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord-13pcs-golf-grip-kit",
        "handle": "golf-pride-mens-tour-velvet-bct-cord-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard",
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31934155096125",
            "gid": "gid://shopify/ProductVariant/31934155096125",
            "sku": "KIT+13xVTC -60R-12 -X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord-13pcs-golf-grip-kit?variant=31934155096125"
          },
          {
            "id": "40582165626941",
            "gid": "gid://shopify/ProductVariant/40582165626941",
            "sku": "KIT+13xMMC -60R-12 -X00",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord-13pcs-golf-grip-kit?variant=40582165626941"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Ribbed"
        ],
        "price": 11.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-grip-ribbed",
        "handle": "golf-pride-tour-velvet-bct-cord-grip-ribbed",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard 60 Ribbed (most popular)",
              "Standard 58 Ribbed"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "18407956487",
            "gid": "gid://shopify/ProductVariant/18407956487",
            "sku": "WEB ONLY: RIBBED-VTC-60X-12-X00",
            "color": "Ribbed",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard 60 Ribbed (most popular)"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-grip-ribbed?variant=18407956487"
          },
          {
            "id": "18407956615",
            "gid": "gid://shopify/ProductVariant/18407956615",
            "sku": "WEB ONLY: RIBBED-VTC-58X-12-X00",
            "color": "Ribbed",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard 58 Ribbed"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-grip-ribbed?variant=18407956615"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord",
        "handle": "golf-pride-mens-tour-velvet-bct-cord",
        "shopify_variants": [
          {
            "id": "116723682",
            "gid": "gid://shopify/ProductVariant/116723682",
            "sku": "VTC -60R-12 -X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-velvet-bct-cord?variant=116723682"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, all-weather, cord, cord-golf-grips, firm, full cord, golf pride bundle, Golf Pride Cord Grips, golf pride single grip, Golf Pride Tour Velvet Cord, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, midsize, midsize-golf-grips, midsize-size-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-velvet-bct-cord-grip-58-core",
    "brand": "Golf Pride",
    "model": "Tour Velvet BCT Cord Grip - 58 Core",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/blog/full-cord-grips-what-are-they-and-why-play-them.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard 58 Round (most popular)"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 11.49,
    "price_max": 11.49,
    "single_price_min": 11.49,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 11.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-grip-58-core",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gp-tour-velvet-cord_df5caa33-54a4-498b-bfe7-0854acc2e064.jpg?v=1626841054",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 11.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-grip-58-core",
        "handle": "golf-pride-tour-velvet-bct-cord-grip-58-core",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard 58 Round (most popular)",
              "Standard 58 Ribbed"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "2055282753",
            "gid": "gid://shopify/ProductVariant/2055282753",
            "sku": "WEB ONLY: 58 CORE-VTC-58R-12-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 58 Round (most popular)"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-grip-58-core?variant=2055282753"
          },
          {
            "id": "18471739335",
            "gid": "gid://shopify/ProductVariant/18471739335",
            "sku": "WEB ONLY: 58 CORE-VTC-58X-12-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 58 Ribbed"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-bct-cord-grip-58-core?variant=18471739335"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, 58 Core, All Products, all-weather, cord, cord-golf-grips, firm, full cord, Golf Pride Cord Grips, golf pride single grip, Golf Pride Tour Velvet, golf-grips, golf-pride, iron/wood, single-golf-grips, single-grip, standard, standard-size-golf-grips, tour velvet, tour velvet cord, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-velvet-grip-58-core",
    "brand": "Golf Pride",
    "model": "Tour Velvet Grip - 58 Core",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber blend",
    "texture": "textured (+ pattern)",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/tour-velvet-collection/tour-velvet.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard 58 Ribbed"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 11.49,
    "price_max": 11.49,
    "single_price_min": 11.49,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 11.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-standard-grip-58-round",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/golf-pride-tour-velvet_11f17f74-bc4e-4508-83b3-11fe98d150ae.jpg?v=1571438514",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 11.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-standard-grip-58-round",
        "handle": "golf-pride-tour-velvet-standard-grip-58-round",
        "shopify_variants": [
          {
            "id": "2055478593",
            "gid": "gid://shopify/ProductVariant/2055478593",
            "sku": "WEB ONLY: 58 CORE-VTM-58X-11-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 58 Ribbed"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-standard-grip-58-round?variant=2055478593"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard 58 Ribbed"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "49 under, 58 Core, All Products, golf pride single grip, Golf Pride Tour Velvet, golf-grips, golf-pride, iron/wood, medium firm, non-cord, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, tour velvet, under-150, under-300, video=9LLEvmz-erQ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-velvet-plus4",
    "brand": "Golf Pride",
    "model": "Tour Velvet PLUS4",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber blend",
    "texture": "textured (+ pattern)",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/swing-grips/tour-velvet-collection/tour-velvet.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 6.99,
    "price_max": 97.55,
    "single_price_min": 6.99,
    "single_price_max": 6.99,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": 55.92,
    "kit_price_min": 97.55,
    "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/web-tour-velvet-plus4_front_454071c5-28b0-47d2-9fea-cc8deee40933.jpg?v=1761759832",
    "fit_tags": [],
    "product_count": 10,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-plus4-midsize-grip",
        "handle": "8pc-bundle-golf-pride-tour-velvet-plus4-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638721503602",
            "gid": "gid://shopify/ProductVariant/61638721503602",
            "sku": "SET-8xVT4M-60R-FU4-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-plus4-midsize-grip?variant=61638721503602"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 55.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-plus4-standard-grip",
        "handle": "8pc-bundle-golf-pride-tour-velvet-plus4-standard-grip",
        "shopify_variants": [
          {
            "id": "61638720225650",
            "gid": "gid://shopify/ProductVariant/61638720225650",
            "sku": "SET-8xVT4S-60R-FU4-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 55.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-tour-velvet-plus4-standard-grip?variant=61638720225650"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-plus4-standard-grip",
        "handle": "13pc-bundle-golf-pride-tour-velvet-plus4-standard-grip",
        "shopify_variants": [
          {
            "id": "60791458365810",
            "gid": "gid://shopify/ProductVariant/60791458365810",
            "sku": "SET-13xVT4S-60R-FU4-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-plus4-standard-grip?variant=60791458365810"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-plus4-midsize-grip",
        "handle": "13pc-bundle-golf-pride-tour-velvet-plus4-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791458201970",
            "gid": "gid://shopify/ProductVariant/60791458201970",
            "sku": "SET-13xVT4M-60R-FU4-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-tour-velvet-plus4-midsize-grip?variant=60791458201970"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 69.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-standard-grip-grip-bundle-set",
        "handle": "golf-pride-tour-velvet-plus4-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021964288061",
            "gid": "gid://shopify/ProductVariant/41021964288061",
            "sku": "SET-10xVT4S-60R-FU4-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-standard-grip-grip-bundle-set?variant=41021964288061"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 69.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-tour-velvet-plus4-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021964255293",
            "gid": "gid://shopify/ProductVariant/41021964255293",
            "sku": "SET-10xVT4M-60R-FU4-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 69.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-midsize-grip-grip-bundle-set?variant=41021964255293"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 97.55,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-midsize-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-velvet-plus4-midsize-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829100605",
            "gid": "gid://shopify/ProductVariant/39915829100605",
            "sku": "KIT+13xVT4M-60R-FU4-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-midsize-13pcs-golf-grip-kit?variant=39915829100605"
          },
          {
            "id": "39915829133373",
            "gid": "gid://shopify/ProductVariant/39915829133373",
            "sku": "KIT(8oz)+13xVT4M-60R-FU4-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 99.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-midsize-13pcs-golf-grip-kit?variant=39915829133373"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 97.55,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-standard-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-velvet-plus4-standard-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829166141",
            "gid": "gid://shopify/ProductVariant/39915829166141",
            "sku": "KIT+13xVT4S-60R-FU4-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 97.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-standard-13pcs-golf-grip-kit?variant=39915829166141"
          },
          {
            "id": "39915829198909",
            "gid": "gid://shopify/ProductVariant/39915829198909",
            "sku": "KIT(8oz)+13xVT4S-60R-FU4-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 99.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-standard-13pcs-golf-grip-kit?variant=39915829198909"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-midsize-grip",
        "handle": "golf-pride-tour-velvet-plus4-midsize-grip",
        "shopify_variants": [
          {
            "id": "13972787986493",
            "gid": "gid://shopify/ProductVariant/13972787986493",
            "sku": "VT4M-60R-FU4-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-midsize-grip?variant=13972787986493"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-standard-grip",
        "handle": "golf-pride-tour-velvet-plus4-standard-grip",
        "shopify_variants": [
          {
            "id": "13972773666877",
            "gid": "gid://shopify/ProductVariant/13972773666877",
            "sku": "VT4S-60R-FU4-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-plus4-standard-grip?variant=13972773666877"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, golf pride bundle, golf pride single grip, Golf Pride Tour Velvet, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, Less Tapered, medium firm, midsize, midsize-golf-grips, Minimal Taper, New 2019 Golf Grips, NEW Golf Pride 2019 Grips, non-cord, non-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-velvet-super-tack",
    "brand": "Golf Pride",
    "model": "Tour Velvet Super Tack",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber blend",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Midsize / Black",
      "Standard / Black"
    ],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 6.99,
    "price_max": 117.35,
    "single_price_min": 6.99,
    "single_price_max": 7.99,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": null,
    "kit_price_min": 104.35,
    "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2020-gp-kits-tour-velvet-supertack.jpg?v=1751587518",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Midsize / Black"
        ],
        "price": 117.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-midsize-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-velvet-super-tack-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Midsize / Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828510781",
            "gid": "gid://shopify/ProductVariant/39915828510781",
            "sku": "KIT+13xVSTM-60R-103-XFF",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 117.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-midsize-grip-13pcs-golf-grip-kit?variant=39915828510781"
          },
          {
            "id": "39915828543549",
            "gid": "gid://shopify/ProductVariant/39915828543549",
            "sku": "KIT(8oz)+13xVSTM-60R-103-XFF",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 122.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-midsize-grip-13pcs-golf-grip-kit?variant=39915828543549"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Black"
        ],
        "price": 104.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-standard-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-velvet-super-tack-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Standard / Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828576317",
            "gid": "gid://shopify/ProductVariant/39915828576317",
            "sku": "KIT+13xVSTS-60R-113-XFF",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 104.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-standard-grip-13pcs-golf-grip-kit?variant=39915828576317"
          },
          {
            "id": "39915828609085",
            "gid": "gid://shopify/ProductVariant/39915828609085",
            "sku": "KIT(8oz)+13xVSTS-60R-113-XFF",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 109.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-standard-grip-13pcs-golf-grip-kit?variant=39915828609085"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-standard-grip",
        "handle": "golf-pride-tour-velvet-super-tack-standard-grip",
        "shopify_variants": [
          {
            "id": "628628337",
            "gid": "gid://shopify/ProductVariant/628628337",
            "sku": "VSTS-60R-113-XFF",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Golf Pride Tour Velvet Super Tack Standard Grip"
            },
            "available": false,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-standard-grip?variant=628628337"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Golf Pride Tour Velvet Super Tack Standard Grip"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 7.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-midsize-grip",
        "handle": "golf-pride-tour-velvet-super-tack-midsize-grip",
        "shopify_variants": [
          {
            "id": "628628325",
            "gid": "gid://shopify/ProductVariant/628628325",
            "sku": "VSTM-60R-103-XFF",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Golf Pride Tour Velvet Super Tack Midsize Grip"
            },
            "available": false,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-velvet-super-tack-midsize-grip?variant=628628325"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Golf Pride Tour Velvet Super Tack Midsize Grip"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, Golf Pride Grip Kits, Golf Pride Super Tack, golf-pride, gp-gift-2025, grip kit, grip kits, grip sets, iron/w",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-wrap-2g",
    "brand": "Golf Pride",
    "model": "Tour Wrap 2G",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.99,
    "price_max": 153.37,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 7.63,
    "bundle_price_min": 87.92,
    "kit_price_min": 99.13,
    "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-wrap-2g",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/tour-wrap-black_144b2f33-2fd3-4891-8c68-171f7d9d4f1f.jpg?v=1761759965",
    "fit_tags": [
      "best_for_arthritis",
      "soft_feel"
    ],
    "product_count": 21,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-jumbo-tour-wrap-2g",
        "handle": "8pc-bundle-golf-pride-jumbo-tour-wrap-2g",
        "shopify_variants": [
          {
            "id": "61638708003186",
            "gid": "gid://shopify/ProductVariant/61638708003186",
            "sku": "SET-8xTWPJ-60R-120-X00",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-jumbo-tour-wrap-2g?variant=61638708003186"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-midsize-tour-wrap-2g",
        "handle": "8pc-bundle-golf-pride-midsize-tour-wrap-2g",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638707937650",
            "gid": "gid://shopify/ProductVariant/61638707937650",
            "sku": "SET-8xTWPM-60R-120-X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-midsize-tour-wrap-2g?variant=61638707937650"
          },
          {
            "id": "61638707970418",
            "gid": "gid://shopify/ProductVariant/61638707970418",
            "sku": "SET-8xTWPM-60R-050-X11",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-midsize-tour-wrap-2g?variant=61638707970418"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-undersize-tour-wrap-2g",
        "handle": "8pc-bundle-golf-pride-undersize-tour-wrap-2g",
        "shopify_variants": [
          {
            "id": "61638703645042",
            "gid": "gid://shopify/ProductVariant/61638703645042",
            "sku": "SET-8xTWPU-58R-120-X00",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-undersize-tour-wrap-2g?variant=61638703645042"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [
          "Black"
        ],
        "price": 87.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mens-tour-wrap-2g",
        "handle": "8pc-bundle-golf-pride-mens-tour-wrap-2g",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61638702727538",
            "gid": "gid://shopify/ProductVariant/61638702727538",
            "sku": "SET-8xTWPS-60R-120-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mens-tour-wrap-2g?variant=61638702727538"
          },
          {
            "id": "61638702760306",
            "gid": "gid://shopify/ProductVariant/61638702760306",
            "sku": "SET-8xTWPS-60R-411-X00",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mens-tour-wrap-2g?variant=61638702760306"
          },
          {
            "id": "61638702793074",
            "gid": "gid://shopify/ProductVariant/61638702793074",
            "sku": "SET-8xTWPS-60R-220-X00",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mens-tour-wrap-2g?variant=61638702793074"
          },
          {
            "id": "61638702825842",
            "gid": "gid://shopify/ProductVariant/61638702825842",
            "sku": "SET-8xTWPS-60R-050-X11",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 87.92,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-mens-tour-wrap-2g?variant=61638702825842"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mens-tour-wrap-2g",
        "handle": "13pc-bundle-golf-pride-mens-tour-wrap-2g",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791468261746",
            "gid": "gid://shopify/ProductVariant/60791468261746",
            "sku": "SET-13xTWPS-60R-120-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mens-tour-wrap-2g?variant=60791468261746"
          },
          {
            "id": "60791468294514",
            "gid": "gid://shopify/ProductVariant/60791468294514",
            "sku": "SET-13xTWPS-60R-411-X00",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mens-tour-wrap-2g?variant=60791468294514"
          },
          {
            "id": "60791468327282",
            "gid": "gid://shopify/ProductVariant/60791468327282",
            "sku": "SET-13xTWPS-60R-220-X00",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mens-tour-wrap-2g?variant=60791468327282"
          },
          {
            "id": "60791468360050",
            "gid": "gid://shopify/ProductVariant/60791468360050",
            "sku": "SET-13xTWPS-60R-050-X11",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-mens-tour-wrap-2g?variant=60791468360050"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-undersize-tour-wrap-2g",
        "handle": "13pc-bundle-golf-pride-undersize-tour-wrap-2g",
        "shopify_variants": [
          {
            "id": "60791467966834",
            "gid": "gid://shopify/ProductVariant/60791467966834",
            "sku": "SET-13xTWPU-58R-120-X00",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-undersize-tour-wrap-2g?variant=60791467966834"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-midsize-tour-wrap-2g",
        "handle": "13pc-bundle-golf-pride-midsize-tour-wrap-2g",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60791467475314",
            "gid": "gid://shopify/ProductVariant/60791467475314",
            "sku": "SET-13xTWPM-60R-120-X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-midsize-tour-wrap-2g?variant=60791467475314"
          },
          {
            "id": "60791467508082",
            "gid": "gid://shopify/ProductVariant/60791467508082",
            "sku": "SET-13xTWPM-60R-050-X11",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-midsize-tour-wrap-2g?variant=60791467508082"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-jumbo-tour-wrap-2g",
        "handle": "13pc-bundle-golf-pride-jumbo-tour-wrap-2g",
        "shopify_variants": [
          {
            "id": "60791467245938",
            "gid": "gid://shopify/ProductVariant/60791467245938",
            "sku": "SET-13xTWPJ-60R-120-X00",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-jumbo-tour-wrap-2g?variant=60791467245938"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g-grip-bundle-set",
        "handle": "golf-pride-mens-tour-wrap-2g-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021977854013",
            "gid": "gid://shopify/ProductVariant/41021977854013",
            "sku": "SET-10xTWPS-60R-120-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g-grip-bundle-set?variant=41021977854013"
          },
          {
            "id": "41021977886781",
            "gid": "gid://shopify/ProductVariant/41021977886781",
            "sku": "SET-10xTWPS-60R-411-X00",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g-grip-bundle-set?variant=41021977886781"
          },
          {
            "id": "41021977919549",
            "gid": "gid://shopify/ProductVariant/41021977919549",
            "sku": "SET-10xTWPS-60R-220-X00",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 449.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g-grip-bundle-set?variant=41021977919549"
          },
          {
            "id": "41021977952317",
            "gid": "gid://shopify/ProductVariant/41021977952317",
            "sku": "SET-10xTWPS-60R-050-X11",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g-grip-bundle-set?variant=41021977952317"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-wrap-2g-grip-bundle-set",
        "handle": "golf-pride-undersize-tour-wrap-2g-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021977657405",
            "gid": "gid://shopify/ProductVariant/41021977657405",
            "sku": "SET-10xTWPU-58R-120-X00",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-wrap-2g-grip-bundle-set?variant=41021977657405"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-wrap-2g-grip-bundle-set",
        "handle": "golf-pride-midsize-tour-wrap-2g-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021977493565",
            "gid": "gid://shopify/ProductVariant/41021977493565",
            "sku": "SET-10xTWPM-60R-120-X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-wrap-2g-grip-bundle-set?variant=41021977493565"
          },
          {
            "id": "41021977526333",
            "gid": "gid://shopify/ProductVariant/41021977526333",
            "sku": "SET-10xTWPM-60R-050-X11",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-wrap-2g-grip-bundle-set?variant=41021977526333"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 109.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-wrap-2g-grip-bundle-set",
        "handle": "golf-pride-jumbo-tour-wrap-2g-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021977362493",
            "gid": "gid://shopify/ProductVariant/41021977362493",
            "sku": "SET-10xTWPJ-60R-120-X00",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 109.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-wrap-2g-grip-bundle-set?variant=41021977362493"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-wrap-2g-13pcs-golf-grip-kit",
        "handle": "golf-pride-undersize-tour-wrap-2g-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828183101",
            "gid": "gid://shopify/ProductVariant/39915828183101",
            "sku": "KIT+13xTWPU-58R-120-X00",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-wrap-2g-13pcs-golf-grip-kit?variant=39915828183101"
          },
          {
            "id": "39915828215869",
            "gid": "gid://shopify/ProductVariant/39915828215869",
            "sku": "KIT(8oz)+13xTWPU-58R-120-X00",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-wrap-2g-13pcs-golf-grip-kit?variant=39915828215869"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 99.13,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-grips-58-round",
        "handle": "grip-kit-13x-golf-pride-tour-wrap-2g-standard-grips-58-round",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830542397",
            "gid": "gid://shopify/ProductVariant/39915830542397",
            "sku": "KIT+13xTWPS-58R-120-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 99.13,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-grips-58-round?variant=39915830542397"
          },
          {
            "id": "39915830575165",
            "gid": "gid://shopify/ProductVariant/39915830575165",
            "sku": "KIT(8oz)+13xTWPS-58R-120-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 104.17,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-grips-58-round?variant=39915830575165"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-jumbo-grips",
        "handle": "grip-kit-13x-golf-pride-tour-wrap-2g-jumbo-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830935613",
            "gid": "gid://shopify/ProductVariant/39915830935613",
            "sku": "KIT+13xTWPJ-60R-120-X00",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-jumbo-grips?variant=39915830935613"
          },
          {
            "id": "39915830968381",
            "gid": "gid://shopify/ProductVariant/39915830968381",
            "sku": "KIT(8oz)+13xTWPJ-60R-120-X00",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-jumbo-grips?variant=39915830968381"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-midsize-grips",
        "handle": "grip-kit-13x-golf-pride-tour-wrap-2g-midsize-grips",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831001149",
            "gid": "gid://shopify/ProductVariant/39915831001149",
            "sku": "KIT+13xTWPM-60R-120-X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-midsize-grips?variant=39915831001149"
          },
          {
            "id": "39915831033917",
            "gid": "gid://shopify/ProductVariant/39915831033917",
            "sku": "KIT+13xTWPM-60R-050-X11",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-midsize-grips?variant=39915831033917"
          },
          {
            "id": "39915831066685",
            "gid": "gid://shopify/ProductVariant/39915831066685",
            "sku": "KIT(8oz)+13xTWPM-60R-120-X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-midsize-grips?variant=39915831066685"
          },
          {
            "id": "39915831099453",
            "gid": "gid://shopify/ProductVariant/39915831099453",
            "sku": "KIT(8oz)+13xTWPM-60R-050-X11",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-midsize-grips?variant=39915831099453"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-grips",
        "handle": "grip-kit-13x-golf-pride-tour-wrap-2g-standard-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831492669",
            "gid": "gid://shopify/ProductVariant/39915831492669",
            "sku": "KIT+13xTWPS-60R-120-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-grips?variant=39915831492669"
          },
          {
            "id": "39915831525437",
            "gid": "gid://shopify/ProductVariant/39915831525437",
            "sku": "KIT(8oz)+13xTWPS-60R-120-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-grips?variant=39915831525437"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-wrap-2g",
        "handle": "golf-pride-jumbo-tour-wrap-2g",
        "shopify_variants": [
          {
            "id": "40683340333117",
            "gid": "gid://shopify/ProductVariant/40683340333117",
            "sku": "TWPJ-60R-120-X00",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-jumbo-tour-wrap-2g?variant=40683340333117"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-wrap-2g",
        "handle": "golf-pride-midsize-tour-wrap-2g",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "116724102",
            "gid": "gid://shopify/ProductVariant/116724102",
            "sku": "TWPM-60R-120-X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-wrap-2g?variant=116724102"
          },
          {
            "id": "361193855",
            "gid": "gid://shopify/ProductVariant/361193855",
            "sku": "TWPM-60R-050-X11",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-tour-wrap-2g?variant=361193855"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-wrap-2g",
        "handle": "golf-pride-undersize-tour-wrap-2g",
        "shopify_variants": [
          {
            "id": "40683340628029",
            "gid": "gid://shopify/ProductVariant/40683340628029",
            "sku": "TWPU-58R-120-X00",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-tour-wrap-2g?variant=40683340628029"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g",
        "handle": "golf-pride-mens-tour-wrap-2g",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "116723832",
            "gid": "gid://shopify/ProductVariant/116723832",
            "sku": "TWPS-60R-120-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g?variant=116723832"
          },
          {
            "id": "308801521",
            "gid": "gid://shopify/ProductVariant/308801521",
            "sku": "TWPS-60R-411-X00",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g?variant=308801521"
          },
          {
            "id": "308802173",
            "gid": "gid://shopify/ProductVariant/308802173",
            "sku": "TWPS-60R-220-X00",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g?variant=308802173"
          },
          {
            "id": "308801873",
            "gid": "gid://shopify/ProductVariant/308801873",
            "sku": "TWPS-60R-050-X11",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-tour-wrap-2g?variant=308801873"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, golf pride bundle, golf pride single grip, Golf Pride Tour Wrap, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, jumbo, jumbo/oversize, non-cord, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, soft, tacky, tour wrap 2g, under-150, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "White",
      "Red",
      "Blue"
    ]
  },
  {
    "id": "golf-pride-tour-wrap-2g-blue",
    "brand": "Golf Pride",
    "model": "Tour Wrap 2G Blue",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 153.37,
    "price_max": 153.37,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 11.8,
    "bundle_price_min": null,
    "kit_price_min": 153.37,
    "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-blue-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/g4l-grip-kits-tw-2g-std-blue.jpg?v=1751587617",
    "fit_tags": [
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-blue-grips",
        "handle": "grip-kit-13x-golf-pride-tour-wrap-2g-standard-blue-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831361597",
            "gid": "gid://shopify/ProductVariant/39915831361597",
            "sku": "KIT+13xTWPS-60R-220-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-blue-grips?variant=39915831361597"
          },
          {
            "id": "39915831394365",
            "gid": "gid://shopify/ProductVariant/39915831394365",
            "sku": "KIT(8oz)+13xTWPS-60R-220-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-blue-grips?variant=39915831394365"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pride",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-wrap-2g-grip-58-core",
    "brand": "Golf Pride",
    "model": "Tour Wrap 2G Grip - 58 Core",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard 58 Round"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.99,
    "price_max": 6.99,
    "single_price_min": 6.99,
    "single_price_max": 6.99,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-2g-standard-grip-58-core",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gp-tour-wrap-blk_76414a34-c8b0-44fb-bbd2-517a584e7f6c.jpg?v=1627141939",
    "fit_tags": [
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-2g-standard-grip-58-core",
        "handle": "golf-pride-tour-wrap-2g-standard-grip-58-core",
        "shopify_variants": [
          {
            "id": "2056059009",
            "gid": "gid://shopify/ProductVariant/2056059009",
            "sku": "TWPS-58R-120-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 58 Round"
            },
            "available": false,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-2g-standard-grip-58-core?variant=2056059009"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard 58 Round"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "49 under, 58 Core, All Products, golf pride single grip, Golf Pride Tour Wrap, golf-grips, golf-pride, iron/wood, non-cord, rubber, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, tacky, tour wrap 2g, under-150, under-300, video=mdJs74xSpJY, wrap, wrap style, wrap-style-gol",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-wrap-2g-red",
    "brand": "Golf Pride",
    "model": "Tour Wrap 2G Red",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 153.37,
    "price_max": 153.37,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 11.8,
    "bundle_price_min": null,
    "kit_price_min": 153.37,
    "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-red-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/g4l-grip-kits-tw-2g-std-red.jpg?v=1751587618",
    "fit_tags": [
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-red-grips",
        "handle": "grip-kit-13x-golf-pride-tour-wrap-2g-standard-red-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831427133",
            "gid": "gid://shopify/ProductVariant/39915831427133",
            "sku": "KIT+13xTWPS-60R-411-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-red-grips?variant=39915831427133"
          },
          {
            "id": "39915831459901",
            "gid": "gid://shopify/ProductVariant/39915831459901",
            "sku": "KIT(8oz)+13xTWPS-60R-411-X00",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-red-grips?variant=39915831459901"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pride",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-wrap-2g-white",
    "brand": "Golf Pride",
    "model": "Tour Wrap 2G White",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 153.37,
    "price_max": 153.37,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 11.8,
    "bundle_price_min": null,
    "kit_price_min": 153.37,
    "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-white-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/g4l-grip-kits-tw-2g-std-wht.jpg?v=1751587615",
    "fit_tags": [
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 153.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-white-grips",
        "handle": "grip-kit-13x-golf-pride-tour-wrap-2g-standard-white-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915831263293",
            "gid": "gid://shopify/ProductVariant/39915831263293",
            "sku": "KIT+13xTWPS-60R-050-X11",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 153.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-white-grips?variant=39915831263293"
          },
          {
            "id": "39915831296061",
            "gid": "gid://shopify/ProductVariant/39915831296061",
            "sku": "KIT(8oz)+13xTWPS-60R-050-X11",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156.09,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-tour-wrap-2g-standard-white-grips?variant=39915831296061"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, golf pride gift card promo, Golf Pride",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-wrap-microsuede",
    "brand": "Golf Pride",
    "model": "Tour Wrap MICROSUEDE",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (microsuede)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Grey",
      "Midsize / Grey",
      "Standard / Grey"
    ],
    "weight_g_by_size": {
      "Standard": 71.9,
      "Midsize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 6.99,
    "price_max": 110.85,
    "single_price_min": 6.99,
    "single_price_max": 7.49,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": null,
    "kit_price_min": 104.35,
    "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2020-gp-kits-tour-wrap-microsuede_3bf30598-c598-4c09-9302-cd16ea3b32ca.jpg?v=1751587535",
    "fit_tags": [
      "best_for_arthritis",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Grey"
        ],
        "price": 104.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-standard-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-wrap-microsuede-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Standard / Grey"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828969533",
            "gid": "gid://shopify/ProductVariant/39915828969533",
            "sku": "KIT+13xTWFS-60R-F7G-X00",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Grey",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 104.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-standard-grip-13pcs-golf-grip-kit?variant=39915828969533"
          },
          {
            "id": "39915829002301",
            "gid": "gid://shopify/ProductVariant/39915829002301",
            "sku": "KIT(8oz)+13xTWFS-60R-F7G-X00",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Grey",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 109.65,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-standard-grip-13pcs-golf-grip-kit?variant=39915829002301"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Midsize / Grey"
        ],
        "price": 110.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-midsize-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-tour-wrap-microsuede-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Midsize / Grey"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915829035069",
            "gid": "gid://shopify/ProductVariant/39915829035069",
            "sku": "KIT+13xTWFM-60R-F7G-X00",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Grey",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 110.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-midsize-grip-13pcs-golf-grip-kit?variant=39915829035069"
          },
          {
            "id": "39915829067837",
            "gid": "gid://shopify/ProductVariant/39915829067837",
            "sku": "KIT(8oz)+13xTWFM-60R-F7G-X00",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Grey",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 116.15,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-midsize-grip-13pcs-golf-grip-kit?variant=39915829067837"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 7.49,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-midsize-grip",
        "handle": "golf-pride-tour-wrap-microsuede-midsize-grip",
        "shopify_variants": [
          {
            "id": "29478676234301",
            "gid": "gid://shopify/ProductVariant/29478676234301",
            "sku": "TWFM-60R-F7G-X00",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 7.49,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-midsize-grip?variant=29478676234301"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 6.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-standard-grip",
        "handle": "golf-pride-tour-wrap-microsuede-standard-grip",
        "shopify_variants": [
          {
            "id": "29478676201533",
            "gid": "gid://shopify/ProductVariant/29478676201533",
            "sku": "TWFS-60R-F7G-X00",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 6.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-microsuede-standard-grip?variant=29478676201533"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2025-black-friday, 2025-winter-sale-no-fuj, All products, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, Golf Pride Grip Kits, golf-pride, gp-gift-2025, grip kit, grip kits, grip sets, iron/wood, labor-day-bundle-sale-2025,",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-v55-non-cord",
    "brand": "Golf Pride",
    "model": "V55 (Non-Cord)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/blog/full-cord-grips-what-are-they-and-why-play-them.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.99,
    "price_max": 142.87,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 10.99,
    "bundle_price_min": 142.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-v55-non-cord-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/v55single-900_33df5b68-1325-4d09-af5a-f5eb00f9ae35.jpg?v=1761759705",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 142.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-v55-non-cord-standard-grip",
        "handle": "13pc-bundle-golf-pride-v55-non-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "60791451877746",
            "gid": "gid://shopify/ProductVariant/60791451877746",
            "sku": "SET-13xVFF -58R-19 -X99",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 142.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-v55-non-cord-standard-grip?variant=60791451877746"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-v55-non-cord-standard-grip",
        "handle": "golf-pride-v55-non-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "51896868897138",
            "gid": "gid://shopify/ProductVariant/51896868897138",
            "sku": "VFF -58R-19 -X99",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-v55-non-cord-standard-grip?variant=51896868897138"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "13pc bundle, 13pc golf pride, All Products, all-weather, cord, cord-golf-grips, firm, full cord, golf pride bundle, Golf Pride Cord Grips, golf pride single grip, golf pride v55, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, single-golf-grips, Size_Standard, standard, standard-size-golf-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-v55-cord",
    "brand": "Golf Pride",
    "model": "V55 Cord",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/blog/full-cord-grips-what-are-they-and-why-play-them.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "8pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14.99,
    "price_max": 194.87,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 14.99,
    "bundle_price_min": 119.92,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-v55-cord-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/golfpride-v55-2_a3df90ff-8c39-477b-85aa-15bdc0ee940b.jpg?v=1761759713",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 119.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-v55-cord-standard-grip",
        "handle": "8pc-bundle-golf-pride-v55-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "61638735495538",
            "gid": "gid://shopify/ProductVariant/61638735495538",
            "sku": "SET-8xVIC -58R-12 -X99",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 119.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-v55-cord-standard-grip?variant=61638735495538"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 194.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-v55-cord-standard-grip",
        "handle": "13pc-bundle-golf-pride-v55-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "60791452107122",
            "gid": "gid://shopify/ProductVariant/60791452107122",
            "sku": "SET-13xVIC -58R-12 -X99",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-v55-cord-standard-grip?variant=60791452107122"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 14.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-v55-cord-standard-grip",
        "handle": "golf-pride-v55-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "51790333673842",
            "gid": "gid://shopify/ProductVariant/51790333673842",
            "sku": "VIC -58R-12 -X99",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-v55-cord-standard-grip?variant=51790333673842"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, all-weather, cord, cord-golf-grips, firm, full cord, golf pride bundle, Golf Pride Cord Grips, golf pride single grip, golf pride v55, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, single-golf-grips, Size_Standard, standard, standard-size-golf-gr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-vdr",
    "brand": "Golf Pride",
    "model": "VDR",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (vibration-dampening)",
    "texture": "textured",
    "feel": "soft",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "high",
    "vibration_dampening": "high",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black",
      "Midsize / Black",
      "Standard / Black",
      "Undersize / Black"
    ],
    "weight_g_by_size": {
      "Standard": 71.9,
      "Undersize": 71.9,
      "Midsize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 7.49,
    "price_max": 117.35,
    "single_price_min": 7.49,
    "single_price_max": 7.99,
    "normalized_price_per_grip": 7.49,
    "bundle_price_min": null,
    "kit_price_min": 110.85,
    "url": "https://www.grips4less.com/products/golf-pride-midsize-vdr",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2020-gp-kits-vdr_378542d8-0098-4ff2-ae96-3f2daea2e5c6.jpg?v=1751587509",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "soft_feel"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Black"
        ],
        "price": 110.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-mens-vdr-black-13pcs-golf-grip-kit",
        "handle": "golf-pride-mens-vdr-black-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Standard / Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828117565",
            "gid": "gid://shopify/ProductVariant/39915828117565",
            "sku": "KIT+13xVDRS-60R-U24-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 110.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-vdr-black-13pcs-golf-grip-kit?variant=39915828117565"
          },
          {
            "id": "39915828150333",
            "gid": "gid://shopify/ProductVariant/39915828150333",
            "sku": "KIT(8oz)+13xVDRS-60R-U24-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 116.05,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-mens-vdr-black-13pcs-golf-grip-kit?variant=39915828150333"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Undersize / Black"
        ],
        "price": 110.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-undersize-vdr-13pcs-golf-grip-kit",
        "handle": "golf-pride-undersize-vdr-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Undersize / Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828248637",
            "gid": "gid://shopify/ProductVariant/39915828248637",
            "sku": "KIT+13xVDRU-58R-U24-X00",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Size and Color": "Undersize / Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 110.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-vdr-13pcs-golf-grip-kit?variant=39915828248637"
          },
          {
            "id": "39915828281405",
            "gid": "gid://shopify/ProductVariant/39915828281405",
            "sku": "KIT(8oz)+13xVDRU-58R-U24-X00",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Size and Color": "Undersize / Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 116.05,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-vdr-13pcs-golf-grip-kit?variant=39915828281405"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Midsize / Black"
        ],
        "price": 117.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-vdr-13pcs-golf-grip-kit",
        "handle": "golf-pride-midsize-vdr-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Midsize / Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828314173",
            "gid": "gid://shopify/ProductVariant/39915828314173",
            "sku": "KIT+13xVDRM-60R-U26-X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 117.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-vdr-13pcs-golf-grip-kit?variant=39915828314173"
          },
          {
            "id": "39915828346941",
            "gid": "gid://shopify/ProductVariant/39915828346941",
            "sku": "KIT(8oz)+13xVDRM-60R-U26-X00",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 122.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-vdr-13pcs-golf-grip-kit?variant=39915828346941"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 7.99,
        "per_grip_g": 59,
        "total_g": 58.9670081,
        "url": "https://www.grips4less.com/products/golf-pride-midsize-vdr",
        "handle": "golf-pride-midsize-vdr",
        "shopify_variants": [
          {
            "id": "13011620495421",
            "gid": "gid://shopify/ProductVariant/13011620495421",
            "sku": "VDRM-60R-U26-X00",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 7.99,
            "weight_g": 59,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-midsize-vdr?variant=13011620495421"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 7.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-undersize-vdr",
        "handle": "golf-pride-undersize-vdr",
        "shopify_variants": [
          {
            "id": "13011619643453",
            "gid": "gid://shopify/ProductVariant/13011619643453",
            "sku": "VDRU-58R-U24-X00",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 7.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-undersize-vdr?variant=13011619643453"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 7.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-mens-vdr-black",
        "handle": "golf-pride-mens-vdr-black",
        "shopify_variants": [
          {
            "id": "116723882",
            "gid": "gid://shopify/ProductVariant/116723882",
            "sku": "VDRS-60R-U24-X00",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 7.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-mens-vdr-black?variant=116723882"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, Golf Pride Grip Kits, Golf Pride VDR, golf-pride, gp-gift-2025, grip kit, grip kits, grip se",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "VDR = vibration dampening; comfort/joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-victory",
    "brand": "Golf Pride",
    "model": "Victory",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.28,
    "price_max": 6.28,
    "single_price_min": 6.28,
    "single_price_max": 6.28,
    "normalized_price_per_grip": 6.28,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/limited-edition-golf-pride-victory-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/v55.jpg?v=1636059144",
    "fit_tags": [
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 6.28,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/limited-edition-golf-pride-victory-grip",
        "handle": "limited-edition-golf-pride-victory-grip",
        "shopify_variants": [
          {
            "id": "39461766955069",
            "gid": "gid://shopify/ProductVariant/39461766955069",
            "sku": "MVMS-60R-19E-XA",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Victory"
            },
            "available": true,
            "price": 6.28,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-golf-pride-victory-grip?variant=39461766955069"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Victory"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "49 under, All products, Brand_Golf Pride, golf pride single grip, golf-pride, iron/wood, rubber, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150, victory",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-victory-green",
    "brand": "Golf Pride",
    "model": "Victory Green",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 4.04,
    "price_max": 4.04,
    "single_price_min": 4.04,
    "single_price_max": 4.04,
    "normalized_price_per_grip": 4.04,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-victory-green-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/victory-green_202e0868-277a-47eb-a769-fc85633c526e.jpg?v=1735455956",
    "fit_tags": [
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 4.04,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/golf-pride-victory-green-grip",
        "handle": "golf-pride-victory-green-grip",
        "shopify_variants": [
          {
            "id": "39461786681405",
            "gid": "gid://shopify/ProductVariant/39461786681405",
            "sku": "MVM-58R10-3",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Green"
            },
            "available": true,
            "price": 4.04,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-victory-green-grip?variant=39461786681405"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Green"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2023-sale, 49 under, All products, bf-nonassembled, Brand_Golf Pride, golf pride single grip, golf-pride, iron/wood, mem25, prime-2025, rubber, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150, veterans-sale-2023, victory",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-z-cord",
    "brand": "Golf Pride",
    "model": "Z-Cord",
    "type": "club",
    "spec_confidence": "derived",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 181.28,
    "price_max": 181.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.94,
    "bundle_price_min": null,
    "kit_price_min": 181.28,
    "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-z-cord-midsize-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-z-cord_da23f999-a0cb-43c1-9d50-59e6c4bd7913.jpg?v=1751587583",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-z-cord-midsize-grips",
        "handle": "grip-kit-13x-golf-pride-z-cord-midsize-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830149181",
            "gid": "gid://shopify/ProductVariant/39915830149181",
            "sku": "KIT+13xGRMC-60R-C11-0",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-z-cord-midsize-grips?variant=39915830149181"
          },
          {
            "id": "39915830181949",
            "gid": "gid://shopify/ProductVariant/39915830181949",
            "sku": "KIT(8oz)+13xGRMC-60R-C11-0",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-z-cord-midsize-grips?variant=39915830181949"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 181.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-z-cord-standard-grips",
        "handle": "grip-kit-13x-golf-pride-z-cord-standard-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915830214717",
            "gid": "gid://shopify/ProductVariant/39915830214717",
            "sku": "KIT+13xGRSC-60R-C10-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-z-cord-standard-grips?variant=39915830214717"
          },
          {
            "id": "39915830247485",
            "gid": "gid://shopify/ProductVariant/39915830247485",
            "sku": "KIT(8oz)+13xGRSC-60R-C10-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 184.49,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-golf-pride-z-cord-standard-grips?variant=39915830247485"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc golf pride, 150-200, 2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, cord, cord-golf-grips, firm, free-rog-momentum-glove, full cord, golf pride b",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-z-grip-align-max",
    "brand": "Golf Pride",
    "model": "Z-GRIP ALIGN MAX",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "ALIGN ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ALIGN",
    "alignment_description": "Raised ridge along the underside designed to promote consistent hand placement.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 71.4,
      "Standard": 71.4
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 127.92,
    "price_max": 222.86,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": 127.92,
    "kit_price_min": 207.87,
    "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-midsize-grip-8-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/zgrip-align-max-900.jpg?v=1772240200",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 8,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 127.92,
        "per_grip_g": 71.4,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-midsize-grip-8-grip-bundle-set",
        "handle": "golf-pride-z-grip-align-max-midsize-grip-8-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "61638695190898",
            "gid": "gid://shopify/ProductVariant/61638695190898",
            "sku": "SET-8xGRZM-60R-C05-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 127.92,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-midsize-grip-8-grip-bundle-set?variant=61638695190898"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 127.92,
        "per_grip_g": 71.4,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-standard-grip-8pc-grip-bundle-set",
        "handle": "golf-pride-z-grip-align-max-standard-grip-8pc-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "61638694928754",
            "gid": "gid://shopify/ProductVariant/61638694928754",
            "sku": "SET-8xGRZS-60R-C04-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 127.92,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-standard-grip-8pc-grip-bundle-set?variant=61638694928754"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 222.86,
        "per_grip_g": 44,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-standard-grip-13pcs-4oz-golf-grip-kit",
        "handle": "golf-pride-z-grip-align-max-standard-grip-13pcs-4oz-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "61620465926514",
            "gid": "gid://shopify/ProductVariant/61620465926514",
            "sku": "KIT+13xGRZS-60R-C04-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 222.86,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-standard-grip-13pcs-4oz-golf-grip-kit?variant=61620465926514"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 207.87,
        "per_grip_g": 44,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-standard-grip-13pc-grip-bundle-set",
        "handle": "golf-pride-z-grip-align-max-standard-grip-13pc-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "61620465140082",
            "gid": "gid://shopify/ProductVariant/61620465140082",
            "sku": "SET-13xGRZS-60R-C04-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-standard-grip-13pc-grip-bundle-set?variant=61620465140082"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 222.86,
        "per_grip_g": 44,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-midsize-grip-13pcs-4oz-golf-grip-kit",
        "handle": "golf-pride-z-grip-align-max-midsize-grip-13pcs-4oz-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "61620429750642",
            "gid": "gid://shopify/ProductVariant/61620429750642",
            "sku": "KIT+13xGRZM-60R-C05-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 222.86,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-midsize-grip-13pcs-4oz-golf-grip-kit?variant=61620429750642"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 207.87,
        "per_grip_g": 44,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-midsize-grip-13-grip-bundle-set",
        "handle": "golf-pride-z-grip-align-max-midsize-grip-13-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "61620385448306",
            "gid": "gid://shopify/ProductVariant/61620385448306",
            "sku": "SET-13xGRZM-60R-C05-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-midsize-grip-13-grip-bundle-set?variant=61620385448306"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 159.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-midsize-grip-10pc-grip-bundle",
        "handle": "golf-pride-z-grip-align-max-midsize-grip-10pc-grip-bundle",
        "shopify_variants": [
          {
            "id": "61618775818610",
            "gid": "gid://shopify/ProductVariant/61618775818610",
            "sku": "SET-10xGRZM-60R-C05-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 159.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-midsize-grip-10pc-grip-bundle?variant=61618775818610"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 159.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-standard-grip-10pc-grip-bundle",
        "handle": "golf-pride-z-grip-align-max-standard-grip-10pc-grip-bundle",
        "shopify_variants": [
          {
            "id": "61618755273074",
            "gid": "gid://shopify/ProductVariant/61618755273074",
            "sku": "SET-10xGRZS-60R-C04-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 159.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-max-standard-grip-10pc-grip-bundle?variant=61618755273074"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, Alignment golf grip, alignment-golf-grips, All Products, all-weather, bundle, bundles-asbl-driver-only, firm, Golf Pride Align, Golf Pride Align MAX, golf pride bundle, Golf Pride Z-Grip, golf-grips, golf-pride, grip bundle, gripkit-shaftbundle-sale, midsize, midsize-golf",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-z-grip-align-cord",
    "brand": "Golf Pride",
    "model": "Z-Grip ALIGN Cord",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "ALIGN ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ALIGN",
    "alignment_description": "Raised ridge along the underside designed to promote consistent hand placement.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit",
      "8pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14.99,
    "price_max": 209.19,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 14.99,
    "bundle_price_min": 119.92,
    "kit_price_min": 208.35,
    "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/web-zgrip-align_front_5ccc4330-59ba-4f09-80aa-47d2bd9ff950.jpg?v=1761759819",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 10,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 119.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-z-grip-align-cord-midsize-grip",
        "handle": "8pc-bundle-golf-pride-z-grip-align-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638723109234",
            "gid": "gid://shopify/ProductVariant/61638723109234",
            "sku": "SET-8xGRXM-60X-C48-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 119.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-z-grip-align-cord-midsize-grip?variant=61638723109234"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 119.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-z-grip-align-cord-standard-grip",
        "handle": "8pc-bundle-golf-pride-z-grip-align-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "61638722683250",
            "gid": "gid://shopify/ProductVariant/61638722683250",
            "sku": "SET-8xGRXS-60X-C49-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 119.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-z-grip-align-cord-standard-grip?variant=61638722683250"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 194.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-z-grip-align-cord-standard-grip",
        "handle": "13pc-bundle-golf-pride-z-grip-align-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "60791457939826",
            "gid": "gid://shopify/ProductVariant/60791457939826",
            "sku": "SET-13xGRXS-60X-C49-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-z-grip-align-cord-standard-grip?variant=60791457939826"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 194.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-z-grip-align-cord-midsize-grip",
        "handle": "13pc-bundle-golf-pride-z-grip-align-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791457907058",
            "gid": "gid://shopify/ProductVariant/60791457907058",
            "sku": "SET-13xGRXM-60X-C48-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-z-grip-align-cord-midsize-grip?variant=60791457907058"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 149.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-standard-grip-grip-bundle-set",
        "handle": "golf-pride-z-grip-align-cord-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021964189757",
            "gid": "gid://shopify/ProductVariant/41021964189757",
            "sku": "SET-10xGRXS-60X-C49-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 149.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-standard-grip-grip-bundle-set?variant=41021964189757"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 149.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-z-grip-align-cord-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021964124221",
            "gid": "gid://shopify/ProductVariant/41021964124221",
            "sku": "SET-10xGRXM-60X-C48-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 149.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-midsize-grip-grip-bundle-set?variant=41021964124221"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 208.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-standard-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-z-grip-align-cord-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828838461",
            "gid": "gid://shopify/ProductVariant/39915828838461",
            "sku": "KIT+13xGRXS-60X-C49-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 208.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-standard-grip-13pcs-golf-grip-kit?variant=39915828838461"
          },
          {
            "id": "39915828871229",
            "gid": "gid://shopify/ProductVariant/39915828871229",
            "sku": "KIT(8oz)+13xGRXS-60X-C49-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 213.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-standard-grip-13pcs-golf-grip-kit?variant=39915828871229"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 209.19,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-midsize-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-z-grip-align-cord-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828903997",
            "gid": "gid://shopify/ProductVariant/39915828903997",
            "sku": "KIT+13xGRXM-60X-C48-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 209.19,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-midsize-grip-13pcs-golf-grip-kit?variant=39915828903997"
          },
          {
            "id": "39915828936765",
            "gid": "gid://shopify/ProductVariant/39915828936765",
            "sku": "KIT(8oz)+13xGRXM-60X-C48-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 212.9,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-midsize-grip-13pcs-golf-grip-kit?variant=39915828936765"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 14.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-midsize-grip",
        "handle": "golf-pride-z-grip-align-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683340726333",
            "gid": "gid://shopify/ProductVariant/40683340726333",
            "sku": "GRXM-60X-C48-XA",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-midsize-grip?variant=40683340726333"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 14.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-standard-grip",
        "handle": "golf-pride-z-grip-align-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "40683340759101",
            "gid": "gid://shopify/ProductVariant/40683340759101",
            "sku": "GRXS-60X-C49-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-align-cord-standard-grip?variant=40683340759101"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, Alignment golf grip, alignment-golf-grips, All Products, all-weather, cord, cord-golf-grips, firm, full cord, Golf Pride Align, golf pride bundle, Golf Pride Cord Grips, golf pride single grip, Golf Pride Z-Grip, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, m",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-z-grip-cord",
    "brand": "Golf Pride",
    "model": "Z-Grip Cord",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/blog/full-cord-grips-what-are-they-and-why-play-them.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "8pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 12.99,
    "price_max": 168.87,
    "single_price_min": 12.99,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 12.99,
    "bundle_price_min": 103.92,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-z-grip-cord-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/gp-zgrip-cord_4dd5d2b5-fc65-4cbc-b690-424dafad5582.jpg?v=1761759923",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 8,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-z-grip-cord-midsize-grip",
        "handle": "8pc-bundle-golf-pride-z-grip-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "61638713508210",
            "gid": "gid://shopify/ProductVariant/61638713508210",
            "sku": "SET-8xGRMC-60R-C11-0",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-z-grip-cord-midsize-grip?variant=61638713508210"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "8pc bundle",
        "colors": [],
        "price": 103.92,
        "per_grip_g": 7.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-z-grip-cord",
        "handle": "8pc-bundle-golf-pride-z-grip-cord",
        "shopify_variants": [
          {
            "id": "61638708822386",
            "gid": "gid://shopify/ProductVariant/61638708822386",
            "sku": "SET-8xGRSC-60R-C10-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.92,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/8pc-bundle-golf-pride-z-grip-cord?variant=61638708822386"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-z-grip-cord",
        "handle": "13pc-bundle-golf-pride-z-grip-cord",
        "shopify_variants": [
          {
            "id": "60791466656114",
            "gid": "gid://shopify/ProductVariant/60791466656114",
            "sku": "SET-13xGRSC-60R-C10-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-z-grip-cord?variant=60791466656114"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [],
        "price": 168.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-z-grip-cord-midsize-grip",
        "handle": "13pc-bundle-golf-pride-z-grip-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "60791465673074",
            "gid": "gid://shopify/ProductVariant/60791465673074",
            "sku": "SET-13xGRMC-60R-C11-0",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 168.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/13pc-bundle-golf-pride-z-grip-cord-midsize-grip?variant=60791465673074"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-cord-grip-bundle-set",
        "handle": "golf-pride-z-grip-cord-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021975232573",
            "gid": "gid://shopify/ProductVariant/41021975232573",
            "sku": "SET-10xGRSC-60R-C10-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-cord-grip-bundle-set?variant=41021975232573"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [],
        "price": 129.9,
        "per_grip_g": 57.2,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-cord-midsize-grip-grip-bundle-set",
        "handle": "golf-pride-z-grip-cord-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021969399869",
            "gid": "gid://shopify/ProductVariant/41021969399869",
            "sku": "SET-10xGRMC-60R-C11-0",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.9,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-cord-midsize-grip-grip-bundle-set?variant=41021969399869"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-cord-midsize-grip",
        "handle": "golf-pride-z-grip-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683340791869",
            "gid": "gid://shopify/ProductVariant/40683340791869",
            "sku": "GRMC-60R-C11-0",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-cord-midsize-grip?variant=40683340791869"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-cord",
        "handle": "golf-pride-z-grip-cord",
        "shopify_variants": [
          {
            "id": "40683340824637",
            "gid": "gid://shopify/ProductVariant/40683340824637",
            "sku": "GRSC-60R-C10-XA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-cord?variant=40683340824637"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "8pc bundle, 8pc golf pride, All Products, all-weather, cord, cord-golf-grips, firm, full cord, golf pride bundle, Golf Pride Cord Grips, golf pride single grip, Golf Pride Z-Grip, golf-grips, golf-pride, grip bundle, grip kit, iron/wood, midsize, midsize-golf-grips, single-golf-grips, under-150, und",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-z-grip-patriot",
    "brand": "Golf Pride",
    "model": "Z-Grip Patriot",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
      "https://www.golfpride.com/us/en-us/blog/full-cord-grips-what-are-they-and-why-play-them.html"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.49,
    "price_max": 138.04,
    "single_price_min": 9.49,
    "single_price_max": 9.49,
    "normalized_price_per_grip": 9.49,
    "bundle_price_min": null,
    "kit_price_min": 138.04,
    "url": "https://www.grips4less.com/products/golf-pride-z-grip-patriot-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2020-gp-kits-z-grip-patriot.jpg?v=1751587517",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 138.04,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-patriot-grip-13pcs-golf-grip-kit",
        "handle": "golf-pride-z-grip-patriot-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39915828445245",
            "gid": "gid://shopify/ProductVariant/39915828445245",
            "sku": "KIT+13xGRSS-60R-221-040",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 138.04,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-patriot-grip-13pcs-golf-grip-kit?variant=39915828445245"
          },
          {
            "id": "39915828478013",
            "gid": "gid://shopify/ProductVariant/39915828478013",
            "sku": "KIT(8oz)+13xGRSS-60R-221-040",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 141.24,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-patriot-grip-13pcs-golf-grip-kit?variant=39915828478013"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-z-grip-patriot-grip",
        "handle": "golf-pride-z-grip-patriot-grip",
        "shopify_variants": [
          {
            "id": "278000228",
            "gid": "gid://shopify/ProductVariant/278000228",
            "sku": "GRSS-60R-221-040",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 9.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-z-grip-patriot-grip?variant=278000228"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf pride bundle, Golf Pride Grip Kits, Golf Pride Z-Grip, golf-pride, gp-gift-2025, grip kit, grip kits, grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-black-armor-2-sticky-evolution-1-8",
    "brand": "Iomic",
    "model": "\"Black Armor 2\" Sticky Evolution 1.8",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black Body / Coral Red Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.87,
    "price_max": 147.05,
    "single_price_min": 10.87,
    "single_price_max": 10.87,
    "normalized_price_per_grip": 10.33,
    "bundle_price_min": 92.94,
    "kit_price_min": 147.05,
    "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/b2-sticky-evo-18-red.jpg?v=1766011165",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black Body / Coral Red Cap"
        ],
        "price": 141.31,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip-bundle-13pcs",
        "handle": "iomic-black-armor-2-sticky-evolution-1-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398916989298",
            "gid": "gid://shopify/ProductVariant/61398916989298",
            "sku": "SET-13xGRISE2B18BRD",
            "color": "Black Body / Coral Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Body / Coral Red Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 141.31,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip-bundle-13pcs?variant=61398916989298"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Body / Coral Red Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black Body / Coral Red Cap"
        ],
        "price": 92.94,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip-grip-bundle-set",
        "handle": "iomic-black-armor-2-sticky-evolution-1-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960060989",
            "gid": "gid://shopify/ProductVariant/41021960060989",
            "sku": "SET-9xGRISE2B18BRD",
            "color": "Black Body / Coral Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Body / Coral Red Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 92.94,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip-grip-bundle-set?variant=41021960060989"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Body / Coral Red Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black Body / Coral Red Cap"
        ],
        "price": 147.05,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip-13pcs-golf-grip-kit",
        "handle": "iomic-black-armor-2-sticky-evolution-1-8-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Body / Coral Red Cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007839776829",
            "gid": "gid://shopify/ProductVariant/32007839776829",
            "sku": "KIT+13xGRISE2B18BRD",
            "color": "Black Body / Coral Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Body / Coral Red Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 147.05,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip-13pcs-golf-grip-kit?variant=32007839776829"
          },
          {
            "id": "40215660331069",
            "gid": "gid://shopify/ProductVariant/40215660331069",
            "sku": "KIT(8oz)+13xGRISE2B18BRD",
            "color": "Black Body / Coral Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Body / Coral Red Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 151.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip-13pcs-golf-grip-kit?variant=40215660331069"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black Body / Coral Red Cap"
        ],
        "price": 10.87,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip",
        "handle": "iomic-black-armor-2-sticky-evolution-1-8-grip",
        "shopify_variants": [
          {
            "id": "31881589063741",
            "gid": "gid://shopify/ProductVariant/31881589063741",
            "sku": "GRISE2B18BRD",
            "color": "Black Body / Coral Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Body / Coral Red Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 10.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-8-grip?variant=31881589063741"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Body / Coral Red Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, black armor, black armor 2, golf-grips, grip bundle, iomic, iron/wood, medium firm, new-add-12172025, single-golf-grips, single-grip, standard, standard-size-golf-grips, sticky evolution, tacky, under-150, under-300, uv resistant, uv-resistant-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black Body / Coral Red Cap"
    ]
  },
  {
    "id": "iomic-black-armor-2-sticky-evolution-2-3",
    "brand": "Iomic",
    "model": "\"Black Armor 2\" Sticky Evolution 2.3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black Body / Blue Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.87,
    "price_max": 147.05,
    "single_price_min": 10.87,
    "single_price_max": 10.87,
    "normalized_price_per_grip": 10.33,
    "bundle_price_min": 92.94,
    "kit_price_min": 147.05,
    "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/b2-sticky-evo-23-blue.jpg?v=1766011159",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black Body / Blue Cap"
        ],
        "price": 141.31,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip-bundle-13pcs",
        "handle": "iomic-black-armor-2-sticky-evolution-2-3-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398916956530",
            "gid": "gid://shopify/ProductVariant/61398916956530",
            "sku": "SET-13xGRISE2B23BBL",
            "color": "Black Body / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Body / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 141.31,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip-bundle-13pcs?variant=61398916956530"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Body / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black Body / Blue Cap"
        ],
        "price": 92.94,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip-grip-bundle-set",
        "handle": "iomic-black-armor-2-sticky-evolution-2-3-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021959962685",
            "gid": "gid://shopify/ProductVariant/41021959962685",
            "sku": "SET-9xGRISE2B23BBL",
            "color": "Black Body / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Body / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 92.94,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip-grip-bundle-set?variant=41021959962685"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Body / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black Body / Blue Cap"
        ],
        "price": 147.05,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip-13pcs-golf-grip-kit",
        "handle": "iomic-black-armor-2-sticky-evolution-2-3-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Body / Blue Cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007839744061",
            "gid": "gid://shopify/ProductVariant/32007839744061",
            "sku": "KIT+13xGRISE2B23BBL",
            "color": "Black Body / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Body / Blue Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 147.05,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip-13pcs-golf-grip-kit?variant=32007839744061"
          },
          {
            "id": "40215665410109",
            "gid": "gid://shopify/ProductVariant/40215665410109",
            "sku": "KIT(8oz)+13xGRISE2B23BBL",
            "color": "Black Body / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Body / Blue Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 151.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip-13pcs-golf-grip-kit?variant=40215665410109"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black Body / Blue Cap"
        ],
        "price": 10.87,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip",
        "handle": "iomic-black-armor-2-sticky-evolution-2-3-grip",
        "shopify_variants": [
          {
            "id": "31881638117437",
            "gid": "gid://shopify/ProductVariant/31881638117437",
            "sku": "GRISE2B23BBL",
            "color": "Black Body / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Body / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-2-3-grip?variant=31881638117437"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Body / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, black armor, black armor 2, golf-grips, grip bundle, iomic, iron/wood, medium firm, new-add-12172025, overstock-oct-2023, single-golf-grips, single-grip, standard, standard-size-golf-grips, sticky evolution, tacky, under-150, under-300, uv resistant, uv-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black Body / Blue Cap"
    ]
  },
  {
    "id": "iomic-black-armor-2-x-evolution-2-3",
    "brand": "Iomic",
    "model": "\"Black Armor 2\" X-Evolution 2.3",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black Grip / Blue Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.87,
    "price_max": 147.05,
    "single_price_min": 10.87,
    "single_price_max": 10.87,
    "normalized_price_per_grip": 10.33,
    "bundle_price_min": 92.94,
    "kit_price_min": 147.05,
    "url": "https://www.grips4less.com/products/iomic-black-armor-2-x-evolution-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/b2-x-evo-23-blue.jpg?v=1766011154",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black Grip / Blue Cap"
        ],
        "price": 141.31,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-x-evolution-2-3-grip-bundle-13pcs",
        "handle": "iomic-black-armor-2-x-evolution-2-3-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398916923762",
            "gid": "gid://shopify/ProductVariant/61398916923762",
            "sku": "SET-13xGRIS2XE23BBL",
            "color": "Black Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 141.31,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-x-evolution-2-3-grip-bundle-13pcs?variant=61398916923762"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black Grip / Blue Cap"
        ],
        "price": 92.94,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-x-evolution-2-3-grip-grip-bundle-set",
        "handle": "iomic-black-armor-2-x-evolution-2-3-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021959864381",
            "gid": "gid://shopify/ProductVariant/41021959864381",
            "sku": "SET-9xGRIS2XE23BBL",
            "color": "Black Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 92.94,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-x-evolution-2-3-grip-grip-bundle-set?variant=41021959864381"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black Grip / Blue Cap"
        ],
        "price": 147.05,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-x-evolution-2-3-grip-13pcs-golf-grip-kit",
        "handle": "iomic-black-armor-2-x-evolution-2-3-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007839711293",
            "gid": "gid://shopify/ProductVariant/32007839711293",
            "sku": "KIT+13xGRIS2XE23BBL",
            "color": "Black Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 147.05,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-x-evolution-2-3-grip-13pcs-golf-grip-kit?variant=32007839711293"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black Grip / Blue Cap"
        ],
        "price": 10.87,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-x-evolution-2-3-grip",
        "handle": "iomic-black-armor-2-x-evolution-2-3-grip",
        "shopify_variants": [
          {
            "id": "31881640280125",
            "gid": "gid://shopify/ProductVariant/31881640280125",
            "sku": "GRIS2XE23BBL",
            "color": "Black Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-x-evolution-2-3-grip?variant=31881640280125"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, black armor, black armor 2, golf-grips, grip bundle, iomic, iron/wood, medium firm, new-add-12172025, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, uv resistant, uv-resistant-golf-grips, video=qq1CToDcULM, x-ev",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black Grip / Blue Cap"
    ]
  },
  {
    "id": "iomic-new-iomic-ix-2-3",
    "brand": "Iomic",
    "model": "(NEW) Iomic iX 2.3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.75,
    "price_max": 178.75,
    "single_price_min": 13.75,
    "single_price_max": 13.75,
    "normalized_price_per_grip": 13.06,
    "bundle_price_min": 117.56,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-ix-23-colors.jpg?v=1766011172",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 178.75,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-bundle-13pcs",
        "handle": "new-iomic-ix-2-3-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398917087602",
            "gid": "gid://shopify/ProductVariant/61398917087602",
            "sku": "SET-13xIX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 178.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-bundle-13pcs?variant=61398917087602"
          },
          {
            "id": "61398917120370",
            "gid": "gid://shopify/ProductVariant/61398917120370",
            "sku": "SET-13xIX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 178.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-bundle-13pcs?variant=61398917120370"
          },
          {
            "id": "61398917153138",
            "gid": "gid://shopify/ProductVariant/61398917153138",
            "sku": "SET-13xIX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 178.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-bundle-13pcs?variant=61398917153138"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 117.56,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-grip-bundle-set",
        "handle": "new-iomic-ix-2-3-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021961732157",
            "gid": "gid://shopify/ProductVariant/41021961732157",
            "sku": "SET-9xIX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 117.56,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-grip-bundle-set?variant=41021961732157"
          },
          {
            "id": "41021961764925",
            "gid": "gid://shopify/ProductVariant/41021961764925",
            "sku": "SET-9xIX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 117.56,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-grip-bundle-set?variant=41021961764925"
          },
          {
            "id": "41021961797693",
            "gid": "gid://shopify/ProductVariant/41021961797693",
            "sku": "SET-9xIX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 117.56,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-grip-bundle-set?variant=41021961797693"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13.75,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip",
        "handle": "new-iomic-ix-2-3-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31464664203325",
            "gid": "gid://shopify/ProductVariant/31464664203325",
            "sku": "IX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip?variant=31464664203325"
          },
          {
            "id": "31464674721853",
            "gid": "gid://shopify/ProductVariant/31464674721853",
            "sku": "IX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip?variant=31464674721853"
          },
          {
            "id": "31464676196413",
            "gid": "gid://shopify/ProductVariant/31464676196413",
            "sku": "IX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip?variant=31464676196413"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, firm, golf-grips, grip bundle, iomic, IOMIC Ix, IOMIC LTC, iron/wood, ix 2.3, Low Torque (LTC), ltc, new-add-12172025, single-golf-grips, single-grip, tacky, under-150, under-300, uv resistant, uv-resistant-golf-grips, video=qq1CToDcULM",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red",
      "Blue"
    ]
  },
  {
    "id": "iomic-new-iomic-ix-sa-2-0",
    "brand": "Iomic",
    "model": "(NEW) Iomic iX SA 2.0",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14.78,
    "price_max": 192.14,
    "single_price_min": 14.78,
    "single_price_max": 14.78,
    "normalized_price_per_grip": 14.04,
    "bundle_price_min": 126.37,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-isa-23-allcolors.jpg?v=1766011128",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 192.14,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-bundle-13pcs",
        "handle": "new-iomic-ix-sa-2-3-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Platinum Grey",
              "Coral Red",
              "Light Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398916596082",
            "gid": "gid://shopify/ProductVariant/61398916596082",
            "sku": "SET-13xIXSA23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 192.14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-bundle-13pcs?variant=61398916596082"
          },
          {
            "id": "61398916628850",
            "gid": "gid://shopify/ProductVariant/61398916628850",
            "sku": "SET-13xIXSA23GY",
            "color": "Platinum Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 192.14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-bundle-13pcs?variant=61398916628850"
          },
          {
            "id": "61398916661618",
            "gid": "gid://shopify/ProductVariant/61398916661618",
            "sku": "SET-13xIXSA23RD",
            "color": "Coral Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Coral Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 192.14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-bundle-13pcs?variant=61398916661618"
          },
          {
            "id": "61398916694386",
            "gid": "gid://shopify/ProductVariant/61398916694386",
            "sku": "SET-13xIXSA23LBL",
            "color": "Light Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Light Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 192.14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-bundle-13pcs?variant=61398916694386"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 126.37,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-grip-bundle-set",
        "handle": "new-iomic-ix-sa-2-3-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Platinum Grey",
              "Coral Red",
              "Light Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021957177405",
            "gid": "gid://shopify/ProductVariant/41021957177405",
            "sku": "SET-9xIXSA23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 126.37,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-grip-bundle-set?variant=41021957177405"
          },
          {
            "id": "41021957210173",
            "gid": "gid://shopify/ProductVariant/41021957210173",
            "sku": "SET-9xIXSA23GY",
            "color": "Platinum Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 126.37,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-grip-bundle-set?variant=41021957210173"
          },
          {
            "id": "41021957242941",
            "gid": "gid://shopify/ProductVariant/41021957242941",
            "sku": "SET-9xIXSA23RD",
            "color": "Coral Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Coral Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 126.37,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-grip-bundle-set?variant=41021957242941"
          },
          {
            "id": "41021957275709",
            "gid": "gid://shopify/ProductVariant/41021957275709",
            "sku": "SET-9xIXSA23LBL",
            "color": "Light Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Light Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 126.37,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip-grip-bundle-set?variant=41021957275709"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 14.78,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip",
        "handle": "new-iomic-ix-sa-2-3-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Platinum Grey",
              "Coral Red",
              "Light Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39290699448381",
            "gid": "gid://shopify/ProductVariant/39290699448381",
            "sku": "IXSA23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.78,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip?variant=39290699448381"
          },
          {
            "id": "39290703970365",
            "gid": "gid://shopify/ProductVariant/39290703970365",
            "sku": "IXSA23GY",
            "color": "Platinum Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.78,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip?variant=39290703970365"
          },
          {
            "id": "39290699481149",
            "gid": "gid://shopify/ProductVariant/39290699481149",
            "sku": "IXSA23RD",
            "color": "Coral Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Coral Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.78,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip?variant=39290699481149"
          },
          {
            "id": "39290699513917",
            "gid": "gid://shopify/ProductVariant/39290699513917",
            "sku": "IXSA23LBL",
            "color": "Light Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Light Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.78,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-sa-2-3-grip?variant=39290699513917"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, firm, golf-grips, grip bundle, iomic, IOMIC Ix, IOMIC Ix SA, IOMIC LTC, iomic sa, iron/wood, ix sa 2.0, Low Torque (LTC), ltc, new-add-12172025, overstock-oct-2022, overstock-oct-2023, single-golf-grips, single-grip, tacky, under-150, under-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Coral Red",
      "Platinum Grey",
      "Light Blue"
    ]
  },
  {
    "id": "iomic-black-armor-2-sticky-evolution-1-5",
    "brand": "Iomic",
    "model": "Black Armor (2) Sticky Evolution 1.5",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Junior"
    ],
    "manufacturer_size_labels": [
      "Junior"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Black Grip / Blue Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 9.75,
    "price_max": 126.75,
    "single_price_min": 9.75,
    "single_price_max": 9.75,
    "normalized_price_per_grip": 9.75,
    "bundle_price_min": 126.75,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-5-junior-grip-black-blue",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/BA2_2BSticky_2BEvolution_2B2.3-1700_4c8dece0-b396-4db2-b44b-d5a0fc625495.jpg?v=1766010773",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Junior"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black Grip / Blue Cap"
        ],
        "price": 126.75,
        "per_grip_g": 1.5,
        "total_g": 20.003423517,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-5-junior-grip-black-blue-bundle-13pcs",
        "handle": "iomic-black-armor-2-sticky-evolution-1-5-junior-grip-black-blue-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398905520498",
            "gid": "gid://shopify/ProductVariant/61398905520498",
            "sku": "SET-13xGRISE2B15BBL",
            "color": "Black Grip / Blue Cap",
            "size": "Junior",
            "selected_options": {
              "Color": "Black Grip / Blue Cap",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 126.75,
            "weight_g": 18.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-5-junior-grip-black-blue-bundle-13pcs?variant=61398905520498"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "single",
        "colors": [
          "Black Grip / Blue Cap"
        ],
        "price": 9.75,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-5-junior-grip-black-blue",
        "handle": "iomic-black-armor-2-sticky-evolution-1-5-junior-grip-black-blue",
        "shopify_variants": [
          {
            "id": "60719369126258",
            "gid": "gid://shopify/ProductVariant/60719369126258",
            "sku": "GRISE2B15BBL",
            "color": "Black Grip / Blue Cap",
            "size": "Junior",
            "selected_options": {
              "Color": "Black Grip / Blue Cap",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 9.75,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-black-armor-2-sticky-evolution-1-5-junior-grip-black-blue?variant=60719369126258"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all weather, black armor, Brand_IOMIC, grip bundle, iomic, junior, junior-golf-grips, kids, lightweight, moisture resistant, new-add-12172025, single grip, single-golf-grips, Size_Junior, soft, sticky, sticky 1.5, sticky evolution, sticky evolution 1.5, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-moebius-black-1-8-ltc",
    "brand": "Iomic",
    "model": "Moebius Black 1.8 LTC",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Gold",
      "Red"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12.5,
    "price_max": 12.5,
    "single_price_min": 12.5,
    "single_price_max": 12.5,
    "normalized_price_per_grip": 12.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-moebius-black-1-8",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPT_Image_Jan_12_2026_12_15_54_PM.png?v=1768251855",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Gold"
        ],
        "price": 12.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-moebius-black-1-8",
        "handle": "iomic-moebius-black-1-8",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gold",
              "Coral Red",
              "Blue",
              "Mint Green",
              "Sky Blue",
              "Lemon Yellow"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61494681108850",
            "gid": "gid://shopify/ProductVariant/61494681108850",
            "sku": "MOBK1.8GD",
            "color": "Gold",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Gold"
            },
            "available": false,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-moebius-black-1-8?variant=61494681108850"
          },
          {
            "id": "61494681141618",
            "gid": "gid://shopify/ProductVariant/61494681141618",
            "sku": "MOBK1.8CR",
            "color": "Coral Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Coral Red"
            },
            "available": false,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-moebius-black-1-8?variant=61494681141618"
          },
          {
            "id": "61494681174386",
            "gid": "gid://shopify/ProductVariant/61494681174386",
            "sku": "MOBK1.8BU",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-moebius-black-1-8?variant=61494681174386"
          },
          {
            "id": "61494681207154",
            "gid": "gid://shopify/ProductVariant/61494681207154",
            "sku": "MOBK1.8MG",
            "color": "Mint Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Mint Green"
            },
            "available": false,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-moebius-black-1-8?variant=61494681207154"
          },
          {
            "id": "61494681239922",
            "gid": "gid://shopify/ProductVariant/61494681239922",
            "sku": "MOBK1.8SB",
            "color": "Sky Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Sky Blue"
            },
            "available": false,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-moebius-black-1-8?variant=61494681239922"
          },
          {
            "id": "61494681272690",
            "gid": "gid://shopify/ProductVariant/61494681272690",
            "sku": "MOBK1.8LY",
            "color": "Lemon Yellow",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Lemon Yellow"
            },
            "available": false,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-moebius-black-1-8?variant=61494681272690"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 12.5,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-moebius-standard-grip",
        "handle": "iomic-moebius-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1091147757",
            "gid": "gid://shopify/ProductVariant/1091147757",
            "sku": "GRIMORED",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-moebius-standard-grip?variant=1091147757"
          },
          {
            "id": "1091147749",
            "gid": "gid://shopify/ProductVariant/1091147749",
            "sku": "GRIMOWHT",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-moebius-standard-grip?variant=1091147749"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_IOMIC, firm, iomic, Iomic golf grips, Iomic grip, iron/wood, Model_IOMIC Moebius, moebius LTC, New for 2015, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, tacky, under-150, video=qq1CToDcULM",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-sticky",
    "brand": "Iomic",
    "model": "Sticky",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Oversize / Jumbo"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "Black / Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 17.25,
    "price_max": 225.84,
    "single_price_min": 17.25,
    "single_price_max": 17.25,
    "normalized_price_per_grip": 16.39,
    "bundle_price_min": 147.49,
    "kit_price_min": 225.84,
    "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-sticky-jumbo.jpg?v=1766011420",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Black"
        ],
        "price": 224.25,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-bundle-13pcs",
        "handle": "iomic-sticky-jumbo-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Black",
              "Sky Blue / Black",
              "Red / Black",
              "Navy Blue / Black"
            ]
          },
          {
            "name": "Iomic Sticky Jumbo Grip",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398924722546",
            "gid": "gid://shopify/ProductVariant/61398924722546",
            "sku": "SET-13xGRISJBLK",
            "color": "Black / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Black",
              "Iomic Sticky Jumbo Grip": "Oversize / Jumbo"
            },
            "available": true,
            "price": 224.25,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-bundle-13pcs?variant=61398924722546"
          },
          {
            "id": "61398924755314",
            "gid": "gid://shopify/ProductVariant/61398924755314",
            "sku": "SET-13xGRISJSKBL",
            "color": "Sky Blue / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Sky Blue / Black",
              "Iomic Sticky Jumbo Grip": "Oversize / Jumbo"
            },
            "available": true,
            "price": 224.25,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-bundle-13pcs?variant=61398924755314"
          },
          {
            "id": "61398924788082",
            "gid": "gid://shopify/ProductVariant/61398924788082",
            "sku": "SET-13xGRISJRED",
            "color": "Red / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / Black",
              "Iomic Sticky Jumbo Grip": "Oversize / Jumbo"
            },
            "available": true,
            "price": 224.25,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-bundle-13pcs?variant=61398924788082"
          },
          {
            "id": "61398924820850",
            "gid": "gid://shopify/ProductVariant/61398924820850",
            "sku": "SET-13xGRISJNVY",
            "color": "Navy Blue / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Navy Blue / Black",
              "Iomic Sticky Jumbo Grip": "Oversize / Jumbo"
            },
            "available": true,
            "price": 224.25,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-bundle-13pcs?variant=61398924820850"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Black"
        ],
        "price": 147.49,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-grip-bundle-set",
        "handle": "iomic-sticky-jumbo-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Black",
              "Sky Blue / Black",
              "Red / Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021972250685",
            "gid": "gid://shopify/ProductVariant/41021972250685",
            "sku": "SET-9xGRISJBLK",
            "color": "Black / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Black",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 147.49,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-grip-bundle-set?variant=41021972250685"
          },
          {
            "id": "41021972283453",
            "gid": "gid://shopify/ProductVariant/41021972283453",
            "sku": "SET-9xGRISJSKBL",
            "color": "Sky Blue / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Sky Blue / Black",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 147.49,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-grip-bundle-set?variant=41021972283453"
          },
          {
            "id": "41021972316221",
            "gid": "gid://shopify/ProductVariant/41021972316221",
            "sku": "SET-9xGRISJRED",
            "color": "Red / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / Black",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 147.49,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-grip-bundle-set?variant=41021972316221"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 225.84,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-13pcs-golf-grip-kit",
        "handle": "iomic-sticky-jumbo-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007848722493",
            "gid": "gid://shopify/ProductVariant/32007848722493",
            "sku": "KIT+13xGRISJBLK",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 225.84,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip-13pcs-golf-grip-kit?variant=32007848722493"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black / Black"
        ],
        "price": 17.25,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip",
        "handle": "iomic-sticky-jumbo-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Black",
              "Sky Blue / Black",
              "Red / Black",
              "Navy Blue / Black",
              "Blue / Black"
            ]
          },
          {
            "name": "Iomic Sticky Jumbo Grip",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "297250401",
            "gid": "gid://shopify/ProductVariant/297250401",
            "sku": "GRISJBLK",
            "color": "Black / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Black"
            },
            "available": true,
            "price": 17.25,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip?variant=297250401"
          },
          {
            "id": "39362062876733",
            "gid": "gid://shopify/ProductVariant/39362062876733",
            "sku": "GRISJSKBL",
            "color": "Sky Blue / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Sky Blue / Black"
            },
            "available": true,
            "price": 17.25,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip?variant=39362062876733"
          },
          {
            "id": "39913482551357",
            "gid": "gid://shopify/ProductVariant/39913482551357",
            "sku": "GRISJRED",
            "color": "Red / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / Black"
            },
            "available": true,
            "price": 17.25,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip?variant=39913482551357"
          },
          {
            "id": "60719258042738",
            "gid": "gid://shopify/ProductVariant/60719258042738",
            "sku": "GRISJNVY",
            "color": "Navy Blue / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Navy Blue / Black"
            },
            "available": true,
            "price": 17.25,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip?variant=60719258042738"
          },
          {
            "id": "61494822601074",
            "gid": "gid://shopify/ProductVariant/61494822601074",
            "sku": "GRISJBL",
            "color": "Blue / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue / Black"
            },
            "available": true,
            "price": 17.25,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-jumbo-grip?variant=61494822601074"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, golf-grips, grip bundle, iomic, iron/wood, jumbo/oversize, medium firm, new-add-12172025, oversize, oversize-jumbo-golf-grips, overstock-oct-2023, single-golf-grips, single-grip, sticky, tacky, under-150, under-300, uv resistant, uv-resistan",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Black",
      "Sky Blue / Black",
      "Red / Black",
      "Navy Blue / Black",
      "Blue / Black"
    ]
  },
  {
    "id": "iomic-sticky-1-0",
    "brand": "Iomic",
    "model": "Sticky 1.0",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Junior"
    ],
    "manufacturer_size_labels": [
      "Junior"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Orange",
      "Black / Org"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.5,
    "price_max": 136.5,
    "single_price_min": 10.5,
    "single_price_max": 10.5,
    "normalized_price_per_grip": 8.55,
    "bundle_price_min": 76.95,
    "kit_price_min": 111.61,
    "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-sticky-junior-blk-blue-green-yellow-orange-red-pink.jpg?v=1766011404",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Junior"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Orange"
        ],
        "price": 136.5,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-bundle-13pcs",
        "handle": "iomic-sticky-junior-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Orange",
              "Pink / White",
              "Red / White",
              "Blue / White",
              "Lemon Yellow / White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398924427634",
            "gid": "gid://shopify/ProductVariant/61398924427634",
            "sku": "SET-13xSJRBLK",
            "color": "Black / Orange",
            "size": "Junior",
            "selected_options": {
              "Color": "Black / Orange",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-bundle-13pcs?variant=61398924427634"
          },
          {
            "id": "61398924460402",
            "gid": "gid://shopify/ProductVariant/61398924460402",
            "sku": "SET-13xGRISJ0PW",
            "color": "Pink / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Pink / White",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-bundle-13pcs?variant=61398924460402"
          },
          {
            "id": "61398924493170",
            "gid": "gid://shopify/ProductVariant/61398924493170",
            "sku": "SET-13xSJRRED",
            "color": "Red / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Red / White",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-bundle-13pcs?variant=61398924493170"
          },
          {
            "id": "61398924525938",
            "gid": "gid://shopify/ProductVariant/61398924525938",
            "sku": "SET-13xGRISJ0BL",
            "color": "Blue / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Blue / White",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-bundle-13pcs?variant=61398924525938"
          },
          {
            "id": "61398924558706",
            "gid": "gid://shopify/ProductVariant/61398924558706",
            "sku": "SET-13xGRISJ0LY",
            "color": "Lemon Yellow / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Lemon Yellow / White",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-bundle-13pcs?variant=61398924558706"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Orange"
        ],
        "price": 76.95,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-grip-bundle-set",
        "handle": "iomic-sticky-junior-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Orange",
              "Pink / White",
              "Mint Green / White",
              "Red / White",
              "Blue / White",
              "Orange / White",
              "Lemon Yellow / White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021970251837",
            "gid": "gid://shopify/ProductVariant/41021970251837",
            "sku": "SET-9xSJRBLK",
            "color": "Black / Orange",
            "size": "Junior",
            "selected_options": {
              "Color": "Black / Orange",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 76.95,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-grip-bundle-set?variant=41021970251837"
          },
          {
            "id": "41021970284605",
            "gid": "gid://shopify/ProductVariant/41021970284605",
            "sku": "SET-9xGRISJ0PW",
            "color": "Pink / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Pink / White",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 76.95,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-grip-bundle-set?variant=41021970284605"
          },
          {
            "id": "41021970317373",
            "gid": "gid://shopify/ProductVariant/41021970317373",
            "sku": "SET-9xGRISJ0GW",
            "color": "Mint Green / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Mint Green / White",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 76.95,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-grip-bundle-set?variant=41021970317373"
          },
          {
            "id": "41021970350141",
            "gid": "gid://shopify/ProductVariant/41021970350141",
            "sku": "SET-9xSJRRED",
            "color": "Red / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Red / White",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 76.95,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-grip-bundle-set?variant=41021970350141"
          },
          {
            "id": "41021970382909",
            "gid": "gid://shopify/ProductVariant/41021970382909",
            "sku": "SET-9xGRISJ0BL",
            "color": "Blue / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Blue / White",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 76.95,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-grip-bundle-set?variant=41021970382909"
          },
          {
            "id": "41021970415677",
            "gid": "gid://shopify/ProductVariant/41021970415677",
            "sku": "SET-9xGRISJ0OR",
            "color": "Orange / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Orange / White",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 76.95,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-grip-bundle-set?variant=41021970415677"
          },
          {
            "id": "41021970448445",
            "gid": "gid://shopify/ProductVariant/41021970448445",
            "sku": "SET-9xGRISJ0LY",
            "color": "Lemon Yellow / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Lemon Yellow / White",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 76.95,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-grip-bundle-set?variant=41021970448445"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Org"
        ],
        "price": 111.61,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-13pcs-golf-grip-kit",
        "handle": "iomic-sticky-junior-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Org",
              "Mint Green / White",
              "Red / White",
              "Blue / White",
              "Orange / White",
              "Lemon Yellow / White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007847510077",
            "gid": "gid://shopify/ProductVariant/32007847510077",
            "sku": "KIT+13xSJRBLK",
            "color": "Black / Org",
            "size": "Junior",
            "selected_options": {
              "Color": "Black / Org"
            },
            "available": false,
            "price": 111.61,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-13pcs-golf-grip-kit?variant=32007847510077"
          },
          {
            "id": "32007847542845",
            "gid": "gid://shopify/ProductVariant/32007847542845",
            "sku": "KIT+13xGRISJ0GW",
            "color": "Mint Green / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Mint Green / White"
            },
            "available": false,
            "price": 111.61,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-13pcs-golf-grip-kit?variant=32007847542845"
          },
          {
            "id": "32007847575613",
            "gid": "gid://shopify/ProductVariant/32007847575613",
            "sku": "KIT+13xSJRRED",
            "color": "Red / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Red / White"
            },
            "available": true,
            "price": 111.61,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-13pcs-golf-grip-kit?variant=32007847575613"
          },
          {
            "id": "32007847608381",
            "gid": "gid://shopify/ProductVariant/32007847608381",
            "sku": "KIT+13xGRISJ0BL",
            "color": "Blue / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Blue / White"
            },
            "available": false,
            "price": 111.61,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-13pcs-golf-grip-kit?variant=32007847608381"
          },
          {
            "id": "32007847641149",
            "gid": "gid://shopify/ProductVariant/32007847641149",
            "sku": "KIT+13xGRISJ0OR",
            "color": "Orange / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Orange / White"
            },
            "available": false,
            "price": 111.61,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-13pcs-golf-grip-kit?variant=32007847641149"
          },
          {
            "id": "32007847673917",
            "gid": "gid://shopify/ProductVariant/32007847673917",
            "sku": "KIT+13xGRISJ0LY",
            "color": "Lemon Yellow / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Lemon Yellow / White"
            },
            "available": true,
            "price": 111.61,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip-13pcs-golf-grip-kit?variant=32007847673917"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "single",
        "colors": [
          "Black / Orange"
        ],
        "price": 10.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip",
        "handle": "iomic-sticky-junior-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Orange",
              "Pink / White",
              "Red / White",
              "Blue / White",
              "Lemon Yellow / White",
              "Black / White",
              "White / White",
              "Sky Blue/White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1118716109",
            "gid": "gid://shopify/ProductVariant/1118716109",
            "sku": "SJRBLK",
            "color": "Black / Orange",
            "size": "Junior",
            "selected_options": {
              "Color": "Black / Orange"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip?variant=1118716109"
          },
          {
            "id": "32916051525693",
            "gid": "gid://shopify/ProductVariant/32916051525693",
            "sku": "GRISJ0PW",
            "color": "Pink / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Pink / White"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip?variant=32916051525693"
          },
          {
            "id": "53091975827",
            "gid": "gid://shopify/ProductVariant/53091975827",
            "sku": "SJRRED",
            "color": "Red / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Red / White"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip?variant=53091975827"
          },
          {
            "id": "551585897",
            "gid": "gid://shopify/ProductVariant/551585897",
            "sku": "SJRBLU",
            "color": "Blue / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Blue / White"
            },
            "available": false,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip?variant=551585897"
          },
          {
            "id": "551598865",
            "gid": "gid://shopify/ProductVariant/551598865",
            "sku": "GRISJ0LY",
            "color": "Lemon Yellow / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Lemon Yellow / White"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip?variant=551598865"
          },
          {
            "id": "61497068224882",
            "gid": "gid://shopify/ProductVariant/61497068224882",
            "sku": "SJRBLKWHT",
            "color": "Black / White",
            "size": "Junior",
            "selected_options": {
              "Color": "Black / White"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip?variant=61497068224882"
          },
          {
            "id": "61497068388722",
            "gid": "gid://shopify/ProductVariant/61497068388722",
            "sku": "SJRWHT",
            "color": "White / White",
            "size": "Junior",
            "selected_options": {
              "Color": "White / White"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip?variant=61497068388722"
          },
          {
            "id": "61497068421490",
            "gid": "gid://shopify/ProductVariant/61497068421490",
            "sku": "SJRSB",
            "color": "Sky Blue/White",
            "size": "Junior",
            "selected_options": {
              "Color": "Sky Blue/White"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-junior-grip?variant=61497068421490"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, golf-grips, grip bundle, iomic, iron/wood, junior, junior-golf-grips, New for 2014, new-add-12172025, single-golf-grips, single-grip, soft, sticky, tacky, under-150, under-300, uv resistant, uv-resistant-golf-grips, video=qq1CToDcULM",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red / White",
      "Lemon Yellow / White",
      "Black / Orange",
      "Blue / White",
      "Pink / White",
      "Black / White",
      "White / White",
      "Sky Blue/White"
    ]
  },
  {
    "id": "iomic-sticky-1-8",
    "brand": "Iomic",
    "model": "Sticky 1.8",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Red Grip / Blue Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.5,
    "price_max": 179.53,
    "single_price_min": 13.5,
    "single_price_max": 13.5,
    "normalized_price_per_grip": 12.83,
    "bundle_price_min": 115.43,
    "kit_price_min": 179.53,
    "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-sticky18-newcolors_de62c70c-e347-4b39-a772-9d3db8181ed3.jpg?v=1766011443",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Red Grip / Blue Cap"
        ],
        "price": 175.5,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs",
        "handle": "iomic-sticky-1-8-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Grip / Blue Cap",
              "Platinum Grey Grip / Black Cap",
              "Black Grip / Sky Blue Cap",
              "Blue Grip / Sky Blue Cap",
              "White / Silver Grey Cap",
              "Orange Grip / Blue Cap",
              "Black Grip / Red Cap",
              "Pink Grip / Milk Pink Cap",
              "Lavender Grip / White Cap",
              "Red Grip / White Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398925607282",
            "gid": "gid://shopify/ProductVariant/61398925607282",
            "sku": "SET-13xGRIS18CRB",
            "color": "Red Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925607282"
          },
          {
            "id": "61398925640050",
            "gid": "gid://shopify/ProductVariant/61398925640050",
            "sku": "SET-13xGRIS18PLG",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925640050"
          },
          {
            "id": "61398925672818",
            "gid": "gid://shopify/ProductVariant/61398925672818",
            "sku": "SET-13xGRIS18BBL",
            "color": "Black Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Sky Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925672818"
          },
          {
            "id": "61398925705586",
            "gid": "gid://shopify/ProductVariant/61398925705586",
            "sku": "SET-13xGRIS18BLSBL",
            "color": "Blue Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue Grip / Sky Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925705586"
          },
          {
            "id": "61398925738354",
            "gid": "gid://shopify/ProductVariant/61398925738354",
            "sku": "SET-13xGRIS18RWGY",
            "color": "White / Silver Grey Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "White / Silver Grey Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925738354"
          },
          {
            "id": "61398925771122",
            "gid": "gid://shopify/ProductVariant/61398925771122",
            "sku": "SET-13xGRIS18OU",
            "color": "Orange Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Orange Grip / Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925771122"
          },
          {
            "id": "61398925803890",
            "gid": "gid://shopify/ProductVariant/61398925803890",
            "sku": "SET-13xGRIS18BR",
            "color": "Black Grip / Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925803890"
          },
          {
            "id": "61398925836658",
            "gid": "gid://shopify/ProductVariant/61398925836658",
            "sku": "SET-13xGRIS18PKMP",
            "color": "Pink Grip / Milk Pink Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink Grip / Milk Pink Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925836658"
          },
          {
            "id": "61398925869426",
            "gid": "gid://shopify/ProductVariant/61398925869426",
            "sku": "SET-13xGRIS18LVW",
            "color": "Lavender Grip / White Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Lavender Grip / White Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925869426"
          },
          {
            "id": "61398925902194",
            "gid": "gid://shopify/ProductVariant/61398925902194",
            "sku": "",
            "color": "Red Grip / White Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / White Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-bundle-13pcs?variant=61398925902194"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Red Grip / Blue Cap"
        ],
        "price": 115.43,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set",
        "handle": "iomic-sticky-1-8-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Grip / Blue Cap",
              "Platinum Grey Grip / Black Cap",
              "Black Grip / Sky Blue Cap",
              "Blue Grip / Sky Blue Cap",
              "White / Silver Grey Cap",
              "Orange Grip / Blue Cap",
              "Black Grip / Red Cap",
              "Pink Grip / Milk Pink Cap",
              "Lavender Grip / White Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021974806589",
            "gid": "gid://shopify/ProductVariant/41021974806589",
            "sku": "SET-9xGRIS18CRB",
            "color": "Red Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set?variant=41021974806589"
          },
          {
            "id": "41021974839357",
            "gid": "gid://shopify/ProductVariant/41021974839357",
            "sku": "SET-9xGRIS18PLG",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set?variant=41021974839357"
          },
          {
            "id": "41021974872125",
            "gid": "gid://shopify/ProductVariant/41021974872125",
            "sku": "SET-9xGRIS18BBL",
            "color": "Black Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Sky Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set?variant=41021974872125"
          },
          {
            "id": "41021974904893",
            "gid": "gid://shopify/ProductVariant/41021974904893",
            "sku": "SET-9xGRIS18BLSBL",
            "color": "Blue Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue Grip / Sky Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set?variant=41021974904893"
          },
          {
            "id": "41021974937661",
            "gid": "gid://shopify/ProductVariant/41021974937661",
            "sku": "SET-9xGRIS18RWGY",
            "color": "White / Silver Grey Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "White / Silver Grey Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set?variant=41021974937661"
          },
          {
            "id": "41021974970429",
            "gid": "gid://shopify/ProductVariant/41021974970429",
            "sku": "SET-9xGRIS18OU",
            "color": "Orange Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Orange Grip / Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set?variant=41021974970429"
          },
          {
            "id": "41021975003197",
            "gid": "gid://shopify/ProductVariant/41021975003197",
            "sku": "SET-9xGRIS18BR",
            "color": "Black Grip / Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set?variant=41021975003197"
          },
          {
            "id": "41021975035965",
            "gid": "gid://shopify/ProductVariant/41021975035965",
            "sku": "SET-9xGRIS18PKMP",
            "color": "Pink Grip / Milk Pink Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink Grip / Milk Pink Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set?variant=41021975035965"
          },
          {
            "id": "41021975068733",
            "gid": "gid://shopify/ProductVariant/41021975068733",
            "sku": "SET-9xGRIS18LVW",
            "color": "Lavender Grip / White Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Lavender Grip / White Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-grip-bundle-set?variant=41021975068733"
          }
        ],
        "shopify_variant_count": 9,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Red Grip / Blue Cap"
        ],
        "price": 179.53,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit",
        "handle": "iomic-sticky-1-8-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Grip / Blue Cap",
              "Platinum Grey Grip / Black Cap",
              "Blue Grip / Sky Blue Cap",
              "White / Silver Grey Cap",
              "Orange Grip / Blue Cap",
              "Black Grip / Red Cap",
              "Pink Grip / Milk Pink Cap",
              "Lavender Grip / White Cap",
              "Black Grip / Light Blue Cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39470624440381",
            "gid": "gid://shopify/ProductVariant/39470624440381",
            "sku": "KIT+13xGRIS18CRB",
            "color": "Red Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / Blue Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=39470624440381"
          },
          {
            "id": "40215673110589",
            "gid": "gid://shopify/ProductVariant/40215673110589",
            "sku": "KIT(8oz)+13xGRIS18CRB",
            "color": "Red Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / Blue Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40215673110589"
          },
          {
            "id": "39470624473149",
            "gid": "gid://shopify/ProductVariant/39470624473149",
            "sku": "KIT+13xGRIS18PLG",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=39470624473149"
          },
          {
            "id": "40215673143357",
            "gid": "gid://shopify/ProductVariant/40215673143357",
            "sku": "KIT(8oz)+13xGRIS18PLG",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40215673143357"
          },
          {
            "id": "39470624505917",
            "gid": "gid://shopify/ProductVariant/39470624505917",
            "sku": "KIT+13xGRIS18BLSBL",
            "color": "Blue Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue Grip / Sky Blue Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=39470624505917"
          },
          {
            "id": "40215673176125",
            "gid": "gid://shopify/ProductVariant/40215673176125",
            "sku": "KIT(8oz)+13xGRIS18BLSBL",
            "color": "Blue Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue Grip / Sky Blue Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40215673176125"
          },
          {
            "id": "39470624538685",
            "gid": "gid://shopify/ProductVariant/39470624538685",
            "sku": "KIT+13xGRIS18RWGY",
            "color": "White / Silver Grey Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "White / Silver Grey Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=39470624538685"
          },
          {
            "id": "40215673208893",
            "gid": "gid://shopify/ProductVariant/40215673208893",
            "sku": "KIT(8oz)+13xGRIS18RWGY",
            "color": "White / Silver Grey Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "White / Silver Grey Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40215673208893"
          },
          {
            "id": "39470624571453",
            "gid": "gid://shopify/ProductVariant/39470624571453",
            "sku": "KIT+13xGRIS18OU",
            "color": "Orange Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Orange Grip / Blue Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=39470624571453"
          },
          {
            "id": "40215673241661",
            "gid": "gid://shopify/ProductVariant/40215673241661",
            "sku": "KIT(8oz)+13xGRIS18OU",
            "color": "Orange Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Orange Grip / Blue Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40215673241661"
          },
          {
            "id": "39470624604221",
            "gid": "gid://shopify/ProductVariant/39470624604221",
            "sku": "KIT+13xGRIS18BR",
            "color": "Black Grip / Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=39470624604221"
          },
          {
            "id": "40215673274429",
            "gid": "gid://shopify/ProductVariant/40215673274429",
            "sku": "KIT(8oz)+13xGRIS18BR",
            "color": "Black Grip / Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40215673274429"
          },
          {
            "id": "39470624636989",
            "gid": "gid://shopify/ProductVariant/39470624636989",
            "sku": "KIT+13xGRIS18PKMP",
            "color": "Pink Grip / Milk Pink Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink Grip / Milk Pink Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=39470624636989"
          },
          {
            "id": "40215673307197",
            "gid": "gid://shopify/ProductVariant/40215673307197",
            "sku": "KIT(8oz)+13xGRIS18PKMP",
            "color": "Pink Grip / Milk Pink Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink Grip / Milk Pink Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40215673307197"
          },
          {
            "id": "39470624669757",
            "gid": "gid://shopify/ProductVariant/39470624669757",
            "sku": "KIT+13xGRIS18LVW",
            "color": "Lavender Grip / White Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Lavender Grip / White Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=39470624669757"
          },
          {
            "id": "40215673339965",
            "gid": "gid://shopify/ProductVariant/40215673339965",
            "sku": "KIT(8oz)+13xGRIS18LVW",
            "color": "Lavender Grip / White Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Lavender Grip / White Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40215673339965"
          },
          {
            "id": "40487409025085",
            "gid": "gid://shopify/ProductVariant/40487409025085",
            "sku": "KIT+13xGRIS18BBL",
            "color": "Black Grip / Light Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Light Blue Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40487409025085"
          },
          {
            "id": "40487409057853",
            "gid": "gid://shopify/ProductVariant/40487409057853",
            "sku": "KIT(8oz)+13xGRIS18BBL",
            "color": "Black Grip / Light Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Light Blue Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-13pcs-golf-grip-kit?variant=40487409057853"
          }
        ],
        "shopify_variant_count": 18,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Red Grip / Blue Cap"
        ],
        "price": 13.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip",
        "handle": "iomic-sticky-1-8-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Grip / Blue Cap",
              "Platinum Grey Grip / Black Cap",
              "Black Grip / Sky Blue Cap",
              "Blue Grip / Sky Blue Cap",
              "White / Silver Grey Cap",
              "Orange Grip / Blue Cap",
              "Black Grip / Red Cap",
              "Pink Grip / Milk Pink Cap",
              "Lavender Grip / White Cap",
              "Red Grip / White Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "30427418492989",
            "gid": "gid://shopify/ProductVariant/30427418492989",
            "sku": "GRIS18CRB",
            "color": "Red Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=30427418492989"
          },
          {
            "id": "39428251942973",
            "gid": "gid://shopify/ProductVariant/39428251942973",
            "sku": "GRIS18PLG",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=39428251942973"
          },
          {
            "id": "40463445360701",
            "gid": "gid://shopify/ProductVariant/40463445360701",
            "sku": "GRIS18BBL",
            "color": "Black Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Sky Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=40463445360701"
          },
          {
            "id": "283129400",
            "gid": "gid://shopify/ProductVariant/283129400",
            "sku": "GRIS18BLSBL",
            "color": "Blue Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue Grip / Sky Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=283129400"
          },
          {
            "id": "28529772101693",
            "gid": "gid://shopify/ProductVariant/28529772101693",
            "sku": "GRIS18RWGY",
            "color": "White / Silver Grey Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "White / Silver Grey Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=28529772101693"
          },
          {
            "id": "7420518301757",
            "gid": "gid://shopify/ProductVariant/7420518301757",
            "sku": "GRIS18OU",
            "color": "Orange Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Orange Grip / Blue Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=7420518301757"
          },
          {
            "id": "210511919",
            "gid": "gid://shopify/ProductVariant/210511919",
            "sku": "GRIS18BR",
            "color": "Black Grip / Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=210511919"
          },
          {
            "id": "283129218",
            "gid": "gid://shopify/ProductVariant/283129218",
            "sku": "GRIS18PKMP",
            "color": "Pink Grip / Milk Pink Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink Grip / Milk Pink Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=283129218"
          },
          {
            "id": "24253966087",
            "gid": "gid://shopify/ProductVariant/24253966087",
            "sku": "GRIS18LVW",
            "color": "Lavender Grip / White Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Lavender Grip / White Cap",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=24253966087"
          },
          {
            "id": "41196852510781",
            "gid": "gid://shopify/ProductVariant/41196852510781",
            "sku": "",
            "color": "Red Grip / White Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / White Cap",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip?variant=41196852510781"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, asbl-grip-option, gifts-for-her, golf-grips, grip bundle, iomic, iron/wood, ladies, new-add-12172025, overstock-oct-2022, overstock-oct-2023, single-golf-grips, single-grip, soft, sticky, tacky, under-150, under-300, undersize, undersize-gol",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red Grip / Blue Cap",
      "Platinum Grey Grip / Black Cap",
      "Black Grip / Sky Blue Cap",
      "Blue Grip / Sky Blue Cap",
      "White / Silver Grey Cap",
      "Orange Grip / Blue Cap",
      "Black Grip / Red Cap",
      "Pink Grip / Milk Pink Cap",
      "Lavender Grip / White Cap",
      "Red Grip / White Cap",
      "Black Grip / Light Blue Cap"
    ]
  },
  {
    "id": "iomic-sticky-1-8-opus-black",
    "brand": "Iomic",
    "model": "Sticky 1.8 Opus Black",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Sky Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12.93,
    "price_max": 12.93,
    "single_price_min": 12.93,
    "single_price_max": 12.93,
    "normalized_price_per_grip": 12.93,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-opus-black-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-opus-blk-3colors.jpg?v=1752715251",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Sky Blue"
        ],
        "price": 12.93,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-sticky-opus-black-grip",
        "handle": "iomic-sticky-opus-black-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Sky Blue",
              "Orange"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "27628181703",
            "gid": "gid://shopify/ProductVariant/27628181703",
            "sku": "IM-OPSBKSB",
            "color": "Sky Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Sky Blue"
            },
            "available": false,
            "price": 12.93,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-black-grip?variant=27628181703"
          },
          {
            "id": "39461761810493",
            "gid": "gid://shopify/ProductVariant/39461761810493",
            "sku": "IM-OPSBKOG",
            "color": "Orange",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange"
            },
            "available": false,
            "price": 12.93,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-black-grip?variant=39461761810493"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_IOMIC, gifts-for-her, iomic, iron/wood, Model_IOMIC Sticky, opus, single-golf-grips, single-grip, Size_Undersize, soft, sticky, Style_Swing Grip, tacky, under-150, undersize, undersize-golf-grips, video=qq1CToDcULM, womens, x-grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-sticky-1-8-ribbed",
    "brand": "Iomic",
    "model": "Sticky 1.8 Ribbed",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "TrueLine ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "TrueLine",
    "alignment_description": "Subtle, tactile ridge along the underside of the grip designed to help square the club face and support consistent hand placement.",
    "manufacturer_benefit_claims": "Subtle, tactile guidance along the underside of the grip designed to help square the club face and lock in consistent hand placement.",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8",
      "https://www.iomicusa.com/collections/ribbed-reminder-grips"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blue Grip / Sky Blue Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.5,
    "price_max": 175.5,
    "single_price_min": 13.5,
    "single_price_max": 13.5,
    "normalized_price_per_grip": 12.83,
    "bundle_price_min": 115.43,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Sticky1.8_ribbed_allcolors-2021.jpg?v=1766011415",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue Grip / Sky Blue Cap"
        ],
        "price": 175.5,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed-bundle-13pcs",
        "handle": "iomic-sticky-1-8-grip-ribbed-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue Grip / Sky Blue Cap",
              "Black Grip / Red Cap",
              "Red Grip / Blue Cap"
            ]
          },
          {
            "name": "Shape",
            "values": [
              "Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398924624242",
            "gid": "gid://shopify/ProductVariant/61398924624242",
            "sku": "SET-13xGRIS18BLSBL+",
            "color": "Blue Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue Grip / Sky Blue Cap",
              "Shape": "Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed-bundle-13pcs?variant=61398924624242"
          },
          {
            "id": "61398924657010",
            "gid": "gid://shopify/ProductVariant/61398924657010",
            "sku": "SET-13xGRIS18BR+",
            "color": "Black Grip / Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Shape": "Ribbed",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed-bundle-13pcs?variant=61398924657010"
          },
          {
            "id": "61398924689778",
            "gid": "gid://shopify/ProductVariant/61398924689778",
            "sku": "SET-13xGRIS18RBL+",
            "color": "Red Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / Blue Cap",
              "Shape": "Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed-bundle-13pcs?variant=61398924689778"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blue Grip / Sky Blue Cap"
        ],
        "price": 115.43,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed-grip-bundle-set",
        "handle": "iomic-sticky-1-8-grip-ribbed-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue Grip / Sky Blue Cap",
              "Black Grip / Red Cap",
              "Red Grip / Blue Cap"
            ]
          },
          {
            "name": "Shape",
            "values": [
              "Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021972086845",
            "gid": "gid://shopify/ProductVariant/41021972086845",
            "sku": "SET-9xGRIS18BLSBL+",
            "color": "Blue Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue Grip / Sky Blue Cap",
              "Shape": "Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed-grip-bundle-set?variant=41021972086845"
          },
          {
            "id": "41021972119613",
            "gid": "gid://shopify/ProductVariant/41021972119613",
            "sku": "SET-9xGRIS18BR+",
            "color": "Black Grip / Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Shape": "Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed-grip-bundle-set?variant=41021972119613"
          },
          {
            "id": "41021972152381",
            "gid": "gid://shopify/ProductVariant/41021972152381",
            "sku": "SET-9xGRIS18RBL+",
            "color": "Red Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / Blue Cap",
              "Shape": "Ribbed",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed-grip-bundle-set?variant=41021972152381"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Blue Grip / Sky Blue Cap"
        ],
        "price": 13.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed",
        "handle": "iomic-sticky-1-8-grip-ribbed",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue Grip / Sky Blue Cap",
              "Black Grip / Red Cap",
              "Red Grip / Blue Cap"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "298051955",
            "gid": "gid://shopify/ProductVariant/298051955",
            "sku": "GRIS18BLSBL+",
            "color": "Blue Grip / Sky Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue Grip / Sky Blue Cap"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed?variant=298051955"
          },
          {
            "id": "298051957",
            "gid": "gid://shopify/ProductVariant/298051957",
            "sku": "GRIS18BR+",
            "color": "Black Grip / Red Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black Grip / Red Cap"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed?variant=298051957"
          },
          {
            "id": "39276786909245",
            "gid": "gid://shopify/ProductVariant/39276786909245",
            "sku": "GRIS18RBL+",
            "color": "Red Grip / Blue Cap",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red Grip / Blue Cap"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-grip-ribbed?variant=39276786909245"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, gifts-for-her, golf-grips, grip bundle, iomic, iron/wood, ladies, new-add-12172025, ribbed, Ribbed Golf Grip, ribbed-reminder-golf-grips, single-golf-grips, single-grip, soft, sticky, tacky, under-150, under-300, undersize, undersize-golf-gr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "2026-07-13",
    "manual_notes": "texture is still ribbed/tacky like the rest of the Sticky line; TrueLine is an added alignment feature, not a replacement for the texture rating",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue Grip / Sky Blue Cap",
      "Red Grip / Blue Cap",
      "Black Grip / Red Cap"
    ]
  },
  {
    "id": "iomic-sticky-1-8-super-light",
    "brand": "Iomic",
    "model": "Sticky 1.8 Super Light",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Undersize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.5,
    "price_max": 13.5,
    "single_price_min": 13.5,
    "single_price_max": 13.5,
    "normalized_price_per_grip": 13.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-1-8-super-light-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPTImageJan13_2026_02_13_29PM.png?v=1769811287",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-1-8-super-light-undersize-grip",
        "handle": "iomic-sticky-1-8-super-light-undersize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Coral Red",
              "Blue"
            ]
          },
          {
            "name": "Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61497034867058",
            "gid": "gid://shopify/ProductVariant/61497034867058",
            "sku": "1.8BK35",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-super-light-undersize-grip?variant=61497034867058"
          },
          {
            "id": "61497034899826",
            "gid": "gid://shopify/ProductVariant/61497034899826",
            "sku": "1.8CR35",
            "color": "Coral Red",
            "size": "Undersize",
            "selected_options": {
              "Color": "Coral Red",
              "Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-super-light-undersize-grip?variant=61497034899826"
          },
          {
            "id": "61497034932594",
            "gid": "gid://shopify/ProductVariant/61497034932594",
            "sku": "1.8BL35",
            "color": "Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue",
              "Size": "Undersize"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-1-8-super-light-undersize-grip?variant=61497034932594"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "35g grip, 49 under, All products, Brand_IOMIC, firm, iomic, iomic 1.8 grip, Iomic golf grips, iomic superlight, iomic undersize grip, iron/wood, light grips, light-weight-grips, lightweight grips, Model_IOMIC Sticky 1.8 Super Light, single-golf-grips, single-grip, sticky 1.0, Style_Swing Grip, super",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Coral Red",
      "Blue"
    ]
  },
  {
    "id": "iomic-sticky-2-3",
    "brand": "Iomic",
    "model": "Sticky 2.3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Orange Grip / Black Cap",
      "Sky Blue / Black Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.5,
    "price_max": 179.53,
    "single_price_min": 13.5,
    "single_price_max": 13.5,
    "normalized_price_per_grip": 12.83,
    "bundle_price_min": 115.43,
    "kit_price_min": 179.53,
    "url": "https://www.grips4less.com/products/iomic-sticky-2-3",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-sticky-8-ALLcolors-withplatgrey_74589a90-c678-4450-b922-7d5056ae3b6d.jpg?v=1766011438",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Sky Blue / Black Cap"
        ],
        "price": 175.5,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs",
        "handle": "iomic-sticky-2-3-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Sky Blue / Black Cap",
              "Orange Grip / Black Cap",
              "Platinum Grey / Black Cap",
              "Navy Grip / Black Cap (Silver Logo)",
              "White Grip / Black Cap",
              "Blue Grip / Black Cap",
              "Black Grip / Black Cap",
              "Bright Green Grip / Black Cap",
              "Red Grip / Black Cap",
              "Royal Purple"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398925246834",
            "gid": "gid://shopify/ProductVariant/61398925246834",
            "sku": "SET-13xGRIS23SKB",
            "color": "Sky Blue / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925246834"
          },
          {
            "id": "61398925279602",
            "gid": "gid://shopify/ProductVariant/61398925279602",
            "sku": "SET-13xGRIS23O",
            "color": "Orange Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925279602"
          },
          {
            "id": "61398925312370",
            "gid": "gid://shopify/ProductVariant/61398925312370",
            "sku": "SET-13xGRIS23PLG",
            "color": "Platinum Grey / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925312370"
          },
          {
            "id": "61398925345138",
            "gid": "gid://shopify/ProductVariant/61398925345138",
            "sku": "SET-13xGRIS23NVY",
            "color": "Navy Grip / Black Cap (Silver Logo)",
            "size": "Standard",
            "selected_options": {
              "Color": "Navy Grip / Black Cap (Silver Logo)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 195,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925345138"
          },
          {
            "id": "61398925377906",
            "gid": "gid://shopify/ProductVariant/61398925377906",
            "sku": "SET-13xGRIS23W",
            "color": "White Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "White Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925377906"
          },
          {
            "id": "61398925410674",
            "gid": "gid://shopify/ProductVariant/61398925410674",
            "sku": "SET-13xGRIS23BL",
            "color": "Blue Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925410674"
          },
          {
            "id": "61398925443442",
            "gid": "gid://shopify/ProductVariant/61398925443442",
            "sku": "SET-13xGRIS23BK",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925443442"
          },
          {
            "id": "61398925476210",
            "gid": "gid://shopify/ProductVariant/61398925476210",
            "sku": "SET-13xGRIS23G",
            "color": "Bright Green Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Bright Green Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925476210"
          },
          {
            "id": "61398925508978",
            "gid": "gid://shopify/ProductVariant/61398925508978",
            "sku": "SET-13xGRIS23BRD",
            "color": "Red Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Red Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925508978"
          },
          {
            "id": "61398925541746",
            "gid": "gid://shopify/ProductVariant/61398925541746",
            "sku": "SET-13xGRIS23RP",
            "color": "Royal Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Royal Purple",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-bundle-13pcs?variant=61398925541746"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Sky Blue / Black Cap"
        ],
        "price": 115.43,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set",
        "handle": "iomic-sticky-2-3-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Sky Blue / Black Cap",
              "Orange Grip / Black Cap",
              "Platinum Grey / Black Cap",
              "Navy Grip / Black Cap",
              "White Grip / Black Cap",
              "Blue Grip / Black Cap",
              "Black Grip / Black Cap",
              "Bright Green Grip / Black Cap",
              "Red Grip / Black Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021974183997",
            "gid": "gid://shopify/ProductVariant/41021974183997",
            "sku": "SET-9xGRIS23SKB",
            "color": "Sky Blue / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set?variant=41021974183997"
          },
          {
            "id": "41021974216765",
            "gid": "gid://shopify/ProductVariant/41021974216765",
            "sku": "SET-9xGRIS23O",
            "color": "Orange Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set?variant=41021974216765"
          },
          {
            "id": "41021974249533",
            "gid": "gid://shopify/ProductVariant/41021974249533",
            "sku": "SET-9xGRIS23PLG",
            "color": "Platinum Grey / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set?variant=41021974249533"
          },
          {
            "id": "41021974282301",
            "gid": "gid://shopify/ProductVariant/41021974282301",
            "sku": "SET-9xGRIS23NVY",
            "color": "Navy Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Navy Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set?variant=41021974282301"
          },
          {
            "id": "41021974315069",
            "gid": "gid://shopify/ProductVariant/41021974315069",
            "sku": "SET-9xGRIS23W",
            "color": "White Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "White Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set?variant=41021974315069"
          },
          {
            "id": "41021974347837",
            "gid": "gid://shopify/ProductVariant/41021974347837",
            "sku": "SET-9xGRIS23BL",
            "color": "Blue Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set?variant=41021974347837"
          },
          {
            "id": "41021974380605",
            "gid": "gid://shopify/ProductVariant/41021974380605",
            "sku": "SET-9xGRIS23BK",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set?variant=41021974380605"
          },
          {
            "id": "41021974413373",
            "gid": "gid://shopify/ProductVariant/41021974413373",
            "sku": "SET-9xGRIS23G",
            "color": "Bright Green Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Bright Green Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set?variant=41021974413373"
          },
          {
            "id": "41021974446141",
            "gid": "gid://shopify/ProductVariant/41021974446141",
            "sku": "SET-9xGRIS23BRD",
            "color": "Red Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Red Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-grip-bundle-set?variant=41021974446141"
          }
        ],
        "shopify_variant_count": 9,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Orange Grip / Black Cap"
        ],
        "price": 179.53,
        "per_grip_g": 69.8,
        "total_g": 907.18474,
        "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit",
        "handle": "iomic-sticky-2-3-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Orange Grip / Black Cap",
              "Sky Blue Grip / Black Cap",
              "Platinum Grey / Black Cap",
              "Navy Grip / Black Cap",
              "White Grip / Black Cap",
              "Blue Grip / Black Cap",
              "Black Grip / Black Cap",
              "Bright Green Grip / Black Cap",
              "Red Grip / Black Cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39472707239997",
            "gid": "gid://shopify/ProductVariant/39472707239997",
            "sku": "KIT+13xGRIS23O",
            "color": "Orange Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 179.53,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=39472707239997"
          },
          {
            "id": "40215677009981",
            "gid": "gid://shopify/ProductVariant/40215677009981",
            "sku": "KIT(8oz)+13xGRIS23O",
            "color": "Orange Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 184.47,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=40215677009981"
          },
          {
            "id": "39909015027773",
            "gid": "gid://shopify/ProductVariant/39909015027773",
            "sku": "KIT+13xGRIS23SKB",
            "color": "Sky Blue Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 179.53,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=39909015027773"
          },
          {
            "id": "40215677042749",
            "gid": "gid://shopify/ProductVariant/40215677042749",
            "sku": "KIT(8oz)+13xGRIS23SKB",
            "color": "Sky Blue Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 184.47,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=40215677042749"
          },
          {
            "id": "39472707272765",
            "gid": "gid://shopify/ProductVariant/39472707272765",
            "sku": "KIT+13xGRIS23PLG",
            "color": "Platinum Grey / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=39472707272765"
          },
          {
            "id": "40215677075517",
            "gid": "gid://shopify/ProductVariant/40215677075517",
            "sku": "KIT(8oz)+13xGRIS23PLG",
            "color": "Platinum Grey / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=40215677075517"
          },
          {
            "id": "39472707305533",
            "gid": "gid://shopify/ProductVariant/39472707305533",
            "sku": "KIT+13xGRIS23NVY",
            "color": "Navy Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Navy Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 179.53,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=39472707305533"
          },
          {
            "id": "40215677108285",
            "gid": "gid://shopify/ProductVariant/40215677108285",
            "sku": "KIT(8oz)+13xGRIS23NVY",
            "color": "Navy Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Navy Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 184.47,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=40215677108285"
          },
          {
            "id": "39472707338301",
            "gid": "gid://shopify/ProductVariant/39472707338301",
            "sku": "KIT+13xGRIS23W",
            "color": "White Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "White Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=39472707338301"
          },
          {
            "id": "40215677141053",
            "gid": "gid://shopify/ProductVariant/40215677141053",
            "sku": "KIT(8oz)+13xGRIS23W",
            "color": "White Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "White Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=40215677141053"
          },
          {
            "id": "39472707371069",
            "gid": "gid://shopify/ProductVariant/39472707371069",
            "sku": "KIT+13xGRIS23BL",
            "color": "Blue Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=39472707371069"
          },
          {
            "id": "40215677173821",
            "gid": "gid://shopify/ProductVariant/40215677173821",
            "sku": "KIT(8oz)+13xGRIS23BL",
            "color": "Blue Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=40215677173821"
          },
          {
            "id": "39472707403837",
            "gid": "gid://shopify/ProductVariant/39472707403837",
            "sku": "KIT+13xGRIS23BK",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 179.53,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=39472707403837"
          },
          {
            "id": "40215677206589",
            "gid": "gid://shopify/ProductVariant/40215677206589",
            "sku": "KIT(8oz)+13xGRIS23BK",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 184.47,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=40215677206589"
          },
          {
            "id": "39472707436605",
            "gid": "gid://shopify/ProductVariant/39472707436605",
            "sku": "KIT+13xGRIS23G",
            "color": "Bright Green Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Bright Green Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=39472707436605"
          },
          {
            "id": "40215677239357",
            "gid": "gid://shopify/ProductVariant/40215677239357",
            "sku": "KIT(8oz)+13xGRIS23G",
            "color": "Bright Green Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Bright Green Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=40215677239357"
          },
          {
            "id": "39472707469373",
            "gid": "gid://shopify/ProductVariant/39472707469373",
            "sku": "KIT+13xGRIS23BRD",
            "color": "Red Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Red Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=39472707469373"
          },
          {
            "id": "40215677272125",
            "gid": "gid://shopify/ProductVariant/40215677272125",
            "sku": "KIT(8oz)+13xGRIS23BRD",
            "color": "Red Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Red Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 184.47,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-13pcs-golf-grip-kit?variant=40215677272125"
          }
        ],
        "shopify_variant_count": 18,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Sky Blue / Black Cap"
        ],
        "price": 13.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-2-3",
        "handle": "iomic-sticky-2-3",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Sky Blue / Black Cap",
              "Orange Grip / Black Cap",
              "Platinum Grey / Black Cap",
              "Navy Grip / Black Cap (Silver Logo)",
              "White Grip / Black Cap",
              "Blue Grip / Black Cap",
              "Black Grip / Black Cap",
              "Bright Green Grip / Black Cap",
              "Red Grip / Black Cap",
              "Royal Purple"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39877164171325",
            "gid": "gid://shopify/ProductVariant/39877164171325",
            "sku": "GRIS23SKB",
            "color": "Sky Blue / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=39877164171325"
          },
          {
            "id": "298045051",
            "gid": "gid://shopify/ProductVariant/298045051",
            "sku": "GRIS23O",
            "color": "Orange Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=298045051"
          },
          {
            "id": "31592456945725",
            "gid": "gid://shopify/ProductVariant/31592456945725",
            "sku": "GRIS23PLG",
            "color": "Platinum Grey / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=31592456945725"
          },
          {
            "id": "53092124371",
            "gid": "gid://shopify/ProductVariant/53092124371",
            "sku": "GRIS23NVY",
            "color": "Navy Grip / Black Cap (Silver Logo)",
            "size": "Standard",
            "selected_options": {
              "Color": "Navy Grip / Black Cap (Silver Logo)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 15,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=53092124371"
          },
          {
            "id": "210512121",
            "gid": "gid://shopify/ProductVariant/210512121",
            "sku": "GRIS23W",
            "color": "White Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "White Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=210512121"
          },
          {
            "id": "210512113",
            "gid": "gid://shopify/ProductVariant/210512113",
            "sku": "GRIS23BL",
            "color": "Blue Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=210512113"
          },
          {
            "id": "210512099",
            "gid": "gid://shopify/ProductVariant/210512099",
            "sku": "GRIS23BK",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=210512099"
          },
          {
            "id": "295066995",
            "gid": "gid://shopify/ProductVariant/295066995",
            "sku": "GRIS23G",
            "color": "Bright Green Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Bright Green Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=295066995"
          },
          {
            "id": "210512115",
            "gid": "gid://shopify/ProductVariant/210512115",
            "sku": "GRIS23BRD",
            "color": "Red Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Red Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=210512115"
          },
          {
            "id": "60718484128114",
            "gid": "gid://shopify/ProductVariant/60718484128114",
            "sku": "GRIS23RP",
            "color": "Royal Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Royal Purple",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3?variant=60718484128114"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, asbl-grip-option, best-sellers, golf-grips, golfers-gift-guide, grip bundle, iomic, iron/wood, New for 2014, new-add-12172025, overstock-oct-2022, overstock-oct-2023, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Platinum Grey / Black Cap",
      "White Grip / Black Cap",
      "Blue Grip / Black Cap",
      "Bright Green Grip / Black Cap",
      "Red Grip / Black Cap",
      "Royal Purple",
      "Sky Blue / Black Cap"
    ]
  },
  {
    "id": "iomic-sticky-2-3-black",
    "brand": "Iomic",
    "model": "Sticky 2.3 Black",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Black / Black cap"
    ],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 179.53,
    "price_max": 179.53,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.81,
    "bundle_price_min": null,
    "kit_price_min": 179.53,
    "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-black-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gripkit-13iomicstickyblack.jpg?v=1752716637",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Black cap"
        ],
        "price": 179.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-black-grips",
        "handle": "grip-kit-13x-iomic-sticky-2-3-black-grips",
        "shopify_variants": [
          {
            "id": "814936129",
            "gid": "gid://shopify/ProductVariant/814936129",
            "sku": "KIT+13xGRIS23BK",
            "color": "Black / Black cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Black cap"
            },
            "available": false,
            "price": 179.53,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-black-grips?variant=814936129"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Black cap"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripki",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-sticky-2-3-blue",
    "brand": "Iomic",
    "model": "Sticky 2.3 Blue",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Blue / Black cap"
    ],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 179.53,
    "price_max": 179.53,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.81,
    "bundle_price_min": null,
    "kit_price_min": 179.53,
    "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-blue-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gripkit-13iomicstickyblue.jpg?v=1752716638",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "Blue / Black cap"
        ],
        "price": 179.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-blue-grips",
        "handle": "grip-kit-13x-iomic-sticky-2-3-blue-grips",
        "shopify_variants": [
          {
            "id": "814934013",
            "gid": "gid://shopify/ProductVariant/814934013",
            "sku": "KIT+13xGRIS23BL",
            "color": "Blue / Black cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / Black cap"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-blue-grips?variant=814934013"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue / Black cap"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripki",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue / Black cap"
    ]
  },
  {
    "id": "iomic-sticky-2-3-red",
    "brand": "Iomic",
    "model": "Sticky 2.3 Red",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Red / Black cap"
    ],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 179.53,
    "price_max": 179.53,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.81,
    "bundle_price_min": null,
    "kit_price_min": 179.53,
    "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-red-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gripkit-13iomicstickyred.jpg?v=1752716639",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "Red / Black cap"
        ],
        "price": 179.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-red-grips",
        "handle": "grip-kit-13x-iomic-sticky-2-3-red-grips",
        "shopify_variants": [
          {
            "id": "814931389",
            "gid": "gid://shopify/ProductVariant/814931389",
            "sku": "KIT+13xGRIS23BRD",
            "color": "Red / Black cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / Black cap"
            },
            "available": true,
            "price": 179.53,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-red-grips?variant=814931389"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / Black cap"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripki",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red / Black cap"
    ]
  },
  {
    "id": "iomic-sticky-2-3-ribbed",
    "brand": "Iomic",
    "model": "Sticky 2.3 Ribbed",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "TrueLine ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "TrueLine",
    "alignment_description": "Subtle, tactile ridge along the underside of the grip designed to help square the club face and support consistent hand placement.",
    "manufacturer_benefit_claims": "Subtle, tactile guidance along the underside of the grip designed to help square the club face and lock in consistent hand placement.",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8",
      "https://www.iomicusa.com/collections/ribbed-reminder-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "Black Grip / Black Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.5,
    "price_max": 175.5,
    "single_price_min": 13.5,
    "single_price_max": 13.5,
    "normalized_price_per_grip": 12.83,
    "bundle_price_min": 115.43,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-2-3-ribbed-grip-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Sticky2.3_bk_43ca0c41-25c6-4fff-8f4e-ab65b6418e07.png?v=1766013922",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black",
          "Black Grip / Black Cap"
        ],
        "price": 175.5,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-2-3-ribbed-grip-black-bundle-13pcs",
        "handle": "iomic-sticky-2-3-ribbed-grip-black-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398924362098",
            "gid": "gid://shopify/ProductVariant/61398924362098",
            "sku": "SET-13xGRIS23BK+",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Shape": "Ribbed",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 175.5,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-ribbed-grip-black-bundle-13pcs?variant=61398924362098"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Black Cap"
            ]
          },
          {
            "name": "Shape",
            "values": [
              "Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black Grip / Black Cap"
        ],
        "price": 115.43,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-sticky-2-3-ribbed-grip-black-grip-bundle-set",
        "handle": "iomic-sticky-2-3-ribbed-grip-black-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021969367101",
            "gid": "gid://shopify/ProductVariant/41021969367101",
            "sku": "SET-9xGRIS23BK+",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Shape": "Ribbed",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 115.43,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-ribbed-grip-black-grip-bundle-set?variant=41021969367101"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Black Cap"
            ]
          },
          {
            "name": "Shape",
            "values": [
              "Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Black Grip / Black Cap"
        ],
        "price": 13.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-2-3-ribbed-grip-black",
        "handle": "iomic-sticky-2-3-ribbed-grip-black",
        "shopify_variants": [
          {
            "id": "772743165",
            "gid": "gid://shopify/ProductVariant/772743165",
            "sku": "GRIS23BK+",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Shape": "Ribbed",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-sticky-2-3-ribbed-grip-black?variant=772743165"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Black Cap"
            ]
          },
          {
            "name": "Shape",
            "values": [
              "Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, golf-grips, grip bundle, iomic, iron/wood, New for 2014, new-add-12172025, ribbed, Ribbed Golf Grip, ribbed-reminder-golf-grips, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, sticky, tacky, under-150, under-300, u",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "2026-07-13",
    "manual_notes": "texture is still ribbed/tacky like the rest of the Sticky line; TrueLine is an added alignment feature, not a replacement for the texture rating",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black Grip / Black Cap"
    ]
  },
  {
    "id": "iomic-sticky-2-3-white",
    "brand": "Iomic",
    "model": "Sticky 2.3 White",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "White"
    ],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 179.53,
    "price_max": 179.53,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 13.81,
    "bundle_price_min": null,
    "kit_price_min": 179.53,
    "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-white-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-grip-kits-sticky23-wht.jpg?v=1752716632",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "White"
        ],
        "price": 179.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-white-grips",
        "handle": "grip-kit-13x-iomic-sticky-2-3-white-grips",
        "shopify_variants": [
          {
            "id": "42252516307",
            "gid": "gid://shopify/ProductVariant/42252516307",
            "sku": "KIT+13xGRIS23W",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 179.53,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-2-3-white-grips?variant=42252516307"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      }
    ],
    "source_tags": "150-200, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripki",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-sticky-3-5",
    "brand": "Iomic",
    "model": "Sticky 3.5",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black Grip / Blue Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15,
    "price_max": 195,
    "single_price_min": 15,
    "single_price_max": 15,
    "normalized_price_per_grip": 14.25,
    "bundle_price_min": 128.25,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-sticky-35-allcolors.jpg?v=1766010926",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black Grip / Blue Cap"
        ],
        "price": 195,
        "per_grip_g": 4.9,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip-bundle-13pcs",
        "handle": "iomic-sticky-3-5-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Blue Cap",
              "Black Grip / Red Cap",
              "Black Grip / Black Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398910566770",
            "gid": "gid://shopify/ProductVariant/61398910566770",
            "sku": "SET-13xGRIS35BBL",
            "color": "Black Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 195,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip-bundle-13pcs?variant=61398910566770"
          },
          {
            "id": "61398910599538",
            "gid": "gid://shopify/ProductVariant/61398910599538",
            "sku": "SET-13xGRIS35BRD",
            "color": "Black Grip / Red Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 195,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip-bundle-13pcs?variant=61398910599538"
          },
          {
            "id": "61398910632306",
            "gid": "gid://shopify/ProductVariant/61398910632306",
            "sku": "SET-13xGRIS35BBK",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 195,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip-bundle-13pcs?variant=61398910632306"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black Grip / Blue Cap"
        ],
        "price": 128.25,
        "per_grip_g": 64,
        "total_g": 576.016950663,
        "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip-grip-bundle-set",
        "handle": "iomic-sticky-3-5-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Blue Cap",
              "Black Grip / Red Cap",
              "Black Grip / Black Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021952688189",
            "gid": "gid://shopify/ProductVariant/41021952688189",
            "sku": "SET-9xGRIS35BBL",
            "color": "Black Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 128.25,
            "weight_g": 576.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip-grip-bundle-set?variant=41021952688189"
          },
          {
            "id": "41021952720957",
            "gid": "gid://shopify/ProductVariant/41021952720957",
            "sku": "SET-9xGRIS35BRD",
            "color": "Black Grip / Red Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 128.25,
            "weight_g": 576.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip-grip-bundle-set?variant=41021952720957"
          },
          {
            "id": "41021952753725",
            "gid": "gid://shopify/ProductVariant/41021952753725",
            "sku": "SET-9xGRIS35BBK",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 128.25,
            "weight_g": 576.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip-grip-bundle-set?variant=41021952753725"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black Grip / Blue Cap"
        ],
        "price": 15,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip",
        "handle": "iomic-sticky-3-5-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Blue Cap",
              "Black Grip / Red Cap",
              "Black Grip / Black Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40547396812861",
            "gid": "gid://shopify/ProductVariant/40547396812861",
            "sku": "GRIS35BBL",
            "color": "Black Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 15,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip?variant=40547396812861"
          },
          {
            "id": "40547396845629",
            "gid": "gid://shopify/ProductVariant/40547396845629",
            "sku": "GRIS35BRD",
            "color": "Black Grip / Red Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Red Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip?variant=40547396845629"
          },
          {
            "id": "40547396878397",
            "gid": "gid://shopify/ProductVariant/40547396878397",
            "sku": "GRIS35BBK",
            "color": "Black Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 15,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-3-5-grip?variant=40547396878397"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2023-summer-new-sale, 2025-black-friday, All products, Brand_IOMIC, grip bundle, iomic, iron/wood, Model_IOMIC Sticky, New for 2014, new-add-12172025, single-golf-grips, single-grip, Size_Standard, soft, standard, standard-size-golf-grips, sticky, Sticky 3.5, Style_Swing Grip, tacky, un",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black Grip / Red Cap"
    ]
  },
  {
    "id": "iomic-sticky-army-1-0",
    "brand": "Iomic",
    "model": "Sticky Army 1.0",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Junior"
    ],
    "manufacturer_size_labels": [
      "Junior"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Camo Lavender"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 10.5,
    "price_max": 136.5,
    "single_price_min": 10.5,
    "single_price_max": 10.5,
    "normalized_price_per_grip": 10.5,
    "bundle_price_min": 136.5,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-sticky1-0-army-blue_0ecf8531-238c-49ac-a620-94c037b3ef04.jpg?v=1766010768",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Junior"
        ],
        "format": "13pc bundle",
        "colors": [
          "Camo Lavender"
        ],
        "price": 136.5,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip-bundle-13pcs",
        "handle": "iomic-sticky-army-1-0-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Lavender",
              "Camo Milky Pink",
              "Camo Mint Green",
              "Camo Orange",
              "Camo Sky Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398905356658",
            "gid": "gid://shopify/ProductVariant/61398905356658",
            "sku": "SET-13xARMY1-0LV",
            "color": "Camo Lavender",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Lavender",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip-bundle-13pcs?variant=61398905356658"
          },
          {
            "id": "61398905389426",
            "gid": "gid://shopify/ProductVariant/61398905389426",
            "sku": "SET-13xARMY1-0MP",
            "color": "Camo Milky Pink",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Milky Pink",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip-bundle-13pcs?variant=61398905389426"
          },
          {
            "id": "61398905422194",
            "gid": "gid://shopify/ProductVariant/61398905422194",
            "sku": "SET-13xARMY1-0MG",
            "color": "Camo Mint Green",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Mint Green",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip-bundle-13pcs?variant=61398905422194"
          },
          {
            "id": "61398905454962",
            "gid": "gid://shopify/ProductVariant/61398905454962",
            "sku": "SET-13xARMY1-0OG",
            "color": "Camo Orange",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Orange",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip-bundle-13pcs?variant=61398905454962"
          },
          {
            "id": "61398905487730",
            "gid": "gid://shopify/ProductVariant/61398905487730",
            "sku": "SET-13xARMY1-0SB",
            "color": "Camo Sky Blue",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Sky Blue",
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 136.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip-bundle-13pcs?variant=61398905487730"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "single",
        "colors": [
          "Camo Lavender"
        ],
        "price": 10.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip",
        "handle": "iomic-sticky-army-1-0-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Lavender",
              "Camo Milky Pink",
              "Camo Mint Green",
              "Camo Orange",
              "Camo Sky Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60826215252338",
            "gid": "gid://shopify/ProductVariant/60826215252338",
            "sku": "ARMY1-0LV",
            "color": "Camo Lavender",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Lavender",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip?variant=60826215252338"
          },
          {
            "id": "60826226164082",
            "gid": "gid://shopify/ProductVariant/60826226164082",
            "sku": "ARMY1-0MP",
            "color": "Camo Milky Pink",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Milky Pink",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip?variant=60826226164082"
          },
          {
            "id": "60826226295154",
            "gid": "gid://shopify/ProductVariant/60826226295154",
            "sku": "ARMY1-0MG",
            "color": "Camo Mint Green",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Mint Green",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip?variant=60826226295154"
          },
          {
            "id": "60826227376498",
            "gid": "gid://shopify/ProductVariant/60826227376498",
            "sku": "ARMY1-0OG",
            "color": "Camo Orange",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Orange",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip?variant=60826227376498"
          },
          {
            "id": "60826227900786",
            "gid": "gid://shopify/ProductVariant/60826227900786",
            "sku": "ARMY1-0SB",
            "color": "Camo Sky Blue",
            "size": "Junior",
            "selected_options": {
              "Color": "Camo Sky Blue",
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 10.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-army-1-0-grip?variant=60826227900786"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, golf-grips, grip bundle, iomic, iron/wood, junior, junior-golf-grips, New for 2014, new-add-12172025, single-golf-grips, single-grip, soft, sticky, tacky, under-150, under-300, uv resistant, uv-resistant-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Camo Lavender",
      "Camo Milky Pink",
      "Camo Mint Green",
      "Camo Orange",
      "Camo Sky Blue"
    ]
  },
  {
    "id": "iomic-sticky-black-army-2-3",
    "brand": "Iomic",
    "model": "Sticky Black Army 2.3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "CAMO Black / Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14,
    "price_max": 182,
    "single_price_min": 14,
    "single_price_max": 14,
    "normalized_price_per_grip": 13.3,
    "bundle_price_min": 119.7,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-sticky-black-army-2colors.jpg?v=1766011145",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "CAMO Black / Blue"
        ],
        "price": 182,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip-bundle-13pcs",
        "handle": "iomic-sticky-black-army-2-3-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "CAMO Black / Blue",
              "CAMO Black / Red"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398916825458",
            "gid": "gid://shopify/ProductVariant/61398916825458",
            "sku": "SET-13xGRIPARM23BBL",
            "color": "CAMO Black / Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO Black / Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 182,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip-bundle-13pcs?variant=61398916825458"
          },
          {
            "id": "61398916858226",
            "gid": "gid://shopify/ProductVariant/61398916858226",
            "sku": "SET-13xGRIPARM23BRD",
            "color": "CAMO Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO Black / Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 182,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip-bundle-13pcs?variant=61398916858226"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "CAMO Black / Blue"
        ],
        "price": 119.7,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip-grip-bundle-set",
        "handle": "iomic-sticky-black-army-2-3-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "CAMO Black / Blue",
              "CAMO Black / Red"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021959274557",
            "gid": "gid://shopify/ProductVariant/41021959274557",
            "sku": "SET-9xGRIPARM23BBL",
            "color": "CAMO Black / Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO Black / Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 119.7,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip-grip-bundle-set?variant=41021959274557"
          },
          {
            "id": "41021959307325",
            "gid": "gid://shopify/ProductVariant/41021959307325",
            "sku": "SET-9xGRIPARM23BRD",
            "color": "CAMO Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO Black / Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 119.7,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip-grip-bundle-set?variant=41021959307325"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "CAMO Black / Blue"
        ],
        "price": 14,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip",
        "handle": "iomic-sticky-black-army-2-3-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "CAMO Black / Blue",
              "CAMO Black / Red",
              "CAMO Black / Orange",
              "CAMO Black / Platinum Grey",
              "CAMO Black / Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32888774787133",
            "gid": "gid://shopify/ProductVariant/32888774787133",
            "sku": "GRIPARM23BBL",
            "color": "CAMO Black / Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO Black / Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip?variant=32888774787133"
          },
          {
            "id": "32888774819901",
            "gid": "gid://shopify/ProductVariant/32888774819901",
            "sku": "GRIPARM23BRD",
            "color": "CAMO Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO Black / Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip?variant=32888774819901"
          },
          {
            "id": "61494737437042",
            "gid": "gid://shopify/ProductVariant/61494737437042",
            "sku": "GRIPARM23BOG",
            "color": "CAMO Black / Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO Black / Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip?variant=61494737437042"
          },
          {
            "id": "61494737469810",
            "gid": "gid://shopify/ProductVariant/61494737469810",
            "sku": "GRIPARM23BPLG",
            "color": "CAMO Black / Platinum Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO Black / Platinum Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip?variant=61494737469810"
          },
          {
            "id": "61494737502578",
            "gid": "gid://shopify/ProductVariant/61494737502578",
            "sku": "GRIPARM23BYL",
            "color": "CAMO Black / Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO Black / Yellow",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-black-army-2-3-grip?variant=61494737502578"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, golf-grips, grip bundle, iomic, IOMIC Army, iomic camo, iron/wood, New for 2014, new-add-12172025, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, sticky, Sticky 2.3 Army, Sticky Black Army, tacky, under-150, under-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "CAMO Black / Blue",
      "CAMO Black / Red",
      "CAMO Black / Orange",
      "CAMO Black / Platinum Grey",
      "CAMO Black / Yellow"
    ]
  },
  {
    "id": "iomic-sticky-camo-1-8",
    "brand": "Iomic",
    "model": "Sticky Camo 1.8",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Camo Green",
      "Camo Pink"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14,
    "price_max": 195.48,
    "single_price_min": 14,
    "single_price_max": 14,
    "normalized_price_per_grip": 13.3,
    "bundle_price_min": 119.7,
    "kit_price_min": 195.48,
    "url": "https://www.grips4less.com/products/iomic-sticky-camo-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Camo_pink.jpg?v=1766011409",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 5,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Camo Pink"
        ],
        "price": 182,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-camo-grip-bundle-13pcs",
        "handle": "iomic-sticky-camo-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398924591474",
            "gid": "gid://shopify/ProductVariant/61398924591474",
            "sku": "SET-13xGRISCAPK",
            "color": "Camo Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Camo Pink",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 182,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-grip-bundle-13pcs?variant=61398924591474"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Pink"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Camo Pink"
        ],
        "price": 119.7,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-sticky-camo-grip-grip-bundle-set",
        "handle": "iomic-sticky-camo-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021970513981",
            "gid": "gid://shopify/ProductVariant/41021970513981",
            "sku": "SET-9xGRISCAPK",
            "color": "Camo Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Camo Pink",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 119.7,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-grip-grip-bundle-set?variant=41021970513981"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Pink"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Camo Pink"
        ],
        "price": 195.48,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-camo-1-8-grip-pink",
        "handle": "grip-kit-13x-iomic-sticky-camo-1-8-grip-pink",
        "shopify_variants": [
          {
            "id": "32423488775",
            "gid": "gid://shopify/ProductVariant/32423488775",
            "sku": "KIT+13xGRISCAPK",
            "color": "Camo Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Camo Pink",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 195.48,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-camo-1-8-grip-pink?variant=32423488775"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Pink"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Camo Green"
        ],
        "price": 195.48,
        "per_grip_g": 59.3,
        "total_g": 771.107029,
        "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-camo-1-8-grip-green",
        "handle": "grip-kit-13x-iomic-sticky-camo-1-8-grip-green",
        "shopify_variants": [
          {
            "id": "32423486919",
            "gid": "gid://shopify/ProductVariant/32423486919",
            "sku": "KIT+13xGRISCAGN",
            "color": "Camo Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Camo Green",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 195.48,
            "weight_g": 771.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-camo-1-8-grip-green?variant=32423486919"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16_tranche1"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Camo Pink"
        ],
        "price": 14,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-camo-grip",
        "handle": "iomic-sticky-camo-grip",
        "shopify_variants": [
          {
            "id": "551602037",
            "gid": "gid://shopify/ProductVariant/551602037",
            "sku": "GRISCAPK",
            "color": "Camo Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Camo Pink",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-grip?variant=551602037"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Pink"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, camo, gifts-for-her, golf-grips, grip bundle, iomic, iomic camo, iron/wood, ladies, New for 2016, new-add-12172025, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, sticky, Sticky Camo, tacky, under-150, under-300, u",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Camo Pink"
    ]
  },
  {
    "id": "iomic-sticky-camo-2-3",
    "brand": "Iomic",
    "model": "Sticky Camo 2.3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Camo Blue",
      "Camo Gray",
      "Camo Green"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14,
    "price_max": 185.71,
    "single_price_min": 14,
    "single_price_max": 14,
    "normalized_price_per_grip": 13.3,
    "bundle_price_min": 119.7,
    "kit_price_min": 185.71,
    "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/sticky-camo-23-4colors.jpg?v=1766011363",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Camo Gray"
        ],
        "price": 182,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip-bundle-13pcs",
        "handle": "iomic-sticky-camo-2-3-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Gray",
              "Camo Green",
              "Camo Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398924034418",
            "gid": "gid://shopify/ProductVariant/61398924034418",
            "sku": "SET-13xGRISCA23GY",
            "color": "Camo Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Gray",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 182,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip-bundle-13pcs?variant=61398924034418"
          },
          {
            "id": "61398924067186",
            "gid": "gid://shopify/ProductVariant/61398924067186",
            "sku": "SET-13xGRISCA23GN",
            "color": "Camo Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Green",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 182,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip-bundle-13pcs?variant=61398924067186"
          },
          {
            "id": "61398924099954",
            "gid": "gid://shopify/ProductVariant/61398924099954",
            "sku": "SET-13xGRISCA23BL",
            "color": "Camo Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 182,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip-bundle-13pcs?variant=61398924099954"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Camo Gray"
        ],
        "price": 119.7,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip-grip-bundle-set",
        "handle": "iomic-sticky-camo-2-3-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Gray",
              "Camo Green",
              "Camo Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021967630397",
            "gid": "gid://shopify/ProductVariant/41021967630397",
            "sku": "SET-9xGRISCA23GY",
            "color": "Camo Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Gray",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.7,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip-grip-bundle-set?variant=41021967630397"
          },
          {
            "id": "41021967663165",
            "gid": "gid://shopify/ProductVariant/41021967663165",
            "sku": "SET-9xGRISCA23GN",
            "color": "Camo Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Green",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 119.7,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip-grip-bundle-set?variant=41021967663165"
          },
          {
            "id": "41021967695933",
            "gid": "gid://shopify/ProductVariant/41021967695933",
            "sku": "SET-9xGRISCA23BL",
            "color": "Camo Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 119.7,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip-grip-bundle-set?variant=41021967695933"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Camo Blue"
        ],
        "price": 185.71,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-camo-2-3-grip-blue",
        "handle": "grip-kit-13x-iomic-sticky-camo-2-3-grip-blue",
        "shopify_variants": [
          {
            "id": "32423178375",
            "gid": "gid://shopify/ProductVariant/32423178375",
            "sku": "KIT+13xGRISCA23BL",
            "color": "Camo Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 185.71,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-camo-2-3-grip-blue?variant=32423178375"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Camo Green"
        ],
        "price": 185.71,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-camo-2-3-grip-green",
        "handle": "grip-kit-13x-iomic-sticky-camo-2-3-grip-green",
        "shopify_variants": [
          {
            "id": "32423051079",
            "gid": "gid://shopify/ProductVariant/32423051079",
            "sku": "KIT+13xGRISCA23GN",
            "color": "Camo Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Green",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 185.71,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-camo-2-3-grip-green?variant=32423051079"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Camo Gray"
        ],
        "price": 185.71,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13xiomic-sticky-camo-2-3-grip-grey",
        "handle": "grip-kit-13xiomic-sticky-camo-2-3-grip-grey",
        "shopify_variants": [
          {
            "id": "32422823175",
            "gid": "gid://shopify/ProductVariant/32422823175",
            "sku": "KIT+13xGRISCA23GY",
            "color": "Camo Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Gray",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 185.71,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13xiomic-sticky-camo-2-3-grip-grey?variant=32422823175"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Camo Gray"
        ],
        "price": 14,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip",
        "handle": "iomic-sticky-camo-2-3-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Gray",
              "Camo Green",
              "Camo Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14011536903",
            "gid": "gid://shopify/ProductVariant/14011536903",
            "sku": "GRISCA23GY",
            "color": "Camo Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Gray"
            },
            "available": false,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip?variant=14011536903"
          },
          {
            "id": "14011536967",
            "gid": "gid://shopify/ProductVariant/14011536967",
            "sku": "GRISCA23GN",
            "color": "Camo Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Green"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip?variant=14011536967"
          },
          {
            "id": "14011537095",
            "gid": "gid://shopify/ProductVariant/14011537095",
            "sku": "GRISCA23BL",
            "color": "Camo Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Camo Blue"
            },
            "available": false,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-camo-2-3-grip?variant=14011537095"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, camo, golf-grips, grip bundle, iomic, iomic camo, iron/wood, New for 2014, new-add-12172025, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, sticky, Sticky Camo, tacky, under-150, under-300, uv resistant, uv-resista",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Camo Green"
    ]
  },
  {
    "id": "iomic-sticky-mid",
    "brand": "Iomic",
    "model": "Sticky Mid",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc bundle",
      "13pc kit",
      "single"
    ],
    "colors_available": [
      "Navy Body / Black Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.75,
    "price_max": 207.32,
    "single_price_min": 15.75,
    "single_price_max": 15.75,
    "normalized_price_per_grip": 15.75,
    "bundle_price_min": 204.75,
    "kit_price_min": 207.32,
    "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-sticky-mid.jpg?v=1766011432",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Navy Body / Black Cap"
        ],
        "price": 204.75,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-bundle-13pcs",
        "handle": "iomic-sticky-mid-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy Body / Black Cap",
              "White Body / Black Cap",
              "Blue Body / Black Cap",
              "Black Body / Black Cap",
              "Red Body / Black Cap",
              "Platinum Grey Body / Black Cap",
              "Sky Blue Body / Black Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398925017458",
            "gid": "gid://shopify/ProductVariant/61398925017458",
            "sku": "SET-13xSMDNAVY",
            "color": "Navy Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Navy Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 204.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-bundle-13pcs?variant=61398925017458"
          },
          {
            "id": "61398925050226",
            "gid": "gid://shopify/ProductVariant/61398925050226",
            "sku": "SET-13xGRISMWHT",
            "color": "White Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "White Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 204.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-bundle-13pcs?variant=61398925050226"
          },
          {
            "id": "61398925082994",
            "gid": "gid://shopify/ProductVariant/61398925082994",
            "sku": "SET-13xGRISMBLU",
            "color": "Blue Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 204.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-bundle-13pcs?variant=61398925082994"
          },
          {
            "id": "61398925115762",
            "gid": "gid://shopify/ProductVariant/61398925115762",
            "sku": "SET-13xGRISMBK",
            "color": "Black Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 204.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-bundle-13pcs?variant=61398925115762"
          },
          {
            "id": "61398925148530",
            "gid": "gid://shopify/ProductVariant/61398925148530",
            "sku": "SET-13xGRISMRD",
            "color": "Red Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 204.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-bundle-13pcs?variant=61398925148530"
          },
          {
            "id": "61398925181298",
            "gid": "gid://shopify/ProductVariant/61398925181298",
            "sku": "SET-13xGRISMPLG",
            "color": "Platinum Grey Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Platinum Grey Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 204.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-bundle-13pcs?variant=61398925181298"
          },
          {
            "id": "61398925214066",
            "gid": "gid://shopify/ProductVariant/61398925214066",
            "sku": "SET-13xGRISMSBLU",
            "color": "Sky Blue Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Sky Blue Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 204.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-bundle-13pcs?variant=61398925214066"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Navy Body / Black Cap"
        ],
        "price": 207.32,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit",
        "handle": "iomic-sticky-mid-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy Body / Black Cap",
              "Red Body / Black Cap",
              "White Body / Black Cap",
              "Blue Body / Black Cap",
              "Black Body / Black Cap",
              "Platinum Grey Body / Black Cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007849672765",
            "gid": "gid://shopify/ProductVariant/32007849672765",
            "sku": "KIT+13xSMDNAVY",
            "color": "Navy Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Navy Body / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 207.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=32007849672765"
          },
          {
            "id": "40215678451773",
            "gid": "gid://shopify/ProductVariant/40215678451773",
            "sku": "KIT(8oz)+13xSMDNAVY",
            "color": "Navy Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Navy Body / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 212.26,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=40215678451773"
          },
          {
            "id": "39473163567165",
            "gid": "gid://shopify/ProductVariant/39473163567165",
            "sku": "KIT+13xGRISMRD",
            "color": "Red Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red Body / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 207.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=39473163567165"
          },
          {
            "id": "40215678484541",
            "gid": "gid://shopify/ProductVariant/40215678484541",
            "sku": "KIT(8oz)+13xGRISMRD",
            "color": "Red Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red Body / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 212.26,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=40215678484541"
          },
          {
            "id": "32007849705533",
            "gid": "gid://shopify/ProductVariant/32007849705533",
            "sku": "KIT+13xGRISMWHT",
            "color": "White Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "White Body / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 207.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=32007849705533"
          },
          {
            "id": "40215678517309",
            "gid": "gid://shopify/ProductVariant/40215678517309",
            "sku": "KIT(8oz)+13xGRISMWHT",
            "color": "White Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "White Body / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 212.26,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=40215678517309"
          },
          {
            "id": "32007849738301",
            "gid": "gid://shopify/ProductVariant/32007849738301",
            "sku": "KIT+13xGRISMBLU",
            "color": "Blue Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue Body / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 207.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=32007849738301"
          },
          {
            "id": "40215678550077",
            "gid": "gid://shopify/ProductVariant/40215678550077",
            "sku": "KIT(8oz)+13xGRISMBLU",
            "color": "Blue Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue Body / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 212.26,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=40215678550077"
          },
          {
            "id": "32007849771069",
            "gid": "gid://shopify/ProductVariant/32007849771069",
            "sku": "KIT+13xGRISMBK",
            "color": "Black Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black Body / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 207.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=32007849771069"
          },
          {
            "id": "40215678582845",
            "gid": "gid://shopify/ProductVariant/40215678582845",
            "sku": "KIT(8oz)+13xGRISMBK",
            "color": "Black Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black Body / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 212.26,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=40215678582845"
          },
          {
            "id": "32007849803837",
            "gid": "gid://shopify/ProductVariant/32007849803837",
            "sku": "KIT+13xGRISMPLG",
            "color": "Platinum Grey Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Platinum Grey Body / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 207.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=32007849803837"
          },
          {
            "id": "40215678615613",
            "gid": "gid://shopify/ProductVariant/40215678615613",
            "sku": "KIT(8oz)+13xGRISMPLG",
            "color": "Platinum Grey Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Platinum Grey Body / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 212.26,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip-13pcs-golf-grip-kit?variant=40215678615613"
          }
        ],
        "shopify_variant_count": 12,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Navy Body / Black Cap"
        ],
        "price": 15.75,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip",
        "handle": "iomic-sticky-mid-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy Body / Black Cap",
              "White Body / Black Cap",
              "Blue Body / Black Cap",
              "Black Body / Black Cap",
              "Red Body / Black Cap",
              "Platinum Grey Body / Black Cap",
              "Sky Blue Body / Black Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "53092080659",
            "gid": "gid://shopify/ProductVariant/53092080659",
            "sku": "SMDNAVY",
            "color": "Navy Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Navy Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip?variant=53092080659"
          },
          {
            "id": "31907119988797",
            "gid": "gid://shopify/ProductVariant/31907119988797",
            "sku": "GRISMWHT",
            "color": "White Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "White Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip?variant=31907119988797"
          },
          {
            "id": "210512785",
            "gid": "gid://shopify/ProductVariant/210512785",
            "sku": "GRISMBLU",
            "color": "Blue Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip?variant=210512785"
          },
          {
            "id": "210512773",
            "gid": "gid://shopify/ProductVariant/210512773",
            "sku": "GRISMBK",
            "color": "Black Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip?variant=210512773"
          },
          {
            "id": "210512775",
            "gid": "gid://shopify/ProductVariant/210512775",
            "sku": "GRISMRD",
            "color": "Red Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip?variant=210512775"
          },
          {
            "id": "31908958404669",
            "gid": "gid://shopify/ProductVariant/31908958404669",
            "sku": "GRISMPLG",
            "color": "Platinum Grey Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Platinum Grey Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip?variant=31908958404669"
          },
          {
            "id": "52345183830386",
            "gid": "gid://shopify/ProductVariant/52345183830386",
            "sku": "GRISMSBLU",
            "color": "Sky Blue Body / Black Cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Sky Blue Body / Black Cap",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 15.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-mid-grip?variant=52345183830386"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, golf-grips, grip bundle, iomic, iron/wood, medium firm, midsize, midsize-golf-grips, new-add-12172025, overstock-oct-2022, overstock-oct-2023, single-golf-grips, single-grip, sticky, tacky, under-150, under-300, uv resistant, uv-resistant-go",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet Public 9pc bundle handle removed on 2026-07-13 because it returns 404 on the published storefront.",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Navy Body / Black Cap",
      "Blue Body / Black Cap",
      "Black Body / Black Cap",
      "Red Body / Black Cap",
      "Platinum Grey Body / Black Cap",
      "Sky Blue Body / Black Cap",
      "White Body / Black Cap"
    ]
  },
  {
    "id": "iomic-sticky-mid-red",
    "brand": "Iomic",
    "model": "Sticky Mid Red",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Red / Black cap"
    ],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 207.32,
    "price_max": 207.32,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 15.95,
    "bundle_price_min": null,
    "kit_price_min": 207.32,
    "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-mid-red-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gripkit-13iomicstickyred_b904bbab-9392-4988-bcca-c302c78cf773.jpg?v=1752716640",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "Red / Black cap"
        ],
        "price": 207.32,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-mid-red-grips",
        "handle": "grip-kit-13x-iomic-sticky-mid-red-grips",
        "shopify_variants": [
          {
            "id": "451071321",
            "gid": "gid://shopify/ProductVariant/451071321",
            "sku": "KIT+13xGRISMRD",
            "color": "Red / Black cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / Black cap"
            },
            "available": true,
            "price": 207.32,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-iomic-sticky-mid-red-grips?variant=451071321"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / Black cap"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "150-200, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripki",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red / Black cap"
    ]
  },
  {
    "id": "iomic-sticky-opus-2",
    "brand": "Iomic",
    "model": "Sticky Opus 2",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White / Orange"
    ],
    "weight_g_by_size": {
      "Unspecified": 45.4
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12,
    "price_max": 12,
    "single_price_min": 12,
    "single_price_max": 12,
    "normalized_price_per_grip": 12,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-opus-2",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/opus2_allcolors.png?v=1752715275",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White / Orange"
        ],
        "price": 12,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/iomic-sticky-opus-2",
        "handle": "iomic-sticky-opus-2",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Orange",
              "White / Green"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "690592849",
            "gid": "gid://shopify/ProductVariant/690592849",
            "sku": "GRISOS2O",
            "color": "White / Orange",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White / Orange"
            },
            "available": false,
            "price": 12,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-2?variant=690592849"
          },
          {
            "id": "1096309473299",
            "gid": "gid://shopify/ProductVariant/1096309473299",
            "sku": "GRISOS2G",
            "color": "White / Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White / Green"
            },
            "available": false,
            "price": 12,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-2?variant=1096309473299"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, all-weather, gifts-for-her, golf-grips, infinite-opt-addkit, iomic, iron/wood, opus, single-golf-grips, single-grip, soft, sticky, tacky, under-150, under-300, undersize, undersize-golf-grips, uv resistant, video=qq1CToDcULM, womens, x-grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-sticky-opus-3",
    "brand": "Iomic",
    "model": "Sticky Opus 3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Navy / White"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9,
    "price_max": 9,
    "single_price_min": 9,
    "single_price_max": 9,
    "normalized_price_per_grip": 9,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-opus-3",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/opus_3_allcolors_15d98e31-b7d0-470a-ad74-b7ca8fa2c072.png?v=1752715208",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Navy / White"
        ],
        "price": 9,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-sticky-opus-3",
        "handle": "iomic-sticky-opus-3",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy / White",
              "Blue / White",
              "Beige / White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461786550333",
            "gid": "gid://shopify/ProductVariant/39461786550333",
            "sku": "GRISOS3N",
            "color": "Navy / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Navy / White"
            },
            "available": true,
            "price": 9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-3?variant=39461786550333"
          },
          {
            "id": "39461786583101",
            "gid": "gid://shopify/ProductVariant/39461786583101",
            "sku": "GRISOS3U",
            "color": "Blue / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / White"
            },
            "available": true,
            "price": 9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-3?variant=39461786583101"
          },
          {
            "id": "39461786615869",
            "gid": "gid://shopify/ProductVariant/39461786615869",
            "sku": "GRISOS3NBG",
            "color": "Beige / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Beige / White"
            },
            "available": true,
            "price": 9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-3?variant=39461786615869"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_IOMIC, gifts-for-her, iomic, iron/wood, Model_IOMIC Sticky, opus, single-golf-grips, single-grip, Size_Undersize, soft, sticky, Style_Swing Grip, tacky, under-150, undersize, undersize-golf-grips, video=qq1CToDcULM, womens",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Navy / White",
      "Blue / White",
      "Beige / White"
    ]
  },
  {
    "id": "iomic-sticky-opus-bc-1-8",
    "brand": "Iomic",
    "model": "Sticky Opus BC 1.8",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Coral Red/Orange"
    ],
    "weight_g_by_size": {
      "Undersize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.5,
    "price_max": 13.5,
    "single_price_min": 13.5,
    "single_price_max": 13.5,
    "normalized_price_per_grip": 13.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-opus-bc-1-8-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPTImageJan13_2026_01_31_26PM.png?v=1768345374",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Coral Red/Orange"
        ],
        "price": 13.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-opus-bc-1-8-undersize-grip",
        "handle": "iomic-sticky-opus-bc-1-8-undersize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Coral Red/Orange",
              "Blue/Sky Blue",
              "Platinum Grey/Silver Grey",
              "Pink/Milky Pink",
              "Violet/Lavender",
              "Black / Gold"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61497002033522",
            "gid": "gid://shopify/ProductVariant/61497002033522",
            "sku": "OPSBC1.8CR",
            "color": "Coral Red/Orange",
            "size": "Undersize",
            "selected_options": {
              "Color": "Coral Red/Orange"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-bc-1-8-undersize-grip?variant=61497002033522"
          },
          {
            "id": "61497002066290",
            "gid": "gid://shopify/ProductVariant/61497002066290",
            "sku": "OPSBC1.8BU",
            "color": "Blue/Sky Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blue/Sky Blue"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-bc-1-8-undersize-grip?variant=61497002066290"
          },
          {
            "id": "61497002099058",
            "gid": "gid://shopify/ProductVariant/61497002099058",
            "sku": "OPSBC1.8PG",
            "color": "Platinum Grey/Silver Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Platinum Grey/Silver Grey"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-bc-1-8-undersize-grip?variant=61497002099058"
          },
          {
            "id": "61497002131826",
            "gid": "gid://shopify/ProductVariant/61497002131826",
            "sku": "OPSBC1.8PK",
            "color": "Pink/Milky Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink/Milky Pink"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-bc-1-8-undersize-grip?variant=61497002131826"
          },
          {
            "id": "61497002164594",
            "gid": "gid://shopify/ProductVariant/61497002164594",
            "sku": "OPSBC1.8VL",
            "color": "Violet/Lavender",
            "size": "Undersize",
            "selected_options": {
              "Color": "Violet/Lavender"
            },
            "available": true,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-bc-1-8-undersize-grip?variant=61497002164594"
          },
          {
            "id": "61498925810034",
            "gid": "gid://shopify/ProductVariant/61498925810034",
            "sku": "OPSBC1.8GD",
            "color": "Black / Gold",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Gold"
            },
            "available": false,
            "price": 13.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-bc-1-8-undersize-grip?variant=61498925810034"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_IOMIC, firm, iomic, Iomic golf grips, Iomic grip, Iomic Sticky Grip, iron/wood, New for 2015, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Sticky 1.8, Sticky Opus Grip, Style_Swing Grip, tacky, under-150, undersize, undersize-golf-g",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Coral Red/Orange",
      "Blue/Sky Blue",
      "Platinum Grey/Silver Grey",
      "Pink/Milky Pink",
      "Violet/Lavender"
    ]
  },
  {
    "id": "iomic-sticky-opus3-1-8",
    "brand": "Iomic",
    "model": "Sticky Opus3 1.8",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Navy / White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 11,
    "price_max": 11,
    "single_price_min": 11,
    "single_price_max": 11,
    "normalized_price_per_grip": 11,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-opus-3-1-8",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-stickyopus3-1-8-colors.jpg?v=1752715273",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Navy / White"
        ],
        "price": 11,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-opus-3-1-8",
        "handle": "iomic-sticky-opus-3-1-8",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy / White",
              "Blue / White",
              "Beige / White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "344209283",
            "gid": "gid://shopify/ProductVariant/344209283",
            "sku": "GRISOS3N",
            "color": "Navy / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Navy / White"
            },
            "available": false,
            "price": 11,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-3-1-8?variant=344209283"
          },
          {
            "id": "344210189",
            "gid": "gid://shopify/ProductVariant/344210189",
            "sku": "GRISOS3U",
            "color": "Blue / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / White"
            },
            "available": false,
            "price": 11,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-3-1-8?variant=344210189"
          },
          {
            "id": "344210351",
            "gid": "gid://shopify/ProductVariant/344210351",
            "sku": "GRISOS3NBG",
            "color": "Beige / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Beige / White"
            },
            "available": false,
            "price": 11,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus-3-1-8?variant=344210351"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.8, 49 under, All Products, all-weather, gifts-for-her, golf-grips, infinite-opt-addkit, iomic, iron/wood, ladies, opus, single-golf-grips, single-grip, soft, sticky, tacky, under-150, under-300, undersize, undersize-golf-grips, uv resistant, video=qq1CToDcULM, womens",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-sticky-opus3-2-3",
    "brand": "Iomic",
    "model": "Sticky Opus3 2.3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Navy / White"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 11,
    "price_max": 11,
    "single_price_min": 11,
    "single_price_max": 11,
    "normalized_price_per_grip": 11,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-opus3-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/stickyopus3-23-colors_64220045-d062-4986-834b-d4d7ad3c60f1.jpg?v=1752715238",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Navy / White"
        ],
        "price": 11,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-sticky-opus3-2-3-grip",
        "handle": "iomic-sticky-opus3-2-3-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy / White",
              "Orange / White",
              "Coral Red / White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "425854730259",
            "gid": "gid://shopify/ProductVariant/425854730259",
            "sku": "OPS32-3NV",
            "color": "Navy / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Navy / White"
            },
            "available": true,
            "price": 11,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus3-2-3-grip?variant=425854730259"
          },
          {
            "id": "425854795795",
            "gid": "gid://shopify/ProductVariant/425854795795",
            "sku": "OPS32-3OG",
            "color": "Orange / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange / White"
            },
            "available": true,
            "price": 11,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus3-2-3-grip?variant=425854795795"
          },
          {
            "id": "837330468883",
            "gid": "gid://shopify/ProductVariant/837330468883",
            "sku": "OPS32-3CR",
            "color": "Coral Red / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Coral Red / White"
            },
            "available": true,
            "price": 11,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-opus3-2-3-grip?variant=837330468883"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_IOMIC, iomic, iron/wood, Model_IOMIC Sticky, New for 2016, New for 2017, opus, single-golf-grips, single-grip, Size_Standard, soft, standard, standard-size-golf-grips, sticky, Style_Swing Grip, tacky, under-150, video=qq1CToDcULM, womens",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Navy / White",
      "Orange / White",
      "Coral Red / White"
    ]
  },
  {
    "id": "iomic-x-evolution",
    "brand": "Iomic",
    "model": "X-Evolution",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Evolution Grip",
      "Red Grip / Black Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13,
    "price_max": 169,
    "single_price_min": 13,
    "single_price_max": 13,
    "normalized_price_per_grip": 13,
    "bundle_price_min": 169,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-x-evolution-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/X_evo_bk_f34779ca-9dc3-4e78-a802-59ec07e12317.png?v=1766014024",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc bundle",
        "colors": [
          "Evolution Grip",
          "Red Grip / Black Cap"
        ],
        "price": 169,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-x-evolution-grip-bundle-13pcs",
        "handle": "iomic-x-evolution-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Grip / Black Cap",
              "Black Grip / Blue Cap",
              "Sky Blue Grip / Yellow Cap",
              "Navy Grip / Sky Blue Cap",
              "White Grip / Red Cap"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398924853618",
            "gid": "gid://shopify/ProductVariant/61398924853618",
            "sku": "SET-13xGRIXERB",
            "color": "Red Grip / Black Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red Grip / Black Cap"
            },
            "available": false,
            "price": 169,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip-bundle-13pcs?variant=61398924853618"
          },
          {
            "id": "61398924886386",
            "gid": "gid://shopify/ProductVariant/61398924886386",
            "sku": "SET-13xGRIXEBBL",
            "color": "Black Grip / Blue Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black Grip / Blue Cap"
            },
            "available": false,
            "price": 169,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip-bundle-13pcs?variant=61398924886386"
          },
          {
            "id": "61398924919154",
            "gid": "gid://shopify/ProductVariant/61398924919154",
            "sku": "SET-13xGRIX26SKBYLW",
            "color": "Sky Blue Grip / Yellow Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Sky Blue Grip / Yellow Cap"
            },
            "available": true,
            "price": 169,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip-bundle-13pcs?variant=61398924919154"
          },
          {
            "id": "61398924951922",
            "gid": "gid://shopify/ProductVariant/61398924951922",
            "sku": "SET-13xGRIX26NVBSB",
            "color": "Navy Grip / Sky Blue Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Navy Grip / Sky Blue Cap"
            },
            "available": true,
            "price": 169,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip-bundle-13pcs?variant=61398924951922"
          },
          {
            "id": "61398924984690",
            "gid": "gid://shopify/ProductVariant/61398924984690",
            "sku": "SET-13xGRIX26WHTCR",
            "color": "White Grip / Red Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White Grip / Red Cap"
            },
            "available": false,
            "price": 169,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip-bundle-13pcs?variant=61398924984690"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Evolution Grip",
          "Red Grip / Black Cap"
        ],
        "price": 13,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-x-evolution-grip",
        "handle": "iomic-x-evolution-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red Grip / Black Cap",
              "Black Grip / Blue Cap",
              "Sky Blue Grip / Yellow Cap",
              "Navy Grip / Sky Blue Cap",
              "White Grip / Red Cap"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "283136558",
            "gid": "gid://shopify/ProductVariant/283136558",
            "sku": "GRIXERB",
            "color": "Red Grip / Black Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red Grip / Black Cap"
            },
            "available": false,
            "price": 13,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip?variant=283136558"
          },
          {
            "id": "39461816565821",
            "gid": "gid://shopify/ProductVariant/39461816565821",
            "sku": "GRIXEBBL",
            "color": "Black Grip / Blue Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black Grip / Blue Cap"
            },
            "available": false,
            "price": 13,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip?variant=39461816565821"
          },
          {
            "id": "51849998598514",
            "gid": "gid://shopify/ProductVariant/51849998598514",
            "sku": "GRIX26SKBYLW",
            "color": "Sky Blue Grip / Yellow Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Sky Blue Grip / Yellow Cap"
            },
            "available": true,
            "price": 13,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip?variant=51849998598514"
          },
          {
            "id": "51850008363378",
            "gid": "gid://shopify/ProductVariant/51850008363378",
            "sku": "GRIX26NVBSB",
            "color": "Navy Grip / Sky Blue Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Navy Grip / Sky Blue Cap"
            },
            "available": true,
            "price": 13,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip?variant=51850008363378"
          },
          {
            "id": "51850009051506",
            "gid": "gid://shopify/ProductVariant/51850009051506",
            "sku": "GRIX26WHTCR",
            "color": "White Grip / Red Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White Grip / Red Cap"
            },
            "available": true,
            "price": 13,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-evolution-grip?variant=51850009051506"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2023-sale, 2025-black-friday, All Products, all-weather, golf-grips, grip bundle, infinite-opt-addkit, iomic, iron/wood, medium firm, mem25, new-add-12172025, prime-2025, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, uv resistant, uv-resistant",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Sky Blue Grip / Yellow Cap",
      "Navy Grip / Sky Blue Cap",
      "White Grip / Red Cap"
    ]
  },
  {
    "id": "iomic-x-grip",
    "brand": "Iomic",
    "model": "X-Grip",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black Grip / Yellow Cap",
      "Grip"
    ],
    "weight_g_by_size": {
      "Standard": 59.3,
      "Unspecified": 64
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 10,
    "price_max": 143.48,
    "single_price_min": 10,
    "single_price_max": 10,
    "normalized_price_per_grip": 10,
    "bundle_price_min": null,
    "kit_price_min": 143.48,
    "url": "https://www.grips4less.com/products/iomic-x-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gripkit-13iomic-xgrip.jpg?v=1752715272",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black Grip / Yellow Cap"
        ],
        "price": 143.48,
        "per_grip_g": 59.3,
        "total_g": 771.107029,
        "url": "https://www.grips4less.com/products/iomic-x-grip-standard-grip-kit",
        "handle": "iomic-x-grip-standard-grip-kit",
        "shopify_variants": [
          {
            "id": "430255413",
            "gid": "gid://shopify/ProductVariant/430255413",
            "sku": "KIT+13xGRIXBLY",
            "color": "Black Grip / Yellow Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black Grip / Yellow Cap"
            },
            "available": false,
            "price": 143.48,
            "weight_g": 771.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-x-grip-standard-grip-kit?variant=430255413"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Yellow Cap"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black Grip / Yellow Cap",
          "Grip"
        ],
        "price": 10,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-x-grip",
        "handle": "iomic-x-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black Grip / Yellow Cap",
              "Red Grip / Black Cap"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "210513239",
            "gid": "gid://shopify/ProductVariant/210513239",
            "sku": "GRIXBLY",
            "color": "Black Grip / Yellow Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black Grip / Yellow Cap"
            },
            "available": true,
            "price": 10,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip?variant=210513239"
          },
          {
            "id": "39461786517565",
            "gid": "gid://shopify/ProductVariant/39461786517565",
            "sku": "GRIXRBL",
            "color": "Red Grip / Black Cap",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red Grip / Black Cap"
            },
            "available": true,
            "price": 10,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip?variant=39461786517565"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, gripkit-freetowel-2026, iomic, iron/wood, labor-day-bundle-sale-2025, labor-da",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black Grip / Yellow Cap",
      "Red Grip / Black Cap"
    ]
  },
  {
    "id": "iomic-x-grip-2-3",
    "brand": "Iomic",
    "model": "X-Grip 2.3",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Platinum Grey Grip / Black Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 12.5,
    "price_max": 175.98,
    "single_price_min": 12.5,
    "single_price_max": 12.5,
    "normalized_price_per_grip": 12.5,
    "bundle_price_min": 162.5,
    "kit_price_min": 175.98,
    "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-xgrip-23.jpg?v=1766011102",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Platinum Grey Grip / Black Cap"
        ],
        "price": 162.5,
        "per_grip_g": 4.9,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-bundle-13pcs",
        "handle": "iomic-x-grip-2-3-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Platinum Grey Grip / Black Cap",
              "Sky Blue Grip / Blue Cap",
              "(Special Limited Tour Edition) Black Grip / Sky Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398914826610",
            "gid": "gid://shopify/ProductVariant/61398914826610",
            "sku": "SET-13xGRIX23GRY",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 162.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-bundle-13pcs?variant=61398914826610"
          },
          {
            "id": "61398914859378",
            "gid": "gid://shopify/ProductVariant/61398914859378",
            "sku": "SET-13xGRIX23SKB",
            "color": "Sky Blue Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 162.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-bundle-13pcs?variant=61398914859378"
          },
          {
            "id": "61398914892146",
            "gid": "gid://shopify/ProductVariant/61398914892146",
            "sku": "SET-13xGRIX23SEBSB",
            "color": "(Special Limited Tour Edition) Black Grip / Sky Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "(Special Limited Tour Edition) Black Grip / Sky Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 162.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-bundle-13pcs?variant=61398914892146"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Platinum Grey Grip / Black Cap"
        ],
        "price": 175.98,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-13pcs-golf-grip-kit",
        "handle": "iomic-x-grip-2-3-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Platinum Grey Grip / Black Cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39469623803965",
            "gid": "gid://shopify/ProductVariant/39469623803965",
            "sku": "KIT+13xGRIX23GRY",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 175.98,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-13pcs-golf-grip-kit?variant=39469623803965"
          },
          {
            "id": "40215678058557",
            "gid": "gid://shopify/ProductVariant/40215678058557",
            "sku": "KIT(8oz)+13xGRIX23GRY",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 181.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-13pcs-golf-grip-kit?variant=40215678058557"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Platinum Grey Grip / Black Cap"
        ],
        "price": 12.5,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip",
        "handle": "iomic-x-grip-2-3-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Platinum Grey Grip / Black Cap",
              "Sky Blue Grip / Blue Cap",
              "(Special Limited Tour Edition) Black Grip / Sky Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39467473174589",
            "gid": "gid://shopify/ProductVariant/39467473174589",
            "sku": "GRIX23GRY",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip?variant=39467473174589"
          },
          {
            "id": "40133595430973",
            "gid": "gid://shopify/ProductVariant/40133595430973",
            "sku": "GRIX23SKB",
            "color": "Sky Blue Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip?variant=40133595430973"
          },
          {
            "id": "52336363471218",
            "gid": "gid://shopify/ProductVariant/52336363471218",
            "sku": "GRIX23SEBSB",
            "color": "(Special Limited Tour Edition) Black Grip / Sky Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "(Special Limited Tour Edition) Black Grip / Sky Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 12.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip?variant=52336363471218"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All products, Brand_IOMIC, grip bundle, iomic, iron/wood, medium firm, Model_IOMIC X-Grip, new-add-12172025, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150, video=qq1CToDcULM, x-grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Platinum Grey Grip / Black Cap",
      "Sky Blue Grip / Blue Cap"
    ]
  },
  {
    "id": "iomic-x-grip-opus-1",
    "brand": "Iomic",
    "model": "X-Grip Opus 1",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Yellow / Orange"
    ],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9,
    "price_max": 9,
    "single_price_min": 9,
    "single_price_max": 9,
    "normalized_price_per_grip": 9,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-x-grip-opus-1",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/opus1-yellow-orange.png?v=1752715209",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Yellow / Orange"
        ],
        "price": 9,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/iomic-x-grip-opus-1",
        "handle": "iomic-x-grip-opus-1",
        "shopify_variants": [
          {
            "id": "39461786484797",
            "gid": "gid://shopify/ProductVariant/39461786484797",
            "sku": "GRISOXLY",
            "color": "Yellow / Orange",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow / Orange"
            },
            "available": true,
            "price": 9,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-x-grip-opus-1?variant=39461786484797"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Yellow / Orange"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Brand_IOMIC, iomic, iron/wood, medium firm, opus, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150, video=qq1CToDcULM, x-grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Yellow / Orange"
    ]
  },
  {
    "id": "iomic-x-grips-2-3",
    "brand": "Iomic",
    "model": "X-Grips 2.3",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Platinum Grey Grip / Black Cap"
    ],
    "weight_g_by_size": {
      "Standard": 64
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 106.88,
    "price_max": 106.88,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 11.88,
    "bundle_price_min": 106.88,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-xgrip-23_817ca5e0-b864-4cba-b4f1-1732bcd482c5.jpg?v=1752716607",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Platinum Grey Grip / Black Cap"
        ],
        "price": 106.88,
        "per_grip_g": 64,
        "total_g": 576.016950663,
        "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-grip-bundle-set",
        "handle": "iomic-x-grip-2-3-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Platinum Grey Grip / Black Cap",
              "Sky Blue Grip / Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021956554813",
            "gid": "gid://shopify/ProductVariant/41021956554813",
            "sku": "SET-9xGRIX23GRY",
            "color": "Platinum Grey Grip / Black Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Platinum Grey Grip / Black Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 106.88,
            "weight_g": 576.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-grip-bundle-set?variant=41021956554813"
          },
          {
            "id": "41021956587581",
            "gid": "gid://shopify/ProductVariant/41021956587581",
            "sku": "SET-9xGRIX23SKB",
            "color": "Sky Blue Grip / Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue Grip / Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 106.88,
            "weight_g": 576.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-x-grip-2-3-grip-grip-bundle-set?variant=41021956587581"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All products, Brand_IOMIC, grip bundle, iomic, iron/wood, medium firm, mem25, Model_IOMIC X-Grip, new-bundle-set, prime-2025, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150, video=qq1CToDcULM, x-grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-ix-2-3",
    "brand": "Iomic",
    "model": "iX 2.3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 182.62,
    "price_max": 182.62,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.05,
    "bundle_price_min": null,
    "kit_price_min": 182.62,
    "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-ix-23-colors_f8bc1861-5d14-4783-9239-d205f2ba199f.jpg?v=1752716625",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 182.62,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-13pcs-golf-grip-kit",
        "handle": "new-iomic-ix-2-3-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007840399421",
            "gid": "gid://shopify/ProductVariant/32007840399421",
            "sku": "KIT+13xIX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 182.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-13pcs-golf-grip-kit?variant=32007840399421"
          },
          {
            "id": "40215666982973",
            "gid": "gid://shopify/ProductVariant/40215666982973",
            "sku": "KIT(8oz)+13xIX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 187.56,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-13pcs-golf-grip-kit?variant=40215666982973"
          },
          {
            "id": "32007840432189",
            "gid": "gid://shopify/ProductVariant/32007840432189",
            "sku": "KIT+13xIX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 182.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-13pcs-golf-grip-kit?variant=32007840432189"
          },
          {
            "id": "40215667015741",
            "gid": "gid://shopify/ProductVariant/40215667015741",
            "sku": "KIT(8oz)+13xIX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 187.56,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-13pcs-golf-grip-kit?variant=40215667015741"
          },
          {
            "id": "32007840464957",
            "gid": "gid://shopify/ProductVariant/32007840464957",
            "sku": "KIT+13xIX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 182.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-13pcs-golf-grip-kit?variant=32007840464957"
          },
          {
            "id": "40215667048509",
            "gid": "gid://shopify/ProductVariant/40215667048509",
            "sku": "KIT(8oz)+13xIX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 187.56,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-iomic-ix-2-3-grip-13pcs-golf-grip-kit?variant=40215667048509"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "150-200, 2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, grip kit, grip kits, grip set, g",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red",
      "Blue"
    ]
  },
  {
    "id": "iomic-ix-touch-2-0",
    "brand": "Iomic",
    "model": "iX Touch 2.0",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Gold"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 14.75,
    "price_max": 14.75,
    "single_price_min": 14.75,
    "single_price_max": 14.75,
    "normalized_price_per_grip": 14.75,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-ix-touch-2-0-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-ix-touch-20.jpg?v=1769810141",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Gold"
        ],
        "price": 14.75,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-ix-touch-2-0-grip",
        "handle": "iomic-ix-touch-2-0-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gold",
              "Black",
              "Coral Red",
              "Sky blue",
              "Silver"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61496949834098",
            "gid": "gid://shopify/ProductVariant/61496949834098",
            "sku": "IXTOUCH2.0GD",
            "color": "Gold",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Gold"
            },
            "available": true,
            "price": 14.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ix-touch-2-0-grip?variant=61496949834098"
          },
          {
            "id": "61496951931250",
            "gid": "gid://shopify/ProductVariant/61496951931250",
            "sku": "IXTOUCH2.0BK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 14.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ix-touch-2-0-grip?variant=61496951931250"
          },
          {
            "id": "61496949866866",
            "gid": "gid://shopify/ProductVariant/61496949866866",
            "sku": "IXTOUCH2.0CR",
            "color": "Coral Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Coral Red"
            },
            "available": true,
            "price": 14.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ix-touch-2-0-grip?variant=61496949866866"
          },
          {
            "id": "61496951964018",
            "gid": "gid://shopify/ProductVariant/61496951964018",
            "sku": "IXTOUCH2.0SB",
            "color": "Sky blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Sky blue"
            },
            "available": true,
            "price": 14.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ix-touch-2-0-grip?variant=61496951964018"
          },
          {
            "id": "61496951996786",
            "gid": "gid://shopify/ProductVariant/61496951996786",
            "sku": "IXTOUCH2.0SV",
            "color": "Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Silver"
            },
            "available": true,
            "price": 14.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ix-touch-2-0-grip?variant=61496951996786"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_IOMIC, firm, iomic, Iomic golf grips, Iomic grip, iron/wood, Ix Touch 2.0, Ix Touch Grip, Model_IOMIC Ix Touch 2.0, moebius LTC, New for 2015, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, tacky, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Gold",
      "Black",
      "Coral Red",
      "Sky blue",
      "Silver"
    ]
  },
  {
    "id": "iomic-ixx-1-8",
    "brand": "Iomic",
    "model": "iXx 1.8",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 10.87,
    "price_max": 10.87,
    "single_price_min": 10.87,
    "single_price_max": 10.87,
    "normalized_price_per_grip": 10.87,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-ixx-1-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-iXx18-allcolors_b6775a34-585f-4dd9-ad7a-cff065067165.jpg?v=1752715252",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 10.87,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/iomic-ixx-1-8-grip",
        "handle": "iomic-ixx-1-8-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "18969275911",
            "gid": "gid://shopify/ProductVariant/18969275911",
            "sku": "IXX18BK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 10.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-1-8-grip?variant=18969275911"
          },
          {
            "id": "18969276039",
            "gid": "gid://shopify/ProductVariant/18969276039",
            "sku": "IXX18BL",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 13.04,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-1-8-grip?variant=18969276039"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_IOMIC, firm, gifts-for-her, iomic, iron/wood, IXX, LTC, Model_IOMIC IXx, New for 2015, New for 2016, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, tacky, under-150, video=qq1CToDcULM",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Blue"
    ]
  },
  {
    "id": "iomic-ixx-2-3",
    "brand": "Iomic",
    "model": "iXx 2.3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.75,
    "price_max": 182.62,
    "single_price_min": 13.75,
    "single_price_max": 13.75,
    "normalized_price_per_grip": 13.06,
    "bundle_price_min": 117.56,
    "kit_price_min": 182.62,
    "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iomic-ixx23-allcolors.jpg?v=1766011259",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 178.75,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-bundle-13pcs",
        "handle": "iomic-ixx-2-3-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398919872882",
            "gid": "gid://shopify/ProductVariant/61398919872882",
            "sku": "SET-13xIXX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 178.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-bundle-13pcs?variant=61398919872882"
          },
          {
            "id": "61398919905650",
            "gid": "gid://shopify/ProductVariant/61398919905650",
            "sku": "SET-13xIXX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 178.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-bundle-13pcs?variant=61398919905650"
          },
          {
            "id": "61398919938418",
            "gid": "gid://shopify/ProductVariant/61398919938418",
            "sku": "SET-13xIXX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 178.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-bundle-13pcs?variant=61398919938418"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 117.56,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-grip-bundle-set",
        "handle": "iomic-ixx-2-3-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021963796541",
            "gid": "gid://shopify/ProductVariant/41021963796541",
            "sku": "SET-9xIXX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 117.56,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-grip-bundle-set?variant=41021963796541"
          },
          {
            "id": "41021963829309",
            "gid": "gid://shopify/ProductVariant/41021963829309",
            "sku": "SET-9xIXX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 117.56,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-grip-bundle-set?variant=41021963829309"
          },
          {
            "id": "41021963862077",
            "gid": "gid://shopify/ProductVariant/41021963862077",
            "sku": "SET-9xIXX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 117.56,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-grip-bundle-set?variant=41021963862077"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 182.62,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-13pcs-golf-grip-kit",
        "handle": "iomic-ixx-2-3-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007843250237",
            "gid": "gid://shopify/ProductVariant/32007843250237",
            "sku": "KIT+13xIXX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 182.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-13pcs-golf-grip-kit?variant=32007843250237"
          },
          {
            "id": "40215670947901",
            "gid": "gid://shopify/ProductVariant/40215670947901",
            "sku": "KIT(8oz)+13xIXX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 187.56,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-13pcs-golf-grip-kit?variant=40215670947901"
          },
          {
            "id": "32007843283005",
            "gid": "gid://shopify/ProductVariant/32007843283005",
            "sku": "KIT+13xIXX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 182.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-13pcs-golf-grip-kit?variant=32007843283005"
          },
          {
            "id": "40215670980669",
            "gid": "gid://shopify/ProductVariant/40215670980669",
            "sku": "KIT(8oz)+13xIXX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 187.56,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-13pcs-golf-grip-kit?variant=40215670980669"
          },
          {
            "id": "32007843315773",
            "gid": "gid://shopify/ProductVariant/32007843315773",
            "sku": "KIT+13xIXX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 182.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-13pcs-golf-grip-kit?variant=32007843315773"
          },
          {
            "id": "40215671013437",
            "gid": "gid://shopify/ProductVariant/40215671013437",
            "sku": "KIT(8oz)+13xIXX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 187.56,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip-13pcs-golf-grip-kit?variant=40215671013437"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13.75,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip",
        "handle": "iomic-ixx-2-3-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14129530732605",
            "gid": "gid://shopify/ProductVariant/14129530732605",
            "sku": "IXX23BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 13.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip?variant=14129530732605"
          },
          {
            "id": "28529745723453",
            "gid": "gid://shopify/ProductVariant/28529745723453",
            "sku": "IXX23RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 13.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip?variant=28529745723453"
          },
          {
            "id": "31498224238653",
            "gid": "gid://shopify/ProductVariant/31498224238653",
            "sku": "IXX23BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 13.75,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-2-3-grip?variant=31498224238653"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, firm, golf-grips, grip bundle, iomic, IOMIC LTC, iron/wood, iXx, iXx 2.3, Low Torque (LTC), ltc, new-add-12172025, single-golf-grips, single-grip, tacky, under-150, under-300, uv resistant, uv-resistant-golf-grips, video=qq1CToDcULM",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red"
    ]
  },
  {
    "id": "iomic-ixx-cord-2-3",
    "brand": "Iomic",
    "model": "iXx Cord 2.3",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Black with Blue Cap"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.75,
    "price_max": 182.62,
    "single_price_min": 13.75,
    "single_price_max": 13.75,
    "normalized_price_per_grip": 13.75,
    "bundle_price_min": 178.75,
    "kit_price_min": 182.62,
    "url": "https://www.grips4less.com/products/iomic-ixx-cord-2-3-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ixxcord-grip_68fff57f-bac3-42d8-8498-dd4413d7954a.jpg?v=1766010914",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black with Blue Cap"
        ],
        "price": 178.75,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-ixx-cord-2-3-grip-bundle-13pcs",
        "handle": "iomic-ixx-cord-2-3-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398910501234",
            "gid": "gid://shopify/ProductVariant/61398910501234",
            "sku": "SET-13xIXX23CORDBKBL",
            "color": "Black with Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black with Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 178.75,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-ixx-cord-2-3-grip-bundle-13pcs?variant=61398910501234"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black with Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black with Blue Cap"
        ],
        "price": 13.75,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-ixx-cord-2-3-grip",
        "handle": "iomic-ixx-cord-2-3-grip",
        "shopify_variants": [
          {
            "id": "41372600598589",
            "gid": "gid://shopify/ProductVariant/41372600598589",
            "sku": "IXX23CORDBKBL",
            "color": "Black with Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black with Blue Cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.75,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/iomic-ixx-cord-2-3-grip?variant=41372600598589"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black with Blue Cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black with Blue Cap"
        ],
        "price": 182.62,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/iomic-ixx-cord-2-3-grip-13pcs-golf-grip-kit",
        "handle": "iomic-ixx-cord-2-3-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black with Blue Cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41372600533053",
            "gid": "gid://shopify/ProductVariant/41372600533053",
            "sku": "KIT+13xIXX23CORDBKBL",
            "color": "Black with Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black with Blue Cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 182.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-cord-2-3-grip-13pcs-golf-grip-kit?variant=41372600533053"
          },
          {
            "id": "41372600565821",
            "gid": "gid://shopify/ProductVariant/41372600565821",
            "sku": "KIT(8oz)+13xIXX23CORDBKBL",
            "color": "Black with Blue Cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black with Blue Cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 187.56,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-ixx-cord-2-3-grip-13pcs-golf-grip-kit?variant=41372600565821"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, all-weather, cord, cord-golf-grips, firm, full cord, golf-grips, grip bundle, iomic, iomic cord, IOMIC LTC, iron/wood, iXx, iXx 2.3, Low Torque (LTC), ltc, new-add-12172025, single-golf-grips, single-grip, tacky, under-150, under-300, uv resistant, uv-re",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "jumbomax-comfort-wrap-large-11-32",
    "brand": "JumboMax",
    "model": "Comfort Wrap Large (+11/32\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Large (+11/32\")"
    ],
    "manufacturer_size_labels": [
      "Large (+11/32\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 11.99,
    "price_max": 160.88,
    "single_price_min": 11.99,
    "single_price_max": 11.99,
    "normalized_price_per_grip": 11.99,
    "bundle_price_min": 155.87,
    "kit_price_min": 160.88,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-comfort-wrap_0774492f-93cc-465a-a0d2-1ae50f40b006.jpg?v=1766011378",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 155.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip-bundle-13pcs",
        "handle": "jumbomax-wrap-large-11-32-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398924165490",
            "gid": "gid://shopify/ProductVariant/61398924165490",
            "sku": "SET-13xJM200-4400",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 155.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip-bundle-13pcs?variant=61398924165490"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 160.88,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-wrap-large-11-32-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919994568765",
            "gid": "gid://shopify/ProductVariant/39919994568765",
            "sku": "KIT+13xJM200-4400",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip-13pcs-golf-grip-kit?variant=39919994568765"
          },
          {
            "id": "39919994601533",
            "gid": "gid://shopify/ProductVariant/39919994601533",
            "sku": "KIT(8oz)+13xJM200-4400",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 165.92,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip-13pcs-golf-grip-kit?variant=39919994601533"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 11.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip",
        "handle": "jumbomax-wrap-large-11-32-grip",
        "shopify_variants": [
          {
            "id": "6719813633",
            "gid": "gid://shopify/ProductVariant/6719813633",
            "sku": "JM200-4400",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip?variant=6719813633"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, jumbomax-large, Large, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-comfort-wrap-medium-5-16",
    "brand": "JumboMax",
    "model": "Comfort Wrap Medium (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 11.99,
    "price_max": 160.88,
    "single_price_min": 11.99,
    "single_price_max": 11.99,
    "normalized_price_per_grip": 11.99,
    "bundle_price_min": 155.87,
    "kit_price_min": 160.88,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-comfort-wrap_67a50872-e97f-4149-be00-8f84c1957273.jpg?v=1766011383",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 155.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip-bundle-13pcs",
        "handle": "jumbomax-wrap-medium-5-16-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398924198258",
            "gid": "gid://shopify/ProductVariant/61398924198258",
            "sku": "SET-13xJM200-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 155.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip-bundle-13pcs?variant=61398924198258"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 160.88,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-wrap-medium-5-16-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919994503229",
            "gid": "gid://shopify/ProductVariant/39919994503229",
            "sku": "KIT+13xJM200-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip-13pcs-golf-grip-kit?variant=39919994503229"
          },
          {
            "id": "39919994535997",
            "gid": "gid://shopify/ProductVariant/39919994535997",
            "sku": "KIT(8oz)+13xJM200-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 165.92,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip-13pcs-golf-grip-kit?variant=39919994535997"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 11.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip",
        "handle": "jumbomax-wrap-medium-5-16-grip",
        "shopify_variants": [
          {
            "id": "6719804545",
            "gid": "gid://shopify/ProductVariant/6719804545",
            "sku": "JM200-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip?variant=6719804545"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, jumbomax-medium, Medium, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-comfort-wrap-small-1-4",
    "brand": "JumboMax",
    "model": "Comfort Wrap Small (+1/4\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Small (+1/4\")"
    ],
    "manufacturer_size_labels": [
      "Small (+1/4\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 11.99,
    "price_max": 160.88,
    "single_price_min": 11.99,
    "single_price_max": 11.99,
    "normalized_price_per_grip": 11.99,
    "bundle_price_min": 155.87,
    "kit_price_min": 160.88,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-comfort-wrap_dca48072-2062-49ff-bc35-2508c81f46ef.jpg?v=1766011389",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 155.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip-bundle-13pcs",
        "handle": "jumbomax-wrap-small-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398924263794",
            "gid": "gid://shopify/ProductVariant/61398924263794",
            "sku": "SET-13xJM200-1100",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 155.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip-bundle-13pcs?variant=61398924263794"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 160.88,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-wrap-small-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919994437693",
            "gid": "gid://shopify/ProductVariant/39919994437693",
            "sku": "KIT+13xJM200-1100",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip-13pcs-golf-grip-kit?variant=39919994437693"
          },
          {
            "id": "39919994470461",
            "gid": "gid://shopify/ProductVariant/39919994470461",
            "sku": "KIT(8oz)+13xJM200-1100",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 165.92,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip-13pcs-golf-grip-kit?variant=39919994470461"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 11.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip",
        "handle": "jumbomax-wrap-small-grip",
        "shopify_variants": [
          {
            "id": "6719788289",
            "gid": "gid://shopify/ProductVariant/6719788289",
            "sku": "JM200-1100",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip?variant=6719788289"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, jumbomax-small, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, Small, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-comfort-wrap-x-large-3-8",
    "brand": "JumboMax",
    "model": "Comfort Wrap X-Large (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 11.99,
    "price_max": 160.88,
    "single_price_min": 11.99,
    "single_price_max": 11.99,
    "normalized_price_per_grip": 11.99,
    "bundle_price_min": 155.87,
    "kit_price_min": 160.88,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-comfort-wrap_9450e5ed-fef8-4241-abed-21221436940a.jpg?v=1766011373",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 155.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip-bundle-13pcs",
        "handle": "jumbomax-wrap-xl-3-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398924132722",
            "gid": "gid://shopify/ProductVariant/61398924132722",
            "sku": "SET-13xJM200-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 155.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip-bundle-13pcs?variant=61398924132722"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 160.88,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-wrap-xl-3-8-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919994634301",
            "gid": "gid://shopify/ProductVariant/39919994634301",
            "sku": "KIT+13xJM200-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip-13pcs-golf-grip-kit?variant=39919994634301"
          },
          {
            "id": "39919994667069",
            "gid": "gid://shopify/ProductVariant/39919994667069",
            "sku": "KIT(8oz)+13xJM200-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 165.92,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip-13pcs-golf-grip-kit?variant=39919994667069"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 11.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip",
        "handle": "jumbomax-wrap-xl-3-8-grip",
        "shopify_variants": [
          {
            "id": "6719852865",
            "gid": "gid://shopify/ProductVariant/6719852865",
            "sku": "JM200-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip?variant=6719852865"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, under-150, under-300, video=tnsdjrbpGjE, XL",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-comfort-wrap-x-small-3-16",
    "brand": "JumboMax",
    "model": "Comfort Wrap X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 11.99,
    "price_max": 160.88,
    "single_price_min": 11.99,
    "single_price_max": 11.99,
    "normalized_price_per_grip": 11.99,
    "bundle_price_min": 155.87,
    "kit_price_min": 160.88,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-comfort-wrap_7f45fb7a-41e4-47b4-857b-e76ab9acb888.jpg?v=1766011079",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 155.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-grip-bundle-13pcs",
        "handle": "jumbomax-wrap-x-small-3-16-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914695538",
            "gid": "gid://shopify/ProductVariant/61398914695538",
            "sku": "SET-13xJM200-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 155.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-grip-bundle-13pcs?variant=61398914695538"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 11.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-grip",
        "handle": "jumbomax-wrap-x-small-3-16-grip",
        "shopify_variants": [
          {
            "id": "40482525577277",
            "gid": "gid://shopify/ProductVariant/40482525577277",
            "sku": "JM200-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-grip?variant=40482525577277"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 160.88,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-13pcs-golf-grip-kit",
        "handle": "jumbomax-wrap-x-small-3-16-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40482525216829",
            "gid": "gid://shopify/ProductVariant/40482525216829",
            "sku": "KIT+13xJM200-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-13pcs-golf-grip-kit?variant=40482525216829"
          },
          {
            "id": "40482525249597",
            "gid": "gid://shopify/ProductVariant/40482525249597",
            "sku": "KIT(8oz)+13xJM200-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 165.92,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-13pcs-golf-grip-kit?variant=40482525249597"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbmax junior, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, jumbomax-2023, jumbomax-small, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, Small, under-150, under-300,",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-jmx-ultralite-1-8",
    "brand": "JumboMax",
    "model": "JMX UltraLite (+1/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Jumbo (+1/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 210.28,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-ultralite_bda81bc1-45b8-4790-833c-8894d3a5a5d3.jpg?v=1766011084",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-standard-jumbo-1-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914728306",
            "gid": "gid://shopify/ProductVariant/61398914728306",
            "sku": "SET-13xJMX600-950",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-grip-bundle-13pcs?variant=61398914728306"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-standard-jumbo-1-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954293821",
            "gid": "gid://shopify/ProductVariant/41021954293821",
            "sku": "SET-9xJMX600-950",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-grip-grip-bundle-set?variant=41021954293821"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-ultralite-standard-jumbo-1-8-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919992176701",
            "gid": "gid://shopify/ProductVariant/39919992176701",
            "sku": "KIT+13xJMX600-950",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-13pcs-golf-grip-kit?variant=39919992176701"
          },
          {
            "id": "39919992242237",
            "gid": "gid://shopify/ProductVariant/39919992242237",
            "sku": "KIT(8oz)+13xJMX600-950",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-13pcs-golf-grip-kit?variant=39919992242237"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-grip",
        "handle": "jumbomax-jmx-ultralite-standard-jumbo-1-8-grip",
        "shopify_variants": [
          {
            "id": "39919802449981",
            "gid": "gid://shopify/ProductVariant/39919802449981",
            "sku": "JMX600-950",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-standard-jumbo-1-8-grip?variant=39919802449981"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-large, Large, Most Popular Oversize, new-add-121720",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-jmx-ultralite-large-11-32",
    "brand": "JumboMax",
    "model": "JMX UltraLite LARGE (+11/32\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Large (+11/32\")"
    ],
    "manufacturer_size_labels": [
      "Large (+11/32\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 210.28,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-ultralite.jpg?v=1766011215",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-large-11-32-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398918922610",
            "gid": "gid://shopify/ProductVariant/61398918922610",
            "sku": "SET-13xJMX600-4400",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip-bundle-13pcs?variant=61398918922610"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-large-11-32-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021962616893",
            "gid": "gid://shopify/ProductVariant/41021962616893",
            "sku": "SET-9xJMX600-4400",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip-grip-bundle-set?variant=41021962616893"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-ultralite-large-11-32-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919995027517",
            "gid": "gid://shopify/ProductVariant/39919995027517",
            "sku": "KIT+13xJMX600-4400",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip-13pcs-golf-grip-kit?variant=39919995027517"
          },
          {
            "id": "39919995060285",
            "gid": "gid://shopify/ProductVariant/39919995060285",
            "sku": "KIT(8oz)+13xJMX600-4400",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip-13pcs-golf-grip-kit?variant=39919995060285"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "single",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip",
        "handle": "jumbomax-jmx-ultralite-large-11-32-grip",
        "shopify_variants": [
          {
            "id": "29461159247933",
            "gid": "gid://shopify/ProductVariant/29461159247933",
            "sku": "JMX600-4400",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-large-11-32-grip?variant=29461159247933"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-large, Large, Most Popular Oversize, new-add-121720",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-jmx-ultralite-medium-5-16",
    "brand": "JumboMax",
    "model": "JMX UltraLite MEDIUM (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 210.28,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-ultralite_3c7f985e-f991-4883-9e71-0d3428da2e77.jpg?v=1766011205",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-medium-5-16-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398918889842",
            "gid": "gid://shopify/ProductVariant/61398918889842",
            "sku": "SET-13xJMX600-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip-bundle-13pcs?variant=61398918889842"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-medium-5-16-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021962584125",
            "gid": "gid://shopify/ProductVariant/41021962584125",
            "sku": "SET-9xJMX600-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip-grip-bundle-set?variant=41021962584125"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-ultralite-medium-5-16-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919995093053",
            "gid": "gid://shopify/ProductVariant/39919995093053",
            "sku": "KIT+13xJMX600-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip-13pcs-golf-grip-kit?variant=39919995093053"
          },
          {
            "id": "39919995125821",
            "gid": "gid://shopify/ProductVariant/39919995125821",
            "sku": "KIT(8oz)+13xJMX600-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip-13pcs-golf-grip-kit?variant=39919995125821"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip",
        "handle": "jumbomax-jmx-ultralite-medium-5-16-grip",
        "shopify_variants": [
          {
            "id": "29461192147005",
            "gid": "gid://shopify/ProductVariant/29461192147005",
            "sku": "JMX600-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-medium-5-16-grip?variant=29461192147005"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-medium, Medium, Most Popular Oversize, new-add-1217",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-jmx-ultralite-small-1-4",
    "brand": "JumboMax",
    "model": "JMX UltraLite SMALL (+1/4\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Small (+1/4\")"
    ],
    "manufacturer_size_labels": [
      "Small (+1/4\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 210.28,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-ultralite_8c1e8193-b26e-4e51-9444-dfb1198b9eae.jpg?v=1766011193",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-small-1-4-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398918758770",
            "gid": "gid://shopify/ProductVariant/61398918758770",
            "sku": "SET-13xJMX600-1100",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip-bundle-13pcs?variant=61398918758770"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-small-1-4-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021962485821",
            "gid": "gid://shopify/ProductVariant/41021962485821",
            "sku": "SET-9xJMX600-1100",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip-grip-bundle-set?variant=41021962485821"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-ultralite-small-1-4-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919995224125",
            "gid": "gid://shopify/ProductVariant/39919995224125",
            "sku": "KIT+13xJMX600-1100",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip-13pcs-golf-grip-kit?variant=39919995224125"
          },
          {
            "id": "39919995256893",
            "gid": "gid://shopify/ProductVariant/39919995256893",
            "sku": "KIT(8oz)+13xJMX600-1100",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip-13pcs-golf-grip-kit?variant=39919995256893"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "single",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip",
        "handle": "jumbomax-jmx-ultralite-small-1-4-grip",
        "shopify_variants": [
          {
            "id": "29461831024701",
            "gid": "gid://shopify/ProductVariant/29461831024701",
            "sku": "JMX600-1100",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-small-1-4-grip?variant=29461831024701"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-small, Most Popular Oversize, new-add-12172025, ove",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-jmx-ultralite-str8-tech-non-tapered-medium-5-16",
    "brand": "JumboMax",
    "model": "JMX UltraLite STR8 Tech Non-Tapered MEDIUM (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {
      "Medium (+5/16\")": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 210.28,
    "price_max": 210.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 16.18,
    "bundle_price_min": null,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-jmx-ultralite-str8-non-tapered-kit-grips-13pcs.jpg?v=1736026815",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919992569917",
            "gid": "gid://shopify/ProductVariant/39919992569917",
            "sku": "KIT+13xJMX610-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-13pcs-golf-grip-kit?variant=39919992569917"
          },
          {
            "id": "39919992602685",
            "gid": "gid://shopify/ProductVariant/39919992602685",
            "sku": "KIT(8oz)+13xJMX610-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-13pcs-golf-grip-kit?variant=39919992602685"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "200-250, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf-grips, grip kit, grip kits, grip set, grip sets, gripkit-freetowel-2026, gripkit-shaftbundle-sale, iron/wood, JMX, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-jmx-ultralite-str8-tech-non-tapered-x-large-3-8",
    "brand": "JumboMax",
    "model": "JMX UltraLite STR8 Tech Non-Tapered X-LARGE (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {
      "X-Large (+3/8\")": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 210.28,
    "price_max": 210.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 16.18,
    "bundle_price_min": null,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-jmx-ultralite-str8-non-tapered-kit-grips-13pcs_3ffb79fe-aafe-4198-9e04-3340114c9be1.jpg?v=1736026816",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919992635453",
            "gid": "gid://shopify/ProductVariant/39919992635453",
            "sku": "KIT+13xJMX610-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-13pcs-golf-grip-kit?variant=39919992635453"
          },
          {
            "id": "39919992668221",
            "gid": "gid://shopify/ProductVariant/39919992668221",
            "sku": "KIT(8oz)+13xJMX610-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-13pcs-golf-grip-kit?variant=39919992668221"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "200-250, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf grip gift, golf-grip-kit-gifts, golf-grips, golfers-gift-guide, grip kit, grip kits, grip set, grip sets, grip-kit-",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-jmx-ultralite-str8-tech-non-tapered-x-small-3-16",
    "brand": "JumboMax",
    "model": "JMX UltraLite STR8 Tech Non-Tapered X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {
      "X-Small (+3/16\")": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 210.28,
    "price_max": 210.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 16.18,
    "bundle_price_min": null,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-jmx-ultralite-str8-non-tapered-kit-grips-13pcs_6fdc650d-2a91-4e67-9bc6-2ce60539ab5a.jpg?v=1736026814",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919992504381",
            "gid": "gid://shopify/ProductVariant/39919992504381",
            "sku": "KIT+13xJMX610-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-13pcs-golf-grip-kit?variant=39919992504381"
          },
          {
            "id": "39919992537149",
            "gid": "gid://shopify/ProductVariant/39919992537149",
            "sku": "KIT(8oz)+13xJMX610-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-13pcs-golf-grip-kit?variant=39919992537149"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "200-250, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf-grips, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripkit-freetowel-2026, gripkit-shaft",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-jmx-ultralite-x-large-3-8",
    "brand": "JumboMax",
    "model": "JMX UltraLite X-LARGE (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 210.28,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-ultralite_017b17b1-b433-486c-bbc4-bc0987aae60d.jpg?v=1766011201",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-x-large-3-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398918857074",
            "gid": "gid://shopify/ProductVariant/61398918857074",
            "sku": "SET-13xJMX600-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip-bundle-13pcs?variant=61398918857074"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-x-large-3-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021962551357",
            "gid": "gid://shopify/ProductVariant/41021962551357",
            "sku": "SET-9xJMX600-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip-grip-bundle-set?variant=41021962551357"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-ultralite-x-large-3-8-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919995158589",
            "gid": "gid://shopify/ProductVariant/39919995158589",
            "sku": "KIT+13xJMX600-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip-13pcs-golf-grip-kit?variant=39919995158589"
          },
          {
            "id": "39919995191357",
            "gid": "gid://shopify/ProductVariant/39919995191357",
            "sku": "KIT(8oz)+13xJMX600-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip-13pcs-golf-grip-kit?variant=39919995191357"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip",
        "handle": "jumbomax-jmx-ultralite-x-large-3-8-grip",
        "shopify_variants": [
          {
            "id": "29461192998973",
            "gid": "gid://shopify/ProductVariant/29461192998973",
            "sku": "JMX600-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-large-3-8-grip?variant=29461192998973"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, best-sellers, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-x-large, Most Popular Oversize, new-a",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-jmx-ultralite-x-small-3-16",
    "brand": "JumboMax",
    "model": "JMX UltraLite X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 210.28,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-ultralite_35f28827-1882-4f6b-a4d8-4ce92b734c51.jpg?v=1766011149",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-8-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-x-small-1-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398916890994",
            "gid": "gid://shopify/ProductVariant/61398916890994",
            "sku": "SET-13xJMX600-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-8-grip-bundle-13pcs?variant=61398916890994"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-8-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-x-small-1-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021959798845",
            "gid": "gid://shopify/ProductVariant/41021959798845",
            "sku": "SET-9xJMX600-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-8-grip-grip-bundle-set?variant=41021959798845"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-4-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-ultralite-x-small-1-4-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919994372157",
            "gid": "gid://shopify/ProductVariant/39919994372157",
            "sku": "KIT+13xJMX600-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-4-13pcs-golf-grip-kit?variant=39919994372157"
          },
          {
            "id": "39919994404925",
            "gid": "gid://shopify/ProductVariant/39919994404925",
            "sku": "KIT(8oz)+13xJMX600-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-4-13pcs-golf-grip-kit?variant=39919994404925"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "single",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-8-grip",
        "handle": "jumbomax-jmx-ultralite-x-small-1-8-grip",
        "shopify_variants": [
          {
            "id": "32043567185981",
            "gid": "gid://shopify/ProductVariant/32043567185981",
            "sku": "JMX600-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-x-small-1-8-grip?variant=32043567185981"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbmax junior, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, JumboMax XSmall, jumbomax-x-small, Most Popu",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-jmx-zenlite",
    "brand": "JumboMax",
    "model": "JMX Zenlite",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Oversize (+1/6\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Jumbo/Oversize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 210.28,
    "price_max": 210.28,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 16.18,
    "bundle_price_min": null,
    "kit_price_min": 210.28,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbolite-zenlite-kit.jpg?v=1736026774",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 210.28,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit",
        "handle": "jumbomax-jmx-zenlite-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/6\")",
              "Standard Jumbo (+1/8\")",
              "X-Small (+3/16\")",
              "Small (+1/4\")",
              "Medium (+5/16\")",
              "Large (+11/32\")",
              "X-Large (+3/8\")"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40521502883901",
            "gid": "gid://shopify/ProductVariant/40521502883901",
            "sku": "KIT+13xJMX700-900",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Standard Oversize (+1/6\")",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521502883901"
          },
          {
            "id": "40521502916669",
            "gid": "gid://shopify/ProductVariant/40521502916669",
            "sku": "KIT(8oz)+13xJMX700-900",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Standard Oversize (+1/6\")",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521502916669"
          },
          {
            "id": "40521502949437",
            "gid": "gid://shopify/ProductVariant/40521502949437",
            "sku": "KIT+13xJMX700-950",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Standard Jumbo (+1/8\")",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521502949437"
          },
          {
            "id": "40521502982205",
            "gid": "gid://shopify/ProductVariant/40521502982205",
            "sku": "KIT(8oz)+13xJMX700-950",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Standard Jumbo (+1/8\")",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521502982205"
          },
          {
            "id": "40521503014973",
            "gid": "gid://shopify/ProductVariant/40521503014973",
            "sku": "KIT+13xJMX700-1000",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "X-Small (+3/16\")",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503014973"
          },
          {
            "id": "40521503047741",
            "gid": "gid://shopify/ProductVariant/40521503047741",
            "sku": "KIT(8oz)+13xJMX700-1000",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "X-Small (+3/16\")",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503047741"
          },
          {
            "id": "40521503080509",
            "gid": "gid://shopify/ProductVariant/40521503080509",
            "sku": "KIT+13xJMX700-1100",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Small (+1/4\")",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503080509"
          },
          {
            "id": "40521503113277",
            "gid": "gid://shopify/ProductVariant/40521503113277",
            "sku": "KIT(8oz)+13xJMX700-1100",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Small (+1/4\")",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503113277"
          },
          {
            "id": "40521503146045",
            "gid": "gid://shopify/ProductVariant/40521503146045",
            "sku": "KIT+13xJMX700-2200",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Medium (+5/16\")",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503146045"
          },
          {
            "id": "40521503178813",
            "gid": "gid://shopify/ProductVariant/40521503178813",
            "sku": "KIT(8oz)+13xJMX700-2200",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Medium (+5/16\")",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503178813"
          },
          {
            "id": "40521503211581",
            "gid": "gid://shopify/ProductVariant/40521503211581",
            "sku": "KIT+13xJMX700-4400",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Large (+11/32\")",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503211581"
          },
          {
            "id": "40521503244349",
            "gid": "gid://shopify/ProductVariant/40521503244349",
            "sku": "KIT(8oz)+13xJMX700-4400",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Large (+11/32\")",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503244349"
          },
          {
            "id": "40521503277117",
            "gid": "gid://shopify/ProductVariant/40521503277117",
            "sku": "KIT+13xJMX700-6600",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "X-Large (+3/8\")",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 210.28,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503277117"
          },
          {
            "id": "40521503309885",
            "gid": "gid://shopify/ProductVariant/40521503309885",
            "sku": "KIT(8oz)+13xJMX700-6600",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "X-Large (+3/8\")",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 215.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-13pcs-golf-grip-kit?variant=40521503309885"
          }
        ],
        "shopify_variant_count": 14,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "200-250, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf-grips, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripkit-freetowel-2026, gripkit-shaft",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "jumbomax-jmx-zenlite-black-sj-grip-1-8",
    "brand": "JumboMax",
    "model": "JMX Zenlite Black (SJ) Grip +1/8\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Jumbo (+1/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": 207.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-zen-lite-grip_add4dc9b-c35b-4bb2-9054-3831f6354f22.jpg?v=1766010963",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 207.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8-bundle-13pcs",
        "handle": "new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912237938",
            "gid": "gid://shopify/ProductVariant/61398912237938",
            "sku": "SET-13xJMX700-950",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": false,
            "price": 207.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8-bundle-13pcs?variant=61398912237938"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8",
        "handle": "new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8",
        "shopify_variants": [
          {
            "id": "40482665005117",
            "gid": "gid://shopify/ProductVariant/40482665005117",
            "sku": "JMX720-950",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8?variant=40482665005117"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbomax, jumbomax standard jumbo, JumboMax zenlite, jumbomax-2023, midsize, midsize-golf-grips, new-add-12172025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, zenlite",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "jumbomax-jmx-zenlite-black-sj-grips-1-8",
    "brand": "JumboMax",
    "model": "JMX Zenlite Black (SJ) Grips +1/8\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Jumbo (+1/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 129.52,
    "price_max": 129.52,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/zenlite-grip.jpg?v=1768349890",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 129.52,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8-grip-bundle-set",
        "handle": "new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953278013",
            "gid": "gid://shopify/ProductVariant/41021953278013",
            "sku": "SET-9xJMX700-950",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": false,
            "price": 129.52,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-jumbo-sj-grip-1-8-grip-bundle-set?variant=41021953278013"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbomax, jumbomax standard jumbo, JumboMax zenlite, jumbomax-2023, midsize, midsize-golf-grips, new-bundle-set, prime-2025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, zenlite",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "jumbomax-jmx-zenlite-black-so-grip-1-16",
    "brand": "JumboMax",
    "model": "JMX Zenlite Black (SO) Grip +1/16\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Oversize (+1/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": 207.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-zen-lite-grip_e51f870b-01a7-4138-bef3-2d49a0e1e90e.jpg?v=1766010967",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 207.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip-bundle-13pcs",
        "handle": "new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912270706",
            "gid": "gid://shopify/ProductVariant/61398912270706",
            "sku": "SET-13xJMX700-900",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip-bundle-13pcs?variant=61398912270706"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip",
        "handle": "new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip",
        "shopify_variants": [
          {
            "id": "40482664972349",
            "gid": "gid://shopify/ProductVariant/40482664972349",
            "sku": "JMX720-900",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip?variant=40482664972349"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbomax, JumboMax zenlite, jumbomax-2023, midsize, midsize-golf-grips, new-add-12172025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, zenlite",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-jmx-zenlite-black-so-grips-1-16",
    "brand": "JumboMax",
    "model": "JMX Zenlite Black (SO) Grips +1/16\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Oversize (+1/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 129.52,
    "price_max": 129.52,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/zenlite-grip.jpg?v=1768349890",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 129.52,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip-grip-bundle-set",
        "handle": "new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953310781",
            "gid": "gid://shopify/ProductVariant/41021953310781",
            "sku": "SET-9xJMX700-900",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-jmx-zenlite-black-standard-oversize-st-grip-grip-bundle-set?variant=41021953310781"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbomax, JumboMax zenlite, jumbomax-2023, midsize, midsize-golf-grips, new-bundle-set, prime-2025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, zenlite",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-jmx-zenlite-black-large-11-32",
    "brand": "JumboMax",
    "model": "JMX Zenlite Black LARGE (+11/32\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Large (+11/32\")"
    ],
    "manufacturer_size_labels": [
      "Large (+11/32\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-large-11-32-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-zen-lite-grip.jpg?v=1766010942",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 207.87,
        "per_grip_g": 8.7,
        "total_g": 113.3980925,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-large-11-32-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-zenlite-black-large-11-32-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912106866",
            "gid": "gid://shopify/ProductVariant/61398912106866",
            "sku": "SET-13xJMX700-4400",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 113.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-large-11-32-grip-bundle-13pcs?variant=61398912106866"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 129.52,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-large-11-32-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-zenlite-black-large-11-32-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953114173",
            "gid": "gid://shopify/ProductVariant/41021953114173",
            "sku": "SET-9xJMX700-4400",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-large-11-32-grip-grip-bundle-set?variant=41021953114173"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15.99,
        "per_grip_g": 113.4,
        "total_g": 113.3980925,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-large-11-32-grip",
        "handle": "jumbomax-jmx-zenlite-black-large-11-32-grip",
        "shopify_variants": [
          {
            "id": "40482665168957",
            "gid": "gid://shopify/ProductVariant/40482665168957",
            "sku": "JMX720-4400",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 113.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-large-11-32-grip?variant=40482665168957"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax zenlite, jumbomax-2023, jumbomax-large, Large, Most Popular Oversize, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, under-150, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-jmx-zenlite-black-medium-5-16",
    "brand": "JumboMax",
    "model": "JMX Zenlite Black MEDIUM (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-medium-5-16-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/zenlite-grip_706d8bd4-ec4c-4282-aa1d-5d9c2156cf71.jpg?v=1766010948",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 207.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-medium-5-16-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-zenlite-black-medium-5-16-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912139634",
            "gid": "gid://shopify/ProductVariant/61398912139634",
            "sku": "SET-13xJMX720-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-medium-5-16-grip-bundle-13pcs?variant=61398912139634"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 129.52,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-medium-5-16-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-zenlite-black-medium-5-16-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953146941",
            "gid": "gid://shopify/ProductVariant/41021953146941",
            "sku": "SET-9xJMX700-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-medium-5-16-grip-grip-bundle-set?variant=41021953146941"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-medium-5-16-grip",
        "handle": "jumbomax-jmx-zenlite-black-medium-5-16-grip",
        "shopify_variants": [
          {
            "id": "40482665136189",
            "gid": "gid://shopify/ProductVariant/40482665136189",
            "sku": "JMX720-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-medium-5-16-grip?variant=40482665136189"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, golfers-gift-guide, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax zenlite, jumbomax-2023, jumbomax-medium, Medium, Most Popular Midsize, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, sin",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-jmx-zenlite-black-small-1-4",
    "brand": "JumboMax",
    "model": "JMX Zenlite Black SMALL (+1/4\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Small (+1/4\")"
    ],
    "manufacturer_size_labels": [
      "Small (+1/4\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-small-1-4-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/zenlite-grip_ee524ec4-3857-4da9-966a-dd340ce2bb6f.jpg?v=1766010953",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 207.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-small-1-4-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-zenlite-black-small-1-4-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912172402",
            "gid": "gid://shopify/ProductVariant/61398912172402",
            "sku": "SET-13xJMX720-1100",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-small-1-4-grip-bundle-13pcs?variant=61398912172402"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 129.52,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-small-1-4-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-zenlite-black-small-1-4-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953179709",
            "gid": "gid://shopify/ProductVariant/41021953179709",
            "sku": "SET-9xJMX720-1100",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-small-1-4-grip-grip-bundle-set?variant=41021953179709"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-small-1-4-grip",
        "handle": "jumbomax-jmx-zenlite-black-small-1-4-grip",
        "shopify_variants": [
          {
            "id": "40482665070653",
            "gid": "gid://shopify/ProductVariant/40482665070653",
            "sku": "JMX720-1100",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-small-1-4-grip?variant=40482665070653"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax zenlite, jumbomax-2023, jumbomax-small, Large, Most Popular Oversize, new-add-12172025, oversize, oversize-jumbo-golf-grips, overstock-mar2024, rubber, single-golf-grips, singl",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-jmx-zenlite-black-x-large-3-8",
    "brand": "JumboMax",
    "model": "JMX Zenlite Black X-Large (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-xl-3-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-zen-lite-grip_f4943026-3867-4108-a864-a37179ba1997.jpg?v=1766010933",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 207.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-xl-3-8-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-zenlite-black-xl-3-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912074098",
            "gid": "gid://shopify/ProductVariant/61398912074098",
            "sku": "SET-13xJMX700-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-xl-3-8-grip-bundle-13pcs?variant=61398912074098"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 129.52,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-xl-3-8-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-zenlite-black-xl-3-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953081405",
            "gid": "gid://shopify/ProductVariant/41021953081405",
            "sku": "SET-9xJMX700-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-xl-3-8-grip-grip-bundle-set?variant=41021953081405"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-xl-3-8-grip",
        "handle": "jumbomax-jmx-zenlite-black-xl-3-8-grip",
        "shopify_variants": [
          {
            "id": "40482665201725",
            "gid": "gid://shopify/ProductVariant/40482665201725",
            "sku": "JMX720-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-xl-3-8-grip?variant=40482665201725"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax zenlite, jumbomax-2023, jumbomax-x-large, Most Popular Oversize, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, under-150, under",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-jmx-zenlite-black-x-small-3-16",
    "brand": "JumboMax",
    "model": "JMX Zenlite Black X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-junior-grip-usa",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-zen-lite-grip_2fd977c3-38e2-47b4-ab82-16ad9a07ddc3.jpg?v=1766010958",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 207.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-junior-grip-usa-bundle-13pcs",
        "handle": "jumbomax-jmx-zenlite-black-junior-grip-usa-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912205170",
            "gid": "gid://shopify/ProductVariant/61398912205170",
            "sku": "SET-13xJMX700-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": false,
            "price": 207.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-junior-grip-usa-bundle-13pcs?variant=61398912205170"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 129.52,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-junior-grip-usa-grip-bundle-set",
        "handle": "jumbomax-jmx-zenlite-black-junior-grip-usa-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953245245",
            "gid": "gid://shopify/ProductVariant/41021953245245",
            "sku": "SET-9xJMX700-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-junior-grip-usa-grip-bundle-set?variant=41021953245245"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-junior-grip-usa",
        "handle": "jumbomax-jmx-zenlite-black-junior-grip-usa",
        "shopify_variants": [
          {
            "id": "40482665037885",
            "gid": "gid://shopify/ProductVariant/40482665037885",
            "sku": "JMX720-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-zenlite-black-junior-grip-usa?variant=40482665037885"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, july4-2022, jumbo, jumbo/oversize, jumbomax, JumboMax Jr, JumboMax Junior, JumboMax zenlite, jumbomax-2023, jumbomax-x-small, junior-golf-grips, Most Popular Midsize, new-add-12172025, oversize, oversize-jumbo-golf-gri",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-blackout-1-8",
    "brand": "JumboMax",
    "model": "NEW JumboMax JMX Ultralite BLACKOUT (+1/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Jumbo (+1/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-ultralite-blackout_356b2286-cc81-4210-91af-e7fd9e28cf0b.jpg?v=1766010999",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914072946",
            "gid": "gid://shopify/ProductVariant/61398914072946",
            "sku": "SET-13xJMX630-950",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip-bundle-13pcs?variant=61398914072946"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953507389",
            "gid": "gid://shopify/ProductVariant/41021953507389",
            "sku": "SET-9xJMX630-950",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip-grip-bundle-set?variant=41021953507389"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip",
        "handle": "jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip",
        "shopify_variants": [
          {
            "id": "40482646065213",
            "gid": "gid://shopify/ProductVariant/40482646065213",
            "sku": "JMX630-950",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-standard-jumbo-1-8-grip?variant=40482646065213"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-2023, jumbomax-large, Large, Most Popular Oversize,",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-blackout-large-11-32",
    "brand": "JumboMax",
    "model": "NEW JumboMax JMX Ultralite BLACKOUT LARGE (+11/32\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Large (+11/32\")"
    ],
    "manufacturer_size_labels": [
      "Large (+11/32\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-large-11-32-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-ultralite-blackout_19e930ea-2784-41a8-bbb3-07d09829e273.jpg?v=1766010977",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-large-11-32-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-blackout-large-11-32-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912336242",
            "gid": "gid://shopify/ProductVariant/61398912336242",
            "sku": "SET-13xJMX630-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-large-11-32-grip-bundle-13pcs?variant=61398912336242"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-large-11-32-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-blackout-large-11-32-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953376317",
            "gid": "gid://shopify/ProductVariant/41021953376317",
            "sku": "SET-9xJMX630-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-large-11-32-grip-grip-bundle-set?variant=41021953376317"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-large-11-32-grip",
        "handle": "jumbomax-jmx-ultralite-blackout-large-11-32-grip",
        "shopify_variants": [
          {
            "id": "40482646196285",
            "gid": "gid://shopify/ProductVariant/40482646196285",
            "sku": "JMX630-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-large-11-32-grip?variant=40482646196285"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-2023, jumbomax-large, Large, Most Popular Oversize,",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-blackout-medium-5-16",
    "brand": "JumboMax",
    "model": "NEW JumboMax JMX Ultralite BLACKOUT MEDIUM (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-medium-5-16-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-ultralite-blackout_6f566bd7-4fcc-4ac3-b242-837b9d7218f9.jpg?v=1766010985",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-medium-5-16-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-blackout-medium-5-16-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912369010",
            "gid": "gid://shopify/ProductVariant/61398912369010",
            "sku": "SET-13xJMX630-2200",
            "color": "Blackout",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-medium-5-16-grip-bundle-13pcs?variant=61398912369010"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-medium-5-16-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-blackout-medium-5-16-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953409085",
            "gid": "gid://shopify/ProductVariant/41021953409085",
            "sku": "SET-9xJMX630-2200",
            "color": "Blackout",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-medium-5-16-grip-grip-bundle-set?variant=41021953409085"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-medium-5-16-grip",
        "handle": "jumbomax-jmx-ultralite-blackout-medium-5-16-grip",
        "shopify_variants": [
          {
            "id": "40482646163517",
            "gid": "gid://shopify/ProductVariant/40482646163517",
            "sku": "JMX630-2200",
            "color": "Blackout",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-medium-5-16-grip?variant=40482646163517"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-2023, jumbomax-medium, Medium, Most Popular Oversiz",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-blackout-small-1-4",
    "brand": "JumboMax",
    "model": "NEW JumboMax JMX Ultralite BLACKOUT SMALL (+1/4\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Small (+1/4\")"
    ],
    "manufacturer_size_labels": [
      "Small (+1/4\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-small-1-4-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-ultralite-blackout.jpg?v=1766010990",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-small-1-4-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-blackout-small-1-4-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912467314",
            "gid": "gid://shopify/ProductVariant/61398912467314",
            "sku": "SET-13xJMX630-1100",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-small-1-4-grip-bundle-13pcs?variant=61398912467314"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-small-1-4-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-blackout-small-1-4-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953441853",
            "gid": "gid://shopify/ProductVariant/41021953441853",
            "sku": "SET-9xJMX630-1100",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-small-1-4-grip-grip-bundle-set?variant=41021953441853"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-small-1-4-grip",
        "handle": "jumbomax-jmx-ultralite-blackout-small-1-4-grip",
        "shopify_variants": [
          {
            "id": "40482646130749",
            "gid": "gid://shopify/ProductVariant/40482646130749",
            "sku": "JMX630-1100",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-small-1-4-grip?variant=40482646130749"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-2023, jumbomax-small, Most Popular Oversize, new-ad",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-blackout-x-large-3-8",
    "brand": "JumboMax",
    "model": "NEW JumboMax JMX Ultralite BLACKOUT X-LARGE (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-large-3-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-ultralite-blackout_d8a63286-745b-43ce-b8d0-b10eefea0626.jpg?v=1766010971",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-large-3-8-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-blackout-x-large-3-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398912303474",
            "gid": "gid://shopify/ProductVariant/61398912303474",
            "sku": "SET-13xJMX630-6600",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-large-3-8-grip-bundle-13pcs?variant=61398912303474"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-large-3-8-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-blackout-x-large-3-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953343549",
            "gid": "gid://shopify/ProductVariant/41021953343549",
            "sku": "SET-9xJMX630-6600",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-large-3-8-grip-grip-bundle-set?variant=41021953343549"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-large-3-8-grip",
        "handle": "jumbomax-jmx-ultralite-blackout-x-large-3-8-grip",
        "shopify_variants": [
          {
            "id": "40482646229053",
            "gid": "gid://shopify/ProductVariant/40482646229053",
            "sku": "JMX630-6600",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-large-3-8-grip?variant=40482646229053"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, jumbomax-2023, jumbomax-x-large, Most Popular Oversize, new-",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-blackout-x-small-3-16",
    "brand": "JumboMax",
    "model": "NEW JumboMax JMX Ultralite BLACKOUT X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-small-1-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-ultralite-blackout_7f4b4240-681b-4eb6-8b16-e6df9157d88a.jpg?v=1766010994",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-small-1-8-grip-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-blackout-x-small-1-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914040178",
            "gid": "gid://shopify/ProductVariant/61398914040178",
            "sku": "SET-13xJMX630-1000",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-small-1-8-grip-bundle-13pcs?variant=61398914040178"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-small-1-8-grip-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-blackout-x-small-1-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953474621",
            "gid": "gid://shopify/ProductVariant/41021953474621",
            "sku": "SET-9xJMX630-1000",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-small-1-8-grip-grip-bundle-set?variant=41021953474621"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-small-1-8-grip",
        "handle": "jumbomax-jmx-ultralite-blackout-x-small-1-8-grip",
        "shopify_variants": [
          {
            "id": "40482646097981",
            "gid": "gid://shopify/ProductVariant/40482646097981",
            "sku": "JMX630-1000",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-blackout-x-small-1-8-grip?variant=40482646097981"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbmax junior, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Ultralite, JumboMax XSmall, jumbomax-2023, jumbomax-x-s",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Lime"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/tour-series-blk-lime_a09d1fd2-e63e-4948-a5e1-e938d1a45f94.jpg?v=1766011141",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-grip-bundle-13pcs",
        "handle": "new-jumbomax-tour-series-standard-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398916792690",
            "gid": "gid://shopify/ProductVariant/61398916792690",
            "sku": "SET-13xJM450-800",
            "color": "Black / Lime",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-grip-bundle-13pcs?variant=61398916792690"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-grip-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021958946877",
            "gid": "gid://shopify/ProductVariant/41021958946877",
            "sku": "SET-9xJM450-800",
            "color": "Black / Lime",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-grip-grip-bundle-set?variant=41021958946877"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black / Lime"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-grip",
        "handle": "new-jumbomax-tour-series-standard-grip",
        "shopify_variants": [
          {
            "id": "32948055343165",
            "gid": "gid://shopify/ProductVariant/32948055343165",
            "sku": "JM450-800",
            "color": "Black / Lime",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-grip?variant=32948055343165"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbomax, JumboMax Tour Series, Most Popular Midsize, new-add-12172025, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Lime"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-sj-grip-1-8",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series (SJ) Grip +1/8\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Jumbo (+1/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Black / Lime"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 13.99,
    "bundle_price_min": 181.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tour-standard-oversize_86f85f11-964d-47ac-bebf-60900b9cd68f.jpg?v=1766011071",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8-bundle-13pcs",
        "handle": "new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398914630002",
            "gid": "gid://shopify/ProductVariant/61398914630002",
            "sku": "SET-13xJM450-950",
            "color": "Black / Lime",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8-bundle-13pcs?variant=61398914630002"
          },
          {
            "id": "61398914662770",
            "gid": "gid://shopify/ProductVariant/61398914662770",
            "sku": "SET-13xJM440-950",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8-bundle-13pcs?variant=61398914662770"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black / Lime"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8",
        "handle": "new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40482563260477",
            "gid": "gid://shopify/ProductVariant/40482563260477",
            "sku": "JM450-950",
            "color": "Black / Lime",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8?variant=40482563260477"
          },
          {
            "id": "40482563293245",
            "gid": "gid://shopify/ProductVariant/40482563293245",
            "sku": "JM440-950",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8?variant=40482563293245"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbomax, jumbomax standard jumbo, JumboMax Tour Series, jumbomax-2023, midsize, midsize-golf-grips, new-add-12172025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Lime",
      "Black / Silver"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-sj-grips-1-8",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series (SJ) Grips +1/8\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Jumbo (+1/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Lime"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 113.32,
    "price_max": 113.32,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-tour-standard-oversize_8f87151c-e036-4e89-bc8e-b2a371024e86.jpg?v=1735455708",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021954129981",
            "gid": "gid://shopify/ProductVariant/41021954129981",
            "sku": "SET-9xJM450-950",
            "color": "Black / Lime",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8-grip-bundle-set?variant=41021954129981"
          },
          {
            "id": "41021954162749",
            "gid": "gid://shopify/ProductVariant/41021954162749",
            "sku": "SET-9xJM440-950",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-jumbo-sj-grip-1-8-grip-bundle-set?variant=41021954162749"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbomax, jumbomax standard jumbo, JumboMax Tour Series, jumbomax-2023, mem25, midsize, midsize-golf-grips, new-bundle-set, prime-2025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Lime",
      "Black / Silver"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-so-grip-1-16",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series (SO) Grip +1/16\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Oversize (+1/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Black / Lime"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 13.99,
    "bundle_price_min": 181.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tour-standard-oversize.jpg?v=1766011133",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip-bundle-13pcs",
        "handle": "new-jumbomax-tour-series-standard-oversize-st-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398916727154",
            "gid": "gid://shopify/ProductVariant/61398916727154",
            "sku": "SET-13xJM450-900",
            "color": "Black / Lime",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip-bundle-13pcs?variant=61398916727154"
          },
          {
            "id": "61398916759922",
            "gid": "gid://shopify/ProductVariant/61398916759922",
            "sku": "SET-13xJM440-900",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip-bundle-13pcs?variant=61398916759922"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black / Lime"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip",
        "handle": "new-jumbomax-tour-series-standard-oversize-st-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32948138246205",
            "gid": "gid://shopify/ProductVariant/32948138246205",
            "sku": "JM450-900",
            "color": "Black / Lime",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip?variant=32948138246205"
          },
          {
            "id": "32948414578749",
            "gid": "gid://shopify/ProductVariant/32948414578749",
            "sku": "JM440-900",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip?variant=32948414578749"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbomax, JumboMax Tour Series, midsize, midsize-golf-grips, new-add-12172025, overstock-mar2024, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Lime",
      "Black / Silver"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-so-grips-1-16",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series (SO) Grips +1/16\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Oversize (+1/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Lime"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 113.32,
    "price_max": 113.32,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-tour-standard-oversize_5b75722c-aa3d-48d1-be0f-ca8055256e5f.jpg?v=1735455694",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-standard-oversize-st-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021958815805",
            "gid": "gid://shopify/ProductVariant/41021958815805",
            "sku": "SET-9xJM450-900",
            "color": "Black / Lime",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip-grip-bundle-set?variant=41021958815805"
          },
          {
            "id": "41021958848573",
            "gid": "gid://shopify/ProductVariant/41021958848573",
            "sku": "SET-9xJM440-900",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-standard-oversize-st-grip-grip-bundle-set?variant=41021958848573"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbomax, JumboMax Tour Series, mem25, midsize, midsize-golf-grips, new-bundle-set, prime-2025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Lime",
      "Black / Silver"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tourseries-blackout_9a5bccbf-a882-4b7d-9c78-8fbcc731ca80.jpg?v=1766011065",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-grip-bundle-13pcs",
        "handle": "new-jumbomax-tour-series-blackout-standard-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914597234",
            "gid": "gid://shopify/ProductVariant/61398914597234",
            "sku": "SET-13xJM460-800",
            "color": "Blackout",
            "size": "Standard",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-grip-bundle-13pcs?variant=61398914597234"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-grip-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-blackout-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954064445",
            "gid": "gid://shopify/ProductVariant/41021954064445",
            "sku": "SET-9xJM460-800",
            "color": "Blackout",
            "size": "Standard",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-grip-grip-bundle-set?variant=41021954064445"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-grip",
        "handle": "new-jumbomax-tour-series-blackout-standard-grip",
        "shopify_variants": [
          {
            "id": "40482580004925",
            "gid": "gid://shopify/ProductVariant/40482580004925",
            "sku": "JM460-800",
            "color": "Blackout",
            "size": "Standard",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-grip?variant=40482580004925"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbomax, JumboMax Tour Series, jumbomax-2023, Most Popular Midsize, new-add-12172025, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout-sj-grip-1-8",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT (SJ) Grip +1/8\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Jumbo (+1/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 13.99,
    "bundle_price_min": 181.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tourseries-blackout_f24c033c-cc5d-491c-9067-1cffbfd95bd7.jpg?v=1766011050",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8-bundle-13pcs",
        "handle": "new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914531698",
            "gid": "gid://shopify/ProductVariant/61398914531698",
            "sku": "SET-13xJM460-950",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": false,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8-bundle-13pcs?variant=61398914531698"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8",
        "handle": "new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8",
        "shopify_variants": [
          {
            "id": "40482580103229",
            "gid": "gid://shopify/ProductVariant/40482580103229",
            "sku": "JM460-950",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8?variant=40482580103229"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbomax, jumbomax standard jumbo, JumboMax Tour Series, jumbomax-2023, midsize, midsize-golf-grips, new-add-12172025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout-sj-grips-1-8",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT (SJ) Grips +1/8\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Jumbo (+1/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 113.32,
    "price_max": 113.32,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-tourseries-blackout_19054e20-a112-467c-afd3-5b0f6225a98b.jpg?v=1735455711",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953998909",
            "gid": "gid://shopify/ProductVariant/41021953998909",
            "sku": "SET-9xJM460-950",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard Jumbo (+1/8\")"
            },
            "available": false,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-jumbo-sj-grip-1-8-grip-bundle-set?variant=41021953998909"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Jumbo (+1/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbomax, jumbomax standard jumbo, JumboMax Tour Series, jumbomax-2023, midsize, midsize-golf-grips, new-bundle-set, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout-so-grip-1-16",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT (SO) Grip +1/16\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Oversize (+1/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 13.99,
    "bundle_price_min": 181.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-oversize-st-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tourseries-blackout_a8505c20-7d09-4b0a-9374-bf5dd23c5c7c.jpg?v=1766011055",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-oversize-st-grip-bundle-13pcs",
        "handle": "new-jumbomax-tour-series-blackout-standard-oversize-st-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914564466",
            "gid": "gid://shopify/ProductVariant/61398914564466",
            "sku": "SET-13xJM460-900",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-oversize-st-grip-bundle-13pcs?variant=61398914564466"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-oversize-st-grip",
        "handle": "new-jumbomax-tour-series-blackout-standard-oversize-st-grip",
        "shopify_variants": [
          {
            "id": "40482580070461",
            "gid": "gid://shopify/ProductVariant/40482580070461",
            "sku": "JM460-900",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-oversize-st-grip?variant=40482580070461"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbomax, JumboMax Tour Series, jumbomax-2023, midsize, midsize-golf-grips, new-add-12172025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout-so-grips-1-16",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT (SO) Grips +1/16\"",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Standard Oversize (+1/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 113.32,
    "price_max": 113.32,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-oversize-st-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-tourseries-blackout_17082ac9-ef5a-4786-96da-ced75205acc1.jpg?v=1735455710",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-oversize-st-grip-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-blackout-standard-oversize-st-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954031677",
            "gid": "gid://shopify/ProductVariant/41021954031677",
            "sku": "SET-9xJM460-900",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Standard Oversize (+1/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-standard-oversize-st-grip-grip-bundle-set?variant=41021954031677"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Oversize (+1/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbomax, JumboMax Tour Series, jumbomax-2023, midsize, midsize-golf-grips, new-bundle-set, prime-2025, rubber, single-golf-grips, single-grip, Size_Midsize, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout-large-11-32",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT LARGE (+11/32\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "LARGE (+11/32\")",
      "Large (+11/32\")"
    ],
    "manufacturer_size_labels": [
      "LARGE (+11/32\")",
      "Large (+11/32\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {
      "LARGE (+11/32\")": 87.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 13.99,
    "price_max": 185.58,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-large-11-32-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tourseries-blackout.jpg?v=1766011021",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-large-11-32-grip-bundle-13pcs",
        "handle": "jumbomax-tour-series-blackout-large-11-32-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914400626",
            "gid": "gid://shopify/ProductVariant/61398914400626",
            "sku": "SET-13xJM460-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-large-11-32-grip-bundle-13pcs?variant=61398914400626"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "LARGE (+11/32\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Blackout"
        ],
        "price": 185.58,
        "per_grip_g": 87.9,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-large-11-32-grips-13pc-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-blackout-large-11-32-grips-13pc-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Kit Option",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "LARGE (+11/32\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51882589553010",
            "gid": "gid://shopify/ProductVariant/51882589553010",
            "sku": "KIT+13xJM460-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "LARGE (+11/32\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-large-11-32-grips-13pc-grip-bundle-set?variant=51882589553010"
          },
          {
            "id": "51882589585778",
            "gid": "gid://shopify/ProductVariant/51882589585778",
            "sku": "KIT(8oz)+13xJM460-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "LARGE (+11/32\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-large-11-32-grips-13pc-grip-bundle-set?variant=51882589585778"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-large-11-32-grip-grip-bundle-set",
        "handle": "jumbomax-tour-series-blackout-large-11-32-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953835069",
            "gid": "gid://shopify/ProductVariant/41021953835069",
            "sku": "SET-9xJM460-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-large-11-32-grip-grip-bundle-set?variant=41021953835069"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-large-11-32-grip",
        "handle": "jumbomax-tour-series-blackout-large-11-32-grip",
        "shopify_variants": [
          {
            "id": "40482580267069",
            "gid": "gid://shopify/ProductVariant/40482580267069",
            "sku": "JM460-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-large-11-32-grip?variant=40482580267069"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Tour Series, jumbomax-2023, jumbomax-large, Large, Most Popular Oversize, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, under-1",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout-medium-5-16",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT MEDIUM (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-medium-5-16-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tourseries-blackout_222c15b0-a96d-4fb3-9f25-b8fa1885b994.jpg?v=1766011030",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-medium-5-16-grip-bundle-13pcs",
        "handle": "jumbomax-tour-series-blackout-medium-5-16-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914433394",
            "gid": "gid://shopify/ProductVariant/61398914433394",
            "sku": "SET-13xJM460-2200",
            "color": "Blackout",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-medium-5-16-grip-bundle-13pcs?variant=61398914433394"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-medium-5-16-grip-grip-bundle-set",
        "handle": "jumbomax-tour-series-blackout-medium-5-16-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953900605",
            "gid": "gid://shopify/ProductVariant/41021953900605",
            "sku": "SET-9xJM460-2200",
            "color": "Blackout",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-medium-5-16-grip-grip-bundle-set?variant=41021953900605"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-medium-5-16-grip",
        "handle": "jumbomax-tour-series-blackout-medium-5-16-grip",
        "shopify_variants": [
          {
            "id": "40482580201533",
            "gid": "gid://shopify/ProductVariant/40482580201533",
            "sku": "JM460-2200",
            "color": "Blackout",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-medium-5-16-grip?variant=40482580201533"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, golfers-gift-guide, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Tour Series, jumbomax-2023, jumbomax-medium, Medium, Most Popular Midsize, new-add-12172025, oversize, oversize-jumbo-golf-grips, overstock-mar2024, rubber,",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout-small-1-4",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT SMALL (+1/4\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Small (+1/4\")"
    ],
    "manufacturer_size_labels": [
      "Small (+1/4\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-small-1-4-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tourseries-blackout_a2e3fe31-3d28-46a4-9341-021ccacd39fd.jpg?v=1766011036",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-small-1-4-grip-bundle-13pcs",
        "handle": "jumbomax-tour-series-blackout-small-1-4-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914466162",
            "gid": "gid://shopify/ProductVariant/61398914466162",
            "sku": "SET-13xJM460-1100",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-small-1-4-grip-bundle-13pcs?variant=61398914466162"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-small-1-4-grip-grip-bundle-set",
        "handle": "jumbomax-tour-series-blackout-small-1-4-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953933373",
            "gid": "gid://shopify/ProductVariant/41021953933373",
            "sku": "SET-9xJM460-1100",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-small-1-4-grip-grip-bundle-set?variant=41021953933373"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-small-1-4-grip",
        "handle": "jumbomax-tour-series-blackout-small-1-4-grip",
        "shopify_variants": [
          {
            "id": "40482580168765",
            "gid": "gid://shopify/ProductVariant/40482580168765",
            "sku": "JM460-1100",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-small-1-4-grip?variant=40482580168765"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Tour Series, jumbomax-2023, jumbomax-small, Large, Most Popular Oversize, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, under-1",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout-x-large-3-8",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT X-Large (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-xl-3-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tourseries-blackout_4eb6b574-69a3-4ec1-a683-b40c809cb0ef.jpg?v=1766011016",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-xl-3-8-grip-bundle-13pcs",
        "handle": "jumbomax-tour-series-blackout-xl-3-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914171250",
            "gid": "gid://shopify/ProductVariant/61398914171250",
            "sku": "SET-13xJM460-6600",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-xl-3-8-grip-bundle-13pcs?variant=61398914171250"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-xl-3-8-grip-grip-bundle-set",
        "handle": "jumbomax-tour-series-blackout-xl-3-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953802301",
            "gid": "gid://shopify/ProductVariant/41021953802301",
            "sku": "SET-9xJM460-6600",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-xl-3-8-grip-grip-bundle-set?variant=41021953802301"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-xl-3-8-grip",
        "handle": "jumbomax-tour-series-blackout-xl-3-8-grip",
        "shopify_variants": [
          {
            "id": "40482580299837",
            "gid": "gid://shopify/ProductVariant/40482580299837",
            "sku": "JM460-6600",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-xl-3-8-grip?variant=40482580299837"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Tour Series, jumbomax-2023, jumbomax-x-large, Most Popular Oversize, new-add-12172025, oversize, oversize-jumbo-golf-grips, overstock-mar2024, rubber, single-golf-grips, single",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-tour-series-blackout-x-small-3-16",
    "brand": "JumboMax",
    "model": "NEW JumboMax Tour Series BLACKOUT X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 181.87,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-junior-grip-usa",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tourseries-blackout_7c5e61cf-7767-4039-8782-3f289d91a412.jpg?v=1766011046",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-junior-grip-usa-bundle-13pcs",
        "handle": "jumbomax-tour-series-blackout-junior-grip-usa-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914498930",
            "gid": "gid://shopify/ProductVariant/61398914498930",
            "sku": "SET-13xJM460-1000",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-junior-grip-usa-bundle-13pcs?variant=61398914498930"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Blackout"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-junior-grip-usa-grip-bundle-set",
        "handle": "jumbomax-tour-series-blackout-junior-grip-usa-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953966141",
            "gid": "gid://shopify/ProductVariant/41021953966141",
            "sku": "SET-9xJM460-1000",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-junior-grip-usa-grip-bundle-set?variant=41021953966141"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "single",
        "colors": [
          "Blackout"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-junior-grip-usa",
        "handle": "jumbomax-tour-series-blackout-junior-grip-usa",
        "shopify_variants": [
          {
            "id": "40482580135997",
            "gid": "gid://shopify/ProductVariant/40482580135997",
            "sku": "JM460-1000",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-blackout-junior-grip-usa?variant=40482580135997"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, july4-2022, jumbo, jumbo/oversize, jumbomax, JumboMax Jr, JumboMax Junior, JumboMax Tour Series, jumbomax-2023, jumbomax-x-small, junior-golf-grips, Most Popular Midsize, new-add-12172025, oversize, oversize-jumbo-golf",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-str8-medium-5-16-grip-non-tapered",
    "brand": "JumboMax",
    "model": "NEW! JumboMax JMX UltraLite STR8 MEDIUM (+5/16\") Grip (Non-Tapered)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": 207.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-ultralite-str8-golf-grip_c63cbd12-0e0b-4ba0-9d9a-234919a99917.jpg?v=1766011119",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398916530546",
            "gid": "gid://shopify/ProductVariant/61398916530546",
            "sku": "SET-13xJMX610-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-bundle-13pcs?variant=61398916530546"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered",
        "handle": "jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered",
        "shopify_variants": [
          {
            "id": "39373312720957",
            "gid": "gid://shopify/ProductVariant/39373312720957",
            "sku": "JMX610-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered?variant=39373312720957"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, asbl-grip-option, golf-grips, grip bundle, iron/wood, JMX, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Non-Tapered, JumboMax STR8, JumboMax Ultralite, jumbomax-medi",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-str8-medium-5-16-grips-non-tapered",
    "brand": "JumboMax",
    "model": "NEW! JumboMax JMX UltraLite STR8 MEDIUM (+5/16\") Grips (Non-Tapered)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {
      "Medium (+5/16\")": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 129.52,
    "price_max": 129.52,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-jmx-ultralite-str8-golf-grip_ba0c8f22-fd3f-4027-9670-b51a2a51d091.jpg?v=1735455702",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021956816957",
            "gid": "gid://shopify/ProductVariant/41021956816957",
            "sku": "SET-9xJMX610-2200",
            "color": "Black (with Red/White/Blue)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-medium-3-8-grip-non-tapered-grip-bundle-set?variant=41021956816957"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, golf-grips, grip bundle, iron/wood, JMX, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Non-Tapered, JumboMax STR8, JumboMax Ultralite, jumbomax-medium, Medium, Most Popular Oversiz",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered",
    "brand": "JumboMax",
    "model": "NEW! JumboMax JMX UltraLite STR8 X-LARGE (+3/8\") Grip (Non-Tapered)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": 207.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-ultralite-str8-golf-grip.jpg?v=1766011123",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398916563314",
            "gid": "gid://shopify/ProductVariant/61398916563314",
            "sku": "SET-13xJMX610-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-bundle-13pcs?variant=61398916563314"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered",
        "handle": "jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered",
        "shopify_variants": [
          {
            "id": "39373291520061",
            "gid": "gid://shopify/ProductVariant/39373291520061",
            "sku": "JMX610-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered?variant=39373291520061"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, asbl-grip-option, golf-grips, grip bundle, iron/wood, JMX, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Non-Tapered, JumboMax STR8, JumboMax Ultralite, jumbomax-x-la",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-str8-x-large-3-8-grips-non-tapered",
    "brand": "JumboMax",
    "model": "NEW! JumboMax JMX UltraLite STR8 X-LARGE (+3/8\") Grips (Non-Tapered)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {
      "X-Large (+3/8\")": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 129.52,
    "price_max": 129.52,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-jmx-ultralite-str8-golf-grip_f10b811f-6177-49a9-b8c6-7dff7e4eb8b9.jpg?v=1735455700",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021956915261",
            "gid": "gid://shopify/ProductVariant/41021956915261",
            "sku": "SET-9xJMX610-6600",
            "color": "Black (with Red/White/Blue)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-large-3-8-grip-non-tapered-grip-bundle-set?variant=41021956915261"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, golf-grips, grip bundle, iron/wood, JMX, JMX Ultralite, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Non-Tapered, JumboMax STR8, JumboMax Ultralite, jumbomax-x-large, Most Popular Oversize, new-",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-str8-x-small-3-16-grip-non-tapered",
    "brand": "JumboMax",
    "model": "NEW! JumboMax JMX UltraLite STR8 X-Small (+3/16\") Grip (Non-Tapered)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": 207.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-jmx-ultralite-str8-golf-grip_18ced680-d41f-4f7a-9926-d71f7725d653.jpg?v=1766011114",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-bundle-13pcs",
        "handle": "jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398916497778",
            "gid": "gid://shopify/ProductVariant/61398916497778",
            "sku": "SET-13xJMX610-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-bundle-13pcs?variant=61398916497778"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "single",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered",
        "handle": "jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered",
        "shopify_variants": [
          {
            "id": "39373321961533",
            "gid": "gid://shopify/ProductVariant/39373321961533",
            "sku": "JMX610-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered?variant=39373321961533"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, asbl-grip-option, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbmax junior, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Non-Tapered, JumboMax STR8, JumboMax ",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-new-jumbomax-jmx-ultralite-str8-x-small-3-16-grips-non-tapered",
    "brand": "JumboMax",
    "model": "NEW! JumboMax JMX UltraLite STR8 X-Small (+3/16\") Grips (Non-Tapered)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (ultralight)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/jumbomax-jmx-ultralite",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with Red/White/Blue)"
    ],
    "weight_g_by_size": {
      "X-Small (+3/16\")": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 129.52,
    "price_max": 129.52,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.39,
    "bundle_price_min": 129.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-jmx-ultralite-str8-golf-grip_8bd9ef95-91dd-4df7-9e50-ded24b98e902.jpg?v=1735455703",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with Red/White/Blue)"
        ],
        "price": 129.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-grip-bundle-set",
        "handle": "jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021956751421",
            "gid": "gid://shopify/ProductVariant/41021956751421",
            "sku": "SET-9xJMX610-1000",
            "color": "Black (with Red/White/Blue)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with Red/White/Blue)",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 129.52,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-ultralite-str8-x-small-3-8-grip-non-tapered-grip-bundle-set?variant=41021956751421"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Red/White/Blue)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, golf-grips, grip bundle, iron/wood, JMX, jmx 17, JMX Ultralite, jumbmax junior, jumbo, jumbo/oversize, jumbomax, JumboMax JMX Ultralite, JumboMax Light, JumboMax Lightweight, JumboMax Lite, JumboMax Non-Tapered, JumboMax STR8, JumboMax Ultralite, JumboMax XSmall, jumb",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/jumbomax-jmx-ultralite",
    "last_verified_date": "",
    "manual_notes": "oversize, ~48-50g; light grip pressure / joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with Red/White/Blue)"
    ]
  },
  {
    "id": "jumbomax-str8-tech-non-tapered-medium-5-16",
    "brand": "JumboMax",
    "model": "STR8 Tech Non-Tapered MEDIUM (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "Black (with White/Green accents)",
      "WRAP STYLE"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14.99,
    "price_max": 197.93,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": 121.42,
    "kit_price_min": 197.93,
    "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-JM550-2200.jpg?v=1766011189",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 8,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 194.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-bundle-13pcs",
        "handle": "jumbomax-str8-tech-non-tapered-medium-5-16-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398918726002",
            "gid": "gid://shopify/ProductVariant/61398918726002",
            "sku": "SET-13xJM550-2200",
            "color": "Black (with White/Green accents)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-bundle-13pcs?variant=61398918726002"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black",
          "WRAP STYLE"
        ],
        "price": 194.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-bundle-13pcs",
        "handle": "jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398918693234",
            "gid": "gid://shopify/ProductVariant/61398918693234",
            "sku": "SET-13xJM500-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-bundle-13pcs?variant=61398918693234"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 121.42,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-grip-bundle-set",
        "handle": "jumbomax-str8-tech-non-tapered-medium-5-16-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021962420285",
            "gid": "gid://shopify/ProductVariant/41021962420285",
            "sku": "SET-9xJM550-2200",
            "color": "Black (with White/Green accents)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 121.42,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-grip-bundle-set?variant=41021962420285"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 121.42,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-grip-bundle-set",
        "handle": "jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021962387517",
            "gid": "gid://shopify/ProductVariant/41021962387517",
            "sku": "SET-9xJM500-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 121.42,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-grip-bundle-set?variant=41021962387517"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 197.93,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-str8-tech-non-tapered-medium-5-16-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919995453501",
            "gid": "gid://shopify/ProductVariant/39919995453501",
            "sku": "KIT+13xJM550-2200",
            "color": "Black (with White/Green accents)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 197.93,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-13pcs-golf-grip-kit?variant=39919995453501"
          },
          {
            "id": "39919995551805",
            "gid": "gid://shopify/ProductVariant/39919995551805",
            "sku": "KIT(8oz)+13xJM550-2200",
            "color": "Black (with White/Green accents)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 202.97,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-13pcs-golf-grip-kit?variant=39919995551805"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black",
          "WRAP STYLE"
        ],
        "price": 197.93,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-13pcs-golf-grip-kit",
        "handle": "jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919997288509",
            "gid": "gid://shopify/ProductVariant/39919997288509",
            "sku": "KIT+13xJM500-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 197.93,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-13pcs-golf-grip-kit?variant=39919997288509"
          },
          {
            "id": "39919997321277",
            "gid": "gid://shopify/ProductVariant/39919997321277",
            "sku": "KIT(8oz)+13xJM500-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 202.97,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style-13pcs-golf-grip-kit?variant=39919997321277"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Black",
          "WRAP STYLE"
        ],
        "price": 14.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style",
        "handle": "jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style",
        "shopify_variants": [
          {
            "id": "29515021582397",
            "gid": "gid://shopify/ProductVariant/29515021582397",
            "sku": "JM500-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip-wrap-style?variant=29515021582397"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 14.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip",
        "handle": "jumbomax-str8-tech-non-tapered-medium-5-16-grip",
        "shopify_variants": [
          {
            "id": "29515010965565",
            "gid": "gid://shopify/ProductVariant/29515010965565",
            "sku": "JM550-2200",
            "color": "Black (with White/Green accents)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-medium-5-16-grip?variant=29515010965565"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Non-Tapered, JumboMax STR8, jumbomax-medium, Less Tapered, Medium, new-add-12172025, non-tapered, non-tapered swing grips, non-tapered-and-less-tapered-swing-grips, oversize, o",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, straight (no taper)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with White/Green accents)",
      "Black"
    ]
  },
  {
    "id": "jumbomax-str8-tech-non-tapered-x-large-3-8",
    "brand": "JumboMax",
    "model": "STR8 Tech Non-Tapered X-LARGE (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "Black (with White/Green accents)",
      "WRAP STYLE"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14.99,
    "price_max": 197.93,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": 121.42,
    "kit_price_min": 197.93,
    "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-JM500-2200_7ee5c89e-0695-46d6-b2cf-be2f04b9850e.jpg?v=1766011096",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 8,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black",
          "WRAP STYLE"
        ],
        "price": 194.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-bundle-13pcs",
        "handle": "jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914793842",
            "gid": "gid://shopify/ProductVariant/61398914793842",
            "sku": "SET-13xJM500-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-bundle-13pcs?variant=61398914793842"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 194.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-bundle-13pcs",
        "handle": "jumbomax-str8-tech-non-tapered-x-large-3-8-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914761074",
            "gid": "gid://shopify/ProductVariant/61398914761074",
            "sku": "SET-13xJM550-6600",
            "color": "Black (with White/Green accents)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-bundle-13pcs?variant=61398914761074"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 121.42,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-grip-bundle-set",
        "handle": "jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954359357",
            "gid": "gid://shopify/ProductVariant/41021954359357",
            "sku": "SET-9xJM500-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 121.42,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-grip-bundle-set?variant=41021954359357"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 121.42,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-grip-bundle-set",
        "handle": "jumbomax-str8-tech-non-tapered-x-large-3-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954326589",
            "gid": "gid://shopify/ProductVariant/41021954326589",
            "sku": "SET-9xJM550-6600",
            "color": "Black (with White/Green accents)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 121.42,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-grip-bundle-set?variant=41021954326589"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 197.93,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-str8-tech-non-tapered-x-large-3-8-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919992438845",
            "gid": "gid://shopify/ProductVariant/39919992438845",
            "sku": "KIT+13xJM550-6600",
            "color": "Black (with White/Green accents)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 197.93,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-13pcs-golf-grip-kit?variant=39919992438845"
          },
          {
            "id": "39919992471613",
            "gid": "gid://shopify/ProductVariant/39919992471613",
            "sku": "KIT(8oz)+13xJM550-6600",
            "color": "Black (with White/Green accents)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 202.97,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-13pcs-golf-grip-kit?variant=39919992471613"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 14.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip",
        "handle": "jumbomax-str8-tech-non-tapered-x-large-3-8-grip",
        "shopify_variants": [
          {
            "id": "39871093440573",
            "gid": "gid://shopify/ProductVariant/39871093440573",
            "sku": "JM550-6600",
            "color": "Black (with White/Green accents)",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip?variant=39871093440573"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black",
          "WRAP STYLE"
        ],
        "price": 197.93,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-13pcs-golf-grip-kit",
        "handle": "jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919992864829",
            "gid": "gid://shopify/ProductVariant/39919992864829",
            "sku": "KIT+13xJM500-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 197.93,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-13pcs-golf-grip-kit?variant=39919992864829"
          },
          {
            "id": "39919992963133",
            "gid": "gid://shopify/ProductVariant/39919992963133",
            "sku": "KIT(8oz)+13xJM500-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 202.97,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style-13pcs-golf-grip-kit?variant=39919992963133"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Black",
          "WRAP STYLE"
        ],
        "price": 14.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style",
        "handle": "jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style",
        "shopify_variants": [
          {
            "id": "39870354784317",
            "gid": "gid://shopify/ProductVariant/39870354784317",
            "sku": "JM500-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-large-3-8-grip-wrap-style?variant=39870354784317"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Non-Tapered, JumboMax STR8, jumbomax-x-large, Less Tapered, new-add-12172025, non-tapered, non-tapered swing grips, non-tapered-and-less-tapered-swing-grips, oversize, oversize",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, straight (no taper)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with White/Green accents)",
      "Black"
    ]
  },
  {
    "id": "jumbomax-str8-tech-non-tapered-x-small-3-16",
    "brand": "JumboMax",
    "model": "STR8 Tech Non-Tapered X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "WRAP STYLE"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14.99,
    "price_max": 197.93,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": 121.42,
    "kit_price_min": 197.93,
    "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-JM500-2200_2ec8b5be-6f67-44a6-a630-17985a69d592.jpg?v=1766011011",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black",
          "WRAP STYLE"
        ],
        "price": 194.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-bundle-13pcs",
        "handle": "jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914138482",
            "gid": "gid://shopify/ProductVariant/61398914138482",
            "sku": "SET-13xJM500-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-bundle-13pcs?variant=61398914138482"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 121.42,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-grip-bundle-set",
        "handle": "jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953769533",
            "gid": "gid://shopify/ProductVariant/41021953769533",
            "sku": "SET-9xJM500-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 121.42,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-grip-bundle-set?variant=41021953769533"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black",
          "WRAP STYLE"
        ],
        "price": 197.93,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-13pcs-golf-grip-kit",
        "handle": "jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40482620244029",
            "gid": "gid://shopify/ProductVariant/40482620244029",
            "sku": "KIT+13xJM500-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 197.93,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-13pcs-golf-grip-kit?variant=40482620244029"
          },
          {
            "id": "40482620276797",
            "gid": "gid://shopify/ProductVariant/40482620276797",
            "sku": "KIT(8oz)+13xJM500-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 202.97,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style-13pcs-golf-grip-kit?variant=40482620276797"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "single",
        "colors": [
          "Black",
          "WRAP STYLE"
        ],
        "price": 14.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style",
        "handle": "jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style",
        "shopify_variants": [
          {
            "id": "40482619981885",
            "gid": "gid://shopify/ProductVariant/40482619981885",
            "sku": "JM500-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-wrap-style?variant=40482619981885"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbmax junior, jumbo, jumbo/oversize, jumbomax, JumboMax Non-Tapered, JumboMax STR8, jumbomax-2023, jumbomax-medium, Less Tapered, Medium, new-add-12172025, non-tapered, non-tapered swing grips, non-tapered-and-less-t",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, straight (no taper)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-str8-tech-tour-non-tapered-x-small-3-16",
    "brand": "JumboMax",
    "model": "STR8 Tech Tour Non-Tapered X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black (with White/Green accents)"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 14.99,
    "price_max": 197.93,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": 121.42,
    "kit_price_min": 197.93,
    "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-JM550-2200_e233b1ed-cd59-4145-a39f-3bc31ccf259f.jpg?v=1766011004",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 194.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-bundle-13pcs",
        "handle": "jumbomax-str8-tech-non-tapered-x-small-3-16-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914105714",
            "gid": "gid://shopify/ProductVariant/61398914105714",
            "sku": "SET-13xJM550-1000",
            "color": "Black (with White/Green accents)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 194.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-bundle-13pcs?variant=61398914105714"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 121.42,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-grip-bundle-set",
        "handle": "jumbomax-str8-tech-non-tapered-x-small-3-16-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953736765",
            "gid": "gid://shopify/ProductVariant/41021953736765",
            "sku": "SET-9xJM550-1000",
            "color": "Black (with White/Green accents)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 121.42,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-grip-bundle-set?variant=41021953736765"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 197.93,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-str8-tech-non-tapered-x-small-3-16-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40482620407869",
            "gid": "gid://shopify/ProductVariant/40482620407869",
            "sku": "KIT+13xJM550-1000",
            "color": "Black (with White/Green accents)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 197.93,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-13pcs-golf-grip-kit?variant=40482620407869"
          },
          {
            "id": "40482620440637",
            "gid": "gid://shopify/ProductVariant/40482620440637",
            "sku": "KIT(8oz)+13xJM550-1000",
            "color": "Black (with White/Green accents)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 202.97,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip-13pcs-golf-grip-kit?variant=40482620440637"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "single",
        "colors": [
          "Black (with White/Green accents)"
        ],
        "price": 14.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip",
        "handle": "jumbomax-str8-tech-non-tapered-x-small-3-16-grip",
        "shopify_variants": [
          {
            "id": "40482620309565",
            "gid": "gid://shopify/ProductVariant/40482620309565",
            "sku": "JM550-1000",
            "color": "Black (with White/Green accents)",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black (with White/Green accents)",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-str8-tech-non-tapered-x-small-3-16-grip?variant=40482620309565"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with White/Green accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbmax junior, jumbo, jumbo/oversize, jumbomax, JumboMax Non-Tapered, JumboMax STR8, jumbomax-2023, jumbomax-medium, Less Tapered, Medium, new-add-12172025, non-tapered, non-tapered swing grips, non-tapered-and-less-t",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, straight (no taper)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black (with White/Green accents)"
    ]
  },
  {
    "id": "jumbomax-tour-series-blackout-medium-5-16",
    "brand": "JumboMax",
    "model": "Tour Series BLACKOUT MEDIUM (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "MEDIUM (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "MEDIUM (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {
      "MEDIUM (+5/16\")": 87.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 185.58,
    "price_max": 185.58,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.28,
    "bundle_price_min": null,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-medium-5-16-grips-13pc-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/BLACKOUT.jpg?v=1743553045",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "MEDIUM (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Blackout"
        ],
        "price": 185.58,
        "per_grip_g": 87.9,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-medium-5-16-grips-13pc-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-blackout-medium-5-16-grips-13pc-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Kit Option",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "MEDIUM (+5/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51879552713074",
            "gid": "gid://shopify/ProductVariant/51879552713074",
            "sku": "KIT+13xJM460-2200",
            "color": "Blackout",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "MEDIUM (+5/16\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-medium-5-16-grips-13pc-grip-bundle-set?variant=51879552713074"
          },
          {
            "id": "51879552745842",
            "gid": "gid://shopify/ProductVariant/51879552745842",
            "sku": "KIT(8oz)+13xJM460-2200",
            "color": "Blackout",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "MEDIUM (+5/16\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-medium-5-16-grips-13pc-grip-bundle-set?variant=51879552745842"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf-grips, grip bundle, grip kit, grip kits, gripkit-freetowel-2026, iron/wood, jumbo, jumbo/oversize, jumbomax, jumbomax grip kit, JumboMax Grip Kits, Jumb",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-tour-series-blackout-small-1-4",
    "brand": "JumboMax",
    "model": "Tour Series BLACKOUT SMALL (+1/4\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "SMALL (+1/4\")"
    ],
    "manufacturer_size_labels": [
      "SMALL (+1/4\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {
      "SMALL (+1/4\")": 87.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 185.58,
    "price_max": 185.58,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.28,
    "bundle_price_min": null,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-small-3-8-grips-13pc-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/BLACKOUT.jpg?v=1743553045",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "SMALL (+1/4\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Blackout"
        ],
        "price": 185.58,
        "per_grip_g": 87.9,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-small-3-8-grips-13pc-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-blackout-small-3-8-grips-13pc-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Kit Option",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "SMALL (+1/4\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51879531905394",
            "gid": "gid://shopify/ProductVariant/51879531905394",
            "sku": "KIT+13xJM460-1100",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "SMALL (+1/4\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-small-3-8-grips-13pc-grip-bundle-set?variant=51879531905394"
          },
          {
            "id": "51879531938162",
            "gid": "gid://shopify/ProductVariant/51879531938162",
            "sku": "KIT(8oz)+13xJM460-1100",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "SMALL (+1/4\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-small-3-8-grips-13pc-grip-bundle-set?variant=51879531938162"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf-grips, grip bundle, grip kit, grip kits, gripkit-freetowel-2026, iron/wood, jumbo, jumbo/oversize, jumbomax, jumbomax grip kit, JumboMax Grip Kits, Jumb",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-tour-series-blackout-x-large-3-8",
    "brand": "JumboMax",
    "model": "Tour Series BLACKOUT X-LARGE (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {
      "X-Large (+3/8\")": 87.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 185.58,
    "price_max": 185.58,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.28,
    "bundle_price_min": null,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-x-large-x-large-3-8-grips-13pc-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/BLACKOUT.jpg?v=1743553045",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Blackout"
        ],
        "price": 185.58,
        "per_grip_g": 87.9,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-x-large-x-large-3-8-grips-13pc-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-blackout-x-large-x-large-3-8-grips-13pc-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Kit Option",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51879508312434",
            "gid": "gid://shopify/ProductVariant/51879508312434",
            "sku": "KIT+13xJM460-6600",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-x-large-x-large-3-8-grips-13pc-grip-bundle-set?variant=51879508312434"
          },
          {
            "id": "51879531643250",
            "gid": "gid://shopify/ProductVariant/51879531643250",
            "sku": "KIT(8oz)+13xJM460-6600",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-x-large-x-large-3-8-grips-13pc-grip-bundle-set?variant=51879531643250"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf-grips, grip bundle, grip kit, grip kits, gripkit-freetowel-2026, iron/wood, jumbo, jumbo/oversize, jumbomax, jumbomax grip kit, JumboMax Grip Kits, Jumb",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-tour-series-blackout-x-small-3-16",
    "brand": "JumboMax",
    "model": "Tour Series BLACKOUT X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-SMALL (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-SMALL (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Blackout"
    ],
    "weight_g_by_size": {
      "X-SMALL (+3/16\")": 87.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 185.58,
    "price_max": 185.58,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.28,
    "bundle_price_min": null,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-x-small-3-8-grips-13pc-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/BLACKOUT.jpg?v=1743553045",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "X-SMALL (+3/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Blackout"
        ],
        "price": 185.58,
        "per_grip_g": 87.9,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-x-small-3-8-grips-13pc-grip-bundle-set",
        "handle": "new-jumbomax-tour-series-blackout-x-small-3-8-grips-13pc-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blackout"
            ]
          },
          {
            "name": "Kit Option",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-SMALL (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51879550681458",
            "gid": "gid://shopify/ProductVariant/51879550681458",
            "sku": "KIT+13xJM460-1000",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-SMALL (+3/16\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-x-small-3-8-grips-13pc-grip-bundle-set?variant=51879550681458"
          },
          {
            "id": "51879550714226",
            "gid": "gid://shopify/ProductVariant/51879550714226",
            "sku": "KIT(8oz)+13xJM460-1000",
            "color": "Blackout",
            "size": "Undersize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Option": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-SMALL (+3/16\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-jumbomax-tour-series-blackout-x-small-3-8-grips-13pc-grip-bundle-set?variant=51879550714226"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf-grips, grip bundle, grip kit, grip kits, gripkit-freetowel-2026, iron/wood, jumbmax junior, jumbo, jumbo/oversize, jumbomax, jumbomax grip kit, JumboMax",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-tour-series-large-11-32",
    "brand": "JumboMax",
    "model": "Tour Series LARGE (+11/32\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Large (+11/32\")"
    ],
    "manufacturer_size_labels": [
      "Large (+11/32\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Lime Green"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 185.58,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tour-series-xl_68bc5d64-e3aa-401f-89de-e2e45dbc581e.jpg?v=1766011294",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Lime Green"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-bundle-13pcs",
        "handle": "jumbomax-tour-series-large-11-32-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime Green",
              "Black / Silver",
              "Red / White / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398920692082",
            "gid": "gid://shopify/ProductVariant/61398920692082",
            "sku": "SET-13xJM450-4400",
            "color": "Black / Lime Green",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime Green",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-bundle-13pcs?variant=61398920692082"
          },
          {
            "id": "61398920724850",
            "gid": "gid://shopify/ProductVariant/61398920724850",
            "sku": "SET-13xJM440-4400",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-bundle-13pcs?variant=61398920724850"
          },
          {
            "id": "61398920757618",
            "gid": "gid://shopify/ProductVariant/61398920757618",
            "sku": "SET-13xJM430-4400",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-bundle-13pcs?variant=61398920757618"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Lime Green"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-grip-bundle-set",
        "handle": "jumbomax-tour-series-large-11-32-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime Green",
              "Black / Silver",
              "Red / White / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021964746813",
            "gid": "gid://shopify/ProductVariant/41021964746813",
            "sku": "SET-9xJM450-4400",
            "color": "Black / Lime Green",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime Green",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-grip-bundle-set?variant=41021964746813"
          },
          {
            "id": "41021964779581",
            "gid": "gid://shopify/ProductVariant/41021964779581",
            "sku": "SET-9xJM440-4400",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-grip-bundle-set?variant=41021964779581"
          },
          {
            "id": "41021964812349",
            "gid": "gid://shopify/ProductVariant/41021964812349",
            "sku": "SET-9xJM430-4400",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-grip-bundle-set?variant=41021964812349"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Lime Green"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime Green",
              "Black / Silver",
              "Red / White / Blue",
              "Blackout"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919994830909",
            "gid": "gid://shopify/ProductVariant/39919994830909",
            "sku": "KIT+13xJM450-4400",
            "color": "Black / Lime Green",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime Green",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit?variant=39919994830909"
          },
          {
            "id": "39919994896445",
            "gid": "gid://shopify/ProductVariant/39919994896445",
            "sku": "KIT(8oz)+13xJM450-4400",
            "color": "Black / Lime Green",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime Green",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit?variant=39919994896445"
          },
          {
            "id": "39919994863677",
            "gid": "gid://shopify/ProductVariant/39919994863677",
            "sku": "KIT+13xJM440-4400",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit?variant=39919994863677"
          },
          {
            "id": "39919994929213",
            "gid": "gid://shopify/ProductVariant/39919994929213",
            "sku": "KIT(8oz)+13xJM440-4400",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit?variant=39919994929213"
          },
          {
            "id": "40482558607421",
            "gid": "gid://shopify/ProductVariant/40482558607421",
            "sku": "KIT+13xJM430-4400",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit?variant=40482558607421"
          },
          {
            "id": "40482558640189",
            "gid": "gid://shopify/ProductVariant/40482558640189",
            "sku": "KIT(8oz)+13xJM430-4400",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit?variant=40482558640189"
          },
          {
            "id": "41547581292605",
            "gid": "gid://shopify/ProductVariant/41547581292605",
            "sku": "KIT+13xJM460-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit?variant=41547581292605"
          },
          {
            "id": "41547581358141",
            "gid": "gid://shopify/ProductVariant/41547581358141",
            "sku": "KIT(8oz)+13xJM460-4400",
            "color": "Blackout",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blackout",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip-13pcs-golf-grip-kit?variant=41547581358141"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "single",
        "colors": [
          "Black / Lime Green"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip",
        "handle": "jumbomax-tour-series-large-11-32-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime Green",
              "Black / Silver",
              "Red / White / Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "12929578205245",
            "gid": "gid://shopify/ProductVariant/12929578205245",
            "sku": "JM450-4400",
            "color": "Black / Lime Green",
            "size": "Large (+11/32\")",
            "selected_options": {
              "Color": "Black / Lime Green"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip?variant=12929578205245"
          },
          {
            "id": "12929578270781",
            "gid": "gid://shopify/ProductVariant/12929578270781",
            "sku": "JM440-4400",
            "color": "Black / Silver",
            "size": "Large (+11/32\")",
            "selected_options": {
              "Color": "Black / Silver"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip?variant=12929578270781"
          },
          {
            "id": "40482557034557",
            "gid": "gid://shopify/ProductVariant/40482557034557",
            "sku": "JM430-4400",
            "color": "Red / White / Blue",
            "size": "Large (+11/32\")",
            "selected_options": {
              "Color": "Red / White / Blue"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-large-11-32-grip?variant=40482557034557"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Tour Series, jumbomax-2023, jumbomax-large, Large, Most Popular Oversize, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, under-1",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Lime Green",
      "Black / Silver",
      "Red / White / Blue",
      "Blackout"
    ]
  },
  {
    "id": "jumbomax-tour-series-medium-5-16",
    "brand": "JumboMax",
    "model": "Tour Series MEDIUM (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "style_forward",
    "non_black_color_count": 4,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "(USA) Red / White / Blue",
      "Black / Lime",
      "Black / Silver",
      "Pink / Grey",
      "Red / White / Blue",
      "USA"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 185.58,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.38,
    "bundle_price_min": 113.32,
    "kit_price_min": 160.88,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tour-series-med.jpg?v=1766011339",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 11,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-bundle-13pcs",
        "handle": "jumbomax-tour-series-medium-5-16-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Red / White / Blue",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398922297714",
            "gid": "gid://shopify/ProductVariant/61398922297714",
            "sku": "SET-13xJM450-2200",
            "color": "Black / Lime",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-bundle-13pcs?variant=61398922297714"
          },
          {
            "id": "61398922330482",
            "gid": "gid://shopify/ProductVariant/61398922330482",
            "sku": "SET-13xJM430-2200",
            "color": "Red / White / Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-bundle-13pcs?variant=61398922330482"
          },
          {
            "id": "61398922363250",
            "gid": "gid://shopify/ProductVariant/61398922363250",
            "sku": "SET-13xJM440-2200",
            "color": "Black / Silver",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-bundle-13pcs?variant=61398922363250"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Red / White / Blue",
          "USA"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa-bundle-13pcs",
        "handle": "jumbomax-tour-series-medium-5-16-grip-usa-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398921183602",
            "gid": "gid://shopify/ProductVariant/61398921183602",
            "sku": "SET-13xUSA-JM430-2200",
            "color": "Red / White / Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa-bundle-13pcs?variant=61398921183602"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-grip-bundle-set",
        "handle": "jumbomax-tour-series-medium-5-16-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Red / White / Blue",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021966876733",
            "gid": "gid://shopify/ProductVariant/41021966876733",
            "sku": "SET-9xJM450-2200",
            "color": "Black / Lime",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-grip-bundle-set?variant=41021966876733"
          },
          {
            "id": "41021966909501",
            "gid": "gid://shopify/ProductVariant/41021966909501",
            "sku": "SET-9xJM430-2200",
            "color": "Red / White / Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-grip-bundle-set?variant=41021966909501"
          },
          {
            "id": "41021966942269",
            "gid": "gid://shopify/ProductVariant/41021966942269",
            "sku": "SET-9xJM440-2200",
            "color": "Black / Silver",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-grip-bundle-set?variant=41021966942269"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Red / White / Blue"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa-grip-bundle-set",
        "handle": "jumbomax-tour-series-medium-5-16-grip-usa-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965566013",
            "gid": "gid://shopify/ProductVariant/41021965566013",
            "sku": "SET-9xUSA-JM430-2200",
            "color": "Red / White / Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": false,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa-grip-bundle-set?variant=41021965566013"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Red / White / Blue",
          "USA"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa-13pcs-golf-grip-kit",
        "handle": "jumbomax-tour-series-medium-5-16-grip-usa-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919994765373",
            "gid": "gid://shopify/ProductVariant/39919994765373",
            "sku": "KIT+13xUSA-JM430-2200",
            "color": "Red / White / Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa-13pcs-golf-grip-kit?variant=39919994765373"
          },
          {
            "id": "39919994798141",
            "gid": "gid://shopify/ProductVariant/39919994798141",
            "sku": "KIT(8oz)+13xUSA-JM430-2200",
            "color": "Red / White / Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa-13pcs-golf-grip-kit?variant=39919994798141"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Red / White / Blue",
          "USA"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa",
        "handle": "jumbomax-tour-series-medium-5-16-grip-usa",
        "shopify_variants": [
          {
            "id": "43327480787",
            "gid": "gid://shopify/ProductVariant/43327480787",
            "sku": "USA-JM430-2200",
            "color": "Red / White / Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip-usa?variant=43327480787"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Pink / Grey"
        ],
        "price": 160.88,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-pink-grey",
        "handle": "grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-pink-grey",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919997550653",
            "gid": "gid://shopify/ProductVariant/39919997550653",
            "sku": "KIT+13xJM420-2200",
            "color": "Pink / Grey",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-pink-grey?variant=39919997550653"
          },
          {
            "id": "39919997583421",
            "gid": "gid://shopify/ProductVariant/39919997583421",
            "sku": "KIT(8oz)+13xJM420-2200",
            "color": "Pink / Grey",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 165.92,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-pink-grey?variant=39919997583421"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "(USA) Red / White / Blue"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-usa",
        "handle": "grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-usa",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919997616189",
            "gid": "gid://shopify/ProductVariant/39919997616189",
            "sku": "KIT+13xJM430-2200",
            "color": "(USA) Red / White / Blue",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-usa?variant=39919997616189"
          },
          {
            "id": "39919997648957",
            "gid": "gid://shopify/ProductVariant/39919997648957",
            "sku": "KIT(8oz)+13xJM430-2200",
            "color": "(USA) Red / White / Blue",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-usa?variant=39919997648957"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Silver"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-black-silver",
        "handle": "grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-black-silver",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919997747261",
            "gid": "gid://shopify/ProductVariant/39919997747261",
            "sku": "KIT+13xJM440-2200",
            "color": "Black / Silver",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-black-silver?variant=39919997747261"
          },
          {
            "id": "39919997780029",
            "gid": "gid://shopify/ProductVariant/39919997780029",
            "sku": "KIT(8oz)+13xJM440-2200",
            "color": "Black / Silver",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-black-silver?variant=39919997780029"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Lime"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-black-lime",
        "handle": "grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-black-lime",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919997812797",
            "gid": "gid://shopify/ProductVariant/39919997812797",
            "sku": "KIT+13xJM450-2200",
            "color": "Black / Lime",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-black-lime?variant=39919997812797"
          },
          {
            "id": "39919997845565",
            "gid": "gid://shopify/ProductVariant/39919997845565",
            "sku": "KIT(8oz)+13xJM450-2200",
            "color": "Black / Lime",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-medium-5-16-grips-black-lime?variant=39919997845565"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "single",
        "colors": [
          "Black / Lime"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip",
        "handle": "jumbomax-tour-series-medium-5-16-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Red / White / Blue",
              "Black / Silver"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "27217674055",
            "gid": "gid://shopify/ProductVariant/27217674055",
            "sku": "JM450-2200",
            "color": "Black / Lime",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Color": "Black / Lime"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip?variant=27217674055"
          },
          {
            "id": "27217674183",
            "gid": "gid://shopify/ProductVariant/27217674183",
            "sku": "JM430-2200",
            "color": "Red / White / Blue",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Color": "Red / White / Blue"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip?variant=27217674183"
          },
          {
            "id": "27217674439",
            "gid": "gid://shopify/ProductVariant/27217674439",
            "sku": "JM440-2200",
            "color": "Black / Silver",
            "size": "Medium (+5/16\")",
            "selected_options": {
              "Color": "Black / Silver"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-medium-5-16-grip?variant=27217674439"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, golfers-gift-guide, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Tour Series, jumbomax-medium, Medium, Most Popular Midsize, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, u",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Lime",
      "Red / White / Blue",
      "Black / Silver",
      "(USA) Red / White / Blue"
    ]
  },
  {
    "id": "jumbomax-tour-series-small-1-4",
    "brand": "JumboMax",
    "model": "Tour Series SMALL (+1/4\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Small (+1/4\")"
    ],
    "manufacturer_size_labels": [
      "Small (+1/4\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Silver"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 185.58,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-3-colors_8d8a8fda-871a-4dc5-b879-8921f80240cc.jpg?v=1766011264",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Silver"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-bundle-13pcs",
        "handle": "jumbomax-tour-series-small-1-4-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Silver",
              "Black / Green",
              "Red / White / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398920003954",
            "gid": "gid://shopify/ProductVariant/61398920003954",
            "sku": "SET-13xJM440-1100",
            "color": "Black / Silver",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-bundle-13pcs?variant=61398920003954"
          },
          {
            "id": "61398920036722",
            "gid": "gid://shopify/ProductVariant/61398920036722",
            "sku": "SET-13xJM450-1100",
            "color": "Black / Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Green",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-bundle-13pcs?variant=61398920036722"
          },
          {
            "id": "61398920069490",
            "gid": "gid://shopify/ProductVariant/61398920069490",
            "sku": "SET-13xJM430-1100",
            "color": "Red / White / Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-bundle-13pcs?variant=61398920069490"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Silver"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-grip-bundle-set",
        "handle": "jumbomax-tour-series-small-1-4-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Silver",
              "Black / Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021963927613",
            "gid": "gid://shopify/ProductVariant/41021963927613",
            "sku": "SET-9xJM440-1100",
            "color": "Black / Silver",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-grip-bundle-set?variant=41021963927613"
          },
          {
            "id": "41021963960381",
            "gid": "gid://shopify/ProductVariant/41021963960381",
            "sku": "SET-9xJM450-1100",
            "color": "Black / Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Green",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-grip-bundle-set?variant=41021963960381"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Silver"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-13pcs-golf-grip-kit",
        "handle": "jumbomax-tour-series-small-1-4-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Silver",
              "Black / Green",
              "Red / White / Blue"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919994961981",
            "gid": "gid://shopify/ProductVariant/39919994961981",
            "sku": "KIT+13xJM440-1100",
            "color": "Black / Silver",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Silver",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-13pcs-golf-grip-kit?variant=39919994961981"
          },
          {
            "id": "39919994994749",
            "gid": "gid://shopify/ProductVariant/39919994994749",
            "sku": "KIT(8oz)+13xJM440-1100",
            "color": "Black / Silver",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Silver",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-13pcs-golf-grip-kit?variant=39919994994749"
          },
          {
            "id": "40482530820157",
            "gid": "gid://shopify/ProductVariant/40482530820157",
            "sku": "KIT+13xJM450-1100",
            "color": "Black / Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Green",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-13pcs-golf-grip-kit?variant=40482530820157"
          },
          {
            "id": "40482530852925",
            "gid": "gid://shopify/ProductVariant/40482530852925",
            "sku": "KIT(8oz)+13xJM450-1100",
            "color": "Black / Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Green",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-13pcs-golf-grip-kit?variant=40482530852925"
          },
          {
            "id": "40482530885693",
            "gid": "gid://shopify/ProductVariant/40482530885693",
            "sku": "KIT+13xJM430-1100",
            "color": "Red / White / Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 173.23,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-13pcs-golf-grip-kit?variant=40482530885693"
          },
          {
            "id": "40482530918461",
            "gid": "gid://shopify/ProductVariant/40482530918461",
            "sku": "KIT(8oz)+13xJM430-1100",
            "color": "Red / White / Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 178.27,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip-13pcs-golf-grip-kit?variant=40482530918461"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "single",
        "colors": [
          "Black / Silver"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip",
        "handle": "jumbomax-tour-series-small-1-4-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Silver",
              "Black / Green",
              "Red / White / Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14106640023613",
            "gid": "gid://shopify/ProductVariant/14106640023613",
            "sku": "JM440-1100",
            "color": "Black / Silver",
            "size": "Small (+1/4\")",
            "selected_options": {
              "Color": "Black / Silver"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip?variant=14106640023613"
          },
          {
            "id": "39464726102077",
            "gid": "gid://shopify/ProductVariant/39464726102077",
            "sku": "JM450-1100",
            "color": "Black / Green",
            "size": "Small (+1/4\")",
            "selected_options": {
              "Color": "Black / Green"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip?variant=39464726102077"
          },
          {
            "id": "41612096438333",
            "gid": "gid://shopify/ProductVariant/41612096438333",
            "sku": "JM430-1100",
            "color": "Red / White / Blue",
            "size": "Small (+1/4\")",
            "selected_options": {
              "Color": "Red / White / Blue"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-small-1-4-grip?variant=41612096438333"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Tour Series, jumbomax-2023, jumbomax-small, Large, Most Popular Oversize, new-add-12172025, oversize, oversize-jumbo-golf-grips, rubber, single-golf-grips, single-grip, under-1",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Silver",
      "Black / Green",
      "Red / White / Blue"
    ]
  },
  {
    "id": "jumbomax-tour-series-x-large-3-8",
    "brand": "JumboMax",
    "model": "Tour Series X-Large (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Lime",
      "Black / Silver",
      "Red / White / Blue",
      "USA"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 185.58,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tour-series-xl_94fb04ca-31a3-49fb-af93-41b179cec3d1.jpg?v=1766011348",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 10,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-bundle-13pcs",
        "handle": "jumbomax-tour-series-xl-3-8-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Red / White / Blue",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398922396018",
            "gid": "gid://shopify/ProductVariant/61398922396018",
            "sku": "SET-13xJM450-6600",
            "color": "Black / Lime",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-bundle-13pcs?variant=61398922396018"
          },
          {
            "id": "61398922428786",
            "gid": "gid://shopify/ProductVariant/61398922428786",
            "sku": "SET-13xJM430-6600",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-bundle-13pcs?variant=61398922428786"
          },
          {
            "id": "61398922461554",
            "gid": "gid://shopify/ProductVariant/61398922461554",
            "sku": "SET-13xJM440-6600",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-bundle-13pcs?variant=61398922461554"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Red / White / Blue",
          "USA"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa-bundle-13pcs",
        "handle": "jumbomax-tour-series-xl-3-8-grip-usa-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398921412978",
            "gid": "gid://shopify/ProductVariant/61398921412978",
            "sku": "SET-13xUSA-JM430-6600",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa-bundle-13pcs?variant=61398921412978"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Lime"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-grip-bundle-set",
        "handle": "jumbomax-tour-series-xl-3-8-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Red / White / Blue",
              "Black / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021967007805",
            "gid": "gid://shopify/ProductVariant/41021967007805",
            "sku": "SET-9xJM450-6600",
            "color": "Black / Lime",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Lime",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-grip-bundle-set?variant=41021967007805"
          },
          {
            "id": "41021967040573",
            "gid": "gid://shopify/ProductVariant/41021967040573",
            "sku": "SET-9xJM430-6600",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-grip-bundle-set?variant=41021967040573"
          },
          {
            "id": "41021967073341",
            "gid": "gid://shopify/ProductVariant/41021967073341",
            "sku": "SET-9xJM440-6600",
            "color": "Black / Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-grip-bundle-set?variant=41021967073341"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Red / White / Blue"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa-grip-bundle-set",
        "handle": "jumbomax-tour-series-xl-3-8-grip-usa-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965598781",
            "gid": "gid://shopify/ProductVariant/41021965598781",
            "sku": "SET-9xUSA-JM430-6600",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": false,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa-grip-bundle-set?variant=41021965598781"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Red / White / Blue",
          "USA"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa-13pcs-golf-grip-kit",
        "handle": "jumbomax-tour-series-xl-3-8-grip-usa-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919994699837",
            "gid": "gid://shopify/ProductVariant/39919994699837",
            "sku": "KIT+13xUSA-JM430-6600",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa-13pcs-golf-grip-kit?variant=39919994699837"
          },
          {
            "id": "39919994732605",
            "gid": "gid://shopify/ProductVariant/39919994732605",
            "sku": "KIT(8oz)+13xUSA-JM430-6600",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa-13pcs-golf-grip-kit?variant=39919994732605"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Red / White / Blue",
          "USA"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa",
        "handle": "jumbomax-tour-series-xl-3-8-grip-usa",
        "shopify_variants": [
          {
            "id": "43327431123",
            "gid": "gid://shopify/ProductVariant/43327431123",
            "sku": "USA-JM430-6600",
            "color": "Red / White / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip-usa?variant=43327431123"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Silver"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-black-silver",
        "handle": "grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-black-silver",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919997878333",
            "gid": "gid://shopify/ProductVariant/39919997878333",
            "sku": "KIT+13xJM440-6600",
            "color": "Black / Silver",
            "size": "X-Large (+3/8\")",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-black-silver?variant=39919997878333"
          },
          {
            "id": "39919997911101",
            "gid": "gid://shopify/ProductVariant/39919997911101",
            "sku": "KIT(8oz)+13xJM440-6600",
            "color": "Black / Silver",
            "size": "X-Large (+3/8\")",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-black-silver?variant=39919997911101"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Lime"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-black-lime",
        "handle": "grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-black-lime",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919997943869",
            "gid": "gid://shopify/ProductVariant/39919997943869",
            "sku": "KIT+13xJM450-6600",
            "color": "Black / Lime",
            "size": "X-Large (+3/8\")",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-black-lime?variant=39919997943869"
          },
          {
            "id": "39919997976637",
            "gid": "gid://shopify/ProductVariant/39919997976637",
            "sku": "KIT(8oz)+13xJM450-6600",
            "color": "Black / Lime",
            "size": "X-Large (+3/8\")",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-black-lime?variant=39919997976637"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Red / White / Blue"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-usa",
        "handle": "grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-usa",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919998009405",
            "gid": "gid://shopify/ProductVariant/39919998009405",
            "sku": "KIT+13xJM430-6600",
            "color": "Red / White / Blue",
            "size": "X-Large (+3/8\")",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-usa?variant=39919998009405"
          },
          {
            "id": "39919998042173",
            "gid": "gid://shopify/ProductVariant/39919998042173",
            "sku": "KIT(8oz)+13xJM430-6600",
            "color": "Red / White / Blue",
            "size": "X-Large (+3/8\")",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-jumbomax-tour-series-xl-3-8-grips-usa?variant=39919998042173"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "single",
        "colors": [
          "Black / Lime"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip",
        "handle": "jumbomax-tour-series-xl-3-8-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime",
              "Red / White / Blue",
              "Black / Silver"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "27207611207",
            "gid": "gid://shopify/ProductVariant/27207611207",
            "sku": "JM450-6600",
            "color": "Black / Lime",
            "size": "X-Large (+3/8\")",
            "selected_options": {
              "Color": "Black / Lime"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip?variant=27207611207"
          },
          {
            "id": "27208964295",
            "gid": "gid://shopify/ProductVariant/27208964295",
            "sku": "JM430-6600",
            "color": "Red / White / Blue",
            "size": "X-Large (+3/8\")",
            "selected_options": {
              "Color": "Red / White / Blue"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip?variant=27208964295"
          },
          {
            "id": "27208870727",
            "gid": "gid://shopify/ProductVariant/27208870727",
            "sku": "JM440-6600",
            "color": "Black / Silver",
            "size": "X-Large (+3/8\")",
            "selected_options": {
              "Color": "Black / Silver"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-xl-3-8-grip?variant=27208870727"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Tour Series, jumbomax-x-large, Most Popular Oversize, new-add-12172025, oversize, oversize-jumbo-golf-grips, overstock-oct-2023, rubber, single-golf-grips, single-grip, under-1",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Lime",
      "Red / White / Blue",
      "Black / Silver"
    ]
  },
  {
    "id": "jumbomax-tour-series-x-small",
    "brand": "JumboMax",
    "model": "Tour Series X-Small",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "(USA) Red / White / Blue"
    ],
    "weight_g_by_size": {
      "X-Small (+3/16\")": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 185.58,
    "price_max": 185.58,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.28,
    "bundle_price_min": null,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grips-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-tour-series-usa_67003891-f1cc-44ee-95e4-091d1dd586fa.jpg?v=1736027130",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "(USA) Red / White / Blue"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grips-13pcs-golf-grip-kit",
        "handle": "jumbomax-tour-series-junior-grips-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39919997485117",
            "gid": "gid://shopify/ProductVariant/39919997485117",
            "sku": "KIT+13xJM430-1000",
            "color": "(USA) Red / White / Blue",
            "size": "X-Small (+3/16\")",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grips-13pcs-golf-grip-kit?variant=39919997485117"
          },
          {
            "id": "39919997517885",
            "gid": "gid://shopify/ProductVariant/39919997517885",
            "sku": "KIT(8oz)+13xJM430-1000",
            "color": "(USA) Red / White / Blue",
            "size": "X-Small (+3/16\")",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grips-13pcs-golf-grip-kit?variant=39919997517885"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "150-200, 2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "jumbomax-tour-series-x-small-3-16",
    "brand": "JumboMax",
    "model": "Tour Series X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://pluggedingolf.com/jumbomax-tour-series-ultralite-grip-review/",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Lime",
      "Black / Silver",
      "Red / White / Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 13.99,
    "price_max": 190.62,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 12.59,
    "bundle_price_min": 113.32,
    "kit_price_min": 185.58,
    "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-tour-series-med_9812afe6-54ef-4f8a-852f-7db4d777197b.jpg?v=1766011300",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 5,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc bundle",
        "colors": [
          "Red / White / Blue"
        ],
        "price": 181.87,
        "per_grip_g": 9.8,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-bundle-13pcs",
        "handle": "jumbomax-tour-series-junior-grip-usa-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue",
              "Black / Green",
              "Pink / Grey",
              "Black / Silver",
              "Black/Green/Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398920954226",
            "gid": "gid://shopify/ProductVariant/61398920954226",
            "sku": "SET-13xJM430-1000",
            "color": "Red / White / Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": false,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-bundle-13pcs?variant=61398920954226"
          },
          {
            "id": "61398920986994",
            "gid": "gid://shopify/ProductVariant/61398920986994",
            "sku": "SET-13xJM450-1000",
            "color": "Black / Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Green",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-bundle-13pcs?variant=61398920986994"
          },
          {
            "id": "61398921019762",
            "gid": "gid://shopify/ProductVariant/61398921019762",
            "sku": "SET-13xJM420-1000",
            "color": "Pink / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink / Grey",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": false,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-bundle-13pcs?variant=61398921019762"
          },
          {
            "id": "61398921052530",
            "gid": "gid://shopify/ProductVariant/61398921052530",
            "sku": "SET-13xJM440-1000",
            "color": "Black / Silver",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-bundle-13pcs?variant=61398921052530"
          },
          {
            "id": "61398921085298",
            "gid": "gid://shopify/ProductVariant/61398921085298",
            "sku": "SET-13xJM410-1000",
            "color": "Black/Green/Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black/Green/Grey",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": false,
            "price": 181.87,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-bundle-13pcs?variant=61398921085298"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Lime"
        ],
        "price": 185.58,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-x-small-3-16-grips-13pcs-golf-grip-kit",
        "handle": "jumbomax-tour-series-x-small-3-16-grips-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Lime"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51879486128498",
            "gid": "gid://shopify/ProductVariant/51879486128498",
            "sku": "KIT+13xJM450-1000",
            "color": "Black / Lime",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Lime",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 185.58,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-x-small-3-16-grips-13pcs-golf-grip-kit?variant=51879486128498"
          },
          {
            "id": "51879486161266",
            "gid": "gid://shopify/ProductVariant/51879486161266",
            "sku": "KIT(8oz)+13xJM450-1000",
            "color": "Black / Lime",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Lime",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-x-small-3-16-grips-13pcs-golf-grip-kit?variant=51879486161266"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Silver"
        ],
        "price": 190.62,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-x-small-5-16-grips-13pcs-golf-grip-kit",
        "handle": "jumbomax-tour-series-x-small-5-16-grips-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Silver"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51879470793074",
            "gid": "gid://shopify/ProductVariant/51879470793074",
            "sku": "KIT+13xJM440-1000",
            "color": "Black / Silver",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Silver",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-x-small-5-16-grips-13pcs-golf-grip-kit?variant=51879470793074"
          },
          {
            "id": "51879467483506",
            "gid": "gid://shopify/ProductVariant/51879467483506",
            "sku": "KIT(8oz)+13xJM440-1000",
            "color": "Black / Silver",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Silver",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 190.62,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-x-small-5-16-grips-13pcs-golf-grip-kit?variant=51879467483506"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Red / White / Blue"
        ],
        "price": 113.32,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-grip-bundle-set",
        "handle": "jumbomax-tour-series-junior-grip-usa-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue",
              "Black / Green",
              "Pink / Grey",
              "Black / Silver",
              "Black/Green/Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021965238333",
            "gid": "gid://shopify/ProductVariant/41021965238333",
            "sku": "SET-9xJM430-1000",
            "color": "Red / White / Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red / White / Blue",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": false,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-grip-bundle-set?variant=41021965238333"
          },
          {
            "id": "41021965271101",
            "gid": "gid://shopify/ProductVariant/41021965271101",
            "sku": "SET-9xJM450-1000",
            "color": "Black / Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Green",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-grip-bundle-set?variant=41021965271101"
          },
          {
            "id": "41021965303869",
            "gid": "gid://shopify/ProductVariant/41021965303869",
            "sku": "SET-9xJM420-1000",
            "color": "Pink / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Pink / Grey",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": false,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-grip-bundle-set?variant=41021965303869"
          },
          {
            "id": "41021965336637",
            "gid": "gid://shopify/ProductVariant/41021965336637",
            "sku": "SET-9xJM440-1000",
            "color": "Black / Silver",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Silver",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-grip-bundle-set?variant=41021965336637"
          },
          {
            "id": "41021965369405",
            "gid": "gid://shopify/ProductVariant/41021965369405",
            "sku": "SET-9xJM410-1000",
            "color": "Black/Green/Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black/Green/Grey",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": false,
            "price": 113.32,
            "weight_g": 1143.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa-grip-bundle-set?variant=41021965369405"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "single",
        "colors": [
          "Red / White / Blue"
        ],
        "price": 13.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa",
        "handle": "jumbomax-tour-series-junior-grip-usa",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Blue",
              "Black / Green",
              "Pink / Grey",
              "Black / Silver",
              "Black/Green/Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "6822305103933",
            "gid": "gid://shopify/ProductVariant/6822305103933",
            "sku": "JM430-1000",
            "color": "Red / White / Blue",
            "size": "X-Small (+3/16\")",
            "selected_options": {
              "Color": "Red / White / Blue"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa?variant=6822305103933"
          },
          {
            "id": "39421479256125",
            "gid": "gid://shopify/ProductVariant/39421479256125",
            "sku": "JM450-1000",
            "color": "Black / Green",
            "size": "X-Small (+3/16\")",
            "selected_options": {
              "Color": "Black / Green"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa?variant=39421479256125"
          },
          {
            "id": "39421489250365",
            "gid": "gid://shopify/ProductVariant/39421489250365",
            "sku": "JM420-1000",
            "color": "Pink / Grey",
            "size": "X-Small (+3/16\")",
            "selected_options": {
              "Color": "Pink / Grey"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa?variant=39421489250365"
          },
          {
            "id": "39421488234557",
            "gid": "gid://shopify/ProductVariant/39421488234557",
            "sku": "JM440-1000",
            "color": "Black / Silver",
            "size": "X-Small (+3/16\")",
            "selected_options": {
              "Color": "Black / Silver"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa?variant=39421488234557"
          },
          {
            "id": "39421486268477",
            "gid": "gid://shopify/ProductVariant/39421486268477",
            "sku": "JM410-1000",
            "color": "Black/Green/Grey",
            "size": "X-Small (+3/16\")",
            "selected_options": {
              "Color": "Black/Green/Grey"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-tour-series-junior-grip-usa?variant=39421486268477"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, golf-grips, grip bundle, iron/wood, july4-2022, jumbo, jumbo/oversize, jumbomax, JumboMax Jr, JumboMax Junior, JumboMax Tour Series, jumbomax-x-small, junior-golf-grips, memsale2022, Most Popular Midsize, new-add-12172025, oversize, oversize-jumbo-golf-g",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize, soft tacky; reduces grip pressure (arthritis-friendly)",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Green",
      "Black / Silver",
      "Black / Lime",
      "Red / White / Blue"
    ]
  },
  {
    "id": "jumbomax-wrap-large-11-32",
    "brand": "JumboMax",
    "model": "Wrap Large (+11/32\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Large (+11/32\")"
    ],
    "manufacturer_size_labels": [
      "Large (+11/32\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 97.12,
    "price_max": 97.12,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 10.79,
    "bundle_price_min": 97.12,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-lg_cbc37bcd-6c88-4c26-b4ae-d4fbc5262bcc.jpg?v=1735455626",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Large (+11/32\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 97.12,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip-grip-bundle-set",
        "handle": "jumbomax-wrap-large-11-32-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967794237",
            "gid": "gid://shopify/ProductVariant/41021967794237",
            "sku": "SET-9xJM200-4400",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Large (+11/32\")"
            },
            "available": true,
            "price": 97.12,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-large-11-32-grip-grip-bundle-set?variant=41021967794237"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large (+11/32\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, jumbomax-large, Large, new-bundle-set, oversize, oversize-jumbo-golf-grips, prime-2025, rubber, single-golf-grips, single-grip, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-wrap-medium-5-16",
    "brand": "JumboMax",
    "model": "Wrap Medium (+5/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Medium (+5/16\")"
    ],
    "manufacturer_size_labels": [
      "Medium (+5/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 97.12,
    "price_max": 97.12,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 10.79,
    "bundle_price_min": 97.12,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-med_dee56dcd-c104-487b-a2f5-aff09f107cf4.jpg?v=1735455626",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Medium (+5/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 97.12,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip-grip-bundle-set",
        "handle": "jumbomax-wrap-medium-5-16-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967827005",
            "gid": "gid://shopify/ProductVariant/41021967827005",
            "sku": "SET-9xJM200-2200",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium (+5/16\")"
            },
            "available": true,
            "price": 97.12,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-medium-5-16-grip-grip-bundle-set?variant=41021967827005"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Medium (+5/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, jumbomax-medium, Medium, new-bundle-set, oversize, oversize-jumbo-golf-grips, prime-2025, rubber, single-golf-grips, single-grip, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-wrap-small-1-4",
    "brand": "JumboMax",
    "model": "Wrap Small (+1/4\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Small (+1/4\")"
    ],
    "manufacturer_size_labels": [
      "Small (+1/4\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 97.12,
    "price_max": 97.12,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 10.79,
    "bundle_price_min": 97.12,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-sm_3db70c90-5b51-4240-92ad-036f0671ea7e.jpg?v=1735455625",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Small (+1/4\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 97.12,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip-grip-bundle-set",
        "handle": "jumbomax-wrap-small-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967859773",
            "gid": "gid://shopify/ProductVariant/41021967859773",
            "sku": "SET-9xJM200-1100",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Small (+1/4\")"
            },
            "available": true,
            "price": 97.12,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-small-grip-grip-bundle-set?variant=41021967859773"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Small (+1/4\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, jumbomax-small, new-bundle-set, oversize, oversize-jumbo-golf-grips, prime-2025, rubber, single-golf-grips, single-grip, Small, under-150, under-300, video=tnsdjrbpGjE",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-wrap-x-large-3-8",
    "brand": "JumboMax",
    "model": "Wrap X-Large (+3/8\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Large (+3/8\")"
    ],
    "manufacturer_size_labels": [
      "X-Large (+3/8\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 97.12,
    "price_max": 97.12,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 10.79,
    "bundle_price_min": 97.12,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-xl_fcddf362-632a-479c-90d2-abc11e232022.jpg?v=1735455627",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "X-Large (+3/8\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 97.12,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip-grip-bundle-set",
        "handle": "jumbomax-wrap-xl-3-8-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967761469",
            "gid": "gid://shopify/ProductVariant/41021967761469",
            "sku": "SET-9xJM200-6600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Large (+3/8\")"
            },
            "available": true,
            "price": 97.12,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-xl-3-8-grip-grip-bundle-set?variant=41021967761469"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Large (+3/8\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, new-bundle-set, oversize, oversize-jumbo-golf-grips, prime-2025, rubber, single-golf-grips, single-grip, under-150, under-300, video=tnsdjrbpGjE, XL",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "jumbomax-wrap-x-small-3-16",
    "brand": "JumboMax",
    "model": "Wrap X-Small (+3/16\")",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "X-Small (+3/16\")"
    ],
    "manufacturer_size_labels": [
      "X-Small (+3/16\")"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 97.12,
    "price_max": 97.12,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 10.79,
    "bundle_price_min": 97.12,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-sm_85375583-1eff-42f0-a669-a855ff38cc64.jpg?v=1735455708",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "X-Small (+3/16\")"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 97.12,
        "per_grip_g": 127,
        "total_g": 1143.0527724,
        "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-grip-grip-bundle-set",
        "handle": "jumbomax-wrap-x-small-3-16-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954195517",
            "gid": "gid://shopify/ProductVariant/41021954195517",
            "sku": "SET-9xJM200-1000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "X-Small (+3/16\")"
            },
            "available": true,
            "price": 97.12,
            "weight_g": 1143.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-wrap-x-small-3-16-grip-grip-bundle-set?variant=41021954195517"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "X-Small (+3/16\")"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, jumbmax junior, jumbo, jumbo/oversize, jumbomax, JumboMax Wrap, jumbomax-2023, jumbomax-small, mem25, new-bundle-set, oversize, oversize-jumbo-golf-grips, prime-2025, rubber, single-golf-grips, single-grip, Small, under-150, under-300, video=tnsdjrbp",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize wrap",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "karma-karma",
    "brand": "Karma",
    "model": "Karma",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 4.25,
    "price_max": 55.25,
    "single_price_min": 4.25,
    "single_price_max": 4.25,
    "normalized_price_per_grip": 3.83,
    "bundle_price_min": 34.43,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/karma-jumbo-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/karma_blue_2_ffe599cc-1f9f-48b1-9a26-288df7670c44.jpg?v=1766011176",
    "fit_tags": [],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue"
        ],
        "price": 55.25,
        "per_grip_g": 24.5,
        "total_g": 318.013610607,
        "url": "https://www.grips4less.com/products/karma-jumbo-grip-bundle-13pcs",
        "handle": "karma-jumbo-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398918660466",
            "gid": "gid://shopify/ProductVariant/61398918660466",
            "sku": "SET-13xHG-RF-184",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 55.25,
            "weight_g": 317.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/karma-jumbo-grip-bundle-13pcs?variant=61398918660466"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 34.43,
        "per_grip_g": 318,
        "total_g": 2862.122495463,
        "url": "https://www.grips4less.com/products/karma-jumbo-grip-grip-bundle-set",
        "handle": "karma-jumbo-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021961863229",
            "gid": "gid://shopify/ProductVariant/41021961863229",
            "sku": "SET-9xHG-RF-184",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 34.43,
            "weight_g": 2862.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/karma-jumbo-grip-grip-bundle-set?variant=41021961863229"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 4.25,
        "per_grip_g": 318,
        "total_g": 318.013610607,
        "url": "https://www.grips4less.com/products/karma-jumbo-grip",
        "handle": "karma-jumbo-grip",
        "shopify_variants": [
          {
            "id": "30573512753213",
            "gid": "gid://shopify/ProductVariant/30573512753213",
            "sku": "HG-RF-184",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 4.25,
            "weight_g": 317.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/karma-jumbo-grip?variant=30573512753213"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, added-11052019, All Products, grip bundle, jumbo, karma, new-add-12172025, oversize, oversize-jumbo-golf-grips, oversize/jumbo, single-golf-grips, single-grip, Style_Swing Grip, under-150",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "karma-training",
    "brand": "Karma",
    "model": "Training",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "training_only",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 5.99,
    "price_max": 5.99,
    "single_price_min": 5.99,
    "single_price_max": 5.99,
    "normalized_price_per_grip": 5.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/karma-training-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/karma-training-grip.jpg?v=1754239795",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/karma-training-grip",
        "handle": "karma-training-grip",
        "shopify_options": [
          {
            "name": "Hand",
            "values": [
              "For Right Handed Players",
              "For Left Handed Players"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52538070073714",
            "gid": "gid://shopify/ProductVariant/52538070073714",
            "sku": "HK-RF27A",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Right Handed Players",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/karma-training-grip?variant=52538070073714"
          },
          {
            "id": "61871721578866",
            "gid": "gid://shopify/ProductVariant/61871721578866",
            "sku": "RF25-001",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Left Handed Players",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/karma-training-grip?variant=61871721578866"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, lamkin, single-golf-grips, single-grip, training, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "karma-velour",
    "brand": "Karma",
    "model": "Velour",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 3.95,
    "price_max": 51.35,
    "single_price_min": 3.95,
    "single_price_max": 3.95,
    "normalized_price_per_grip": 3.56,
    "bundle_price_min": 32,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/karma-velour-standard-grip-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/karma-velour-standard-black-grip_aaec0312-aef3-4cdb-9373-af385167f20a.jpg?v=1766011109",
    "fit_tags": [],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 51.35,
        "per_grip_g": 24.5,
        "total_g": 318.013610607,
        "url": "https://www.grips4less.com/products/karma-velour-standard-grip-black-bundle-13pcs",
        "handle": "karma-velour-standard-grip-black-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398914924914",
            "gid": "gid://shopify/ProductVariant/61398914924914",
            "sku": "SET-13xHG-RF07-001",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 51.35,
            "weight_g": 317.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/karma-velour-standard-grip-black-bundle-13pcs?variant=61398914924914"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 32,
        "per_grip_g": 318,
        "total_g": 2862.122495463,
        "url": "https://www.grips4less.com/products/karma-velour-standard-grip-black-grip-bundle-set",
        "handle": "karma-velour-standard-grip-black-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021956653117",
            "gid": "gid://shopify/ProductVariant/41021956653117",
            "sku": "SET-9xHG-RF07-001",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 32,
            "weight_g": 2862.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/karma-velour-standard-grip-black-grip-bundle-set?variant=41021956653117"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 3.95,
        "per_grip_g": 318,
        "total_g": 318.013610607,
        "url": "https://www.grips4less.com/products/karma-velour-standard-grip-black",
        "handle": "karma-velour-standard-grip-black",
        "shopify_variants": [
          {
            "id": "39378760466493",
            "gid": "gid://shopify/ProductVariant/39378760466493",
            "sku": "HG-RF07-001",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 3.95,
            "weight_g": 317.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/karma-velour-standard-grip-black?variant=39378760466493"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, added-11052019, All Products, grip bundle, karma, new-add-12172025, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "lamkin-majors-lamkin-z5",
    "brand": "Lamkin",
    "model": "\"Majors\" Lamkin Z5",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "multi-texture (Tri-Layer)",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Green/Yellow"
    ],
    "weight_g_by_size": {
      "Midsize": 90.7,
      "Standard": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 7.99,
    "price_max": 8.49,
    "single_price_min": 7.99,
    "single_price_max": 8.49,
    "normalized_price_per_grip": 7.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-z5-midsize-grip-green-yellow",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Z5Masters-front_df57e0b0-dd01-4a5e-8b64-570a517083a8.jpg?v=1627215085",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Green/Yellow"
        ],
        "price": 8.49,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-z5-midsize-grip-green-yellow",
        "handle": "limited-edition-masters-lamkin-z5-midsize-grip-green-yellow",
        "shopify_variants": [
          {
            "id": "37838135303",
            "gid": "gid://shopify/ProductVariant/37838135303",
            "sku": "101622",
            "color": "Green/Yellow",
            "size": "Standard",
            "selected_options": {
              "Shape/ID": "58 Round"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-z5-midsize-grip-green-yellow?variant=37838135303"
          }
        ],
        "shopify_options": [
          {
            "name": "Shape/ID",
            "values": [
              "58 Round"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green/Yellow"
        ],
        "price": 7.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-z5-standard-grip-green-yellow",
        "handle": "limited-edition-masters-lamkin-z5-standard-grip-green-yellow",
        "shopify_variants": [
          {
            "id": "37834332807",
            "gid": "gid://shopify/ProductVariant/37834332807",
            "sku": "101619",
            "color": "Green/Yellow",
            "size": "Standard",
            "selected_options": {
              "Shape/ID": "58 Round"
            },
            "available": false,
            "price": 7.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-z5-standard-grip-green-yellow?variant=37834332807"
          }
        ],
        "shopify_options": [
          {
            "name": "Shape/ID",
            "values": [
              "58 Round"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, hybrid, hybrid-golf-grips, infinite-opt-addkit, iron/wood, lamkin, Lamkin Z5, limited edition, medium firm, midsize, midsize-golf-grips, Most Popular, Most Popular Golf Club Grips, New for 2016, rubber, single-golf-grips, single-grip, under-150, under-300, video=I",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-arthritic",
    "brand": "Lamkin",
    "model": "Arthritic",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 80.92,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 80.92,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-arthritic-std-58r",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-arthritic.jpg?v=1735455581",
    "fit_tags": [],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-arthritic-std-58r-grip-bundle-set",
        "handle": "lamkin-arthritic-std-58r-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976805437",
            "gid": "gid://shopify/ProductVariant/41021976805437",
            "sku": "SET-9x100661",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-arthritic-std-58r-grip-bundle-set?variant=41021976805437"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-arthritic-std-58r",
        "handle": "lamkin-arthritic-std-58r",
        "shopify_variants": [
          {
            "id": "40683358847037",
            "gid": "gid://shopify/ProductVariant/40683358847037",
            "sku": "100661",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-arthritic-std-58r?variant=40683358847037"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, arthritic, arthritic-golf-grips, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Arthritic, medium firm, midsize, midsize-golf-grips, new-bundle-set, single-golf-grips, single-grip, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-comfort-plus",
    "brand": "Lamkin",
    "model": "Comfort Plus",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (soft)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black / Red",
      "Gray"
    ],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Undersize": 90.7,
      "Standard": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 6.69,
    "price_max": 110.94,
    "single_price_min": 6.69,
    "single_price_max": 7.19,
    "normalized_price_per_grip": 6.69,
    "bundle_price_min": null,
    "kit_price_min": 110.94,
    "url": "https://www.grips4less.com/products/lamkin-comfort-plus-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-comfortplus-blk-kit.jpg?v=1736027117",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 110.94,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-comfort-plus-13pcs-golf-grip-kit",
        "handle": "lamkin-comfort-plus-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Midsize",
              "Standard",
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13277681385533",
            "gid": "gid://shopify/ProductVariant/13277681385533",
            "sku": "KIT+13xLG-101805",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Size": "Midsize"
            },
            "available": false,
            "price": 110.94,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-comfort-plus-13pcs-golf-grip-kit?variant=13277681385533"
          },
          {
            "id": "39918722416701",
            "gid": "gid://shopify/ProductVariant/39918722416701",
            "sku": "KIT(8oz)+13xLG-101805",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Size": "Midsize"
            },
            "available": false,
            "price": 116.24,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-comfort-plus-13pcs-golf-grip-kit?variant=39918722416701"
          },
          {
            "id": "13277707141181",
            "gid": "gid://shopify/ProductVariant/13277707141181",
            "sku": "KIT+13xLG-101801",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard"
            },
            "available": false,
            "price": 104.44,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-comfort-plus-13pcs-golf-grip-kit?variant=13277707141181"
          },
          {
            "id": "39918722449469",
            "gid": "gid://shopify/ProductVariant/39918722449469",
            "sku": "KIT(8oz)+13xLG-101801",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard"
            },
            "available": false,
            "price": 109.74,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-comfort-plus-13pcs-golf-grip-kit?variant=39918722449469"
          },
          {
            "id": "13277709140029",
            "gid": "gid://shopify/ProductVariant/13277709140029",
            "sku": "KIT+13xLG-101803",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Size": "Undersize"
            },
            "available": false,
            "price": 104.44,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-comfort-plus-13pcs-golf-grip-kit?variant=13277709140029"
          },
          {
            "id": "39918722482237",
            "gid": "gid://shopify/ProductVariant/39918722482237",
            "sku": "KIT(8oz)+13xLG-101803",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Size": "Undersize"
            },
            "available": false,
            "price": 109.74,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-comfort-plus-13pcs-golf-grip-kit?variant=39918722482237"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Gray"
        ],
        "price": 6.69,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-comfort-plus-undersize-grip",
        "handle": "lamkin-comfort-plus-undersize-grip",
        "shopify_variants": [
          {
            "id": "7145133342781",
            "gid": "gid://shopify/ProductVariant/7145133342781",
            "sku": "LG-101803",
            "color": "Gray",
            "size": "Undersize",
            "selected_options": {
              "Color": "Gray"
            },
            "available": false,
            "price": 6.69,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-comfort-plus-undersize-grip?variant=7145133342781"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black / Red"
        ],
        "price": 7.19,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-comfort-plus-midsize-grip",
        "handle": "lamkin-comfort-plus-midsize-grip",
        "shopify_variants": [
          {
            "id": "7145133310013",
            "gid": "gid://shopify/ProductVariant/7145133310013",
            "sku": "LG-101805",
            "color": "Black / Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 7.19,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-comfort-plus-midsize-grip?variant=7145133310013"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black / Red"
        ],
        "price": 6.69,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-comfort-plus-standard-grip",
        "handle": "lamkin-comfort-plus-standard-grip",
        "shopify_variants": [
          {
            "id": "7145133211709",
            "gid": "gid://shopify/ProductVariant/7145133211709",
            "sku": "LG-101801",
            "color": "Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 6.69,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-comfort-plus-standard-grip?variant=7145133211709"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, blackfriday2020, bundle, bundles-asbl-driver-only, Comfort plus, Comfort Plus (Coming Feb 2018), free-rog-momentum-glove, gifts-for-her, grip kit, grip kits, grip set, grip ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline",
    "brand": "Lamkin",
    "model": "Crossline",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured (crossline tread)",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Ribbed"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5,
      "Jumbo/Oversize": 78,
      "Undersize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 6.49,
    "price_max": 92.96,
    "single_price_min": 6.49,
    "single_price_max": 6.49,
    "normalized_price_per_grip": 5.84,
    "bundle_price_min": 52.57,
    "kit_price_min": 92.96,
    "url": "https://www.grips4less.com/products/lamkin-crossline-standard-grip-ribbed",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-crossline_2c1b8dba-d50f-46f1-9f19-5a1b1ff06816.jpg?v=1735455577",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 12,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-std-58r-grip-bundle-set",
        "handle": "lamkin-crossline-std-58r-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Shape",
            "values": [
              "60 Round (most popular)",
              "58 Round",
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021977198653",
            "gid": "gid://shopify/ProductVariant/41021977198653",
            "sku": "SET-9x101302",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "60 Round (most popular)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-std-58r-grip-bundle-set?variant=41021977198653"
          },
          {
            "id": "41021977231421",
            "gid": "gid://shopify/ProductVariant/41021977231421",
            "sku": "SET-9x101308",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Round",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-std-58r-grip-bundle-set?variant=41021977231421"
          },
          {
            "id": "41021977264189",
            "gid": "gid://shopify/ProductVariant/41021977264189",
            "sku": "SET-9x101309",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Ribbed",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-std-58r-grip-bundle-set?variant=41021977264189"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-mid-58r-grip-bundle-set",
        "handle": "lamkin-crossline-mid-58r-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021977002045",
            "gid": "gid://shopify/ProductVariant/41021977002045",
            "sku": "SET-9x101311",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-mid-58r-grip-bundle-set?variant=41021977002045"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 52.57,
        "per_grip_g": 78,
        "total_g": 702,
        "url": "https://www.grips4less.com/products/lamkin-crossline-ovr-58r-grip-bundle-set",
        "handle": "lamkin-crossline-ovr-58r-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976936509",
            "gid": "gid://shopify/ProductVariant/41021976936509",
            "sku": "SET-9x101312",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 702,
            "weight_unit": "grams",
            "url": "https://www.grips4less.com/products/lamkin-crossline-ovr-58r-grip-bundle-set?variant=41021976936509"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-undersize-pink-or-white-grip-bundle-set",
        "handle": "lamkin-crossline-undersize-pink-or-white-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021975167037",
            "gid": "gid://shopify/ProductVariant/41021975167037",
            "sku": "SET-9x101313",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-undersize-pink-or-white-grip-bundle-set?variant=41021975167037"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 92.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-oversize-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-oversize-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683357241405",
            "gid": "gid://shopify/ProductVariant/40683357241405",
            "sku": "KIT+13x101312",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-oversize-13pcs-golf-grip-kit?variant=40683357241405"
          },
          {
            "id": "40683357274173",
            "gid": "gid://shopify/ProductVariant/40683357274173",
            "sku": "KIT(8oz)+13x101312",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 97.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-oversize-13pcs-golf-grip-kit?variant=40683357274173"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Ribbed"
        ],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-standard-grip-ribbed",
        "handle": "lamkin-crossline-standard-grip-ribbed",
        "shopify_variants": [
          {
            "id": "40683357929533",
            "gid": "gid://shopify/ProductVariant/40683357929533",
            "sku": "WEB ONLY: RIBBED-101309",
            "color": "Ribbed",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-standard-grip-ribbed?variant=40683357929533"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 92.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-standard-grips",
        "handle": "grip-kit-13x-lamkin-crossline-standard-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683358126141",
            "gid": "gid://shopify/ProductVariant/40683358126141",
            "sku": "KIT+13x101302",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-standard-grips?variant=40683358126141"
          },
          {
            "id": "40683358158909",
            "gid": "gid://shopify/ProductVariant/40683358158909",
            "sku": "KIT(8oz)+13x101302",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 97.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-standard-grips?variant=40683358158909"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 92.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-midsize-grips",
        "handle": "grip-kit-13x-lamkin-crossline-midsize-grips",
        "shopify_options": [],
        "shopify_variants": [
          {
            "id": "40683358257213",
            "gid": "gid://shopify/ProductVariant/40683358257213",
            "sku": "KIT+13x101311",
            "color": "",
            "size": "Midsize",
            "selected_options": {},
            "available": false,
            "price": 92.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-midsize-grips?variant=40683358257213"
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-undersize-pink-or-white",
        "handle": "lamkin-crossline-undersize-pink-or-white",
        "shopify_variants": [
          {
            "id": "40683358617661",
            "gid": "gid://shopify/ProductVariant/40683358617661",
            "sku": "101313",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-undersize-pink-or-white?variant=40683358617661"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 78,
        "total_g": 78,
        "url": "https://www.grips4less.com/products/lamkin-crossline-ovr-58r",
        "handle": "lamkin-crossline-ovr-58r",
        "shopify_variants": [
          {
            "id": "40683358879805",
            "gid": "gid://shopify/ProductVariant/40683358879805",
            "sku": "101312",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 78,
            "weight_unit": "grams",
            "url": "https://www.grips4less.com/products/lamkin-crossline-ovr-58r?variant=40683358879805"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-mid-58r",
        "handle": "lamkin-crossline-mid-58r",
        "shopify_variants": [
          {
            "id": "40683358945341",
            "gid": "gid://shopify/ProductVariant/40683358945341",
            "sku": "101311",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-mid-58r?variant=40683358945341"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-std-58r",
        "handle": "lamkin-crossline-std-58r",
        "shopify_options": [
          {
            "name": "Shape",
            "values": [
              "60 Round (most popular)",
              "58 Round",
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683359043645",
            "gid": "gid://shopify/ProductVariant/40683359043645",
            "sku": "101302",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "60 Round (most popular)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-std-58r?variant=40683359043645"
          },
          {
            "id": "40683359076413",
            "gid": "gid://shopify/ProductVariant/40683359076413",
            "sku": "101308",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Round",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-std-58r?variant=40683359076413"
          },
          {
            "id": "40683359109181",
            "gid": "gid://shopify/ProductVariant/40683359109181",
            "sku": "101309",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Ribbed",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-std-58r?variant=40683359109181"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, crossline, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Crossline, mem25, new-bundle-set, overstock-oct-2023, prime-2025, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=7cMfZ99VQSI",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline-1150-wedge",
    "brand": "Lamkin",
    "model": "Crossline 1150 (Wedge)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured (crossline tread)",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 80.92,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 80.92,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-crossline-1150-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-crossline-1150.jpg?v=1735455646",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-crossline-1150-grip-grip-bundle-set",
        "handle": "lamkin-crossline-1150-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965205565",
            "gid": "gid://shopify/ProductVariant/41021965205565",
            "sku": "SET-9x101368",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-1150-grip-grip-bundle-set?variant=41021965205565"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-crossline-1150-grip",
        "handle": "lamkin-crossline-1150-grip",
        "shopify_variants": [
          {
            "id": "40683357569085",
            "gid": "gid://shopify/ProductVariant/40683357569085",
            "sku": "101368",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-1150-grip?variant=40683357569085"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "360, 360-golf-grips, All Products, crossline, Crossline 1150, Crossline wedge grip, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Crossline 1150, midsize, midsize-golf-grips, New for 2016, New for 2017, New for 2018, new-bundle-set, rubber, single-golf-grips, single-grip, standard, standa",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline-360",
    "brand": "Lamkin",
    "model": "Crossline 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured (crossline tread)",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "Grey"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 7.49,
    "price_max": 105.31,
    "single_price_min": 7.49,
    "single_price_max": 7.49,
    "normalized_price_per_grip": 6.74,
    "bundle_price_min": 60.67,
    "kit_price_min": 105.31,
    "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-crossline-360_70187cf7-5920-4728-8f00-8c832a523182.jpg?v=1735455649",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 12,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 60.67,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-grey-grip-bundle-set",
        "handle": "lamkin-crossline-360-standard-grip-grey-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021964648509",
            "gid": "gid://shopify/ProductVariant/41021964648509",
            "sku": "SET-9xLG-101377",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 60.67,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-grey-grip-bundle-set?variant=41021964648509"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 60.67,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-grey-grip-bundle-set",
        "handle": "lamkin-crossline-360-midsize-grip-grey-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952917565",
            "gid": "gid://shopify/ProductVariant/41021952917565",
            "sku": "SET-9xLG-101397",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 60.67,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-grey-grip-bundle-set?variant=41021952917565"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 60.67,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-black-grip-bundle-set",
        "handle": "lamkin-crossline-360-midsize-grip-black-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952884797",
            "gid": "gid://shopify/ProductVariant/41021952884797",
            "sku": "SET-9xLG-101396",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 60.67,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-black-grip-bundle-set?variant=41021952884797"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 60.67,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-black-grip-bundle-set",
        "handle": "lamkin-crossline-360-standard-grip-black-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952852029",
            "gid": "gid://shopify/ProductVariant/41021952852029",
            "sku": "SET-9xLG-101395",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 60.67,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-black-grip-bundle-set?variant=41021952852029"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 105.31,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-black-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-360-standard-grip-black-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683355013181",
            "gid": "gid://shopify/ProductVariant/40683355013181",
            "sku": "KIT+13xLG-101395",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 105.31,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-black-13pcs-golf-grip-kit?variant=40683355013181"
          },
          {
            "id": "40683355045949",
            "gid": "gid://shopify/ProductVariant/40683355045949",
            "sku": "KIT(8oz)+13xLG-101395",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 110.34,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-black-13pcs-golf-grip-kit?variant=40683355045949"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 7.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-black",
        "handle": "lamkin-crossline-360-standard-grip-black",
        "shopify_variants": [
          {
            "id": "40683355078717",
            "gid": "gid://shopify/ProductVariant/40683355078717",
            "sku": "LG-101395",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 7.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-black?variant=40683355078717"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 105.31,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-black-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-360-midsize-grip-black-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683355111485",
            "gid": "gid://shopify/ProductVariant/40683355111485",
            "sku": "KIT+13xLG-101396",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 105.31,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-black-13pcs-golf-grip-kit?variant=40683355111485"
          },
          {
            "id": "40683355144253",
            "gid": "gid://shopify/ProductVariant/40683355144253",
            "sku": "KIT(8oz)+13xLG-101396",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 110.34,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-black-13pcs-golf-grip-kit?variant=40683355144253"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 7.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-black",
        "handle": "lamkin-crossline-360-midsize-grip-black",
        "shopify_variants": [
          {
            "id": "40683355177021",
            "gid": "gid://shopify/ProductVariant/40683355177021",
            "sku": "LG-101396",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 7.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-black?variant=40683355177021"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Grey"
        ],
        "price": 105.31,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-grey-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-360-midsize-grip-grey-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683355209789",
            "gid": "gid://shopify/ProductVariant/40683355209789",
            "sku": "KIT+13xLG-101397",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 105.31,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-grey-13pcs-golf-grip-kit?variant=40683355209789"
          },
          {
            "id": "40683355242557",
            "gid": "gid://shopify/ProductVariant/40683355242557",
            "sku": "KIT(8oz)+13xLG-101397",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 110.34,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-grey-13pcs-golf-grip-kit?variant=40683355242557"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 7.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-grey",
        "handle": "lamkin-crossline-360-midsize-grip-grey",
        "shopify_variants": [
          {
            "id": "40683355275325",
            "gid": "gid://shopify/ProductVariant/40683355275325",
            "sku": "LG-101397",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 7.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-midsize-grip-grey?variant=40683355275325"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Grey"
        ],
        "price": 105.31,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-grey-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-360-standard-grip-grey-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356225597",
            "gid": "gid://shopify/ProductVariant/40683356225597",
            "sku": "KIT+13xLG-101377",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 105.31,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-grey-13pcs-golf-grip-kit?variant=40683356225597"
          },
          {
            "id": "40683356258365",
            "gid": "gid://shopify/ProductVariant/40683356258365",
            "sku": "KIT(8oz)+13xLG-101377",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 110.34,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-grey-13pcs-golf-grip-kit?variant=40683356258365"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 7.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-grey",
        "handle": "lamkin-crossline-360-standard-grip-grey",
        "shopify_variants": [
          {
            "id": "40683357405245",
            "gid": "gid://shopify/ProductVariant/40683357405245",
            "sku": "LG-101377",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 7.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-360-standard-grip-grey?variant=40683357405245"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, All Products, crossline, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Crossline, mem25, new-bundle-set, no logo, prime-2025, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=7cMfZ99VQSI",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline-3gen-ace",
    "brand": "Lamkin",
    "model": "Crossline 3GEN ACE",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured (crossline tread)",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Jumbo/Oversize": 64,
      "Midsize": 64,
      "Standard": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 4.67,
    "price_max": 5.45,
    "single_price_min": 4.67,
    "single_price_max": 5.45,
    "normalized_price_per_grip": 4.67,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-crossline-3gen-ace-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2015-logo-crossline-ace-3gen_a303ca62-1e19-4aff-a006-a13bc8e22222.jpg?v=1636058563",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 5.45,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-crossline-3gen-ace-oversize-grip",
        "handle": "lamkin-crossline-3gen-ace-oversize-grip",
        "shopify_variants": [
          {
            "id": "39461768560701",
            "gid": "gid://shopify/ProductVariant/39461768560701",
            "sku": "100755",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default"
            },
            "available": true,
            "price": 5.45,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-3gen-ace-oversize-grip?variant=39461768560701"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 5.06,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-crossline-3gen-ace-midsize-grip",
        "handle": "lamkin-crossline-3gen-ace-midsize-grip",
        "shopify_variants": [
          {
            "id": "39461768396861",
            "gid": "gid://shopify/ProductVariant/39461768396861",
            "sku": "101319",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default"
            },
            "available": true,
            "price": 5.06,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-3gen-ace-midsize-grip?variant=39461768396861"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 4.67,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-crossline-3gen-ace-grip",
        "handle": "lamkin-crossline-3gen-ace-grip",
        "shopify_variants": [
          {
            "id": "39461768331325",
            "gid": "gid://shopify/ProductVariant/39461768331325",
            "sku": "100753",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default"
            },
            "available": true,
            "price": 4.67,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-3gen-ace-grip?variant=39461768331325"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Brand_Lamkin, crossline, crossline ace, iron/wood, jumbo/oversize, lamkin, medium firm, oversize, oversize-jumbo-golf-grips, single-golf-grips, single-grip, Size_Jumbo/Oversize, Style_Swing Grip, tacky, under-150, video=5uc_oQKM6WA",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline-black",
    "brand": "Lamkin",
    "model": "Crossline Black",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured (crossline tread)",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Junior",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Junior",
      "Midsize",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5,
      "Jumbo/Oversize": 63.5,
      "Undersize": 63.5,
      "Junior": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 6.49,
    "price_max": 92.96,
    "single_price_min": 6.49,
    "single_price_max": 6.49,
    "normalized_price_per_grip": 5.84,
    "bundle_price_min": 52.57,
    "kit_price_min": 92.96,
    "url": "https://www.grips4less.com/products/lamkin-crossline-black-junior-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-crossline-black_2df9dd55-537e-44f8-bab3-8993efbbeb75.jpg?v=1735455631",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 15,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-standard-grip-grip-bundle-set",
        "handle": "lamkin-crossline-black-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967302717",
            "gid": "gid://shopify/ProductVariant/41021967302717",
            "sku": "SET-9x101310",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-standard-grip-grip-bundle-set?variant=41021967302717"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-midsize-grip-grip-bundle-set",
        "handle": "lamkin-crossline-black-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967269949",
            "gid": "gid://shopify/ProductVariant/41021967269949",
            "sku": "SET-9x101326",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-midsize-grip-grip-bundle-set?variant=41021967269949"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-oversize-grip-grip-bundle-set",
        "handle": "lamkin-crossline-black-oversize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967237181",
            "gid": "gid://shopify/ProductVariant/41021967237181",
            "sku": "SET-9x101327",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-oversize-grip-grip-bundle-set?variant=41021967237181"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-undersize-grip-grip-bundle-set",
        "handle": "lamkin-crossline-black-undersize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967204413",
            "gid": "gid://shopify/ProductVariant/41021967204413",
            "sku": "SET-9x101325",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-undersize-grip-grip-bundle-set?variant=41021967204413"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-junior-grip-grip-bundle-set",
        "handle": "lamkin-crossline-black-junior-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967171645",
            "gid": "gid://shopify/ProductVariant/41021967171645",
            "sku": "SET-9x101324",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-junior-grip-grip-bundle-set?variant=41021967171645"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 92.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-black-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683355799613",
            "gid": "gid://shopify/ProductVariant/40683355799613",
            "sku": "KIT+13x101310",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-standard-grip-13pcs-golf-grip-kit?variant=40683355799613"
          },
          {
            "id": "40683355832381",
            "gid": "gid://shopify/ProductVariant/40683355832381",
            "sku": "KIT(8oz)+13x101310",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 97.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-standard-grip-13pcs-golf-grip-kit?variant=40683355832381"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 92.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-midsize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-black-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683355865149",
            "gid": "gid://shopify/ProductVariant/40683355865149",
            "sku": "KIT+13x101326",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-midsize-grip-13pcs-golf-grip-kit?variant=40683355865149"
          },
          {
            "id": "40683355897917",
            "gid": "gid://shopify/ProductVariant/40683355897917",
            "sku": "KIT(8oz)+13x101326",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 97.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-midsize-grip-13pcs-golf-grip-kit?variant=40683355897917"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 92.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-oversize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-black-oversize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683355930685",
            "gid": "gid://shopify/ProductVariant/40683355930685",
            "sku": "KIT+13x101327",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-oversize-grip-13pcs-golf-grip-kit?variant=40683355930685"
          },
          {
            "id": "40683355963453",
            "gid": "gid://shopify/ProductVariant/40683355963453",
            "sku": "KIT(8oz)+13x101327",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 97.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-oversize-grip-13pcs-golf-grip-kit?variant=40683355963453"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 92.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-undersize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-black-undersize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356028989",
            "gid": "gid://shopify/ProductVariant/40683356028989",
            "sku": "KIT+13x101325",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-undersize-grip-13pcs-golf-grip-kit?variant=40683356028989"
          },
          {
            "id": "40683356061757",
            "gid": "gid://shopify/ProductVariant/40683356061757",
            "sku": "KIT(8oz)+13x101325",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 97.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-undersize-grip-13pcs-golf-grip-kit?variant=40683356061757"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 92.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-junior-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-black-junior-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356094525",
            "gid": "gid://shopify/ProductVariant/40683356094525",
            "sku": "KIT+13x101324",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-junior-grip-13pcs-golf-grip-kit?variant=40683356094525"
          },
          {
            "id": "40683356127293",
            "gid": "gid://shopify/ProductVariant/40683356127293",
            "sku": "KIT(8oz)+13x101324",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 97.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-junior-grip-13pcs-golf-grip-kit?variant=40683356127293"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-junior-grip",
        "handle": "lamkin-crossline-black-junior-grip",
        "shopify_variants": [
          {
            "id": "40683357962301",
            "gid": "gid://shopify/ProductVariant/40683357962301",
            "sku": "101324",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-junior-grip?variant=40683357962301"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-undersize-grip",
        "handle": "lamkin-crossline-black-undersize-grip",
        "shopify_variants": [
          {
            "id": "40683357995069",
            "gid": "gid://shopify/ProductVariant/40683357995069",
            "sku": "101325",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-undersize-grip?variant=40683357995069"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-oversize-grip",
        "handle": "lamkin-crossline-black-oversize-grip",
        "shopify_variants": [
          {
            "id": "40683358027837",
            "gid": "gid://shopify/ProductVariant/40683358027837",
            "sku": "101327",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-oversize-grip?variant=40683358027837"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-midsize-grip",
        "handle": "lamkin-crossline-black-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683358060605",
            "gid": "gid://shopify/ProductVariant/40683358060605",
            "sku": "101326",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-midsize-grip?variant=40683358060605"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-black-standard-grip",
        "handle": "lamkin-crossline-black-standard-grip",
        "shopify_variants": [
          {
            "id": "40683358093373",
            "gid": "gid://shopify/ProductVariant/40683358093373",
            "sku": "101310",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-black-standard-grip?variant=40683358093373"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, crossline, crossline black, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Crossline Black, mem25, new-bundle-set, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=7cMfZ99VQSI",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline-full-cord",
    "brand": "Lamkin",
    "model": "Crossline Full Cord",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9,
      "Midsize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 148.53,
    "price_max": 148.53,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 11.43,
    "bundle_price_min": null,
    "kit_price_min": 148.53,
    "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-full-cord-standard-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/crossline-full-cord-kit_f28a1cce-2d44-4f8f-ade9-df4f505722bd.jpg?v=1736027218",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-full-cord-standard-grips",
        "handle": "grip-kit-13x-lamkin-crossline-full-cord-standard-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683357601853",
            "gid": "gid://shopify/ProductVariant/40683357601853",
            "sku": "KIT+13x101315",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-full-cord-standard-grips?variant=40683357601853"
          },
          {
            "id": "40683357634621",
            "gid": "gid://shopify/ProductVariant/40683357634621",
            "sku": "KIT(8oz)+13x101315",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 153.57,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-full-cord-standard-grips?variant=40683357634621"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-full-cord-midsize-grips",
        "handle": "grip-kit-13x-lamkin-crossline-full-cord-midsize-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683357667389",
            "gid": "gid://shopify/ProductVariant/40683357667389",
            "sku": "KIT+13x101316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-full-cord-midsize-grips?variant=40683357667389"
          },
          {
            "id": "40683357700157",
            "gid": "gid://shopify/ProductVariant/40683357700157",
            "sku": "KIT(8oz)+13x101316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 153.57,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-crossline-full-cord-midsize-grips?variant=40683357700157"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "150-200, 2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, cord, cord-golf-grips, crossline, free-rog-momentum-glove, full",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline-full-cord",
    "brand": "Lamkin",
    "model": "Crossline Full-Cord",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "style_forward",
    "non_black_color_count": 5,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Cord Midsize Grip",
      "Cord Oversize Grip",
      "Cord Standard Grip",
      "Oversize / Black/White",
      "Ribbed"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5,
      "Jumbo/Oversize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 143.35,
    "single_price_min": 9.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 9.89,
    "bundle_price_min": 89.02,
    "kit_price_min": 143.35,
    "url": "https://www.grips4less.com/products/lamkin-crossline-full-cord-standard-grip-ribbed",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2015-logo-crossline-fc_f4f75e35-21e6-47e8-87ea-0cf2a1f58950.jpg?v=1735455578",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 7,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 89.02,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-cord-std-58r-grip-bundle-set",
        "handle": "lamkin-crossline-cord-std-58r-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Shape",
            "values": [
              "58 Round",
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021977067581",
            "gid": "gid://shopify/ProductVariant/41021977067581",
            "sku": "SET-9x101315",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Round",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-cord-std-58r-grip-bundle-set?variant=41021977067581"
          },
          {
            "id": "41021977100349",
            "gid": "gid://shopify/ProductVariant/41021977100349",
            "sku": "SET-9x101340-58REM",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Ribbed",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-cord-std-58r-grip-bundle-set?variant=41021977100349"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 89.02,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-cord-mid-58r-grip-bundle-set",
        "handle": "lamkin-crossline-cord-mid-58r-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976969277",
            "gid": "gid://shopify/ProductVariant/41021976969277",
            "sku": "SET-9x101316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-cord-mid-58r-grip-bundle-set?variant=41021976969277"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Ribbed"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-full-cord-standard-grip-ribbed",
        "handle": "lamkin-crossline-full-cord-standard-grip-ribbed",
        "shopify_variants": [
          {
            "id": "40683355537469",
            "gid": "gid://shopify/ProductVariant/40683355537469",
            "sku": "SET-1x101340-58REM",
            "color": "Ribbed",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-full-cord-standard-grip-ribbed?variant=40683355537469"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Oversize / Black/White"
        ],
        "price": 143.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossilne-full-cord-oversize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-crossilne-full-cord-oversize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Oversize / Black/White"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007847804989",
            "gid": "gid://shopify/ProductVariant/32007847804989",
            "sku": "KIT+13x101317",
            "color": "Oversize / Black/White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Oversize / Black/White",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 143.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossilne-full-cord-oversize-grip-13pcs-golf-grip-kit?variant=32007847804989"
          },
          {
            "id": "39918727692349",
            "gid": "gid://shopify/ProductVariant/39918727692349",
            "sku": "KIT(8oz)+13x101317",
            "color": "Oversize / Black/White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Oversize / Black/White",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 148.65,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossilne-full-cord-oversize-grip-13pcs-golf-grip-kit?variant=39918727692349"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Cord Oversize Grip"
        ],
        "price": 9.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-crossilne-full-cord-oversize-grip",
        "handle": "lamkin-crossilne-full-cord-oversize-grip",
        "shopify_variants": [
          {
            "id": "39461785239613",
            "gid": "gid://shopify/ProductVariant/39461785239613",
            "sku": "101317",
            "color": "Cord Oversize Grip",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossilne-full-cord-oversize-grip?variant=39461785239613"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Cord Midsize Grip"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-cord-mid-58r",
        "handle": "lamkin-crossline-cord-mid-58r",
        "shopify_variants": [
          {
            "id": "40683358912573",
            "gid": "gid://shopify/ProductVariant/40683358912573",
            "sku": "101316",
            "color": "Cord Midsize Grip",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-cord-mid-58r?variant=40683358912573"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Cord Standard Grip"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-cord-std-58r",
        "handle": "lamkin-crossline-cord-std-58r",
        "shopify_options": [
          {
            "name": "Shape",
            "values": [
              "58 Round",
              "58 Ribbed"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683358978109",
            "gid": "gid://shopify/ProductVariant/40683358978109",
            "sku": "101315",
            "color": "Cord Standard Grip",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Round",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-cord-std-58r?variant=40683358978109"
          },
          {
            "id": "40683359010877",
            "gid": "gid://shopify/ProductVariant/40683359010877",
            "sku": "101340-58REM",
            "color": "Cord Standard Grip",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Ribbed",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-cord-std-58r?variant=40683359010877"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, all-weather, cord, cord-golf-grips, crossline, crossline full-cord, full cord, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Crossline Full-Cord, medium firm, new-bundle-set, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=uAaDUcnoCW",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Cord Oversize Grip"
    ]
  },
  {
    "id": "lamkin-crossline-full-cord-genesis-360",
    "brand": "Lamkin",
    "model": "Crossline Full-Cord GENESIS 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 11.49,
    "price_max": 154.71,
    "single_price_min": 11.49,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 10.34,
    "bundle_price_min": 93.07,
    "kit_price_min": 154.71,
    "url": "https://www.grips4less.com/products/lamkin-crossline-genesis-360-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-crossline360-genesis-fc-grip_2e14d278-81a8-4520-9404-eb1f605dd5a1.jpg?v=1735455692",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 5,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 93.07,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-genesis-360-standard-grip-grip-bundle-set",
        "handle": "lamkin-crossline-genesis-360-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021959110717",
            "gid": "gid://shopify/ProductVariant/41021959110717",
            "sku": "SET-9xLG-101392",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 93.07,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-genesis-360-standard-grip-grip-bundle-set?variant=41021959110717"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 93.07,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-genesis-360-midsize-grip-grip-bundle-set",
        "handle": "lamkin-crossline-genesis-360-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952819261",
            "gid": "gid://shopify/ProductVariant/41021952819261",
            "sku": "SET-9xLG-101398",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 93.07,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-genesis-360-midsize-grip-grip-bundle-set?variant=41021952819261"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 11.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-genesis-360-midsize-grip",
        "handle": "lamkin-crossline-genesis-360-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683354980413",
            "gid": "gid://shopify/ProductVariant/40683354980413",
            "sku": "LG-101398",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-genesis-360-midsize-grip?variant=40683354980413"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 154.71,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-full-cord-genesis-360-standard-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-full-cord-genesis-360-standard-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard",
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683355406397",
            "gid": "gid://shopify/ProductVariant/40683355406397",
            "sku": "KIT+13xLG-101392",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 154.71,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-full-cord-genesis-360-standard-13pcs-golf-grip-kit?variant=40683355406397"
          },
          {
            "id": "40683355439165",
            "gid": "gid://shopify/ProductVariant/40683355439165",
            "sku": "KIT(8oz)+13xLG-101392",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 159.74,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-full-cord-genesis-360-standard-13pcs-golf-grip-kit?variant=40683355439165"
          },
          {
            "id": "40683355471933",
            "gid": "gid://shopify/ProductVariant/40683355471933",
            "sku": "KIT+13xLG-101398",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 154.71,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-full-cord-genesis-360-standard-13pcs-golf-grip-kit?variant=40683355471933"
          },
          {
            "id": "40683355504701",
            "gid": "gid://shopify/ProductVariant/40683355504701",
            "sku": "KIT(8oz)+13xLG-101398",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 159.74,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-full-cord-genesis-360-standard-13pcs-golf-grip-kit?variant=40683355504701"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 11.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-genesis-360-standard-grip",
        "handle": "lamkin-crossline-genesis-360-standard-grip",
        "shopify_variants": [
          {
            "id": "40683355766845",
            "gid": "gid://shopify/ProductVariant/40683355766845",
            "sku": "LG-101392",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-genesis-360-standard-grip?variant=40683355766845"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, All Products, cord, cord-golf-grips, crossline, crossline full-cord, crossline genesis, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Crossline, Lamkin Crossline Full-Cord, new-bundle-set, no logo, rubber, single-golf-grips, single-grip, standard, standard-s",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline-grip-58-core",
    "brand": "Lamkin",
    "model": "Crossline Grip - 58 Core",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured (crossline tread)",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.49,
    "price_max": 6.49,
    "single_price_min": 6.49,
    "single_price_max": 6.49,
    "normalized_price_per_grip": 6.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-crossline-standard-grip-58-core",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/lamkin-crossline_b25aee5d-a3bf-49d0-8bf9-163c51e5be6c.jpg?v=1690422364",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-standard-grip-58-core",
        "handle": "lamkin-crossline-standard-grip-58-core",
        "shopify_options": [
          {
            "name": "Shape",
            "values": [
              "58 Round",
              "58 Ribbed"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683358191677",
            "gid": "gid://shopify/ProductVariant/40683358191677",
            "sku": "WEB ONLY: 58 CORE-101308",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Round"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-standard-grip-58-core?variant=40683358191677"
          },
          {
            "id": "40683358224445",
            "gid": "gid://shopify/ProductVariant/40683358224445",
            "sku": "WEB ONLY: 58 CORE-101309",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Shape": "58 Ribbed"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-standard-grip-58-core?variant=40683358224445"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, 58 Core, All Products, crossline, firm, golf-grips, iron/wood, lamkin, Lamkin Crossline, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=7cMfZ99VQSI",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline-plus",
    "brand": "Lamkin",
    "model": "Crossline Plus",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured (crossline tread)",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 7.99,
    "price_max": 117.66,
    "single_price_min": 7.99,
    "single_price_max": 8.49,
    "normalized_price_per_grip": 7.19,
    "bundle_price_min": 64.72,
    "kit_price_min": 111.48,
    "url": "https://www.grips4less.com/products/lamkin-crossline-plus-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-crossline-plus_efb72543-b219-4c23-9c09-ae6f3a8ff232.jpg?v=1735455731",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 64.72,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-plus-standard-grip-grip-bundle-set",
        "handle": "lamkin-crossline-plus-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952360509",
            "gid": "gid://shopify/ProductVariant/41021952360509",
            "sku": "SET-9x101378",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 64.72,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-standard-grip-grip-bundle-set?variant=41021952360509"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 68.77,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-plus-midsize-grip-grip-bundle-set",
        "handle": "lamkin-crossline-plus-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952327741",
            "gid": "gid://shopify/ProductVariant/41021952327741",
            "sku": "SET-9x101379",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 68.77,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-midsize-grip-grip-bundle-set?variant=41021952327741"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 117.66,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-plus-midsize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-plus-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683354685501",
            "gid": "gid://shopify/ProductVariant/40683354685501",
            "sku": "KIT+13x101379",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 117.66,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-midsize-grip-13pcs-golf-grip-kit?variant=40683354685501"
          },
          {
            "id": "40683354718269",
            "gid": "gid://shopify/ProductVariant/40683354718269",
            "sku": "KIT(8oz)+13x101379",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 122.69,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-midsize-grip-13pcs-golf-grip-kit?variant=40683354718269"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 111.48,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-plus-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-plus-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683354751037",
            "gid": "gid://shopify/ProductVariant/40683354751037",
            "sku": "KIT+13x101378",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 111.48,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-standard-grip-13pcs-golf-grip-kit?variant=40683354751037"
          },
          {
            "id": "40683354783805",
            "gid": "gid://shopify/ProductVariant/40683354783805",
            "sku": "KIT(8oz)+13x101378",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 116.52,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-standard-grip-13pcs-golf-grip-kit?variant=40683354783805"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 8.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-plus-midsize-grip",
        "handle": "lamkin-crossline-plus-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683354816573",
            "gid": "gid://shopify/ProductVariant/40683354816573",
            "sku": "101379",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-midsize-grip?variant=40683354816573"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 7.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-plus-standard-grip",
        "handle": "lamkin-crossline-plus-standard-grip",
        "shopify_variants": [
          {
            "id": "40683354849341",
            "gid": "gid://shopify/ProductVariant/40683354849341",
            "sku": "101378",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-standard-grip?variant=40683354849341"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, crossline, crossline plus, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Crossline plus, Less Tapered, Minimal Taper, Model_Lamkin Crossline Plus, new-bundle-set, non-tapered swing grips, reduced taper, rubber, single-golf-grips, single-grip, Size_Standard, standard, standar",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-crossline-plus-wrap",
    "brand": "Lamkin",
    "model": "Crossline Plus Wrap",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured (crossline tread)",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round/ribbed (varies)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "ribbed",
    "alignment_description": "Internal reminder rib creates a raised ridge along the underside when installed.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 7.99,
    "price_max": 111.48,
    "single_price_min": 7.99,
    "single_price_max": 7.99,
    "normalized_price_per_grip": 7.19,
    "bundle_price_min": 64.72,
    "kit_price_min": 111.48,
    "url": "https://www.grips4less.com/products/lamkin-crossline-plus-wrap-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-crossline-wrap_1ded1aea-4386-4aaf-92f6-2e775c978cd0.jpg?v=1735455732",
    "fit_tags": [
      "alignment_aid"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 64.72,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-crossline-plus-wrap-standard-grip-grip-bundle-set",
        "handle": "lamkin-crossline-plus-wrap-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952294973",
            "gid": "gid://shopify/ProductVariant/41021952294973",
            "sku": "SET-9x101380",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 64.72,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-wrap-standard-grip-grip-bundle-set?variant=41021952294973"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 111.48,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-crossline-plus-wrap-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-crossline-plus-wrap-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683354587197",
            "gid": "gid://shopify/ProductVariant/40683354587197",
            "sku": "KIT+13x101380",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 111.48,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-wrap-standard-grip-13pcs-golf-grip-kit?variant=40683354587197"
          },
          {
            "id": "40683354619965",
            "gid": "gid://shopify/ProductVariant/40683354619965",
            "sku": "KIT(8oz)+13x101380",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 116.52,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-wrap-standard-grip-13pcs-golf-grip-kit?variant=40683354619965"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 7.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-crossline-plus-wrap-standard-grip",
        "handle": "lamkin-crossline-plus-wrap-standard-grip",
        "shopify_variants": [
          {
            "id": "40683354652733",
            "gid": "gid://shopify/ProductVariant/40683354652733",
            "sku": "101380",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-crossline-plus-wrap-standard-grip?variant=40683354652733"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, crossline, crossline plus, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Crossline plus, Less Tapered, Minimal Taper, Model_Lamkin Crossline Plus, new-bundle-set, non-tapered swing grips, reduced taper, rubber, single-golf-grips, single-grip, Size_Standard, standard, standar",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-perma-wrap-ace-3gen",
    "brand": "Lamkin",
    "model": "Perma-Wrap ACE 3GEN",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Gray"
    ],
    "weight_g_by_size": {
      "Standard": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 3.5,
    "price_max": 3.5,
    "single_price_min": 3.5,
    "single_price_max": 3.5,
    "normalized_price_per_grip": 3.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-permawrap-ace-3gen-std",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/permawrap-ace-3gen-allcolors_e4dc3bd3-2e00-4fd3-b9b0-968c597759df.jpg?v=1636055562",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Gray"
        ],
        "price": 3.5,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-permawrap-ace-3gen-std",
        "handle": "lamkin-permawrap-ace-3gen-std",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461784879165",
            "gid": "gid://shopify/ProductVariant/39461784879165",
            "sku": "100741",
            "color": "Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Gray"
            },
            "available": true,
            "price": 3.5,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-permawrap-ace-3gen-std?variant=39461784879165"
          },
          {
            "id": "39461784911933",
            "gid": "gid://shopify/ProductVariant/39461784911933",
            "sku": "100742",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 3.5,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-permawrap-ace-3gen-std?variant=39461784911933"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_Lamkin, iron/wood, lamkin, perma-wrap, rubber, single-golf-grips, single-grip, Size_Standard, soft, standard, standard-size-golf-grips, Style_Swing Grip, tacky, under-150, video=KIRPGmIBadE",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Gray",
      "White"
    ]
  },
  {
    "id": "lamkin-players-cord",
    "brand": "Lamkin",
    "model": "Players Cord",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard",
      "Standard+ Reduced Taper"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Ribbed"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.49,
    "price_max": 136.85,
    "single_price_min": 9.49,
    "single_price_max": 9.49,
    "normalized_price_per_grip": 9.49,
    "bundle_price_min": null,
    "kit_price_min": 136.85,
    "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip-ribbed",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/PlayersCord-Std-Front_65a5c96b-9cd0-4e5f-90e1-6ead85087150.jpg?v=1736026985",
    "fit_tags": [],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 136.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-players-cord-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard+ Reduced Taper",
              "Standard Taper"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007845412925",
            "gid": "gid://shopify/ProductVariant/32007845412925",
            "sku": "KIT+13xLG-100829",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard+ Reduced Taper"
            },
            "available": false,
            "price": 136.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip-13pcs-golf-grip-kit?variant=32007845412925"
          },
          {
            "id": "32007845445693",
            "gid": "gid://shopify/ProductVariant/32007845445693",
            "sku": "KIT+13xLG-100827",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard Taper"
            },
            "available": false,
            "price": 130.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip-13pcs-golf-grip-kit?variant=32007845445693"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Ribbed"
        ],
        "price": 9.49,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip-ribbed",
        "handle": "lamkin-players-cord-standard-grip-ribbed",
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Standard+ (Reduced) Taper / Ribbed",
              "Standard Taper / Ribbed"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "988393537555",
            "gid": "gid://shopify/ProductVariant/988393537555",
            "sku": "LG-100830",
            "color": "Ribbed",
            "size": "Standard",
            "selected_options": {
              "Title": "Standard+ (Reduced) Taper / Ribbed"
            },
            "available": false,
            "price": 9.49,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip-ribbed?variant=988393537555"
          },
          {
            "id": "988393504787",
            "gid": "gid://shopify/ProductVariant/988393504787",
            "sku": "LG-100828",
            "color": "Ribbed",
            "size": "Standard",
            "selected_options": {
              "Title": "Standard Taper / Ribbed"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip-ribbed?variant=988393504787"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.49,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip",
        "handle": "lamkin-players-cord-standard-grip",
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Standard+ (Reduced) Taper",
              "Standard Taper"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461737660477",
            "gid": "gid://shopify/ProductVariant/39461737660477",
            "sku": "LG-100829",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Standard+ (Reduced) Taper"
            },
            "available": false,
            "price": 9.49,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip?variant=39461737660477"
          },
          {
            "id": "988392259603",
            "gid": "gid://shopify/ProductVariant/988392259603",
            "sku": "LG-100827",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Standard Taper"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-players-cord-standard-grip?variant=988392259603"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bundle, bundles-asbl-driver-only, cord, cord-golf-grips, free-rog-momentum-glove, full cord, grip kit, grip kits, grip set, grip sets, iron/wood, KIT-added07282020, labor-day-bundle-sale-202",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-r-e-l-3gen-ace-360",
    "brand": "Lamkin",
    "model": "R.E.L 3GEN ACE 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (ACE 3GEN rubber)",
    "texture": "fingerprint texture",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.99,
    "price_max": 6.99,
    "single_price_min": 6.99,
    "single_price_max": 6.99,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/r-e-l-3gen-ace-360-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/rel-3gen-360_7b63884f-adea-4beb-8202-6a28fcc65c07.jpg?v=1636055568",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 6.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/r-e-l-3gen-ace-360-standard-grip",
        "handle": "r-e-l-3gen-ace-360-standard-grip",
        "shopify_variants": [
          {
            "id": "39461784780861",
            "gid": "gid://shopify/ProductVariant/39461784780861",
            "sku": "101028",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/r-e-l-3gen-ace-360-standard-grip?variant=39461784780861"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Brand_Lamkin, iron/wood, lamkin, medium firm, R.E.L., single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, tacky, under-150, video=-HJcP7k4Fto",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-r-e-l-3gen-ace",
    "brand": "Lamkin",
    "model": "R.E.L. 3GEN ACE",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (ACE 3GEN rubber)",
    "texture": "fingerprint texture",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 45
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.99,
    "price_max": 6.99,
    "single_price_min": 6.99,
    "single_price_max": 6.99,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-lamkin-rel-ace-3gen-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/REL-ACE-3GEN-Black-Std_ea97726c-b5d1-405e-9201-1810623af392.jpg?v=1636052804",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.99,
        "per_grip_g": 45,
        "total_g": 44.996363104,
        "url": "https://www.grips4less.com/products/new-lamkin-rel-ace-3gen-oversize-grip",
        "handle": "new-lamkin-rel-ace-3gen-oversize-grip",
        "shopify_variants": [
          {
            "id": "628107437",
            "gid": "gid://shopify/ProductVariant/628107437",
            "sku": "101022",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-lamkin-rel-ace-3gen-oversize-grip?variant=628107437"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, 58 core, All products, Brand_Lamkin, iron/wood, jumbo/oversize, lamkin, medium firm, New for 2014, oversize, oversize-jumbo-golf-grips, R.E.L., rubber, single-golf-grips, single-grip, Size_Jumbo/Oversize, Style_Swing Grip, tacky, under-150, video=8Qu4scxzSEw",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "lamkin-r-e-l-3gen-ace-360",
    "brand": "Lamkin",
    "model": "R.E.L. 3GEN ACE 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (ACE 3GEN rubber)",
    "texture": "fingerprint texture",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.99,
    "price_max": 6.99,
    "single_price_min": 6.99,
    "single_price_max": 6.99,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/r-e-l-3gen-360-ace-standard",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/rel-ace-3gen-360_de7d67e3-7d63-4221-873a-7bf287fcf721.jpg?v=1627089183",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/r-e-l-3gen-360-ace-standard",
        "handle": "r-e-l-3gen-360-ace-standard",
        "shopify_variants": [
          {
            "id": "397803889",
            "gid": "gid://shopify/ProductVariant/397803889",
            "sku": "101028",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default"
            },
            "available": false,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/r-e-l-3gen-360-ace-standard?variant=397803889"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, infinite-opt-addkit, iron/wood, lamkin, Lamkin R.E.L., medium firm, R.E.L., single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=video=8Qu4scxzSEw",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-r-e-l-ace-3gen",
    "brand": "Lamkin",
    "model": "R.E.L. ACE 3GEN",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (ACE 3GEN rubber)",
    "texture": "fingerprint texture",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Undersize": 45.4
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.99,
    "price_max": 104.35,
    "single_price_min": 5.99,
    "single_price_max": 6.49,
    "normalized_price_per_grip": 5.99,
    "bundle_price_min": null,
    "kit_price_min": 91.35,
    "url": "https://www.grips4less.com/products/lamkin-rel-ace-3gen-undersize-black-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/rel-kits-black_631d6d8b-0925-4e16-86f7-df309924e41d.jpg?v=1736027235",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 104.35,
        "per_grip_g": 246,
        "total_g": 3197.8262085,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-r-e-l-ace-3gen-oversize-grip-black",
        "handle": "grip-kit-13x-lamkin-r-e-l-ace-3gen-oversize-grip-black",
        "shopify_variants": [
          {
            "id": "35920127239",
            "gid": "gid://shopify/ProductVariant/35920127239",
            "sku": "KIT+13x101022",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 104.35,
            "weight_g": 3197.8,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-r-e-l-ace-3gen-oversize-grip-black?variant=35920127239"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 97.85,
        "per_grip_g": 246,
        "total_g": 3197.8262085,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-r-e-l-ace-3gen-midsize-grip-black",
        "handle": "grip-kit-13x-lamkin-r-e-l-ace-3gen-midsize-grip-black",
        "shopify_variants": [
          {
            "id": "35917477767",
            "gid": "gid://shopify/ProductVariant/35917477767",
            "sku": "KIT+13x101016",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 97.85,
            "weight_g": 3197.8,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-r-e-l-ace-3gen-midsize-grip-black?variant=35917477767"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 91.35,
        "per_grip_g": 246,
        "total_g": 3197.8262085,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-r-e-l-ace-3gen-standard-grip-black",
        "handle": "grip-kit-13x-lamkin-r-e-l-ace-3gen-standard-grip-black",
        "shopify_variants": [
          {
            "id": "35915188231",
            "gid": "gid://shopify/ProductVariant/35915188231",
            "sku": "KIT+13x101009",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 91.35,
            "weight_g": 3197.8,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-r-e-l-ace-3gen-standard-grip-black?variant=35915188231"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/lamkin-rel-ace-3gen-undersize-black-grip",
        "handle": "lamkin-rel-ace-3gen-undersize-black-grip",
        "shopify_variants": [
          {
            "id": "397804177",
            "gid": "gid://shopify/ProductVariant/397804177",
            "sku": "101000",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-rel-ace-3gen-undersize-black-grip?variant=397804177"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.49,
        "per_grip_g": 45,
        "total_g": 44.996363104,
        "url": "https://www.grips4less.com/products/new-lamkin-rel-ace-3gen-midsize-grip",
        "handle": "new-lamkin-rel-ace-3gen-midsize-grip",
        "shopify_variants": [
          {
            "id": "628120669",
            "gid": "gid://shopify/ProductVariant/628120669",
            "sku": "101016",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 6.49,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-lamkin-rel-ace-3gen-midsize-grip?variant=628120669"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.99,
        "per_grip_g": 45,
        "total_g": 44.996363104,
        "url": "https://www.grips4less.com/products/new-lamkin-rel-ace-3gen-standard-grip",
        "handle": "new-lamkin-rel-ace-3gen-standard-grip",
        "shopify_variants": [
          {
            "id": "308881003",
            "gid": "gid://shopify/ProductVariant/308881003",
            "sku": "101009",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-lamkin-rel-ace-3gen-standard-grip?variant=308881003"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, iron/wood, jumbo/oversize, labor-day-bundle-sale-2025, labor-day-bundle-sale-2025-v2, lamkin, Lamkin R",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "lamkin-r-e-l-ace-3gen-soft",
    "brand": "Lamkin",
    "model": "R.E.L. ACE 3GEN (Soft)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (ACE 3GEN rubber)",
    "texture": "fingerprint texture",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Neon Purple"
    ],
    "weight_g_by_size": {
      "Undersize": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 5.99,
    "price_max": 5.99,
    "single_price_min": 5.99,
    "single_price_max": 5.99,
    "normalized_price_per_grip": 5.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/r-e-l-3gen-undersize-58r",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/REL-ACE-undersize-allcolors_ba6d5fa7-d7d0-46cd-b163-decf911fd6e8.jpg?v=1636059257",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Neon Purple"
        ],
        "price": 5.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/r-e-l-3gen-undersize-58r",
        "handle": "r-e-l-3gen-undersize-58r",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Purple",
              "Neon Pink"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "308881837",
            "gid": "gid://shopify/ProductVariant/308881837",
            "sku": "101002",
            "color": "Neon Purple",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Purple"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/r-e-l-3gen-undersize-58r?variant=308881837"
          },
          {
            "id": "628146129",
            "gid": "gid://shopify/ProductVariant/628146129",
            "sku": "101001",
            "color": "Neon Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Pink"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/r-e-l-3gen-undersize-58r?variant=628146129"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, 58 core, All products, Brand_Lamkin, iron/wood, lamkin, New for 2014, R.E.L., rubber, single-golf-grips, single-grip, Size_Undersize, soft, Style_Swing Grip, tacky, under-150, undersize, undersize-golf-grips, video=8Qu4scxzSEw, womens",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Neon Purple",
      "Neon Pink"
    ]
  },
  {
    "id": "lamkin-st-2-hybrid",
    "brand": "Lamkin",
    "model": "ST+2 Hybrid",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 49.9,
      "Midsize": 49.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 11.49,
    "price_max": 154.71,
    "single_price_min": 11.49,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 10.34,
    "bundle_price_min": 93.07,
    "kit_price_min": 154.71,
    "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-st-plus2-hybrid_43583e93-73a9-452d-a453-c619616c8c03.jpg?v=1735455682",
    "fit_tags": [],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 93.07,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-standard-grip-grip-bundle-set",
        "handle": "lamkin-st-2-hybrid-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960912957",
            "gid": "gid://shopify/ProductVariant/41021960912957",
            "sku": "SET-9xLG-101929",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 93.07,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-standard-grip-grip-bundle-set?variant=41021960912957"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 93.07,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-midsize-grip-grip-bundle-set",
        "handle": "lamkin-st-2-hybrid-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960749117",
            "gid": "gid://shopify/ProductVariant/41021960749117",
            "sku": "SET-9xLG-101930",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip": "Midsize"
            },
            "available": false,
            "price": 93.07,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-midsize-grip-grip-bundle-set?variant=41021960749117"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 154.71,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-st-2-hybrid-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356717117",
            "gid": "gid://shopify/ProductVariant/40683356717117",
            "sku": "KIT+13xLG-101929",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 154.71,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-standard-grip-13pcs-golf-grip-kit?variant=40683356717117"
          },
          {
            "id": "40683356749885",
            "gid": "gid://shopify/ProductVariant/40683356749885",
            "sku": "KIT(8oz)+13xLG-101929",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 159.74,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-standard-grip-13pcs-golf-grip-kit?variant=40683356749885"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 154.71,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-midsize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-st-2-hybrid-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356913725",
            "gid": "gid://shopify/ProductVariant/40683356913725",
            "sku": "KIT+13xLG-101930",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 154.71,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-midsize-grip-13pcs-golf-grip-kit?variant=40683356913725"
          },
          {
            "id": "40683356946493",
            "gid": "gid://shopify/ProductVariant/40683356946493",
            "sku": "KIT(8oz)+13xLG-101930",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 159.74,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-midsize-grip-13pcs-golf-grip-kit?variant=40683356946493"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 11.49,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-midsize-grip",
        "handle": "lamkin-st-2-hybrid-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683356979261",
            "gid": "gid://shopify/ProductVariant/40683356979261",
            "sku": "LG-101930",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip": "Midsize"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-midsize-grip?variant=40683356979261"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 11.49,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-standard-grip",
        "handle": "lamkin-st-2-hybrid-standard-grip",
        "shopify_variants": [
          {
            "id": "40683357077565",
            "gid": "gid://shopify/ProductVariant/40683357077565",
            "sku": "LG-101929",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-standard-grip?variant=40683357077565"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, cord, firm, golf-grips, grip bundle, hybrid, hybrid-golf-grips, iron/wood, lamkin, Lamkin ST Hybrid, Lamkin ST+2, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium firm, mem25, Minimal Taper, new-bundle-set, non-tapered-and-less-tapered-swing-grips, prime-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-st-2-hybrid-360",
    "brand": "Lamkin",
    "model": "ST+2 Hybrid 360",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 49.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 11.49,
    "price_max": 154.71,
    "single_price_min": 11.49,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 10.34,
    "bundle_price_min": 93.07,
    "kit_price_min": 154.71,
    "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-360-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-st-360.jpg?v=1735455729",
    "fit_tags": [],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 93.07,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-360-standard-grip-grip-bundle-set",
        "handle": "lamkin-st-2-hybrid-360-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952589885",
            "gid": "gid://shopify/ProductVariant/41021952589885",
            "sku": "SET-9xLG-101940",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 93.07,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-360-standard-grip-grip-bundle-set?variant=41021952589885"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 154.71,
        "per_grip_g": 73.3,
        "total_g": 952.543977,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-360-standard-grip-13pc-golf-grip-kit",
        "handle": "lamkin-st-2-hybrid-360-standard-grip-13pc-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683354882109",
            "gid": "gid://shopify/ProductVariant/40683354882109",
            "sku": "KIT+13xLG-101940",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 154.71,
            "weight_g": 952.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-360-standard-grip-13pc-golf-grip-kit?variant=40683354882109"
          },
          {
            "id": "40683354914877",
            "gid": "gid://shopify/ProductVariant/40683354914877",
            "sku": "KIT(8oz)+13xLG-101940",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 159.74,
            "weight_g": 952.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-360-standard-grip-13pc-golf-grip-kit?variant=40683354914877"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 11.49,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-360-standard-grip",
        "handle": "lamkin-st-2-hybrid-360-standard-grip",
        "shopify_variants": [
          {
            "id": "40683354947645",
            "gid": "gid://shopify/ProductVariant/40683354947645",
            "sku": "LG-101940",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-360-standard-grip?variant=40683354947645"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, All Products, asbl-grip-option, cord, firm, golf-grips, grip bundle, hybrid, hybrid-golf-grips, iron/wood, lamkin, Lamkin ST Hybrid, Lamkin ST+2, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium firm, mem25, Minimal Taper, new-bundle-set, non-tapered-and-l",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-st-2-hybrid-with-calibrate",
    "brand": "Lamkin",
    "model": "ST+2 Hybrid with CALIBRATE",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "CALIBRATE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "Calibrate",
    "alignment_description": "Raised ridge along the underside marketed as a hand-placement reference. Lamkin is a discontinued brand at Grips4Less -- not eligible for live quiz recommendations regardless of this field.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 49.9,
      "Midsize": 49.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 11.49,
    "price_max": 160.88,
    "single_price_min": 11.49,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 10.34,
    "bundle_price_min": 93.07,
    "kit_price_min": 154.71,
    "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkkn-st-plus2-hybrid-with-calibrate_cfaa38fb-a984-4765-ba4b-f6f299fe854c.jpg?v=1735455683",
    "fit_tags": [
      "alignment_aid",
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 5,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 93.07,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-standard-grip-grip-bundle-set",
        "handle": "lamkin-st-2-hybrid-with-calibrate-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960880189",
            "gid": "gid://shopify/ProductVariant/41021960880189",
            "sku": "SET-9xLG-101927",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 93.07,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-standard-grip-grip-bundle-set?variant=41021960880189"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 97.12,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-midsize-grip-grip-bundle-set",
        "handle": "lamkin-st-2-hybrid-with-calibrate-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960781885",
            "gid": "gid://shopify/ProductVariant/41021960781885",
            "sku": "SET-9xLG-101928",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip": "Midsize"
            },
            "available": false,
            "price": 97.12,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-midsize-grip-grip-bundle-set?variant=41021960781885"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 154.71,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-st-2-hybrid-with-calibrate-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356782653",
            "gid": "gid://shopify/ProductVariant/40683356782653",
            "sku": "KIT+13xLG-101927",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 154.71,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-standard-grip-13pcs-golf-grip-kit?variant=40683356782653"
          },
          {
            "id": "40683356815421",
            "gid": "gid://shopify/ProductVariant/40683356815421",
            "sku": "KIT(8oz)+13xLG-101927",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 159.74,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-standard-grip-13pcs-golf-grip-kit?variant=40683356815421"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 160.88,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-midsize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-st-2-hybrid-with-calibrate-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356848189",
            "gid": "gid://shopify/ProductVariant/40683356848189",
            "sku": "KIT+13xLG-101928",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-midsize-grip-13pcs-golf-grip-kit?variant=40683356848189"
          },
          {
            "id": "40683356880957",
            "gid": "gid://shopify/ProductVariant/40683356880957",
            "sku": "KIT(8oz)+13xLG-101928",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 165.92,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-midsize-grip-13pcs-golf-grip-kit?variant=40683356880957"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 11.49,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-standard-grip",
        "handle": "lamkin-st-2-hybrid-with-calibrate-standard-grip",
        "shopify_variants": [
          {
            "id": "40683357044797",
            "gid": "gid://shopify/ProductVariant/40683357044797",
            "sku": "LG-101927",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-standard-grip?variant=40683357044797"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "Alignment golf grip, alignment-golf-grips, All Products, cord, firm, golf-grips, grip bundle, hybrid, hybrid-golf-grips, iron/wood, lamkin, Lamkin Calibrate, Lamkin ST Hybrid, Lamkin ST+2, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium firm, Minimal Taper, new-bundle-set, non-tapered-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar",
    "brand": "Lamkin",
    "model": "Sonar",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 90.7,
      "Midsize": 90.7,
      "Jumbo/Oversize": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 136.18,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 80.92,
    "kit_price_min": 136.18,
    "url": "https://www.grips4less.com/products/lamkin-sonar-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-sonar_e5049f8b-ae2c-4226-8548-914ca368d1fa.jpg?v=1735455647",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 8,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 128.25,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-sonar-standard-grip-grip-bundle-set",
        "handle": "lamkin-sonar-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965140029",
            "gid": "gid://shopify/ProductVariant/41021965140029",
            "sku": "SET-9xLG-101902",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 128.25,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-standard-grip-grip-bundle-set?variant=41021965140029"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-sonar-midsize-grip-grip-bundle-set",
        "handle": "lamkin-sonar-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965107261",
            "gid": "gid://shopify/ProductVariant/41021965107261",
            "sku": "SET-9xLG-101903",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-midsize-grip-grip-bundle-set?variant=41021965107261"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-sonar-oversize-grip-grip-bundle-set",
        "handle": "lamkin-sonar-oversize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021961699389",
            "gid": "gid://shopify/ProductVariant/41021961699389",
            "sku": "SET-9xLG-101926",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-oversize-grip-grip-bundle-set?variant=41021961699389"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-sonar-oversize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-sonar-oversize-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "40683356520509",
            "gid": "gid://shopify/ProductVariant/40683356520509",
            "sku": "KIT+13xLG-101926",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-oversize-grip-13pcs-golf-grip-kit?variant=40683356520509"
          },
          {
            "id": "40683356553277",
            "gid": "gid://shopify/ProductVariant/40683356553277",
            "sku": "KIT(8oz)+13xLG-101926",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-oversize-grip-13pcs-golf-grip-kit?variant=40683356553277"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-sonar-oversize-grip",
        "handle": "lamkin-sonar-oversize-grip",
        "shopify_variants": [
          {
            "id": "40683357175869",
            "gid": "gid://shopify/ProductVariant/40683357175869",
            "sku": "LG-101926",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-oversize-grip?variant=40683357175869"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-sonar-13pcs-grips-golf-grip-kit",
        "handle": "lamkin-sonar-13pcs-grips-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard",
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13277634789437",
            "gid": "gid://shopify/ProductVariant/13277634789437",
            "sku": "KIT+13xLG-101902",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-13pcs-grips-golf-grip-kit?variant=13277634789437"
          },
          {
            "id": "39918740013117",
            "gid": "gid://shopify/ProductVariant/39918740013117",
            "sku": "KIT(8oz)+13xLG-101902",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-13pcs-grips-golf-grip-kit?variant=39918740013117"
          },
          {
            "id": "13277658873917",
            "gid": "gid://shopify/ProductVariant/13277658873917",
            "sku": "KIT+13xLG-101903",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-13pcs-grips-golf-grip-kit?variant=13277658873917"
          },
          {
            "id": "39918740045885",
            "gid": "gid://shopify/ProductVariant/39918740045885",
            "sku": "KIT(8oz)+13xLG-101903",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-13pcs-grips-golf-grip-kit?variant=39918740045885"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-sonar-midsize-grip",
        "handle": "lamkin-sonar-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683357503549",
            "gid": "gid://shopify/ProductVariant/40683357503549",
            "sku": "LG-101903",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-midsize-grip?variant=40683357503549"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-sonar-standard-grip",
        "handle": "lamkin-sonar-standard-grip",
        "shopify_variants": [
          {
            "id": "40683357536317",
            "gid": "gid://shopify/ProductVariant/40683357536317",
            "sku": "LG-101902",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-standard-grip?variant=40683357536317"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, best-sellers, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Sonar, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium soft, mem25, Minimal Taper, new-bundle-set, non-tapered-and-less-tapered-swing-grips, reduced taper, single-golf-grips, single-grip, s",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar-tour",
    "brand": "Lamkin",
    "model": "Sonar TOUR",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 49.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.49,
    "price_max": 130.01,
    "single_price_min": 9.49,
    "single_price_max": 9.49,
    "normalized_price_per_grip": 8.54,
    "bundle_price_min": 76.87,
    "kit_price_min": 130.01,
    "url": "https://www.grips4less.com/products/lamkin-sonar-tour-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-sonar-tour.jpg?v=1735455656",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 76.87,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-sonar-tour-standard-grip-grip-bundle-set",
        "handle": "lamkin-sonar-tour-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021964025917",
            "gid": "gid://shopify/ProductVariant/41021964025917",
            "sku": "SET-9xLG-101916",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 76.87,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-tour-standard-grip-grip-bundle-set?variant=41021964025917"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 130.01,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-sonar-tour-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-sonar-tour-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356389437",
            "gid": "gid://shopify/ProductVariant/40683356389437",
            "sku": "KIT+13xLG-101916",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 130.01,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-tour-standard-grip-13pcs-golf-grip-kit?variant=40683356389437"
          },
          {
            "id": "40683356422205",
            "gid": "gid://shopify/ProductVariant/40683356422205",
            "sku": "KIT(8oz)+13xLG-101916",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 135.04,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-tour-standard-grip-13pcs-golf-grip-kit?variant=40683356422205"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.49,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-sonar-tour-standard-grip",
        "handle": "lamkin-sonar-tour-standard-grip",
        "shopify_variants": [
          {
            "id": "40683357306941",
            "gid": "gid://shopify/ProductVariant/40683357306941",
            "sku": "LG-101916",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.49,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-tour-standard-grip?variant=40683357306941"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin R.E.L., Lamkin Sonar, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium firm, Minimal Taper, new-bundle-set, non-tapered-and-less-tapered-swing-grips, overstock-oct-2022, overstock-oct-2023, single-golf-grips, single-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar-tour-with-calibrate",
    "brand": "Lamkin",
    "model": "Sonar Tour with CALIBRATE",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "CALIBRATE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "Calibrate",
    "alignment_description": "Raised ridge along the underside marketed as a hand-placement reference. Lamkin is a discontinued brand at Grips4Less -- not eligible for live quiz recommendations regardless of this field.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 49.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 136.18,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 80.92,
    "kit_price_min": 136.18,
    "url": "https://www.grips4less.com/products/lamkin-sonar-tour-with-calibrate-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-sonar-tour-calibrate-front-back_918d3bb6-b50e-429d-a433-34b714e54efd.jpg?v=1735455681",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-sonar-tour-with-calibrate-standard-grip-grip-bundle-set",
        "handle": "lamkin-sonar-tour-with-calibrate-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960978493",
            "gid": "gid://shopify/ProductVariant/41021960978493",
            "sku": "SET-9xLG-101924",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-tour-with-calibrate-standard-grip-grip-bundle-set?variant=41021960978493"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-sonar-tour-with-calibrate-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-sonar-tour-with-calibrate-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356586045",
            "gid": "gid://shopify/ProductVariant/40683356586045",
            "sku": "KIT+13xLG-101924",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-tour-with-calibrate-standard-grip-13pcs-golf-grip-kit?variant=40683356586045"
          },
          {
            "id": "40683356618813",
            "gid": "gid://shopify/ProductVariant/40683356618813",
            "sku": "KIT(8oz)+13xLG-101924",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-tour-with-calibrate-standard-grip-13pcs-golf-grip-kit?variant=40683356618813"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-sonar-tour-with-calibrate-standard-grip",
        "handle": "lamkin-sonar-tour-with-calibrate-standard-grip",
        "shopify_variants": [
          {
            "id": "40683357143101",
            "gid": "gid://shopify/ProductVariant/40683357143101",
            "sku": "LG-101924",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-tour-with-calibrate-standard-grip?variant=40683357143101"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "Alignment golf grip, alignment-golf-grips, All Products, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Calibrate, Lamkin Sonar, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium firm, Minimal Taper, new-bundle-set, non-tapered-and-less-tapered-swing-grips, reduced taper, remin",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar-rose-gold",
    "brand": "Lamkin",
    "model": "Sonar+ (Rose Gold)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Undersize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 190.95,
    "price_max": 190.95,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.69,
    "bundle_price_min": null,
    "kit_price_min": 190.95,
    "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-kits-sonar-undersize-rose.jpg?v=1736026989",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 190.95,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-sonar-undersize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356160061",
            "gid": "gid://shopify/ProductVariant/40683356160061",
            "sku": "KIT+13xLG-101901",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 190.95,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip-13pcs-golf-grip-kit?variant=40683356160061"
          },
          {
            "id": "40683356192829",
            "gid": "gid://shopify/ProductVariant/40683356192829",
            "sku": "KIT(8oz)+13xLG-101901",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 194.95,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip-13pcs-golf-grip-kit?variant=40683356192829"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, gifts-for-her, grip kit, grip kits, grip set, grip sets, gri",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar-black",
    "brand": "Lamkin",
    "model": "Sonar+ BLACK",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 90.7,
      "Midsize": 90.7,
      "Jumbo/Oversize": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 136.18,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 80.92,
    "kit_price_min": 136.18,
    "url": "https://www.grips4less.com/products/lamkin-sonar-black-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-sonar-black_d3a98e47-7476-4003-bf82-babbef970ee4.jpg?v=1735455707",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 7,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-sonar-black-standard-grip-grip-bundle-set",
        "handle": "lamkin-sonar-black-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954261053",
            "gid": "gid://shopify/ProductVariant/41021954261053",
            "sku": "SET-9xLG-101951",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-standard-grip-grip-bundle-set?variant=41021954261053"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-sonar-black-midsize-grip-grip-bundle-set",
        "handle": "lamkin-sonar-black-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953048637",
            "gid": "gid://shopify/ProductVariant/41021953048637",
            "sku": "SET-9xLG-101952",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-midsize-grip-grip-bundle-set?variant=41021953048637"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-sonar-black-oversize-grip-grip-bundle-set",
        "handle": "lamkin-sonar-black-oversize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021953015869",
            "gid": "gid://shopify/ProductVariant/41021953015869",
            "sku": "SET-9xLG-101953",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-oversize-grip-grip-bundle-set?variant=41021953015869"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-sonar-black-oversize-grip",
        "handle": "lamkin-sonar-black-oversize-grip",
        "shopify_variants": [
          {
            "id": "40683355308093",
            "gid": "gid://shopify/ProductVariant/40683355308093",
            "sku": "LG-101953",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-oversize-grip?variant=40683355308093"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-sonar-black-midsize-grip",
        "handle": "lamkin-sonar-black-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683355340861",
            "gid": "gid://shopify/ProductVariant/40683355340861",
            "sku": "LG-101952",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-midsize-grip?variant=40683355340861"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-sonar-black-13pcs-grips-golf-grip-kit",
        "handle": "lamkin-sonar-black-13pcs-grips-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard",
              "Midsize",
              "Oversize / Jumbo"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40472067113021",
            "gid": "gid://shopify/ProductVariant/40472067113021",
            "sku": "KIT+13xLG-101951",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-13pcs-grips-golf-grip-kit?variant=40472067113021"
          },
          {
            "id": "40472067145789",
            "gid": "gid://shopify/ProductVariant/40472067145789",
            "sku": "KIT(8oz)+13xLG-101951",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-13pcs-grips-golf-grip-kit?variant=40472067145789"
          },
          {
            "id": "40483640442941",
            "gid": "gid://shopify/ProductVariant/40483640442941",
            "sku": "KIT+13xLG-101952",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-13pcs-grips-golf-grip-kit?variant=40483640442941"
          },
          {
            "id": "40483640475709",
            "gid": "gid://shopify/ProductVariant/40483640475709",
            "sku": "KIT(8oz)+13xLG-101952",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-13pcs-grips-golf-grip-kit?variant=40483640475709"
          },
          {
            "id": "40483640508477",
            "gid": "gid://shopify/ProductVariant/40483640508477",
            "sku": "KIT+13xLG-101953",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-13pcs-grips-golf-grip-kit?variant=40483640508477"
          },
          {
            "id": "40483640541245",
            "gid": "gid://shopify/ProductVariant/40483640541245",
            "sku": "KIT(8oz)+13xLG-101953",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-13pcs-grips-golf-grip-kit?variant=40483640541245"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-sonar-black-standard-grip",
        "handle": "lamkin-sonar-black-standard-grip",
        "shopify_variants": [
          {
            "id": "40683355373629",
            "gid": "gid://shopify/ProductVariant/40683355373629",
            "sku": "LG-101951",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-black-standard-grip?variant=40683355373629"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Sonar, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium soft, mem25, Minimal Taper, new-bundle-set, non-tapered-and-less-tapered-swing-grips, reduced taper, single-golf-grips, single-grip, soft, sonar, So",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar-grip-rose-gold",
    "brand": "Lamkin",
    "model": "Sonar+ Grip (Rose Gold)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Undersize": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 15,
    "price_max": 15,
    "single_price_min": 15,
    "single_price_max": 15,
    "normalized_price_per_grip": 15,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-sonar-undersize-rose-gold.jpg?v=1571438540",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 15,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip",
        "handle": "lamkin-sonar-undersize-grip",
        "shopify_variants": [
          {
            "id": "40683357438013",
            "gid": "gid://shopify/ProductVariant/40683357438013",
            "sku": "LG-101901",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 15,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip?variant=40683357438013"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, asbl-grip-option, gifts-for-her, golf-grips, iron/wood, lamkin, Lamkin Sonar, lamkin sonar bogo, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium soft, Minimal Taper, non-tapered-and-less-tapered-swing-grips, reduced taper, single-golf-grips, single-grip, soft, s",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar-grips-rose-gold",
    "brand": "Lamkin",
    "model": "Sonar+ Grips (Rose Gold)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Undersize": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 128.25,
    "price_max": 128.25,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 14.25,
    "bundle_price_min": 128.25,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-sonar-undersize-rose-gold_d358040d-54d4-405b-a8cb-c18803ecefa4.jpg?v=1735455649",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 128.25,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip-grip-bundle-set",
        "handle": "lamkin-sonar-undersize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021964681277",
            "gid": "gid://shopify/ProductVariant/41021964681277",
            "sku": "SET-9xLG-101901",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 128.25,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-undersize-grip-grip-bundle-set?variant=41021964681277"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, gifts-for-her, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Sonar, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium soft, mem25, Minimal Taper, new-bundle-set, non-tapered-and-less-tapered-swing-grips, prime-2025, reduced taper, single-golf-grips, s",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar-hero",
    "brand": "Lamkin",
    "model": "Sonar+ Hero",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [
      "Navy Blue (with Red Accents)"
    ],
    "weight_g_by_size": {
      "Standard": 90.7,
      "Midsize": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 80.92,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 80.92,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sonar-hero-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Lamkin_Sonar_Hero_-Address-1600.jpg?v=1735455732",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Navy Blue (with Red Accents)"
        ],
        "price": 80.92,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-sonar-hero-standard-grip-grip-bundle-set",
        "handle": "lamkin-sonar-hero-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952229437",
            "gid": "gid://shopify/ProductVariant/41021952229437",
            "sku": "SET-9xLG-101955",
            "color": "Navy Blue (with Red Accents)",
            "size": "Standard",
            "selected_options": {
              "Color": "Navy Blue (with Red Accents)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-hero-standard-grip-grip-bundle-set?variant=41021952229437"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy Blue (with Red Accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Navy Blue (with Red Accents)"
        ],
        "price": 80.92,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/lamkin-sonar-hero-midsize-grip-grip-bundle-set",
        "handle": "lamkin-sonar-hero-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021952196669",
            "gid": "gid://shopify/ProductVariant/41021952196669",
            "sku": "SET-9xLG-101958",
            "color": "Navy Blue (with Red Accents)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Navy Blue (with Red Accents)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-hero-midsize-grip-grip-bundle-set?variant=41021952196669"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy Blue (with Red Accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Navy Blue (with Red Accents)"
        ],
        "price": 9.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-sonar-hero-midsize-grip",
        "handle": "lamkin-sonar-hero-midsize-grip",
        "shopify_variants": [
          {
            "id": "40999834714173",
            "gid": "gid://shopify/ProductVariant/40999834714173",
            "sku": "LG-101958",
            "color": "Navy Blue (with Red Accents)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Navy Blue (with Red Accents)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-hero-midsize-grip?variant=40999834714173"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy Blue (with Red Accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Navy Blue (with Red Accents)"
        ],
        "price": 9.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-sonar-hero-standard-grip",
        "handle": "lamkin-sonar-hero-standard-grip",
        "shopify_variants": [
          {
            "id": "40999811743805",
            "gid": "gid://shopify/ProductVariant/40999811743805",
            "sku": "LG-101955",
            "color": "Navy Blue (with Red Accents)",
            "size": "Standard",
            "selected_options": {
              "Color": "Navy Blue (with Red Accents)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-hero-standard-grip?variant=40999811743805"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy Blue (with Red Accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2024 new products, All Products, asbl-grip-option, best-sellers, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Sonar, lamkin sonar hero, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium soft, mem25, Minimal Taper, new-bundle-set, non-tapered-and-less-tapered-swing-grips, prime-2025",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar-wrap",
    "brand": "Lamkin",
    "model": "Sonar+ WRAP",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 49.9,
      "Midsize": 49.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 136.18,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 80.92,
    "kit_price_min": 136.18,
    "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-sonar-wrap-closeup_2c636a1a-b4e8-4f73-b333-6a3fa3663420.jpg?v=1735455655",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-standard-grip-grip-bundle-set",
        "handle": "lamkin-sonar-wrap-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021964058685",
            "gid": "gid://shopify/ProductVariant/41021964058685",
            "sku": "SET-9xLG-101914",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-standard-grip-grip-bundle-set?variant=41021964058685"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-midsize-grip-grip-bundle-set",
        "handle": "lamkin-sonar-wrap-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021963894845",
            "gid": "gid://shopify/ProductVariant/41021963894845",
            "sku": "SET-9xLG-101915",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-midsize-grip-grip-bundle-set?variant=41021963894845"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-sonar-wrap-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356291133",
            "gid": "gid://shopify/ProductVariant/40683356291133",
            "sku": "KIT+13xLG-101914",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-standard-grip-13pcs-golf-grip-kit?variant=40683356291133"
          },
          {
            "id": "40683356323901",
            "gid": "gid://shopify/ProductVariant/40683356323901",
            "sku": "KIT(8oz)+13xLG-101914",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-standard-grip-13pcs-golf-grip-kit?variant=40683356323901"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-midsize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-sonar-wrap-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683356454973",
            "gid": "gid://shopify/ProductVariant/40683356454973",
            "sku": "KIT+13xLG-101915",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-midsize-grip-13pcs-golf-grip-kit?variant=40683356454973"
          },
          {
            "id": "40683356487741",
            "gid": "gid://shopify/ProductVariant/40683356487741",
            "sku": "KIT(8oz)+13xLG-101915",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-midsize-grip-13pcs-golf-grip-kit?variant=40683356487741"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-midsize-grip",
        "handle": "lamkin-sonar-wrap-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683357208637",
            "gid": "gid://shopify/ProductVariant/40683357208637",
            "sku": "LG-101915",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-midsize-grip?variant=40683357208637"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-standard-grip",
        "handle": "lamkin-sonar-wrap-standard-grip",
        "shopify_variants": [
          {
            "id": "40683357372477",
            "gid": "gid://shopify/ProductVariant/40683357372477",
            "sku": "LG-101914",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-standard-grip?variant=40683357372477"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Sonar, lamkin wrap, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium soft, mem25, Minimal Taper, new-bundle-set, non-tapered-and-less-tapered-swing-grips, reduced taper, single-golf-grips, single-grip, soft, sonar, Sonar (",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sonar-wrap-with-calibrate",
    "brand": "Lamkin",
    "model": "Sonar+ Wrap with CALIBRATE",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "CALIBRATE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "Calibrate",
    "alignment_description": "Raised ridge along the underside marketed as a hand-placement reference. Lamkin is a discontinued brand at Grips4Less -- not eligible for live quiz recommendations regardless of this field.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 49.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 136.18,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 80.92,
    "kit_price_min": 136.18,
    "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-with-calibrate-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-sonar-wrap-calibrate-front-back_4d70080e-6cd2-4bda-98dc-1045488faa20.jpg?v=1735455682",
    "fit_tags": [
      "alignment_aid",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 49.9,
        "total_g": 449.0564463,
        "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-with-calibrate-standard-grip-grip-bundle-set",
        "handle": "lamkin-sonar-wrap-with-calibrate-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960945725",
            "gid": "gid://shopify/ProductVariant/41021960945725",
            "sku": "SET-9xLG-101925",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 449.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-with-calibrate-standard-grip-grip-bundle-set?variant=41021960945725"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-with-calibrate-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-sonar-wrap-with-calibrate-standard-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "40683356651581",
            "gid": "gid://shopify/ProductVariant/40683356651581",
            "sku": "KIT+13xLG-101925",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-with-calibrate-standard-grip-13pcs-golf-grip-kit?variant=40683356651581"
          },
          {
            "id": "40683356684349",
            "gid": "gid://shopify/ProductVariant/40683356684349",
            "sku": "KIT(8oz)+13xLG-101925",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 141.22,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-with-calibrate-standard-grip-13pcs-golf-grip-kit?variant=40683356684349"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-with-calibrate-standard-grip",
        "handle": "lamkin-sonar-wrap-with-calibrate-standard-grip",
        "shopify_variants": [
          {
            "id": "40683357110333",
            "gid": "gid://shopify/ProductVariant/40683357110333",
            "sku": "LG-101925",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sonar-wrap-with-calibrate-standard-grip?variant=40683357110333"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "Alignment golf grip, alignment-golf-grips, All Products, firm, golf-grips, grip bundle, iron/wood, lamkin, Lamkin R.E.L., Lamkin Sonar, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium firm, Minimal Taper, new-bundle-set, non-tapered-and-less-tapered-swing-grips, reduced taper, reminder",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-ts1",
    "brand": "Lamkin",
    "model": "TS1",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black / Red"
    ],
    "weight_g_by_size": {
      "Standard": 71.9,
      "Midsize": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 10.99,
    "price_max": 156.35,
    "single_price_min": 10.99,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 10.99,
    "bundle_price_min": null,
    "kit_price_min": 156.35,
    "url": "https://www.grips4less.com/products/lamkin-ts1-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-ts1-kit.jpg?v=1736027120",
    "fit_tags": [],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 156.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-ts1-13pcs-grips-golf-grip-kit",
        "handle": "lamkin-ts1-13pcs-grips-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard",
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13277591633981",
            "gid": "gid://shopify/ProductVariant/13277591633981",
            "sku": "KIT+13xLG-101905",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard"
            },
            "available": false,
            "price": 156.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-ts1-13pcs-grips-golf-grip-kit?variant=13277591633981"
          },
          {
            "id": "13277619781693",
            "gid": "gid://shopify/ProductVariant/13277619781693",
            "sku": "KIT+13xLG-101906",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Size": "Midsize"
            },
            "available": false,
            "price": 162.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-ts1-13pcs-grips-golf-grip-kit?variant=13277619781693"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black / Red"
        ],
        "price": 11.49,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-ts1-midsize-grip",
        "handle": "lamkin-ts1-midsize-grip",
        "shopify_variants": [
          {
            "id": "7145132916797",
            "gid": "gid://shopify/ProductVariant/7145132916797",
            "sku": "LG-101906",
            "color": "Black / Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-ts1-midsize-grip?variant=7145132916797"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black / Red"
        ],
        "price": 10.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/lamkin-ts1-standard-grip",
        "handle": "lamkin-ts1-standard-grip",
        "shopify_variants": [
          {
            "id": "7145132851261",
            "gid": "gid://shopify/ProductVariant/7145132851261",
            "sku": "LG-101905",
            "color": "Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-ts1-standard-grip?variant=7145132851261"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "150-200, 2021-endofyear, 2021-nysale, 2022-newyear, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip set, iron/wood, labor-day-bundle-sale-2025, labor-day-bundle-sale-2025-v2, lamkin, Lamkin ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-taylormade-lamkin-crossline-360-genesis-full-cord",
    "brand": "Lamkin",
    "model": "TaylorMade Lamkin Crossline 360 Genesis Full-Cord",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "full cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [
      "Black/White/Burgundy",
      "Cord Standard Grip"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 10.99,
    "price_max": 89.02,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 9.89,
    "bundle_price_min": 89.02,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/taylormade-lamkin-crossline-360-genesis-full-cord-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-tm-crossline-fc-grip.jpg?v=1735455698",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black/White/Burgundy"
        ],
        "price": 89.02,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/taylormade-lamkin-crossline-360-genesis-full-cord-standard-grip-grip-bundle-set",
        "handle": "taylormade-lamkin-crossline-360-genesis-full-cord-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021957374013",
            "gid": "gid://shopify/ProductVariant/41021957374013",
            "sku": "SET-9xLG-101387",
            "color": "Black/White/Burgundy",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/White/Burgundy",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/taylormade-lamkin-crossline-360-genesis-full-cord-standard-grip-grip-bundle-set?variant=41021957374013"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White/Burgundy"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black/White/Burgundy",
          "Cord Standard Grip"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/taylormade-lamkin-crossline-360-genesis-full-cord-standard-grip",
        "handle": "taylormade-lamkin-crossline-360-genesis-full-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "39335821770813",
            "gid": "gid://shopify/ProductVariant/39335821770813",
            "sku": "LG-101387",
            "color": "Black/White/Burgundy",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/White/Burgundy",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/taylormade-lamkin-crossline-360-genesis-full-cord-standard-grip?variant=39335821770813"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White/Burgundy"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, All Products, all-weather, cord, cord-golf-grips, crossline, Crossline 360, crossline full-cord, full cord, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Crossline Full-Cord, medium firm, new-bundle-set, single-golf-grips, single-grip, standard, standard-size-golf",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-training",
    "brand": "Lamkin",
    "model": "Training",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Undersize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 10.99,
    "price_max": 89.02,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 9.89,
    "bundle_price_min": 89.02,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-mens-left-handed-training-grip-580",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Lamkin_MENS_LEFT_HANDED_TRAINING_GRIP_580_5a3c74e4-47ce-4fb2-8e5a-dced645ddaa9.jpg?v=1735455582",
    "fit_tags": [],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 89.02,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-mens-left-handed-training-grip-580-grip-bundle-set",
        "handle": "lamkin-mens-left-handed-training-grip-580-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Hand",
            "values": [
              "For Right Handed Players",
              "For Left Handed Players"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021976674365",
            "gid": "gid://shopify/ProductVariant/41021976674365",
            "sku": "SET-9x150",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Right Handed Players",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-mens-left-handed-training-grip-580-grip-bundle-set?variant=41021976674365"
          },
          {
            "id": "41021976707133",
            "gid": "gid://shopify/ProductVariant/41021976707133",
            "sku": "SET-9x151",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Left Handed Players",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-mens-left-handed-training-grip-580-grip-bundle-set?variant=41021976707133"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 89.02,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-ladys-training-grip-grip-bundle-set",
        "handle": "lamkin-ladys-training-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021973364797",
            "gid": "gid://shopify/ProductVariant/41021973364797",
            "sku": "SET-9x152",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-ladys-training-grip-grip-bundle-set?variant=41021973364797"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-mens-left-handed-training-grip-580",
        "handle": "lamkin-mens-left-handed-training-grip-580",
        "shopify_options": [
          {
            "name": "Hand",
            "values": [
              "For Right Handed Players",
              "For Left Handed Players"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683358781501",
            "gid": "gid://shopify/ProductVariant/40683358781501",
            "sku": "150",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Right Handed Players",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-mens-left-handed-training-grip-580?variant=40683358781501"
          },
          {
            "id": "40683358814269",
            "gid": "gid://shopify/ProductVariant/40683358814269",
            "sku": "151",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Left Handed Players",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-mens-left-handed-training-grip-580?variant=40683358814269"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, golf-grips, grip bundle, lamkin, Lamkin Training, mem25, new-bundle-set, prime-2025, single-golf-grips, single-grip, training, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-ut",
    "brand": "Lamkin",
    "model": "UT",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black / Red cap"
    ],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 10.99,
    "price_max": 148.53,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 10.99,
    "bundle_price_min": null,
    "kit_price_min": 148.53,
    "url": "https://www.grips4less.com/products/lamkin-ut-plus-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Lamkin-UT_-13pc-gripkit.jpg?v=1736026673",
    "fit_tags": [],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Red cap"
        ],
        "price": 148.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-ut-plus-midsize-grip-black",
        "handle": "grip-kit-13x-lamkin-ut-plus-midsize-grip-black",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41136896868413",
            "gid": "gid://shopify/ProductVariant/41136896868413",
            "sku": "KIT+13xLG-101244",
            "color": "Black / Red cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Red cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-ut-plus-midsize-grip-black?variant=41136896868413"
          },
          {
            "id": "41136896901181",
            "gid": "gid://shopify/ProductVariant/41136896901181",
            "sku": "KIT(8oz)+13xLG-101244",
            "color": "Black / Red cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Red cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 153.57,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-ut-plus-midsize-grip-black?variant=41136896901181"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Red cap"
        ],
        "price": 148.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-ut-plus-standard-grip-black",
        "handle": "grip-kit-13x-lamkin-ut-plus-standard-grip-black",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41136896802877",
            "gid": "gid://shopify/ProductVariant/41136896802877",
            "sku": "KIT+13xLG-101243",
            "color": "Black / Red cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-ut-plus-standard-grip-black?variant=41136896802877"
          },
          {
            "id": "41136896835645",
            "gid": "gid://shopify/ProductVariant/41136896835645",
            "sku": "KIT(8oz)+13xLG-101243",
            "color": "Black / Red cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 153.57,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-ut-plus-standard-grip-black?variant=41136896835645"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black / Red cap"
        ],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/lamkin-ut-plus-midsize-grip",
        "handle": "lamkin-ut-plus-midsize-grip",
        "shopify_variants": [
          {
            "id": "41136896770109",
            "gid": "gid://shopify/ProductVariant/41136896770109",
            "sku": "LG-101244",
            "color": "Black / Red cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Red cap",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-ut-plus-midsize-grip?variant=41136896770109"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black / Red cap"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-ut-plus-standard-grip-black",
        "handle": "lamkin-ut-plus-standard-grip-black",
        "shopify_variants": [
          {
            "id": "41136896737341",
            "gid": "gid://shopify/ProductVariant/41136896737341",
            "sku": "LG-101243",
            "color": "Black / Red cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-ut-plus-standard-grip-black?variant=41136896737341"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2024 new products, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripkit-shaftbundle-sale, iron/wood, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-utx-full-cord",
    "brand": "Lamkin",
    "model": "UTX+ Full Cord",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid cord (ACE 3GEN)",
    "texture": "corded hybrid",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Charcoal Grey / Blue cap"
    ],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 10.99,
    "price_max": 148.53,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 10.99,
    "bundle_price_min": null,
    "kit_price_min": 148.53,
    "url": "https://www.grips4less.com/products/lamkin-utx-plus-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/lamkin-utx-13pc-grip-kit.jpg?v=1736026675",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Charcoal Grey / Blue cap"
        ],
        "price": 148.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-plus-cord-midsize-grip-charcoal",
        "handle": "grip-kit-13x-lamkin-utx-plus-cord-midsize-grip-charcoal",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Charcoal Grey / Blue cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41136896671805",
            "gid": "gid://shopify/ProductVariant/41136896671805",
            "sku": "KIT+13xLG-101246",
            "color": "Charcoal Grey / Blue cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Charcoal Grey / Blue cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-plus-cord-midsize-grip-charcoal?variant=41136896671805"
          },
          {
            "id": "41136896704573",
            "gid": "gid://shopify/ProductVariant/41136896704573",
            "sku": "KIT(8oz)+13xLG-101246",
            "color": "Charcoal Grey / Blue cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Charcoal Grey / Blue cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 153.57,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-plus-cord-midsize-grip-charcoal?variant=41136896704573"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Charcoal Grey / Blue cap"
        ],
        "price": 148.53,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-plus-cord-standard-grip-charcoal",
        "handle": "grip-kit-13x-lamkin-utx-plus-cord-standard-grip-charcoal",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Charcoal Grey / Blue cap"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41136896606269",
            "gid": "gid://shopify/ProductVariant/41136896606269",
            "sku": "KIT+13xLG-101245",
            "color": "Charcoal Grey / Blue cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Charcoal Grey / Blue cap",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-plus-cord-standard-grip-charcoal?variant=41136896606269"
          },
          {
            "id": "41136896639037",
            "gid": "gid://shopify/ProductVariant/41136896639037",
            "sku": "KIT(8oz)+13xLG-101245",
            "color": "Charcoal Grey / Blue cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Charcoal Grey / Blue cap",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 153.57,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-plus-cord-standard-grip-charcoal?variant=41136896639037"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Charcoal Grey / Blue cap"
        ],
        "price": 10.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/lamkin-utx-plus-midsize-grip",
        "handle": "lamkin-utx-plus-midsize-grip",
        "shopify_variants": [
          {
            "id": "41136896573501",
            "gid": "gid://shopify/ProductVariant/41136896573501",
            "sku": "LG-101246",
            "color": "Charcoal Grey / Blue cap",
            "size": "Midsize",
            "selected_options": {
              "Color": "Charcoal Grey / Blue cap",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-utx-plus-midsize-grip?variant=41136896573501"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Charcoal Grey / Blue cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Charcoal Grey / Blue cap"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-utx-plus-standard-grip-black",
        "handle": "lamkin-utx-plus-standard-grip-black",
        "shopify_variants": [
          {
            "id": "41136896540733",
            "gid": "gid://shopify/ProductVariant/41136896540733",
            "sku": "LG-101245",
            "color": "Charcoal Grey / Blue cap",
            "size": "Standard",
            "selected_options": {
              "Color": "Charcoal Grey / Blue cap",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-utx-plus-standard-grip-black?variant=41136896540733"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Charcoal Grey / Blue cap"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2024 new products, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, all-weather, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, cord, cord-golf-grips, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, iron/wood, lab",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-utx-cord",
    "brand": "Lamkin",
    "model": "UTx Cord",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid cord (ACE 3GEN)",
    "texture": "corded hybrid",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "style_forward",
    "non_black_color_count": 6,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Green / Yellow",
      "Green/Yellow",
      "Solid Blue",
      "Solid Gray",
      "Solid Grey",
      "Solid Red"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 45.4
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 6.99,
    "price_max": 142.36,
    "single_price_min": 6.99,
    "single_price_max": 10.49,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": 84.97,
    "kit_price_min": 110.85,
    "url": "https://www.grips4less.com/products/lamkin-limited-edition-utx-cord-standard-grip-green-yellow",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-utx-cord-3colors_68db2728-817c-4388-a0f0-8980ad305e3f.jpg?v=1735455607",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 11,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Solid Gray"
        ],
        "price": 84.97,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/lamkin-utx-standard-grip-black-grip-bundle-set",
        "handle": "lamkin-utx-standard-grip-black-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Gray",
              "Blue",
              "Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021971071037",
            "gid": "gid://shopify/ProductVariant/41021971071037",
            "sku": "SET-9xLG-101234",
            "color": "Solid Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Solid Gray",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 84.97,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-standard-grip-black-grip-bundle-set?variant=41021971071037"
          },
          {
            "id": "41021971103805",
            "gid": "gid://shopify/ProductVariant/41021971103805",
            "sku": "SET-9xLG-101239",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 84.97,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-standard-grip-black-grip-bundle-set?variant=41021971103805"
          },
          {
            "id": "41021971136573",
            "gid": "gid://shopify/ProductVariant/41021971136573",
            "sku": "SET-9xLG-101237",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 84.97,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-standard-grip-black-grip-bundle-set?variant=41021971136573"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Solid Gray"
        ],
        "price": 84.97,
        "per_grip_g": 45.4,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/lamkin-utx-midsize-grip-grip-bundle-set",
        "handle": "lamkin-utx-midsize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Gray",
              "Blue",
              "Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021970743357",
            "gid": "gid://shopify/ProductVariant/41021970743357",
            "sku": "SET-9xLG-101235",
            "color": "Solid Gray",
            "size": "Midsize",
            "selected_options": {
              "Color": "Solid Gray",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 84.97,
            "weight_g": 408.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-midsize-grip-grip-bundle-set?variant=41021970743357"
          },
          {
            "id": "41021970776125",
            "gid": "gid://shopify/ProductVariant/41021970776125",
            "sku": "SET-9xLG-101240",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 84.97,
            "weight_g": 408.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-midsize-grip-grip-bundle-set?variant=41021970776125"
          },
          {
            "id": "41021970808893",
            "gid": "gid://shopify/ProductVariant/41021970808893",
            "sku": "SET-9xLG-101238",
            "color": "Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 84.97,
            "weight_g": 408.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-midsize-grip-grip-bundle-set?variant=41021970808893"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Solid Red"
        ],
        "price": 117.35,
        "per_grip_g": 59.3,
        "total_g": 771.107029,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-solid-red",
        "handle": "grip-kit-13x-lamkin-utx-cord-midsize-grip-solid-red",
        "shopify_variants": [
          {
            "id": "37486392455",
            "gid": "gid://shopify/ProductVariant/37486392455",
            "sku": "KIT+13x101225",
            "color": "Solid Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Solid Red"
            },
            "available": false,
            "price": 117.35,
            "weight_g": 771.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-solid-red?variant=37486392455"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Solid Blue"
        ],
        "price": 117.35,
        "per_grip_g": 59.3,
        "total_g": 771.107029,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-solid-blue",
        "handle": "grip-kit-13x-lamkin-utx-cord-midsize-grip-solid-blue",
        "shopify_variants": [
          {
            "id": "37486341383",
            "gid": "gid://shopify/ProductVariant/37486341383",
            "sku": "KIT+13x101226",
            "color": "Solid Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Solid Blue"
            },
            "available": false,
            "price": 117.35,
            "weight_g": 771.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-solid-blue?variant=37486341383"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Solid Grey"
        ],
        "price": 142.36,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-black",
        "handle": "grip-kit-13x-lamkin-utx-cord-midsize-grip-black",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Grey",
              "Blue",
              "Green"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683357732925",
            "gid": "gid://shopify/ProductVariant/40683357732925",
            "sku": "KIT+13xLG-101235",
            "color": "Solid Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Solid Grey",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 142.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-black?variant=40683357732925"
          },
          {
            "id": "40683357765693",
            "gid": "gid://shopify/ProductVariant/40683357765693",
            "sku": "KIT(8oz)+13xLG-101235",
            "color": "Solid Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Solid Grey",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 147.39,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-black?variant=40683357765693"
          },
          {
            "id": "40683357798461",
            "gid": "gid://shopify/ProductVariant/40683357798461",
            "sku": "KIT+13xLG-101240",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 142.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-black?variant=40683357798461"
          },
          {
            "id": "40683357831229",
            "gid": "gid://shopify/ProductVariant/40683357831229",
            "sku": "KIT(8oz)+13xLG-101240",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 147.39,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-black?variant=40683357831229"
          },
          {
            "id": "40683357863997",
            "gid": "gid://shopify/ProductVariant/40683357863997",
            "sku": "KIT+13xLG-101238",
            "color": "Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 142.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-black?variant=40683357863997"
          },
          {
            "id": "40683357896765",
            "gid": "gid://shopify/ProductVariant/40683357896765",
            "sku": "KIT(8oz)+13xLG-101238",
            "color": "Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 147.39,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-midsize-grip-black?variant=40683357896765"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Solid Red"
        ],
        "price": 110.85,
        "per_grip_g": 59.3,
        "total_g": 771.107029,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-solid-red",
        "handle": "grip-kit-13x-lamkin-utx-cord-standard-grip-solid-red",
        "shopify_variants": [
          {
            "id": "37486210759",
            "gid": "gid://shopify/ProductVariant/37486210759",
            "sku": "KIT+13x101223",
            "color": "Solid Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Solid Red"
            },
            "available": false,
            "price": 110.85,
            "weight_g": 771.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-solid-red?variant=37486210759"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Solid Blue"
        ],
        "price": 110.85,
        "per_grip_g": 59.3,
        "total_g": 771.107029,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-solid-blue",
        "handle": "grip-kit-13x-lamkin-utx-cord-standard-grip-solid-blue",
        "shopify_variants": [
          {
            "id": "37486166023",
            "gid": "gid://shopify/ProductVariant/37486166023",
            "sku": "KIT+13x101224",
            "color": "Solid Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Solid Blue"
            },
            "available": false,
            "price": 110.85,
            "weight_g": 771.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-solid-blue?variant=37486166023"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Solid Grey"
        ],
        "price": 142.36,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-black",
        "handle": "grip-kit-13x-lamkin-utx-cord-standard-grip-black",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Grey",
              "Blue",
              "Green"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683359240253",
            "gid": "gid://shopify/ProductVariant/40683359240253",
            "sku": "KIT+13xLG-101234",
            "color": "Solid Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Solid Grey",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 142.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-black?variant=40683359240253"
          },
          {
            "id": "40683359273021",
            "gid": "gid://shopify/ProductVariant/40683359273021",
            "sku": "KIT(8oz)+13xLG-101234",
            "color": "Solid Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Solid Grey",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 147.39,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-black?variant=40683359273021"
          },
          {
            "id": "40683359305789",
            "gid": "gid://shopify/ProductVariant/40683359305789",
            "sku": "KIT+13xLG-101239",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 142.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-black?variant=40683359305789"
          },
          {
            "id": "40683359338557",
            "gid": "gid://shopify/ProductVariant/40683359338557",
            "sku": "KIT(8oz)+13xLG-101239",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 147.39,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-black?variant=40683359338557"
          },
          {
            "id": "40683359371325",
            "gid": "gid://shopify/ProductVariant/40683359371325",
            "sku": "KIT+13xLG-101237",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 142.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-black?variant=40683359371325"
          },
          {
            "id": "40683359404093",
            "gid": "gid://shopify/ProductVariant/40683359404093",
            "sku": "KIT(8oz)+13xLG-101237",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 147.39,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-utx-cord-standard-grip-black?variant=40683359404093"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green / Yellow",
          "Green/Yellow"
        ],
        "price": 6.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-limited-edition-utx-cord-standard-grip-green-yellow",
        "handle": "lamkin-limited-edition-utx-cord-standard-grip-green-yellow",
        "shopify_variants": [
          {
            "id": "18947879431",
            "gid": "gid://shopify/ProductVariant/18947879431",
            "sku": "101231",
            "color": "Green / Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "Green / Yellow"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-limited-edition-utx-cord-standard-grip-green-yellow?variant=18947879431"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green / Yellow"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Solid Gray"
        ],
        "price": 10.49,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/lamkin-utx-midsize-grip",
        "handle": "lamkin-utx-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Gray",
              "Blue",
              "Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683358322749",
            "gid": "gid://shopify/ProductVariant/40683358322749",
            "sku": "LG-101235",
            "color": "Solid Gray",
            "size": "Midsize",
            "selected_options": {
              "Color": "Solid Gray"
            },
            "available": false,
            "price": 10.49,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-midsize-grip?variant=40683358322749"
          },
          {
            "id": "40683358355517",
            "gid": "gid://shopify/ProductVariant/40683358355517",
            "sku": "LG-101240",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 10.49,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-midsize-grip?variant=40683358355517"
          },
          {
            "id": "40683358388285",
            "gid": "gid://shopify/ProductVariant/40683358388285",
            "sku": "LG-101238",
            "color": "Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green"
            },
            "available": false,
            "price": 10.49,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-midsize-grip?variant=40683358388285"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Solid Gray"
        ],
        "price": 10.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-utx-standard-grip-black",
        "handle": "lamkin-utx-standard-grip-black",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Solid Gray",
              "Blue",
              "Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683358421053",
            "gid": "gid://shopify/ProductVariant/40683358421053",
            "sku": "LG-101234",
            "color": "Solid Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Solid Gray"
            },
            "available": false,
            "price": 10.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-standard-grip-black?variant=40683358421053"
          },
          {
            "id": "40683358453821",
            "gid": "gid://shopify/ProductVariant/40683358453821",
            "sku": "LG-101239",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 10.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-standard-grip-black?variant=40683358453821"
          },
          {
            "id": "40683358486589",
            "gid": "gid://shopify/ProductVariant/40683358486589",
            "sku": "LG-101237",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green"
            },
            "available": false,
            "price": 10.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-utx-standard-grip-black?variant=40683358486589"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, all-weather, best-sellers, cord, cord-golf-grips, golf-grips, grip bundle, iron/wood, lamkin, Lamkin Utx Cord, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium firm, mem25, New for 2014, new-bundle-set, prime-2025, single-golf-grips, single-grip, standard, standard-size-go",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Green / Yellow"
    ]
  },
  {
    "id": "lamkin-utx-wrap",
    "brand": "Lamkin",
    "model": "UTx Wrap",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "hybrid (ACE 3GEN rubber)",
    "texture": "fingerprint texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Midsize": 64,
      "Standard": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.99,
    "price_max": 7.49,
    "single_price_min": 6.99,
    "single_price_max": 7.49,
    "normalized_price_per_grip": 6.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-lamkin-utx-wrap-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/utx-wrap-all-colors_3479aafa-70d3-40b8-b51a-7a8f1357619b.jpg?v=1636053769",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 7.49,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/new-lamkin-utx-wrap-midsize-grip",
        "handle": "new-lamkin-utx-wrap-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1027605589",
            "gid": "gid://shopify/ProductVariant/1027605589",
            "sku": "101216",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 7.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-lamkin-utx-wrap-midsize-grip?variant=1027605589"
          },
          {
            "id": "1027605593",
            "gid": "gid://shopify/ProductVariant/1027605593",
            "sku": "101217",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 7.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-lamkin-utx-wrap-midsize-grip?variant=1027605593"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/new-lamkin-utx-wrap-standard-grip",
        "handle": "new-lamkin-utx-wrap-standard-grip",
        "shopify_variants": [
          {
            "id": "1027602213",
            "gid": "gid://shopify/ProductVariant/1027602213",
            "sku": "101213",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-lamkin-utx-wrap-standard-grip?variant=1027602213"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, 58 core, All products, Brand_Lamkin, iron/wood, lamkin, medium firm, midsize, midsize-golf-grips, New for 2015, single-golf-grips, single-grip, Size_Midsize, Style_Swing Grip, tacky, under-150, UTx, video=qdQ9GkfeAX8",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Blue"
    ]
  },
  {
    "id": "lamkin-wrap-tech",
    "brand": "Lamkin",
    "model": "Wrap-Tech",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "style_forward",
    "non_black_color_count": 4,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black with White Stripe",
      "Tech Midsize Grip",
      "Tech Oversize Grip",
      "Tech Standard Grip",
      "White"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 71.9,
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 4.99,
    "price_max": 91.35,
    "single_price_min": 4.99,
    "single_price_max": 5.99,
    "normalized_price_per_grip": 4.99,
    "bundle_price_min": null,
    "kit_price_min": 78.35,
    "url": "https://www.grips4less.com/products/lamkin-wrap-tech-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/wrap-tech-kits-white-stripe_d2043269-5fca-4845-b2ad-49ec4987611b.jpg?v=1736027166",
    "fit_tags": [
      "best_for_arthritis",
      "soft_feel"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black with White Stripe"
        ],
        "price": 91.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-wrap-tech-oversize-grip",
        "handle": "grip-kit-13x-lamkin-wrap-tech-oversize-grip",
        "shopify_variants": [
          {
            "id": "40683186055",
            "gid": "gid://shopify/ProductVariant/40683186055",
            "sku": "KIT+13x101505",
            "color": "Black with White Stripe",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black with White Stripe"
            },
            "available": false,
            "price": 91.35,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-wrap-tech-oversize-grip?variant=40683186055"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black with White Stripe"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black with White Stripe"
        ],
        "price": 84.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-wrap-tech-midsize-grip",
        "handle": "grip-kit-13x-lamkin-wrap-tech-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683124039",
            "gid": "gid://shopify/ProductVariant/40683124039",
            "sku": "KIT+13x101504",
            "color": "Black with White Stripe",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black with White Stripe"
            },
            "available": false,
            "price": 84.85,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-wrap-tech-midsize-grip?variant=40683124039"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black with White Stripe"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black with White Stripe"
        ],
        "price": 78.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-wrap-tech-standard-grip",
        "handle": "grip-kit-13x-lamkin-wrap-tech-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black with White Stripe",
              "Black with Blue Stripe",
              "Black with Red Stripe"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40682963207",
            "gid": "gid://shopify/ProductVariant/40682963207",
            "sku": "KIT+13x101501",
            "color": "Black with White Stripe",
            "size": "Standard",
            "selected_options": {
              "Color": "Black with White Stripe"
            },
            "available": false,
            "price": 78.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-wrap-tech-standard-grip?variant=40682963207"
          },
          {
            "id": "40683021703",
            "gid": "gid://shopify/ProductVariant/40683021703",
            "sku": "KIT+13x101503",
            "color": "Black with Blue Stripe",
            "size": "Standard",
            "selected_options": {
              "Color": "Black with Blue Stripe"
            },
            "available": false,
            "price": 78.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-wrap-tech-standard-grip?variant=40683021703"
          },
          {
            "id": "40683011335",
            "gid": "gid://shopify/ProductVariant/40683011335",
            "sku": "KIT+13x101502",
            "color": "Black with Red Stripe",
            "size": "Standard",
            "selected_options": {
              "Color": "Black with Red Stripe"
            },
            "available": false,
            "price": 78.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-wrap-tech-standard-grip?variant=40683011335"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Tech Oversize Grip",
          "White"
        ],
        "price": 5.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-wrap-tech-oversize-grip",
        "handle": "lamkin-wrap-tech-oversize-grip",
        "shopify_variants": [
          {
            "id": "39461770035261",
            "gid": "gid://shopify/ProductVariant/39461770035261",
            "sku": "101505",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-wrap-tech-oversize-grip?variant=39461770035261"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Tech Midsize Grip",
          "White"
        ],
        "price": 5.49,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-wrap-tech-midsize-grip",
        "handle": "lamkin-wrap-tech-midsize-grip",
        "shopify_variants": [
          {
            "id": "39461770592317",
            "gid": "gid://shopify/ProductVariant/39461770592317",
            "sku": "101504",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 5.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-wrap-tech-midsize-grip?variant=39461770592317"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Tech Standard Grip",
          "White"
        ],
        "price": 4.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-wrap-tech-standard-grip",
        "handle": "lamkin-wrap-tech-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461770723389",
            "gid": "gid://shopify/ProductVariant/39461770723389",
            "sku": "101501",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 4.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-wrap-tech-standard-grip?variant=39461770723389"
          },
          {
            "id": "39461770756157",
            "gid": "gid://shopify/ProductVariant/39461770756157",
            "sku": "101503",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 4.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-wrap-tech-standard-grip?variant=39461770756157"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, iron/wood, jumbo/oversize, labor-day-bundle-sale-2025, labor-day-bundle-sale-2025-v2, lamkin, Lamkin W",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "White"
    ]
  },
  {
    "id": "lamkin-x10",
    "brand": "Lamkin",
    "model": "X10",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Default"
    ],
    "manufacturer_size_labels": [
      "Default"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Default": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 3.11,
    "price_max": 4.49,
    "single_price_min": 3.11,
    "single_price_max": 4.49,
    "normalized_price_per_grip": 3.11,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-x10-grip-oversize",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2015-logo-x10_5d48f71b-4034-41d7-b161-bd2e4b1e5b1e.jpg?v=1636055671",
    "fit_tags": [],
    "product_count": 5,
    "variants": [
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 3.89,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-x10-grip-oversize",
        "handle": "lamkin-x10-grip-oversize",
        "shopify_variants": [
          {
            "id": "39461784715325",
            "gid": "gid://shopify/ProductVariant/39461784715325",
            "sku": "101534",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 3.89,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-x10-grip-oversize?variant=39461784715325"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 3.11,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-x10-grip",
        "handle": "lamkin-x10-grip",
        "shopify_variants": [
          {
            "id": "39461784649789",
            "gid": "gid://shopify/ProductVariant/39461784649789",
            "sku": "101532",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 3.11,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-x10-grip?variant=39461784649789"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 3.45,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-x10-grip-junior",
        "handle": "lamkin-x10-grip-junior",
        "shopify_variants": [
          {
            "id": "397804285",
            "gid": "gid://shopify/ProductVariant/397804285",
            "sku": "101530",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 3.45,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-x10-grip-junior?variant=397804285"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 4.49,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-x10-grip-midsize",
        "handle": "lamkin-x10-grip-midsize",
        "shopify_variants": [
          {
            "id": "397804297",
            "gid": "gid://shopify/ProductVariant/397804297",
            "sku": "101533",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 4.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-x10-grip-midsize?variant=397804297"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 4.29,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-x10-grip-undersize",
        "handle": "lamkin-x10-grip-undersize",
        "shopify_variants": [
          {
            "id": "397804333",
            "gid": "gid://shopify/ProductVariant/397804333",
            "sku": "101531",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 4.29,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-x10-grip-undersize?variant=397804333"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Brand_Lamkin, iron/wood, jumbo/oversize, lamkin, medium firm, oversize, oversize-jumbo-golf-grips, single-golf-grips, single-grip, Size_Jumbo/Oversize, Style_Swing Grip, under-150, video=lfZMWwGetl4, X10",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-xxx-lamkin-st-2-hybrid-with-calibrate",
    "brand": "Lamkin",
    "model": "XXX Lamkin ST+2 Hybrid with CALIBRATE",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "calibrate texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "CALIBRATE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "Calibrate",
    "alignment_description": "Raised ridge along the underside marketed as a hand-placement reference. Lamkin is a discontinued brand at Grips4Less -- not eligible for live quiz recommendations regardless of this field.",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 49.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 11.99,
    "price_max": 11.99,
    "single_price_min": 11.99,
    "single_price_max": 11.99,
    "normalized_price_per_grip": 11.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkkn-st-plus2-hybrid-with-calibrate_9379bb8b-976b-4beb-960d-515146f41da2.jpg?v=1576790568",
    "fit_tags": [
      "alignment_aid",
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 11.99,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-midsize-grip",
        "handle": "lamkin-st-2-hybrid-with-calibrate-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683357012029",
            "gid": "gid://shopify/ProductVariant/40683357012029",
            "sku": "LG-101928",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip": "Midsize"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-st-2-hybrid-with-calibrate-midsize-grip?variant=40683357012029"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, Alignment golf grip, alignment-golf-grips, All Products, cord, firm, golf-grips, hybrid, hybrid-golf-grips, iron/wood, lamkin, Lamkin Calibrate, Lamkin ST Hybrid, Lamkin ST+2, lamkin-2023-spring-promo, lamkin-free-gift-offer-2023, medium firm, midsize, midsize-golf-grips, Minimal Taper, no",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-z5",
    "brand": "Lamkin",
    "model": "Z5",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "multi-texture (Tri-Layer)",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black",
      "Black / Grey",
      "Black / Grey (58R)",
      "Black/Gray",
      "Purple / Turquoise",
      "Red",
      "Ribbed"
    ],
    "weight_g_by_size": {
      "Standard": 71.9,
      "Midsize": 71.9,
      "Undersize": 91
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 7.99,
    "price_max": 123.95,
    "single_price_min": 7.99,
    "single_price_max": 8.49,
    "normalized_price_per_grip": 7.99,
    "bundle_price_min": null,
    "kit_price_min": 117.35,
    "url": "https://www.grips4less.com/products/lamkin-z5-standard-grip-ribbed",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-z5-blk-grey_4d1b3b06-7f17-4864-9adc-3f2e70e68459.jpg?v=1736026974",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 9,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Grey (58R)"
        ],
        "price": 117.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-z5-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-z5-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey (58R)",
              "Black / Grey / Standard+ (60R)"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007846821949",
            "gid": "gid://shopify/ProductVariant/32007846821949",
            "sku": "KIT+13xLG-101643",
            "color": "Black / Grey (58R)",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey (58R)"
            },
            "available": false,
            "price": 117.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-z5-standard-grip-13pcs-golf-grip-kit?variant=32007846821949"
          },
          {
            "id": "32007846854717",
            "gid": "gid://shopify/ProductVariant/32007846854717",
            "sku": "KIT+13xLG-101646",
            "color": "Black / Grey / Standard+ (60R)",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey / Standard+ (60R)"
            },
            "available": false,
            "price": 117.35,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-z5-standard-grip-13pcs-golf-grip-kit?variant=32007846854717"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black/Gray"
        ],
        "price": 123.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-z5-midsize-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-z5-midsize-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007846789181",
            "gid": "gid://shopify/ProductVariant/32007846789181",
            "sku": "KIT+13xLG-101645",
            "color": "Black/Gray",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black/Gray"
            },
            "available": false,
            "price": 123.85,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-z5-midsize-grip-13pcs-golf-grip-kit?variant=32007846789181"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/Gray"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Ribbed"
        ],
        "price": 7.99,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-z5-standard-grip-ribbed",
        "handle": "lamkin-z5-standard-grip-ribbed",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "44101467859",
            "gid": "gid://shopify/ProductVariant/44101467859",
            "sku": "101604",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-z5-standard-grip-ribbed?variant=44101467859"
          },
          {
            "id": "44101467923",
            "gid": "gid://shopify/ProductVariant/44101467923",
            "sku": "101605",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-z5-standard-grip-ribbed?variant=44101467923"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Purple / Turquoise"
        ],
        "price": 7.99,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-z5-undersize-grip",
        "handle": "lamkin-z5-undersize-grip",
        "shopify_variants": [
          {
            "id": "40303383111",
            "gid": "gid://shopify/ProductVariant/40303383111",
            "sku": "LG-101628",
            "color": "Purple / Turquoise",
            "size": "Undersize",
            "selected_options": {
              "Color": "Purple / Turquoise"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-z5-undersize-grip?variant=40303383111"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Purple / Turquoise"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Red"
        ],
        "price": 123.95,
        "per_grip_g": 59.3,
        "total_g": 771.107029,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-z5-midsize-grip-red",
        "handle": "grip-kit-13x-lamkin-z5-midsize-grip-red",
        "shopify_variants": [
          {
            "id": "37485687687",
            "gid": "gid://shopify/ProductVariant/37485687687",
            "sku": "KIT+13xLG-101612",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 123.95,
            "weight_g": 771.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-z5-midsize-grip-red?variant=37485687687"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 123.95,
        "per_grip_g": 59.3,
        "total_g": 771.107029,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-z5-midsize-grip-black",
        "handle": "grip-kit-13x-lamkin-z5-midsize-grip-black",
        "shopify_variants": [
          {
            "id": "37485557383",
            "gid": "gid://shopify/ProductVariant/37485557383",
            "sku": "KIT+13xLG-101610",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 123.95,
            "weight_g": 771.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-z5-midsize-grip-black?variant=37485557383"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Red"
        ],
        "price": 117.45,
        "per_grip_g": 59.3,
        "total_g": 771.107029,
        "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-z5-standard-grip-red",
        "handle": "grip-kit-13x-lamkin-z5-standard-grip-red",
        "shopify_variants": [
          {
            "id": "37485479239",
            "gid": "gid://shopify/ProductVariant/37485479239",
            "sku": "KIT+13xLG-101603",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 117.45,
            "weight_g": 771.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-lamkin-z5-standard-grip-red?variant=37485479239"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black / Grey"
        ],
        "price": 8.49,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-z5-midsize-grip",
        "handle": "lamkin-z5-midsize-grip",
        "shopify_variants": [
          {
            "id": "39461761876029",
            "gid": "gid://shopify/ProductVariant/39461761876029",
            "sku": "LG-101645",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-z5-midsize-grip?variant=39461761876029"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 7.99,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-z5-standard-grip",
        "handle": "lamkin-z5-standard-grip",
        "shopify_variants": [
          {
            "id": "39461761908797",
            "gid": "gid://shopify/ProductVariant/39461761908797",
            "sku": "LG-101602",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-z5-standard-grip?variant=39461761908797"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, hybrid, hybrid-golf-grips, iron/wood, KIT-added07282020, labor-day-bundle-sale-2025, labor-day-bundle-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Blue",
      "Purple / Turquoise"
    ]
  },
  {
    "id": "lamkin-z5-black",
    "brand": "Lamkin",
    "model": "Z5 BLACK",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "multi-texture (Tri-Layer)",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Z5 BLACK"
    ],
    "weight_g_by_size": {
      "Standard": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 5.99,
    "price_max": 5.99,
    "single_price_min": 5.99,
    "single_price_max": 5.99,
    "normalized_price_per_grip": 5.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-z5-black-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Z5-Blk-Std-front_723830fb-7f9e-44e7-886c-9bfe29bc45fb.jpg?v=1636059985",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Z5 BLACK"
        ],
        "price": 5.99,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-z5-black-standard-grip",
        "handle": "lamkin-z5-black-standard-grip",
        "shopify_variants": [
          {
            "id": "988393570323",
            "gid": "gid://shopify/ProductVariant/988393570323",
            "sku": "LG-101642",
            "color": "Z5 BLACK",
            "size": "Standard",
            "selected_options": {
              "Color": "Z5 BLACK"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-z5-black-standard-grip?variant=988393570323"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Z5 BLACK"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, 58 core, All products, Brand_Lamkin, iron/wood, lamkin, medium firm, Model_Lamkin Z5, Most Popular, Most Popular Golf Club Grips, New for 2016, rubber, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150, Z5 Black, Z5 Black (Coming",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-z5-plus",
    "brand": "Lamkin",
    "model": "Z5 PLUS",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (Genesis)",
    "texture": "multi-texture (Tri-Layer)",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black / Grey"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 8.99,
    "price_max": 130.35,
    "single_price_min": 8.99,
    "single_price_max": 8.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": null,
    "kit_price_min": 130.35,
    "url": "https://www.grips4less.com/products/lamkin-z5-tour-taper-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-z5-tourtaper-diag_6c174b6e-80a2-4b4e-8504-dbe69b83d5b3.jpg?v=1736026981",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Grey"
        ],
        "price": 130.35,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/lamkin-z5-tour-taper-standard-grip-13pcs-golf-grip-kit",
        "handle": "lamkin-z5-tour-taper-standard-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007845838909",
            "gid": "gid://shopify/ProductVariant/32007845838909",
            "sku": "KIT+13x101629",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 130.35,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-z5-tour-taper-standard-grip-13pcs-golf-grip-kit?variant=32007845838909"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black / Grey"
        ],
        "price": 8.99,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-z5-tour-taper-standard-grip",
        "handle": "lamkin-z5-tour-taper-standard-grip",
        "shopify_variants": [
          {
            "id": "43670632531",
            "gid": "gid://shopify/ProductVariant/43670632531",
            "sku": "101629",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-z5-tour-taper-standard-grip?variant=43670632531"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, hybrid, hybrid-golf-grips, iron/wood, KIT-added07282020, labor-day-bundle-sale-2025, labor-day-bundle-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-i-line",
    "brand": "Lamkin",
    "model": "i-Line",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "style_forward",
    "non_black_color_count": 6,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black",
      "Lime Green",
      "Line Midsize Grip",
      "Line Oversize Grip",
      "Line Putter Grip",
      "Line Standard Grip",
      "Line Undersize Grip"
    ],
    "weight_g_by_size": {
      "Standard": 91,
      "Undersize": 91,
      "Midsize": 91,
      "Jumbo/Oversize": 91,
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.23,
    "price_max": 9.35,
    "single_price_min": 6.23,
    "single_price_max": 9.35,
    "normalized_price_per_grip": 6.23,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-i-line-grip-black-std",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iline-allcolors_dff02ea7-798b-4b2d-b517-9fd245a54e89.jpg?v=1636055538",
    "fit_tags": [],
    "product_count": 7,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Line Standard Grip"
        ],
        "price": 7.59,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-i-line-grip-black-std",
        "handle": "lamkin-i-line-grip-black-std",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Navy Blue",
              "Lime Green",
              "Yellow",
              "Turquoise"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461785043005",
            "gid": "gid://shopify/ProductVariant/39461785043005",
            "sku": "100762",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 7.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-grip-black-std?variant=39461785043005"
          },
          {
            "id": "39461785075773",
            "gid": "gid://shopify/ProductVariant/39461785075773",
            "sku": "100764",
            "color": "Navy Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Navy Blue"
            },
            "available": true,
            "price": 7.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-grip-black-std?variant=39461785075773"
          },
          {
            "id": "39461785108541",
            "gid": "gid://shopify/ProductVariant/39461785108541",
            "sku": "100763",
            "color": "Lime Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Lime Green"
            },
            "available": true,
            "price": 7.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-grip-black-std?variant=39461785108541"
          },
          {
            "id": "39461785141309",
            "gid": "gid://shopify/ProductVariant/39461785141309",
            "sku": "100765",
            "color": "Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "Yellow"
            },
            "available": true,
            "price": 7.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-grip-black-std?variant=39461785141309"
          },
          {
            "id": "39461785174077",
            "gid": "gid://shopify/ProductVariant/39461785174077",
            "sku": "100766",
            "color": "Turquoise",
            "size": "Standard",
            "selected_options": {
              "Color": "Turquoise"
            },
            "available": true,
            "price": 7.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-grip-black-std?variant=39461785174077"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Line Undersize Grip"
        ],
        "price": 7.59,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-i-line-grip-magenta-undersize",
        "handle": "lamkin-i-line-grip-magenta-undersize",
        "shopify_variants": [
          {
            "id": "39461785010237",
            "gid": "gid://shopify/ProductVariant/39461785010237",
            "sku": "100761",
            "color": "Line Undersize Grip",
            "size": "Undersize",
            "selected_options": {
              "Title": "Default"
            },
            "available": true,
            "price": 7.59,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-i-line-grip-magenta-undersize?variant=39461785010237"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Line Midsize Grip"
        ],
        "price": 6.62,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/new-lamkin-i-line-midsize-grip",
        "handle": "new-lamkin-i-line-midsize-grip",
        "shopify_variants": [
          {
            "id": "39461778423869",
            "gid": "gid://shopify/ProductVariant/39461778423869",
            "sku": "101107",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 6.62,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-lamkin-i-line-midsize-grip?variant=39461778423869"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Line Oversize Grip"
        ],
        "price": 7.01,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/new-lamkin-i-line-oversize-grip",
        "handle": "new-lamkin-i-line-oversize-grip",
        "shopify_variants": [
          {
            "id": "39461778358333",
            "gid": "gid://shopify/ProductVariant/39461778358333",
            "sku": "101112",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 7.01,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-lamkin-i-line-oversize-grip?variant=39461778358333"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Line Standard Grip"
        ],
        "price": 6.23,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-i-line-standard-grip",
        "handle": "lamkin-i-line-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Vibrant Orange",
              "Lime Green"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461778194493",
            "gid": "gid://shopify/ProductVariant/39461778194493",
            "sku": "101102",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 6.23,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-standard-grip?variant=39461778194493"
          },
          {
            "id": "39461778227261",
            "gid": "gid://shopify/ProductVariant/39461778227261",
            "sku": "101104",
            "color": "Vibrant Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Vibrant Orange"
            },
            "available": true,
            "price": 6.23,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-standard-grip?variant=39461778227261"
          },
          {
            "id": "39461778260029",
            "gid": "gid://shopify/ProductVariant/39461778260029",
            "sku": "101103",
            "color": "Lime Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Lime Green"
            },
            "available": true,
            "price": 6.23,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-standard-grip?variant=39461778260029"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.23,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/new-lamkin-i-line-undersize-grip",
        "handle": "new-lamkin-i-line-undersize-grip",
        "shopify_variants": [
          {
            "id": "39461778096189",
            "gid": "gid://shopify/ProductVariant/39461778096189",
            "sku": "101100",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 6.23,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-lamkin-i-line-undersize-grip?variant=39461778096189"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Lime Green",
          "Line Putter Grip"
        ],
        "price": 9.35,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-i-line-putter-grip",
        "handle": "lamkin-i-line-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Lime Green",
              "Yellow"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461775769661",
            "gid": "gid://shopify/ProductVariant/39461775769661",
            "sku": "101119",
            "color": "Lime Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Lime Green"
            },
            "available": true,
            "price": 9.35,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-putter-grip?variant=39461775769661"
          },
          {
            "id": "39461775802429",
            "gid": "gid://shopify/ProductVariant/39461775802429",
            "sku": "101121",
            "color": "Yellow",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow"
            },
            "available": true,
            "price": 9.35,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-i-line-putter-grip?variant=39461775802429"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_Lamkin, i-Line, iron/wood, lamkin, rubber, single-golf-grips, single-grip, Size_Standard, soft, standard, standard-size-golf-grips, Style_Swing Grip, tacky, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Navy Blue",
      "Lime Green",
      "Yellow",
      "Turquoise",
      "Vibrant Orange",
      "Line Undersize Grip"
    ]
  },
  {
    "id": "lizard-skins-lizard-skin-dsp-bb49-ultra-wrap",
    "brand": "Lizard Skins",
    "model": "Lizard Skin DSP BB49 Ultra Wrap",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "polymer (DSP, no rubber)",
    "texture": "micro-dot texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lizardskins.com/golf/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Jet Black",
      "Neon Pink",
      "Pink"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 15.99,
    "price_max": 207.87,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": 207.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip-pink",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/lizard-skin-bb49-3colors_42d20f5a-ac41-4f4c-a6e7-d1129a13d6ec.jpg?v=1766010899",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Jet Black"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-midsize-grip-bundle-13pcs",
        "handle": "lizard-skins-dsp-bb49-ultra-midsize-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Jet Black",
              "Powder Blue",
              "Royal Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398910337394",
            "gid": "gid://shopify/ProductVariant/61398910337394",
            "sku": "SET-13xDSPUGBW210",
            "color": "Jet Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Jet Black",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-midsize-grip-bundle-13pcs?variant=61398910337394"
          },
          {
            "id": "61398910370162",
            "gid": "gid://shopify/ProductVariant/61398910370162",
            "sku": "SET-13xDSPUGBW243",
            "color": "Powder Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Powder Blue",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-midsize-grip-bundle-13pcs?variant=61398910370162"
          },
          {
            "id": "61398910402930",
            "gid": "gid://shopify/ProductVariant/61398910402930",
            "sku": "SET-13xDSPUGBW241",
            "color": "Royal Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Royal Blue",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-midsize-grip-bundle-13pcs?variant=61398910402930"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Jet Black"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip-bundle-13pcs",
        "handle": "lizard-skins-dsp-bb49-ultra-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Jet Black",
              "Powder Blue",
              "Royal Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398910239090",
            "gid": "gid://shopify/ProductVariant/61398910239090",
            "sku": "SET-13xDSPUGBW110",
            "color": "Jet Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Jet Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip-bundle-13pcs?variant=61398910239090"
          },
          {
            "id": "61398910271858",
            "gid": "gid://shopify/ProductVariant/61398910271858",
            "sku": "SET-13xDSPUGBW143",
            "color": "Powder Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Powder Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip-bundle-13pcs?variant=61398910271858"
          },
          {
            "id": "61398910304626",
            "gid": "gid://shopify/ProductVariant/61398910304626",
            "sku": "SET-13xDSPUGBW141",
            "color": "Royal Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Royal Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip-bundle-13pcs?variant=61398910304626"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Neon Pink",
          "Pink"
        ],
        "price": 207.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip-pink-bundle-13pcs",
        "handle": "lizard-skins-dsp-bb49-ultra-standard-grip-pink-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398909845874",
            "gid": "gid://shopify/ProductVariant/61398909845874",
            "sku": "SET-13xDSPUGBW156",
            "color": "Neon Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Pink",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 207.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip-pink-bundle-13pcs?variant=61398909845874"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Pink"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Neon Pink",
          "Pink"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip-pink",
        "handle": "lizard-skins-dsp-bb49-ultra-standard-grip-pink",
        "shopify_variants": [
          {
            "id": "51793821565298",
            "gid": "gid://shopify/ProductVariant/51793821565298",
            "sku": "DSPUGBW156",
            "color": "Neon Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Pink",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip-pink?variant=51793821565298"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Pink"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Jet Black"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip",
        "handle": "lizard-skins-dsp-bb49-ultra-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Jet Black",
              "Powder Blue",
              "Royal Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51793821335922",
            "gid": "gid://shopify/ProductVariant/51793821335922",
            "sku": "DSPUGBW110",
            "color": "Jet Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Jet Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip?variant=51793821335922"
          },
          {
            "id": "51793821368690",
            "gid": "gid://shopify/ProductVariant/51793821368690",
            "sku": "DSPUGBW143",
            "color": "Powder Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Powder Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip?variant=51793821368690"
          },
          {
            "id": "51793821401458",
            "gid": "gid://shopify/ProductVariant/51793821401458",
            "sku": "DSPUGBW141",
            "color": "Royal Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Royal Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-standard-grip?variant=51793821401458"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Jet Black"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-midsize-grip",
        "handle": "lizard-skins-dsp-bb49-ultra-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Jet Black",
              "Powder Blue",
              "Royal Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51793821204850",
            "gid": "gid://shopify/ProductVariant/51793821204850",
            "sku": "DSPUGBW210",
            "color": "Jet Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Jet Black",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-midsize-grip?variant=51793821204850"
          },
          {
            "id": "51793821237618",
            "gid": "gid://shopify/ProductVariant/51793821237618",
            "sku": "DSPUGBW243",
            "color": "Powder Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Powder Blue",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-midsize-grip?variant=51793821237618"
          },
          {
            "id": "51793821270386",
            "gid": "gid://shopify/ProductVariant/51793821270386",
            "sku": "DSPUGBW241",
            "color": "Royal Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Royal Blue",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-ultra-midsize-grip?variant=51793821270386"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, arthritic, arthritic-golf-grips, grip bundle, lizard, lizard skin, lizard skins, midsize, midsize-size-golf-grips, new-add-12172025, single-golf-grips, single-grip, tacky, tacky grip, wrap, wrap style, wrap-style-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lizardskins.com/golf/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Jet Black"
    ]
  },
  {
    "id": "lizard-skins-lizard-skin-dsp-bb49-wrap-ultra",
    "brand": "Lizard Skins",
    "model": "Lizard Skin DSP BB49 Wrap Ultra",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "polymer (DSP, no rubber)",
    "texture": "micro-dot texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lizardskins.com/golf/"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Jet Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 17.99,
    "price_max": 233.87,
    "single_price_min": 17.99,
    "single_price_max": 17.99,
    "normalized_price_per_grip": 17.99,
    "bundle_price_min": 233.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-wrap-ultra-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/lizard-skin-bb49-oversize-2colors_dd6c010f-6a29-4cc3-918a-5e953084b349.jpg?v=1766010881",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Jet Black"
        ],
        "price": 233.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-wrap-ultra-oversize-grip-bundle-13pcs",
        "handle": "lizard-skins-dsp-bb49-wrap-ultra-oversize-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Jet Black",
              "Powder Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398910173554",
            "gid": "gid://shopify/ProductVariant/61398910173554",
            "sku": "SET-13xDSPUGBW310",
            "color": "Jet Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Jet Black",
              "Grip Size": "Oversize"
            },
            "available": false,
            "price": 233.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-wrap-ultra-oversize-grip-bundle-13pcs?variant=61398910173554"
          },
          {
            "id": "61398910206322",
            "gid": "gid://shopify/ProductVariant/61398910206322",
            "sku": "SET-13xDSPUGBW343",
            "color": "Powder Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Powder Blue",
              "Grip Size": "Oversize"
            },
            "available": false,
            "price": 233.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-wrap-ultra-oversize-grip-bundle-13pcs?variant=61398910206322"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Jet Black"
        ],
        "price": 17.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-wrap-ultra-oversize-grip",
        "handle": "lizard-skins-dsp-bb49-wrap-ultra-oversize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Jet Black",
              "Powder Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51793821466994",
            "gid": "gid://shopify/ProductVariant/51793821466994",
            "sku": "DSPUGBW310",
            "color": "Jet Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Jet Black",
              "Grip Size": "Oversize"
            },
            "available": false,
            "price": 17.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-wrap-ultra-oversize-grip?variant=51793821466994"
          },
          {
            "id": "51793821499762",
            "gid": "gid://shopify/ProductVariant/51793821499762",
            "sku": "DSPUGBW343",
            "color": "Powder Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Powder Blue",
              "Grip Size": "Oversize"
            },
            "available": false,
            "price": 17.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-bb49-wrap-ultra-oversize-grip?variant=51793821499762"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, arthritic, arthritic-golf-grips, grip bundle, jumbo, jumbo/oversize, lizard, lizard skin, lizard skins, new-add-12172025, oversize, oversize-jumbo-golf-grips, single-golf-grips, single-grip, tacky, tacky grip, wrap, wrap style, wrap-style-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lizardskins.com/golf/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lizard-skins-lizard-skin-dsp-hd64-ultra",
    "brand": "Lizard Skins",
    "model": "Lizard Skin DSP HD64 Ultra",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "polymer (DSP, no rubber)",
    "texture": "micro-dot texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.lizardskins.com/golf/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Blue Scoop"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 19.99,
    "price_max": 259.87,
    "single_price_min": 19.99,
    "single_price_max": 19.99,
    "normalized_price_per_grip": 19.99,
    "bundle_price_min": 259.87,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/lizard-skins-hd64-2colors_5b840447-a52e-4d2e-aec5-7f58e00e6dc3.jpg?v=1766010868",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue Scoop"
        ],
        "price": 259.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-midsize-grip-bundle-13pcs",
        "handle": "lizard-skins-dsp-hd64-ultra-midsize-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue Scoop",
              "Four Leaf"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398909780338",
            "gid": "gid://shopify/ProductVariant/61398909780338",
            "sku": "SET-13xDSPUGHD2BS",
            "color": "Blue Scoop",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue Scoop",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 259.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-midsize-grip-bundle-13pcs?variant=61398909780338"
          },
          {
            "id": "61398909813106",
            "gid": "gid://shopify/ProductVariant/61398909813106",
            "sku": "SET-13xDSPUGHD2FL",
            "color": "Four Leaf",
            "size": "Midsize",
            "selected_options": {
              "Color": "Four Leaf",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 259.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-midsize-grip-bundle-13pcs?variant=61398909813106"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Blue Scoop"
        ],
        "price": 259.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-standard-grip-bundle-13pcs",
        "handle": "lizard-skins-dsp-hd64-ultra-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue Scoop",
              "Four Leaf"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398909714802",
            "gid": "gid://shopify/ProductVariant/61398909714802",
            "sku": "SET-13xDSPUGHD1BS",
            "color": "Blue Scoop",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue Scoop",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 259.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-standard-grip-bundle-13pcs?variant=61398909714802"
          },
          {
            "id": "61398909747570",
            "gid": "gid://shopify/ProductVariant/61398909747570",
            "sku": "SET-13xDSPUGHD1FL",
            "color": "Four Leaf",
            "size": "Standard",
            "selected_options": {
              "Color": "Four Leaf",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 259.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-standard-grip-bundle-13pcs?variant=61398909747570"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blue Scoop"
        ],
        "price": 19.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-standard-grip",
        "handle": "lizard-skins-dsp-hd64-ultra-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue Scoop",
              "Four Leaf"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51793821663602",
            "gid": "gid://shopify/ProductVariant/51793821663602",
            "sku": "DSPUGHD1BS",
            "color": "Blue Scoop",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue Scoop",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-standard-grip?variant=51793821663602"
          },
          {
            "id": "51793821696370",
            "gid": "gid://shopify/ProductVariant/51793821696370",
            "sku": "DSPUGHD1FL",
            "color": "Four Leaf",
            "size": "Standard",
            "selected_options": {
              "Color": "Four Leaf",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-standard-grip?variant=51793821696370"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Blue Scoop"
        ],
        "price": 19.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-midsize-grip",
        "handle": "lizard-skins-dsp-hd64-ultra-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue Scoop",
              "Four Leaf"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51793821598066",
            "gid": "gid://shopify/ProductVariant/51793821598066",
            "sku": "DSPUGHD2BS",
            "color": "Blue Scoop",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue Scoop",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-midsize-grip?variant=51793821598066"
          },
          {
            "id": "51793821630834",
            "gid": "gid://shopify/ProductVariant/51793821630834",
            "sku": "DSPUGHD2FL",
            "color": "Four Leaf",
            "size": "Midsize",
            "selected_options": {
              "Color": "Four Leaf",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-hd64-ultra-midsize-grip?variant=51793821630834"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, arthritic, arthritic-golf-grips, grip bundle, lizard, lizard skin, lizard skins, midsize, midsize-size-golf-grips, new-add-12172025, single-golf-grips, single-grip, tacky, tacky grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lizardskins.com/golf/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "loudmouth-black-pink-argyle-swing",
    "brand": "LoudMouth",
    "model": "Black & Pink Argyle Swing",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 10.95,
    "price_max": 10.95,
    "single_price_min": 10.95,
    "single_price_max": 10.95,
    "normalized_price_per_grip": 10.95,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/loudmouth-black-pink-argyle-standard-swing-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/swing-argyle-blk-pink-diag.jpg?v=1626964335",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 10.95,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/loudmouth-black-pink-argyle-standard-swing-grip",
        "handle": "loudmouth-black-pink-argyle-standard-swing-grip",
        "shopify_variants": [
          {
            "id": "571620553",
            "gid": "gid://shopify/ProductVariant/571620553",
            "sku": "LH-R-LM-PB",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Standard"
            },
            "available": true,
            "price": 10.95,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/loudmouth-black-pink-argyle-standard-swing-grip?variant=571620553"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, infinite-opt-addkit, iron/wood, loudmouth, Pink & Argyle, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "loudmouth-black-shagadelic-swing",
    "brand": "LoudMouth",
    "model": "Black Shagadelic Swing",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 10.95,
    "price_max": 10.95,
    "single_price_min": 10.95,
    "single_price_max": 10.95,
    "normalized_price_per_grip": 10.95,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/loudmouth-black-shagadelic-standard-swing-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/swing-shagadelic-diag.jpg?v=1626964335",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 10.95,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/loudmouth-black-shagadelic-standard-swing-grip",
        "handle": "loudmouth-black-shagadelic-standard-swing-grip",
        "shopify_variants": [
          {
            "id": "571578005",
            "gid": "gid://shopify/ProductVariant/571578005",
            "sku": "LH-R-LM-BS",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Standard"
            },
            "available": true,
            "price": 10.95,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/loudmouth-black-shagadelic-standard-swing-grip?variant=571578005"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, infinite-opt-addkit, iron/wood, loudmouth, Shagadelic, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "loudmouth-captain-thunderbolt-swing",
    "brand": "LoudMouth",
    "model": "Captain Thunderbolt Swing",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 10.95,
    "price_max": 10.95,
    "single_price_min": 10.95,
    "single_price_max": 10.95,
    "normalized_price_per_grip": 10.95,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/loudmouth-captain-thunderbolt-standard-swing-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/swing-thunder-diag.jpg?v=1626964335",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 10.95,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/loudmouth-captain-thunderbolt-standard-swing-grip",
        "handle": "loudmouth-captain-thunderbolt-standard-swing-grip",
        "shopify_variants": [
          {
            "id": "571595789",
            "gid": "gid://shopify/ProductVariant/571595789",
            "sku": "LH-R-LM-CT",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Standard"
            },
            "available": true,
            "price": 10.95,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/loudmouth-captain-thunderbolt-standard-swing-grip?variant=571595789"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, infinite-opt-addkit, iron/wood, loudmouth, single-golf-grips, single-grip, standard, standard-size-golf-grips, Thunderbolt, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "pure-grips-pure-combo-reduced-taper",
    "brand": "Pure Grips",
    "model": "PURE Combo (Reduced Taper)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (bonded, tapeless)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://puregrips.com/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [
      "Black w/ White",
      "Green w/ White"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 10.99,
    "price_max": 89.02,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 9.89,
    "bundle_price_min": 89.02,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/pure-combo-blk-main_4bffb9ae-73a5-42b4-a7a1-b163e6327d66.jpg?v=1735455695",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black w/ White"
        ],
        "price": 89.02,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip-grip-bundle-set",
        "handle": "new-pure-combo-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black w/ White",
              "White w/ Black",
              "Grey w/ Black",
              "Blue w/ White",
              "Red w/ White",
              "Purple w/ White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021958422589",
            "gid": "gid://shopify/ProductVariant/41021958422589",
            "sku": "SET-9xPG-7210",
            "color": "Black w/ White",
            "size": "Standard",
            "selected_options": {
              "Color": "Black w/ White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip-grip-bundle-set?variant=41021958422589"
          },
          {
            "id": "41021958455357",
            "gid": "gid://shopify/ProductVariant/41021958455357",
            "sku": "SET-9xPG-7211",
            "color": "White w/ Black",
            "size": "Standard",
            "selected_options": {
              "Color": "White w/ Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 97.12,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip-grip-bundle-set?variant=41021958455357"
          },
          {
            "id": "41021958488125",
            "gid": "gid://shopify/ProductVariant/41021958488125",
            "sku": "SET-9xPG-7214",
            "color": "Grey w/ Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey w/ Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 97.12,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip-grip-bundle-set?variant=41021958488125"
          },
          {
            "id": "41021958520893",
            "gid": "gid://shopify/ProductVariant/41021958520893",
            "sku": "SET-9xPG-7213",
            "color": "Blue w/ White",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue w/ White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 97.12,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip-grip-bundle-set?variant=41021958520893"
          },
          {
            "id": "41021958553661",
            "gid": "gid://shopify/ProductVariant/41021958553661",
            "sku": "SET-9xPG-7215",
            "color": "Red w/ White",
            "size": "Standard",
            "selected_options": {
              "Color": "Red w/ White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 97.12,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip-grip-bundle-set?variant=41021958553661"
          },
          {
            "id": "41021958586429",
            "gid": "gid://shopify/ProductVariant/41021958586429",
            "sku": "SET-9xPG-7216",
            "color": "Purple w/ White",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple w/ White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 97.12,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip-grip-bundle-set?variant=41021958586429"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green w/ White"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip",
        "handle": "new-pure-combo-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green w/ White",
              "Purple w/ White",
              "Black w/ White",
              "White w/ Black",
              "Grey w/ Black",
              "Blue w/ White",
              "Red w/ White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41098392272957",
            "gid": "gid://shopify/ProductVariant/41098392272957",
            "sku": "PG-7212",
            "color": "Green w/ White",
            "size": "Standard",
            "selected_options": {
              "Color": "Green w/ White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip?variant=41098392272957"
          },
          {
            "id": "40683500535869",
            "gid": "gid://shopify/ProductVariant/40683500535869",
            "sku": "PG-7216",
            "color": "Purple w/ White",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple w/ White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip?variant=40683500535869"
          },
          {
            "id": "40683500372029",
            "gid": "gid://shopify/ProductVariant/40683500372029",
            "sku": "PG-7210",
            "color": "Black w/ White",
            "size": "Standard",
            "selected_options": {
              "Color": "Black w/ White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip?variant=40683500372029"
          },
          {
            "id": "40683500404797",
            "gid": "gid://shopify/ProductVariant/40683500404797",
            "sku": "PG-7211",
            "color": "White w/ Black",
            "size": "Standard",
            "selected_options": {
              "Color": "White w/ Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip?variant=40683500404797"
          },
          {
            "id": "40683500437565",
            "gid": "gid://shopify/ProductVariant/40683500437565",
            "sku": "PG-7214",
            "color": "Grey w/ Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey w/ Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip?variant=40683500437565"
          },
          {
            "id": "40683500470333",
            "gid": "gid://shopify/ProductVariant/40683500470333",
            "sku": "PG-7213",
            "color": "Blue w/ White",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue w/ White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip?variant=40683500470333"
          },
          {
            "id": "40683500503101",
            "gid": "gid://shopify/ProductVariant/40683500503101",
            "sku": "PG-7215",
            "color": "Red w/ White",
            "size": "Standard",
            "selected_options": {
              "Color": "Red w/ White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/new-pure-combo-standard-grip?variant=40683500503101"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, fathers-day-2021-sale, firm, golf-grips, grip bundle, hybrid, hybrid-golf-grips, iron/wood, july4-2022, memsale2022, new-bundle-set, pure combo, pure pro, pure-grips, rubber, single-golf-grips, standard, standard-size-golf-grips, under-150, under-300, video=kCFbPuwC2TI",
    "source_quality": "manufacturer_family",
    "source_url": "https://puregrips.com/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Purple w/ White"
    ]
  },
  {
    "id": "pure-grips-pure-dtx",
    "brand": "Pure Grips",
    "model": "PURE DTX",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (bonded, tapeless)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://puregrips.com/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black",
      "NEON",
      "Neon Blue",
      "Royal Blue"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 10.99,
    "price_max": 148.08,
    "single_price_min": 10.99,
    "single_price_max": 13.69,
    "normalized_price_per_grip": 10.38,
    "bundle_price_min": null,
    "kit_price_min": 134.95,
    "url": "https://www.grips4less.com/products/pure-grips-pure-dtx-standard-neon",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/pure-dtx-neon-allcolors.jpg?v=1710258886",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 19,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "NEON",
          "Neon Blue"
        ],
        "price": 13.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-pure-dtx-standard-neon",
        "handle": "pure-grips-pure-dtx-standard-neon",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Blue",
              "Neon Orange",
              "Neon Pink",
              "Neon Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41086810554429",
            "gid": "gid://shopify/ProductVariant/41086810554429",
            "sku": "PG-1222",
            "color": "Neon Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-dtx-standard-neon?variant=41086810554429"
          },
          {
            "id": "41086810587197",
            "gid": "gid://shopify/ProductVariant/41086810587197",
            "sku": "PG-1223",
            "color": "Neon Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Orange",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-dtx-standard-neon?variant=41086810587197"
          },
          {
            "id": "41086810619965",
            "gid": "gid://shopify/ProductVariant/41086810619965",
            "sku": "PG-1218",
            "color": "Neon Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Pink",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-dtx-standard-neon?variant=41086810619965"
          },
          {
            "id": "41086810652733",
            "gid": "gid://shopify/ProductVariant/41086810652733",
            "sku": "PG-1221",
            "color": "Neon Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-dtx-standard-neon?variant=41086810652733"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-purple",
        "handle": "grip-kit-13x-pure-grips-dtx-standard-grips-purple",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498307645",
            "gid": "gid://shopify/ProductVariant/40683498307645",
            "sku": "SET-13xPG-1214",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-purple?variant=40683498307645"
          },
          {
            "id": "40683498340413",
            "gid": "gid://shopify/ProductVariant/40683498340413",
            "sku": "KIT(ATT)+13xPG-1214",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-purple?variant=40683498340413"
          },
          {
            "id": "40683498373181",
            "gid": "gid://shopify/ProductVariant/40683498373181",
            "sku": "KIT(CUP)+13xPG-1214",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-purple?variant=40683498373181"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-grey",
        "handle": "grip-kit-13x-pure-grips-dtx-standard-grips-grey",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498405949",
            "gid": "gid://shopify/ProductVariant/40683498405949",
            "sku": "SET-13xPG-131T532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-grey?variant=40683498405949"
          },
          {
            "id": "40683498438717",
            "gid": "gid://shopify/ProductVariant/40683498438717",
            "sku": "KIT(ATT)+13xPG-131T532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-grey?variant=40683498438717"
          },
          {
            "id": "40683498471485",
            "gid": "gid://shopify/ProductVariant/40683498471485",
            "sku": "KIT(CUP)+13xPG-131T532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-grey?variant=40683498471485"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-green",
        "handle": "grip-kit-13x-pure-grips-dtx-standard-grips-green",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498504253",
            "gid": "gid://shopify/ProductVariant/40683498504253",
            "sku": "SET-13xPG-01216",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-green?variant=40683498504253"
          },
          {
            "id": "40683498537021",
            "gid": "gid://shopify/ProductVariant/40683498537021",
            "sku": "KIT(ATT)+13xPG-01216",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-green?variant=40683498537021"
          },
          {
            "id": "40683498569789",
            "gid": "gid://shopify/ProductVariant/40683498569789",
            "sku": "KIT(CUP)+13xPG-01216",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-green?variant=40683498569789"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-grey",
        "handle": "grip-kit-13x-pure-grips-dtx-midsize-grips-grey",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498602557",
            "gid": "gid://shopify/ProductVariant/40683498602557",
            "sku": "SET-13xPG-131T632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-grey?variant=40683498602557"
          },
          {
            "id": "40683498635325",
            "gid": "gid://shopify/ProductVariant/40683498635325",
            "sku": "KIT(ATT)+13xPG-131T632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-grey?variant=40683498635325"
          },
          {
            "id": "40683498668093",
            "gid": "gid://shopify/ProductVariant/40683498668093",
            "sku": "KIT(CUP)+13xPG-131T632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-grey?variant=40683498668093"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-purple",
        "handle": "grip-kit-13x-pure-grips-dtx-midsize-grips-purple",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498700861",
            "gid": "gid://shopify/ProductVariant/40683498700861",
            "sku": "SET-13xPG-1314",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-purple?variant=40683498700861"
          },
          {
            "id": "40683498733629",
            "gid": "gid://shopify/ProductVariant/40683498733629",
            "sku": "KIT(ATT)+13xPG-1314",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-purple?variant=40683498733629"
          },
          {
            "id": "40683498766397",
            "gid": "gid://shopify/ProductVariant/40683498766397",
            "sku": "KIT(CUP)+13xPG-1314",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-purple?variant=40683498766397"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-green",
        "handle": "grip-kit-13x-pure-grips-dtx-midsize-grips-green",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498799165",
            "gid": "gid://shopify/ProductVariant/40683498799165",
            "sku": "SET-13xPG-01316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-green?variant=40683498799165"
          },
          {
            "id": "40683498831933",
            "gid": "gid://shopify/ProductVariant/40683498831933",
            "sku": "KIT(ATT)+13xPG-01316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-green?variant=40683498831933"
          },
          {
            "id": "40683498864701",
            "gid": "gid://shopify/ProductVariant/40683498864701",
            "sku": "KIT(CUP)+13xPG-01316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-green?variant=40683498864701"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Royal Blue"
        ],
        "price": 134.95,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/pure-grips-dtx-standard-13pcs-golf-grip-kit",
        "handle": "pure-grips-dtx-standard-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Royal Blue",
              "Eagle Green",
              "Titanium Grey",
              "Purple"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007848460349",
            "gid": "gid://shopify/ProductVariant/32007848460349",
            "sku": "KIT+13xPG-91532",
            "color": "Royal Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Royal Blue"
            },
            "available": false,
            "price": 134.95,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard-13pcs-golf-grip-kit?variant=32007848460349"
          },
          {
            "id": "32007848493117",
            "gid": "gid://shopify/ProductVariant/32007848493117",
            "sku": "KIT+13xPG-01216",
            "color": "Eagle Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 110.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard-13pcs-golf-grip-kit?variant=32007848493117"
          },
          {
            "id": "32007848525885",
            "gid": "gid://shopify/ProductVariant/32007848525885",
            "sku": "KIT+13xPG-131T532",
            "color": "Titanium Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 109.01,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard-13pcs-golf-grip-kit?variant=32007848525885"
          },
          {
            "id": "32007848558653",
            "gid": "gid://shopify/ProductVariant/32007848558653",
            "sku": "KIT+13xPG-1214",
            "color": "Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 110.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard-13pcs-golf-grip-kit?variant=32007848558653"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize-13pcs-golf-grip-kit",
        "handle": "pure-grips-dtx-midsize-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Eagle Green",
              "Purple"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007848329277",
            "gid": "gid://shopify/ProductVariant/32007848329277",
            "sku": "KIT+13xPG-11632",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize-13pcs-golf-grip-kit?variant=32007848329277"
          },
          {
            "id": "32007848362045",
            "gid": "gid://shopify/ProductVariant/32007848362045",
            "sku": "KIT+13xPG-131T632",
            "color": "Titanium Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 111.48,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize-13pcs-golf-grip-kit?variant=32007848362045"
          },
          {
            "id": "32007848394813",
            "gid": "gid://shopify/ProductVariant/32007848394813",
            "sku": "KIT+13xPG-01316",
            "color": "Eagle Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 112.72,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize-13pcs-golf-grip-kit?variant=32007848394813"
          },
          {
            "id": "32007848427581",
            "gid": "gid://shopify/ProductVariant/32007848427581",
            "sku": "KIT+13xPG-1314",
            "color": "Purple",
            "size": "Midsize",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 112.72,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize-13pcs-golf-grip-kit?variant=32007848427581"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-white",
        "handle": "grip-kit-13x-pure-grips-dtx-midsize-grips-white",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683505877053",
            "gid": "gid://shopify/ProductVariant/40683505877053",
            "sku": "SET-13xPG-21632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-white?variant=40683505877053"
          },
          {
            "id": "40683505909821",
            "gid": "gid://shopify/ProductVariant/40683505909821",
            "sku": "KIT(ATT)+13xPG-21632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-white?variant=40683505909821"
          },
          {
            "id": "40683505942589",
            "gid": "gid://shopify/ProductVariant/40683505942589",
            "sku": "KIT(CUP)+13xPG-21632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-white?variant=40683505942589"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-royal-blue",
        "handle": "grip-kit-13x-pure-grips-dtx-midsize-grips-royal-blue",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683506008125",
            "gid": "gid://shopify/ProductVariant/40683506008125",
            "sku": "SET-13xPG-091632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-royal-blue?variant=40683506008125"
          },
          {
            "id": "40683506040893",
            "gid": "gid://shopify/ProductVariant/40683506040893",
            "sku": "KIT(ATT)+13xPG-091632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-royal-blue?variant=40683506040893"
          },
          {
            "id": "40683506073661",
            "gid": "gid://shopify/ProductVariant/40683506073661",
            "sku": "KIT(CUP)+13xPG-091632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-royal-blue?variant=40683506073661"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-red",
        "handle": "grip-kit-13x-pure-grips-dtx-midsize-grips-red",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683506106429",
            "gid": "gid://shopify/ProductVariant/40683506106429",
            "sku": "SET-13xPG-31632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-red?variant=40683506106429"
          },
          {
            "id": "40683506139197",
            "gid": "gid://shopify/ProductVariant/40683506139197",
            "sku": "KIT(ATT)+13xPG-31632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-red?variant=40683506139197"
          },
          {
            "id": "40683506171965",
            "gid": "gid://shopify/ProductVariant/40683506171965",
            "sku": "KIT(CUP)+13xPG-31632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-red?variant=40683506171965"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-black",
        "handle": "grip-kit-13x-pure-grips-dtx-midsize-grips-black",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683506204733",
            "gid": "gid://shopify/ProductVariant/40683506204733",
            "sku": "SET-13xPG-11632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-black?variant=40683506204733"
          },
          {
            "id": "40683506237501",
            "gid": "gid://shopify/ProductVariant/40683506237501",
            "sku": "KIT(ATT)+13xPG-11632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-black?variant=40683506237501"
          },
          {
            "id": "40683506270269",
            "gid": "gid://shopify/ProductVariant/40683506270269",
            "sku": "KIT(CUP)+13xPG-11632",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-midsize-grips-black?variant=40683506270269"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-white",
        "handle": "grip-kit-13x-pure-grips-dtx-standard-grips-white",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683506303037",
            "gid": "gid://shopify/ProductVariant/40683506303037",
            "sku": "SET-13xPG-21532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-white?variant=40683506303037"
          },
          {
            "id": "40683506335805",
            "gid": "gid://shopify/ProductVariant/40683506335805",
            "sku": "KIT(ATT)+13xPG-21532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-white?variant=40683506335805"
          },
          {
            "id": "40683506368573",
            "gid": "gid://shopify/ProductVariant/40683506368573",
            "sku": "KIT(CUP)+13xPG-21532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-white?variant=40683506368573"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-royal-blue",
        "handle": "grip-kit-13x-pure-grips-dtx-standard-grips-royal-blue",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683506401341",
            "gid": "gid://shopify/ProductVariant/40683506401341",
            "sku": "SET-13xPG-91532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-royal-blue?variant=40683506401341"
          },
          {
            "id": "40683506434109",
            "gid": "gid://shopify/ProductVariant/40683506434109",
            "sku": "KIT(ATT)+13xPG-91532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-royal-blue?variant=40683506434109"
          },
          {
            "id": "40683506466877",
            "gid": "gid://shopify/ProductVariant/40683506466877",
            "sku": "KIT(CUP)+13xPG-91532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-royal-blue?variant=40683506466877"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 148.08,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-red",
        "handle": "grip-kit-13x-pure-grips-dtx-standard-grips-red",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683506499645",
            "gid": "gid://shopify/ProductVariant/40683506499645",
            "sku": "SET-13xPG-31532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 148.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-red?variant=40683506499645"
          },
          {
            "id": "40683506532413",
            "gid": "gid://shopify/ProductVariant/40683506532413",
            "sku": "KIT(ATT)+13xPG-31532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 174.44,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-red?variant=40683506532413"
          },
          {
            "id": "40683506565181",
            "gid": "gid://shopify/ProductVariant/40683506565181",
            "sku": "KIT(CUP)+13xPG-31532",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 156.63,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-grips-dtx-standard-grips-red?variant=40683506565181"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/pure-grips-dtx-standard-grip-kit",
        "handle": "pure-grips-dtx-standard-grip-kit",
        "shopify_options": [],
        "shopify_variants": [
          {
            "id": "40683507417149",
            "gid": "gid://shopify/ProductVariant/40683507417149",
            "sku": "SET-13xPG-11532",
            "color": "",
            "size": "Standard",
            "selected_options": {},
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard-grip-kit?variant=40683507417149"
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize",
        "handle": "pure-grips-dtx-midsize",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Eagle Green",
              "Purple",
              "White",
              "Red",
              "Royal Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683507744829",
            "gid": "gid://shopify/ProductVariant/40683507744829",
            "sku": "PG-11632",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize?variant=40683507744829"
          },
          {
            "id": "40683507777597",
            "gid": "gid://shopify/ProductVariant/40683507777597",
            "sku": "PG-131T632",
            "color": "Titanium Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize?variant=40683507777597"
          },
          {
            "id": "40683507810365",
            "gid": "gid://shopify/ProductVariant/40683507810365",
            "sku": "PG-01316",
            "color": "Eagle Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize?variant=40683507810365"
          },
          {
            "id": "40683507843133",
            "gid": "gid://shopify/ProductVariant/40683507843133",
            "sku": "PG-1314",
            "color": "Purple",
            "size": "Midsize",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize?variant=40683507843133"
          },
          {
            "id": "40683507875901",
            "gid": "gid://shopify/ProductVariant/40683507875901",
            "sku": "PG-21632",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize?variant=40683507875901"
          },
          {
            "id": "40683507908669",
            "gid": "gid://shopify/ProductVariant/40683507908669",
            "sku": "PG-31632",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize?variant=40683507908669"
          },
          {
            "id": "40683507941437",
            "gid": "gid://shopify/ProductVariant/40683507941437",
            "sku": "PG-091632",
            "color": "Royal Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Royal Blue"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-midsize?variant=40683507941437"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Royal Blue"
        ],
        "price": 11.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-dtx-standard",
        "handle": "pure-grips-dtx-standard",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Royal Blue",
              "Eagle Green",
              "Titanium Grey",
              "Purple",
              "White",
              "Black",
              "Red"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683507974205",
            "gid": "gid://shopify/ProductVariant/40683507974205",
            "sku": "PG-91532",
            "color": "Royal Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Royal Blue"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard?variant=40683507974205"
          },
          {
            "id": "40683508006973",
            "gid": "gid://shopify/ProductVariant/40683508006973",
            "sku": "PG-01216",
            "color": "Eagle Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard?variant=40683508006973"
          },
          {
            "id": "40683508039741",
            "gid": "gid://shopify/ProductVariant/40683508039741",
            "sku": "PG-131T532",
            "color": "Titanium Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard?variant=40683508039741"
          },
          {
            "id": "40683508072509",
            "gid": "gid://shopify/ProductVariant/40683508072509",
            "sku": "PG-1214",
            "color": "Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard?variant=40683508072509"
          },
          {
            "id": "40683508105277",
            "gid": "gid://shopify/ProductVariant/40683508105277",
            "sku": "PG-21532",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard?variant=40683508105277"
          },
          {
            "id": "40683508138045",
            "gid": "gid://shopify/ProductVariant/40683508138045",
            "sku": "PG-11532",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard?variant=40683508138045"
          },
          {
            "id": "40683508170813",
            "gid": "gid://shopify/ProductVariant/40683508170813",
            "sku": "PG-31532",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-dtx-standard?variant=40683508170813"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2023-summer-new-sale, 2024 new products, 49 under, All Products, blackfriday2020, fathers-day-2021-sale, firm, golf-grips, iron/wood, july4-2022, memsale2022, neon grips, overstock-mar2024, pure dtx, pure-grips, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, under-150, u",
    "source_quality": "manufacturer_family",
    "source_url": "https://puregrips.com/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Royal Blue"
    ]
  },
  {
    "id": "pure-grips-pure-pro",
    "brand": "Pure Grips",
    "model": "PURE Pro",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (bonded, tapeless)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "style_forward",
    "non_black_color_count": 8,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://puregrips.com/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "NEON",
      "Nassau Navy",
      "Neon Blue",
      "Neon Orange",
      "Neon Pink",
      "Neon Yellow",
      "Pure Pink",
      "White"
    ],
    "weight_g_by_size": {
      "Undersize": 63.5,
      "Midsize": 63.5,
      "Standard": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 4.09,
    "price_max": 136.18,
    "single_price_min": 4.09,
    "single_price_max": 13.69,
    "normalized_price_per_grip": 4.09,
    "bundle_price_min": 89.02,
    "kit_price_min": 123.38,
    "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/pure-pro-2021-colors_83e93d20-f5dc-4585-861d-7971c9ef35dd.jpg?v=1735455604",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 40,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "White"
        ],
        "price": 89.02,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-grip-bundle-set",
        "handle": "pure-grips-pure-pro-undersize-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White",
              "Black",
              "Titanium Grey",
              "Purple",
              "Red",
              "Royal Blue",
              "Eagle Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021971529789",
            "gid": "gid://shopify/ProductVariant/41021971529789",
            "sku": "SET-9xPG-021012",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-grip-bundle-set?variant=41021971529789"
          },
          {
            "id": "41021971562557",
            "gid": "gid://shopify/ProductVariant/41021971562557",
            "sku": "SET-9xPG-11012",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-grip-bundle-set?variant=41021971562557"
          },
          {
            "id": "41021971595325",
            "gid": "gid://shopify/ProductVariant/41021971595325",
            "sku": "SET-9xPG-131T012",
            "color": "Titanium Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Titanium Grey",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-grip-bundle-set?variant=41021971595325"
          },
          {
            "id": "41021971628093",
            "gid": "gid://shopify/ProductVariant/41021971628093",
            "sku": "SET-9xPG-2114",
            "color": "Purple",
            "size": "Undersize",
            "selected_options": {
              "Color": "Purple",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-grip-bundle-set?variant=41021971628093"
          },
          {
            "id": "41021971660861",
            "gid": "gid://shopify/ProductVariant/41021971660861",
            "sku": "SET-9xPG-031012",
            "color": "Red",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 408.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-grip-bundle-set?variant=41021971660861"
          },
          {
            "id": "41021971693629",
            "gid": "gid://shopify/ProductVariant/41021971693629",
            "sku": "SET-9xPG-091012",
            "color": "Royal Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Royal Blue",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 408.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-grip-bundle-set?variant=41021971693629"
          },
          {
            "id": "41021971726397",
            "gid": "gid://shopify/ProductVariant/41021971726397",
            "sku": "SET-9xPG-02116",
            "color": "Eagle Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Eagle Green",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 89.02,
            "weight_g": 408.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-grip-bundle-set?variant=41021971726397"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Neon Blue"
        ],
        "price": 110.89,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon-grip-bundle-set",
        "handle": "pure-grips-pure-pro-undersize-neon-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Blue",
              "Neon Orange",
              "Neon Pink",
              "Neon Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021952426045",
            "gid": "gid://shopify/ProductVariant/41021952426045",
            "sku": "SET-9xPG-2124",
            "color": "Neon Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Blue",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 110.89,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon-grip-bundle-set?variant=41021952426045"
          },
          {
            "id": "41021952458813",
            "gid": "gid://shopify/ProductVariant/41021952458813",
            "sku": "SET-9xPG-2123",
            "color": "Neon Orange",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Orange",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 110.89,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon-grip-bundle-set?variant=41021952458813"
          },
          {
            "id": "41021952491581",
            "gid": "gid://shopify/ProductVariant/41021952491581",
            "sku": "SET-9xPG-2118",
            "color": "Neon Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Pink",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 110.89,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon-grip-bundle-set?variant=41021952491581"
          },
          {
            "id": "41021952524349",
            "gid": "gid://shopify/ProductVariant/41021952524349",
            "sku": "SET-9xPG-2121",
            "color": "Neon Yellow",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Yellow",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 110.89,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon-grip-bundle-set?variant=41021952524349"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "NEON",
          "Neon Blue"
        ],
        "price": 13.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon",
        "handle": "pure-grips-pure-pro-undersize-neon",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Blue",
              "Neon Orange",
              "Neon Pink",
              "Neon Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683497914429",
            "gid": "gid://shopify/ProductVariant/40683497914429",
            "sku": "PG-2124",
            "color": "Neon Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Blue",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon?variant=40683497914429"
          },
          {
            "id": "40683497947197",
            "gid": "gid://shopify/ProductVariant/40683497947197",
            "sku": "PG-2123",
            "color": "Neon Orange",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Orange",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon?variant=40683497947197"
          },
          {
            "id": "40683497979965",
            "gid": "gid://shopify/ProductVariant/40683497979965",
            "sku": "PG-2118",
            "color": "Neon Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Pink",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon?variant=40683497979965"
          },
          {
            "id": "40683498012733",
            "gid": "gid://shopify/ProductVariant/40683498012733",
            "sku": "PG-2121",
            "color": "Neon Yellow",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Yellow",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-neon?variant=40683498012733"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "NEON",
          "Neon Blue"
        ],
        "price": 13.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-neon",
        "handle": "pure-grips-pure-pro-midsize-neon",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Blue",
              "Neon Orange",
              "Neon Pink",
              "Neon Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498045501",
            "gid": "gid://shopify/ProductVariant/40683498045501",
            "sku": "PG-2322",
            "color": "Neon Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Neon Blue",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-neon?variant=40683498045501"
          },
          {
            "id": "40683498078269",
            "gid": "gid://shopify/ProductVariant/40683498078269",
            "sku": "PG-2323",
            "color": "Neon Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "Neon Orange",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-neon?variant=40683498078269"
          },
          {
            "id": "40683498111037",
            "gid": "gid://shopify/ProductVariant/40683498111037",
            "sku": "PG-2318",
            "color": "Neon Pink",
            "size": "Midsize",
            "selected_options": {
              "Color": "Neon Pink",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-neon?variant=40683498111037"
          },
          {
            "id": "40683498143805",
            "gid": "gid://shopify/ProductVariant/40683498143805",
            "sku": "PG-2321",
            "color": "Neon Yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "Neon Yellow",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-neon?variant=40683498143805"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "NEON",
          "Neon Blue"
        ],
        "price": 13.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-neon",
        "handle": "pure-grips-pure-pro-standard-neon",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Blue",
              "Neon Orange",
              "Neon Pink",
              "Neon Yellow"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498176573",
            "gid": "gid://shopify/ProductVariant/40683498176573",
            "sku": "PG-2224",
            "color": "Neon Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-neon?variant=40683498176573"
          },
          {
            "id": "40683498209341",
            "gid": "gid://shopify/ProductVariant/40683498209341",
            "sku": "PG-2223",
            "color": "Neon Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Orange",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-neon?variant=40683498209341"
          },
          {
            "id": "40683498242109",
            "gid": "gid://shopify/ProductVariant/40683498242109",
            "sku": "PG-2218",
            "color": "Neon Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Pink",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-neon?variant=40683498242109"
          },
          {
            "id": "40683498274877",
            "gid": "gid://shopify/ProductVariant/40683498274877",
            "sku": "PG-2221",
            "color": "Neon Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Yellow",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-neon?variant=40683498274877"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-purple",
        "handle": "grip-kit-13x-pure-pro-undersize-grips-purple",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498897469",
            "gid": "gid://shopify/ProductVariant/40683498897469",
            "sku": "SET-13xPG-2114",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-purple?variant=40683498897469"
          },
          {
            "id": "40683498930237",
            "gid": "gid://shopify/ProductVariant/40683498930237",
            "sku": "KIT(ATT)+13xPG-2114",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-purple?variant=40683498930237"
          },
          {
            "id": "40683498963005",
            "gid": "gid://shopify/ProductVariant/40683498963005",
            "sku": "KIT(CUP)+13xPG-2114",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-purple?variant=40683498963005"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-grey",
        "handle": "grip-kit-13x-pure-pro-undersize-grips-grey",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683498995773",
            "gid": "gid://shopify/ProductVariant/40683498995773",
            "sku": "SET-13xPG-131T012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-grey?variant=40683498995773"
          },
          {
            "id": "40683499028541",
            "gid": "gid://shopify/ProductVariant/40683499028541",
            "sku": "KIT(ATT)+13xPG-131T012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-grey?variant=40683499028541"
          },
          {
            "id": "40683499061309",
            "gid": "gid://shopify/ProductVariant/40683499061309",
            "sku": "KIT(CUP)+13xPG-131T012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-grey?variant=40683499061309"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-green",
        "handle": "grip-kit-13x-pure-pro-undersize-grips-green",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499094077",
            "gid": "gid://shopify/ProductVariant/40683499094077",
            "sku": "SET-13xPG-02116",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-green?variant=40683499094077"
          },
          {
            "id": "40683499126845",
            "gid": "gid://shopify/ProductVariant/40683499126845",
            "sku": "KIT(ATT)+13xPG-02116",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-green?variant=40683499126845"
          },
          {
            "id": "40683499159613",
            "gid": "gid://shopify/ProductVariant/40683499159613",
            "sku": "KIT(CUP)+13xPG-02116",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-green?variant=40683499159613"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-purple",
        "handle": "grip-kit-13x-pure-pro-standard-grips-purple",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499192381",
            "gid": "gid://shopify/ProductVariant/40683499192381",
            "sku": "SET-13xPG-2214",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-purple?variant=40683499192381"
          },
          {
            "id": "40683499225149",
            "gid": "gid://shopify/ProductVariant/40683499225149",
            "sku": "KIT(ATT)+13xPG-2214",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-purple?variant=40683499225149"
          },
          {
            "id": "40683499257917",
            "gid": "gid://shopify/ProductVariant/40683499257917",
            "sku": "KIT(CUP)+13xPG-2214",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-purple?variant=40683499257917"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-grey",
        "handle": "grip-kit-13x-pure-pro-standard-grips-grey",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499290685",
            "gid": "gid://shopify/ProductVariant/40683499290685",
            "sku": "SET-13xPG-131T132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-grey?variant=40683499290685"
          },
          {
            "id": "40683499323453",
            "gid": "gid://shopify/ProductVariant/40683499323453",
            "sku": "KIT(ATT)+13xPG-131T132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-grey?variant=40683499323453"
          },
          {
            "id": "40683499356221",
            "gid": "gid://shopify/ProductVariant/40683499356221",
            "sku": "KIT(CUP)+13xPG-131T132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-grey?variant=40683499356221"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-green",
        "handle": "grip-kit-13x-pure-pro-standard-grips-green",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499388989",
            "gid": "gid://shopify/ProductVariant/40683499388989",
            "sku": "SET-13xPG-02216",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-green?variant=40683499388989"
          },
          {
            "id": "40683499421757",
            "gid": "gid://shopify/ProductVariant/40683499421757",
            "sku": "KIT(ATT)+13xPG-02216",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-green?variant=40683499421757"
          },
          {
            "id": "40683499454525",
            "gid": "gid://shopify/ProductVariant/40683499454525",
            "sku": "KIT(CUP)+13xPG-02216",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-green?variant=40683499454525"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-purple",
        "handle": "grip-kit-13x-pure-pro-midsize-grips-purple",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499487293",
            "gid": "gid://shopify/ProductVariant/40683499487293",
            "sku": "SET-13xPG-2314",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-purple?variant=40683499487293"
          },
          {
            "id": "40683499520061",
            "gid": "gid://shopify/ProductVariant/40683499520061",
            "sku": "KIT(ATT)+13xPG-2314",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-purple?variant=40683499520061"
          },
          {
            "id": "40683499552829",
            "gid": "gid://shopify/ProductVariant/40683499552829",
            "sku": "KIT(CUP)+13xPG-2314",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-purple?variant=40683499552829"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-grey",
        "handle": "grip-kit-13x-pure-pro-midsize-grips-grey",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499585597",
            "gid": "gid://shopify/ProductVariant/40683499585597",
            "sku": "SET-13xPG-131T232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-grey?variant=40683499585597"
          },
          {
            "id": "40683499618365",
            "gid": "gid://shopify/ProductVariant/40683499618365",
            "sku": "KIT(ATT)+13xPG-131T232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-grey?variant=40683499618365"
          },
          {
            "id": "40683499651133",
            "gid": "gid://shopify/ProductVariant/40683499651133",
            "sku": "KIT(CUP)+13xPG-131T232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-grey?variant=40683499651133"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-green",
        "handle": "grip-kit-13x-pure-pro-midsize-grips-green",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499683901",
            "gid": "gid://shopify/ProductVariant/40683499683901",
            "sku": "SET-13xPG-02316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-green?variant=40683499683901"
          },
          {
            "id": "40683499716669",
            "gid": "gid://shopify/ProductVariant/40683499716669",
            "sku": "KIT(ATT)+13xPG-02316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-green?variant=40683499716669"
          },
          {
            "id": "40683499749437",
            "gid": "gid://shopify/ProductVariant/40683499749437",
            "sku": "KIT(CUP)+13xPG-02316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-green?variant=40683499749437"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Neon Pink"
        ],
        "price": 5.8,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/pure-pro-limited-edition-standard-grip-neon-pink",
        "handle": "pure-pro-limited-edition-standard-grip-neon-pink",
        "shopify_variants": [
          {
            "id": "39461766135869",
            "gid": "gid://shopify/ProductVariant/39461766135869",
            "sku": "PG-141132",
            "color": "Neon Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Pink"
            },
            "available": true,
            "price": 5.8,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/pure-pro-limited-edition-standard-grip-neon-pink?variant=39461766135869"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Pink"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Neon Pink"
        ],
        "price": 4.69,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/pure-pro-limited-edition-undersize-grip-neon-pink",
        "handle": "pure-pro-limited-edition-undersize-grip-neon-pink",
        "shopify_variants": [
          {
            "id": "39461766070333",
            "gid": "gid://shopify/ProductVariant/39461766070333",
            "sku": "PG-141012",
            "color": "Neon Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Pink"
            },
            "available": true,
            "price": 4.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/pure-pro-limited-edition-undersize-grip-neon-pink?variant=39461766070333"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Pink"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Neon Orange"
        ],
        "price": 4.59,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/pure-pro-limited-edition-standard-grip-neon-orange",
        "handle": "pure-pro-limited-edition-standard-grip-neon-orange",
        "shopify_variants": [
          {
            "id": "39461761613885",
            "gid": "gid://shopify/ProductVariant/39461761613885",
            "sku": "PG-171132",
            "color": "Neon Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Orange"
            },
            "available": true,
            "price": 4.59,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/pure-pro-limited-edition-standard-grip-neon-orange?variant=39461761613885"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Orange"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Neon Orange"
        ],
        "price": 4.69,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/pure-pro-limited-edition-undersize-grip-neon-orange",
        "handle": "pure-pro-limited-edition-undersize-grip-neon-orange",
        "shopify_variants": [
          {
            "id": "39461761548349",
            "gid": "gid://shopify/ProductVariant/39461761548349",
            "sku": "PG-171032",
            "color": "Neon Orange",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Orange"
            },
            "available": true,
            "price": 4.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/pure-pro-limited-edition-undersize-grip-neon-orange?variant=39461761548349"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Orange"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Neon Yellow"
        ],
        "price": 4.59,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/pure-pro-limited-edition-standard-grip-neon-yellow",
        "handle": "pure-pro-limited-edition-standard-grip-neon-yellow",
        "shopify_variants": [
          {
            "id": "39461761450045",
            "gid": "gid://shopify/ProductVariant/39461761450045",
            "sku": "PG-151132",
            "color": "Neon Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "Neon Yellow"
            },
            "available": true,
            "price": 4.59,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/pure-pro-limited-edition-standard-grip-neon-yellow?variant=39461761450045"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Yellow"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Neon Yellow"
        ],
        "price": 4.69,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/pure-pro-limited-edition-undersize-grip-neon-yellow",
        "handle": "pure-pro-limited-edition-undersize-grip-neon-yellow",
        "shopify_variants": [
          {
            "id": "39461761417277",
            "gid": "gid://shopify/ProductVariant/39461761417277",
            "sku": "PG-151012",
            "color": "Neon Yellow",
            "size": "Undersize",
            "selected_options": {
              "Color": "Neon Yellow"
            },
            "available": true,
            "price": 4.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/pure-pro-limited-edition-undersize-grip-neon-yellow?variant=39461761417277"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Neon Yellow"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 133.71,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-13pcs-golf-grip-kit",
        "handle": "pure-grips-pure-pro-standard-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Purple",
              "Eagle Green"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007849345085",
            "gid": "gid://shopify/ProductVariant/32007849345085",
            "sku": "KIT+13xPG-11132",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 133.71,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-13pcs-golf-grip-kit?variant=32007849345085"
          },
          {
            "id": "32007849377853",
            "gid": "gid://shopify/ProductVariant/32007849377853",
            "sku": "KIT+13xPG-131T132",
            "color": "Titanium Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 109.01,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-13pcs-golf-grip-kit?variant=32007849377853"
          },
          {
            "id": "32007849410621",
            "gid": "gid://shopify/ProductVariant/32007849410621",
            "sku": "KIT+13xPG-2214",
            "color": "Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 110.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-13pcs-golf-grip-kit?variant=32007849410621"
          },
          {
            "id": "32007849443389",
            "gid": "gid://shopify/ProductVariant/32007849443389",
            "sku": "KIT+13xPG-02216",
            "color": "Eagle Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 110.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard-13pcs-golf-grip-kit?variant=32007849443389"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-13pcs-golf-grip-kit",
        "handle": "pure-grips-pure-pro-midsize-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Purple",
              "Eagle Green"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007849082941",
            "gid": "gid://shopify/ProductVariant/32007849082941",
            "sku": "KIT+13xPG-11232",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-13pcs-golf-grip-kit?variant=32007849082941"
          },
          {
            "id": "32007849115709",
            "gid": "gid://shopify/ProductVariant/32007849115709",
            "sku": "KIT+13xPG-131T232",
            "color": "Titanium Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 111.48,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-13pcs-golf-grip-kit?variant=32007849115709"
          },
          {
            "id": "32007849148477",
            "gid": "gid://shopify/ProductVariant/32007849148477",
            "sku": "KIT+13xPG-2314",
            "color": "Purple",
            "size": "Midsize",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 112.72,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-13pcs-golf-grip-kit?variant=32007849148477"
          },
          {
            "id": "32007849181245",
            "gid": "gid://shopify/ProductVariant/32007849181245",
            "sku": "KIT+13xPG-02316",
            "color": "Eagle Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 112.72,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize-13pcs-golf-grip-kit?variant=32007849181245"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "White"
        ],
        "price": 133.71,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-13pcs-golf-grip-kit",
        "handle": "pure-grips-pure-pro-undersize-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White",
              "Titanium Grey",
              "Purple",
              "Eagle Green"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007847837757",
            "gid": "gid://shopify/ProductVariant/32007847837757",
            "sku": "KIT+13xPG-021012",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 133.71,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-13pcs-golf-grip-kit?variant=32007847837757"
          },
          {
            "id": "32007847870525",
            "gid": "gid://shopify/ProductVariant/32007847870525",
            "sku": "KIT+13xPG-131T012",
            "color": "Titanium Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 109.01,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-13pcs-golf-grip-kit?variant=32007847870525"
          },
          {
            "id": "32007847903293",
            "gid": "gid://shopify/ProductVariant/32007847903293",
            "sku": "KIT+13xPG-2114",
            "color": "Purple",
            "size": "Undersize",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 110.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-13pcs-golf-grip-kit?variant=32007847903293"
          },
          {
            "id": "32007847936061",
            "gid": "gid://shopify/ProductVariant/32007847936061",
            "sku": "KIT+13xPG-02116",
            "color": "Eagle Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 110.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize-13pcs-golf-grip-kit?variant=32007847936061"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-white",
        "handle": "grip-kit-13x-pure-pro-midsize-grips-white",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501486141",
            "gid": "gid://shopify/ProductVariant/40683501486141",
            "sku": "SET-13xPG-21232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-white?variant=40683501486141"
          },
          {
            "id": "40683501518909",
            "gid": "gid://shopify/ProductVariant/40683501518909",
            "sku": "KIT(ATT)+13xPG-21232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-white?variant=40683501518909"
          },
          {
            "id": "40683501551677",
            "gid": "gid://shopify/ProductVariant/40683501551677",
            "sku": "KIT(CUP)+13xPG-21232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-white?variant=40683501551677"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-royal-blue",
        "handle": "grip-kit-13x-pure-pro-midsize-grips-royal-blue",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501584445",
            "gid": "gid://shopify/ProductVariant/40683501584445",
            "sku": "SET-13xPG-91232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-royal-blue?variant=40683501584445"
          },
          {
            "id": "40683501617213",
            "gid": "gid://shopify/ProductVariant/40683501617213",
            "sku": "KIT(ATT)+13xPG-91232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-royal-blue?variant=40683501617213"
          },
          {
            "id": "40683501649981",
            "gid": "gid://shopify/ProductVariant/40683501649981",
            "sku": "KIT(CUP)+13xPG-91232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-royal-blue?variant=40683501649981"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-red",
        "handle": "grip-kit-13x-pure-pro-midsize-grips-red",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501682749",
            "gid": "gid://shopify/ProductVariant/40683501682749",
            "sku": "SET-13xPG-31232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-red?variant=40683501682749"
          },
          {
            "id": "40683501715517",
            "gid": "gid://shopify/ProductVariant/40683501715517",
            "sku": "KIT(ATT)+13xPG-31232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-red?variant=40683501715517"
          },
          {
            "id": "40683501748285",
            "gid": "gid://shopify/ProductVariant/40683501748285",
            "sku": "KIT(CUP)+13xPG-31232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-red?variant=40683501748285"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-black",
        "handle": "grip-kit-13x-pure-pro-midsize-grips-black",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501781053",
            "gid": "gid://shopify/ProductVariant/40683501781053",
            "sku": "SET-13xPG-11232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-black?variant=40683501781053"
          },
          {
            "id": "40683501813821",
            "gid": "gid://shopify/ProductVariant/40683501813821",
            "sku": "KIT(ATT)+13xPG-11232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-black?variant=40683501813821"
          },
          {
            "id": "40683501846589",
            "gid": "gid://shopify/ProductVariant/40683501846589",
            "sku": "KIT(CUP)+13xPG-11232",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-midsize-grips-black?variant=40683501846589"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-white",
        "handle": "grip-kit-13x-pure-pro-standard-grips-white",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501879357",
            "gid": "gid://shopify/ProductVariant/40683501879357",
            "sku": "SET-13xPG-21132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-white?variant=40683501879357"
          },
          {
            "id": "40683501912125",
            "gid": "gid://shopify/ProductVariant/40683501912125",
            "sku": "KIT(ATT)+13xPG-21132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-white?variant=40683501912125"
          },
          {
            "id": "40683501944893",
            "gid": "gid://shopify/ProductVariant/40683501944893",
            "sku": "KIT(CUP)+13xPG-21132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-white?variant=40683501944893"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-royal-blue",
        "handle": "grip-kit-13x-pure-pro-standard-grips-royal-blue",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501977661",
            "gid": "gid://shopify/ProductVariant/40683501977661",
            "sku": "SET-13xPG-91132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-royal-blue?variant=40683501977661"
          },
          {
            "id": "40683502010429",
            "gid": "gid://shopify/ProductVariant/40683502010429",
            "sku": "KIT(ATT)+13xPG-91132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-royal-blue?variant=40683502010429"
          },
          {
            "id": "40683502043197",
            "gid": "gid://shopify/ProductVariant/40683502043197",
            "sku": "KIT(CUP)+13xPG-91132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-royal-blue?variant=40683502043197"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-red",
        "handle": "grip-kit-13x-pure-pro-standard-grips-red",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683502075965",
            "gid": "gid://shopify/ProductVariant/40683502075965",
            "sku": "SET-13xPG-31132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-red?variant=40683502075965"
          },
          {
            "id": "40683502108733",
            "gid": "gid://shopify/ProductVariant/40683502108733",
            "sku": "KIT(ATT)+13xPG-31132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-red?variant=40683502108733"
          },
          {
            "id": "40683502141501",
            "gid": "gid://shopify/ProductVariant/40683502141501",
            "sku": "KIT(CUP)+13xPG-31132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-red?variant=40683502141501"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-black",
        "handle": "grip-kit-13x-pure-pro-standard-grips-black",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool) ONLY",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683502174269",
            "gid": "gid://shopify/ProductVariant/40683502174269",
            "sku": "SET-13xPG-11132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool) ONLY"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-black?variant=40683502174269"
          },
          {
            "id": "40683502207037",
            "gid": "gid://shopify/ProductVariant/40683502207037",
            "sku": "KIT(ATT)+13xPG-11132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-black?variant=40683502207037"
          },
          {
            "id": "40683502239805",
            "gid": "gid://shopify/ProductVariant/40683502239805",
            "sku": "KIT(CUP)+13xPG-11132",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-standard-grips-black?variant=40683502239805"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-white",
        "handle": "grip-kit-13x-pure-pro-undersize-grips-white",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683502534717",
            "gid": "gid://shopify/ProductVariant/40683502534717",
            "sku": "SET-13xPG-021012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-white?variant=40683502534717"
          },
          {
            "id": "40683502633021",
            "gid": "gid://shopify/ProductVariant/40683502633021",
            "sku": "KIT(ATT)+13xPG-021012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-white?variant=40683502633021"
          },
          {
            "id": "40683502764093",
            "gid": "gid://shopify/ProductVariant/40683502764093",
            "sku": "KIT(CUP)+13xPG-021012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-white?variant=40683502764093"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-royal-blue",
        "handle": "grip-kit-13x-pure-pro-undersize-grips-royal-blue",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683505582141",
            "gid": "gid://shopify/ProductVariant/40683505582141",
            "sku": "SET-13xPG-091012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-royal-blue?variant=40683505582141"
          },
          {
            "id": "40683505614909",
            "gid": "gid://shopify/ProductVariant/40683505614909",
            "sku": "KIT(ATT)+13xPG-091012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-royal-blue?variant=40683505614909"
          },
          {
            "id": "40683505647677",
            "gid": "gid://shopify/ProductVariant/40683505647677",
            "sku": "KIT(CUP)+13xPG-091012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-royal-blue?variant=40683505647677"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 135.73,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-red",
        "handle": "grip-kit-13x-pure-pro-undersize-grips-red",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683505680445",
            "gid": "gid://shopify/ProductVariant/40683505680445",
            "sku": "SET-13xPG-031012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 135.73,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-red?variant=40683505680445"
          },
          {
            "id": "40683505713213",
            "gid": "gid://shopify/ProductVariant/40683505713213",
            "sku": "KIT(ATT)+13xPG-031012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 162.09,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-red?variant=40683505713213"
          },
          {
            "id": "40683505745981",
            "gid": "gid://shopify/ProductVariant/40683505745981",
            "sku": "KIT(CUP)+13xPG-031012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 144.28,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-red?variant=40683505745981"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-black",
        "handle": "grip-kit-13x-pure-pro-undersize-grips-black",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683505778749",
            "gid": "gid://shopify/ProductVariant/40683505778749",
            "sku": "SET-13xPG-11012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-black?variant=40683505778749"
          },
          {
            "id": "40683505811517",
            "gid": "gid://shopify/ProductVariant/40683505811517",
            "sku": "KIT(ATT)+13xPG-11012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-black?variant=40683505811517"
          },
          {
            "id": "40683505844285",
            "gid": "gid://shopify/ProductVariant/40683505844285",
            "sku": "KIT(CUP)+13xPG-11012",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-pro-undersize-grips-black?variant=40683505844285"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Nassau Navy"
        ],
        "price": 4.09,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/pure-pro-undersize-grip-2017-color-collection",
        "handle": "pure-pro-undersize-grip-2017-color-collection",
        "shopify_variants": [
          {
            "id": "36205148551",
            "gid": "gid://shopify/ProductVariant/36205148551",
            "sku": "PG-241012",
            "color": "Nassau Navy",
            "size": "Undersize",
            "selected_options": {
              "Color": "Nassau Navy"
            },
            "available": true,
            "price": 4.09,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/pure-pro-undersize-grip-2017-color-collection?variant=36205148551"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Nassau Navy"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Pure Pink"
        ],
        "price": 4.09,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/pure-pro-standard-grip-2017-color-collection",
        "handle": "pure-pro-standard-grip-2017-color-collection",
        "shopify_variants": [
          {
            "id": "36205061511",
            "gid": "gid://shopify/ProductVariant/36205061511",
            "sku": "PG-221132",
            "color": "Pure Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Pure Pink"
            },
            "available": true,
            "price": 4.09,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/pure-pro-standard-grip-2017-color-collection?variant=36205061511"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Pure Pink"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "White"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize",
        "handle": "pure-grips-pure-pro-undersize",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White",
              "Black",
              "Titanium Grey",
              "Purple",
              "Red",
              "Royal Blue",
              "Eagle Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683507515453",
            "gid": "gid://shopify/ProductVariant/40683507515453",
            "sku": "PG-021012",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize?variant=40683507515453"
          },
          {
            "id": "40683507548221",
            "gid": "gid://shopify/ProductVariant/40683507548221",
            "sku": "PG-11012",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize?variant=40683507548221"
          },
          {
            "id": "40683507580989",
            "gid": "gid://shopify/ProductVariant/40683507580989",
            "sku": "PG-131T012",
            "color": "Titanium Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize?variant=40683507580989"
          },
          {
            "id": "40683507613757",
            "gid": "gid://shopify/ProductVariant/40683507613757",
            "sku": "PG-2114",
            "color": "Purple",
            "size": "Undersize",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize?variant=40683507613757"
          },
          {
            "id": "40683507646525",
            "gid": "gid://shopify/ProductVariant/40683507646525",
            "sku": "PG-031012",
            "color": "Red",
            "size": "Undersize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize?variant=40683507646525"
          },
          {
            "id": "40683507679293",
            "gid": "gid://shopify/ProductVariant/40683507679293",
            "sku": "PG-091012",
            "color": "Royal Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Royal Blue"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize?variant=40683507679293"
          },
          {
            "id": "40683507712061",
            "gid": "gid://shopify/ProductVariant/40683507712061",
            "sku": "PG-02116",
            "color": "Eagle Green",
            "size": "Undersize",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-undersize?variant=40683507712061"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize",
        "handle": "pure-grips-pure-pro-midsize",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Purple",
              "Royal Blue",
              "Eagle Green",
              "Red",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683508793405",
            "gid": "gid://shopify/ProductVariant/40683508793405",
            "sku": "PG-11232",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize?variant=40683508793405"
          },
          {
            "id": "40683508826173",
            "gid": "gid://shopify/ProductVariant/40683508826173",
            "sku": "PG-131T232",
            "color": "Titanium Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Titanium Grey",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize?variant=40683508826173"
          },
          {
            "id": "40683508858941",
            "gid": "gid://shopify/ProductVariant/40683508858941",
            "sku": "PG-2314",
            "color": "Purple",
            "size": "Midsize",
            "selected_options": {
              "Color": "Purple",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize?variant=40683508858941"
          },
          {
            "id": "40683508891709",
            "gid": "gid://shopify/ProductVariant/40683508891709",
            "sku": "PG-91232",
            "color": "Royal Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Royal Blue",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize?variant=40683508891709"
          },
          {
            "id": "40683508924477",
            "gid": "gid://shopify/ProductVariant/40683508924477",
            "sku": "PG-02316",
            "color": "Eagle Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Eagle Green",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize?variant=40683508924477"
          },
          {
            "id": "40683508957245",
            "gid": "gid://shopify/ProductVariant/40683508957245",
            "sku": "PG-31232",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize?variant=40683508957245"
          },
          {
            "id": "40683508990013",
            "gid": "gid://shopify/ProductVariant/40683508990013",
            "sku": "PG-21232",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-midsize?variant=40683508990013"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard",
        "handle": "pure-grips-pure-pro-standard",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Purple",
              "Royal Blue",
              "Eagle Green",
              "Red",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683509022781",
            "gid": "gid://shopify/ProductVariant/40683509022781",
            "sku": "PG-11132",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard?variant=40683509022781"
          },
          {
            "id": "40683509055549",
            "gid": "gid://shopify/ProductVariant/40683509055549",
            "sku": "PG-131T132",
            "color": "Titanium Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Titanium Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard?variant=40683509055549"
          },
          {
            "id": "40683509088317",
            "gid": "gid://shopify/ProductVariant/40683509088317",
            "sku": "PG-2214",
            "color": "Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard?variant=40683509088317"
          },
          {
            "id": "40683509121085",
            "gid": "gid://shopify/ProductVariant/40683509121085",
            "sku": "PG-91132",
            "color": "Royal Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Royal Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard?variant=40683509121085"
          },
          {
            "id": "40683509153853",
            "gid": "gid://shopify/ProductVariant/40683509153853",
            "sku": "PG-02216",
            "color": "Eagle Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Eagle Green",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard?variant=40683509153853"
          },
          {
            "id": "40683509186621",
            "gid": "gid://shopify/ProductVariant/40683509186621",
            "sku": "PG-31132",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard?variant=40683509186621"
          },
          {
            "id": "40683509219389",
            "gid": "gid://shopify/ProductVariant/40683509219389",
            "sku": "PG-21132",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-pro-standard?variant=40683509219389"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, blackfriday2020, fathers-day-2021-sale, firm, gifts-for-her, golf-grips, grip bundle, iron/wood, july4-2022, ladies, memsale2022, new-bundle-set, pure pro, pure-grips, rubber, single-golf-grips, under-150, under-300, undersize, undersize-golf-grips, video=kCFbPuwC2TI, womens",
    "source_quality": "manufacturer_family",
    "source_url": "https://puregrips.com/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Titanium Grey",
      "Neon Pink",
      "Neon Orange",
      "Neon Yellow",
      "Nassau Navy",
      "Pure Pink"
    ]
  },
  {
    "id": "pure-grips-pure-wrap",
    "brand": "Pure Grips",
    "model": "Pure Wrap",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (bonded, tapeless)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://puregrips.com/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Oversize / Jumbo",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black",
      "White"
    ],
    "weight_g_by_size": {
      "Standard": 71.9,
      "Midsize": 71.9,
      "Jumbo/Oversize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 8.99,
    "price_max": 272.03,
    "single_price_min": 8.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 8.54,
    "bundle_price_min": null,
    "kit_price_min": 111.03,
    "url": "https://www.grips4less.com/products/pure-grips-jumbo-wrap-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/kit-set-pure-midsize-wrap-allcolors-purple_cb53a8c4-381d-4518-92f9-5b4d246f2553.jpg?v=1736026802",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 21,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-purple",
        "handle": "grip-kit-13x-pure-wrap-standard-grips-purple",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499782205",
            "gid": "gid://shopify/ProductVariant/40683499782205",
            "sku": "SET-13xPG-3214",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-purple?variant=40683499782205"
          },
          {
            "id": "40683499814973",
            "gid": "gid://shopify/ProductVariant/40683499814973",
            "sku": "KIT(ATT)+13xPG-3214",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-purple?variant=40683499814973"
          },
          {
            "id": "40683499847741",
            "gid": "gid://shopify/ProductVariant/40683499847741",
            "sku": "KIT(CUP)+13xPG-3214",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-purple?variant=40683499847741"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-grey",
        "handle": "grip-kit-13x-pure-wrap-standard-grips-grey",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499880509",
            "gid": "gid://shopify/ProductVariant/40683499880509",
            "sku": "SET-13xPG-3215",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-grey?variant=40683499880509"
          },
          {
            "id": "40683499913277",
            "gid": "gid://shopify/ProductVariant/40683499913277",
            "sku": "KIT(ATT)+13xPG-3215",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-grey?variant=40683499913277"
          },
          {
            "id": "40683499946045",
            "gid": "gid://shopify/ProductVariant/40683499946045",
            "sku": "KIT(CUP)+13xPG-3215",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-grey?variant=40683499946045"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-green",
        "handle": "grip-kit-13x-pure-wrap-standard-grips-green",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683499978813",
            "gid": "gid://shopify/ProductVariant/40683499978813",
            "sku": "SET-13xPG-02216",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-green?variant=40683499978813"
          },
          {
            "id": "40683500011581",
            "gid": "gid://shopify/ProductVariant/40683500011581",
            "sku": "KIT(ATT)+13xPG-02216",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-green?variant=40683500011581"
          },
          {
            "id": "40683500044349",
            "gid": "gid://shopify/ProductVariant/40683500044349",
            "sku": "KIT(CUP)+13xPG-02216",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-green?variant=40683500044349"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-purple",
        "handle": "grip-kit-13x-pure-wrap-midsize-grips-purple",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683500077117",
            "gid": "gid://shopify/ProductVariant/40683500077117",
            "sku": "SET-13xPG-3314",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-purple?variant=40683500077117"
          },
          {
            "id": "40683500109885",
            "gid": "gid://shopify/ProductVariant/40683500109885",
            "sku": "KIT(ATT)+13xPG-3314",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-purple?variant=40683500109885"
          },
          {
            "id": "40683500142653",
            "gid": "gid://shopify/ProductVariant/40683500142653",
            "sku": "KIT(CUP)+13xPG-3314",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-purple?variant=40683500142653"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-grey",
        "handle": "grip-kit-13x-pure-wrap-midsize-grips-grey",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683500175421",
            "gid": "gid://shopify/ProductVariant/40683500175421",
            "sku": "SET-13xPG-3315",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-grey?variant=40683500175421"
          },
          {
            "id": "40683500208189",
            "gid": "gid://shopify/ProductVariant/40683500208189",
            "sku": "KIT(ATT)+13xPG-3315",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-grey?variant=40683500208189"
          },
          {
            "id": "40683500240957",
            "gid": "gid://shopify/ProductVariant/40683500240957",
            "sku": "KIT(CUP)+13xPG-3315",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-grey?variant=40683500240957"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-green",
        "handle": "grip-kit-13x-pure-wrap-midsize-grips-green",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683500273725",
            "gid": "gid://shopify/ProductVariant/40683500273725",
            "sku": "SET-13xPG-03316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-green?variant=40683500273725"
          },
          {
            "id": "40683500306493",
            "gid": "gid://shopify/ProductVariant/40683500306493",
            "sku": "KIT(ATT)+13xPG-03316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-green?variant=40683500306493"
          },
          {
            "id": "40683500339261",
            "gid": "gid://shopify/ProductVariant/40683500339261",
            "sku": "KIT(CUP)+13xPG-03316",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-green?variant=40683500339261"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 136.18,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap-13pcs-golf-grip-kit",
        "handle": "pure-grips-pure-midsize-wrap-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Purple",
              "Eagle Green"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007848951869",
            "gid": "gid://shopify/ProductVariant/32007848951869",
            "sku": "KIT+13xPG-11432",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap-13pcs-golf-grip-kit?variant=32007848951869"
          },
          {
            "id": "32007848984637",
            "gid": "gid://shopify/ProductVariant/32007848984637",
            "sku": "KIT+13xPG-3315",
            "color": "Titanium Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 111.48,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap-13pcs-golf-grip-kit?variant=32007848984637"
          },
          {
            "id": "32007849017405",
            "gid": "gid://shopify/ProductVariant/32007849017405",
            "sku": "KIT+13xPG-3314",
            "color": "Purple",
            "size": "Midsize",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 112.72,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap-13pcs-golf-grip-kit?variant=32007849017405"
          },
          {
            "id": "32007849050173",
            "gid": "gid://shopify/ProductVariant/32007849050173",
            "sku": "KIT+13xPG-03316",
            "color": "Eagle Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 112.72,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap-13pcs-golf-grip-kit?variant=32007849050173"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 133.71,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard-13pcs-golf-grip-kit",
        "handle": "pure-grips-p2-wrap-standard-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Purple",
              "Eagle Green"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007848820797",
            "gid": "gid://shopify/ProductVariant/32007848820797",
            "sku": "KIT+13xPG-10932",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 133.71,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard-13pcs-golf-grip-kit?variant=32007848820797"
          },
          {
            "id": "32007848853565",
            "gid": "gid://shopify/ProductVariant/32007848853565",
            "sku": "KIT+13xPG-3215",
            "color": "Titanium Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 109.01,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard-13pcs-golf-grip-kit?variant=32007848853565"
          },
          {
            "id": "32007848886333",
            "gid": "gid://shopify/ProductVariant/32007848886333",
            "sku": "KIT+13xPG-3214",
            "color": "Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 110.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard-13pcs-golf-grip-kit?variant=32007848886333"
          },
          {
            "id": "32007848919101",
            "gid": "gid://shopify/ProductVariant/32007848919101",
            "sku": "KIT+13xPG-03216",
            "color": "Eagle Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 110.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard-13pcs-golf-grip-kit?variant=32007848919101"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "White"
        ],
        "price": 272.03,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-jumbo-grips-white",
        "handle": "grip-kit-13x-pure-wrap-jumbo-grips-white",
        "shopify_variants": [
          {
            "id": "40508866311",
            "gid": "gid://shopify/ProductVariant/40508866311",
            "sku": "KIT+13xPG-022132",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 272.03,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-jumbo-grips-white?variant=40508866311"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 172.78,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-jumbo-grips-black",
        "handle": "grip-kit-13x-pure-wrap-jumbo-grips-black",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683500568637",
            "gid": "gid://shopify/ProductVariant/40683500568637",
            "sku": "SET-13xPG-012132",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 172.78,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-jumbo-grips-black?variant=40683500568637"
          },
          {
            "id": "40683500601405",
            "gid": "gid://shopify/ProductVariant/40683500601405",
            "sku": "KIT(ATT)+13xPG-012132",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 199.14,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-jumbo-grips-black?variant=40683500601405"
          },
          {
            "id": "40683500634173",
            "gid": "gid://shopify/ProductVariant/40683500634173",
            "sku": "KIT(CUP)+13xPG-012132",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 181.33,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-jumbo-grips-black?variant=40683500634173"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-white",
        "handle": "grip-kit-13x-pure-wrap-midsize-grips-white",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683500666941",
            "gid": "gid://shopify/ProductVariant/40683500666941",
            "sku": "SET-13xPG-21432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-white?variant=40683500666941"
          },
          {
            "id": "40683500699709",
            "gid": "gid://shopify/ProductVariant/40683500699709",
            "sku": "KIT(ATT)+13xPG-21432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-white?variant=40683500699709"
          },
          {
            "id": "40683500732477",
            "gid": "gid://shopify/ProductVariant/40683500732477",
            "sku": "KIT(CUP)+13xPG-21432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-white?variant=40683500732477"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-royal-blue",
        "handle": "grip-kit-13x-pure-wrap-midsize-grips-royal-blue",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683500765245",
            "gid": "gid://shopify/ProductVariant/40683500765245",
            "sku": "SET-13xPG-91432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-royal-blue?variant=40683500765245"
          },
          {
            "id": "40683500798013",
            "gid": "gid://shopify/ProductVariant/40683500798013",
            "sku": "KIT(ATT)+13xPG-91432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-royal-blue?variant=40683500798013"
          },
          {
            "id": "40683500830781",
            "gid": "gid://shopify/ProductVariant/40683500830781",
            "sku": "KIT(CUP)+13xPG-91432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-royal-blue?variant=40683500830781"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-red",
        "handle": "grip-kit-13x-pure-wrap-midsize-grips-red",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683500863549",
            "gid": "gid://shopify/ProductVariant/40683500863549",
            "sku": "SET-13xPG-31432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-red?variant=40683500863549"
          },
          {
            "id": "40683500896317",
            "gid": "gid://shopify/ProductVariant/40683500896317",
            "sku": "KIT(ATT)+13xPG-31432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-red?variant=40683500896317"
          },
          {
            "id": "40683500929085",
            "gid": "gid://shopify/ProductVariant/40683500929085",
            "sku": "KIT(CUP)+13xPG-31432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-red?variant=40683500929085"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 111.03,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-black",
        "handle": "grip-kit-13x-pure-wrap-midsize-grips-black",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683500961853",
            "gid": "gid://shopify/ProductVariant/40683500961853",
            "sku": "SET-13xPG-11432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 111.03,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-black?variant=40683500961853"
          },
          {
            "id": "40683500994621",
            "gid": "gid://shopify/ProductVariant/40683500994621",
            "sku": "KIT(ATT)+13xPG-11432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 137.39,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-black?variant=40683500994621"
          },
          {
            "id": "40683501027389",
            "gid": "gid://shopify/ProductVariant/40683501027389",
            "sku": "KIT(CUP)+13xPG-11432",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 119.58,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-midsize-grips-black?variant=40683501027389"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-white",
        "handle": "grip-kit-13x-pure-wrap-standard-grips-white",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501060157",
            "gid": "gid://shopify/ProductVariant/40683501060157",
            "sku": "SET-13xPG-20932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-white?variant=40683501060157"
          },
          {
            "id": "40683501092925",
            "gid": "gid://shopify/ProductVariant/40683501092925",
            "sku": "KIT(ATT)+13xPG-20932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-white?variant=40683501092925"
          },
          {
            "id": "40683501125693",
            "gid": "gid://shopify/ProductVariant/40683501125693",
            "sku": "KIT(CUP)+13xPG-20932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-white?variant=40683501125693"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-royal-blue",
        "handle": "grip-kit-13x-pure-wrap-standard-grips-royal-blue",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501158461",
            "gid": "gid://shopify/ProductVariant/40683501158461",
            "sku": "SET-13xPG-90932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-royal-blue?variant=40683501158461"
          },
          {
            "id": "40683501191229",
            "gid": "gid://shopify/ProductVariant/40683501191229",
            "sku": "KIT(ATT)+13xPG-90932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-royal-blue?variant=40683501191229"
          },
          {
            "id": "40683501223997",
            "gid": "gid://shopify/ProductVariant/40683501223997",
            "sku": "KIT(CUP)+13xPG-90932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-royal-blue?variant=40683501223997"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 123.38,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-red",
        "handle": "grip-kit-13x-pure-wrap-standard-grips-red",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501256765",
            "gid": "gid://shopify/ProductVariant/40683501256765",
            "sku": "SET-13xPG-30932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 123.38,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-red?variant=40683501256765"
          },
          {
            "id": "40683501289533",
            "gid": "gid://shopify/ProductVariant/40683501289533",
            "sku": "KIT(ATT)+13xPG-30932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 149.74,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-red?variant=40683501289533"
          },
          {
            "id": "40683501322301",
            "gid": "gid://shopify/ProductVariant/40683501322301",
            "sku": "KIT(CUP)+13xPG-30932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 131.93,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-red?variant=40683501322301"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 111.03,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-black",
        "handle": "grip-kit-13x-pure-wrap-standard-grips-black",
        "shopify_options": [
          {
            "name": "Option",
            "values": [
              "13pc Grips Only (No Installer Tool)",
              "13pc Grips + Installer Tool (Gun + Cup Attachment)",
              "13pc Grips + Green Cup Attachment Only"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683501355069",
            "gid": "gid://shopify/ProductVariant/40683501355069",
            "sku": "SET-13xPG-10932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips Only (No Installer Tool)"
            },
            "available": false,
            "price": 111.03,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-black?variant=40683501355069"
          },
          {
            "id": "40683501387837",
            "gid": "gid://shopify/ProductVariant/40683501387837",
            "sku": "KIT(ATT)+13xPG-10932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Installer Tool (Gun + Cup Attachment)"
            },
            "available": false,
            "price": 137.39,
            "weight_g": 1020.6,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-black?variant=40683501387837"
          },
          {
            "id": "40683501420605",
            "gid": "gid://shopify/ProductVariant/40683501420605",
            "sku": "KIT(CUP)+13xPG-10932",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Option": "13pc Grips + Green Cup Attachment Only"
            },
            "available": false,
            "price": 119.58,
            "weight_g": 975.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-pure-wrap-standard-grips-black?variant=40683501420605"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/pure-grips-jumbo-wrap-grip",
        "handle": "pure-grips-jumbo-wrap-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Purple",
              "Blue",
              "Red",
              "White",
              "Titanium Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683506597949",
            "gid": "gid://shopify/ProductVariant/40683506597949",
            "sku": "PG-012132",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-jumbo-wrap-grip?variant=40683506597949"
          },
          {
            "id": "40683506630717",
            "gid": "gid://shopify/ProductVariant/40683506630717",
            "sku": "PG-3414",
            "color": "Purple",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-jumbo-wrap-grip?variant=40683506630717"
          },
          {
            "id": "40683506663485",
            "gid": "gid://shopify/ProductVariant/40683506663485",
            "sku": "PG-3411",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-jumbo-wrap-grip?variant=40683506663485"
          },
          {
            "id": "40683506696253",
            "gid": "gid://shopify/ProductVariant/40683506696253",
            "sku": "PG-3412",
            "color": "Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-jumbo-wrap-grip?variant=40683506696253"
          },
          {
            "id": "40683506729021",
            "gid": "gid://shopify/ProductVariant/40683506729021",
            "sku": "PG-022132",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-jumbo-wrap-grip?variant=40683506729021"
          },
          {
            "id": "40683506761789",
            "gid": "gid://shopify/ProductVariant/40683506761789",
            "sku": "PG-3515",
            "color": "Titanium Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-jumbo-wrap-grip?variant=40683506761789"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard",
        "handle": "pure-grips-p2-wrap-standard",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Purple",
              "Red",
              "White",
              "Royal Blue",
              "Eagle Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683508203581",
            "gid": "gid://shopify/ProductVariant/40683508203581",
            "sku": "PG-10932",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard?variant=40683508203581"
          },
          {
            "id": "40683508236349",
            "gid": "gid://shopify/ProductVariant/40683508236349",
            "sku": "PG-3215",
            "color": "Titanium Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Titanium Grey",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard?variant=40683508236349"
          },
          {
            "id": "40683508269117",
            "gid": "gid://shopify/ProductVariant/40683508269117",
            "sku": "PG-3214",
            "color": "Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard?variant=40683508269117"
          },
          {
            "id": "40683508301885",
            "gid": "gid://shopify/ProductVariant/40683508301885",
            "sku": "PG-30932",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard?variant=40683508301885"
          },
          {
            "id": "40683508334653",
            "gid": "gid://shopify/ProductVariant/40683508334653",
            "sku": "PG-20932",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard?variant=40683508334653"
          },
          {
            "id": "40683508367421",
            "gid": "gid://shopify/ProductVariant/40683508367421",
            "sku": "PG-90932",
            "color": "Royal Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Royal Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard?variant=40683508367421"
          },
          {
            "id": "40683508400189",
            "gid": "gid://shopify/ProductVariant/40683508400189",
            "sku": "PG-03216",
            "color": "Eagle Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Eagle Green",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-p2-wrap-standard?variant=40683508400189"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap",
        "handle": "pure-grips-pure-midsize-wrap",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Titanium Grey",
              "Purple",
              "Red",
              "Royal Blue",
              "Eagle Green",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683508564029",
            "gid": "gid://shopify/ProductVariant/40683508564029",
            "sku": "PG-11432",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap?variant=40683508564029"
          },
          {
            "id": "40683508596797",
            "gid": "gid://shopify/ProductVariant/40683508596797",
            "sku": "PG-3315",
            "color": "Titanium Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Titanium Grey",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap?variant=40683508596797"
          },
          {
            "id": "40683508629565",
            "gid": "gid://shopify/ProductVariant/40683508629565",
            "sku": "PG-3314",
            "color": "Purple",
            "size": "Midsize",
            "selected_options": {
              "Color": "Purple",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap?variant=40683508629565"
          },
          {
            "id": "40683508662333",
            "gid": "gid://shopify/ProductVariant/40683508662333",
            "sku": "PG-31432",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap?variant=40683508662333"
          },
          {
            "id": "40683508695101",
            "gid": "gid://shopify/ProductVariant/40683508695101",
            "sku": "PG-91432",
            "color": "Royal Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Royal Blue",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap?variant=40683508695101"
          },
          {
            "id": "40683508727869",
            "gid": "gid://shopify/ProductVariant/40683508727869",
            "sku": "PG-03316",
            "color": "Eagle Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Eagle Green",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap?variant=40683508727869"
          },
          {
            "id": "40683508760637",
            "gid": "gid://shopify/ProductVariant/40683508760637",
            "sku": "PG-21432",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-grips-pure-midsize-wrap?variant=40683508760637"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, iron/wood, july4-2022, labor-day-bundle-sale-2025, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://puregrips.com/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "secret-grip-secret-cord",
    "brand": "Secret Grip",
    "model": "Secret Cord",
    "type": "club",
    "spec_confidence": "derived",
    "material": "full cord",
    "texture": "corded",
    "feel": "medium",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 100
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 10.99,
    "price_max": 10.99,
    "single_price_min": 10.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 10.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/secret-cord-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/secret-grip-cord.jpg?v=1636059037",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 100,
        "total_g": 100.017117585,
        "url": "https://www.grips4less.com/products/secret-cord-grip",
        "handle": "secret-cord-grip",
        "shopify_variants": [
          {
            "id": "718618877",
            "gid": "gid://shopify/ProductVariant/718618877",
            "sku": "GRSGV3-CORD",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 99.8,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/secret-cord-grip?variant=718618877"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, cord, cord-golf-grips, iron/wood, rubber, secret-grip, single-golf-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, under-150, video=jnpcMoWfaOw, wood/iron",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "silver-diamond-training",
    "brand": "Silver Diamond",
    "model": "Training",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "training_only",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Junior",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Junior",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Junior": 64,
      "Standard": 64,
      "Undersize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 7.5,
    "price_max": 60.75,
    "single_price_min": 7.5,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 6.75,
    "bundle_price_min": 60.75,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/junior-training-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/junior-training-grip.jpg?v=1735455641",
    "fit_tags": [],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Junior",
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 60.75,
        "per_grip_g": 64,
        "total_g": 576.016950663,
        "url": "https://www.grips4less.com/products/junior-training-standard-grip-grip-bundle-set",
        "handle": "junior-training-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021966385213",
            "gid": "gid://shopify/ProductVariant/41021966385213",
            "sku": "SET-9xGW-RTGJ",
            "color": "",
            "size": "",
            "selected_options": {
              "Hand": "For Right Handed Players"
            },
            "available": true,
            "price": 60.75,
            "weight_g": 576.1,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/junior-training-standard-grip-grip-bundle-set?variant=41021966385213"
          }
        ],
        "shopify_options": [
          {
            "name": "Hand",
            "values": [
              "For Right Handed Players"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Junior",
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 7.5,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/junior-training-standard-grip",
        "handle": "junior-training-standard-grip",
        "shopify_variants": [
          {
            "id": "39716471879",
            "gid": "gid://shopify/ProductVariant/39716471879",
            "sku": "GW-RTGJ",
            "color": "",
            "size": "",
            "selected_options": {
              "Hand": "For Right Handed Players"
            },
            "available": true,
            "price": 7.5,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/junior-training-standard-grip?variant=39716471879"
          }
        ],
        "shopify_options": [
          {
            "name": "Hand",
            "values": [
              "For Right Handed Players"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-ladys-training-grip",
        "handle": "lamkin-ladys-training-grip",
        "shopify_variants": [
          {
            "id": "40683358519357",
            "gid": "gid://shopify/ProductVariant/40683358519357",
            "sku": "RF26A",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-ladys-training-grip?variant=40683358519357"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All products, Golf Grips, grip bundle, junior, junior-golf-grips, new-bundle-set, prime-2025, silver-diamond, single-golf-grips, single-grip, Size_Junior, Style_Swing Grip, training, training-sets-multiclub, under-150",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "star-grip-classic-wrap-360",
    "brand": "Star Grip",
    "model": "Classic Wrap / 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "EPDM rubber (StarTack)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/collections/all-grips/products/star-classic-wrap-360-grip"
    ],
    "sizes_available": [
      "Ladies",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Ladies",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black",
      "Pink"
    ],
    "weight_g_by_size": {
      "Ladies": 71.8,
      "Undersize": 71.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 136.18,
    "single_price_min": 9.99,
    "single_price_max": 11.99,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": null,
    "kit_price_min": 136.18,
    "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-pink",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-classic-wrap-4colors_0b97f70f-4b32-489b-9067-a41a3e01c239.jpg?v=1736026899",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Ladies",
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 136.18,
        "per_grip_g": 71.8,
        "total_g": 933.992049067,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-13pc-grip-kit-bundle",
        "handle": "star-grip-classic-wrap-ladies-undersize-360-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Pink",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39493132255293",
            "gid": "gid://shopify/ProductVariant/39493132255293",
            "sku": "KIT+13xNST-BLK1411",
            "color": "Black",
            "size": "",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-13pc-grip-kit-bundle?variant=39493132255293"
          },
          {
            "id": "39493132288061",
            "gid": "gid://shopify/ProductVariant/39493132288061",
            "sku": "KIT+13xNST-RED1411",
            "color": "Red",
            "size": "",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-13pc-grip-kit-bundle?variant=39493132288061"
          },
          {
            "id": "39493132320829",
            "gid": "gid://shopify/ProductVariant/39493132320829",
            "sku": "KIT+13xNST-BLU1411",
            "color": "Blue",
            "size": "",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-13pc-grip-kit-bundle?variant=39493132320829"
          },
          {
            "id": "39493132353597",
            "gid": "gid://shopify/ProductVariant/39493132353597",
            "sku": "KIT+13xNST-PNK1411",
            "color": "Pink",
            "size": "",
            "selected_options": {
              "Color": "Pink"
            },
            "available": false,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-13pc-grip-kit-bundle?variant=39493132353597"
          },
          {
            "id": "39493132386365",
            "gid": "gid://shopify/ProductVariant/39493132386365",
            "sku": "KIT+13xNST-WHT1411",
            "color": "White",
            "size": "",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-13pc-grip-kit-bundle?variant=39493132386365"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Ladies",
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Pink"
        ],
        "price": 11.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-pink",
        "handle": "star-grip-classic-wrap-ladies-undersize-360-grip-pink",
        "shopify_variants": [
          {
            "id": "39272021065789",
            "gid": "gid://shopify/ProductVariant/39272021065789",
            "sku": "SET-1xNST-PNK1411",
            "color": "Pink",
            "size": "",
            "selected_options": {
              "Color": "Pink"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-pink?variant=39272021065789"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Pink"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Ladies",
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip",
        "handle": "star-grip-classic-wrap-ladies-undersize-360-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Pink",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31464697135165",
            "gid": "gid://shopify/ProductVariant/31464697135165",
            "sku": "NST-BLK1411",
            "color": "Black",
            "size": "",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip?variant=31464697135165"
          },
          {
            "id": "32875901911101",
            "gid": "gid://shopify/ProductVariant/32875901911101",
            "sku": "NST-RED1411",
            "color": "Red",
            "size": "",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip?variant=32875901911101"
          },
          {
            "id": "32881304830013",
            "gid": "gid://shopify/ProductVariant/32881304830013",
            "sku": "NST-BLU1411",
            "color": "Blue",
            "size": "",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip?variant=32881304830013"
          },
          {
            "id": "32881305321533",
            "gid": "gid://shopify/ProductVariant/32881305321533",
            "sku": "NST-PNK1411",
            "color": "Pink",
            "size": "",
            "selected_options": {
              "Color": "Pink"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip?variant=32881305321533"
          },
          {
            "id": "32881305616445",
            "gid": "gid://shopify/ProductVariant/32881305616445",
            "sku": "NST-WHT1411",
            "color": "White",
            "size": "",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip?variant=32881305616445"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 360, 360 grip, 360-golf-grips, All Products, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, classic wrap, free-rog-momentum-glove, gifts-for-her, golf-grips, grip kit, grip kits, grip set, grip sets, g",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/collections/all-grips/products/star-classic-wrap-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red",
      "Blue",
      "Pink"
    ]
  },
  {
    "id": "star-grip-classic-wrap-360",
    "brand": "Star Grip",
    "model": "Classic Wrap 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "EPDM rubber (StarTack)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/collections/all-grips/products/star-classic-wrap-360-grip"
    ],
    "sizes_available": [
      "Junior",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Junior",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 71.8,
      "Junior": 71.8,
      "Midsize": 71.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 7.99,
    "price_max": 141.12,
    "single_price_min": 7.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 7.99,
    "bundle_price_min": null,
    "kit_price_min": 111.48,
    "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-classic-wrap-4colors_05b09962-7e95-4b3d-9e3c-2a70b7cfd91e.jpg?v=1736026890",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 136.18,
        "per_grip_g": 71.8,
        "total_g": 933.992049067,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-13pc-grip-kit-bundle",
        "handle": "star-grip-classic-wrap-standard-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39493133434941",
            "gid": "gid://shopify/ProductVariant/39493133434941",
            "sku": "KIT+13xNST-BLK1521",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-13pc-grip-kit-bundle?variant=39493133434941"
          },
          {
            "id": "39493133467709",
            "gid": "gid://shopify/ProductVariant/39493133467709",
            "sku": "KIT+13xNST-BLU1521",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-13pc-grip-kit-bundle?variant=39493133467709"
          },
          {
            "id": "39493133500477",
            "gid": "gid://shopify/ProductVariant/39493133500477",
            "sku": "KIT+13xNST-RED1521",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-13pc-grip-kit-bundle?variant=39493133500477"
          },
          {
            "id": "39493133533245",
            "gid": "gid://shopify/ProductVariant/39493133533245",
            "sku": "KIT+13xNST-WHT1521",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-13pc-grip-kit-bundle?variant=39493133533245"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 111.48,
        "per_grip_g": 71.8,
        "total_g": 933.992049067,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-junior-360-grip-13pc-grip-kit-bundle",
        "handle": "star-grip-classic-wrap-junior-360-grip-13pc-grip-kit-bundle",
        "shopify_variants": [
          {
            "id": "39493132419133",
            "gid": "gid://shopify/ProductVariant/39493132419133",
            "sku": "KIT+13xNST-BLK2031",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 111.48,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-junior-360-grip-13pc-grip-kit-bundle?variant=39493132419133"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 141.12,
        "per_grip_g": 71.8,
        "total_g": 933.992049067,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-13pc-grip-kit-bundle",
        "handle": "star-grip-classic-wrap-midsize-360-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39493131665469",
            "gid": "gid://shopify/ProductVariant/39493131665469",
            "sku": "KIT+13xNST-BLK1621",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 141.12,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-13pc-grip-kit-bundle?variant=39493131665469"
          },
          {
            "id": "39493131698237",
            "gid": "gid://shopify/ProductVariant/39493131698237",
            "sku": "KIT+13xNST-BLU1621",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 141.12,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-13pc-grip-kit-bundle?variant=39493131698237"
          },
          {
            "id": "39493131731005",
            "gid": "gid://shopify/ProductVariant/39493131731005",
            "sku": "KIT+13xNST-RED1621",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 141.12,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-13pc-grip-kit-bundle?variant=39493131731005"
          },
          {
            "id": "39493131763773",
            "gid": "gid://shopify/ProductVariant/39493131763773",
            "sku": "KIT+13xNST-WHT1621",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 141.12,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-13pc-grip-kit-bundle?variant=39493131763773"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 10.39,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip",
        "handle": "star-grip-classic-wrap-midsize-360-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32875917279293",
            "gid": "gid://shopify/ProductVariant/32875917279293",
            "sku": "NST-BLK1621",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 10.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip?variant=32875917279293"
          },
          {
            "id": "32881300635709",
            "gid": "gid://shopify/ProductVariant/32881300635709",
            "sku": "NST-BLU1621",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 10.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip?variant=32881300635709"
          },
          {
            "id": "32881300996157",
            "gid": "gid://shopify/ProductVariant/32881300996157",
            "sku": "NST-RED1621",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 10.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip?variant=32881300996157"
          },
          {
            "id": "32881301225533",
            "gid": "gid://shopify/ProductVariant/32881301225533",
            "sku": "NST-WHT1621",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 10.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip?variant=32881301225533"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 7.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-junior-360-grip",
        "handle": "star-grip-classic-wrap-junior-360-grip",
        "shopify_variants": [
          {
            "id": "41088039845949",
            "gid": "gid://shopify/ProductVariant/41088039845949",
            "sku": "NST-BLK2031",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-junior-360-grip?variant=41088039845949"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip",
        "handle": "star-grip-classic-wrap-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1159628397",
            "gid": "gid://shopify/ProductVariant/1159628397",
            "sku": "NST-BLK1521",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip?variant=1159628397"
          },
          {
            "id": "32875894964285",
            "gid": "gid://shopify/ProductVariant/32875894964285",
            "sku": "NST-BLU1521",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip?variant=32875894964285"
          },
          {
            "id": "32875896930365",
            "gid": "gid://shopify/ProductVariant/32875896930365",
            "sku": "NST-RED1521",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip?variant=32875896930365"
          },
          {
            "id": "32881302863933",
            "gid": "gid://shopify/ProductVariant/32881302863933",
            "sku": "NST-WHT1521",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip?variant=32881302863933"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 360, 360 grip, 360-golf-grips, All Products, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, classic wrap, free-rog-momentum-glove, golf grip gift, golf-grip-kit-gifts, golf-grips, grip kit, grip kits, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/collections/all-grips/products/star-classic-wrap-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red",
      "Blue",
      "White"
    ]
  },
  {
    "id": "star-grip-sample-star-grip-sidewinder-360-grip-free-with-any-25",
    "brand": "Star Grip",
    "model": "SAMPLE: Star Grip Sidewinder 360 Grip (Free with Any $25+)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "EPDM rubber (StarTack)",
    "texture": "S-pattern texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "promotional_sample",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/products/star-sidewinder-360-grip"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Green"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 0,
    "price_max": 0,
    "single_price_min": 0,
    "single_price_max": 0,
    "normalized_price_per_grip": 0,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/sample-star-grip-sidewinder-standard-360-grip-free-with-any-25",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-sample-green-orange_02163fe7-7dc8-4ed5-9010-5f30a80fae29.jpg?v=1665852107",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green"
        ],
        "price": 0,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/sample-star-grip-sidewinder-standard-360-grip-free-with-any-25",
        "handle": "sample-star-grip-sidewinder-standard-360-grip-free-with-any-25",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green",
              "Orange"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40308192641085",
            "gid": "gid://shopify/ProductVariant/40308192641085",
            "sku": "SAMPLE-NST-GRN1221",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green"
            },
            "available": true,
            "price": 0,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/sample-star-grip-sidewinder-standard-360-grip-free-with-any-25?variant=40308192641085"
          },
          {
            "id": "40308192673853",
            "gid": "gid://shopify/ProductVariant/40308192673853",
            "sku": "SAMPLE-NST-ORN1221",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange"
            },
            "available": true,
            "price": 0,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/sample-star-grip-sidewinder-standard-360-grip-free-with-any-25?variant=40308192673853"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, 49 under, All Products, firm, golf-grips, iron/wood, july4-2022, memsale2022, Model_Star Sidewinder, no logo, sidewinder, single-golf-grips, Size_Standard, standard, standard-size-golf-grips, star-grip, star-sample, Style_Swing Grip, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/products/star-sidewinder-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Green",
      "Orange"
    ]
  },
  {
    "id": "star-grip-stx-360",
    "brand": "Star Grip",
    "model": "STX 360",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "EPDM rubber (StarTack)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/products/star-sidewinder-360-grip"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5,
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12.99,
    "price_max": 13.39,
    "single_price_min": 12.99,
    "single_price_max": 13.39,
    "normalized_price_per_grip": 12.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/star-grip-stx-midsize-360-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/star-stx-allcolors_e6e4c274-ae44-4bf3-8293-a4e2b52a79f4.jpg?v=1747688149",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13.39,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-stx-midsize-360-grip",
        "handle": "star-grip-stx-midsize-360-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52002272805234",
            "gid": "gid://shopify/ProductVariant/52002272805234",
            "sku": "NST-BLK2321",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 13.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-stx-midsize-360-grip?variant=52002272805234"
          },
          {
            "id": "52002272838002",
            "gid": "gid://shopify/ProductVariant/52002272838002",
            "sku": "NST-GRY2321",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 13.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-stx-midsize-360-grip?variant=52002272838002"
          },
          {
            "id": "52002272870770",
            "gid": "gid://shopify/ProductVariant/52002272870770",
            "sku": "NST-WHT2321",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 13.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-stx-midsize-360-grip?variant=52002272870770"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-stx-standard-grip",
        "handle": "star-grip-stx-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52002272706930",
            "gid": "gid://shopify/ProductVariant/52002272706930",
            "sku": "NST-BLK2221",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-stx-standard-grip?variant=52002272706930"
          },
          {
            "id": "52002272739698",
            "gid": "gid://shopify/ProductVariant/52002272739698",
            "sku": "NST-GRY2221",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-stx-standard-grip?variant=52002272739698"
          },
          {
            "id": "52002272772466",
            "gid": "gid://shopify/ProductVariant/52002272772466",
            "sku": "NST-WHT2221",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-stx-standard-grip?variant=52002272772466"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, 49 under, All Products, firm, golf-grips, iron/wood, july4-2022, memsale2022, midsize, midsize-golf-grips, Model_Star STX, no logo, overstock-feb-2026, overstock-mar2024, overstock-oct-2022, overstock-oct-2023, sidewinder, single-golf-grips, Size_Midsize, star-grip, st",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/products/star-sidewinder-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Grey",
      "White"
    ]
  },
  {
    "id": "star-grip-sidewinder-360",
    "brand": "Star Grip",
    "model": "Sidewinder / 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "EPDM rubber (StarTack)",
    "texture": "S-pattern texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/products/star-sidewinder-360-grip"
    ],
    "sizes_available": [
      "Ladies",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Ladies",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black",
      "Pink"
    ],
    "weight_g_by_size": {
      "Ladies": 71.8,
      "Undersize": 71.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 136.18,
    "single_price_min": 9.99,
    "single_price_max": 11.99,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": null,
    "kit_price_min": 136.18,
    "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-360-grip-pink",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-sidewinder-6colors_34b9adfe-6294-4fd4-88b7-746b4395c0bd.jpg?v=1736026895",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Ladies",
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 136.18,
        "per_grip_g": 71.8,
        "total_g": 933.992049067,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-13pc-grip-kit-bundle",
        "handle": "star-grip-sidewinder-ladies-undersize-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Green",
              "Orange",
              "Red",
              "White",
              "Pink"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39493132615741",
            "gid": "gid://shopify/ProductVariant/39493132615741",
            "sku": "KIT+13xNST-BLK1111",
            "color": "Black",
            "size": "",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-13pc-grip-kit-bundle?variant=39493132615741"
          },
          {
            "id": "39493132648509",
            "gid": "gid://shopify/ProductVariant/39493132648509",
            "sku": "KIT+13xNST-BLU1111",
            "color": "Blue",
            "size": "",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-13pc-grip-kit-bundle?variant=39493132648509"
          },
          {
            "id": "39493132681277",
            "gid": "gid://shopify/ProductVariant/39493132681277",
            "sku": "KIT+13xNST-GRN1111",
            "color": "Green",
            "size": "",
            "selected_options": {
              "Color": "Green"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-13pc-grip-kit-bundle?variant=39493132681277"
          },
          {
            "id": "39493132714045",
            "gid": "gid://shopify/ProductVariant/39493132714045",
            "sku": "KIT+13xNST-ORN1111",
            "color": "Orange",
            "size": "",
            "selected_options": {
              "Color": "Orange"
            },
            "available": true,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-13pc-grip-kit-bundle?variant=39493132714045"
          },
          {
            "id": "39493132746813",
            "gid": "gid://shopify/ProductVariant/39493132746813",
            "sku": "KIT+13xNST-RED1111",
            "color": "Red",
            "size": "",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-13pc-grip-kit-bundle?variant=39493132746813"
          },
          {
            "id": "39493132779581",
            "gid": "gid://shopify/ProductVariant/39493132779581",
            "sku": "KIT+13xNST-WHT1111",
            "color": "White",
            "size": "",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-13pc-grip-kit-bundle?variant=39493132779581"
          },
          {
            "id": "39493132812349",
            "gid": "gid://shopify/ProductVariant/39493132812349",
            "sku": "KIT+13xNST-PNK1111",
            "color": "Pink",
            "size": "",
            "selected_options": {
              "Color": "Pink"
            },
            "available": false,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-13pc-grip-kit-bundle?variant=39493132812349"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Ladies",
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Pink"
        ],
        "price": 11.99,
        "per_grip_g": 46,
        "total_g": 46,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-360-grip-pink",
        "handle": "star-grip-sidewinder-ladies-undersize-360-grip-pink",
        "shopify_variants": [
          {
            "id": "41088037748797",
            "gid": "gid://shopify/ProductVariant/41088037748797",
            "sku": "SET-1xNST-PNK1111",
            "color": "Pink",
            "size": "",
            "selected_options": {
              "Color": "Pink"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 46,
            "weight_unit": "grams",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-360-grip-pink?variant=41088037748797"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Pink"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Ladies",
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 9.99,
        "per_grip_g": 46,
        "total_g": 46,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip",
        "handle": "star-grip-sidewinder-ladies-undersize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey",
              "Blue",
              "Green",
              "Orange",
              "Red",
              "White",
              "Pink"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "30296414912573",
            "gid": "gid://shopify/ProductVariant/30296414912573",
            "sku": "NST-BLK1111",
            "color": "Black",
            "size": "",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 46,
            "weight_unit": "GRAMS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip?variant=30296414912573"
          },
          {
            "id": "39877252546621",
            "gid": "gid://shopify/ProductVariant/39877252546621",
            "sku": "NST-GRY1111",
            "color": "Grey",
            "size": "",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 46,
            "weight_unit": "GRAMS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip?variant=39877252546621"
          },
          {
            "id": "32875981406269",
            "gid": "gid://shopify/ProductVariant/32875981406269",
            "sku": "NST-BLU1111",
            "color": "Blue",
            "size": "",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 46,
            "weight_unit": "GRAMS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip?variant=32875981406269"
          },
          {
            "id": "32875981766717",
            "gid": "gid://shopify/ProductVariant/32875981766717",
            "sku": "NST-GRN1111",
            "color": "Green",
            "size": "",
            "selected_options": {
              "Color": "Green"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 46,
            "weight_unit": "GRAMS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip?variant=32875981766717"
          },
          {
            "id": "32875981832253",
            "gid": "gid://shopify/ProductVariant/32875981832253",
            "sku": "NST-ORN1111",
            "color": "Orange",
            "size": "",
            "selected_options": {
              "Color": "Orange"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 46,
            "weight_unit": "GRAMS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip?variant=32875981832253"
          },
          {
            "id": "32875981930557",
            "gid": "gid://shopify/ProductVariant/32875981930557",
            "sku": "NST-RED1111",
            "color": "Red",
            "size": "",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 46,
            "weight_unit": "GRAMS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip?variant=32875981930557"
          },
          {
            "id": "32875981963325",
            "gid": "gid://shopify/ProductVariant/32875981963325",
            "sku": "NST-WHT1111",
            "color": "White",
            "size": "",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 46,
            "weight_unit": "GRAMS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip?variant=32875981963325"
          },
          {
            "id": "32881310367805",
            "gid": "gid://shopify/ProductVariant/32881310367805",
            "sku": "NST-PNK1111",
            "color": "Pink",
            "size": "",
            "selected_options": {
              "Color": "Pink"
            },
            "available": false,
            "price": 11.99,
            "weight_g": 46,
            "weight_unit": "GRAMS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip?variant=32881310367805"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 360, 360 grip, 360-golf-grips, All Products, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, gifts-for-her, golf-grips, grip kit, grip kits, grip set, grip sets, grip-kit-",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/products/star-sidewinder-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Orange",
      "Red",
      "White",
      "Grey",
      "Green"
    ]
  },
  {
    "id": "star-grip-sidewinder-360",
    "brand": "Star Grip",
    "model": "Sidewinder 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "EPDM rubber (StarTack)",
    "texture": "S-pattern texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/products/star-sidewinder-360-grip"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 71.8,
      "Midsize": 71.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 141.12,
    "single_price_min": 9.99,
    "single_price_max": 10.39,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": null,
    "kit_price_min": 136.18,
    "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-sidewinder-6colors_a3da68b9-c655-4f6e-b2b0-7dc166095593.jpg?v=1736026892",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 136.18,
        "per_grip_g": 71.8,
        "total_g": 933.992049067,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-13pc-grip-kit-bundle",
        "handle": "star-grip-sidewinder-standard-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Green",
              "Orange",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39493133008957",
            "gid": "gid://shopify/ProductVariant/39493133008957",
            "sku": "KIT+13xNST-BLK1221",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-13pc-grip-kit-bundle?variant=39493133008957"
          },
          {
            "id": "39493133041725",
            "gid": "gid://shopify/ProductVariant/39493133041725",
            "sku": "KIT+13xNST-BLU1221",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-13pc-grip-kit-bundle?variant=39493133041725"
          },
          {
            "id": "39493133074493",
            "gid": "gid://shopify/ProductVariant/39493133074493",
            "sku": "KIT+13xNST-GRN1221",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-13pc-grip-kit-bundle?variant=39493133074493"
          },
          {
            "id": "39493133107261",
            "gid": "gid://shopify/ProductVariant/39493133107261",
            "sku": "KIT+13xNST-ORN1221",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange"
            },
            "available": false,
            "price": 160.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-13pc-grip-kit-bundle?variant=39493133107261"
          },
          {
            "id": "39493133140029",
            "gid": "gid://shopify/ProductVariant/39493133140029",
            "sku": "KIT+13xNST-RED1221",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-13pc-grip-kit-bundle?variant=39493133140029"
          },
          {
            "id": "39493133172797",
            "gid": "gid://shopify/ProductVariant/39493133172797",
            "sku": "KIT+13xNST-WHT1221",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-13pc-grip-kit-bundle?variant=39493133172797"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 141.12,
        "per_grip_g": 71.8,
        "total_g": 933.992049067,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-13pc-grip-kit-bundle",
        "handle": "star-grip-sidewinder-midsize-360-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Green",
              "Orange",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39493132058685",
            "gid": "gid://shopify/ProductVariant/39493132058685",
            "sku": "KIT+13xNST-BLK1321",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 141.12,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-13pc-grip-kit-bundle?variant=39493132058685"
          },
          {
            "id": "39493132091453",
            "gid": "gid://shopify/ProductVariant/39493132091453",
            "sku": "KIT+13xNST-BLU1321",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 141.12,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-13pc-grip-kit-bundle?variant=39493132091453"
          },
          {
            "id": "39493132124221",
            "gid": "gid://shopify/ProductVariant/39493132124221",
            "sku": "KIT+13xNST-GRN1321",
            "color": "Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green"
            },
            "available": false,
            "price": 141.12,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-13pc-grip-kit-bundle?variant=39493132124221"
          },
          {
            "id": "39493132156989",
            "gid": "gid://shopify/ProductVariant/39493132156989",
            "sku": "KIT+13xNST-ORN1321",
            "color": "Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "Orange"
            },
            "available": false,
            "price": 165.82,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-13pc-grip-kit-bundle?variant=39493132156989"
          },
          {
            "id": "39493132189757",
            "gid": "gid://shopify/ProductVariant/39493132189757",
            "sku": "KIT+13xNST-RED1321",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 141.12,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-13pc-grip-kit-bundle?variant=39493132189757"
          },
          {
            "id": "39493132222525",
            "gid": "gid://shopify/ProductVariant/39493132222525",
            "sku": "KIT+13xNST-WHT1321",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 141.12,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-13pc-grip-kit-bundle?variant=39493132222525"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 10.39,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip",
        "handle": "star-grip-sidewinder-midsize-360-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Green",
              "Orange",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41088039125053",
            "gid": "gid://shopify/ProductVariant/41088039125053",
            "sku": "NST-BLK1321",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 10.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip?variant=41088039125053"
          },
          {
            "id": "41088039157821",
            "gid": "gid://shopify/ProductVariant/41088039157821",
            "sku": "NST-BLU1321",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 10.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip?variant=41088039157821"
          },
          {
            "id": "41088039190589",
            "gid": "gid://shopify/ProductVariant/41088039190589",
            "sku": "NST-GRN1321",
            "color": "Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green"
            },
            "available": false,
            "price": 10.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip?variant=41088039190589"
          },
          {
            "id": "41088039223357",
            "gid": "gid://shopify/ProductVariant/41088039223357",
            "sku": "NST-ORN1321",
            "color": "Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "Orange"
            },
            "available": false,
            "price": 12.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip?variant=41088039223357"
          },
          {
            "id": "41088039256125",
            "gid": "gid://shopify/ProductVariant/41088039256125",
            "sku": "NST-RED1321",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 10.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip?variant=41088039256125"
          },
          {
            "id": "41088039288893",
            "gid": "gid://shopify/ProductVariant/41088039288893",
            "sku": "NST-WHT1321",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 10.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip?variant=41088039288893"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip",
        "handle": "star-grip-sidewinder-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey",
              "Blue",
              "Green",
              "Orange",
              "Red",
              "White",
              "Pink"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1159632717",
            "gid": "gid://shopify/ProductVariant/1159632717",
            "sku": "NST-BLK1221",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip?variant=1159632717"
          },
          {
            "id": "39877253365821",
            "gid": "gid://shopify/ProductVariant/39877253365821",
            "sku": "NST-GRY1221",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip?variant=39877253365821"
          },
          {
            "id": "32876008046653",
            "gid": "gid://shopify/ProductVariant/32876008046653",
            "sku": "NST-BLU1221",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip?variant=32876008046653"
          },
          {
            "id": "32876008996925",
            "gid": "gid://shopify/ProductVariant/32876008996925",
            "sku": "NST-GRN1221",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip?variant=32876008996925"
          },
          {
            "id": "32876009947197",
            "gid": "gid://shopify/ProductVariant/32876009947197",
            "sku": "NST-ORN1221",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip?variant=32876009947197"
          },
          {
            "id": "32876010897469",
            "gid": "gid://shopify/ProductVariant/32876010897469",
            "sku": "NST-RED1221",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip?variant=32876010897469"
          },
          {
            "id": "32876011847741",
            "gid": "gid://shopify/ProductVariant/32876011847741",
            "sku": "NST-WHT1221",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip?variant=32876011847741"
          },
          {
            "id": "51667701760370",
            "gid": "gid://shopify/ProductVariant/51667701760370",
            "sku": "NST-PNK1221",
            "color": "Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Pink"
            },
            "available": true,
            "price": 11.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip?variant=51667701760370"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 360, 360 grip, 360-golf-grips, All Products, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, golf-grips, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/products/star-sidewinder-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Blue",
      "Green",
      "Red",
      "White",
      "Grey",
      "Orange",
      "Pink"
    ]
  },
  {
    "id": "star-grip-tour-star-360",
    "brand": "Star Grip",
    "model": "Tour Star + 360",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "EPDM rubber (StarTack)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/products/star-sidewinder-360-grip"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 71.8,
      "Jumbo/Oversize": 71.8
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 148.53,
    "single_price_min": 9.99,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": null,
    "kit_price_min": 136.18,
    "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-tour-star-allcolors_1431d706-1cd7-4827-8e34-4dc57386426f.jpg?v=1736026903",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 136.18,
        "per_grip_g": 71.8,
        "total_g": 933.992049067,
        "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-13pc-grip-kit-bundle",
        "handle": "star-grip-tour-star-standard-360-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "White",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39493131927613",
            "gid": "gid://shopify/ProductVariant/39493131927613",
            "sku": "KIT+13xNST-BLK1721",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-13pc-grip-kit-bundle?variant=39493131927613"
          },
          {
            "id": "39493131960381",
            "gid": "gid://shopify/ProductVariant/39493131960381",
            "sku": "KIT+13xNST-BLU1721",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-13pc-grip-kit-bundle?variant=39493131960381"
          },
          {
            "id": "39493131993149",
            "gid": "gid://shopify/ProductVariant/39493131993149",
            "sku": "KIT+13xNST-WHT1721",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-13pc-grip-kit-bundle?variant=39493131993149"
          },
          {
            "id": "39493132025917",
            "gid": "gid://shopify/ProductVariant/39493132025917",
            "sku": "KIT+13xNST-RED1721",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 136.18,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-13pc-grip-kit-bundle?variant=39493132025917"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 148.53,
        "per_grip_g": 71.8,
        "total_g": 933.992049067,
        "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-13pc-grip-kit-bundle",
        "handle": "star-grip-tour-star-oversize-360-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "White",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39493131796541",
            "gid": "gid://shopify/ProductVariant/39493131796541",
            "sku": "KIT+13xNST-BLK1821",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-13pc-grip-kit-bundle?variant=39493131796541"
          },
          {
            "id": "39493131829309",
            "gid": "gid://shopify/ProductVariant/39493131829309",
            "sku": "KIT+13xNST-BLU1821",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-13pc-grip-kit-bundle?variant=39493131829309"
          },
          {
            "id": "39493131862077",
            "gid": "gid://shopify/ProductVariant/39493131862077",
            "sku": "KIT+13xNST-WHT1821",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-13pc-grip-kit-bundle?variant=39493131862077"
          },
          {
            "id": "39493131894845",
            "gid": "gid://shopify/ProductVariant/39493131894845",
            "sku": "KIT+13xNST-RED1821",
            "color": "Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 148.53,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-13pc-grip-kit-bundle?variant=39493131894845"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 10.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip",
        "handle": "star-grip-tour-star-oversize-360-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "White",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31464722169917",
            "gid": "gid://shopify/ProductVariant/31464722169917",
            "sku": "NST-BLK1821",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip?variant=31464722169917"
          },
          {
            "id": "32876095045693",
            "gid": "gid://shopify/ProductVariant/32876095045693",
            "sku": "NST-BLU1821",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip?variant=32876095045693"
          },
          {
            "id": "32876095209533",
            "gid": "gid://shopify/ProductVariant/32876095209533",
            "sku": "NST-WHT1821",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip?variant=32876095209533"
          },
          {
            "id": "32876095242301",
            "gid": "gid://shopify/ProductVariant/32876095242301",
            "sku": "NST-RED1821",
            "color": "Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip?variant=32876095242301"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip",
        "handle": "star-grip-tour-star-standard-360-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "White",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31464722006077",
            "gid": "gid://shopify/ProductVariant/31464722006077",
            "sku": "NST-BLK1721",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip?variant=31464722006077"
          },
          {
            "id": "32876093276221",
            "gid": "gid://shopify/ProductVariant/32876093276221",
            "sku": "NST-BLU1721",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip?variant=32876093276221"
          },
          {
            "id": "32876093308989",
            "gid": "gid://shopify/ProductVariant/32876093308989",
            "sku": "NST-WHT1721",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip?variant=32876093308989"
          },
          {
            "id": "32876094259261",
            "gid": "gid://shopify/ProductVariant/32876094259261",
            "sku": "NST-RED1721",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip?variant=32876094259261"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 360, 360 grip, 360-golf-grips, All Products, bf-nonassembled, bf-sale, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, golf-grips, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripkit-sh",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/products/star-sidewinder-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "White",
      "Black",
      "Red"
    ]
  },
  {
    "id": "star-grip-s-classic-wrap-360",
    "brand": "Star Grip",
    "model": "s Classic Wrap / 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "EPDM rubber (StarTack)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/collections/all-grips/products/star-classic-wrap-360-grip"
    ],
    "sizes_available": [
      "Ladies",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Ladies",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Ladies": 63.5,
      "Undersize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 89.91,
    "price_max": 89.91,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": 89.91,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-classic-wrap-4colors_b502bae0-bd38-4427-9159-73bc9e38bdc3.jpg?v=1735455677",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Ladies",
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 89.91,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-grip-bundle-set",
        "handle": "star-grip-classic-wrap-ladies-undersize-360-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Pink",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021961502781",
            "gid": "gid://shopify/ProductVariant/41021961502781",
            "sku": "SET-9xNST-BLK1411",
            "color": "Black",
            "size": "",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-grip-bundle-set?variant=41021961502781"
          },
          {
            "id": "41021961535549",
            "gid": "gid://shopify/ProductVariant/41021961535549",
            "sku": "SET-9xNST-RED1411",
            "color": "Red",
            "size": "",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-grip-bundle-set?variant=41021961535549"
          },
          {
            "id": "41021961568317",
            "gid": "gid://shopify/ProductVariant/41021961568317",
            "sku": "SET-9xNST-BLU1411",
            "color": "Blue",
            "size": "",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-grip-bundle-set?variant=41021961568317"
          },
          {
            "id": "41021961601085",
            "gid": "gid://shopify/ProductVariant/41021961601085",
            "sku": "SET-9xNST-PNK1411",
            "color": "Pink",
            "size": "",
            "selected_options": {
              "Color": "Pink"
            },
            "available": true,
            "price": 107.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-grip-bundle-set?variant=41021961601085"
          },
          {
            "id": "41021961633853",
            "gid": "gid://shopify/ProductVariant/41021961633853",
            "sku": "SET-9xNST-WHT1411",
            "color": "White",
            "size": "",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-ladies-undersize-360-grip-grip-bundle-set?variant=41021961633853"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, All Products, classic wrap, gifts-for-her, golf-grips, grip bundle, iron/wood, july4-2022, ladies, mem25, memsale2022, Model_Star Classic Wrap, new-bundle-set, no logo, overstock-feb-2026, overstock-oct-2022, overstock-oct-2023, prime-2025, single-golf-grips, Size_Unde",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/collections/all-grips/products/star-classic-wrap-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red",
      "Blue",
      "Pink"
    ]
  },
  {
    "id": "star-grip-s-classic-wrap-360",
    "brand": "Star Grip",
    "model": "s Classic Wrap 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "EPDM rubber (StarTack)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/collections/all-grips/products/star-classic-wrap-360-grip"
    ],
    "sizes_available": [
      "Junior",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Junior",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Junior": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 71.91,
    "price_max": 98.91,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 7.99,
    "bundle_price_min": 71.91,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-classic-wrap-4colors_81dbbbe3-aad8-4a63-87ea-d104b4c36186.jpg?v=1735455622",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 98.91,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-grip-bundle-set",
        "handle": "star-grip-classic-wrap-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021968187453",
            "gid": "gid://shopify/ProductVariant/41021968187453",
            "sku": "SET-9xNST-BLK1521",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 98.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-grip-bundle-set?variant=41021968187453"
          },
          {
            "id": "41021968220221",
            "gid": "gid://shopify/ProductVariant/41021968220221",
            "sku": "SET-9xNST-BLU1521",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-grip-bundle-set?variant=41021968220221"
          },
          {
            "id": "41021968252989",
            "gid": "gid://shopify/ProductVariant/41021968252989",
            "sku": "SET-9xNST-RED1521",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-grip-bundle-set?variant=41021968252989"
          },
          {
            "id": "41021968285757",
            "gid": "gid://shopify/ProductVariant/41021968285757",
            "sku": "SET-9xNST-WHT1521",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-standard-grip-grip-bundle-set?variant=41021968285757"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 71.91,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-junior-360-grip-grip-bundle-set",
        "handle": "star-grip-classic-wrap-junior-360-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021961666621",
            "gid": "gid://shopify/ProductVariant/41021961666621",
            "sku": "SET-9xNST-BLK2031",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 71.91,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-junior-360-grip-grip-bundle-set?variant=41021961666621"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 93.51,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-grip-bundle-set",
        "handle": "star-grip-classic-wrap-midsize-360-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021959503933",
            "gid": "gid://shopify/ProductVariant/41021959503933",
            "sku": "SET-9xNST-BLK1621",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 93.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-grip-bundle-set?variant=41021959503933"
          },
          {
            "id": "41021959536701",
            "gid": "gid://shopify/ProductVariant/41021959536701",
            "sku": "SET-9xNST-BLU1621",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 93.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-grip-bundle-set?variant=41021959536701"
          },
          {
            "id": "41021959569469",
            "gid": "gid://shopify/ProductVariant/41021959569469",
            "sku": "SET-9xNST-RED1621",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 93.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-grip-bundle-set?variant=41021959569469"
          },
          {
            "id": "41021959602237",
            "gid": "gid://shopify/ProductVariant/41021959602237",
            "sku": "SET-9xNST-WHT1621",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 93.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-classic-wrap-midsize-360-grip-grip-bundle-set?variant=41021959602237"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, All Products, classic wrap, golf-grips, grip bundle, iron/wood, july4-2022, mem25, memsale2022, Model_Star Classic Wrap, new-bundle-set, no logo, overstock-feb-2026, overstock-oct-2022, overstock-oct-2023, prime-2025, single-golf-grips, Size_Standard, soft, standard, s",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/collections/all-grips/products/star-classic-wrap-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red",
      "Blue",
      "White"
    ]
  },
  {
    "id": "star-grip-s-sidewinder-360",
    "brand": "Star Grip",
    "model": "s Sidewinder / 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "EPDM rubber (StarTack)",
    "texture": "S-pattern texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/products/star-sidewinder-360-grip"
    ],
    "sizes_available": [
      "Ladies",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Ladies",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Ladies": 63.5,
      "Undersize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 89.91,
    "price_max": 89.91,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": 89.91,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-sidewinder-6colors_de6a1ec2-fe25-42aa-81fe-28c9cfba47d8.jpg?v=1735455672",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Ladies",
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 89.91,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set",
        "handle": "star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey",
              "Blue",
              "Green",
              "Orange",
              "Red",
              "White",
              "Pink"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021961895997",
            "gid": "gid://shopify/ProductVariant/41021961895997",
            "sku": "SET-9xNST-BLK1111",
            "color": "Black",
            "size": "",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set?variant=41021961895997"
          },
          {
            "id": "41021961928765",
            "gid": "gid://shopify/ProductVariant/41021961928765",
            "sku": "SET-9xNST-GRY1111",
            "color": "Grey",
            "size": "",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set?variant=41021961928765"
          },
          {
            "id": "41021961961533",
            "gid": "gid://shopify/ProductVariant/41021961961533",
            "sku": "SET-9xNST-BLU1111",
            "color": "Blue",
            "size": "",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set?variant=41021961961533"
          },
          {
            "id": "41021961994301",
            "gid": "gid://shopify/ProductVariant/41021961994301",
            "sku": "SET-9xNST-GRN1111",
            "color": "Green",
            "size": "",
            "selected_options": {
              "Color": "Green"
            },
            "available": false,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set?variant=41021961994301"
          },
          {
            "id": "41021962027069",
            "gid": "gid://shopify/ProductVariant/41021962027069",
            "sku": "SET-9xNST-ORN1111",
            "color": "Orange",
            "size": "",
            "selected_options": {
              "Color": "Orange"
            },
            "available": true,
            "price": 107.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set?variant=41021962027069"
          },
          {
            "id": "41021962059837",
            "gid": "gid://shopify/ProductVariant/41021962059837",
            "sku": "SET-9xNST-RED1111",
            "color": "Red",
            "size": "",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set?variant=41021962059837"
          },
          {
            "id": "41021962092605",
            "gid": "gid://shopify/ProductVariant/41021962092605",
            "sku": "SET-9xNST-WHT1111",
            "color": "White",
            "size": "",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set?variant=41021962092605"
          },
          {
            "id": "41021962125373",
            "gid": "gid://shopify/ProductVariant/41021962125373",
            "sku": "SET-9xNST-PNK1111",
            "color": "Pink",
            "size": "",
            "selected_options": {
              "Color": "Pink"
            },
            "available": false,
            "price": 107.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-ladies-undersize-grip-grip-bundle-set?variant=41021962125373"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, All Products, firm, gifts-for-her, golf-grips, grip bundle, iron/wood, july4-2022, ladies, mem25, memsale2022, Model_Star Sidewinder, new-bundle-set, no-logo, overstock-feb-2026, overstock-oct-2022, overstock-oct-2023, prime-2025, sidewinder, single-golf-grips, Size_Un",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/products/star-sidewinder-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Grey",
      "Orange",
      "Red",
      "White"
    ]
  },
  {
    "id": "star-grip-s-sidewinder-360",
    "brand": "Star Grip",
    "model": "s Sidewinder 360",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "EPDM rubber (StarTack)",
    "texture": "S-pattern texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/products/star-sidewinder-360-grip"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 89.91,
    "price_max": 93.51,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": 89.91,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-sidewinder-6colors_6109199b-c5d2-4c44-8d5f-251e911a9369.jpg?v=1735455623",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 89.91,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-grip-bundle-set",
        "handle": "star-grip-sidewinder-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey",
              "Blue",
              "Green",
              "Orange",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021967958077",
            "gid": "gid://shopify/ProductVariant/41021967958077",
            "sku": "SET-9xNST-BLK1221",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-grip-bundle-set?variant=41021967958077"
          },
          {
            "id": "41021967990845",
            "gid": "gid://shopify/ProductVariant/41021967990845",
            "sku": "SET-9xNST-GRY1221",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-grip-bundle-set?variant=41021967990845"
          },
          {
            "id": "41021968023613",
            "gid": "gid://shopify/ProductVariant/41021968023613",
            "sku": "SET-9xNST-BLU1221",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-grip-bundle-set?variant=41021968023613"
          },
          {
            "id": "41021968056381",
            "gid": "gid://shopify/ProductVariant/41021968056381",
            "sku": "SET-9xNST-GRN1221",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-grip-bundle-set?variant=41021968056381"
          },
          {
            "id": "41021968089149",
            "gid": "gid://shopify/ProductVariant/41021968089149",
            "sku": "SET-9xNST-ORN1221",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange"
            },
            "available": false,
            "price": 107.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-grip-bundle-set?variant=41021968089149"
          },
          {
            "id": "41021968121917",
            "gid": "gid://shopify/ProductVariant/41021968121917",
            "sku": "SET-9xNST-RED1221",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-grip-bundle-set?variant=41021968121917"
          },
          {
            "id": "41021968154685",
            "gid": "gid://shopify/ProductVariant/41021968154685",
            "sku": "SET-9xNST-WHT1221",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-standard-grip-grip-bundle-set?variant=41021968154685"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 93.51,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-grip-bundle-set",
        "handle": "star-grip-sidewinder-midsize-360-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Green",
              "Orange",
              "Red",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021961306173",
            "gid": "gid://shopify/ProductVariant/41021961306173",
            "sku": "SET-9xNST-BLK1321",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 93.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-grip-bundle-set?variant=41021961306173"
          },
          {
            "id": "41021961338941",
            "gid": "gid://shopify/ProductVariant/41021961338941",
            "sku": "SET-9xNST-BLU1321",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 93.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-grip-bundle-set?variant=41021961338941"
          },
          {
            "id": "41021961371709",
            "gid": "gid://shopify/ProductVariant/41021961371709",
            "sku": "SET-9xNST-GRN1321",
            "color": "Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green"
            },
            "available": false,
            "price": 93.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-grip-bundle-set?variant=41021961371709"
          },
          {
            "id": "41021961404477",
            "gid": "gid://shopify/ProductVariant/41021961404477",
            "sku": "SET-9xNST-ORN1321",
            "color": "Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "Orange"
            },
            "available": false,
            "price": 111.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-grip-bundle-set?variant=41021961404477"
          },
          {
            "id": "41021961437245",
            "gid": "gid://shopify/ProductVariant/41021961437245",
            "sku": "SET-9xNST-RED1321",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 93.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-grip-bundle-set?variant=41021961437245"
          },
          {
            "id": "41021961470013",
            "gid": "gid://shopify/ProductVariant/41021961470013",
            "sku": "SET-9xNST-WHT1321",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 93.51,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-sidewinder-midsize-360-grip-grip-bundle-set?variant=41021961470013"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, All Products, firm, golf-grips, grip bundle, iron/wood, july4-2022, mem25, memsale2022, Model_Star Sidewinder, new-bundle-set, no logo, overstock-feb-2026, overstock-oct-2024, prime-2025, sidewinder, single-golf-grips, Size_Standard, standard, standard-size-golf-grips,",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/products/star-sidewinder-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Grey",
      "Blue",
      "Green",
      "Red",
      "White"
    ]
  },
  {
    "id": "star-grip-s-tour-star-360",
    "brand": "Star Grip",
    "model": "s Tour Star + 360",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "EPDM rubber (StarTack)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://stargrip.com/products/star-sidewinder-360-grip"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 89.91,
    "price_max": 98.91,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": 89.91,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/star-tour-star-allcolors_68ca52f7-2865-4c59-9f0b-686e6842ea19.jpg?v=1735455679",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 89.91,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-grip-bundle-set",
        "handle": "star-grip-tour-star-standard-360-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "White",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021961175101",
            "gid": "gid://shopify/ProductVariant/41021961175101",
            "sku": "SET-9xNST-BLK1721",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-grip-bundle-set?variant=41021961175101"
          },
          {
            "id": "41021961207869",
            "gid": "gid://shopify/ProductVariant/41021961207869",
            "sku": "SET-9xNST-BLU1721",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-grip-bundle-set?variant=41021961207869"
          },
          {
            "id": "41021961240637",
            "gid": "gid://shopify/ProductVariant/41021961240637",
            "sku": "SET-9xNST-WHT1721",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-grip-bundle-set?variant=41021961240637"
          },
          {
            "id": "41021961273405",
            "gid": "gid://shopify/ProductVariant/41021961273405",
            "sku": "SET-9xNST-RED1721",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 89.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-standard-360-grip-grip-bundle-set?variant=41021961273405"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 98.91,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-grip-bundle-set",
        "handle": "star-grip-tour-star-oversize-360-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "White",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021961044029",
            "gid": "gid://shopify/ProductVariant/41021961044029",
            "sku": "SET-9xNST-BLK1821",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 98.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-grip-bundle-set?variant=41021961044029"
          },
          {
            "id": "41021961076797",
            "gid": "gid://shopify/ProductVariant/41021961076797",
            "sku": "SET-9xNST-BLU1821",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 98.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-grip-bundle-set?variant=41021961076797"
          },
          {
            "id": "41021961109565",
            "gid": "gid://shopify/ProductVariant/41021961109565",
            "sku": "SET-9xNST-WHT1821",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 98.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-grip-bundle-set?variant=41021961109565"
          },
          {
            "id": "41021961142333",
            "gid": "gid://shopify/ProductVariant/41021961142333",
            "sku": "SET-9xNST-RED1821",
            "color": "Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 98.91,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-grip-tour-star-oversize-360-grip-grip-bundle-set?variant=41021961142333"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "360, 360 grip, 360-golf-grips, All Products, golf-grips, grip bundle, iron/wood, july4-2022, Less Tapered, mem25, memsale2022, Model_Star Tour Star, new-bundle-set, no logo, overstock-feb-2026, prime-2025, reduced taper, single-golf-grips, Size_Standard, soft, standard, standard-size-golf-grips, Sta",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/products/star-sidewinder-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Blue",
      "White",
      "Red"
    ]
  },
  {
    "id": "stick-grip-gaucho",
    "brand": "Stick Grip",
    "model": "Gaucho",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Clay",
      "Pink"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.49,
    "price_max": 13.49,
    "single_price_min": 13.49,
    "single_price_max": 13.49,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-pink",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ScreenShot2025-03-20at12.01.53PM.png?v=1744323562",
    "fit_tags": [],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Pink"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-pink",
        "handle": "stick-grip-gaucho-standard-grip-pink",
        "shopify_variants": [
          {
            "id": "51845877858674",
            "gid": "gid://shopify/ProductVariant/51845877858674",
            "sku": "STG-Guacho-Grip-Pink",
            "color": "Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Pink",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-pink?variant=51845877858674"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Pink"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Clay"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-clay",
        "handle": "stick-grip-gaucho-standard-grip-clay",
        "shopify_variants": [
          {
            "id": "51845877825906",
            "gid": "gid://shopify/ProductVariant/51845877825906",
            "sku": "STG-Guacho-Grip-Clay",
            "color": "Clay",
            "size": "Standard",
            "selected_options": {
              "Color": "Clay",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-clay?variant=51845877825906"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Clay"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, standard, standard-golf-grips, stick grip, stickgrip",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Pink"
    ]
  },
  {
    "id": "stick-grip-guacho",
    "brand": "Stick Grip",
    "model": "Guacho",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Agave Green"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.49,
    "price_max": 13.49,
    "single_price_min": 13.49,
    "single_price_max": 13.49,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-agave-green",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ScreenShot2025-03-20at12.15.04PM.png?v=1744323564",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Agave Green"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-agave-green",
        "handle": "stick-grip-gaucho-standard-grip-agave-green",
        "shopify_variants": [
          {
            "id": "51845877530994",
            "gid": "gid://shopify/ProductVariant/51845877530994",
            "sku": "STG-Guacho-Grip-Green",
            "color": "Agave Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Agave Green",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-agave-green?variant=51845877530994"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Agave Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, standard, standard-golf-grips, stick grip, stickgrip",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Agave Green"
    ]
  },
  {
    "id": "stick-grip-shamrock",
    "brand": "Stick Grip",
    "model": "Shamrock",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Dark Green",
      "Light Green",
      "White"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.49,
    "price_max": 13.49,
    "single_price_min": 13.49,
    "single_price_max": 13.49,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/stick-grip-shamrock-standard-grip-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ScreenShot2025-03-19at1.29.48PM.png?v=1744323555",
    "fit_tags": [],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "White"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-shamrock-standard-grip-white",
        "handle": "stick-grip-shamrock-standard-grip-white",
        "shopify_variants": [
          {
            "id": "51845879398770",
            "gid": "gid://shopify/ProductVariant/51845879398770",
            "sku": "STG-LAD-White-Grip",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-shamrock-standard-grip-white?variant=51845879398770"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Light Green"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-shamrock-standard-grip-light-green",
        "handle": "stick-grip-shamrock-standard-grip-light-green",
        "shopify_variants": [
          {
            "id": "51845878940018",
            "gid": "gid://shopify/ProductVariant/51845878940018",
            "sku": "STG-LAD-LightGreen-Grip",
            "color": "Light Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Light Green",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-shamrock-standard-grip-light-green?variant=51845878940018"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Light Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Dark Green"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-shamrock-standard-grip-dark-green",
        "handle": "stick-grip-shamrock-standard-grip-dark-green",
        "shopify_variants": [
          {
            "id": "51845878579570",
            "gid": "gid://shopify/ProductVariant/51845878579570",
            "sku": "STG-LAD-DarkGreen-Grip",
            "color": "Dark Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Dark Green",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-shamrock-standard-grip-dark-green?variant=51845878579570"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, standard, standard-golf-grips, stick grip, stickgrip",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White",
      "Light Green",
      "Dark Green"
    ]
  },
  {
    "id": "stick-grip-topography",
    "brand": "Stick Grip",
    "model": "Topography",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "style_forward",
    "non_black_color_count": 6,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Dark Blue",
      "Green",
      "Grey",
      "Light Blue",
      "Purple",
      "Tan"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.49,
    "price_max": 13.49,
    "single_price_min": 13.49,
    "single_price_max": 13.49,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-purple",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ScreenShot2025-03-18at5.52.45PM.png?v=1744323547",
    "fit_tags": [],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Purple"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-purple",
        "handle": "stick-grip-topography-standard-grip-purple",
        "shopify_variants": [
          {
            "id": "51845880643954",
            "gid": "gid://shopify/ProductVariant/51845880643954",
            "sku": "STG-TOPO-Purple-Grip",
            "color": "Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-purple?variant=51845880643954"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Purple"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Tan"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-tan",
        "handle": "stick-grip-topography-standard-grip-tan",
        "shopify_variants": [
          {
            "id": "51845880349042",
            "gid": "gid://shopify/ProductVariant/51845880349042",
            "sku": "STG-TOPO-Tan-Grip",
            "color": "Tan",
            "size": "Standard",
            "selected_options": {
              "Color": "Tan",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-tan?variant=51845880349042"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Tan"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Light Blue"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-light-blue",
        "handle": "stick-grip-topography-standard-grip-light-blue",
        "shopify_variants": [
          {
            "id": "51845880316274",
            "gid": "gid://shopify/ProductVariant/51845880316274",
            "sku": "STG-TOPO-LightBlue-Grip",
            "color": "Light Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Light Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-light-blue?variant=51845880316274"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Light Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-grey",
        "handle": "stick-grip-topography-standard-grip-grey",
        "shopify_variants": [
          {
            "id": "51845880217970",
            "gid": "gid://shopify/ProductVariant/51845880217970",
            "sku": "STG-TOPO-Grey-Grip",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-grey?variant=51845880217970"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-green",
        "handle": "stick-grip-topography-standard-grip-green",
        "shopify_variants": [
          {
            "id": "51845879791986",
            "gid": "gid://shopify/ProductVariant/51845879791986",
            "sku": "STG-TOPO-Green-Grip",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-green?variant=51845879791986"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Dark Blue"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-dark-blue",
        "handle": "stick-grip-topography-standard-grip-dark-blue",
        "shopify_variants": [
          {
            "id": "51845879628146",
            "gid": "gid://shopify/ProductVariant/51845879628146",
            "sku": "STG-TOPO-DarkBlue-Grip",
            "color": "Dark Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Dark Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-topography-standard-grip-dark-blue?variant=51845879628146"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, standard, standard-golf-grips, stick grip, stickgrip",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Purple",
      "Light Blue",
      "Grey",
      "Green",
      "Dark Blue"
    ]
  },
  {
    "id": "stick-grip-s-gaucho",
    "brand": "Stick Grip",
    "model": "s Gaucho",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.49,
    "price_max": 13.49,
    "single_price_min": 13.49,
    "single_price_max": 13.49,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-navy-blue",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ScreenShot2025-03-20at12.03.17PM.png?v=1744323561",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-navy-blue",
        "handle": "stick-grip-gaucho-standard-grip-navy-blue",
        "shopify_variants": [
          {
            "id": "51845878153586",
            "gid": "gid://shopify/ProductVariant/51845878153586",
            "sku": "STG-Guacho-Grip-Blue",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-gaucho-standard-grip-navy-blue?variant=51845878153586"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, standard, standard-golf-grips, stick grip, stickgrip",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue"
    ]
  },
  {
    "id": "super-stroke-cross-comfort",
    "brand": "Super Stroke",
    "model": "Cross Comfort",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (soft)",
    "texture": "textured",
    "feel": "soft",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Red",
      "Gray / Black",
      "Gray / Pink"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 5.99,
    "price_max": 105.86,
    "single_price_min": 5.99,
    "single_price_max": 6.99,
    "normalized_price_per_grip": 5.39,
    "bundle_price_min": 48.52,
    "kit_price_min": 92.86,
    "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/super-stroke-cross-comfort-std-4colors.jpg?v=1766011332",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "soft_feel"
    ],
    "product_count": 15,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Gray / Black"
        ],
        "price": 77.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-bundle-13pcs",
        "handle": "super-stroke-cross-comfort-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Black",
              "Black / Grey",
              "Black / Blue",
              "Black / Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398922166642",
            "gid": "gid://shopify/ProductVariant/61398922166642",
            "sku": "SET-13xSSG-446114",
            "color": "Gray / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Gray / Black"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-bundle-13pcs?variant=61398922166642"
          },
          {
            "id": "61398922199410",
            "gid": "gid://shopify/ProductVariant/61398922199410",
            "sku": "SET-13xSSG-446124",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-bundle-13pcs?variant=61398922199410"
          },
          {
            "id": "61398922232178",
            "gid": "gid://shopify/ProductVariant/61398922232178",
            "sku": "SET-13xSSG-446123",
            "color": "Black / Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Blue"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-bundle-13pcs?variant=61398922232178"
          },
          {
            "id": "61398922264946",
            "gid": "gid://shopify/ProductVariant/61398922264946",
            "sku": "SET-13xSSG-446122",
            "color": "Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-bundle-13pcs?variant=61398922264946"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Gray / Pink"
        ],
        "price": 77.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-bundle-13pcs",
        "handle": "super-stroke-cross-comfort-undersize-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Pink",
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398922068338",
            "gid": "gid://shopify/ProductVariant/61398922068338",
            "sku": "SET-13xSSG-446010",
            "color": "Gray / Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Gray / Pink"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-bundle-13pcs?variant=61398922068338"
          },
          {
            "id": "61398922101106",
            "gid": "gid://shopify/ProductVariant/61398922101106",
            "sku": "SET-13xSSG-446022",
            "color": "Black / Red",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-bundle-13pcs?variant=61398922101106"
          },
          {
            "id": "61398922133874",
            "gid": "gid://shopify/ProductVariant/61398922133874",
            "sku": "SET-13xSSG-446024",
            "color": "Black / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-bundle-13pcs?variant=61398922133874"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Gray / Black"
        ],
        "price": 84.37,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-bundle-13pcs",
        "handle": "super-stroke-cross-comfort-midsize-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398921707890",
            "gid": "gid://shopify/ProductVariant/61398921707890",
            "sku": "SET-13xSSG-446314",
            "color": "Gray / Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Gray / Black"
            },
            "available": false,
            "price": 84.37,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-bundle-13pcs?variant=61398921707890"
          },
          {
            "id": "61398921740658",
            "gid": "gid://shopify/ProductVariant/61398921740658",
            "sku": "SET-13xSSG-446322",
            "color": "Black / Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 84.37,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-bundle-13pcs?variant=61398921740658"
          },
          {
            "id": "61398921773426",
            "gid": "gid://shopify/ProductVariant/61398921773426",
            "sku": "SET-13xSSG-446324",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 84.37,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-bundle-13pcs?variant=61398921773426"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Black",
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black / Red"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip-bundle-13pcs",
        "handle": "super-stroke-cross-comfort-jumbo-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398921544050",
            "gid": "gid://shopify/ProductVariant/61398921544050",
            "sku": "SET-13xSSG-446522",
            "color": "Black / Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip-bundle-13pcs?variant=61398921544050"
          },
          {
            "id": "61398921576818",
            "gid": "gid://shopify/ProductVariant/61398921576818",
            "sku": "SET-13xSSG-446524",
            "color": "Black / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip-bundle-13pcs?variant=61398921576818"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Gray / Black"
        ],
        "price": 48.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-grip-bundle-set",
        "handle": "super-stroke-cross-comfort-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Black",
              "Black / Grey",
              "Black / Blue",
              "Black / Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021966745661",
            "gid": "gid://shopify/ProductVariant/41021966745661",
            "sku": "SET-9xSSG-446114",
            "color": "Gray / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Gray / Black"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-grip-bundle-set?variant=41021966745661"
          },
          {
            "id": "41021966778429",
            "gid": "gid://shopify/ProductVariant/41021966778429",
            "sku": "SET-9xSSG-446124",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-grip-bundle-set?variant=41021966778429"
          },
          {
            "id": "41021966811197",
            "gid": "gid://shopify/ProductVariant/41021966811197",
            "sku": "SET-9xSSG-446123",
            "color": "Black / Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Blue"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-grip-bundle-set?variant=41021966811197"
          },
          {
            "id": "41021966843965",
            "gid": "gid://shopify/ProductVariant/41021966843965",
            "sku": "SET-9xSSG-446122",
            "color": "Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-grip-bundle-set?variant=41021966843965"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Gray / Pink"
        ],
        "price": 48.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-grip-bundle-set",
        "handle": "super-stroke-cross-comfort-undersize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Pink",
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021966647357",
            "gid": "gid://shopify/ProductVariant/41021966647357",
            "sku": "SET-9xSSG-446010",
            "color": "Gray / Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Gray / Pink"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-grip-bundle-set?variant=41021966647357"
          },
          {
            "id": "41021966680125",
            "gid": "gid://shopify/ProductVariant/41021966680125",
            "sku": "SET-9xSSG-446022",
            "color": "Black / Red",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-grip-bundle-set?variant=41021966680125"
          },
          {
            "id": "41021966712893",
            "gid": "gid://shopify/ProductVariant/41021966712893",
            "sku": "SET-9xSSG-446024",
            "color": "Black / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": true,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-grip-bundle-set?variant=41021966712893"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Gray / Black"
        ],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-grip-bundle-set",
        "handle": "super-stroke-cross-comfort-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021966549053",
            "gid": "gid://shopify/ProductVariant/41021966549053",
            "sku": "SET-9xSSG-446314",
            "color": "Gray / Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Gray / Black"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-grip-bundle-set?variant=41021966549053"
          },
          {
            "id": "41021966581821",
            "gid": "gid://shopify/ProductVariant/41021966581821",
            "sku": "SET-9xSSG-446322",
            "color": "Black / Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-grip-bundle-set?variant=41021966581821"
          },
          {
            "id": "41021966614589",
            "gid": "gid://shopify/ProductVariant/41021966614589",
            "sku": "SET-9xSSG-446324",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-grip-bundle-set?variant=41021966614589"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Black",
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Red"
        ],
        "price": 56.62,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip-grip-bundle-set",
        "handle": "super-stroke-cross-comfort-jumbo-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021966483517",
            "gid": "gid://shopify/ProductVariant/41021966483517",
            "sku": "SET-9xSSG-446522",
            "color": "Black / Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 56.62,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip-grip-bundle-set?variant=41021966483517"
          },
          {
            "id": "41021966516285",
            "gid": "gid://shopify/ProductVariant/41021966516285",
            "sku": "SET-9xSSG-446524",
            "color": "Black / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 56.62,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip-grip-bundle-set?variant=41021966516285"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Gray / Black"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-cross-comfort-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Black",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007846723645",
            "gid": "gid://shopify/ProductVariant/32007846723645",
            "sku": "KIT+13xSSG-446114",
            "color": "Gray / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Gray / Black"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-13pcs-golf-grip-kit?variant=32007846723645"
          },
          {
            "id": "32007846756413",
            "gid": "gid://shopify/ProductVariant/32007846756413",
            "sku": "KIT+13xSSG-446124",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip-13pcs-golf-grip-kit?variant=32007846756413"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Gray / Pink"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-cross-comfort-undersize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Pink",
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007846625341",
            "gid": "gid://shopify/ProductVariant/32007846625341",
            "sku": "KIT+13xSSG-446010",
            "color": "Gray / Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Gray / Pink"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-13pcs-golf-grip-kit?variant=32007846625341"
          },
          {
            "id": "32007846658109",
            "gid": "gid://shopify/ProductVariant/32007846658109",
            "sku": "KIT+13xSSG-446022",
            "color": "Black / Red",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-13pcs-golf-grip-kit?variant=32007846658109"
          },
          {
            "id": "32007846690877",
            "gid": "gid://shopify/ProductVariant/32007846690877",
            "sku": "KIT+13xSSG-446024",
            "color": "Black / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": true,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip-13pcs-golf-grip-kit?variant=32007846690877"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Gray / Black"
        ],
        "price": 99.36,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-cross-comfort-midsize-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007846559805",
            "gid": "gid://shopify/ProductVariant/32007846559805",
            "sku": "KIT+13xSSG-446314",
            "color": "Gray / Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Gray / Black"
            },
            "available": false,
            "price": 99.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-13pcs-golf-grip-kit?variant=32007846559805"
          },
          {
            "id": "32007846592573",
            "gid": "gid://shopify/ProductVariant/32007846592573",
            "sku": "KIT+13xSSG-446324",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 99.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip-13pcs-golf-grip-kit?variant=32007846592573"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Black",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black / Red"
        ],
        "price": 105.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-cross-comfort-jumbo-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007846199357",
            "gid": "gid://shopify/ProductVariant/32007846199357",
            "sku": "KIT+13xSSG-446522",
            "color": "Black / Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 105.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip-13pcs-golf-grip-kit?variant=32007846199357"
          },
          {
            "id": "32007846232125",
            "gid": "gid://shopify/ProductVariant/32007846232125",
            "sku": "KIT+13xSSG-446524",
            "color": "Black / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 105.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip-13pcs-golf-grip-kit?variant=32007846232125"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black / Red"
        ],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip",
        "handle": "super-stroke-cross-comfort-jumbo-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39075068743",
            "gid": "gid://shopify/ProductVariant/39075068743",
            "sku": "SSG-446522",
            "color": "Black / Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip?variant=39075068743"
          },
          {
            "id": "31552990969917",
            "gid": "gid://shopify/ProductVariant/31552990969917",
            "sku": "SSG-446524",
            "color": "Black / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-grip?variant=31552990969917"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Gray / Pink"
        ],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip",
        "handle": "super-stroke-cross-comfort-undersize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Pink",
              "Black / Red",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41088044793917",
            "gid": "gid://shopify/ProductVariant/41088044793917",
            "sku": "SSG-446010",
            "color": "Gray / Pink",
            "size": "Undersize",
            "selected_options": {
              "Color": "Gray / Pink"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip?variant=41088044793917"
          },
          {
            "id": "41088044826685",
            "gid": "gid://shopify/ProductVariant/41088044826685",
            "sku": "SSG-446022",
            "color": "Black / Red",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip?variant=41088044826685"
          },
          {
            "id": "41088044859453",
            "gid": "gid://shopify/ProductVariant/41088044859453",
            "sku": "SSG-446024",
            "color": "Black / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-undersize-grip?variant=41088044859453"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Gray / Black"
        ],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip",
        "handle": "super-stroke-cross-comfort-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Black",
              "Black / Grey",
              "Black / Blue",
              "Black / Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39074327687",
            "gid": "gid://shopify/ProductVariant/39074327687",
            "sku": "SSG-446114",
            "color": "Gray / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Gray / Black"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip?variant=39074327687"
          },
          {
            "id": "31553004798013",
            "gid": "gid://shopify/ProductVariant/31553004798013",
            "sku": "SSG-446124",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip?variant=31553004798013"
          },
          {
            "id": "39074327751",
            "gid": "gid://shopify/ProductVariant/39074327751",
            "sku": "SSG-446123",
            "color": "Black / Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Blue"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip?variant=39074327751"
          },
          {
            "id": "39074327815",
            "gid": "gid://shopify/ProductVariant/39074327815",
            "sku": "SSG-446122",
            "color": "Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-standard-grip?variant=39074327815"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, blackfriday2020, cross comfort, golf-grips, grip bundle, iron/wood, New for 2016, new-add-12172025, rubber, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, super-stroke, super-stroke-cross-comfort-grips, superstroke, tacky, unde",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Grey",
      "Black / Red"
    ]
  },
  {
    "id": "super-stroke-cross-comfort-black-blue",
    "brand": "Super Stroke",
    "model": "Cross Comfort (Black/Blue)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (soft)",
    "texture": "textured",
    "feel": "soft",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Standard / Black/Blue"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 92.86,
    "price_max": 92.86,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 7.14,
    "bundle_price_min": null,
    "kit_price_min": 92.86,
    "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-black-blue",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-superstroke-cc-blk-blue.jpg?v=1736027153",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Black/Blue"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-black-blue",
        "handle": "grip-kit-13x-super-stroke-cross-comfort-standard-grips-black-blue",
        "shopify_variants": [
          {
            "id": "44509616531",
            "gid": "gid://shopify/ProductVariant/44509616531",
            "sku": "KIT+13xSSG-446123",
            "color": "Black / Blue",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black/Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-black-blue?variant=44509616531"
          },
          {
            "id": "39920743252029",
            "gid": "gid://shopify/ProductVariant/39920743252029",
            "sku": "KIT(8oz)+13xSSG-446123",
            "color": "Black / Blue",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black/Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 96.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-black-blue?variant=39920743252029"
          }
        ],
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Standard / Black/Blue"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, cross comfort, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, gri",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-cross-comfort-black-red",
    "brand": "Super Stroke",
    "model": "Cross Comfort (Black/Red)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (soft)",
    "texture": "textured",
    "feel": "soft",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Jumbo / Black/Red",
      "Midsize / Black/Red",
      "Standard / Black/Red"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 71.9,
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 92.86,
    "price_max": 105.86,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 7.14,
    "bundle_price_min": null,
    "kit_price_min": 92.86,
    "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-black-red-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-superstroke-cc-blk-red_f9a67d0a-dcea-4bf0-b7b9-0423185f3508.jpg?v=1736027123",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Jumbo / Black/Red"
        ],
        "price": 105.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-black-red-13pcs-golf-grip-kit",
        "handle": "super-stroke-cross-comfort-jumbo-black-red-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "8377276563517",
            "gid": "gid://shopify/ProductVariant/8377276563517",
            "sku": "KIT+13xSSG-446522",
            "color": "Black / Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size and Color": "Jumbo / Black/Red",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 105.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-black-red-13pcs-golf-grip-kit?variant=8377276563517"
          },
          {
            "id": "39920729194557",
            "gid": "gid://shopify/ProductVariant/39920729194557",
            "sku": "KIT(8oz)+13xSSG-446522",
            "color": "Black / Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size and Color": "Jumbo / Black/Red",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 109.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-jumbo-black-red-13pcs-golf-grip-kit?variant=39920729194557"
          }
        ],
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Jumbo / Black/Red"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Midsize / Black/Red"
        ],
        "price": 99.36,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-midsize-grips-black-red",
        "handle": "grip-kit-13x-super-stroke-cross-comfort-midsize-grips-black-red",
        "shopify_variants": [
          {
            "id": "44511098387",
            "gid": "gid://shopify/ProductVariant/44511098387",
            "sku": "KIT+13xSSG-446322",
            "color": "Black / Red",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Black/Red",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 99.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-midsize-grips-black-red?variant=44511098387"
          },
          {
            "id": "39920736403517",
            "gid": "gid://shopify/ProductVariant/39920736403517",
            "sku": "KIT(8oz)+13xSSG-446322",
            "color": "Black / Red",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Black/Red",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 103.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-midsize-grips-black-red?variant=39920736403517"
          }
        ],
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Midsize / Black/Red"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Black/Red"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-black-red",
        "handle": "grip-kit-13x-super-stroke-cross-comfort-standard-grips-black-red",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "44510123155",
            "gid": "gid://shopify/ProductVariant/44510123155",
            "sku": "KIT+13xSSG-446122",
            "color": "Standard / Black/Red",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-black-red?variant=44510123155"
          },
          {
            "id": "39920748199997",
            "gid": "gid://shopify/ProductVariant/39920748199997",
            "sku": "KIT(8oz)+13xSSG-446122",
            "color": "Standard / Black/Red",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 96.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-black-red?variant=39920748199997"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, cross comfort, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tee",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-cross-comfort-gray-black",
    "brand": "Super Stroke",
    "model": "Cross Comfort (Gray/Black)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (soft)",
    "texture": "textured",
    "feel": "soft",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Midsize / Gray/Black",
      "Standard / Gray/Black"
    ],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 92.86,
    "price_max": 99.36,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 7.14,
    "bundle_price_min": null,
    "kit_price_min": 92.86,
    "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-midsize-grips-gray-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/grip-kits-superstroke-cc-gry-blk_bc10cb98-296b-4f9c-9e55-5336eb429783.jpg?v=1736027147",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Midsize / Gray/Black"
        ],
        "price": 99.36,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-midsize-grips-gray-black",
        "handle": "grip-kit-13x-super-stroke-cross-comfort-midsize-grips-gray-black",
        "shopify_variants": [
          {
            "id": "44511208147",
            "gid": "gid://shopify/ProductVariant/44511208147",
            "sku": "KIT+13xSSG-446314",
            "color": "Gray / Black",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Gray/Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 99.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-midsize-grips-gray-black?variant=44511208147"
          },
          {
            "id": "39920741908541",
            "gid": "gid://shopify/ProductVariant/39920741908541",
            "sku": "KIT(8oz)+13xSSG-446314",
            "color": "Gray / Black",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Gray/Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 103.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-midsize-grips-gray-black?variant=39920741908541"
          }
        ],
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Midsize / Gray/Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Gray/Black"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-grey-black",
        "handle": "grip-kit-13x-super-stroke-cross-comfort-standard-grips-grey-black",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "44510634899",
            "gid": "gid://shopify/ProductVariant/44510634899",
            "sku": "KIT+13xSSG-446114",
            "color": "Standard / Gray/Black",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-grey-black?variant=44510634899"
          },
          {
            "id": "39920748953661",
            "gid": "gid://shopify/ProductVariant/39920748953661",
            "sku": "KIT(8oz)+13xSSG-446114",
            "color": "Standard / Gray/Black",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 96.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-cross-comfort-standard-grips-grey-black?variant=39920748953661"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, cross comfort, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, gri",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-cross-comfort-grip-all-variants",
    "brand": "Super Stroke",
    "model": "Cross Comfort Grip (all variants )",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "rubber (soft)",
    "texture": "textured",
    "feel": "soft",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Gray / Black"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.49,
    "price_max": 6.49,
    "single_price_min": 6.49,
    "single_price_max": 6.49,
    "normalized_price_per_grip": 6.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-crosscomf-gry-blk_67a07eaf-3d3a-42d6-857e-977dfb634e04.jpg?v=1626817986",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Gray / Black"
        ],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip",
        "handle": "super-stroke-cross-comfort-midsize-grip",
        "shopify_variants": [
          {
            "id": "39074919559",
            "gid": "gid://shopify/ProductVariant/39074919559",
            "sku": "SSG-446314",
            "color": "Gray / Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Gray / Black"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip?variant=39074919559"
          },
          {
            "id": "31521758707773",
            "gid": "gid://shopify/ProductVariant/31521758707773",
            "sku": "SSG-446324",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-cross-comfort-midsize-grip?variant=31521758707773"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray / Black",
              "Black / Grey"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, blackfriday2020, cross comfort, golf-grips, iron/wood, midsize, midsize-golf-grips, New for 2016, New for 2017, rubber, single-golf-grips, single-grip, soft, super-stroke, super-stroke-cross-comfort-grips, superstroke, tacky, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-crossline-2-0",
    "brand": "Super Stroke",
    "model": "Crossline 2.0",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Jumbo",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Undersize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.99,
    "price_max": 77.87,
    "single_price_min": 5.99,
    "single_price_max": 5.99,
    "normalized_price_per_grip": 5.99,
    "bundle_price_min": 59.9,
    "kit_price_min": 77.87,
    "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/superstroke-crossline-20-black-main_050aeb14-d9fe-4408-af88-6eaa29f502a0.jpg?v=1766010798",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 13,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-undersize-grip",
        "handle": "super-stroke-crossline-2-0-undersize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61544318501234",
            "gid": "gid://shopify/ProductVariant/61544318501234",
            "sku": "SSG-148001",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-undersize-grip?variant=61544318501234"
          },
          {
            "id": "61544318534002",
            "gid": "gid://shopify/ProductVariant/61544318534002",
            "sku": "SSG-148014",
            "color": "Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-undersize-grip?variant=61544318534002"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 77.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip-bundle-13pcs",
        "handle": "super-stroke-crossline-2-0-jumbo-wrap-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398905749874",
            "gid": "gid://shopify/ProductVariant/61398905749874",
            "sku": "SET-13xSSG-148501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip-bundle-13pcs?variant=61398905749874"
          },
          {
            "id": "61398905782642",
            "gid": "gid://shopify/ProductVariant/61398905782642",
            "sku": "SET-13xSSG-148514",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip-bundle-13pcs?variant=61398905782642"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 77.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip-bundle-13pcs",
        "handle": "super-stroke-crossline-2-0-midsize-wrap-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398905684338",
            "gid": "gid://shopify/ProductVariant/61398905684338",
            "sku": "SET-13xSSG-148301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip-bundle-13pcs?variant=61398905684338"
          },
          {
            "id": "61398905717106",
            "gid": "gid://shopify/ProductVariant/61398905717106",
            "sku": "SET-13xSSG-148314",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip-bundle-13pcs?variant=61398905717106"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 77.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip-bundle-13pcs",
        "handle": "super-stroke-crossline-2-0-standard-wrap-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398905618802",
            "gid": "gid://shopify/ProductVariant/61398905618802",
            "sku": "SET-13xSSG-148101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip-bundle-13pcs?variant=61398905618802"
          },
          {
            "id": "61398905651570",
            "gid": "gid://shopify/ProductVariant/61398905651570",
            "sku": "SET-13xSSG-148114",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip-bundle-13pcs?variant=61398905651570"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 59.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip-10pc-grip-bundle",
        "handle": "super-stroke-crossline-2-0-jumbo-wrap-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346588332402",
            "gid": "gid://shopify/ProductVariant/52346588332402",
            "sku": "SET-10xSSG-148501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 59.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip-10pc-grip-bundle?variant=52346588332402"
          },
          {
            "id": "52346588365170",
            "gid": "gid://shopify/ProductVariant/52346588365170",
            "sku": "SET-10xSSG-148514",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 59.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip-10pc-grip-bundle?variant=52346588365170"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 59.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip-10pc-grip-bundle",
        "handle": "super-stroke-crossline-2-0-midsize-wrap-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346587545970",
            "gid": "gid://shopify/ProductVariant/52346587545970",
            "sku": "SET-10xSSG-148301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 59.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip-10pc-grip-bundle?variant=52346587545970"
          },
          {
            "id": "52346587578738",
            "gid": "gid://shopify/ProductVariant/52346587578738",
            "sku": "SET-10xSSG-148314",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 59.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip-10pc-grip-bundle?variant=52346587578738"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 59.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip-10pc-grip-bundle",
        "handle": "super-stroke-crossline-2-0-standard-wrap-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346587447666",
            "gid": "gid://shopify/ProductVariant/52346587447666",
            "sku": "SET-10xSSG-148101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 59.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip-10pc-grip-bundle?variant=52346587447666"
          },
          {
            "id": "52346587480434",
            "gid": "gid://shopify/ProductVariant/52346587480434",
            "sku": "SET-10xSSG-148114",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 59.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip-10pc-grip-bundle?variant=52346587480434"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 77.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-crossline-2-0-jumbo-wrap-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346587087218",
            "gid": "gid://shopify/ProductVariant/52346587087218",
            "sku": "KIT+13xSSG-148501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip-13pc-grip-kit-bundle?variant=52346587087218"
          },
          {
            "id": "52346587119986",
            "gid": "gid://shopify/ProductVariant/52346587119986",
            "sku": "KIT+13xSSG-148514",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip-13pc-grip-kit-bundle?variant=52346587119986"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 77.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-crossline-2-0-midsize-wrap-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346586890610",
            "gid": "gid://shopify/ProductVariant/52346586890610",
            "sku": "KIT+13xSSG-148301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip-13pc-grip-kit-bundle?variant=52346586890610"
          },
          {
            "id": "52346586923378",
            "gid": "gid://shopify/ProductVariant/52346586923378",
            "sku": "KIT+13xSSG-148314",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip-13pc-grip-kit-bundle?variant=52346586923378"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 77.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-crossline-2-0-standard-wrap-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346586202482",
            "gid": "gid://shopify/ProductVariant/52346586202482",
            "sku": "KIT+13xSSG-148101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip-13pc-grip-kit-bundle?variant=52346586202482"
          },
          {
            "id": "52346586235250",
            "gid": "gid://shopify/ProductVariant/52346586235250",
            "sku": "KIT+13xSSG-148114",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip-13pc-grip-kit-bundle?variant=52346586235250"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip",
        "handle": "super-stroke-crossline-2-0-standard-wrap-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217807730",
            "gid": "gid://shopify/ProductVariant/52295217807730",
            "sku": "SSG-148101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip?variant=52295217807730"
          },
          {
            "id": "52295217840498",
            "gid": "gid://shopify/ProductVariant/52295217840498",
            "sku": "SSG-148114",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-standard-wrap-grip?variant=52295217840498"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip",
        "handle": "super-stroke-crossline-2-0-midsize-wrap-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217742194",
            "gid": "gid://shopify/ProductVariant/52295217742194",
            "sku": "SSG-148301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip?variant=52295217742194"
          },
          {
            "id": "52295217774962",
            "gid": "gid://shopify/ProductVariant/52295217774962",
            "sku": "SSG-148314",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-midsize-wrap-grip?variant=52295217774962"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip",
        "handle": "super-stroke-crossline-2-0-jumbo-wrap-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217676658",
            "gid": "gid://shopify/ProductVariant/52295217676658",
            "sku": "SSG-148501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip?variant=52295217676658"
          },
          {
            "id": "52295217709426",
            "gid": "gid://shopify/ProductVariant/52295217709426",
            "sku": "SSG-148514",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-jumbo-wrap-grip?variant=52295217709426"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, best-sellers, Crossline, Crossline 2.0, Crossline 2.0 undersize, Crossline Grip, Crossline Undersize, firm, golf-grips, iron/wood, rubber-golf-grips, single-golf-grips, single-grip, Size_Undersize, Super Stroke, Super Stroke Crossline, Super Stroke Crossline 2.0, tacky, under",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Grey"
    ]
  },
  {
    "id": "super-stroke-crossline-2-0-full-cord",
    "brand": "Super Stroke",
    "model": "Crossline 2.0 Full-Cord",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Black",
      "Cord Midsize Grip",
      "Cord Standard Grip"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 9.99,
    "price_max": 129.87,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": 99.9,
    "kit_price_min": 129.87,
    "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/superstroke-crossline-cord-20-black-main_4547e166-ca13-450d-834e-0cae6ea29c31.jpg?v=1766010784",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 8,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black",
          "Cord Midsize Grip"
        ],
        "price": 129.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-midsize-grip-bundle-13pcs",
        "handle": "super-stroke-crossline-2-0-cord-midsize-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398905586034",
            "gid": "gid://shopify/ProductVariant/61398905586034",
            "sku": "SET-13xSSG-248301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-midsize-grip-bundle-13pcs?variant=61398905586034"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black",
          "Cord Standard Grip"
        ],
        "price": 129.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-standard-grip-bundle-13pcs",
        "handle": "super-stroke-crossline-2-0-cord-standard-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398905553266",
            "gid": "gid://shopify/ProductVariant/61398905553266",
            "sku": "SET-13xSSG-248101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-standard-grip-bundle-13pcs?variant=61398905553266"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 99.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-midsize-grip-10pc-grip-bundle",
        "handle": "super-stroke-crossline-2-0-cord-midsize-grip-10pc-grip-bundle",
        "shopify_variants": [
          {
            "id": "52346587316594",
            "gid": "gid://shopify/ProductVariant/52346587316594",
            "sku": "SET-10xSSG-248301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 99.9,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-midsize-grip-10pc-grip-bundle?variant=52346587316594"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 99.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-standard-grip-10pc-grip-bundle",
        "handle": "super-stroke-crossline-2-0-cord-standard-grip-10pc-grip-bundle",
        "shopify_variants": [
          {
            "id": "52346587185522",
            "gid": "gid://shopify/ProductVariant/52346587185522",
            "sku": "SET-10xSSG-248101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 99.9,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-standard-grip-10pc-grip-bundle?variant=52346587185522"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 129.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-midsize-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-crossline-2-0-cord-midsize-grip-13pc-grip-kit-bundle",
        "shopify_variants": [
          {
            "id": "52346585973106",
            "gid": "gid://shopify/ProductVariant/52346585973106",
            "sku": "KIT+13xSSG-248301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-midsize-grip-13pc-grip-kit-bundle?variant=52346585973106"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 129.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-standard-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-crossline-2-0-cord-standard-grip-13pc-grip-kit-bundle",
        "shopify_variants": [
          {
            "id": "52346585710962",
            "gid": "gid://shopify/ProductVariant/52346585710962",
            "sku": "KIT+13xSSG-248101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.87,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-standard-grip-13pc-grip-kit-bundle?variant=52346585710962"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Cord Standard Grip"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-standard-grip",
        "handle": "super-stroke-crossline-2-0-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "52295217906034",
            "gid": "gid://shopify/ProductVariant/52295217906034",
            "sku": "SSG-248101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-standard-grip?variant=52295217906034"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Cord Midsize Grip"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-midsize-grip",
        "handle": "super-stroke-crossline-2-0-cord-midsize-grip",
        "shopify_variants": [
          {
            "id": "52295217873266",
            "gid": "gid://shopify/ProductVariant/52295217873266",
            "sku": "SSG-248301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-crossline-2-0-cord-midsize-grip?variant=52295217873266"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, best-sellers, cord, cord-golf-grips, Crossline, Crossline 2.0, Crossline Grip, firm, golf-grips, grip bundle, iron/wood, midsize, midsize-golf-grips, new-add-12172025, single-golf-grips, single-grip, Super Stroke, Super Stroke Crossline, Super Stroke Cro",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "super-stroke-revl-comfort",
    "brand": "Super Stroke",
    "model": "REVL Comfort",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Jumbo",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 8.99,
    "price_max": 131.86,
    "single_price_min": 8.99,
    "single_price_max": 8.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 89.9,
    "kit_price_min": 131.86,
    "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/super-stroke-revl-comfort-black-main_555f6e32-f832-4b59-90cc-edc8d3bc11b2.jpg?v=1766010856",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 16,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 116.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip-bundle-13pcs",
        "handle": "super-stroke-revl-comfort-jumbo-wrap-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398908666226",
            "gid": "gid://shopify/ProductVariant/61398908666226",
            "sku": "SET-13xSSG-548501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip-bundle-13pcs?variant=61398908666226"
          },
          {
            "id": "61398908698994",
            "gid": "gid://shopify/ProductVariant/61398908698994",
            "sku": "SET-13xSSG-548500",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip-bundle-13pcs?variant=61398908698994"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 116.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip-bundle-13pcs",
        "handle": "super-stroke-revl-comfort-midsize-wrap-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398908600690",
            "gid": "gid://shopify/ProductVariant/61398908600690",
            "sku": "SET-13xSSG-548301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip-bundle-13pcs?variant=61398908600690"
          },
          {
            "id": "61398908633458",
            "gid": "gid://shopify/ProductVariant/61398908633458",
            "sku": "SET-13xSSG-548300",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip-bundle-13pcs?variant=61398908633458"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 116.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip-bundle-13pcs",
        "handle": "super-stroke-revl-comfort-standard-wrap-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398908535154",
            "gid": "gid://shopify/ProductVariant/61398908535154",
            "sku": "SET-13xSSG-548101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip-bundle-13pcs?variant=61398908535154"
          },
          {
            "id": "61398908567922",
            "gid": "gid://shopify/ProductVariant/61398908567922",
            "sku": "SET-13xSSG-548100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip-bundle-13pcs?variant=61398908567922"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 116.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip-bundle-13pcs",
        "handle": "super-stroke-revl-comfort-undersize-wrap-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398907847026",
            "gid": "gid://shopify/ProductVariant/61398907847026",
            "sku": "SET-13xSSG-548001",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip-bundle-13pcs?variant=61398907847026"
          },
          {
            "id": "61398907879794",
            "gid": "gid://shopify/ProductVariant/61398907879794",
            "sku": "SET-13xSSG-548000",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip-bundle-13pcs?variant=61398907879794"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 89.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip-10pc-grip-bundle",
        "handle": "super-stroke-revl-comfort-undersize-wrap-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346550124914",
            "gid": "gid://shopify/ProductVariant/52346550124914",
            "sku": "SET-10xSSG-548001",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 89.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip-10pc-grip-bundle?variant=52346550124914"
          },
          {
            "id": "52346550157682",
            "gid": "gid://shopify/ProductVariant/52346550157682",
            "sku": "SET-10xSSG-548000",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 89.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip-10pc-grip-bundle?variant=52346550157682"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 89.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip-10pc-grip-bundle",
        "handle": "super-stroke-revl-comfort-standard-wrap-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346549404018",
            "gid": "gid://shopify/ProductVariant/52346549404018",
            "sku": "SET-10xSSG-548101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 89.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip-10pc-grip-bundle?variant=52346549404018"
          },
          {
            "id": "52346549436786",
            "gid": "gid://shopify/ProductVariant/52346549436786",
            "sku": "SET-10xSSG-548100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 89.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip-10pc-grip-bundle?variant=52346549436786"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 89.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip-10pc-grip-bundle",
        "handle": "super-stroke-revl-comfort-midsize-wrap-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346548715890",
            "gid": "gid://shopify/ProductVariant/52346548715890",
            "sku": "SET-10xSSG-548301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 89.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip-10pc-grip-bundle?variant=52346548715890"
          },
          {
            "id": "52346548748658",
            "gid": "gid://shopify/ProductVariant/52346548748658",
            "sku": "SET-10xSSG-548300",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 89.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip-10pc-grip-bundle?variant=52346548748658"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Black"
        ],
        "price": 89.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip-10pc-grip-bundle",
        "handle": "super-stroke-revl-comfort-jumbo-wrap-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346547667314",
            "gid": "gid://shopify/ProductVariant/52346547667314",
            "sku": "SET-10xSSG-548501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 89.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip-10pc-grip-bundle?variant=52346547667314"
          },
          {
            "id": "52346547700082",
            "gid": "gid://shopify/ProductVariant/52346547700082",
            "sku": "SET-10xSSG-548500",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 89.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip-10pc-grip-bundle?variant=52346547700082"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 131.86,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-revl-comfort-undersize-wrap-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346529972594",
            "gid": "gid://shopify/ProductVariant/52346529972594",
            "sku": "KIT+13xSSG-548001",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 131.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip-13pc-grip-kit-bundle?variant=52346529972594"
          },
          {
            "id": "52346530005362",
            "gid": "gid://shopify/ProductVariant/52346530005362",
            "sku": "KIT+13xSSG-548000",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 131.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip-13pc-grip-kit-bundle?variant=52346530005362"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 131.86,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-revl-comfort-standard-wrap-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346526957938",
            "gid": "gid://shopify/ProductVariant/52346526957938",
            "sku": "KIT+13xSSG-548101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 131.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip-13pc-grip-kit-bundle?variant=52346526957938"
          },
          {
            "id": "52346526990706",
            "gid": "gid://shopify/ProductVariant/52346526990706",
            "sku": "KIT+13xSSG-548100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 131.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip-13pc-grip-kit-bundle?variant=52346526990706"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 131.86,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-revl-comfort-midsize-wrap-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346524467570",
            "gid": "gid://shopify/ProductVariant/52346524467570",
            "sku": "KIT+13xSSG-548301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 131.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip-13pc-grip-kit-bundle?variant=52346524467570"
          },
          {
            "id": "52346524500338",
            "gid": "gid://shopify/ProductVariant/52346524500338",
            "sku": "KIT+13xSSG-548300",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 131.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip-13pc-grip-kit-bundle?variant=52346524500338"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 131.86,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-revl-comfort-jumbo-wrap-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346522435954",
            "gid": "gid://shopify/ProductVariant/52346522435954",
            "sku": "KIT+13xSSG-548501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 131.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip-13pc-grip-kit-bundle?variant=52346522435954"
          },
          {
            "id": "52346522468722",
            "gid": "gid://shopify/ProductVariant/52346522468722",
            "sku": "KIT+13xSSG-548500",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 131.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip-13pc-grip-kit-bundle?variant=52346522468722"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip",
        "handle": "super-stroke-revl-comfort-undersize-wrap-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217119602",
            "gid": "gid://shopify/ProductVariant/52295217119602",
            "sku": "SSG-548001",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip?variant=52295217119602"
          },
          {
            "id": "52295217152370",
            "gid": "gid://shopify/ProductVariant/52295217152370",
            "sku": "SSG-548000",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-undersize-wrap-grip?variant=52295217152370"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip",
        "handle": "super-stroke-revl-comfort-standard-wrap-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217054066",
            "gid": "gid://shopify/ProductVariant/52295217054066",
            "sku": "SSG-548101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip?variant=52295217054066"
          },
          {
            "id": "52295217086834",
            "gid": "gid://shopify/ProductVariant/52295217086834",
            "sku": "SSG-548100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-standard-wrap-grip?variant=52295217086834"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip",
        "handle": "super-stroke-revl-comfort-midsize-wrap-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295216988530",
            "gid": "gid://shopify/ProductVariant/52295216988530",
            "sku": "SSG-548301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip?variant=52295216988530"
          },
          {
            "id": "52295217021298",
            "gid": "gid://shopify/ProductVariant/52295217021298",
            "sku": "SSG-548300",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-midsize-wrap-grip?variant=52295217021298"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip",
        "handle": "super-stroke-revl-comfort-jumbo-wrap-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295216922994",
            "gid": "gid://shopify/ProductVariant/52295216922994",
            "sku": "SSG-548501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip?variant=52295216922994"
          },
          {
            "id": "52295216955762",
            "gid": "gid://shopify/ProductVariant/52295216955762",
            "sku": "SSG-548500",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Jumbo"
            },
            "available": true,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-comfort-jumbo-wrap-grip?variant=52295216955762"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, best-sellers, golf-grips, grip bundle, iron/wood, jumbo, jumbo-golf-grips, new-add-12172025, oversize-golf-grips, REVL, Revl Comfort, REVL Grip, single-golf-grips, single-grip, soft, Super Stroke, Super Stroke REVL, Super Stroke REVL Comfort, tacky, wrap",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "White"
    ]
  },
  {
    "id": "super-stroke-revl-element-half-cord",
    "brand": "Super Stroke",
    "model": "REVL Element (Half-Cord)",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Grey/Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 9.99,
    "price_max": 144.86,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": 99.9,
    "kit_price_min": 144.86,
    "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/superstroke-revl-element-black-main_d4a0eb92-090d-4e97-9e16-ca26451a75c7.jpg?v=1766010835",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 8,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 129.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip-bundle-13pcs",
        "handle": "super-stroke-revl-element-half-cord-midsize-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398907781490",
            "gid": "gid://shopify/ProductVariant/61398907781490",
            "sku": "SET-13xSSG-448314",
            "color": "Grey/Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip-bundle-13pcs?variant=61398907781490"
          },
          {
            "id": "61398907814258",
            "gid": "gid://shopify/ProductVariant/61398907814258",
            "sku": "SET-13xSSG-448301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 129.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip-bundle-13pcs?variant=61398907814258"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 129.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip-bundle-13pcs",
        "handle": "super-stroke-revl-element-half-cord-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398907715954",
            "gid": "gid://shopify/ProductVariant/61398907715954",
            "sku": "SET-13xSSG-448114",
            "color": "Grey/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip-bundle-13pcs?variant=61398907715954"
          },
          {
            "id": "61398907748722",
            "gid": "gid://shopify/ProductVariant/61398907748722",
            "sku": "SET-13xSSG-448101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 129.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip-bundle-13pcs?variant=61398907748722"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 99.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip-10pc-grip-bundle",
        "handle": "super-stroke-revl-element-half-cord-standard-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346551697778",
            "gid": "gid://shopify/ProductVariant/52346551697778",
            "sku": "SET-10xSSG-448114",
            "color": "Grey/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 99.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip-10pc-grip-bundle?variant=52346551697778"
          },
          {
            "id": "52346551730546",
            "gid": "gid://shopify/ProductVariant/52346551730546",
            "sku": "SET-10xSSG-448101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 99.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip-10pc-grip-bundle?variant=52346551730546"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 99.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip-10pc-grip-bundle",
        "handle": "super-stroke-revl-element-half-cord-midsize-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346550878578",
            "gid": "gid://shopify/ProductVariant/52346550878578",
            "sku": "SET-10xSSG-448314",
            "color": "Grey/Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 99.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip-10pc-grip-bundle?variant=52346550878578"
          },
          {
            "id": "52346550911346",
            "gid": "gid://shopify/ProductVariant/52346550911346",
            "sku": "SET-10xSSG-448301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 99.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip-10pc-grip-bundle?variant=52346550911346"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Grey/Blue"
        ],
        "price": 144.86,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-revl-element-half-cord-standard-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346537378162",
            "gid": "gid://shopify/ProductVariant/52346537378162",
            "sku": "KIT+13xSSG-448114",
            "color": "Grey/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 144.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip-13pc-grip-kit-bundle?variant=52346537378162"
          },
          {
            "id": "52346537410930",
            "gid": "gid://shopify/ProductVariant/52346537410930",
            "sku": "KIT+13xSSG-448101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 144.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip-13pc-grip-kit-bundle?variant=52346537410930"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Grey/Blue"
        ],
        "price": 144.86,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-revl-element-half-cord-midsize-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346533151090",
            "gid": "gid://shopify/ProductVariant/52346533151090",
            "sku": "KIT+13xSSG-448314",
            "color": "Grey/Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 144.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip-13pc-grip-kit-bundle?variant=52346533151090"
          },
          {
            "id": "52346533183858",
            "gid": "gid://shopify/ProductVariant/52346533183858",
            "sku": "KIT+13xSSG-448301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 144.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip-13pc-grip-kit-bundle?variant=52346533183858"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Grey/Blue"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip",
        "handle": "super-stroke-revl-element-half-cord-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217283442",
            "gid": "gid://shopify/ProductVariant/52295217283442",
            "sku": "SSG-448114",
            "color": "Grey/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip?variant=52295217283442"
          },
          {
            "id": "52295217316210",
            "gid": "gid://shopify/ProductVariant/52295217316210",
            "sku": "SSG-448101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-standard-grip?variant=52295217316210"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Grey/Blue"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip",
        "handle": "super-stroke-revl-element-half-cord-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217185138",
            "gid": "gid://shopify/ProductVariant/52295217185138",
            "sku": "SSG-448314",
            "color": "Grey/Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip?variant=52295217185138"
          },
          {
            "id": "52295217217906",
            "gid": "gid://shopify/ProductVariant/52295217217906",
            "sku": "SSG-448301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-midsize-grip?variant=52295217217906"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, best-sellers, golf-grips, grip bundle, half-cord, hybrid, hybrid-golf-grips, iron/wood, midsize, midsize-golf-grips, new-add-12172025, REVL, Revl Element, REVL Grip, single-golf-grips, single-grip, soft, Super Stroke, Super Stroke REVL, Super Stroke REVL",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Grey/Blue",
      "Black"
    ]
  },
  {
    "id": "super-stroke-revl-element-half-cord-4x",
    "brand": "Super Stroke",
    "model": "REVL Element (Half-Cord) 4X",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 9.99,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 9.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-4x-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/super-stroke-revl-element-4x-main.jpg?v=1781551851",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-4x-standard-grip",
        "handle": "super-stroke-revl-element-half-cord-4x-standard-grip",
        "shopify_variants": [
          {
            "id": "61940432601458",
            "gid": "gid://shopify/ProductVariant/61940432601458",
            "sku": "SSG-848101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-4x-standard-grip?variant=61940432601458"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-4x-midsize-grip",
        "handle": "super-stroke-revl-element-half-cord-4x-midsize-grip",
        "shopify_variants": [
          {
            "id": "61940432503154",
            "gid": "gid://shopify/ProductVariant/61940432503154",
            "sku": "SSG-848301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-revl-element-half-cord-4x-midsize-grip?variant=61940432503154"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, 4x element, All Products, best-sellers, golf-grips, half-cord, hybrid, hybrid-golf-grips, iron/wood, REVL, revl 4x, Revl Element, REVL Grip, single-golf-grips, single-grip, soft, standard, standard-golf-grips, Super Stroke, Super Stroke REVL, Super Stroke REVL Element, tacky",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "super-stroke-revl-player",
    "brand": "Super Stroke",
    "model": "REVL Player",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "10pc bundle",
      "13pc bundle",
      "13pc kit"
    ],
    "colors_available": [
      "Grey/Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 7.99,
    "price_max": 118.86,
    "single_price_min": 7.99,
    "single_price_max": 7.99,
    "normalized_price_per_grip": 7.99,
    "bundle_price_min": 79.9,
    "kit_price_min": 118.86,
    "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/superstroke-revl-player-black-main_915e72a0-bb1d-4add-8393-d855acdddfbd.jpg?v=1766010824",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 12,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 103.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-bundle-13pcs",
        "handle": "super-stroke-revl-player-midsize-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398907617650",
            "gid": "gid://shopify/ProductVariant/61398907617650",
            "sku": "SET-13xSSG-348314",
            "color": "Grey/Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-bundle-13pcs?variant=61398907617650"
          },
          {
            "id": "61398907650418",
            "gid": "gid://shopify/ProductVariant/61398907650418",
            "sku": "SET-13xSSG-348301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-bundle-13pcs?variant=61398907650418"
          },
          {
            "id": "61398907683186",
            "gid": "gid://shopify/ProductVariant/61398907683186",
            "sku": "SET-13xSSG-348300",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-bundle-13pcs?variant=61398907683186"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 103.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-bundle-13pcs",
        "handle": "super-stroke-revl-player-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398907519346",
            "gid": "gid://shopify/ProductVariant/61398907519346",
            "sku": "SET-13xSSG-348114",
            "color": "Grey/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-bundle-13pcs?variant=61398907519346"
          },
          {
            "id": "61398907552114",
            "gid": "gid://shopify/ProductVariant/61398907552114",
            "sku": "SET-13xSSG-348101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-bundle-13pcs?variant=61398907552114"
          },
          {
            "id": "61398907584882",
            "gid": "gid://shopify/ProductVariant/61398907584882",
            "sku": "SET-13xSSG-348100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-bundle-13pcs?variant=61398907584882"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 103.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-bundle-13pcs",
        "handle": "super-stroke-revl-player-undersize-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398907421042",
            "gid": "gid://shopify/ProductVariant/61398907421042",
            "sku": "SET-13xSSG-348014",
            "color": "Grey/Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-bundle-13pcs?variant=61398907421042"
          },
          {
            "id": "61398907453810",
            "gid": "gid://shopify/ProductVariant/61398907453810",
            "sku": "SET-13xSSG-348001",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-bundle-13pcs?variant=61398907453810"
          },
          {
            "id": "61398907486578",
            "gid": "gid://shopify/ProductVariant/61398907486578",
            "sku": "SET-13xSSG-348000",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-bundle-13pcs?variant=61398907486578"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 79.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-10pc-grip-bundle",
        "handle": "super-stroke-revl-player-undersize-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346554286450",
            "gid": "gid://shopify/ProductVariant/52346554286450",
            "sku": "SET-10xSSG-348014",
            "color": "Grey/Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 79.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-10pc-grip-bundle?variant=52346554286450"
          },
          {
            "id": "52346554319218",
            "gid": "gid://shopify/ProductVariant/52346554319218",
            "sku": "SET-10xSSG-348001",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 79.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-10pc-grip-bundle?variant=52346554319218"
          },
          {
            "id": "52346554351986",
            "gid": "gid://shopify/ProductVariant/52346554351986",
            "sku": "SET-10xSSG-348000",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 79.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-10pc-grip-bundle?variant=52346554351986"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "10pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 79.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-10pc-grip-bundle",
        "handle": "super-stroke-revl-player-standard-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346553336178",
            "gid": "gid://shopify/ProductVariant/52346553336178",
            "sku": "SET-10xSSG-348114",
            "color": "Grey/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 79.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-10pc-grip-bundle?variant=52346553336178"
          },
          {
            "id": "52346553368946",
            "gid": "gid://shopify/ProductVariant/52346553368946",
            "sku": "SET-10xSSG-348101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 79.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-10pc-grip-bundle?variant=52346553368946"
          },
          {
            "id": "52346553401714",
            "gid": "gid://shopify/ProductVariant/52346553401714",
            "sku": "SET-10xSSG-348100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 79.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-10pc-grip-bundle?variant=52346553401714"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "10pc bundle",
        "colors": [
          "Grey/Blue"
        ],
        "price": 79.9,
        "per_grip_g": 6.4,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-10pc-grip-bundle",
        "handle": "super-stroke-revl-player-midsize-grip-10pc-grip-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346552385906",
            "gid": "gid://shopify/ProductVariant/52346552385906",
            "sku": "SET-10xSSG-348314",
            "color": "Grey/Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 79.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-10pc-grip-bundle?variant=52346552385906"
          },
          {
            "id": "52346552418674",
            "gid": "gid://shopify/ProductVariant/52346552418674",
            "sku": "SET-10xSSG-348301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 79.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-10pc-grip-bundle?variant=52346552418674"
          },
          {
            "id": "52346552451442",
            "gid": "gid://shopify/ProductVariant/52346552451442",
            "sku": "SET-10xSSG-348300",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 79.9,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-10pc-grip-bundle?variant=52346552451442"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Grey/Blue"
        ],
        "price": 118.86,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-revl-player-undersize-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346546258290",
            "gid": "gid://shopify/ProductVariant/52346546258290",
            "sku": "KIT+13xSSG-348014",
            "color": "Grey/Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 118.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-13pc-grip-kit-bundle?variant=52346546258290"
          },
          {
            "id": "52346546291058",
            "gid": "gid://shopify/ProductVariant/52346546291058",
            "sku": "KIT+13xSSG-348001",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 118.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-13pc-grip-kit-bundle?variant=52346546291058"
          },
          {
            "id": "52346546323826",
            "gid": "gid://shopify/ProductVariant/52346546323826",
            "sku": "KIT+13xSSG-348000",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 118.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip-13pc-grip-kit-bundle?variant=52346546323826"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Grey/Blue"
        ],
        "price": 118.86,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-revl-player-standard-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346543767922",
            "gid": "gid://shopify/ProductVariant/52346543767922",
            "sku": "KIT+13xSSG-348114",
            "color": "Grey/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-13pc-grip-kit-bundle?variant=52346543767922"
          },
          {
            "id": "52346543800690",
            "gid": "gid://shopify/ProductVariant/52346543800690",
            "sku": "KIT+13xSSG-348101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-13pc-grip-kit-bundle?variant=52346543800690"
          },
          {
            "id": "52346543833458",
            "gid": "gid://shopify/ProductVariant/52346543833458",
            "sku": "KIT+13xSSG-348100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip-13pc-grip-kit-bundle?variant=52346543833458"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Grey/Blue"
        ],
        "price": 118.86,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-13pc-grip-kit-bundle",
        "handle": "super-stroke-revl-player-midsize-grip-13pc-grip-kit-bundle",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52346540687730",
            "gid": "gid://shopify/ProductVariant/52346540687730",
            "sku": "KIT+13xSSG-348314",
            "color": "Grey/Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-13pc-grip-kit-bundle?variant=52346540687730"
          },
          {
            "id": "52346540720498",
            "gid": "gid://shopify/ProductVariant/52346540720498",
            "sku": "KIT+13xSSG-348301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-13pc-grip-kit-bundle?variant=52346540720498"
          },
          {
            "id": "52346540753266",
            "gid": "gid://shopify/ProductVariant/52346540753266",
            "sku": "KIT+13xSSG-348300",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip-13pc-grip-kit-bundle?variant=52346540753266"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Grey/Blue"
        ],
        "price": 7.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip",
        "handle": "super-stroke-revl-player-undersize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217578354",
            "gid": "gid://shopify/ProductVariant/52295217578354",
            "sku": "SSG-348014",
            "color": "Grey/Blue",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip?variant=52295217578354"
          },
          {
            "id": "52295217611122",
            "gid": "gid://shopify/ProductVariant/52295217611122",
            "sku": "SSG-348001",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip?variant=52295217611122"
          },
          {
            "id": "52295217643890",
            "gid": "gid://shopify/ProductVariant/52295217643890",
            "sku": "SSG-348000",
            "color": "White",
            "size": "Undersize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-undersize-grip?variant=52295217643890"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Grey/Blue"
        ],
        "price": 7.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip",
        "handle": "super-stroke-revl-player-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217480050",
            "gid": "gid://shopify/ProductVariant/52295217480050",
            "sku": "SSG-348114",
            "color": "Grey/Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip?variant=52295217480050"
          },
          {
            "id": "52295217512818",
            "gid": "gid://shopify/ProductVariant/52295217512818",
            "sku": "SSG-348101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip?variant=52295217512818"
          },
          {
            "id": "52295217545586",
            "gid": "gid://shopify/ProductVariant/52295217545586",
            "sku": "SSG-348100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-standard-grip?variant=52295217545586"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Grey/Blue"
        ],
        "price": 7.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip",
        "handle": "super-stroke-revl-player-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey/Blue",
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52295217381746",
            "gid": "gid://shopify/ProductVariant/52295217381746",
            "sku": "SSG-348314",
            "color": "Grey/Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey/Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip?variant=52295217381746"
          },
          {
            "id": "52295217414514",
            "gid": "gid://shopify/ProductVariant/52295217414514",
            "sku": "SSG-348301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip?variant=52295217414514"
          },
          {
            "id": "52295217447282",
            "gid": "gid://shopify/ProductVariant/52295217447282",
            "sku": "SSG-348300",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-revl-player-midsize-grip?variant=52295217447282"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, best-sellers, golf-grips, grip bundle, iron/wood, midsize, midsize-golf-grips, new-add-12172025, REVL, REVL Grip, Revl Player, rubber, rubber-golf-grips, single-golf-grips, single-grip, soft, Super Stroke, Super Stroke REVL, Super Stroke REVL Player, tac",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Grey/Blue",
      "Black",
      "White"
    ]
  },
  {
    "id": "super-stroke-s-tech",
    "brand": "Super Stroke",
    "model": "S-Tech",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "Tech Midsize Grip",
      "Tech Standard Grip"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 5.99,
    "price_max": 84.37,
    "single_price_min": 5.99,
    "single_price_max": 6.49,
    "normalized_price_per_grip": 5.39,
    "bundle_price_min": 48.52,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-s-tech-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/super-stroke-stech-4colors.jpg?v=1766011358",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black",
          "Tech Standard Grip"
        ],
        "price": 77.87,
        "per_grip_g": 4.5,
        "total_g": 58.9670081,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-bundle-13pcs",
        "handle": "super-stroke-s-tech-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Gray"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398923903346",
            "gid": "gid://shopify/ProductVariant/61398923903346",
            "sku": "SET-13xSSG-018101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 59,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-bundle-13pcs?variant=61398923903346"
          },
          {
            "id": "61398923936114",
            "gid": "gid://shopify/ProductVariant/61398923936114",
            "sku": "SET-13xSSG-018102",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 59,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-bundle-13pcs?variant=61398923936114"
          },
          {
            "id": "61398923968882",
            "gid": "gid://shopify/ProductVariant/61398923968882",
            "sku": "SET-13xSSG-018103",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 59,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-bundle-13pcs?variant=61398923968882"
          },
          {
            "id": "61398924001650",
            "gid": "gid://shopify/ProductVariant/61398924001650",
            "sku": "SET-13xSSG-018114",
            "color": "Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Gray"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 59,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-bundle-13pcs?variant=61398924001650"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black",
          "Tech Midsize Grip"
        ],
        "price": 84.37,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-midsize-grip-bundle-13pcs",
        "handle": "super-stroke-s-tech-midsize-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398922559858",
            "gid": "gid://shopify/ProductVariant/61398922559858",
            "sku": "SET-13xSSG-018301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 84.37,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-midsize-grip-bundle-13pcs?variant=61398922559858"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 48.52,
        "per_grip_g": 59,
        "total_g": 530.7030729,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-grip-bundle-set",
        "handle": "super-stroke-s-tech-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Gray"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021967499325",
            "gid": "gid://shopify/ProductVariant/41021967499325",
            "sku": "SET-9xSSG-018101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 530.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-grip-bundle-set?variant=41021967499325"
          },
          {
            "id": "41021967532093",
            "gid": "gid://shopify/ProductVariant/41021967532093",
            "sku": "SET-9xSSG-018102",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 530.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-grip-bundle-set?variant=41021967532093"
          },
          {
            "id": "41021967564861",
            "gid": "gid://shopify/ProductVariant/41021967564861",
            "sku": "SET-9xSSG-018103",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 530.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-grip-bundle-set?variant=41021967564861"
          },
          {
            "id": "41021967597629",
            "gid": "gid://shopify/ProductVariant/41021967597629",
            "sku": "SET-9xSSG-018114",
            "color": "Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Gray"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 530.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip-grip-bundle-set?variant=41021967597629"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-midsize-grip-grip-bundle-set",
        "handle": "super-stroke-s-tech-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967433789",
            "gid": "gid://shopify/ProductVariant/41021967433789",
            "sku": "SET-9xSSG-018301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-midsize-grip-grip-bundle-set?variant=41021967433789"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Tech Midsize Grip"
        ],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-midsize-grip",
        "handle": "super-stroke-s-tech-midsize-grip",
        "shopify_variants": [
          {
            "id": "14868036423",
            "gid": "gid://shopify/ProductVariant/14868036423",
            "sku": "SSG-018301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-midsize-grip?variant=14868036423"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black",
          "Tech Standard Grip"
        ],
        "price": 5.99,
        "per_grip_g": 59,
        "total_g": 58.9670081,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip",
        "handle": "super-stroke-s-tech-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14867875015",
            "gid": "gid://shopify/ProductVariant/14867875015",
            "sku": "SSG-018101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 59,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip?variant=14867875015"
          },
          {
            "id": "40848790855",
            "gid": "gid://shopify/ProductVariant/40848790855",
            "sku": "SSG-018102",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 59,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip?variant=40848790855"
          },
          {
            "id": "14867875143",
            "gid": "gid://shopify/ProductVariant/14867875143",
            "sku": "SSG-018103",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 59,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-grip?variant=14867875143"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, blackfriday2020, golf-grips, grip bundle, infinite-opt-addkit, iron/wood, medium soft, New for 2016, new-add-12172025, rubber, s-tech, single-golf-grips, single-grip, standard, standard-size-golf-grips, super stroke swing, super-stroke, super-stroke-s-te",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-s-tech-black",
    "brand": "Super Stroke",
    "model": "S-Tech (Black)",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Black",
      "Midsize / Black"
    ],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 92.86,
    "price_max": 99.36,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 7.14,
    "bundle_price_min": null,
    "kit_price_min": 92.86,
    "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-midsize-grips-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-2018-stech-blk_e9cc2ed4-feb8-45aa-a5ab-a284adacf065.jpg?v=1736027159",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Midsize / Black"
        ],
        "price": 99.36,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-midsize-grips-black",
        "handle": "grip-kit-13x-super-stroke-s-tech-midsize-grips-black",
        "shopify_variants": [
          {
            "id": "42064653651",
            "gid": "gid://shopify/ProductVariant/42064653651",
            "sku": "KIT+13xSSG-018301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Black",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 99.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-midsize-grips-black?variant=42064653651"
          },
          {
            "id": "39920758128701",
            "gid": "gid://shopify/ProductVariant/39920758128701",
            "sku": "KIT(8oz)+13xSSG-018301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Black",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 103.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-midsize-grips-black?variant=39920758128701"
          }
        ],
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Midsize / Black"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-standard-grips-black",
        "handle": "grip-kit-13x-super-stroke-s-tech-standard-grips-black",
        "shopify_variants": [
          {
            "id": "42063774803",
            "gid": "gid://shopify/ProductVariant/42063774803",
            "sku": "KIT+13xSSG-018101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-standard-grips-black?variant=42063774803"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, cord, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, iron/w",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-s-tech-blue",
    "brand": "Super Stroke",
    "model": "S-Tech (Blue)",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 92.86,
    "price_max": 92.86,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 7.14,
    "bundle_price_min": null,
    "kit_price_min": 92.86,
    "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-standard-grips-blue",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-2018-stech-blue.jpg?v=1736027161",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Blue"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-standard-grips-blue",
        "handle": "grip-kit-13x-super-stroke-s-tech-standard-grips-blue",
        "shopify_variants": [
          {
            "id": "42063985619",
            "gid": "gid://shopify/ProductVariant/42063985619",
            "sku": "KIT+13xSSG-018103",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-standard-grips-blue?variant=42063985619"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, cord, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-fre",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-s-tech-grey",
    "brand": "Super Stroke",
    "model": "S-Tech (Grey)",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Grey"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 92.86,
    "price_max": 92.86,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 7.14,
    "bundle_price_min": null,
    "kit_price_min": 92.86,
    "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-standard-grips-grey",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-2018-stech-grey.jpg?v=1736027160",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Grey"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-standard-grips-grey",
        "handle": "grip-kit-13x-super-stroke-s-tech-standard-grips-grey",
        "shopify_variants": [
          {
            "id": "42064448211",
            "gid": "gid://shopify/ProductVariant/42064448211",
            "sku": "KIT+13xSSG-018114",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/grip-kit-13x-super-stroke-s-tech-standard-grips-grey?variant=42064448211"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, cord, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-fre",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-s-tech-red",
    "brand": "Super Stroke",
    "model": "S-Tech (Red)",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 92.86,
    "price_max": 92.86,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 7.14,
    "bundle_price_min": null,
    "kit_price_min": 92.86,
    "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-red-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-2018-stech-red.jpg?v=1736027132",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Red"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-red-13pcs-golf-grip-kit",
        "handle": "super-stroke-s-tech-standard-red-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "1123823321107",
            "gid": "gid://shopify/ProductVariant/1123823321107",
            "sku": "KIT+13xSSG-018102",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-standard-red-13pcs-golf-grip-kit?variant=1123823321107"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, bf-sale, blackfriday2020, bundle, bundles-asbl-driver-only, cord, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, iron/wood",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-s-tech-cord",
    "brand": "Super Stroke",
    "model": "S-Tech CORD",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "cord",
    "texture": "corded",
    "feel": "firm",
    "tack": "low",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "full_cord",
    "cord_coverage": "full",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "low",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 8.99,
    "price_max": 131.86,
    "single_price_min": 8.99,
    "single_price_max": 8.99,
    "normalized_price_per_grip": 8.09,
    "bundle_price_min": 72.82,
    "kit_price_min": 131.86,
    "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/superstroke-stech-cord.jpg?v=1766011255",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 116.87,
        "per_grip_g": 4.5,
        "total_g": 58.9670081,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip-bundle-13pcs",
        "handle": "super-stroke-s-tech-cord-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398919807346",
            "gid": "gid://shopify/ProductVariant/61398919807346",
            "sku": "SET-13xSSG-118101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 116.87,
            "weight_g": 59,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip-bundle-13pcs?variant=61398919807346"
          },
          {
            "id": "61398919840114",
            "gid": "gid://shopify/ProductVariant/61398919840114",
            "sku": "SET-13xSSG-118100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 116.87,
            "weight_g": 59,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip-bundle-13pcs?variant=61398919840114"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 72.82,
        "per_grip_g": 59,
        "total_g": 530.7030729,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip-grip-bundle-set",
        "handle": "super-stroke-s-tech-cord-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021963731005",
            "gid": "gid://shopify/ProductVariant/41021963731005",
            "sku": "SET-9xSSG-118101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 72.82,
            "weight_g": 530.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip-grip-bundle-set?variant=41021963731005"
          },
          {
            "id": "41021963763773",
            "gid": "gid://shopify/ProductVariant/41021963763773",
            "sku": "SET-9xSSG-118100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 72.82,
            "weight_g": 530.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip-grip-bundle-set?variant=41021963763773"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 131.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-s-tech-cord-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007842922557",
            "gid": "gid://shopify/ProductVariant/32007842922557",
            "sku": "KIT+13xSSG-118101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 131.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip-13pcs-golf-grip-kit?variant=32007842922557"
          },
          {
            "id": "32007842955325",
            "gid": "gid://shopify/ProductVariant/32007842955325",
            "sku": "KIT+13xSSG-118100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 131.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip-13pcs-golf-grip-kit?variant=32007842955325"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 8.99,
        "per_grip_g": 59,
        "total_g": 58.9670081,
        "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip",
        "handle": "super-stroke-s-tech-cord-standard-grip",
        "shopify_variants": [
          {
            "id": "29155593781309",
            "gid": "gid://shopify/ProductVariant/29155593781309",
            "sku": "SSG-118101",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 8.99,
            "weight_g": 59,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-s-tech-cord-standard-grip?variant=29155593781309"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, blackfriday2020, cord, cord-golf-grips, full cord, golf-grips, grip bundle, iron/wood, New for 2016, new-add-12172025, s-tech, single-golf-grips, single-grip, standard, standard-size-golf-grips, Super Stroke cord, super stroke swing, super-stroke, super-",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "super-stroke-soft-wrap-tc",
    "brand": "Super Stroke",
    "model": "Soft Wrap TC",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 71.9,
      "Midsize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 4.45,
    "price_max": 86.36,
    "single_price_min": 4.45,
    "single_price_max": 5.49,
    "normalized_price_per_grip": 4.45,
    "bundle_price_min": null,
    "kit_price_min": 79.86,
    "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/superstroke-soft-wrap-tc-red-black_ea4238b1-04cc-4f6a-91e4-d9e6103b8abd.jpg?v=1736026986",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 5,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 79.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-standard-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-soft-wrap-tc-standard-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007845216317",
            "gid": "gid://shopify/ProductVariant/32007845216317",
            "sku": "KIT+13xSSG-346101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 79.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-standard-grip-13pcs-golf-grip-kit?variant=32007845216317"
          },
          {
            "id": "32007845249085",
            "gid": "gid://shopify/ProductVariant/32007845249085",
            "sku": "KIT+13xSSG-346102",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 79.86,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-standard-grip-13pcs-golf-grip-kit?variant=32007845249085"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 86.36,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-midsize-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-soft-wrap-tc-midsize-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007845118013",
            "gid": "gid://shopify/ProductVariant/32007845118013",
            "sku": "KIT+13xSSG-346301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 86.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-midsize-grip-13pcs-golf-grip-kit?variant=32007845118013"
          },
          {
            "id": "32007845150781",
            "gid": "gid://shopify/ProductVariant/32007845150781",
            "sku": "KIT+13xSSG-346302",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 86.36,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-midsize-grip-13pcs-golf-grip-kit?variant=32007845150781"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 4.45,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-oversize-grip",
        "handle": "super-stroke-soft-wrap-tc-oversize-grip",
        "shopify_variants": [
          {
            "id": "7647338463293",
            "gid": "gid://shopify/ProductVariant/7647338463293",
            "sku": "SSG-346501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 4.45,
            "weight_g": 190.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-oversize-grip?variant=7647338463293"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-midsize-grip",
        "handle": "super-stroke-soft-wrap-tc-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "7647331549245",
            "gid": "gid://shopify/ProductVariant/7647331549245",
            "sku": "SSG-346301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 5.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-midsize-grip?variant=7647331549245"
          },
          {
            "id": "12706172665917",
            "gid": "gid://shopify/ProductVariant/12706172665917",
            "sku": "SSG-346302",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 5.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-midsize-grip?variant=12706172665917"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 4.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-standard-grip",
        "handle": "super-stroke-soft-wrap-tc-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "7647268864061",
            "gid": "gid://shopify/ProductVariant/7647268864061",
            "sku": "SSG-346101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 4.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-standard-grip?variant=7647268864061"
          },
          {
            "id": "7647268896829",
            "gid": "gid://shopify/ProductVariant/7647268896829",
            "sku": "SSG-346102",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 4.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-soft-wrap-tc-standard-grip?variant=7647268896829"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-nysale, 2025-black-friday, 2025-winter-sale-bundles, 2025-winter-sale-no-fuj, All Products, blackfriday2020, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, iron/wood, KIT-added07282020, labor-day-bundle-sale-2025, labor-day-bundle-sale-2025-",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "super-stroke-tour-traxion-club",
    "brand": "Super Stroke",
    "model": "Tour TRAXION Club",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "Embossed ridge",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "reduced",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "White / Grey",
      "White / Red / Grey"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 7.99,
    "price_max": 131.86,
    "single_price_min": 7.99,
    "single_price_max": 8.99,
    "normalized_price_per_grip": 7.19,
    "bundle_price_min": 64.72,
    "kit_price_min": 118.86,
    "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/super-stroke-traxion-club-std-5colors.jpg?v=1766011247",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 16,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "White / Red / Grey"
        ],
        "price": 103.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-bundle-13pcs",
        "handle": "super-stroke-tour-traxion-club-swing-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Red / Grey",
              "Black / Grey",
              "Digi Camo",
              "Tiff / Gry / Wht",
              "White / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398919512434",
            "gid": "gid://shopify/ProductVariant/61398919512434",
            "sku": "SET-13xSSG-646100",
            "color": "White / Red / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "White / Red / Grey"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-bundle-13pcs?variant=61398919512434"
          },
          {
            "id": "61398919545202",
            "gid": "gid://shopify/ProductVariant/61398919545202",
            "sku": "SET-13xSSG-646124",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-bundle-13pcs?variant=61398919545202"
          },
          {
            "id": "61398919577970",
            "gid": "gid://shopify/ProductVariant/61398919577970",
            "sku": "SET-13xSSG-646137",
            "color": "Digi Camo",
            "size": "Standard",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-bundle-13pcs?variant=61398919577970"
          },
          {
            "id": "61398919610738",
            "gid": "gid://shopify/ProductVariant/61398919610738",
            "sku": "SET-13xSSG-646120",
            "color": "Tiff / Gry / Wht",
            "size": "Standard",
            "selected_options": {
              "Color": "Tiff / Gry / Wht"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-bundle-13pcs?variant=61398919610738"
          },
          {
            "id": "61398919643506",
            "gid": "gid://shopify/ProductVariant/61398919643506",
            "sku": "SET-13xSSG-646114",
            "color": "White / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-bundle-13pcs?variant=61398919643506"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "White / Grey"
        ],
        "price": 103.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip-bundle-13pcs",
        "handle": "super-stroke-tour-traxion-club-swing-undersize-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Grey",
              "Tiff / Grey / Wht"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398919315826",
            "gid": "gid://shopify/ProductVariant/61398919315826",
            "sku": "SET-13xSSG-646014",
            "color": "White / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip-bundle-13pcs?variant=61398919315826"
          },
          {
            "id": "61398919348594",
            "gid": "gid://shopify/ProductVariant/61398919348594",
            "sku": "SET-13xSSG-646020",
            "color": "Tiff / Grey / Wht",
            "size": "Undersize",
            "selected_options": {
              "Color": "Tiff / Grey / Wht"
            },
            "available": true,
            "price": 103.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip-bundle-13pcs?variant=61398919348594"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "White / Grey"
        ],
        "price": 116.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-bundle-13pcs",
        "handle": "super-stroke-tour-traxion-club-swing-jumbo-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Grey",
              "Black / Grey",
              "Digi Camo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398919217522",
            "gid": "gid://shopify/ProductVariant/61398919217522",
            "sku": "SET-13xSSG-646514",
            "color": "White / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": false,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-bundle-13pcs?variant=61398919217522"
          },
          {
            "id": "61398919250290",
            "gid": "gid://shopify/ProductVariant/61398919250290",
            "sku": "SET-13xSSG-646524",
            "color": "Black / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-bundle-13pcs?variant=61398919250290"
          },
          {
            "id": "61398919283058",
            "gid": "gid://shopify/ProductVariant/61398919283058",
            "sku": "SET-13xSSG-646537",
            "color": "Digi Camo",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 116.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-bundle-13pcs?variant=61398919283058"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "White / Grey"
        ],
        "price": 110.37,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-bundle-13pcs",
        "handle": "super-stroke-tour-traxion-club-swing-midsize-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398919151986",
            "gid": "gid://shopify/ProductVariant/61398919151986",
            "sku": "SET-13xSSG-646314",
            "color": "White / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 110.37,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-bundle-13pcs?variant=61398919151986"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "White / Red / Grey"
        ],
        "price": 64.72,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-grip-bundle-set",
        "handle": "super-stroke-tour-traxion-club-swing-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Red / Grey",
              "Black / Grey",
              "Digi Camo",
              "Tiff / Gry / Wht",
              "White / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021963567165",
            "gid": "gid://shopify/ProductVariant/41021963567165",
            "sku": "SET-9xSSG-646100",
            "color": "White / Red / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "White / Red / Grey"
            },
            "available": true,
            "price": 64.72,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-grip-bundle-set?variant=41021963567165"
          },
          {
            "id": "41021963599933",
            "gid": "gid://shopify/ProductVariant/41021963599933",
            "sku": "SET-9xSSG-646124",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": true,
            "price": 64.72,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-grip-bundle-set?variant=41021963599933"
          },
          {
            "id": "41021963632701",
            "gid": "gid://shopify/ProductVariant/41021963632701",
            "sku": "SET-9xSSG-646137",
            "color": "Digi Camo",
            "size": "Standard",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": true,
            "price": 64.72,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-grip-bundle-set?variant=41021963632701"
          },
          {
            "id": "41021963665469",
            "gid": "gid://shopify/ProductVariant/41021963665469",
            "sku": "SET-9xSSG-646120",
            "color": "Tiff / Gry / Wht",
            "size": "Standard",
            "selected_options": {
              "Color": "Tiff / Gry / Wht"
            },
            "available": true,
            "price": 64.72,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-grip-bundle-set?variant=41021963665469"
          },
          {
            "id": "41021963698237",
            "gid": "gid://shopify/ProductVariant/41021963698237",
            "sku": "SET-9xSSG-646114",
            "color": "White / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 64.72,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-grip-bundle-set?variant=41021963698237"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "White / Grey"
        ],
        "price": 64.72,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip-grip-bundle-set",
        "handle": "super-stroke-tour-traxion-club-swing-undersize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Grey",
              "Tiff / Grey / Wht"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021963501629",
            "gid": "gid://shopify/ProductVariant/41021963501629",
            "sku": "SET-9xSSG-646014",
            "color": "White / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 64.72,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip-grip-bundle-set?variant=41021963501629"
          },
          {
            "id": "41021963534397",
            "gid": "gid://shopify/ProductVariant/41021963534397",
            "sku": "SET-9xSSG-646020",
            "color": "Tiff / Grey / Wht",
            "size": "Undersize",
            "selected_options": {
              "Color": "Tiff / Grey / Wht"
            },
            "available": true,
            "price": 64.72,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip-grip-bundle-set?variant=41021963534397"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "White / Grey"
        ],
        "price": 72.82,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-grip-bundle-set",
        "handle": "super-stroke-tour-traxion-club-swing-jumbo-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Grey",
              "Black / Grey",
              "Digi Camo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021963370557",
            "gid": "gid://shopify/ProductVariant/41021963370557",
            "sku": "SET-9xSSG-646514",
            "color": "White / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": false,
            "price": 72.82,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-grip-bundle-set?variant=41021963370557"
          },
          {
            "id": "41021963403325",
            "gid": "gid://shopify/ProductVariant/41021963403325",
            "sku": "SET-9xSSG-646524",
            "color": "Black / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 72.82,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-grip-bundle-set?variant=41021963403325"
          },
          {
            "id": "41021963436093",
            "gid": "gid://shopify/ProductVariant/41021963436093",
            "sku": "SET-9xSSG-646537",
            "color": "Digi Camo",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 72.82,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-grip-bundle-set?variant=41021963436093"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "White / Red / Grey"
        ],
        "price": 68.77,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-grip-bundle-set",
        "handle": "super-stroke-tour-traxion-club-swing-midsize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Red / Grey",
              "Black / Grey",
              "Digi Camo",
              "White / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021962649661",
            "gid": "gid://shopify/ProductVariant/41021962649661",
            "sku": "SET-9xSSG-646300",
            "color": "White / Red / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "White / Red / Grey"
            },
            "available": false,
            "price": 68.77,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-grip-bundle-set?variant=41021962649661"
          },
          {
            "id": "41021962682429",
            "gid": "gid://shopify/ProductVariant/41021962682429",
            "sku": "SET-9xSSG-646324",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 68.77,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-grip-bundle-set?variant=41021962682429"
          },
          {
            "id": "41021962715197",
            "gid": "gid://shopify/ProductVariant/41021962715197",
            "sku": "SET-9xSSG-646337",
            "color": "Digi Camo",
            "size": "Midsize",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 68.77,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-grip-bundle-set?variant=41021962715197"
          },
          {
            "id": "41021962747965",
            "gid": "gid://shopify/ProductVariant/41021962747965",
            "sku": "SET-9xSSG-646314",
            "color": "White / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 68.77,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-grip-bundle-set?variant=41021962747965"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "White / Red / Grey"
        ],
        "price": 118.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-tour-traxion-club-swing-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Red / Grey",
              "Black / Grey",
              "Digi Camo",
              "Tiff / Gry / Wht",
              "White / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007842627645",
            "gid": "gid://shopify/ProductVariant/32007842627645",
            "sku": "KIT+13xSSG-646100",
            "color": "White / Red / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "White / Red / Grey"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-13pcs-golf-grip-kit?variant=32007842627645"
          },
          {
            "id": "32007842660413",
            "gid": "gid://shopify/ProductVariant/32007842660413",
            "sku": "KIT+13xSSG-646124",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-13pcs-golf-grip-kit?variant=32007842660413"
          },
          {
            "id": "32007842693181",
            "gid": "gid://shopify/ProductVariant/32007842693181",
            "sku": "KIT+13xSSG-646137",
            "color": "Digi Camo",
            "size": "Standard",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-13pcs-golf-grip-kit?variant=32007842693181"
          },
          {
            "id": "32007842725949",
            "gid": "gid://shopify/ProductVariant/32007842725949",
            "sku": "KIT+13xSSG-646120",
            "color": "Tiff / Gry / Wht",
            "size": "Standard",
            "selected_options": {
              "Color": "Tiff / Gry / Wht"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-13pcs-golf-grip-kit?variant=32007842725949"
          },
          {
            "id": "32007842758717",
            "gid": "gid://shopify/ProductVariant/32007842758717",
            "sku": "KIT+13xSSG-646114",
            "color": "White / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip-13pcs-golf-grip-kit?variant=32007842758717"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "White / Grey"
        ],
        "price": 118.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-tour-traxion-club-swing-undersize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Grey",
              "Tiff / Grey / Wht"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007842299965",
            "gid": "gid://shopify/ProductVariant/32007842299965",
            "sku": "KIT+13xSSG-646014",
            "color": "White / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip-13pcs-golf-grip-kit?variant=32007842299965"
          },
          {
            "id": "32007842332733",
            "gid": "gid://shopify/ProductVariant/32007842332733",
            "sku": "KIT+13xSSG-646020",
            "color": "Tiff / Grey / Wht",
            "size": "Undersize",
            "selected_options": {
              "Color": "Tiff / Grey / Wht"
            },
            "available": true,
            "price": 118.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip-13pcs-golf-grip-kit?variant=32007842332733"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "White / Grey"
        ],
        "price": 131.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-tour-traxion-club-swing-jumbo-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Grey",
              "Black / Grey",
              "Digi Camo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007842070589",
            "gid": "gid://shopify/ProductVariant/32007842070589",
            "sku": "KIT+13xSSG-646514",
            "color": "White / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": false,
            "price": 131.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-13pcs-golf-grip-kit?variant=32007842070589"
          },
          {
            "id": "32007842103357",
            "gid": "gid://shopify/ProductVariant/32007842103357",
            "sku": "KIT+13xSSG-646524",
            "color": "Black / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 131.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-13pcs-golf-grip-kit?variant=32007842103357"
          },
          {
            "id": "32007842136125",
            "gid": "gid://shopify/ProductVariant/32007842136125",
            "sku": "KIT+13xSSG-646537",
            "color": "Digi Camo",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 131.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip-13pcs-golf-grip-kit?variant=32007842136125"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "White / Red / Grey"
        ],
        "price": 125.36,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-tour-traxion-club-swing-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Red / Grey",
              "Black / Grey",
              "Digi Camo",
              "White / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007841677373",
            "gid": "gid://shopify/ProductVariant/32007841677373",
            "sku": "KIT+13xSSG-646300",
            "color": "White / Red / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "White / Red / Grey"
            },
            "available": false,
            "price": 125.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-13pcs-golf-grip-kit?variant=32007841677373"
          },
          {
            "id": "32007841710141",
            "gid": "gid://shopify/ProductVariant/32007841710141",
            "sku": "KIT+13xSSG-646324",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 125.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-13pcs-golf-grip-kit?variant=32007841710141"
          },
          {
            "id": "32007841742909",
            "gid": "gid://shopify/ProductVariant/32007841742909",
            "sku": "KIT+13xSSG-646337",
            "color": "Digi Camo",
            "size": "Midsize",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 125.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-13pcs-golf-grip-kit?variant=32007841742909"
          },
          {
            "id": "32007841775677",
            "gid": "gid://shopify/ProductVariant/32007841775677",
            "sku": "KIT+13xSSG-646314",
            "color": "White / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 125.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip-13pcs-golf-grip-kit?variant=32007841775677"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "White / Red / Grey"
        ],
        "price": 8.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip",
        "handle": "super-stroke-tour-traxion-club-swing-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Red / Grey",
              "Black / Grey",
              "Digi Camo",
              "White / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "29423969566781",
            "gid": "gid://shopify/ProductVariant/29423969566781",
            "sku": "SSG-646300",
            "color": "White / Red / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "White / Red / Grey"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip?variant=29423969566781"
          },
          {
            "id": "31553042579517",
            "gid": "gid://shopify/ProductVariant/31553042579517",
            "sku": "SSG-646324",
            "color": "Black / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": true,
            "price": 8.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip?variant=31553042579517"
          },
          {
            "id": "31553043136573",
            "gid": "gid://shopify/ProductVariant/31553043136573",
            "sku": "SSG-646337",
            "color": "Digi Camo",
            "size": "Midsize",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip?variant=31553043136573"
          },
          {
            "id": "29423969599549",
            "gid": "gid://shopify/ProductVariant/29423969599549",
            "sku": "SSG-646314",
            "color": "White / Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 8.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-midsize-grip?variant=29423969599549"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "White / Grey"
        ],
        "price": 8.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip",
        "handle": "super-stroke-tour-traxion-club-swing-jumbo-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Grey",
              "Black / Grey",
              "Digi Camo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "29423967567933",
            "gid": "gid://shopify/ProductVariant/29423967567933",
            "sku": "SSG-646514",
            "color": "White / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip?variant=29423967567933"
          },
          {
            "id": "31553043988541",
            "gid": "gid://shopify/ProductVariant/31553043988541",
            "sku": "SSG-646524",
            "color": "Black / Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip?variant=31553043988541"
          },
          {
            "id": "31553044217917",
            "gid": "gid://shopify/ProductVariant/31553044217917",
            "sku": "SSG-646537",
            "color": "Digi Camo",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-jumbo-grip?variant=31553044217917"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "White / Grey"
        ],
        "price": 7.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip",
        "handle": "super-stroke-tour-traxion-club-swing-undersize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Grey",
              "Tiff / Grey / Wht"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "29423963406397",
            "gid": "gid://shopify/ProductVariant/29423963406397",
            "sku": "SSG-646014",
            "color": "White / Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip?variant=29423963406397"
          },
          {
            "id": "31553022296125",
            "gid": "gid://shopify/ProductVariant/31553022296125",
            "sku": "SSG-646020",
            "color": "Tiff / Grey / Wht",
            "size": "Undersize",
            "selected_options": {
              "Color": "Tiff / Grey / Wht"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-undersize-grip?variant=31553022296125"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "White / Red / Grey"
        ],
        "price": 7.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip",
        "handle": "super-stroke-tour-traxion-club-swing-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Red / Grey",
              "Black / Grey",
              "Digi Camo",
              "Tiff / Gry / Wht",
              "White / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "29423937323069",
            "gid": "gid://shopify/ProductVariant/29423937323069",
            "sku": "SSG-646100",
            "color": "White / Red / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "White / Red / Grey"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip?variant=29423937323069"
          },
          {
            "id": "31553040187453",
            "gid": "gid://shopify/ProductVariant/31553040187453",
            "sku": "SSG-646124",
            "color": "Black / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Grey"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip?variant=31553040187453"
          },
          {
            "id": "31553041236029",
            "gid": "gid://shopify/ProductVariant/31553041236029",
            "sku": "SSG-646137",
            "color": "Digi Camo",
            "size": "Standard",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip?variant=31553041236029"
          },
          {
            "id": "31553041858621",
            "gid": "gid://shopify/ProductVariant/31553041858621",
            "sku": "SSG-646120",
            "color": "Tiff / Gry / Wht",
            "size": "Standard",
            "selected_options": {
              "Color": "Tiff / Gry / Wht"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip?variant=31553041858621"
          },
          {
            "id": "29423937355837",
            "gid": "gid://shopify/ProductVariant/29423937355837",
            "sku": "SSG-646114",
            "color": "White / Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "White / Grey"
            },
            "available": true,
            "price": 7.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-traxion-club-swing-standard-grip?variant=29423937355837"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, blackfriday2020, flatso traxion, golf-grips, grip bundle, iron/wood, new-add-12172025, single-golf-grips, single-grip, standard, standard-size-golf-grips, super stroke swing, Super Stroke Traxion Tour Club, super-stroke, super-stroke-traxion-tour-club-gr",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "2026-07-13",
    "manual_notes": "SPYNE uses an embossed ridge; Tour TRAXION Club uses a reduced taper.",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "White / Red / Grey",
      "Black / Grey",
      "Digi Camo",
      "Tiff / Gry / Wht",
      "White / Grey",
      "Tiff / Grey / Wht"
    ]
  },
  {
    "id": "super-stroke-training",
    "brand": "Super Stroke",
    "model": "Training",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "training_only",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard Mens"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 14.99,
    "price_max": 14.99,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 14.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-training-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/superstroke-training-1.jpg?v=1760117699",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 14.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-training-standard-grip",
        "handle": "super-stroke-training-standard-grip",
        "shopify_options": [
          {
            "name": "Hand",
            "values": [
              "For Left Handed Players",
              "For Right Handed Players"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard Mens",
              "Standard Womens"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "60752714137970",
            "gid": "gid://shopify/ProductVariant/60752714137970",
            "sku": "SSG-000154",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Left Handed Players",
              "Grip Size": "Standard Mens"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-training-standard-grip?variant=60752714137970"
          },
          {
            "id": "60752716792178",
            "gid": "gid://shopify/ProductVariant/60752716792178",
            "sku": "SSG-000155",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Right Handed Players",
              "Grip Size": "Standard Womens"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-training-standard-grip?variant=60752716792178"
          },
          {
            "id": "60752714105202",
            "gid": "gid://shopify/ProductVariant/60752714105202",
            "sku": "SSG-000153",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Hand": "For Right Handed Players",
              "Grip Size": "Standard Mens"
            },
            "available": false,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-training-standard-grip?variant=60752714105202"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, Brand_Super Stroke, golf-grips, single-golf-grips, single-grip, Super Stroke, super stroke training, training, training-beginner-practice, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-wrap",
    "brand": "Super Stroke",
    "model": "Traxion WRAP",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black",
      "Grey"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 5.99,
    "price_max": 105.86,
    "single_price_min": 5.99,
    "single_price_max": 6.99,
    "normalized_price_per_grip": 5.39,
    "bundle_price_min": 48.52,
    "kit_price_min": 92.86,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/superstroke-traxion-wrap-allcolors_9d96acfc-3bd7-497a-b5c4-cdace1909eb3.jpg?v=1766011288",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 15,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 77.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-bundle-13pcs",
        "handle": "super-stroke-traxion-wrap-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Tan/Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398920593778",
            "gid": "gid://shopify/ProductVariant/61398920593778",
            "sku": "SET-13xSSG-546101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-bundle-13pcs?variant=61398920593778"
          },
          {
            "id": "61398920626546",
            "gid": "gid://shopify/ProductVariant/61398920626546",
            "sku": "SET-13xSSG-546118",
            "color": "Tan/Copper",
            "size": "Standard",
            "selected_options": {
              "Color": "Tan/Copper"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-bundle-13pcs?variant=61398920626546"
          },
          {
            "id": "61398920659314",
            "gid": "gid://shopify/ProductVariant/61398920659314",
            "sku": "SET-13xSSG-546114",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-bundle-13pcs?variant=61398920659314"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 84.37,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-bundle-13pcs",
        "handle": "super-stroke-traxion-wrap-midsize-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398920462706",
            "gid": "gid://shopify/ProductVariant/61398920462706",
            "sku": "SET-13xSSG-546301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 84.37,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-bundle-13pcs?variant=61398920462706"
          },
          {
            "id": "61398920495474",
            "gid": "gid://shopify/ProductVariant/61398920495474",
            "sku": "SET-13xSSG-546318",
            "color": "Tan/Copper",
            "size": "Midsize",
            "selected_options": {
              "Color": "Tan/Copper"
            },
            "available": false,
            "price": 84.37,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-bundle-13pcs?variant=61398920495474"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Tan/Copper"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 90.87,
        "per_grip_g": 4.9,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-bundle-13pcs",
        "handle": "super-stroke-traxion-wrap-oversize-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Tan/Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398920233330",
            "gid": "gid://shopify/ProductVariant/61398920233330",
            "sku": "SET-13xSSG-546501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-bundle-13pcs?variant=61398920233330"
          },
          {
            "id": "61398920266098",
            "gid": "gid://shopify/ProductVariant/61398920266098",
            "sku": "SET-13xSSG-546518",
            "color": "Tan/Copper",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Tan/Copper"
            },
            "available": false,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-bundle-13pcs?variant=61398920266098"
          },
          {
            "id": "61398920298866",
            "gid": "gid://shopify/ProductVariant/61398920298866",
            "sku": "SET-13xSSG-546514",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 90.87,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-bundle-13pcs?variant=61398920298866"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 77.87,
        "per_grip_g": 14.7,
        "total_g": 190.5087954,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-undersize-grip-bundle-13pcs",
        "handle": "super-stroke-traxion-wrap-undersize-grip-bundle-13pcs",
        "shopify_variants": [
          {
            "id": "61398920135026",
            "gid": "gid://shopify/ProductVariant/61398920135026",
            "sku": "SET-13xSSG-546014",
            "color": "Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 77.87,
            "weight_g": 190.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-undersize-grip-bundle-13pcs?variant=61398920135026"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 48.52,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-grip-bundle-set",
        "handle": "super-stroke-traxion-wrap-standard-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021964550205",
            "gid": "gid://shopify/ProductVariant/41021964550205",
            "sku": "SET-9xSSG-546101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-grip-bundle-set?variant=41021964550205"
          },
          {
            "id": "41021964582973",
            "gid": "gid://shopify/ProductVariant/41021964582973",
            "sku": "SET-9xSSG-546118",
            "color": "Copper",
            "size": "Standard",
            "selected_options": {
              "Color": "Copper"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-grip-bundle-set?variant=41021964582973"
          },
          {
            "id": "41021964615741",
            "gid": "gid://shopify/ProductVariant/41021964615741",
            "sku": "SET-9xSSG-546114",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-grip-bundle-set?variant=41021964615741"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 52.57,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-grip-bundle-set",
        "handle": "super-stroke-traxion-wrap-midsize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021964451901",
            "gid": "gid://shopify/ProductVariant/41021964451901",
            "sku": "SET-9xSSG-546301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-grip-bundle-set?variant=41021964451901"
          },
          {
            "id": "41021964484669",
            "gid": "gid://shopify/ProductVariant/41021964484669",
            "sku": "SET-9xSSG-546318",
            "color": "Copper",
            "size": "Midsize",
            "selected_options": {
              "Color": "Copper"
            },
            "available": false,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-grip-bundle-set?variant=41021964484669"
          },
          {
            "id": "41021964517437",
            "gid": "gid://shopify/ProductVariant/41021964517437",
            "sku": "SET-9xSSG-546314",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 52.57,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-grip-bundle-set?variant=41021964517437"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 56.62,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-grip-bundle-set",
        "handle": "super-stroke-traxion-wrap-oversize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021964353597",
            "gid": "gid://shopify/ProductVariant/41021964353597",
            "sku": "SET-9xSSG-546501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 56.62,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-grip-bundle-set?variant=41021964353597"
          },
          {
            "id": "41021964386365",
            "gid": "gid://shopify/ProductVariant/41021964386365",
            "sku": "SET-9xSSG-546518",
            "color": "Copper",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Copper"
            },
            "available": false,
            "price": 56.62,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-grip-bundle-set?variant=41021964386365"
          },
          {
            "id": "41021964419133",
            "gid": "gid://shopify/ProductVariant/41021964419133",
            "sku": "SET-9xSSG-546514",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 56.62,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-grip-bundle-set?variant=41021964419133"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Grey"
        ],
        "price": 48.52,
        "per_grip_g": 190.5,
        "total_g": 1714.5791586,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-undersize-grip-grip-bundle-set",
        "handle": "super-stroke-traxion-wrap-undersize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021964320829",
            "gid": "gid://shopify/ProductVariant/41021964320829",
            "sku": "SET-9xSSG-546014",
            "color": "Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 48.52,
            "weight_g": 1714.6,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-undersize-grip-grip-bundle-set?variant=41021964320829"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 92.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-traxion-wrap-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007844331581",
            "gid": "gid://shopify/ProductVariant/32007844331581",
            "sku": "KIT+13xSSG-546101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-13pcs-golf-grip-kit?variant=32007844331581"
          },
          {
            "id": "32007844364349",
            "gid": "gid://shopify/ProductVariant/32007844364349",
            "sku": "KIT+13xSSG-546118",
            "color": "Copper",
            "size": "Standard",
            "selected_options": {
              "Color": "Copper"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-13pcs-golf-grip-kit?variant=32007844364349"
          },
          {
            "id": "32007844397117",
            "gid": "gid://shopify/ProductVariant/32007844397117",
            "sku": "KIT+13xSSG-546114",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 92.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip-13pcs-golf-grip-kit?variant=32007844397117"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 99.36,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-traxion-wrap-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007844102205",
            "gid": "gid://shopify/ProductVariant/32007844102205",
            "sku": "KIT+13xSSG-546301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 99.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-13pcs-golf-grip-kit?variant=32007844102205"
          },
          {
            "id": "32007844134973",
            "gid": "gid://shopify/ProductVariant/32007844134973",
            "sku": "KIT+13xSSG-546318",
            "color": "Copper",
            "size": "Midsize",
            "selected_options": {
              "Color": "Copper"
            },
            "available": false,
            "price": 99.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-13pcs-golf-grip-kit?variant=32007844134973"
          },
          {
            "id": "32007844167741",
            "gid": "gid://shopify/ProductVariant/32007844167741",
            "sku": "KIT+13xSSG-546314",
            "color": "Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": true,
            "price": 99.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip-13pcs-golf-grip-kit?variant=32007844167741"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 105.86,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-13pcs-golf-grip-kit",
        "handle": "super-stroke-traxion-wrap-oversize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007843872829",
            "gid": "gid://shopify/ProductVariant/32007843872829",
            "sku": "KIT+13xSSG-546501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 105.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-13pcs-golf-grip-kit?variant=32007843872829"
          },
          {
            "id": "32007843905597",
            "gid": "gid://shopify/ProductVariant/32007843905597",
            "sku": "KIT+13xSSG-546518",
            "color": "Copper",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Copper"
            },
            "available": false,
            "price": 105.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-13pcs-golf-grip-kit?variant=32007843905597"
          },
          {
            "id": "32007843938365",
            "gid": "gid://shopify/ProductVariant/32007843938365",
            "sku": "KIT+13xSSG-546514",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 105.86,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip-13pcs-golf-grip-kit?variant=32007843938365"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Grey"
        ],
        "price": 5.99,
        "per_grip_g": 190.5,
        "total_g": 190.5087954,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-undersize-grip",
        "handle": "super-stroke-traxion-wrap-undersize-grip",
        "shopify_variants": [
          {
            "id": "41088042139709",
            "gid": "gid://shopify/ProductVariant/41088042139709",
            "sku": "SSG-546014",
            "color": "Grey",
            "size": "Undersize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 190.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-undersize-grip?variant=41088042139709"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip",
        "handle": "super-stroke-traxion-wrap-oversize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Tan/Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13910138454077",
            "gid": "gid://shopify/ProductVariant/13910138454077",
            "sku": "SSG-546501",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip?variant=13910138454077"
          },
          {
            "id": "13910138486845",
            "gid": "gid://shopify/ProductVariant/13910138486845",
            "sku": "SSG-546518",
            "color": "Tan/Copper",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Tan/Copper"
            },
            "available": false,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip?variant=13910138486845"
          },
          {
            "id": "13910138519613",
            "gid": "gid://shopify/ProductVariant/13910138519613",
            "sku": "SSG-546514",
            "color": "Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 6.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-oversize-grip?variant=13910138519613"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip",
        "handle": "super-stroke-traxion-wrap-midsize-grip",
        "shopify_variants": [
          {
            "id": "13910130851901",
            "gid": "gid://shopify/ProductVariant/13910130851901",
            "sku": "SSG-546301",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip?variant=13910130851901"
          },
          {
            "id": "13910130884669",
            "gid": "gid://shopify/ProductVariant/13910130884669",
            "sku": "SSG-546318",
            "color": "Tan/Copper",
            "size": "Midsize",
            "selected_options": {
              "Color": "Tan/Copper"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-midsize-grip?variant=13910130884669"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Tan/Copper"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 5.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip",
        "handle": "super-stroke-traxion-wrap-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Tan/Copper",
              "Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13910106636349",
            "gid": "gid://shopify/ProductVariant/13910106636349",
            "sku": "SSG-546101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip?variant=13910106636349"
          },
          {
            "id": "13910106669117",
            "gid": "gid://shopify/ProductVariant/13910106669117",
            "sku": "SSG-546118",
            "color": "Tan/Copper",
            "size": "Standard",
            "selected_options": {
              "Color": "Tan/Copper"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip?variant=13910106669117"
          },
          {
            "id": "13910106701885",
            "gid": "gid://shopify/ProductVariant/13910106701885",
            "sku": "SSG-546114",
            "color": "Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey"
            },
            "available": false,
            "price": 5.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-wrap-standard-grip?variant=13910106701885"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, All Products, blackfriday2020, golf-grips, grip bundle, iron/wood, Less Tapered, minimal taper, new arrivals, New for 2016, new-add-12172025, non-tapered swing grips, non-tapered-and-less-tapered-swing-grips, reduced taper, rubber, single-golf-grips, single-grip, soft",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Grey"
    ]
  },
  {
    "id": "tacki-mac-arthritic-serrated",
    "brand": "Tacki-Mac",
    "model": "Arthritic Serrated",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5,
      "Standard": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.1,
    "price_max": 68.26,
    "single_price_min": 5.1,
    "single_price_max": 5.25,
    "normalized_price_per_grip": 4.59,
    "bundle_price_min": 41.31,
    "kit_price_min": 67.02,
    "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/serrated_os_c538c068-f593-40ed-984b-efef67aafd57.jpg?v=1735455597",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 42.53,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-oversize-grip-bundle-set",
        "handle": "tacki-mac-arthritic-serrated-oversize-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021972938813",
            "gid": "gid://shopify/ProductVariant/41021972938813",
            "sku": "SET-9x27-160",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 42.53,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-oversize-grip-bundle-set?variant=41021972938813"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 41.31,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-standard-grip-grip-bundle-set",
        "handle": "tacki-mac-arthritic-serrated-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021969301565",
            "gid": "gid://shopify/ProductVariant/41021969301565",
            "sku": "SET-9x26-158",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 41.31,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-standard-grip-grip-bundle-set?variant=41021969301565"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 68.26,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-oversize-13pcs-golf-grip-kit",
        "handle": "tacki-mac-arthritic-serrated-oversize-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007849508925",
            "gid": "gid://shopify/ProductVariant/32007849508925",
            "sku": "KIT+13x27-160",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 68.26,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-oversize-13pcs-golf-grip-kit?variant=32007849508925"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 67.02,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-standard-grip-13pcs-golf-grip-kit",
        "handle": "tacki-mac-arthritic-serrated-standard-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007847411773",
            "gid": "gid://shopify/ProductVariant/32007847411773",
            "sku": "KIT+13x26-158",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 67.02,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-standard-grip-13pcs-golf-grip-kit?variant=32007847411773"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 5.1,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-standard-grip",
        "handle": "tacki-mac-arthritic-serrated-standard-grip",
        "shopify_variants": [
          {
            "id": "810188301",
            "gid": "gid://shopify/ProductVariant/810188301",
            "sku": "26-158",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.1,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-standard-grip?variant=810188301"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 5.25,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-oversize",
        "handle": "tacki-mac-arthritic-serrated-oversize",
        "shopify_variants": [
          {
            "id": "243454562",
            "gid": "gid://shopify/ProductVariant/243454562",
            "sku": "27-160",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.25,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-arthritic-serrated-oversize?variant=243454562"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, arthritic, arthritic-golf-grips, golf-grips, grip bundle, iron/wood, jumbo/oversize, mem25, new-bundle-set, oversize, oversize-jumbo-golf-grips, prime-2025, single-golf-grips, single-grip, soft, tacki-mac, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "tacki-mac-bubble-replacement-810",
    "brand": "Tacki-Mac",
    "model": "Bubble Replacement (.810\")",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "specialty_bubble_core",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 74.43,
    "price_max": 74.43,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 5.73,
    "bundle_price_min": null,
    "kit_price_min": 74.43,
    "url": "https://www.grips4less.com/products/tacki-mac-bubble-replacement-grip-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/bubble_99a4f540-5a50-461c-9e84-188bd29ae0b2.jpg?v=1736026950",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 74.43,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-bubble-replacement-grip-13pcs-golf-grip-kit",
        "handle": "tacki-mac-bubble-replacement-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007848755261",
            "gid": "gid://shopify/ProductVariant/32007848755261",
            "sku": "KIT+13x105b-810tm",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 74.43,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-bubble-replacement-grip-13pcs-golf-grip-kit?variant=32007848755261"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, All Products, bf-nonassembled, bf-sale, blackfriday2020, bubble, bubble-golf-grips, bundle, bundles-asbl-driver-only, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, iron/wood, jumbo/oversize,",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "tacki-mac-bubble-replacement-grip-810-core",
    "brand": "Tacki-Mac",
    "model": "Bubble Replacement Grip (.810\" core)",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "specialty_bubble_core",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 5.25,
    "price_max": 5.25,
    "single_price_min": 5.25,
    "single_price_max": 5.25,
    "normalized_price_per_grip": 5.25,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/tacki-mac-bubble-replacement-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/bubble.jpg?v=1626808841",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 5.25,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-bubble-replacement-grip",
        "handle": "tacki-mac-bubble-replacement-grip",
        "shopify_variants": [
          {
            "id": "39289174786109",
            "gid": "gid://shopify/ProductVariant/39289174786109",
            "sku": "105b-810tm",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.25,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-bubble-replacement-grip?variant=39289174786109"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, bubble, bubble-golf-grips, golf-grips, iron/wood, jumbo/oversize, rubber, single-golf-grips, single-grip, tacki-mac, under-150, under-300, wrap, wrap-style-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "tacki-mac-itomic-wrap-black",
    "brand": "Tacki-Mac",
    "model": "Itomic Wrap Black",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Jumbo/Oversize": 62,
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 5.69,
    "price_max": 5.75,
    "single_price_min": 5.69,
    "single_price_max": 5.75,
    "normalized_price_per_grip": 5.69,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/tacki-mac-itomic-wrap-black-jumbo-grip-black-cap-with-white-cap",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/itomis-black-grip_dc115320-a9c1-47e2-bb7f-3dbd45497cdb.jpg?v=1758227660",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 5.75,
        "per_grip_g": 62,
        "total_g": 62,
        "url": "https://www.grips4less.com/products/tacki-mac-itomic-wrap-black-jumbo-grip-black-cap-with-white-cap",
        "handle": "tacki-mac-itomic-wrap-black-jumbo-grip-black-cap-with-white-cap",
        "shopify_variants": [
          {
            "id": "60711373046130",
            "gid": "gid://shopify/ProductVariant/60711373046130",
            "sku": "1097BK",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.75,
            "weight_g": 62,
            "weight_unit": "grams",
            "url": "https://www.grips4less.com/products/tacki-mac-itomic-wrap-black-jumbo-grip-black-cap-with-white-cap?variant=60711373046130"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 5.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-itomic-wrap-black-midsize-grip-black-cap-with-white-cap",
        "handle": "tacki-mac-itomic-wrap-black-midsize-grip-black-cap-with-white-cap",
        "shopify_variants": [
          {
            "id": "60709400150386",
            "gid": "gid://shopify/ProductVariant/60709400150386",
            "sku": "1096BK",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-itomic-wrap-black-midsize-grip-black-cap-with-white-cap?variant=60709400150386"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, iron/wood, itomic, jumbo/oversize, oversize, oversize-jumbo-golf-grips, single-golf-grips, single-grip, soft, tacki-mac, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "tacki-mac-non-tapered-serrated",
    "brand": "Tacki-Mac",
    "model": "Non-Tapered Serrated",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.35,
    "price_max": 77.15,
    "single_price_min": 5.35,
    "single_price_max": 5.35,
    "normalized_price_per_grip": 4.82,
    "bundle_price_min": 43.34,
    "kit_price_min": 77.15,
    "url": "https://www.grips4less.com/products/tacki-mac-non-tapered-serrated-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/non-tapered-serrated_9d424991-34af-4a88-8779-b8305726c395.jpg?v=1735455606",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 43.34,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/tacki-mac-non-tapered-serrated-oversize-grip-grip-bundle-set",
        "handle": "tacki-mac-non-tapered-serrated-oversize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021971267645",
            "gid": "gid://shopify/ProductVariant/41021971267645",
            "sku": "SET-9x40-160",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 43.34,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-non-tapered-serrated-oversize-grip-grip-bundle-set?variant=41021971267645"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 77.15,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-non-tapered-serrated-oversize-grip-13pcs-golf-grip-kit",
        "handle": "tacki-mac-non-tapered-serrated-oversize-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007847739453",
            "gid": "gid://shopify/ProductVariant/32007847739453",
            "sku": "KIT+13x40-160",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 77.15,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-non-tapered-serrated-oversize-grip-13pcs-golf-grip-kit?variant=32007847739453"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 5.35,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-non-tapered-serrated-oversize-grip",
        "handle": "tacki-mac-non-tapered-serrated-oversize-grip",
        "shopify_variants": [
          {
            "id": "482123121",
            "gid": "gid://shopify/ProductVariant/482123121",
            "sku": "40-160",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.35,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-non-tapered-serrated-oversize-grip?variant=482123121"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, arthritic, arthritic-golf-grips, golf-grips, grip bundle, iron/wood, jumbo/oversize, mem25, new-bundle-set, non-tapered, non-tapered swing grips, non-tapered-and-less-tapered-swing-grips, oversize, oversize-jumbo-golf-grips, prime-2025, single-golf-grips, single-grip, soft, t",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "tacki-mac-perforated-tour-pro-wrap",
    "brand": "Tacki-Mac",
    "model": "Perforated Tour Pro Wrap",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard 60 Round (most popular)"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 45.4,
      "Midsize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.1,
    "price_max": 65.79,
    "single_price_min": 5.1,
    "single_price_max": 5.25,
    "normalized_price_per_grip": 4.59,
    "bundle_price_min": 41.31,
    "kit_price_min": 60.85,
    "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-midsize",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/105p__64923_zoom_8d07fe14-c0a5-49bf-8b1d-aa0fcaae8b16.jpg?v=1735455597",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 41.31,
        "per_grip_g": 45.4,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-105p-grip-bundle-set",
        "handle": "tacki-mac-perforated-tour-pro-wrap-105p-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard 60 Round (most popular)",
              "Standard 58 Round"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021973004349",
            "gid": "gid://shopify/ProductVariant/41021973004349",
            "sku": "SET-9x105P.600",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 60 Round (most popular)"
            },
            "available": true,
            "price": 41.31,
            "weight_g": 408.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-105p-grip-bundle-set?variant=41021973004349"
          },
          {
            "id": "41021973037117",
            "gid": "gid://shopify/ProductVariant/41021973037117",
            "sku": "SET-9x105P.580",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 58 Round"
            },
            "available": true,
            "price": 41.31,
            "weight_g": 408.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-105p-grip-bundle-set?variant=41021973037117"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 42.53,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-midsize-grip-bundle-set",
        "handle": "tacki-mac-perforated-tour-pro-wrap-midsize-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021971923005",
            "gid": "gid://shopify/ProductVariant/41021971923005",
            "sku": "SET-9x106P.600",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 42.53,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-midsize-grip-bundle-set?variant=41021971923005"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 60.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-105p-13pcs-golf-grip-kit",
        "handle": "tacki-mac-perforated-tour-pro-wrap-105p-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard 60 Round (most popular)",
              "Standard 58 Round"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32007849541693",
            "gid": "gid://shopify/ProductVariant/32007849541693",
            "sku": "KIT+13x105P.600",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 60 Round (most popular)"
            },
            "available": true,
            "price": 60.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-105p-13pcs-golf-grip-kit?variant=32007849541693"
          },
          {
            "id": "32007849574461",
            "gid": "gid://shopify/ProductVariant/32007849574461",
            "sku": "KIT+13x105P.580",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 58 Round"
            },
            "available": true,
            "price": 60.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-105p-13pcs-golf-grip-kit?variant=32007849574461"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 65.79,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-midsize-13pcs-golf-grip-kit",
        "handle": "tacki-mac-perforated-tour-pro-wrap-midsize-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007848067133",
            "gid": "gid://shopify/ProductVariant/32007848067133",
            "sku": "KIT+13x106P.600",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 65.79,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-midsize-13pcs-golf-grip-kit?variant=32007848067133"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 5.25,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-midsize",
        "handle": "tacki-mac-perforated-tour-pro-wrap-midsize",
        "shopify_variants": [
          {
            "id": "311504657",
            "gid": "gid://shopify/ProductVariant/311504657",
            "sku": "106P.600",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.25,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-midsize?variant=311504657"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 5.1,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-105p",
        "handle": "tacki-mac-perforated-tour-pro-wrap-105p",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard 60 Round (most popular)",
              "Standard 58 Round"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "468595549",
            "gid": "gid://shopify/ProductVariant/468595549",
            "sku": "105P.600",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 60 Round (most popular)"
            },
            "available": true,
            "price": 5.1,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-105p?variant=468595549"
          },
          {
            "id": "235119396",
            "gid": "gid://shopify/ProductVariant/235119396",
            "sku": "105P.580",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard 58 Round"
            },
            "available": true,
            "price": 5.1,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-105p?variant=235119396"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, grip bundle, iron/wood, mem25, new-bundle-set, prime-2025, rubber, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, tacki-mac, tacky, under-150, under-300, wrap, wrap-style-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "tacki-mac-perforated-tour-pro-wrap-grip-58-core",
    "brand": "Tacki-Mac",
    "model": "Perforated Tour Pro Wrap Grip - 58 Core",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 45.4
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 5.1,
    "price_max": 5.1,
    "single_price_min": 5.1,
    "single_price_max": 5.1,
    "normalized_price_per_grip": 5.1,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-grip-58-core",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/105p__64923_zoom_ad644c8d-5bea-4201-acc0-4eaca177d4df.jpg?v=1627135871",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 5.1,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-grip-58-core",
        "handle": "tacki-mac-perforated-tour-pro-wrap-grip-58-core",
        "shopify_variants": [
          {
            "id": "13184901677117",
            "gid": "gid://shopify/ProductVariant/13184901677117",
            "sku": "WEB ONLY: 58 CORE-105P.580",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.1,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-pro-wrap-grip-58-core?variant=13184901677117"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, 58 Core, All Products, golf-grips, iron/wood, rubber, single-golf-grips, single-grip, soft, standard, standard-size-golf-grips, tacki-mac, tacky, under-150, under-300, wrap, wrap-style-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "tacki-mac-perforated-tour-wrap",
    "brand": "Tacki-Mac",
    "model": "Perforated Tour Wrap",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.35,
    "price_max": 63.32,
    "single_price_min": 5.35,
    "single_price_max": 5.35,
    "normalized_price_per_grip": 4.82,
    "bundle_price_min": 43.34,
    "kit_price_min": 63.32,
    "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-wrap-jumbo",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/107p__32364_zoom_0fa665df-f875-4172-9259-e7a5e3de802a.jpg?v=1735455600",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 43.34,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-wrap-jumbo-grip-bundle-set",
        "handle": "tacki-mac-perforated-tour-wrap-jumbo-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021972381757",
            "gid": "gid://shopify/ProductVariant/41021972381757",
            "sku": "SET-9x107P - 600",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 43.34,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-wrap-jumbo-grip-bundle-set?variant=41021972381757"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 63.32,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-wrap-jumbo-13pcs-golf-grip-kit",
        "handle": "tacki-mac-perforated-tour-wrap-jumbo-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007848788029",
            "gid": "gid://shopify/ProductVariant/32007848788029",
            "sku": "KIT+13x107P - 600",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 63.32,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-wrap-jumbo-13pcs-golf-grip-kit?variant=32007848788029"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 5.35,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-wrap-jumbo",
        "handle": "tacki-mac-perforated-tour-wrap-jumbo",
        "shopify_variants": [
          {
            "id": "295581673",
            "gid": "gid://shopify/ProductVariant/295581673",
            "sku": "107P - 600",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.35,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-perforated-tour-wrap-jumbo?variant=295581673"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, grip bundle, iron/wood, jumbo/oversize, mem25, new-bundle-set, oversize, oversize-jumbo-golf-grips, prime-2025, rubber, single-golf-grips, single-grip, soft, tacki-mac, tacky, under-150, under-300, wrap, wrap-style-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "tacki-mac-pro-lite-865-bubble",
    "brand": "Tacki-Mac",
    "model": "Pro Lite 865 Bubble",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "specialty_bubble_core",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.25,
    "price_max": 68.26,
    "single_price_min": 5.25,
    "single_price_max": 5.25,
    "normalized_price_per_grip": 5.25,
    "bundle_price_min": null,
    "kit_price_min": 68.26,
    "url": "https://www.grips4less.com/products/tacki-mac-pro-lite-865-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/pro-lite-865_0a6bb819-eac4-4d3b-9cf9-8785431b8a30.jpg?v=1736026959",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 68.26,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-pro-lite-865-grip-13pcs-golf-grip-kit",
        "handle": "tacki-mac-pro-lite-865-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007847477309",
            "gid": "gid://shopify/ProductVariant/32007847477309",
            "sku": "KIT+13x865L",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 68.26,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-pro-lite-865-grip-13pcs-golf-grip-kit?variant=32007847477309"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 5.25,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/tacki-mac-pro-lite-865-grip",
        "handle": "tacki-mac-pro-lite-865-grip",
        "shopify_variants": [
          {
            "id": "39289174655037",
            "gid": "gid://shopify/ProductVariant/39289174655037",
            "sku": "865L",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.25,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-pro-lite-865-grip?variant=39289174655037"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, All Products, bf-nonassembled, bf-sale, blackfriday2020, bubble, bubble-golf-grips, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, iron/wood, jumbo/ove",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "tacki-mac-tour-pro-wrap",
    "brand": "Tacki-Mac",
    "model": "Tour Pro Wrap",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Junior"
    ],
    "manufacturer_size_labels": [
      "Junior"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Junior": 45.4
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 4.65,
    "price_max": 59.12,
    "single_price_min": 4.65,
    "single_price_max": 4.65,
    "normalized_price_per_grip": 4.19,
    "bundle_price_min": 37.67,
    "kit_price_min": 59.12,
    "url": "https://www.grips4less.com/products/tacki-mac-tour-pro-wrap-junior-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/103P-tourpro-junior_64be9dd9-14b2-45ea-8120-5fd09c25f6e2.jpg?v=1735455606",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Junior"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 37.67,
        "per_grip_g": 45.4,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/tacki-mac-tour-pro-wrap-junior-grip-grip-bundle-set",
        "handle": "tacki-mac-tour-pro-wrap-junior-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021971202109",
            "gid": "gid://shopify/ProductVariant/41021971202109",
            "sku": "SET-9x103P",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 37.67,
            "weight_g": 408.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-tour-pro-wrap-junior-grip-grip-bundle-set?variant=41021971202109"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 59.12,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-tour-pro-wrap-junior-grip-13pcs-golf-grip-kit",
        "handle": "tacki-mac-tour-pro-wrap-junior-grip-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007847706685",
            "gid": "gid://shopify/ProductVariant/32007847706685",
            "sku": "KIT+13x103P",
            "color": "Black",
            "size": "Junior",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 59.12,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-tour-pro-wrap-junior-grip-13pcs-golf-grip-kit?variant=32007847706685"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "single",
        "colors": [],
        "price": 4.65,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/tacki-mac-tour-pro-wrap-junior-grip",
        "handle": "tacki-mac-tour-pro-wrap-junior-grip",
        "shopify_variants": [
          {
            "id": "13184905183293",
            "gid": "gid://shopify/ProductVariant/13184905183293",
            "sku": "103P",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 4.65,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-tour-pro-wrap-junior-grip?variant=13184905183293"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, grip bundle, iron/wood, junior, junior-golf-grips, mem25, new-bundle-set, prime-2025, rubber, single-golf-grips, single-grip, soft, tacki-mac, tacky, under-150, under-300, wrap, wrap-style-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "tacki-mac-tour-select-mens-black",
    "brand": "Tacki-Mac",
    "model": "Tour Select Mens Black",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.1,
    "price_max": 63.07,
    "single_price_min": 5.1,
    "single_price_max": 5.1,
    "normalized_price_per_grip": 4.59,
    "bundle_price_min": 41.31,
    "kit_price_min": 63.07,
    "url": "https://www.grips4less.com/products/tacki-mac-tour-select-mens-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/tourselect_mens_575e009b-e2fa-4c18-8782-1603e5f34058.jpg?v=1735455598",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 41.31,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/tacki-mac-tour-select-mens-black-grip-bundle-set",
        "handle": "tacki-mac-tour-select-mens-black-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021972873277",
            "gid": "gid://shopify/ProductVariant/41021972873277",
            "sku": "SET-9xM51",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 41.31,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-tour-select-mens-black-grip-bundle-set?variant=41021972873277"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 63.07,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-tour-select-mens-black-13pcs-golf-grip-kit",
        "handle": "tacki-mac-tour-select-mens-black-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007849476157",
            "gid": "gid://shopify/ProductVariant/32007849476157",
            "sku": "KIT+13xM51",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 63.07,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-tour-select-mens-black-13pcs-golf-grip-kit?variant=32007849476157"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 5.1,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-tour-select-mens-black",
        "handle": "tacki-mac-tour-select-mens-black",
        "shopify_variants": [
          {
            "id": "243454808",
            "gid": "gid://shopify/ProductVariant/243454808",
            "sku": "M51",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.1,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-tour-select-mens-black?variant=243454808"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, firm, golf-grips, grip bundle, iron/wood, jumbo/oversize, mem25, new-bundle-set, oversize, oversize-jumbo-golf-grips, oversize/jumbo, prime-2025, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, tacki-mac, tour select, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "tacki-mac-unified-wrap-non-tapered",
    "brand": "Tacki-Mac",
    "model": "Unified Wrap Non-Tapered",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "thermoplastic rubber (TPR)",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.tackimac.com/golf-grips.html"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 5.35,
    "price_max": 77.15,
    "single_price_min": 5.35,
    "single_price_max": 5.35,
    "normalized_price_per_grip": 4.82,
    "bundle_price_min": 43.34,
    "kit_price_min": 77.15,
    "url": "https://www.grips4less.com/products/tacki-mac-unified-wrap-non-tapered-oversize",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/30-160__48392_zoom_02fd5f08-cba3-4385-a430-ab9c80f3109b.jpg?v=1735455596",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 43.34,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/tacki-mac-unified-wrap-non-tapered-oversize-grip-bundle-set",
        "handle": "tacki-mac-unified-wrap-non-tapered-oversize-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021973102653",
            "gid": "gid://shopify/ProductVariant/41021973102653",
            "sku": "SET-9x30-160",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 43.34,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-unified-wrap-non-tapered-oversize-grip-bundle-set?variant=41021973102653"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Black"
        ],
        "price": 77.15,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/tacki-mac-unified-wrap-non-tapered-oversize-13pcs-golf-grip-kit",
        "handle": "tacki-mac-unified-wrap-non-tapered-oversize-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007849607229",
            "gid": "gid://shopify/ProductVariant/32007849607229",
            "sku": "KIT+13x30-160",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 77.15,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-unified-wrap-non-tapered-oversize-13pcs-golf-grip-kit?variant=32007849607229"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 5.35,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tacki-mac-unified-wrap-non-tapered-oversize",
        "handle": "tacki-mac-unified-wrap-non-tapered-oversize",
        "shopify_variants": [
          {
            "id": "235117834",
            "gid": "gid://shopify/ProductVariant/235117834",
            "sku": "30-160",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 5.35,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tacki-mac-unified-wrap-non-tapered-oversize?variant=235117834"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, firm, golf-grips, grip bundle, iron/wood, jumbo/oversize, mem25, Most Popular Discount Golf Grips, new-bundle-set, non-tapered, non-tapered swing grips, non-tapered-and-less-tapered-swing-grips, oversize, oversize-jumbo-golf-grips, prime-2025, single-golf-grips, single-grip, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.tackimac.com/golf-grips.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "taylormade-crossline-bubble-680",
    "brand": "TaylorMade",
    "model": "Crossline Bubble (.680\")",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "specialty_bubble_core",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 117.66,
    "price_max": 117.66,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 9.05,
    "bundle_price_min": null,
    "kit_price_min": 117.66,
    "url": "https://www.grips4less.com/products/taylormade-crossline-bubble-13pcs-golf-grip-kit",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/TaylorMade_Crossline_Bubble_58f31c10-a935-48b9-88f3-de3c1e94972d.jpg?v=1736026938",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "13pc kit",
        "colors": [
          "Black/White"
        ],
        "price": 117.66,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/taylormade-crossline-bubble-13pcs-golf-grip-kit",
        "handle": "taylormade-crossline-bubble-13pcs-golf-grip-kit",
        "shopify_variants": [
          {
            "id": "32007850197053",
            "gid": "gid://shopify/ProductVariant/32007850197053",
            "sku": "KIT+13x100798",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 117.66,
            "weight_g": 934.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/taylormade-crossline-bubble-13pcs-golf-grip-kit?variant=32007850197053"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2021-nysale, 2023-sale, 2025-black-friday, 2025-winter-sale-bundles, All Products, bf-nonassembled, bf-sale, bubble-golf-grips, bundle, bundles-asbl-driver-only, firm, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, iron/wood, KIT-added07282020, labor-day-bundle-sale-2025, labor-d",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "taylormade-crossline-bubble-grip-680",
    "brand": "TaylorMade",
    "model": "Crossline Bubble Grip (.680\")",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "specialty_bubble_core",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 8.49,
    "price_max": 8.49,
    "single_price_min": 8.49,
    "single_price_max": 8.49,
    "normalized_price_per_grip": 8.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/taylormade-crossline-bubble",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/TaylorMade_Crossline_Bubble.jpg?v=1627084901",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 8.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/taylormade-crossline-bubble",
        "handle": "taylormade-crossline-bubble",
        "shopify_variants": [
          {
            "id": "39289174556733",
            "gid": "gid://shopify/ProductVariant/39289174556733",
            "sku": "100798",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/taylormade-crossline-bubble?variant=39289174556733"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, bubble-golf-grips, firm, golf-grips, iron/wood, ribbed, rubber, single-golf-grips, single-grip, taylormade, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "taylormade-lamkin-taylormade-universal-golf-grip-100796",
    "brand": "TaylorMade",
    "model": "Lamkin TaylorMade Universal Golf Grip (100796)",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 5.5,
    "price_max": 5.5,
    "single_price_min": 5.5,
    "single_price_max": 5.5,
    "normalized_price_per_grip": 5.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-taylormade-universal-golf-grip-100796",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/taylormade-100796-grip.jpg?v=1596733787",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 5.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-taylormade-universal-golf-grip-100796",
        "handle": "lamkin-taylormade-universal-golf-grip-100796",
        "shopify_variants": [
          {
            "id": "32024305729597",
            "gid": "gid://shopify/ProductVariant/32024305729597",
            "sku": "100796",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 5.5,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-taylormade-universal-golf-grip-100796?variant=32024305729597"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, Brand_Lamkin, Brand_TaylorMade, firm, golf-grips, infinite-opt-addkit, iron/wood, rubber, single-golf-grips, single-grip, Size_Standard, Style_Swing Grip, taylormade, TaylorMade Universal Grip, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "test-golf-pride-new-decade-multicompound",
    "brand": "Test",
    "model": "Golf Pride New Decade Multicompound",
    "type": "club",
    "spec_confidence": "derived",
    "material": "hybrid",
    "texture": "hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "hybrid",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "bad_data",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 8.15,
    "price_max": 8.15,
    "single_price_min": 8.15,
    "single_price_max": 8.15,
    "normalized_price_per_grip": 8.15,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/test-golf-pride-new-decade-multicompound",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/mcc-new-decade-7colors_26df8a62-04b8-4c4e-98d5-123df1bf95d0.jpg?v=1636061784",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 8.15,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/test-golf-pride-new-decade-multicompound",
        "handle": "test-golf-pride-new-decade-multicompound",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red",
              "Black",
              "Blue",
              "Orange",
              "White",
              "Yellow"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461752078397",
            "gid": "gid://shopify/ProductVariant/39461752078397",
            "sku": "Test--1",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 8.15,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/test-golf-pride-new-decade-multicompound?variant=39461752078397"
          },
          {
            "id": "39461752111165",
            "gid": "gid://shopify/ProductVariant/39461752111165",
            "sku": "Test--2",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 8.15,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/test-golf-pride-new-decade-multicompound?variant=39461752111165"
          },
          {
            "id": "39461752143933",
            "gid": "gid://shopify/ProductVariant/39461752143933",
            "sku": "Test--3",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 8.15,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/test-golf-pride-new-decade-multicompound?variant=39461752143933"
          },
          {
            "id": "39461752176701",
            "gid": "gid://shopify/ProductVariant/39461752176701",
            "sku": "Test--4",
            "color": "Orange",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange"
            },
            "available": true,
            "price": 7.84,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/test-golf-pride-new-decade-multicompound?variant=39461752176701"
          },
          {
            "id": "39461752209469",
            "gid": "gid://shopify/ProductVariant/39461752209469",
            "sku": "Test--5",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 8.15,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/test-golf-pride-new-decade-multicompound?variant=39461752209469"
          },
          {
            "id": "39461752242237",
            "gid": "gid://shopify/ProductVariant/39461752242237",
            "sku": "Test--6",
            "color": "Yellow",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow"
            },
            "available": true,
            "price": 8.15,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/test-golf-pride-new-decade-multicompound?variant=39461752242237"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, bct cord, cord, firm, hybrid, hybrid-golf-grips, iron/wood, mcc multicompound, new decade, rubber, single-golf-grips, Size_Standard, standard, standard-size-golf-grips, Style_Swing Grip, test, under-150, video=Hks8VPLYDtI",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Orange",
      "White",
      "Yellow"
    ]
  },
  {
    "id": "true-temper-icon",
    "brand": "True Temper",
    "model": "ICON",
    "type": "club",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard (60 Round)"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc bundle"
    ],
    "colors_available": [
      "Black",
      "Black/White Logo"
    ],
    "weight_g_by_size": {},
    "weight_source": "derived_from_bundle",
    "weight_confidence": "low",
    "price_min": 6.49,
    "price_max": 84.37,
    "single_price_min": 6.49,
    "single_price_max": 6.49,
    "normalized_price_per_grip": 6.49,
    "bundle_price_min": 84.37,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/true-temper-icon-grip-black_86a9754d-341e-44ab-8a4f-d693b0d623a6.jpg?v=1766010906",
    "fit_tags": [],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc bundle",
        "colors": [
          "Black"
        ],
        "price": 84.37,
        "per_grip_g": 3.8,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip-bundle-13pcs",
        "handle": "true-temper-icon-standard-grip-bundle-13pcs",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard (60 Round)",
              "Standard (58 Round)"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61398910435698",
            "gid": "gid://shopify/ProductVariant/61398910435698",
            "sku": "SET-13xGRTT-ICON-0006",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard (60 Round)"
            },
            "available": false,
            "price": 84.37,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip-bundle-13pcs?variant=61398910435698"
          },
          {
            "id": "61398910468466",
            "gid": "gid://shopify/ProductVariant/61398910468466",
            "sku": "SET-13xGRTT-ICON-0005",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard (58 Round)"
            },
            "available": false,
            "price": 84.37,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip-bundle-13pcs?variant=61398910468466"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black/White Logo"
        ],
        "price": 6.49,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip",
        "handle": "true-temper-icon-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White Logo",
              "Black/Gold Logo",
              "Black/USA Logo",
              "Grey/White Logo"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard (60 Round)",
              "Standard (58 Round)",
              "Midsize (60 Round)",
              "Oversize (60 Round)",
              "Undersize (60 Round)",
              "Standard Ribbed (58 Round)"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51739845001586",
            "gid": "gid://shopify/ProductVariant/51739845001586",
            "sku": "GRTT-ICON-0006",
            "color": "Black/White Logo",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/White Logo",
              "Grip Size": "Standard (60 Round)"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip?variant=51739845001586"
          },
          {
            "id": "51739843363186",
            "gid": "gid://shopify/ProductVariant/51739843363186",
            "sku": "GRTT-ICON-0005",
            "color": "Black/White Logo",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/White Logo",
              "Grip Size": "Standard (58 Round)"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip?variant=51739843363186"
          },
          {
            "id": "61567257444722",
            "gid": "gid://shopify/ProductVariant/61567257444722",
            "sku": "TTICON-MD60R-WHT",
            "color": "Black/White Logo",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black/White Logo",
              "Grip Size": "Midsize (60 Round)"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip?variant=61567257444722"
          },
          {
            "id": "61567257477490",
            "gid": "gid://shopify/ProductVariant/61567257477490",
            "sku": "TTICON-OS60R-WHT",
            "color": "Black/White Logo",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black/White Logo",
              "Grip Size": "Oversize (60 Round)"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip?variant=61567257477490"
          },
          {
            "id": "61567257510258",
            "gid": "gid://shopify/ProductVariant/61567257510258",
            "sku": "TTICON-US60R-WHT",
            "color": "Black/White Logo",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black/White Logo",
              "Grip Size": "Undersize (60 Round)"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip?variant=61567257510258"
          },
          {
            "id": "61572766007666",
            "gid": "gid://shopify/ProductVariant/61572766007666",
            "sku": "TTICON-RIB-WHT",
            "color": "Black/White Logo",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/White Logo",
              "Grip Size": "Standard Ribbed (58 Round)"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip?variant=61572766007666"
          },
          {
            "id": "61567257543026",
            "gid": "gid://shopify/ProductVariant/61567257543026",
            "sku": "TTICON-LT60R-WHT",
            "color": "Black/Gold Logo",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/Gold Logo",
              "Grip Size": "Standard (60 Round)"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip?variant=61567257543026"
          },
          {
            "id": "61567257575794",
            "gid": "gid://shopify/ProductVariant/61567257575794",
            "sku": "TTICON-STD60R-USA",
            "color": "Black/USA Logo",
            "size": "Standard",
            "selected_options": {
              "Color": "Black/USA Logo",
              "Grip Size": "Standard (60 Round)"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip?variant=61567257575794"
          },
          {
            "id": "61567257608562",
            "gid": "gid://shopify/ProductVariant/61567257608562",
            "sku": "TTICON-STD60R-GREY",
            "color": "Grey/White Logo",
            "size": "Standard",
            "selected_options": {
              "Color": "Grey/White Logo",
              "Grip Size": "Standard (60 Round)"
            },
            "available": false,
            "price": 6.49,
            "weight_g": 49.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/true-temper-icon-standard-grip?variant=61567257608562"
          }
        ],
        "shopify_variant_count": 9,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "13pc bundle, 2025-black-friday, 360, 360-golf-grips, All Products, best-sellers, golf-grips, grip bundle, icon, Icon grip, iron/wood, medium firm, New for 2018, new-add-12172025, rubber, single-golf-grips, single-grip, standard, standard-size-golf-grips, True Temper Icon, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-d2r",
    "brand": "Winn",
    "model": "D2R",
    "type": "club",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5,
      "Standard": 63.5,
      "Undersize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.39,
    "price_max": 6.69,
    "single_price_min": 6.39,
    "single_price_max": 6.69,
    "normalized_price_per_grip": 6.39,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-d2r-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-dr2-midsize_faadd117-10e7-4d00-8eac-362c8ace619f.jpg?v=1645659094",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-d2r-midsize-grip",
        "handle": "winn-d2r-midsize-grip",
        "shopify_variants": [
          {
            "id": "39776639156285",
            "gid": "gid://shopify/ProductVariant/39776639156285",
            "sku": "6DR-BK",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 6.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-d2r-midsize-grip?variant=39776639156285"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.39,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-d2r-standard-grip",
        "handle": "winn-d2r-standard-grip",
        "shopify_variants": [
          {
            "id": "39776638140477",
            "gid": "gid://shopify/ProductVariant/39776638140477",
            "sku": "5DR-BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 6.39,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-d2r-standard-grip?variant=39776638140477"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 6.39,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-d2r-undersize-grip",
        "handle": "winn-d2r-undersize-grip",
        "shopify_variants": [
          {
            "id": "39776637452349",
            "gid": "gid://shopify/ProductVariant/39776637452349",
            "sku": "3DR-BK",
            "color": "Black",
            "size": "Undersize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 6.39,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-d2r-undersize-grip?variant=39776637452349"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, blackfriday2020, d2r, firm, golf-grips, iron/wood, midsize, midsize-golf-grips, single-golf-grips, tacky, under-150, under-300, winn, Winn d2r",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac",
    "brand": "Winn",
    "model": "Dri-Tac",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "style_forward",
    "non_black_color_count": 6,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Junior",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Junior",
      "Midsize",
      "Oversize / Jumbo",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Blue",
      "Black / Red",
      "Black/Blue",
      "Black/Red",
      "Dark Gray",
      "Standard / Dark Gray",
      "Tac Grip",
      "Tac Junior Grip",
      "Tac Midsize Grip",
      "Tac Oversize Grip"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5,
      "Jumbo/Oversize": 90.7,
      "Junior": 63.5,
      "Unspecified": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 7.69,
    "price_max": 176.81,
    "single_price_min": 7.69,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 7.69,
    "bundle_price_min": 69.21,
    "kit_price_min": 113.45,
    "url": "https://www.grips4less.com/products/winn-dri-tac-midsize-grip-6dt",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/5DT-BRD-1700_62cbee22-a0b4-4499-8018-8a1fd8b69d53.jpg?v=1735455586",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 14,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Red"
        ],
        "price": 74.44,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-black-red-grip-5dt-brd-grip-bundle-set",
        "handle": "winn-dritac-avs-winndry-standard-black-red-grip-5dt-brd-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976117309",
            "gid": "gid://shopify/ProductVariant/41021976117309",
            "sku": "SET-9x5DT-BRD",
            "color": "Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 74.44,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-black-red-grip-5dt-brd-grip-bundle-set?variant=41021976117309"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-midsize-black-blue-grip-1-16-6dt-bbl-grip-bundle-set",
        "handle": "winn-dritac-avs-winndry-midsize-black-blue-grip-1-16-6dt-bbl-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976051773",
            "gid": "gid://shopify/ProductVariant/41021976051773",
            "sku": "SET-9x6DT-BBL",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 80.92,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-midsize-black-blue-grip-1-16-6dt-bbl-grip-bundle-set?variant=41021976051773"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Dark Gray"
        ],
        "price": 87.4,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-oversize-dark-gray-grip-1-8-7dt-dg-grip-bundle-set",
        "handle": "winn-dritac-avs-winndry-oversize-dark-gray-grip-1-8-7dt-dg-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021975986237",
            "gid": "gid://shopify/ProductVariant/41021975986237",
            "sku": "SET-9x7DT-DG",
            "color": "Dark Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Dark Gray",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 87.4,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-oversize-dark-gray-grip-1-8-7dt-dg-grip-bundle-set?variant=41021975986237"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 69.21,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dri-tac-junior-blue-grip-jdt-bl-grip-bundle-set",
        "handle": "winn-dri-tac-junior-blue-grip-jdt-bl-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021972742205",
            "gid": "gid://shopify/ProductVariant/41021972742205",
            "sku": "SET-9xJDT-BL",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 69.21,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-junior-blue-grip-jdt-bl-grip-bundle-set?variant=41021972742205"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 113.45,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-junior-grips",
        "handle": "grip-kit-13x-winn-dri-tac-junior-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911359086653",
            "gid": "gid://shopify/ProductVariant/39911359086653",
            "sku": "KIT+13xJDT-BL",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 113.45,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-junior-grips?variant=39911359086653"
          },
          {
            "id": "39911359119421",
            "gid": "gid://shopify/ProductVariant/39911359119421",
            "sku": "KIT(8oz)+13xJDT-BL",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 118.75,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-junior-grips?variant=39911359119421"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Dark Gray"
        ],
        "price": 149.9,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-midsize-grips",
        "handle": "grip-kit-13x-winn-dri-tac-midsize-grips",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray",
              "Navy Blue"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911358726205",
            "gid": "gid://shopify/ProductVariant/39911358726205",
            "sku": "KIT+13x6DT-DG",
            "color": "Dark Gray",
            "size": "Midsize",
            "selected_options": {
              "Color": "Dark Gray",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 149.9,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-midsize-grips?variant=39911358726205"
          },
          {
            "id": "39911358758973",
            "gid": "gid://shopify/ProductVariant/39911358758973",
            "sku": "KIT+13x6DT-NB",
            "color": "Navy Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Navy Blue",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 149.9,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-midsize-grips?variant=39911358758973"
          },
          {
            "id": "39911358824509",
            "gid": "gid://shopify/ProductVariant/39911358824509",
            "sku": "KIT(8oz)+13x6DT-DG",
            "color": "Dark Gray",
            "size": "Midsize",
            "selected_options": {
              "Color": "Dark Gray",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 156,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-midsize-grips?variant=39911358824509"
          },
          {
            "id": "39911358857277",
            "gid": "gid://shopify/ProductVariant/39911358857277",
            "sku": "KIT(8oz)+13x6DT-NB",
            "color": "Navy Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Navy Blue",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 156,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-midsize-grips?variant=39911358857277"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Dark Gray"
        ],
        "price": 176.81,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-oversize-grips",
        "handle": "grip-kit-13x-winn-dri-tac-oversize-grips",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray",
              "Navy"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911358234685",
            "gid": "gid://shopify/ProductVariant/39911358234685",
            "sku": "KIT+13x7DT-DG",
            "color": "Dark Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Dark Gray",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 176.81,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-oversize-grips?variant=39911358234685"
          },
          {
            "id": "39911358300221",
            "gid": "gid://shopify/ProductVariant/39911358300221",
            "sku": "KIT+13x7DT-NB",
            "color": "Navy",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Navy",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 176.81,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-oversize-grips?variant=39911358300221"
          },
          {
            "id": "39911358332989",
            "gid": "gid://shopify/ProductVariant/39911358332989",
            "sku": "KIT(8oz)+13x7DT-DG",
            "color": "Dark Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Dark Gray",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 182.91,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-oversize-grips?variant=39911358332989"
          },
          {
            "id": "39911358398525",
            "gid": "gid://shopify/ProductVariant/39911358398525",
            "sku": "KIT(8oz)+13x7DT-NB",
            "color": "Navy",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Navy",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 182.91,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-oversize-grips?variant=39911358398525"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Dark Gray"
        ],
        "price": 137.94,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-standard-grip-kit",
        "handle": "winn-dri-tac-standard-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray",
              "Navy Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911357907005",
            "gid": "gid://shopify/ProductVariant/39911357907005",
            "sku": "KIT+13x5DT-DG",
            "color": "Dark Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Dark Gray"
            },
            "available": true,
            "price": 137.94,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-standard-grip-kit?variant=39911357907005"
          },
          {
            "id": "39911357939773",
            "gid": "gid://shopify/ProductVariant/39911357939773",
            "sku": "KIT+13x5DT-NB",
            "color": "Navy Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Navy Blue"
            },
            "available": false,
            "price": 137.94,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-standard-grip-kit?variant=39911357939773"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black / Blue",
          "Tac Midsize Grip"
        ],
        "price": 12.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-midsize-grip-6dt",
        "handle": "winn-dri-tac-midsize-grip-6dt",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Blue",
              "Navy Blue",
              "Dark Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "8380961161277",
            "gid": "gid://shopify/ProductVariant/8380961161277",
            "sku": "SET-1x6DT-BBL",
            "color": "Black / Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Blue"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-midsize-grip-6dt?variant=8380961161277"
          },
          {
            "id": "403413405",
            "gid": "gid://shopify/ProductVariant/403413405",
            "sku": "6DT-NB",
            "color": "Navy Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Navy Blue"
            },
            "available": false,
            "price": 10.19,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-midsize-grip-6dt?variant=403413405"
          },
          {
            "id": "397708793",
            "gid": "gid://shopify/ProductVariant/397708793",
            "sku": "6DT-DG",
            "color": "Dark Gray",
            "size": "Midsize",
            "selected_options": {
              "Color": "Dark Gray"
            },
            "available": true,
            "price": 10.19,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-midsize-grip-6dt?variant=397708793"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Junior"
        ],
        "format": "single",
        "colors": [
          "Tac Junior Grip"
        ],
        "price": 7.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dri-tac-junior-blue-grip-jdt-bl",
        "handle": "winn-dri-tac-junior-blue-grip-jdt-bl",
        "shopify_variants": [
          {
            "id": "40683425792061",
            "gid": "gid://shopify/ProductVariant/40683425792061",
            "sku": "JDT-BL",
            "color": "Tac Junior Grip",
            "size": "Junior",
            "selected_options": {
              "Grip Size": "Junior"
            },
            "available": true,
            "price": 7.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-junior-blue-grip-jdt-bl?variant=40683425792061"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Junior"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Dark Gray",
          "Tac Oversize Grip"
        ],
        "price": 12.29,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-oversize-dark-gray-grip-1-8-7dt-dg",
        "handle": "winn-dritac-avs-winndry-oversize-dark-gray-grip-1-8-7dt-dg",
        "shopify_variants": [
          {
            "id": "397708805",
            "gid": "gid://shopify/ProductVariant/397708805",
            "sku": "7DT-DG",
            "color": "Dark Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Dark Gray",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 12.29,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-oversize-dark-gray-grip-1-8-7dt-dg?variant=397708805"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black/Blue"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-midsize-black-blue-grip-1-16-6dt-bbl",
        "handle": "winn-dritac-avs-winndry-midsize-black-blue-grip-1-16-6dt-bbl",
        "shopify_variants": [
          {
            "id": "40683427233853",
            "gid": "gid://shopify/ProductVariant/40683427233853",
            "sku": "6DT-BBL",
            "color": "Black/Blue",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-midsize-black-blue-grip-1-16-6dt-bbl?variant=40683427233853"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black / Red",
          "Black/Red"
        ],
        "price": 11.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-black-red-grip-5dt-brd",
        "handle": "winn-dritac-avs-winndry-standard-black-red-grip-5dt-brd",
        "shopify_variants": [
          {
            "id": "397708837",
            "gid": "gid://shopify/ProductVariant/397708837",
            "sku": "5DT-BRD",
            "color": "Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-black-red-grip-5dt-brd?variant=397708837"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Standard / Dark Gray",
          "Tac Grip"
        ],
        "price": 9.59,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-dark-gray-grip",
        "handle": "winn-dritac-avs-winndry-standard-dark-gray-grip",
        "shopify_options": [
          {
            "name": "Size and Color",
            "values": [
              "Standard / Dark Gray",
              "Standard / Navy Blue",
              "Standard / Black/Red",
              "Midsize / Black/Blue",
              "Midsize / Navy Blue",
              "Midsize / Dark Gray",
              "Oversize / Dark Gray",
              "Oversize / Navy Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "397708873",
            "gid": "gid://shopify/ProductVariant/397708873",
            "sku": "5DT-DG",
            "color": "Dark Gray",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Dark Gray"
            },
            "available": true,
            "price": 9.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-dark-gray-grip?variant=397708873"
          },
          {
            "id": "430180853",
            "gid": "gid://shopify/ProductVariant/430180853",
            "sku": "5DT-NB",
            "color": "Navy Blue",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Navy Blue"
            },
            "available": false,
            "price": 9.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-dark-gray-grip?variant=430180853"
          },
          {
            "id": "12641424605245",
            "gid": "gid://shopify/ProductVariant/12641424605245",
            "sku": "SET-1x5DT-BRD",
            "color": "Black / Red",
            "size": "Standard",
            "selected_options": {
              "Size and Color": "Standard / Black/Red"
            },
            "available": true,
            "price": 11.49,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-dark-gray-grip?variant=12641424605245"
          },
          {
            "id": "12641401897021",
            "gid": "gid://shopify/ProductVariant/12641401897021",
            "sku": "SET-1x6DT-BBL-1",
            "color": "Black / Blue",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Black/Blue"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-dark-gray-grip?variant=12641401897021"
          },
          {
            "id": "12641403666493",
            "gid": "gid://shopify/ProductVariant/12641403666493",
            "sku": "SET-1x6DT-NB",
            "color": "Navy Blue",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Navy Blue"
            },
            "available": false,
            "price": 10.19,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-dark-gray-grip?variant=12641403666493"
          },
          {
            "id": "12641404518461",
            "gid": "gid://shopify/ProductVariant/12641404518461",
            "sku": "SET-1x6DT-DG",
            "color": "Dark Gray",
            "size": "Midsize",
            "selected_options": {
              "Size and Color": "Midsize / Dark Gray"
            },
            "available": true,
            "price": 10.19,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-dark-gray-grip?variant=12641404518461"
          },
          {
            "id": "12641443774525",
            "gid": "gid://shopify/ProductVariant/12641443774525",
            "sku": "SET-1x7DT-DG",
            "color": "Dark Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size and Color": "Oversize / Dark Gray"
            },
            "available": true,
            "price": 12.29,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-dark-gray-grip?variant=12641443774525"
          },
          {
            "id": "12641445150781",
            "gid": "gid://shopify/ProductVariant/12641445150781",
            "sku": "SET-1x7DT-NB",
            "color": "Navy Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size and Color": "Oversize / Navy Blue"
            },
            "available": true,
            "price": 12.29,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dritac-avs-winndry-standard-dark-gray-grip?variant=12641445150781"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, all weather, blackfriday2020, dri-tac, fathers-day-2021-sale, golf-grips, grip bundle, iron/wood, mem25, new-bundle-set, single-golf-grips, soft, standard, standard-size-golf-grips, tacky, under-150, under-300, video=LK-k-SpmuVE, winn, Winn Dri-Tac, winn dritac",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Dark Gray",
      "Black / Red",
      "Navy Blue",
      "Tac Junior Grip"
    ]
  },
  {
    "id": "winn-dri-tac",
    "brand": "Winn",
    "model": "Dri-Tac /",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [
      "Dark Gray / Pink",
      "Gray"
    ],
    "weight_g_by_size": {
      "Undersize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.59,
    "price_max": 74.44,
    "single_price_min": 9.59,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 7.37,
    "bundle_price_min": 66.34,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-dri-tac-ladies-grip-gray",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/3DT-GPK-1700_fac0b77e-2445-457b-a027-cee31c760423.jpg?v=1735455599",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 74.44,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lady-dark-gray-pink-3dt-gpk-grip-bundle-set",
        "handle": "winn-dri-tac-lady-dark-gray-pink-3dt-gpk-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021972807741",
            "gid": "gid://shopify/ProductVariant/41021972807741",
            "sku": "SET-9x3DT-GPK",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 74.44,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lady-dark-gray-pink-3dt-gpk-grip-bundle-set?variant=41021972807741"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Gray"
        ],
        "price": 66.34,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/winn-dri-tac-ladies-grip-gray-grip-bundle-set",
        "handle": "winn-dri-tac-ladies-grip-gray-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021971333181",
            "gid": "gid://shopify/ProductVariant/41021971333181",
            "sku": "SET-9x3DT-GY",
            "color": "Gray",
            "size": "Undersize",
            "selected_options": {
              "Color": "Gray",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 66.34,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-ladies-grip-gray-grip-bundle-set?variant=41021971333181"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Gray"
        ],
        "price": 9.59,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-ladies-grip-gray",
        "handle": "winn-dri-tac-ladies-grip-gray",
        "shopify_variants": [
          {
            "id": "397708733",
            "gid": "gid://shopify/ProductVariant/397708733",
            "sku": "3DT-GY",
            "color": "Gray",
            "size": "Undersize",
            "selected_options": {
              "Color": "Gray",
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 9.59,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-ladies-grip-gray?variant=397708733"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Dark Gray / Pink"
        ],
        "price": 11.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lady-dark-gray-pink-3dt-gpk",
        "handle": "winn-dri-tac-lady-dark-gray-pink-3dt-gpk",
        "shopify_variants": [
          {
            "id": "40683426775101",
            "gid": "gid://shopify/ProductVariant/40683426775101",
            "sku": "3DT-GPK",
            "color": "Dark Gray / Pink",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lady-dark-gray-pink-3dt-gpk?variant=40683426775101"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, all weather, blackfriday2020, dri-tac, fathers-day-2021-sale, gifts-for-her, golf-grips, grip bundle, iron/wood, ladies, new-bundle-set, single-golf-grips, soft, tacky, under-150, under-300, undersize, undersize-golf-grips, video=Ylt1xt-8sn8, winn, Winn Dri-Tac, winn dritac, womens",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Gray"
    ]
  },
  {
    "id": "winn-dri-tac-dark-grey-pink",
    "brand": "Winn",
    "model": "Dri-Tac / Dark Grey/Pink",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Undersize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 152.89,
    "price_max": 152.89,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 11.76,
    "bundle_price_min": null,
    "kit_price_min": 152.89,
    "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-ladies-dark-gray-pink-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-grip-kits-dritac-jr-pink.jpg?v=1740079860",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 152.89,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-ladies-dark-gray-pink-grips",
        "handle": "grip-kit-13x-winn-dri-tac-ladies-dark-gray-pink-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911359381565",
            "gid": "gid://shopify/ProductVariant/39911359381565",
            "sku": "KIT+13x3DT-GPK",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 152.89,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-ladies-dark-gray-pink-grips?variant=39911359381565"
          },
          {
            "id": "39911359414333",
            "gid": "gid://shopify/ProductVariant/39911359414333",
            "sku": "KIT(8oz)+13x3DT-GPK",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 158.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-ladies-dark-gray-pink-grips?variant=39911359414333"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, dri-tac, free-rog-momentum-glove, gifts-for-her, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripkit-shaftbundle-sale, iron/wood, ladies, overstock-oct-2023, soft,",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-grey",
    "brand": "Winn",
    "model": "Dri-Tac / Grey",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Undersize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 137.94,
    "price_max": 137.94,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 10.61,
    "bundle_price_min": null,
    "kit_price_min": 137.94,
    "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-ladies-grey-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-grip-kits-dritac-jr-grey.jpg?v=1740079862",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 137.94,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-ladies-grey-grips",
        "handle": "grip-kit-13x-winn-dri-tac-ladies-grey-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911359316029",
            "gid": "gid://shopify/ProductVariant/39911359316029",
            "sku": "KIT+13x3DT-GY",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 137.94,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-ladies-grey-grips?variant=39911359316029"
          },
          {
            "id": "39911359348797",
            "gid": "gid://shopify/ProductVariant/39911359348797",
            "sku": "KIT(8oz)+13x3DT-GY",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 144.04,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-ladies-grey-grips?variant=39911359348797"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, dri-tac, free-rog-momentum-glove, gifts-for-her, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripkit-shaftbundle-sale, iron/wood, ladies, overstock-oct-2024, soft,",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-2-0",
    "brand": "Winn",
    "model": "Dri-Tac 2.0",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard",
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard",
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5,
      "Jumbo/Oversize": 63.5,
      "Undersize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 182.79,
    "single_price_min": 9.99,
    "single_price_max": 12.69,
    "normalized_price_per_grip": 7.82,
    "bundle_price_min": 70.39,
    "kit_price_min": 145.42,
    "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/52DT-JBK-1700.jpg?v=1735455696",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 10,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 70.39,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-standard-grip-grip-bundle-set",
        "handle": "winn-dri-tac-2-0-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021957701693",
            "gid": "gid://shopify/ProductVariant/41021957701693",
            "sku": "SET-9x52DT-JBK",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 70.39,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-standard-grip-grip-bundle-set?variant=41021957701693"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 74.44,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-midsize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-2-0-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021957603389",
            "gid": "gid://shopify/ProductVariant/41021957603389",
            "sku": "SET-9x62DT-JBK",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 74.44,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-midsize-grip-grip-bundle-set?variant=41021957603389"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 90.64,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-oversize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-2-0-oversize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021957537853",
            "gid": "gid://shopify/ProductVariant/41021957537853",
            "sku": "SET-9x72DT-JBK",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 90.64,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-oversize-grip-grip-bundle-set?variant=41021957537853"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 145.42,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-undersize-grip-13pcs-w-gripkit",
        "handle": "winn-dri-tac-2-0-undersize-grip-13pcs-w-gripkit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360954429",
            "gid": "gid://shopify/ProductVariant/39911360954429",
            "sku": "KIT+13x32DT-JBK",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 145.42,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-undersize-grip-13pcs-w-gripkit?variant=39911360954429"
          },
          {
            "id": "39911360987197",
            "gid": "gid://shopify/ProductVariant/39911360987197",
            "sku": "KIT(8oz)+13x32DT-JBK",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 151.51,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-undersize-grip-13pcs-w-gripkit?variant=39911360987197"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 182.79,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-oversize-grip-13pcs-w-gripkit",
        "handle": "winn-dri-tac-2-0-oversize-grip-13pcs-w-gripkit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360856125",
            "gid": "gid://shopify/ProductVariant/39911360856125",
            "sku": "KIT+13x72DT-JBK",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 182.79,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-oversize-grip-13pcs-w-gripkit?variant=39911360856125"
          },
          {
            "id": "39911360888893",
            "gid": "gid://shopify/ProductVariant/39911360888893",
            "sku": "KIT(8oz)+13x72DT-JBK",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 188.89,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-oversize-grip-13pcs-w-gripkit?variant=39911360888893"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 152.89,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-midsize-grip-13pcs-w-gripkit",
        "handle": "winn-dri-tac-2-0-midsize-grip-13pcs-w-gripkit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "33034209361981",
            "gid": "gid://shopify/ProductVariant/33034209361981",
            "sku": "KIT+13x62DT-JBK",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 152.89,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-midsize-grip-13pcs-w-gripkit?variant=33034209361981"
          },
          {
            "id": "39911083933757",
            "gid": "gid://shopify/ProductVariant/39911083933757",
            "sku": "KIT(8oz)+13x62DT-JBK",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 158.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-midsize-grip-13pcs-w-gripkit?variant=39911083933757"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 145.42,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-standard-grip-13pcs-w-gripkit",
        "handle": "winn-dri-tac-2-0-standard-grip-13pcs-w-gripkit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360790589",
            "gid": "gid://shopify/ProductVariant/39911360790589",
            "sku": "KIT+13x52DT-JBK",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 145.42,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-standard-grip-13pcs-w-gripkit?variant=39911360790589"
          },
          {
            "id": "39911360823357",
            "gid": "gid://shopify/ProductVariant/39911360823357",
            "sku": "KIT(8oz)+13x52DT-JBK",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 151.51,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-standard-grip-13pcs-w-gripkit?variant=39911360823357"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 12.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-oversize-grip",
        "handle": "winn-dri-tac-2-0-oversize-grip",
        "shopify_variants": [
          {
            "id": "33034190094397",
            "gid": "gid://shopify/ProductVariant/33034190094397",
            "sku": "72DT-JBK",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 12.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-oversize-grip?variant=33034190094397"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-midsize-grip",
        "handle": "winn-dri-tac-2-0-midsize-grip",
        "shopify_variants": [
          {
            "id": "33034182230077",
            "gid": "gid://shopify/ProductVariant/33034182230077",
            "sku": "62DT-JBK",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 10.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-midsize-grip?variant=33034182230077"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-standard-grip",
        "handle": "winn-dri-tac-2-0-standard-grip",
        "shopify_variants": [
          {
            "id": "33034174005309",
            "gid": "gid://shopify/ProductVariant/33034174005309",
            "sku": "52DT-JBK",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-standard-grip?variant=33034174005309"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, all weather, asbl-grip-option, blackfriday2020, dri-tac, dri-tac 2.0, dri-tac 2.0 standard, dritac, dritac 2.0, dritac 20, fathers-day-2021-sale, golf-grips, grip bundle, iron/wood, new-bundle-set, prime-2025, single-golf-grips, soft, standard, standard-size-golf-grips, tacky, under-15",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-2-0",
    "brand": "Winn",
    "model": "Dri-Tac 2.0 /",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Undersize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 70.39,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 7.82,
    "bundle_price_min": 70.39,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/32DT-JBK-1700.jpg?v=1735455698",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 70.39,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-undersize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-2-0-undersize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021957472317",
            "gid": "gid://shopify/ProductVariant/41021957472317",
            "sku": "SET-9x32DT-JBK",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 70.39,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-undersize-grip-grip-bundle-set?variant=41021957472317"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-undersize-grip",
        "handle": "winn-dri-tac-2-0-undersize-grip",
        "shopify_variants": [
          {
            "id": "33034191929405",
            "gid": "gid://shopify/ProductVariant/33034191929405",
            "sku": "32DT-JBK",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-2-0-undersize-grip?variant=33034191929405"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, all weather, blackfriday2020, dri-tac, dri-tac 2.0, dri-tac 2.0 standard, dritac, dritac 2.0, dritac 20, fathers-day-2021-sale, golf-grips, grip bundle, iron/wood, new-bundle-set, prime-2025, single-golf-grips, soft, standard, standard-size-golf-grips, tacky, under-150, under-300, winn",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-black-blue",
    "brand": "Winn",
    "model": "Dri-Tac Black/Blue",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Midsize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 164.85,
    "price_max": 164.85,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 12.68,
    "bundle_price_min": null,
    "kit_price_min": 164.85,
    "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-black-blue-midsize-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-grip-kits-dritac-mid-blkblue.jpg?v=1740079886",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 164.85,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-black-blue-midsize-grips",
        "handle": "grip-kit-13x-winn-dri-tac-black-blue-midsize-grips",
        "shopify_options": [],
        "shopify_variants": [
          {
            "id": "39911358169149",
            "gid": "gid://shopify/ProductVariant/39911358169149",
            "sku": "KIT+13x6DT-BBL",
            "color": "",
            "size": "Midsize",
            "selected_options": {},
            "available": false,
            "price": 164.85,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-black-blue-midsize-grips?variant=39911358169149"
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, dri-tac, dritac midsize, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripkit-shaftbundle-sale, iron/wood, midsize, midsize-golf-grips, sof",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-black-red",
    "brand": "Winn",
    "model": "Dri-Tac Black/Red",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 152.89,
    "price_max": 152.89,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 11.76,
    "bundle_price_min": null,
    "kit_price_min": 152.89,
    "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-black-red-standard-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-grip-kits-dritac-std-blkred.jpg?v=1740079888",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 152.89,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-black-red-standard-grips",
        "handle": "grip-kit-13x-winn-dri-tac-black-red-standard-grips",
        "shopify_options": [],
        "shopify_variants": [
          {
            "id": "39911358103613",
            "gid": "gid://shopify/ProductVariant/39911358103613",
            "sku": "KIT+13x5DT-BRD",
            "color": "",
            "size": "Standard",
            "selected_options": {},
            "available": true,
            "price": 152.89,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-dri-tac-black-red-standard-grips?variant=39911358103613"
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, All Products, bf-nonassembled, bf-sale, blackfriday2020, bundle, dri-tac, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripkit-shaftbundle-sale, iron/wood, overstock-oct-2024, soft, standard, standard-siz",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-lite",
    "brand": "Winn",
    "model": "Dri-Tac LITE",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Jumbo/Oversize": 90.7,
      "Midsize": 90.7,
      "Standard": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 11.09,
    "price_max": 182.79,
    "single_price_min": 11.09,
    "single_price_max": 13.39,
    "normalized_price_per_grip": 8.27,
    "bundle_price_min": 74.44,
    "kit_price_min": 152.89,
    "url": "https://www.grips4less.com/products/winn-dri-tac-lite-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-dritac-lite-ov_fba454d8-a164-4786-ae73-6b2e7b59ae24.jpg?v=1735455643",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 9,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 90.64,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lite-oversize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-lite-oversize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965533245",
            "gid": "gid://shopify/ProductVariant/41021965533245",
            "sku": "SET-9x7DTL-DG",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 90.64,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-oversize-grip-grip-bundle-set?variant=41021965533245"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 78.49,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lite-midsize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-lite-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965500477",
            "gid": "gid://shopify/ProductVariant/41021965500477",
            "sku": "SET-9x6DTL-DG",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 78.49,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-midsize-grip-grip-bundle-set?variant=41021965500477"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 74.44,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lite-standard-grip-grip-bundle-set",
        "handle": "winn-dri-tac-lite-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021965467709",
            "gid": "gid://shopify/ProductVariant/41021965467709",
            "sku": "SET-9x5DTL-DG",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 74.44,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-standard-grip-grip-bundle-set?variant=41021965467709"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 182.79,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lite-oversize-grip-13pcs-golf-grip-kit",
        "handle": "winn-dri-tac-lite-oversize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360462909",
            "gid": "gid://shopify/ProductVariant/39911360462909",
            "sku": "KIT+13x7DTL-DG",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 182.79,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-oversize-grip-13pcs-golf-grip-kit?variant=39911360462909"
          },
          {
            "id": "39911360495677",
            "gid": "gid://shopify/ProductVariant/39911360495677",
            "sku": "KIT(8oz)+13x7DTL-DG",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 188.89,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-oversize-grip-13pcs-golf-grip-kit?variant=39911360495677"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 160.37,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lite-midsize-grip-13pcs-golf-grip-kit",
        "handle": "winn-dri-tac-lite-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360397373",
            "gid": "gid://shopify/ProductVariant/39911360397373",
            "sku": "KIT+13x6DTL-DG",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 160.37,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-midsize-grip-13pcs-golf-grip-kit?variant=39911360397373"
          },
          {
            "id": "39911360430141",
            "gid": "gid://shopify/ProductVariant/39911360430141",
            "sku": "KIT(8oz)+13x6DTL-DG",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 166.46,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-midsize-grip-13pcs-golf-grip-kit?variant=39911360430141"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 152.89,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lite-standard-grip-13pcs-golf-grip-kit",
        "handle": "winn-dri-tac-lite-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360331837",
            "gid": "gid://shopify/ProductVariant/39911360331837",
            "sku": "KIT+13x5DTL-DG",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 152.89,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-standard-grip-13pcs-golf-grip-kit?variant=39911360331837"
          },
          {
            "id": "39911360364605",
            "gid": "gid://shopify/ProductVariant/39911360364605",
            "sku": "KIT(8oz)+13x5DTL-DG",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 158.99,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-standard-grip-13pcs-golf-grip-kit?variant=39911360364605"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 11.09,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lite-standard-grip",
        "handle": "winn-dri-tac-lite-standard-grip",
        "shopify_variants": [
          {
            "id": "40683427102781",
            "gid": "gid://shopify/ProductVariant/40683427102781",
            "sku": "5DTL-DG",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 11.09,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-standard-grip?variant=40683427102781"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 11.69,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lite-midsize-grip",
        "handle": "winn-dri-tac-lite-midsize-grip",
        "shopify_variants": [
          {
            "id": "40683426938941",
            "gid": "gid://shopify/ProductVariant/40683426938941",
            "sku": "6DTL-DG",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 11.69,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-midsize-grip?variant=40683426938941"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 13.39,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lite-oversize-grip",
        "handle": "winn-dri-tac-lite-oversize-grip",
        "shopify_variants": [
          {
            "id": "40683427070013",
            "gid": "gid://shopify/ProductVariant/40683427070013",
            "sku": "7DTL-DG",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 13.39,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lite-oversize-grip?variant=40683427070013"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, blackfriday2020, dri-tac lite, dri-tac oversize, dritac lite, dritac oversize, fathers-day-2021-sale, golf-grips, grip bundle, iron/wood, jumbo/oversize, light weight, light-weight-grips, lightweight, New for 2014, New for 2016, New for 2017, New for 2018, new-bundle-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "lighter weight",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-lt-less-taper",
    "brand": "Winn",
    "model": "Dri-Tac LT (Less Taper)",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reduced",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Black / Gray"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5,
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 11.69,
    "price_max": 190.27,
    "single_price_min": 11.69,
    "single_price_max": 13.59,
    "normalized_price_per_grip": 9.17,
    "bundle_price_min": 82.54,
    "kit_price_min": 167.84,
    "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/5LTDT-BKG-1700.jpg?v=1735455685",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 9,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Gray"
        ],
        "price": 82.54,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-standard-grip-grip-bundle-set",
        "handle": "winn-dri-tac-lt-less-taper-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960716349",
            "gid": "gid://shopify/ProductVariant/41021960716349",
            "sku": "SET-9x5LTDT-BKG",
            "color": "Black / Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Gray",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 82.54,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-standard-grip-grip-bundle-set?variant=41021960716349"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Gray"
        ],
        "price": 86.59,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-midsize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-lt-less-taper-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960683581",
            "gid": "gid://shopify/ProductVariant/41021960683581",
            "sku": "SET-9x6LTDT-BKG",
            "color": "Black / Gray",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Gray",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 86.59,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-midsize-grip-grip-bundle-set?variant=41021960683581"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black / Gray"
        ],
        "price": 94.69,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-oversize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-lt-less-taper-oversize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021960650813",
            "gid": "gid://shopify/ProductVariant/41021960650813",
            "sku": "SET-9x7LTDT-BKG",
            "color": "Black / Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Gray",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 94.69,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-oversize-grip-grip-bundle-set?variant=41021960650813"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 167.84,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-standard-grip-13pcs-golf-grip-kit",
        "handle": "winn-dri-tac-lt-less-taper-standard-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360266301",
            "gid": "gid://shopify/ProductVariant/39911360266301",
            "sku": "KIT+13x5LTDT-BKG",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 167.84,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-standard-grip-13pcs-golf-grip-kit?variant=39911360266301"
          },
          {
            "id": "39911360299069",
            "gid": "gid://shopify/ProductVariant/39911360299069",
            "sku": "KIT(8oz)+13x5LTDT-BKG",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Grip Size": "Standard",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 173.94,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-standard-grip-13pcs-golf-grip-kit?variant=39911360299069"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 175.32,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-midsize-grip-13pcs-golf-grip-kit",
        "handle": "winn-dri-tac-lt-less-taper-midsize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360200765",
            "gid": "gid://shopify/ProductVariant/39911360200765",
            "sku": "KIT+13x6LTDT-BKG",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 175.32,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-midsize-grip-13pcs-golf-grip-kit?variant=39911360200765"
          },
          {
            "id": "39911360233533",
            "gid": "gid://shopify/ProductVariant/39911360233533",
            "sku": "KIT(8oz)+13x6LTDT-BKG",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Grip Size": "Midsize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 181.41,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-midsize-grip-13pcs-golf-grip-kit?variant=39911360233533"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 190.27,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-oversize-grip-13pcs-golf-grip-kit",
        "handle": "winn-dri-tac-lt-less-taper-oversize-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360135229",
            "gid": "gid://shopify/ProductVariant/39911360135229",
            "sku": "KIT+13x7LTDT-BKG",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 190.27,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-oversize-grip-13pcs-golf-grip-kit?variant=39911360135229"
          },
          {
            "id": "39911360167997",
            "gid": "gid://shopify/ProductVariant/39911360167997",
            "sku": "KIT(8oz)+13x7LTDT-BKG",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Grip Size": "Oversize / Jumbo",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 196.36,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-oversize-grip-13pcs-golf-grip-kit?variant=39911360167997"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black / Gray"
        ],
        "price": 13.59,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-oversize-grip",
        "handle": "winn-dri-tac-lt-less-taper-oversize-grip",
        "shopify_variants": [
          {
            "id": "31506523455549",
            "gid": "gid://shopify/ProductVariant/31506523455549",
            "sku": "7LTDT-BKG",
            "color": "Black / Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Gray",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": false,
            "price": 13.59,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-oversize-grip?variant=31506523455549"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black / Gray"
        ],
        "price": 12.59,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-midsize-grip",
        "handle": "winn-dri-tac-lt-less-taper-midsize-grip",
        "shopify_variants": [
          {
            "id": "31506523390013",
            "gid": "gid://shopify/ProductVariant/31506523390013",
            "sku": "6LTDT-BKG",
            "color": "Black / Gray",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Gray",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 12.59,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-midsize-grip?variant=31506523390013"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black / Gray"
        ],
        "price": 11.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-standard-grip",
        "handle": "winn-dri-tac-lt-less-taper-standard-grip",
        "shopify_variants": [
          {
            "id": "31506523357245",
            "gid": "gid://shopify/ProductVariant/31506523357245",
            "sku": "5LTDT-BKG",
            "color": "Black / Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Gray",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 11.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-lt-less-taper-standard-grip?variant=31506523357245"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, blackfriday2020, Dri-Tac LT, dritac lt, fathers-day-2021-sale, golf-grips, grip bundle, iron/wood, new-bundle-set, reduced taper, single-golf-grips, standard, standard-size-golf-grips, under-150, under-300, winn, Winn 2020, Winn Dri-Tac LT, Winn Dritac",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "LT = less taper, larger lower hand",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Gray"
    ]
  },
  {
    "id": "winn-dri-tac-wrap",
    "brand": "Winn",
    "model": "Dri-Tac WRAP",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "style_forward",
    "non_black_color_count": 5,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Copper",
      "Copper or Dark Gray",
      "Copper or Dark Grey",
      "Dark Gray",
      "Dark Grey"
    ],
    "weight_g_by_size": {
      "Standard": 90.7,
      "Jumbo/Oversize": 90.7,
      "Midsize": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 8.79,
    "price_max": 158.87,
    "single_price_min": 8.79,
    "single_price_max": 10.99,
    "normalized_price_per_grip": 7.01,
    "bundle_price_min": 63.1,
    "kit_price_min": 131.96,
    "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/5DTWR-DG-1700_6f82c6c9-5a9f-486a-9032-44bbdbc9059d.jpg?v=1735455618",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 9,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [
          "Dark Grey"
        ],
        "price": 63.1,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-standard-grip-grip-bundle-set",
        "handle": "winn-dri-tac-wrap-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021968810045",
            "gid": "gid://shopify/ProductVariant/41021968810045",
            "sku": "SET-9x5DTWR-DG",
            "color": "Dark Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Dark Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 63.1,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-standard-grip-grip-bundle-set?variant=41021968810045"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Dark Grey"
        ],
        "price": 77.68,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-wrap-oversize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Grey",
              "Copper"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021968744509",
            "gid": "gid://shopify/ProductVariant/41021968744509",
            "sku": "SET-9x7DTWR-DG",
            "color": "Dark Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Dark Grey",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 77.68,
            "weight_g": 816.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-grip-grip-bundle-set?variant=41021968744509"
          },
          {
            "id": "41021968777277",
            "gid": "gid://shopify/ProductVariant/41021968777277",
            "sku": "SET-9x7DTWR-CP",
            "color": "Copper",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Copper",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 77.68,
            "weight_g": 816.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-grip-grip-bundle-set?variant=41021968777277"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Dark Grey"
        ],
        "price": 66.34,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-wrap-midsize-grip-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Grey",
              "Copper"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021968646205",
            "gid": "gid://shopify/ProductVariant/41021968646205",
            "sku": "SET-9x6DTWR-DG",
            "color": "Dark Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Dark Grey",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 66.34,
            "weight_g": 816.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-grip-grip-bundle-set?variant=41021968646205"
          },
          {
            "id": "41021968678973",
            "gid": "gid://shopify/ProductVariant/41021968678973",
            "sku": "SET-9x6DTWR-CP",
            "color": "Copper",
            "size": "Midsize",
            "selected_options": {
              "Color": "Copper",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 66.34,
            "weight_g": 816.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-grip-grip-bundle-set?variant=41021968678973"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Copper",
          "Copper or Dark Gray"
        ],
        "price": 158.87,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-13pcs-golf-grip-kit-copper-or-dark-gray",
        "handle": "winn-dri-tac-wrap-oversize-13pcs-golf-grip-kit-copper-or-dark-gray",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Copper",
              "Dark Gray"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911359742013",
            "gid": "gid://shopify/ProductVariant/39911359742013",
            "sku": "KIT+13x7DTWR-CP",
            "color": "Copper",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Copper",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 158.87,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-13pcs-golf-grip-kit-copper-or-dark-gray?variant=39911359742013"
          },
          {
            "id": "39911359774781",
            "gid": "gid://shopify/ProductVariant/39911359774781",
            "sku": "KIT+13x7DTWR-DG",
            "color": "Dark Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Dark Gray",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 158.87,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-13pcs-golf-grip-kit-copper-or-dark-gray?variant=39911359774781"
          },
          {
            "id": "39911359807549",
            "gid": "gid://shopify/ProductVariant/39911359807549",
            "sku": "KIT(8oz)+13x7DTWR-CP",
            "color": "Copper",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Copper",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 164.97,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-13pcs-golf-grip-kit-copper-or-dark-gray?variant=39911359807549"
          },
          {
            "id": "39911359840317",
            "gid": "gid://shopify/ProductVariant/39911359840317",
            "sku": "KIT(8oz)+13x7DTWR-DG",
            "color": "Dark Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Dark Gray",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Oversize / Jumbo"
            },
            "available": true,
            "price": 164.97,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-13pcs-golf-grip-kit-copper-or-dark-gray?variant=39911359840317"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Copper or Dark Gray",
          "Dark Gray"
        ],
        "price": 131.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-standard-13pcs-golf-grip-kit-copper-or-dark-gray",
        "handle": "winn-dri-tac-wrap-standard-13pcs-golf-grip-kit-copper-or-dark-gray",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911359643709",
            "gid": "gid://shopify/ProductVariant/39911359643709",
            "sku": "KIT+13x5DTWR-DG",
            "color": "Dark Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Dark Gray",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 131.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-standard-13pcs-golf-grip-kit-copper-or-dark-gray?variant=39911359643709"
          },
          {
            "id": "39911359709245",
            "gid": "gid://shopify/ProductVariant/39911359709245",
            "sku": "KIT(8oz)+13x5DTWR-DG",
            "color": "Dark Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Dark Gray",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 138.06,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-standard-13pcs-golf-grip-kit-copper-or-dark-gray?variant=39911359709245"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [
          "Copper",
          "Copper or Dark Grey"
        ],
        "price": 137.94,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-copper-13pcs-golf-grip-kit",
        "handle": "winn-dri-tac-wrap-midsize-copper-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Copper",
              "Dark Grey"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911359447101",
            "gid": "gid://shopify/ProductVariant/39911359447101",
            "sku": "KIT+13x6DTWR-CP",
            "color": "Copper",
            "size": "Midsize",
            "selected_options": {
              "Color": "Copper",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 137.94,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-copper-13pcs-golf-grip-kit?variant=39911359447101"
          },
          {
            "id": "39911359479869",
            "gid": "gid://shopify/ProductVariant/39911359479869",
            "sku": "KIT+13x6DTWR-DG",
            "color": "Dark Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Dark Grey",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 137.94,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-copper-13pcs-golf-grip-kit?variant=39911359479869"
          },
          {
            "id": "39911359512637",
            "gid": "gid://shopify/ProductVariant/39911359512637",
            "sku": "KIT(8oz)+13x6DTWR-CP",
            "color": "Copper",
            "size": "Midsize",
            "selected_options": {
              "Color": "Copper",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 144.04,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-copper-13pcs-golf-grip-kit?variant=39911359512637"
          },
          {
            "id": "39911359545405",
            "gid": "gid://shopify/ProductVariant/39911359545405",
            "sku": "KIT(8oz)+13x6DTWR-DG",
            "color": "Dark Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Dark Grey",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 144.04,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-copper-13pcs-golf-grip-kit?variant=39911359545405"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Dark Grey"
        ],
        "price": 9.69,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-grip",
        "handle": "winn-dri-tac-wrap-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Grey",
              "Copper"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "999721385",
            "gid": "gid://shopify/ProductVariant/999721385",
            "sku": "6DTWR-DG",
            "color": "Dark Grey",
            "size": "Midsize",
            "selected_options": {
              "Color": "Dark Grey"
            },
            "available": true,
            "price": 9.69,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-grip?variant=999721385"
          },
          {
            "id": "897978007571",
            "gid": "gid://shopify/ProductVariant/897978007571",
            "sku": "6DTWR-CP",
            "color": "Copper",
            "size": "Midsize",
            "selected_options": {
              "Color": "Copper"
            },
            "available": false,
            "price": 9.69,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-midsize-grip?variant=897978007571"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Dark Grey"
        ],
        "price": 10.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-grip",
        "handle": "winn-dri-tac-wrap-oversize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Grey",
              "Copper"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "999721329",
            "gid": "gid://shopify/ProductVariant/999721329",
            "sku": "7DTWR-DG",
            "color": "Dark Grey",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Dark Grey"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-grip?variant=999721329"
          },
          {
            "id": "897977516051",
            "gid": "gid://shopify/ProductVariant/897977516051",
            "sku": "7DTWR-CP",
            "color": "Copper",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Copper"
            },
            "available": true,
            "price": 10.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-oversize-grip?variant=897977516051"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Dark Grey"
        ],
        "price": 8.79,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-standard-grip",
        "handle": "winn-dri-tac-wrap-standard-grip",
        "shopify_variants": [
          {
            "id": "999721285",
            "gid": "gid://shopify/ProductVariant/999721285",
            "sku": "5DTWR-DG",
            "color": "Dark Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Dark Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 8.79,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-standard-grip?variant=999721285"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Grey"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, asbl-grip-option, blackfriday2020, dri-tac wrap, dritac wrap, fathers-day-2021-sale, golf-grips, grip bundle, iron/wood, mem25, new-bundle-set, prime-2025, single-golf-grips, soft, standard, standard-size-golf-grips, under-150, under-300, video=Unk0Y-otMyw, winn, Winn Dri-Tac Wrap, win",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Dark Grey",
      "Copper",
      "Dark Gray"
    ]
  },
  {
    "id": "winn-dri-tac-wrap",
    "brand": "Winn",
    "model": "Dri-Tac WRAP /",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [
      "Dark Gray"
    ],
    "weight_g_by_size": {
      "Undersize": 90.7
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 8.79,
    "price_max": 131.96,
    "single_price_min": 8.79,
    "single_price_max": 8.79,
    "normalized_price_per_grip": 7.01,
    "bundle_price_min": 63.1,
    "kit_price_min": 131.96,
    "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-ladies-undersize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-dri-tac-wrap-undersize_a64468b7-50b1-4cf4-ad78-b397a9ca1c3b.jpg?v=1735455628",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Dark Gray"
        ],
        "price": 63.1,
        "per_grip_g": 90.7,
        "total_g": 816.466266,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-ladies-undersize-grip-grip-bundle-set",
        "handle": "winn-dri-tac-wrap-ladies-undersize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021967728701",
            "gid": "gid://shopify/ProductVariant/41021967728701",
            "sku": "SET-9x3DTWR-GY",
            "color": "Dark Gray",
            "size": "Undersize",
            "selected_options": {
              "Color": "Dark Gray",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 63.1,
            "weight_g": 816.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-ladies-undersize-grip-grip-bundle-set?variant=41021967728701"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [
          "Dark Gray"
        ],
        "price": 131.96,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-undersize-13pcs-golf-grip-kit-dark-gray",
        "handle": "winn-dri-tac-wrap-undersize-13pcs-golf-grip-kit-dark-gray",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360036925",
            "gid": "gid://shopify/ProductVariant/39911360036925",
            "sku": "KIT+13x3DTWR-GY",
            "color": "Dark Gray",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 131.96,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-undersize-13pcs-golf-grip-kit-dark-gray?variant=39911360036925"
          },
          {
            "id": "39911360069693",
            "gid": "gid://shopify/ProductVariant/39911360069693",
            "sku": "KIT(8oz)+13x3DTWR-GY",
            "color": "Dark Gray",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 138.06,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-undersize-13pcs-golf-grip-kit-dark-gray?variant=39911360069693"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [
          "Dark Gray"
        ],
        "price": 8.79,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-ladies-undersize-grip",
        "handle": "winn-dri-tac-wrap-ladies-undersize-grip",
        "shopify_variants": [
          {
            "id": "11821205895",
            "gid": "gid://shopify/ProductVariant/11821205895",
            "sku": "3DTWR-GY",
            "color": "Dark Gray",
            "size": "Undersize",
            "selected_options": {
              "Color": "Dark Gray",
              "Grip Size": "Undersize"
            },
            "available": false,
            "price": 8.79,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-wrap-ladies-undersize-grip?variant=11821205895"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, blackfriday2020, dri-tac wrap, dritac wrap, fathers-day-2021-sale, gifts-for-her, golf-grips, grip bundle, iron/wood, ladies, new-bundle-set, single-golf-grips, soft, under-150, under-300, undersize, undersize-golf-grips, video=Unk0Y-otMyw, winn, Winn Dri-Tac Wrap, winn dritac, womens,",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-x",
    "brand": "Winn",
    "model": "Dri-Tac X",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit"
    ],
    "colors_available": [
      "Green / Black",
      "Tac X Standard Grip"
    ],
    "weight_g_by_size": {
      "Standard": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 6.59,
    "price_max": 99.25,
    "single_price_min": 6.59,
    "single_price_max": 6.59,
    "normalized_price_per_grip": 6.59,
    "bundle_price_min": null,
    "kit_price_min": 99.25,
    "url": "https://www.grips4less.com/products/winn-dri-tac-x-standard-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/dri-tac-x-splash.jpg?v=1736027131",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Green / Black"
        ],
        "price": 99.25,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-dri-tac-x-standard-13pcs-golf-grip-kit",
        "handle": "winn-dri-tac-x-standard-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green / Black",
              "Blue / Black",
              "Red / Black"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1124339515411",
            "gid": "gid://shopify/ProductVariant/1124339515411",
            "sku": "KIT+13x5DTX-GRB",
            "color": "Green / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Green / Black"
            },
            "available": false,
            "price": 99.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-standard-13pcs-golf-grip-kit?variant=1124339515411"
          },
          {
            "id": "1124339548179",
            "gid": "gid://shopify/ProductVariant/1124339548179",
            "sku": "KIT+13x5DTX-BLB",
            "color": "Blue / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue / Black"
            },
            "available": false,
            "price": 99.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-standard-13pcs-golf-grip-kit?variant=1124339548179"
          },
          {
            "id": "1124339580947",
            "gid": "gid://shopify/ProductVariant/1124339580947",
            "sku": "KIT+13x5DTX-RDB",
            "color": "Red / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Red / Black"
            },
            "available": false,
            "price": 99.25,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-standard-13pcs-golf-grip-kit?variant=1124339580947"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green / Black",
          "Tac X Standard Grip"
        ],
        "price": 6.59,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-x-standard-grip",
        "handle": "winn-dri-tac-x-standard-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green / Black",
              "Blue / Black",
              "Red / Black"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "897470136339",
            "gid": "gid://shopify/ProductVariant/897470136339",
            "sku": "5DTX-GRB",
            "color": "Green / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Green / Black"
            },
            "available": false,
            "price": 6.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-standard-grip?variant=897470136339"
          },
          {
            "id": "897470169107",
            "gid": "gid://shopify/ProductVariant/897470169107",
            "sku": "5DTX-BLB",
            "color": "Blue / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue / Black"
            },
            "available": false,
            "price": 6.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-standard-grip?variant=897470169107"
          },
          {
            "id": "897470201875",
            "gid": "gid://shopify/ProductVariant/897470201875",
            "sku": "5DTX-RDB",
            "color": "Red / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Red / Black"
            },
            "available": false,
            "price": 6.59,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-standard-grip?variant=897470201875"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, All Products, blackfriday2020, dri-tac, Dri-Tac X, dritac x, dritacx, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, gripkit-shaftbundle-sale, iron/wood, New for 2016, New for 2017, New for 2018, soft, standard, standard-size-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-excel",
    "brand": "Winn",
    "model": "Excel",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer",
    "texture": "textured",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5,
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 8.19,
    "price_max": 76.06,
    "single_price_min": 8.19,
    "single_price_max": 10.79,
    "normalized_price_per_grip": 6.65,
    "bundle_price_min": 59.86,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-excel-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/5715w-1000.jpg?v=1735455583",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 6,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 59.86,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-excel-standard-grip-grip-bundle-set",
        "handle": "winn-excel-standard-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976543293",
            "gid": "gid://shopify/ProductVariant/41021976543293",
            "sku": "SET-9x5715W",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 59.86,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-excel-standard-grip-grip-bundle-set?variant=41021976543293"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "9pc bundle",
        "colors": [
          "Black"
        ],
        "price": 63.91,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-excel-midsize-grip-grip-bundle-set",
        "handle": "winn-excel-midsize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976477757",
            "gid": "gid://shopify/ProductVariant/41021976477757",
            "sku": "SET-9x6715W",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 63.91,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-excel-midsize-grip-grip-bundle-set?variant=41021976477757"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 76.06,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-excel-oversize-grip-grip-bundle-set",
        "handle": "winn-excel-oversize-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976412221",
            "gid": "gid://shopify/ProductVariant/41021976412221",
            "sku": "SET-9x7715W",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 76.06,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-excel-oversize-grip-grip-bundle-set?variant=41021976412221"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.79,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-excel-oversize-grip",
        "handle": "winn-excel-oversize-grip",
        "shopify_variants": [
          {
            "id": "13184968589373",
            "gid": "gid://shopify/ProductVariant/13184968589373",
            "sku": "7715W",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 10.79,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-excel-oversize-grip?variant=13184968589373"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-excel-midsize-grip",
        "handle": "winn-excel-midsize-grip",
        "shopify_variants": [
          {
            "id": "13184959938621",
            "gid": "gid://shopify/ProductVariant/13184959938621",
            "sku": "6715W",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 8.69,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-excel-midsize-grip?variant=13184959938621"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.19,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-excel-standard-grip",
        "handle": "winn-excel-standard-grip",
        "shopify_variants": [
          {
            "id": "13185305935933",
            "gid": "gid://shopify/ProductVariant/13185305935933",
            "sku": "5715W",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 8.19,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-excel-standard-grip?variant=13185305935933"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "5715W, All Products, arthritic, arthritic-golf-grips, asbl-grip-option, blackfriday2020, excel, excel wrap, fathers-day-2021-sale, golf-grips, grip bundle, iron/wood, new-bundle-set, single-golf-grips, soft, standard, standard-size-golf-grips, tacky, under-150, under-300, W5, W5 Grip, winn, Winn Dri",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "winn-excel",
    "brand": "Winn",
    "model": "Excel /",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer",
    "texture": "textured",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Undersize"
    ],
    "manufacturer_size_labels": [
      "Undersize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "13pc kit",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Undersize": 63.5
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 8.19,
    "price_max": 125.98,
    "single_price_min": 8.19,
    "single_price_max": 8.19,
    "normalized_price_per_grip": 6.65,
    "bundle_price_min": 59.86,
    "kit_price_min": 125.98,
    "url": "https://www.grips4less.com/products/winn-excel-ladies-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/3715w-1000.jpg?v=1735455582",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Undersize"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 59.86,
        "per_grip_g": 63.5,
        "total_g": 571.5263862,
        "url": "https://www.grips4less.com/products/winn-excel-ladies-grip-grip-bundle-set",
        "handle": "winn-excel-ladies-grip-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021976608829",
            "gid": "gid://shopify/ProductVariant/41021976608829",
            "sku": "SET-9x3715W",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 59.86,
            "weight_g": 571.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-excel-ladies-grip-grip-bundle-set?variant=41021976608829"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 125.98,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/winn-excel-ladies-grip-13pcs-golf-grip-kit",
        "handle": "winn-excel-ladies-grip-13pcs-golf-grip-kit",
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          },
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911360725053",
            "gid": "gid://shopify/ProductVariant/39911360725053",
            "sku": "KIT+13x3715W",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 125.98,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-excel-ladies-grip-13pcs-golf-grip-kit?variant=39911360725053"
          },
          {
            "id": "39911360757821",
            "gid": "gid://shopify/ProductVariant/39911360757821",
            "sku": "KIT(8oz)+13x3715W",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize",
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 132.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-excel-ladies-grip-13pcs-golf-grip-kit?variant=39911360757821"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Undersize"
        ],
        "format": "single",
        "colors": [],
        "price": 8.19,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-excel-ladies-grip",
        "handle": "winn-excel-ladies-grip",
        "shopify_variants": [
          {
            "id": "40683427594301",
            "gid": "gid://shopify/ProductVariant/40683427594301",
            "sku": "3715W",
            "color": "",
            "size": "Undersize",
            "selected_options": {
              "Grip Size": "Undersize"
            },
            "available": true,
            "price": 8.19,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-excel-ladies-grip?variant=40683427594301"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size",
            "values": [
              "Undersize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "3715W, All Products, arthritic, arthritic-golf-grips, blackfriday2020, excel, excel wrap, fathers-day-2021-sale, gifts-for-her, golf-grips, grip bundle, iron/wood, ladies, mem25, new-bundle-set, single-golf-grips, soft, tacky, under-150, under-300, undersize, undersize-golf-grips, video=IJMkiiz81EQ,",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-excel-black",
    "brand": "Winn",
    "model": "Excel Black",
    "type": "club",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer",
    "texture": "textured",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "",
    "putter_size": "",
    "putter_size_class": "",
    "putter_weight_class": "",
    "wrist_stability_level": "",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "13pc kit"
    ],
    "colors_available": [
      "Oversize / Black",
      "Standard / Black"
    ],
    "weight_g_by_size": {
      "Midsize": 71.9,
      "Standard": 71.9,
      "Jumbo/Oversize": 71.9
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 125.98,
    "price_max": 155.88,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 9.69,
    "bundle_price_min": null,
    "kit_price_min": 125.98,
    "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-midsize-black-grips",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gripkit-winn-excel-ov-blk.jpg?v=1740079869",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "13pc kit",
        "colors": [],
        "price": 133.46,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-midsize-black-grips",
        "handle": "grip-kit-13x-winn-excel-midsize-black-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911358988349",
            "gid": "gid://shopify/ProductVariant/39911358988349",
            "sku": "KIT+13x6715W",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 133.46,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-midsize-black-grips?variant=39911358988349"
          },
          {
            "id": "39911359021117",
            "gid": "gid://shopify/ProductVariant/39911359021117",
            "sku": "KIT(8oz)+13x6715W",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 139.55,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-midsize-black-grips?variant=39911359021117"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "13pc kit",
        "colors": [
          "Standard / Black"
        ],
        "price": 125.98,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-standard-black-grips",
        "handle": "grip-kit-13x-winn-excel-standard-black-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911358922813",
            "gid": "gid://shopify/ProductVariant/39911358922813",
            "sku": "KIT+13x5715W",
            "color": "Standard / Black",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 125.98,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-standard-black-grips?variant=39911358922813"
          },
          {
            "id": "39911358955581",
            "gid": "gid://shopify/ProductVariant/39911358955581",
            "sku": "KIT(8oz)+13x5715W",
            "color": "Standard / Black",
            "size": "Standard",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": true,
            "price": 132.08,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-standard-black-grips?variant=39911358955581"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "13pc kit",
        "colors": [
          "Oversize / Black"
        ],
        "price": 155.88,
        "per_grip_g": 71.9,
        "total_g": 934.4002822,
        "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-oversize-black-grips",
        "handle": "grip-kit-13x-winn-excel-oversize-black-grips",
        "shopify_options": [
          {
            "name": "Kit Options",
            "values": [
              "4oz Solvent + 14ct Tape Strips + Shaft Clamp",
              "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39911358627901",
            "gid": "gid://shopify/ProductVariant/39911358627901",
            "sku": "KIT+13x7715W",
            "color": "Oversize / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "4oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 155.88,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-oversize-black-grips?variant=39911358627901"
          },
          {
            "id": "39911358660669",
            "gid": "gid://shopify/ProductVariant/39911358660669",
            "sku": "KIT(8oz)+13x7715W",
            "color": "Oversize / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Kit Options": "8oz Solvent + 14ct Tape Strips + Shaft Clamp"
            },
            "available": false,
            "price": 161.98,
            "weight_g": 934.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/grip-kit-13x-winn-excel-oversize-black-grips?variant=39911358660669"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2021-endofyear, 2021-nysale, 2022-newyear, 2023-sale, 6715W, All Products, arthritic, arthritic-golf-grips, bf-nonassembled, bf-sale, blackfriday2020, bundle, excel, excel wrap, free-rog-momentum-glove, grip kit, grip kits, grip set, grip sets, grip-kit-free-tees, gripkit-shaftbundle-sale, iron/wood",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Standard / Black"
    ]
  },
  {
    "id": "2thumb-octotech-36",
    "brand": "2Thumb",
    "model": "OCTOTECH 36",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-octotech-36-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Octo36B.jpg?v=1649285075",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-octotech-36-putter-grip",
        "handle": "2-thumb-octotech-36-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39873073938493",
            "gid": "gid://shopify/ProductVariant/39873073938493",
            "sku": "2T-OCTB36",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-octotech-36-putter-grip?variant=39873073938493"
          },
          {
            "id": "39873073971261",
            "gid": "gid://shopify/ProductVariant/39873073971261",
            "sku": "2T-OCTW36",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-octotech-36-putter-grip?variant=39873073971261"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2thumb-octotech, 49 under, All Products, Brand_2Thumb, fathers-day-gifts, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, putter grip gift, putter",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "White"
    ]
  },
  {
    "id": "2thumb-octotech-43",
    "brand": "2Thumb",
    "model": "OCTOTECH 43",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2thumb-octotech-43-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/octotech-43-1-black.jpg?v=1704400905",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2thumb-octotech-43-putter-grip",
        "handle": "2thumb-octotech-43-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40950411755581",
            "gid": "gid://shopify/ProductVariant/40950411755581",
            "sku": "2T-OCTOB43",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-octotech-43-putter-grip?variant=40950411755581"
          },
          {
            "id": "40950411788349",
            "gid": "gid://shopify/ProductVariant/40950411788349",
            "sku": "2T-OCTOW43",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-octotech-43-putter-grip?variant=40950411788349"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2thumb-octotech, 49 under, All Products, Brand_2Thumb, fathers-day-gifts, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, putter grip gift, putter",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "2thumb-og-lite-31",
    "brand": "2Thumb",
    "model": "OG LITE 31",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-og-lite-31-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2thumb-og-lite-31-putter-grip-black.jpg?v=1649371670",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-og-lite-31-putter-grip",
        "handle": "2-thumb-og-lite-31-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39873073446973",
            "gid": "gid://shopify/ProductVariant/39873073446973",
            "sku": "2T-OGB31",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-og-lite-31-putter-grip?variant=39873073446973"
          },
          {
            "id": "39873073479741",
            "gid": "gid://shopify/ProductVariant/39873073479741",
            "sku": "2T-OGW31",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-og-lite-31-putter-grip?variant=39873073479741"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2thumb-og-lite, 49 under, All Products, Brand_2Thumb, fathers-day-gifts, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, putter grip gift, putter-",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "2thumb-og-lite-35",
    "brand": "2Thumb",
    "model": "OG LITE 35",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-og-lite-35-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2thumb-og-lite-35-putter-grip-black.jpg?v=1649373609",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-og-lite-35-putter-grip",
        "handle": "2-thumb-og-lite-35-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39873073512509",
            "gid": "gid://shopify/ProductVariant/39873073512509",
            "sku": "2T-OGB35",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-og-lite-35-putter-grip?variant=39873073512509"
          },
          {
            "id": "39873073545277",
            "gid": "gid://shopify/ProductVariant/39873073545277",
            "sku": "2T-OGW35",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-og-lite-35-putter-grip?variant=39873073545277"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2thumb-og-lite, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, putter grip gift, putter-grip-gifts, putter-",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "2thumb-og-lite-39",
    "brand": "2Thumb",
    "model": "OG LITE 39",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2thumb-og-lite-39-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/2thumb-og-lite-43-1.jpg?v=1710028353",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2thumb-og-lite-39-putter-grip",
        "handle": "2thumb-og-lite-39-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41083185102909",
            "gid": "gid://shopify/ProductVariant/41083185102909",
            "sku": "2T-OGB39",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-og-lite-39-putter-grip?variant=41083185102909"
          },
          {
            "id": "41083185135677",
            "gid": "gid://shopify/ProductVariant/41083185135677",
            "sku": "2T-OGW39",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-og-lite-39-putter-grip?variant=41083185135677"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2thumb-og-lite, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, reduced taper, single-grip, Size_Jumbo/Overs",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "2thumb-og-lite-39-putter-grip-17",
    "brand": "2Thumb",
    "model": "OG LITE 39 Putter Grip - 17\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Long"
    ],
    "manufacturer_size_labels": [
      "Long"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Long": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2thumb-og-lite-39-putter-grip-long",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/2thumb-oglite-39-long.jpg?v=1710021366",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Long"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2thumb-og-lite-39-putter-grip-long",
        "handle": "2thumb-og-lite-39-putter-grip-long",
        "shopify_variants": [
          {
            "id": "41083093745725",
            "gid": "gid://shopify/ProductVariant/41083093745725",
            "sku": "2T-OGBL39",
            "color": "Black",
            "size": "Long",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/2thumb-og-lite-39-putter-grip-long?variant=41083093745725"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2 thumb, 2024 new products, 2thumb, 2Thumb Putter Grip, 2thumb-og-lite, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, long, Long Putter, Long/Belly Putter, non-tapered, og lite 39, og lite long, oversize, oversize-golf-grips, oversize-jumbo-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "2thumb-og-lite-43",
    "brand": "2Thumb",
    "model": "OG LITE 43",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2thumb-og-lite-43-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2thumb-oglite-43.jpg?v=1652228604",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2thumb-og-lite-43-putter-grip",
        "handle": "2thumb-og-lite-43-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39931187527741",
            "gid": "gid://shopify/ProductVariant/39931187527741",
            "sku": "2T-OGB43",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-og-lite-43-putter-grip?variant=39931187527741"
          },
          {
            "id": "41083184218173",
            "gid": "gid://shopify/ProductVariant/41083184218173",
            "sku": "2T-OGW43",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-og-lite-43-putter-grip?variant=41083184218173"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2thumb-og-lite, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, reduced taper, single-grip, Size_Jumbo/Overs",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "2thumb-pistol-7e-26",
    "brand": "2Thumb",
    "model": "PISTOL 7E 26",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-26-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Pistol26B.jpg?v=1649373879",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-26-putter-grip",
        "handle": "2-thumb-pistol-7e-26-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39873073578045",
            "gid": "gid://shopify/ProductVariant/39873073578045",
            "sku": "2T-PIS7B26",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-26-putter-grip?variant=39873073578045"
          },
          {
            "id": "39873073610813",
            "gid": "gid://shopify/ProductVariant/39873073610813",
            "sku": "2T-PIS7W26",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-26-putter-grip?variant=39873073610813"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2thumb-pistol-7e, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, putter-grips, reduced taper, single-grip, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "White"
    ]
  },
  {
    "id": "2thumb-pistol-7e-29",
    "brand": "2Thumb",
    "model": "PISTOL 7E 29",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-29-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Pistol7E29B.jpg?v=1649374151",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-29-putter-grip",
        "handle": "2-thumb-pistol-7e-29-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39873073643581",
            "gid": "gid://shopify/ProductVariant/39873073643581",
            "sku": "2T-PIS7B29",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-29-putter-grip?variant=39873073643581"
          },
          {
            "id": "39873073676349",
            "gid": "gid://shopify/ProductVariant/39873073676349",
            "sku": "2T-PIS7W29",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-29-putter-grip?variant=39873073676349"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2thumb-pistol-7e, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, overstock-oct-2022, overstock-oct-2023, putter, putter grip, pu",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White"
    ]
  },
  {
    "id": "2thumb-pistol-7e-32",
    "brand": "2Thumb",
    "model": "PISTOL 7E 32",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-32-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Pistol7E32B.jpg?v=1649374314",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-32-putter-grip",
        "handle": "2-thumb-pistol-7e-32-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39873073709117",
            "gid": "gid://shopify/ProductVariant/39873073709117",
            "sku": "2T-PIS7B32",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-32-putter-grip?variant=39873073709117"
          },
          {
            "id": "39873073741885",
            "gid": "gid://shopify/ProductVariant/39873073741885",
            "sku": "2T-PIS7W32",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-pistol-7e-32-putter-grip?variant=39873073741885"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2thumb-pistol-7e, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, overstock-oct-2022, overstock-oct-2023, putter, putter grip, pu",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White"
    ]
  },
  {
    "id": "2thumb-snug-sq-30-putter-grip-17",
    "brand": "2Thumb",
    "model": "SNUG SQ 30 Putter Grip - 17\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Long"
    ],
    "manufacturer_size_labels": [
      "Long"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Long": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2thumb-snug-sq-30-putter-grip-long",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/2thumb-SNUGSQ30LONG.jpg?v=1710021716",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Long"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2thumb-snug-sq-30-putter-grip-long",
        "handle": "2thumb-snug-sq-30-putter-grip-long",
        "shopify_variants": [
          {
            "id": "41083095187517",
            "gid": "gid://shopify/ProductVariant/41083095187517",
            "sku": "2T-S2B30L",
            "color": "Black",
            "size": "Long",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/2thumb-snug-sq-30-putter-grip-long?variant=41083095187517"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2 thumb, 2024 new products, 2thumb, 2Thumb Putter Grip, 2Thumb SNUG, 2thumb-snug-tour, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, long, Long Putter, Long/Belly Putter, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "2thumb-snug-tour-24",
    "brand": "2Thumb",
    "model": "SNUG TOUR 24",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-snug-tour-24-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/snug_tour24B.jpg?v=1649376026",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-snug-tour-24-putter-grip",
        "handle": "2-thumb-snug-tour-24-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39873073774653",
            "gid": "gid://shopify/ProductVariant/39873073774653",
            "sku": "2T-STB24",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-snug-tour-24-putter-grip?variant=39873073774653"
          },
          {
            "id": "39873073807421",
            "gid": "gid://shopify/ProductVariant/39873073807421",
            "sku": "2T-STW24",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-snug-tour-24-putter-grip?variant=39873073807421"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2Thumb SNUG, 2thumb-snug-tour, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, overstock-oct-2022, overstock-oct-2023, putter, pu",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White"
    ]
  },
  {
    "id": "2thumb-snug-tour-27",
    "brand": "2Thumb",
    "model": "SNUG TOUR 27",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2thumb-snug-tour-27-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/2thumb-snugtour-27-21.jpg?v=1710029901",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2thumb-snug-tour-27-putter-grip",
        "handle": "2thumb-snug-tour-27-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41083215249469",
            "gid": "gid://shopify/ProductVariant/41083215249469",
            "sku": "2T-STB27",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-snug-tour-27-putter-grip?variant=41083215249469"
          },
          {
            "id": "41083215282237",
            "gid": "gid://shopify/ProductVariant/41083215282237",
            "sku": "2T-STW27",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-snug-tour-27-putter-grip?variant=41083215282237"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2Thumb SNUG, 2thumb-snug-tour, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, overstock-oct-2022, overstock-oct-2023, putter, pu",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White"
    ]
  },
  {
    "id": "2thumb-snug-tour-30",
    "brand": "2Thumb",
    "model": "SNUG TOUR 30",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-snug-tour-30-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/SnugTour30B.jpg?v=1649376212",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-snug-tour-30-putter-grip",
        "handle": "2-thumb-snug-tour-30-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39873073840189",
            "gid": "gid://shopify/ProductVariant/39873073840189",
            "sku": "2T-STB30",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-snug-tour-30-putter-grip?variant=39873073840189"
          },
          {
            "id": "39873073872957",
            "gid": "gid://shopify/ProductVariant/39873073872957",
            "sku": "2T-STW30",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-snug-tour-30-putter-grip?variant=39873073872957"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2Thumb SNUG, 2thumb-snug-tour, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, overstock-oct-2022, overstock-oct-2023, putter, pu",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "2thumb-snug-sq-27",
    "brand": "2Thumb",
    "model": "Snug SQ 27",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-snug-sq-27-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/2thumb-snug-sq-27-1.jpg?v=1710031491",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-snug-sq-27-putter-grip",
        "handle": "2-thumb-snug-sq-27-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41083226488893",
            "gid": "gid://shopify/ProductVariant/41083226488893",
            "sku": "2T-S2B27",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-snug-sq-27-putter-grip?variant=41083226488893"
          },
          {
            "id": "41083226521661",
            "gid": "gid://shopify/ProductVariant/41083226521661",
            "sku": "2T-S2W27",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-snug-sq-27-putter-grip?variant=41083226521661"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2Thumb SNUG, 2thumb-snug-sq, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, overstock-oct-2022, overstock-oct-2023, putter, putt",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "White"
    ]
  },
  {
    "id": "2thumb-snug-sq-30",
    "brand": "2Thumb",
    "model": "Snug SQ 30",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2-thumb-snug-sq-30-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/2thumb-snug-sq-30-1.jpg?v=1710031960",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2-thumb-snug-sq-30-putter-grip",
        "handle": "2-thumb-snug-sq-30-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41083226751037",
            "gid": "gid://shopify/ProductVariant/41083226751037",
            "sku": "2T-S2B30",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-snug-sq-30-putter-grip?variant=41083226751037"
          },
          {
            "id": "41083226783805",
            "gid": "gid://shopify/ProductVariant/41083226783805",
            "sku": "2T-S2W30",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2-thumb-snug-sq-30-putter-grip?variant=41083226783805"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2Thumb SNUG, 2thumb-snug-sq, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, overstock-oct-2022, overstock-oct-2023, putter, putt",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White"
    ]
  },
  {
    "id": "2thumb-snug-sq-33",
    "brand": "2Thumb",
    "model": "Snug SQ 33",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU Ultra-Tac over EVA core",
    "texture": "wrap",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper, oversize)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://row.twothumbgrip.com/products/og-lite-39l"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2thumb-snug-sq-33-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/2thumb-snug-sq-33-1.jpg?v=1710032074",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/2thumb-snug-sq-33-putter-grip",
        "handle": "2thumb-snug-sq-33-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41083226980413",
            "gid": "gid://shopify/ProductVariant/41083226980413",
            "sku": "2T-S2B33",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-snug-sq-33-putter-grip?variant=41083226980413"
          },
          {
            "id": "41083227013181",
            "gid": "gid://shopify/ProductVariant/41083227013181",
            "sku": "2T-S2W33",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2thumb-snug-sq-33-putter-grip?variant=41083227013181"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2 thumb, 2thumb, 2Thumb Putter Grip, 2Thumb SNUG, 2thumb-snug-sq, 49 under, All Products, Brand_2Thumb, golf-grips, jumbo/oversize, laborday-2022, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, overstock-oct-2022, overstock-oct-2023, putter, putt",
    "source_quality": "manufacturer_family",
    "source_url": "https://row.twothumbgrip.com/products/og-lite-39l",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "evnroll-gravity-gravity",
    "brand": "Evnroll (Gravity)",
    "model": "Gravity",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red/White (Gravity Logo)"
    ],
    "weight_g_by_size": {
      "Unspecified": 122.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/evnroll-gravity-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/EVNR_Grip_GG1-sq-scaled_94931d62-a1b3-43b6-942e-a2f7c66656bd.webp?v=1758304562",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red/White (Gravity Logo)"
        ],
        "price": 24.99,
        "per_grip_g": 122.5,
        "total_g": 122.4699399,
        "url": "https://www.grips4less.com/products/evnroll-gravity-putter-grip",
        "handle": "evnroll-gravity-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red/White (Gravity Logo)",
              "Red/White (EVNROLL Gravity Logo)",
              "Black/White (Gravity Logo)",
              "Black/White (EVNROLL Gravity Logo)"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31303042236477",
            "gid": "gid://shopify/ProductVariant/31303042236477",
            "sku": "GRAVGRIP-RED",
            "color": "Red/White (Gravity Logo)",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White (Gravity Logo)"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 122.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/evnroll-gravity-putter-grip?variant=31303042236477"
          },
          {
            "id": "32908515967037",
            "gid": "gid://shopify/ProductVariant/32908515967037",
            "sku": "ERGGRAV-RED",
            "color": "Red/White (EVNROLL Gravity Logo)",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White (EVNROLL Gravity Logo)"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 122.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/evnroll-gravity-putter-grip?variant=32908515967037"
          },
          {
            "id": "31303046627389",
            "gid": "gid://shopify/ProductVariant/31303046627389",
            "sku": "GRAVGRIP-BLACK",
            "color": "Black/White (Gravity Logo)",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White (Gravity Logo)"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 122.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/evnroll-gravity-putter-grip?variant=31303046627389"
          },
          {
            "id": "32908516687933",
            "gid": "gid://shopify/ProductVariant/32908516687933",
            "sku": "ERGGRAV-BLACK",
            "color": "Black/White (EVNROLL Gravity Logo)",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White (EVNROLL Gravity Logo)"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 122.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/evnroll-gravity-putter-grip?variant=32908516687933"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, Counter Balance, Countercore, Evenroll, Evnroll, Evnroll Gravity Grip, evnroll-gravity, fathers-day-gifts, golf-grips, golfers-gift-guide, Gravity, Gravity Grip, july4-2022, laborday-2022, mid-ov-putter-sale, non-tapered, putter, putter grip, putter grip g",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White (EVNROLL Gravity Logo)"
    ]
  },
  {
    "id": "flat-cat-flat-cat",
    "brand": "Flat Cat",
    "model": "Flat Cat",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Svelte / 51g"
    ],
    "manufacturer_size_labels": [
      "Svelte / 51g"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Svelte / 51g": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-flat-cat-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Flat-Cat-Svelte-diag.jpg?v=1626819764",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Svelte / 51g"
        ],
        "format": "single",
        "colors": [],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-flat-cat-putter-grip",
        "handle": "lamkin-flat-cat-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Svelte / 51g",
              "Slim / 45g",
              "Standard / 68g",
              "Fat / 85g",
              "Big Boy / 104g"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41656664019",
            "gid": "gid://shopify/ProductVariant/41656664019",
            "sku": "FG-8718nt",
            "color": "",
            "size": "Svelte / 51g",
            "selected_options": {
              "Size": "Svelte / 51g"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-flat-cat-putter-grip?variant=41656664019"
          },
          {
            "id": "41655871443",
            "gid": "gid://shopify/ProductVariant/41655871443",
            "sku": "FG-8706nt",
            "color": "",
            "size": "Svelte / 51g",
            "selected_options": {
              "Size": "Slim / 45g"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-flat-cat-putter-grip?variant=41655871443"
          },
          {
            "id": "8935619919933",
            "gid": "gid://shopify/ProductVariant/8935619919933",
            "sku": "FG-8707nt",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard / 68g"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-flat-cat-putter-grip?variant=8935619919933"
          },
          {
            "id": "41656670931",
            "gid": "gid://shopify/ProductVariant/41656670931",
            "sku": "FG-8708nt",
            "color": "",
            "size": "Svelte / 51g",
            "selected_options": {
              "Size": "Fat / 85g"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-flat-cat-putter-grip?variant=41656670931"
          },
          {
            "id": "41656672979",
            "gid": "gid://shopify/ProductVariant/41656672979",
            "sku": "FG-8709nt",
            "color": "",
            "size": "Svelte / 51g",
            "selected_options": {
              "Size": "Big Boy / 104g"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-flat-cat-putter-grip?variant=41656672979"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, Flat Cat Big Boy, Flat Cat Fat, Flat Cat Putter, Flat Cat Slim, Flat Cat Standard, Flat Cat Svelte, flat-cat, golf-grips, jumbo/oversize, laborday-2022, midsize, midsize-golf-grips, Most Popular Oversize Putter Grips, new arrivals, New for 2017, oversize, ",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "flat-cat-pistol",
    "brand": "Flat Cat",
    "model": "PISTOL",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard / 60g"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/flat-cat-pistol-standard-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Pistol_Original.jpg?v=1571438537",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/flat-cat-pistol-standard-putter-grip",
        "handle": "flat-cat-pistol-standard-putter-grip",
        "shopify_variants": [
          {
            "id": "41088042926141",
            "gid": "gid://shopify/ProductVariant/41088042926141",
            "sku": "FG-8733",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard / 60g"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/flat-cat-pistol-standard-putter-grip?variant=41088042926141"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Standard / 60g"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, Flat Cat Fat, Flat Cat Putter, flat-cat, golf-grips, jumbo/oversize, new arrivals, overstock-mar2024, putter, putter grip, putter-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=icH4ytklXxE",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "flat-cat-solution",
    "brand": "Flat Cat",
    "model": "Solution",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Pistol / 75g"
    ],
    "manufacturer_size_labels": [
      "Pistol / 75g"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Pistol / 75g": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/flat-cat-solutionputter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/flatcat-solution-bigboy.jpg?v=1571438532",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Pistol / 75g"
        ],
        "format": "single",
        "colors": [],
        "price": 39.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/flat-cat-solutionputter-grip",
        "handle": "flat-cat-solutionputter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Pistol / 75g",
              "Svelte / 126g",
              "Standard / 172g",
              "Fat / 197g",
              "Big Boy / 227g"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "8935642890301",
            "gid": "gid://shopify/ProductVariant/8935642890301",
            "sku": "FG-8732",
            "color": "",
            "size": "Pistol / 75g",
            "selected_options": {
              "Size": "Pistol / 75g"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/flat-cat-solutionputter-grip?variant=8935642890301"
          },
          {
            "id": "48632288339",
            "gid": "gid://shopify/ProductVariant/48632288339",
            "sku": "FG-8721",
            "color": "",
            "size": "Pistol / 75g",
            "selected_options": {
              "Size": "Svelte / 126g"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/flat-cat-solutionputter-grip?variant=48632288339"
          },
          {
            "id": "48632288403",
            "gid": "gid://shopify/ProductVariant/48632288403",
            "sku": "FG-8722",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard / 172g"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/flat-cat-solutionputter-grip?variant=48632288403"
          },
          {
            "id": "48632288467",
            "gid": "gid://shopify/ProductVariant/48632288467",
            "sku": "FG-8723",
            "color": "",
            "size": "Pistol / 75g",
            "selected_options": {
              "Size": "Fat / 197g"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/flat-cat-solutionputter-grip?variant=48632288467"
          },
          {
            "id": "48632288531",
            "gid": "gid://shopify/ProductVariant/48632288531",
            "sku": "FG-8724",
            "color": "",
            "size": "Pistol / 75g",
            "selected_options": {
              "Size": "Big Boy / 227g"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/flat-cat-solutionputter-grip?variant=48632288531"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, fathers-day-gifts, Flat Cat Big Boy, Flat Cat Fat, Flat Cat Putter, Flat Cat Slim, Flat Cat Solution, Flat Cat Standard, Flat Cat Svelte, flat-cat, golf-grips, jumbo/oversize, laborday-2022, midsize, midsize-golf-grips, Most Popular Oversize Putter Grips, ",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "flat-cat-tak",
    "brand": "Flat Cat",
    "model": "TAK",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Slim / 63g"
    ],
    "manufacturer_size_labels": [
      "Slim / 63g"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Slim / 63g": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/flat-cat-tak-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Tak_Slim.jpg?v=1571438537",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Slim / 63g"
        ],
        "format": "single",
        "colors": [],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/flat-cat-tak-putter-grip",
        "handle": "flat-cat-tak-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Slim / 63g",
              "Svelte / 75g",
              "Standard / 92"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "8935824752701",
            "gid": "gid://shopify/ProductVariant/8935824752701",
            "sku": "FG-8725",
            "color": "",
            "size": "Slim / 63g",
            "selected_options": {
              "Size": "Slim / 63g"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/flat-cat-tak-putter-grip?variant=8935824752701"
          },
          {
            "id": "8935824785469",
            "gid": "gid://shopify/ProductVariant/8935824785469",
            "sku": "FG-8726",
            "color": "",
            "size": "Slim / 63g",
            "selected_options": {
              "Size": "Svelte / 75g"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/flat-cat-tak-putter-grip?variant=8935824785469"
          },
          {
            "id": "8935824818237",
            "gid": "gid://shopify/ProductVariant/8935824818237",
            "sku": "FG-8727",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Size": "Standard / 92"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/flat-cat-tak-putter-grip?variant=8935824818237"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, Flat Cat Fat, Flat Cat Putter, Flat Cat Slim, Flat Cat Svelte, Flat Cat Tak, flat-cat, golf-grips, jumbo/oversize, midsize, midsize-golf-grips, new arrivals, oversize, oversize-jumbo-golf-grips, overstock-mar2024, putter, putter grip, putter grip gift, putter-grip-gifts, putt",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "garsen-g-pro-3-sided-ultimate",
    "brand": "Garsen",
    "model": "G-Pro (3-Sided) Ultimate",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "PU / TPE (semi-tacky)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "paddle/pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://garsengolf.com/products/quad-tour"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/garsen-g-pro-3-sided-ultimate-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/garsen-ultimate-4colors.jpg?v=1637096323",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/garsen-g-pro-3-sided-ultimate-putter-grip",
        "handle": "garsen-g-pro-3-sided-ultimate-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Neon Green",
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "35969615367",
            "gid": "gid://shopify/ProductVariant/35969615367",
            "sku": "GSG-UM-BK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-3-sided-ultimate-putter-grip?variant=35969615367"
          },
          {
            "id": "39484760227901",
            "gid": "gid://shopify/ProductVariant/39484760227901",
            "sku": "GSG-UM-NG",
            "color": "Neon Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Neon Green"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-3-sided-ultimate-putter-grip?variant=39484760227901"
          },
          {
            "id": "35969615495",
            "gid": "gid://shopify/ProductVariant/35969615495",
            "sku": "GSG-UM-BU",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-3-sided-ultimate-putter-grip?variant=35969615495"
          },
          {
            "id": "35969615559",
            "gid": "gid://shopify/ProductVariant/35969615559",
            "sku": "GSG-UM-RD",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-3-sided-ultimate-putter-grip?variant=35969615559"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-newyear, 49 under, All Products, G-Pro Ultimate, garsen, golf-grips, mid-ov-putter-sale, midsize, midsize-golf-grips, New for 2016, non-tapered, putter, putter grip, single-grip, under-150, under-300, video=u3pILVEKrRU",
    "source_quality": "manufacturer_family",
    "source_url": "https://garsengolf.com/products/quad-tour",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "garsen-g-pro-edge",
    "brand": "Garsen",
    "model": "G-Pro Edge",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "PU / TPE (semi-tacky)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "paddle/pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://garsengolf.com/products/quad-tour"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 17.99,
    "price_max": 17.99,
    "single_price_min": 17.99,
    "single_price_max": 17.99,
    "normalized_price_per_grip": 17.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/garsen-g-pro-edge-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/g-pro-puttergrip-allcolors.jpg?v=1627121987",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 17.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/garsen-g-pro-edge-putter-grip",
        "handle": "garsen-g-pro-edge-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White",
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "896161189",
            "gid": "gid://shopify/ProductVariant/896161189",
            "sku": "GARSGPEBLK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 17.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-edge-putter-grip?variant=896161189"
          },
          {
            "id": "896166209",
            "gid": "gid://shopify/ProductVariant/896166209",
            "sku": "GARSGPEWHT",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 17.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-edge-putter-grip?variant=896166209"
          },
          {
            "id": "896166349",
            "gid": "gid://shopify/ProductVariant/896166349",
            "sku": "GARSGPEBLU",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 17.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-edge-putter-grip?variant=896166349"
          },
          {
            "id": "896166473",
            "gid": "gid://shopify/ProductVariant/896166473",
            "sku": "GARSGPERED",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 17.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-edge-putter-grip?variant=896166473"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, G-Pro Edge, garsen, golf-grips, putter, putter grip, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=u3pILVEKrRU",
    "source_quality": "manufacturer_family",
    "source_url": "https://garsengolf.com/products/quad-tour",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "garsen-g-pro-max",
    "brand": "Garsen",
    "model": "G-Pro Max",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "PU / TPE (semi-tacky)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "paddle/pistol",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://garsengolf.com/products/quad-tour"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black / Blue"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/garsen-g-pro-max-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/garsen-allcolors.jpg?v=1626798507",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black / Blue"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/garsen-g-pro-max-putter-grip",
        "handle": "garsen-g-pro-max-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Blue",
              "Black / White",
              "Black / Red",
              "Red / Black",
              "Blue / Black",
              "White / Black"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "27727823687",
            "gid": "gid://shopify/ProductVariant/27727823687",
            "sku": "GARSGPMBU",
            "color": "Black / Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Blue"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-max-putter-grip?variant=27727823687"
          },
          {
            "id": "896168853",
            "gid": "gid://shopify/ProductVariant/896168853",
            "sku": "GARSGPMBW",
            "color": "Black / White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / White"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-max-putter-grip?variant=896168853"
          },
          {
            "id": "27727842631",
            "gid": "gid://shopify/ProductVariant/27727842631",
            "sku": "GARSGPMBR",
            "color": "Black / Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-max-putter-grip?variant=27727842631"
          },
          {
            "id": "27727882247",
            "gid": "gid://shopify/ProductVariant/27727882247",
            "sku": "GARSGPMRB",
            "color": "Red / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red / Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-max-putter-grip?variant=27727882247"
          },
          {
            "id": "27727864327",
            "gid": "gid://shopify/ProductVariant/27727864327",
            "sku": "GARSGPMUB",
            "color": "Blue / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue / Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-max-putter-grip?variant=27727864327"
          },
          {
            "id": "896173721",
            "gid": "gid://shopify/ProductVariant/896173721",
            "sku": "GARSGPMWB",
            "color": "White / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White / Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-g-pro-max-putter-grip?variant=896173721"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-jan-overstock, 2022-newyear, 49 under, All Products, G-Pro Max, garsen, golf-grips, jumbo/oversize, laborday-2022, mid-ov-putter-sale, New for 2016, putter, putter grip, single-grip, summer-overstock-2022, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://garsengolf.com/products/quad-tour",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "garsen-max-15",
    "brand": "Garsen",
    "model": "Max 15\"",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "PU / TPE (semi-tacky)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "paddle/pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://garsengolf.com/products/quad-tour"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black / White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/garsen-max-15-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/garsen-allcolors_grande_5b0880b4-5798-4925-be0c-e8d1eeded34e.jpg?v=1627196195",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black / White"
        ],
        "price": 39.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/garsen-max-15-putter-grip",
        "handle": "garsen-max-15-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / White",
              "Black / Blue",
              "Black / Red",
              "Red / Black",
              "Blue / Black",
              "White / Black"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "35969311815",
            "gid": "gid://shopify/ProductVariant/35969311815",
            "sku": "GSG-MAX15-BW",
            "color": "Black / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-max-15-putter-grip?variant=35969311815"
          },
          {
            "id": "35969311879",
            "gid": "gid://shopify/ProductVariant/35969311879",
            "sku": "GSG-MAX15-BU",
            "color": "Black / Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Blue"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-max-15-putter-grip?variant=35969311879"
          },
          {
            "id": "35969311943",
            "gid": "gid://shopify/ProductVariant/35969311943",
            "sku": "GSG-MAX15-BR",
            "color": "Black / Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-max-15-putter-grip?variant=35969311943"
          },
          {
            "id": "35969312007",
            "gid": "gid://shopify/ProductVariant/35969312007",
            "sku": "GSG-MAX15-RB",
            "color": "Red / Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / Black"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-max-15-putter-grip?variant=35969312007"
          },
          {
            "id": "35969312071",
            "gid": "gid://shopify/ProductVariant/35969312071",
            "sku": "GSG-MAX15-UB",
            "color": "Blue / Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / Black"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-max-15-putter-grip?variant=35969312071"
          },
          {
            "id": "35969312135",
            "gid": "gid://shopify/ProductVariant/35969312135",
            "sku": "GSG-MAX15-WB",
            "color": "White / Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White / Black"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-max-15-putter-grip?variant=35969312135"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-newyear, 49 under, All Products, Counter Balance, G-Pro Max, garsen, golf-grips, jumbo/oversize, Max 15, mid-ov-putter-sale, New for 2016, oversize, oversize-jumbo-golf-grips, putter, putter grip, single-grip, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://garsengolf.com/products/quad-tour",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "garsen-quad-tour-proto-non-tapered",
    "brand": "Garsen",
    "model": "QUAD Tour PROTO Non-Tapered",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU / TPE (semi-tacky)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "no_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "paddle (4-sided)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://garsengolf.com/products/quad-tour"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red / Blue",
      "Tapered Putter Grip"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/garsen-quad-non-tapered-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/garsen-quad-straight-2-colors.jpg?v=1571438529",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red / Blue",
          "Tapered Putter Grip"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/garsen-quad-non-tapered-putter-grip",
        "handle": "garsen-quad-non-tapered-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / Blue",
              "Blue / Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "47130783187",
            "gid": "gid://shopify/ProductVariant/47130783187",
            "sku": "GS-QUAD-GR-504",
            "color": "Red / Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / Blue"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-quad-non-tapered-putter-grip?variant=47130783187"
          },
          {
            "id": "47130783251",
            "gid": "gid://shopify/ProductVariant/47130783251",
            "sku": "GS-QUAD-GR-505",
            "color": "Blue / Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / Red"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-quad-non-tapered-putter-grip?variant=47130783251"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-newyear, 49 under, All Products, G-Pro Edge, garsen, golf-grips, non-tapered, putter, putter grip, Quad, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=u3pILVEKrRU",
    "source_quality": "manufacturer_family",
    "source_url": "https://garsengolf.com/products/quad-tour",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "garsen-quad-tour-proto-tapered",
    "brand": "Garsen",
    "model": "QUAD Tour Proto Tapered",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU / TPE (semi-tacky)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "paddle (4-sided)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://garsengolf.com/products/quad-tour"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red / Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/garsen-quad-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/garsen-quad-tapered-2colors.jpg?v=1571438529",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red / Blue"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/garsen-quad-putter-grip",
        "handle": "garsen-quad-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / Blue",
              "Blue / Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "47130290131",
            "gid": "gid://shopify/ProductVariant/47130290131",
            "sku": "GS-QUAD-GR-501",
            "color": "Red / Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / Blue"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-quad-putter-grip?variant=47130290131"
          },
          {
            "id": "47130290195",
            "gid": "gid://shopify/ProductVariant/47130290195",
            "sku": "GS-QUAD-GR-502",
            "color": "Blue / Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / Red"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/garsen-quad-putter-grip?variant=47130290195"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-newyear, 49 under, All Products, G-Pro Edge, garsen, golf-grips, mid-ov-putter-sale, putter, putter grip, Quad, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=u3pILVEKrRU",
    "source_quality": "manufacturer_family",
    "source_url": "https://garsengolf.com/products/quad-tour",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "garsen-quad-tour-tapered-putter-grip-black",
    "brand": "Garsen",
    "model": "QUAD Tour Tapered Putter Grip (Black)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "PU / TPE (semi-tacky)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "paddle (4-sided)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://garsengolf.com/products/quad-tour"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/garsen-quad-tour-tapered-putter-grip-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/garsen-quad-black-1.jpg?v=1619626025",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/garsen-quad-tour-tapered-putter-grip-black",
        "handle": "garsen-quad-tour-tapered-putter-grip-black",
        "shopify_variants": [
          {
            "id": "39299776905277",
            "gid": "gid://shopify/ProductVariant/39299776905277",
            "sku": "GARS-GR503",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/garsen-quad-tour-tapered-putter-grip-black?variant=39299776905277"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2022-newyear, 49 under, All Products, G-Pro Edge, garsen, golf-grips, mid-ov-putter-sale, putter, putter grip, Quad, single-grip, standard, standard-size-golf-grips, under-150, under-300, video=u3pILVEKrRU",
    "source_quality": "manufacturer_family",
    "source_url": "https://garsengolf.com/products/quad-tour",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-honorary-starter-reverse-taper",
    "brand": "Golf Pride",
    "model": "Honorary Starter Reverse Taper",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "hybrid (cotton cord upper / rubber lower)",
    "texture": "part-corded hybrid",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reverse_taper",
    "texture_family": "partial_cord",
    "cord_coverage": "partial",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "maximum_wet",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Medium"
    ],
    "manufacturer_size_labels": [
      "Medium"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Pistol"
    ],
    "weight_g_by_size": {
      "Medium": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-honorary-starter-reverse-taper-putter-grip-pistol",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/gp-starter-RT-putter-1.jpg?v=1741831356",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Medium"
        ],
        "format": "single",
        "colors": [
          "Pistol"
        ],
        "price": 34.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-honorary-starter-reverse-taper-putter-grip-pistol",
        "handle": "golf-pride-honorary-starter-reverse-taper-putter-grip-pistol",
        "shopify_variants": [
          {
            "id": "51835011793266",
            "gid": "gid://shopify/ProductVariant/51835011793266",
            "sku": "RTPM-58R-GW3-XA",
            "color": "Pistol",
            "size": "Midsize",
            "selected_options": {
              "Size": "Medium"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-honorary-starter-reverse-taper-putter-grip-pistol?variant=51835011793266"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Medium"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, fathers-day-gifts, Golf Pride Putter, Golf Pride Putter Grip, golf pride reverse, golf pride reverse taper, golf pride reverse taper pistol, golf pride single grip, golf-grips, golf-pride, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, reverse taper g",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "MCC Plus4-based bundle",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-pro-only",
    "brand": "Golf Pride",
    "model": "PRO Only",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (cc-sized)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Red Star (72cc)"
    ],
    "manufacturer_size_labels": [
      "Red Star (72cc)"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Red Star (72cc)": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 19.99,
    "price_max": 19.99,
    "single_price_min": 19.99,
    "single_price_max": 19.99,
    "normalized_price_per_grip": 19.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-pro-only-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/gp-proonly-bluestar.jpg?v=1751584998",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Red Star (72cc)"
        ],
        "format": "single",
        "colors": [],
        "price": 19.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-pro-only-putter-grip",
        "handle": "golf-pride-pro-only-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Red Star (72cc)",
              "Green Star (88cc)",
              "Blue Star (81cc)"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "29478683803709",
            "gid": "gid://shopify/ProductVariant/29478683803709",
            "sku": "PO1S-58R-FZ0-XA",
            "color": "",
            "size": "Red Star (72cc)",
            "selected_options": {
              "Size": "Red Star (72cc)"
            },
            "available": true,
            "price": 19.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-pro-only-putter-grip?variant=29478683803709"
          },
          {
            "id": "29478683836477",
            "gid": "gid://shopify/ProductVariant/29478683836477",
            "sku": "PO2S-58R-FZ0-XA",
            "color": "",
            "size": "Red Star (72cc)",
            "selected_options": {
              "Size": "Green Star (88cc)"
            },
            "available": true,
            "price": 19.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-pro-only-putter-grip?variant=29478683836477"
          },
          {
            "id": "29478683869245",
            "gid": "gid://shopify/ProductVariant/29478683869245",
            "sku": "PO3S-58R-FZ0-XA",
            "color": "",
            "size": "Red Star (72cc)",
            "selected_options": {
              "Size": "Blue Star (81cc)"
            },
            "available": true,
            "price": 19.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-pro-only-putter-grip?variant=29478683869245"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, asbl-putter-grip-option, blue star, golf pride pro only, Golf Pride Putter, Golf Pride Putter Grip, golf pride single grip, golf-grips, golf-pride, green star, laborday-2022, mid-ov-putter-sale, overstock-oct-2022, overstock-oct-2023, Pro Only Putter Grip - COMING SOON, putte",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-pro-only-cord",
    "brand": "Golf Pride",
    "model": "PRO Only Cord",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "firm",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (cc-sized)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Red Star (72cc)"
    ],
    "manufacturer_size_labels": [
      "Red Star (72cc)"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Red Star (72cc)": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-pro-only-cord-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/proonlycord-700.jpg?v=1751584951",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Red Star (72cc)"
        ],
        "format": "single",
        "colors": [],
        "price": 24.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-pro-only-cord-putter-grip",
        "handle": "golf-pride-pro-only-cord-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Red Star (72cc)",
              "Green Star (88cc)",
              "Blue Star (81cc)"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "32898307653693",
            "gid": "gid://shopify/ProductVariant/32898307653693",
            "sku": "POC1-58R-D09-XA",
            "color": "",
            "size": "Red Star (72cc)",
            "selected_options": {
              "Size": "Red Star (72cc)"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-pro-only-cord-putter-grip?variant=32898307653693"
          },
          {
            "id": "32898307686461",
            "gid": "gid://shopify/ProductVariant/32898307686461",
            "sku": "POC2-58R-D09-XA",
            "color": "",
            "size": "Red Star (72cc)",
            "selected_options": {
              "Size": "Green Star (88cc)"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-pro-only-cord-putter-grip?variant=32898307686461"
          },
          {
            "id": "32898307719229",
            "gid": "gid://shopify/ProductVariant/32898307719229",
            "sku": "POC3-58R-D09-XA",
            "color": "",
            "size": "Red Star (72cc)",
            "selected_options": {
              "Size": "Blue Star (81cc)"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-pro-only-cord-putter-grip?variant=32898307719229"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, blue star, cord, cord putter, cord putter grip, cord-golf-grips, golf pride pro only, Golf Pride Putter, Golf Pride Putter Grip, golf pride single grip, golf-grips, golf-pride, golfers-gift-guide, green star, mid-ov-putter-sale, overstock-oct-2023, pro only cord, putter, putt",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-players-wrap",
    "brand": "Golf Pride",
    "model": "Players Wrap",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol/wrap",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 8.49,
    "price_max": 8.49,
    "single_price_min": 8.49,
    "single_price_max": 8.49,
    "normalized_price_per_grip": 8.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-players-wrap-putter-grip-black-std",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Golf_Pride_Players_Wrap_Putter_Grip_Black_Std.jpeg?v=1626917901",
    "fit_tags": [
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-players-wrap-putter-grip-black-std",
        "handle": "golf-pride-players-wrap-putter-grip-black-std",
        "shopify_variants": [
          {
            "id": "278001540",
            "gid": "gid://shopify/ProductVariant/278001540",
            "sku": "GPSP-58R-120-X00",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-players-wrap-putter-grip-black-std?variant=278001540"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, bundle, golf pride bundle, Golf Pride Putter, golf pride single grip, golf-grips, golf-pride, grip kit, paddle, putter, putter grips by golf pride, single-grip, standard, standard-size-golf-grips, under-150, under-300, wrap, wrap-style-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-reverse-taper",
    "brand": "Golf Pride",
    "model": "Reverse Taper",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "reverse_taper",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "reverse-taper (larger lower hand)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Small"
    ],
    "manufacturer_size_labels": [
      "Small"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Flat",
      "Pistol",
      "Round"
    ],
    "weight_g_by_size": {
      "Small": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-round-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/RT_Round_Medium_P1003047-1700.jpg?v=1751584768",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Small"
        ],
        "format": "single",
        "colors": [
          "Round"
        ],
        "price": 34.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-round-putter-grip",
        "handle": "golf-pride-reverse-taper-round-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Small",
              "Medium",
              "Large"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51829448049010",
            "gid": "gid://shopify/ProductVariant/51829448049010",
            "sku": "RTRS-58R-GW1-XA",
            "color": "Round",
            "size": "Undersize",
            "selected_options": {
              "Size": "Small"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-round-putter-grip?variant=51829448049010"
          },
          {
            "id": "41174340665405",
            "gid": "gid://shopify/ProductVariant/41174340665405",
            "sku": "RTRM-58R-GW1-XA",
            "color": "Round",
            "size": "Midsize",
            "selected_options": {
              "Size": "Medium"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-round-putter-grip?variant=41174340665405"
          },
          {
            "id": "41174340698173",
            "gid": "gid://shopify/ProductVariant/41174340698173",
            "sku": "RTRL-58R-GW1-XA",
            "color": "Round",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size": "Large"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-round-putter-grip?variant=41174340698173"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Small"
        ],
        "format": "single",
        "colors": [
          "Pistol"
        ],
        "price": 34.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-pistol-putter-grip",
        "handle": "golf-pride-reverse-taper-pistol-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Small",
              "Medium",
              "Large"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51830016737650",
            "gid": "gid://shopify/ProductVariant/51830016737650",
            "sku": "RTPS-58R-GW1-XA",
            "color": "Pistol",
            "size": "Undersize",
            "selected_options": {
              "Size": "Small"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-pistol-putter-grip?variant=51830016737650"
          },
          {
            "id": "41174340599869",
            "gid": "gid://shopify/ProductVariant/41174340599869",
            "sku": "RTPM-58R-GW1-XA",
            "color": "Pistol",
            "size": "Midsize",
            "selected_options": {
              "Size": "Medium"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-pistol-putter-grip?variant=41174340599869"
          },
          {
            "id": "41174340632637",
            "gid": "gid://shopify/ProductVariant/41174340632637",
            "sku": "RTPL-58R-GW1-XA",
            "color": "Pistol",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size": "Large"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-pistol-putter-grip?variant=41174340632637"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Small"
        ],
        "format": "single",
        "colors": [
          "Flat"
        ],
        "price": 34.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-flat-putter-grip",
        "handle": "golf-pride-reverse-taper-flat-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Small",
              "Medium",
              "Large"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51830031876466",
            "gid": "gid://shopify/ProductVariant/51830031876466",
            "sku": "RTFS-58R-GW1-XA",
            "color": "Flat",
            "size": "Undersize",
            "selected_options": {
              "Size": "Small"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-flat-putter-grip?variant=51830031876466"
          },
          {
            "id": "41174340534333",
            "gid": "gid://shopify/ProductVariant/41174340534333",
            "sku": "RTFM-58R-GW1-XA",
            "color": "Flat",
            "size": "Midsize",
            "selected_options": {
              "Size": "Medium"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-flat-putter-grip?variant=41174340534333"
          },
          {
            "id": "41174340567101",
            "gid": "gid://shopify/ProductVariant/41174340567101",
            "sku": "RTFL-58R-GW1-XA",
            "color": "Flat",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Size": "Large"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-reverse-taper-flat-putter-grip?variant=41174340567101"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, fathers-day-gifts, Golf Pride Putter, Golf Pride Putter Grip, golf pride reverse, golf pride reverse taper, golf pride reverse taper round, golf pride single grip, golf-grips, golf-pride, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, reverse taper gr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Round",
      "Pistol",
      "Flat"
    ]
  },
  {
    "id": "golf-pride-tour-classic",
    "brand": "Golf Pride",
    "model": "Tour Classic",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "all_weather",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9.49,
    "price_max": 9.49,
    "single_price_min": 9.49,
    "single_price_max": 9.49,
    "normalized_price_per_grip": 9.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-classic-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Golf_Pride_Tour_Classic_Black_Putter_Grip.jpg?v=1627078287",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 9.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-classic-black",
        "handle": "golf-pride-tour-classic-black",
        "shopify_variants": [
          {
            "id": "116724242",
            "gid": "gid://shopify/ProductVariant/116724242",
            "sku": "CLCP-58R-R1H-X0",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 9.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-classic-black?variant=116724242"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, bundle, golf pride bundle, Golf Pride Putter, golf pride single grip, golf-grips, golf-pride, grip kit, midsize, midsize-golf-grips, putter, single-grip, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-snsr-contour",
    "brand": "Golf Pride",
    "model": "Tour SNSR Contour",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "contour pistol",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "104cc"
    ],
    "manufacturer_size_labels": [
      "104cc"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "104cc": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 27.99,
    "price_max": 27.99,
    "single_price_min": 27.99,
    "single_price_max": 27.99,
    "normalized_price_per_grip": 27.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-snsr-contour-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/snsr-contour.jpg?v=1627109774",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "104cc"
        ],
        "format": "single",
        "colors": [],
        "price": 27.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-snsr-contour-putter-grip",
        "handle": "golf-pride-snsr-contour-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "104cc",
              "140cc"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "20611322567",
            "gid": "gid://shopify/ProductVariant/20611322567",
            "sku": "PC1M-58R-33RD-XA",
            "color": "",
            "size": "104cc",
            "selected_options": {
              "Size": "104cc"
            },
            "available": true,
            "price": 27.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-snsr-contour-putter-grip?variant=20611322567"
          },
          {
            "id": "20611322695",
            "gid": "gid://shopify/ProductVariant/20611322695",
            "sku": "PC1L-58R-33RD-XA",
            "color": "",
            "size": "104cc",
            "selected_options": {
              "Size": "140cc"
            },
            "available": true,
            "price": 27.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-snsr-contour-putter-grip?variant=20611322695"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, Golf Pride Putter, golf pride single grip, golf-grips, golf-pride, golfers-gift-guide, jumbo, jumbo/oversize, mid-ov-putter-sale, Most Popular Oversize Putter Grips, Most Popular Styles, oversize, oversize-jumbo-golf-grips, pistol, putter, single-grip, snsr, under-150, under-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-snsr-contour-pro",
    "brand": "Golf Pride",
    "model": "Tour SNSR Contour PRO",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "contour pistol",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "104cc"
    ],
    "manufacturer_size_labels": [
      "104cc"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "104cc": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 27.99,
    "price_max": 27.99,
    "single_price_min": 27.99,
    "single_price_max": 27.99,
    "normalized_price_per_grip": 27.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-snsr-contour-pro-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/web-snsr-contour-pro-quarter-104.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "104cc"
        ],
        "format": "single",
        "colors": [],
        "price": 27.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-tour-snsr-contour-pro-putter-grip",
        "handle": "golf-pride-tour-snsr-contour-pro-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "104cc",
              "140cc"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13973083291709",
            "gid": "gid://shopify/ProductVariant/13973083291709",
            "sku": "PP1M-58R-33GB-XA",
            "color": "",
            "size": "104cc",
            "selected_options": {
              "Size": "104cc"
            },
            "available": false,
            "price": 27.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-snsr-contour-pro-putter-grip?variant=13973083291709"
          },
          {
            "id": "13973083324477",
            "gid": "gid://shopify/ProductVariant/13973083324477",
            "sku": "PP1L-58R-33GB-XA",
            "color": "",
            "size": "104cc",
            "selected_options": {
              "Size": "140cc"
            },
            "available": false,
            "price": 27.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-snsr-contour-pro-putter-grip?variant=13973083324477"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, Golf Pride Putter, golf pride single grip, Golf Pride SNSR, golf-grips, golf-pride, golfers-gift-guide, jumbo, jumbo/oversize, mid-ov-putter-sale, Most Popular Oversize Putter Grips, Most Popular Styles, New 2019 Golf Grips, NEW Golf Pride 2019 Grips,",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-snsr-straight",
    "brand": "Golf Pride",
    "model": "Tour SNSR Straight",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "straight (no-taper)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "104cc"
    ],
    "manufacturer_size_labels": [
      "104cc"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "104cc": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 27.99,
    "price_max": 27.99,
    "single_price_min": 27.99,
    "single_price_max": 27.99,
    "normalized_price_per_grip": 27.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-snsr-straight-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/snsr-straight.jpeg?v=1627109190",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "104cc"
        ],
        "format": "single",
        "colors": [],
        "price": 27.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/golf-pride-tour-snsr-straight-putter-grip",
        "handle": "golf-pride-tour-snsr-straight-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "104cc",
              "140cc"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "20611318919",
            "gid": "gid://shopify/ProductVariant/20611318919",
            "sku": "PS1M-58R-33BL-XA",
            "color": "",
            "size": "104cc",
            "selected_options": {
              "Size": "104cc"
            },
            "available": true,
            "price": 27.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-snsr-straight-putter-grip?variant=20611318919"
          },
          {
            "id": "20611319175",
            "gid": "gid://shopify/ProductVariant/20611319175",
            "sku": "PS1L-58R-33BL-XA",
            "color": "",
            "size": "104cc",
            "selected_options": {
              "Size": "140cc"
            },
            "available": true,
            "price": 27.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-tour-snsr-straight-putter-grip?variant=20611319175"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, Golf Pride Putter, golf pride single grip, golf-grips, golf-pride, jumbo, jumbo/oversize, mid-ov-putter-sale, non-tapered, oversize, oversize-jumbo-golf-grips, putter, single-grip, snsr, under-150, under-300, video=MkEhJ2kF3fM",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-tradition",
    "brand": "Golf Pride",
    "model": "Tour Tradition",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 8.49,
    "price_max": 8.49,
    "single_price_min": 8.49,
    "single_price_max": 8.49,
    "normalized_price_per_grip": 8.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-tradition",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Golf_Pride_Tour_Tradition_Black_Putter_Grip.jpg?v=1627081086",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/golf-pride-tour-tradition",
        "handle": "golf-pride-tour-tradition",
        "shopify_variants": [
          {
            "id": "116724212",
            "gid": "gid://shopify/ProductVariant/116724212",
            "sku": "GOPP-58R-R1H-X0",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 8.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-tradition?variant=116724212"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, bundle, golf pride bundle, Golf Pride Putter, golf pride single grip, golf-grips, golf-pride, grip kit, putter, single-grip, standard, standard-size-golf-grips, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-tour-wrap",
    "brand": "Golf Pride",
    "model": "Tour Wrap",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "wrap",
    "feel": "soft",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "wrap",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Junior"
    ],
    "manufacturer_size_labels": [
      "Junior"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Junior": 49.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 7.5,
    "price_max": 7.5,
    "single_price_min": 7.5,
    "single_price_max": 7.5,
    "normalized_price_per_grip": 7.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-junior-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/new-tourwrapjunior-onemore-700.jpg?v=1637109138",
    "fit_tags": [
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Junior"
        ],
        "format": "single",
        "colors": [],
        "price": 7.5,
        "per_grip_g": 49.9,
        "total_g": 49.8951607,
        "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-junior-putter-grip",
        "handle": "golf-pride-tour-wrap-junior-putter-grip",
        "shopify_variants": [
          {
            "id": "39484794798141",
            "gid": "gid://shopify/ProductVariant/39484794798141",
            "sku": "JRP50-18-XC",
            "color": "",
            "size": "Junior",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": false,
            "price": 7.5,
            "weight_g": 49.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-tour-wrap-junior-putter-grip?variant=39484794798141"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, 58 core, added-11162021, All products, golf pride single grip, golf-pride, iron/wood, junior, junior-golf-grips, medium firm, putter, putter grip, single-grip, Size_Junior, Size_Undersize, Style_Putter Grip, under-150, undersize, undersize-golf-grips, undersize/junior putter, wrap, wrap-st",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-velvet-pro",
    "brand": "Golf Pride",
    "model": "Velvet Pro",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 3.7,
    "price_max": 3.7,
    "single_price_min": 3.7,
    "single_price_max": 3.7,
    "normalized_price_per_grip": 3.7,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-velvet-pro-series-putter",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Golf_Pride_Velvet_Pro_Series_Putter_54c9752a-b83e-48c3-a788-36ca9996ca55.jpg?v=1636051836",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 3.7,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/golf-pride-velvet-pro-series-putter",
        "handle": "golf-pride-velvet-pro-series-putter",
        "shopify_variants": [
          {
            "id": "39461786746941",
            "gid": "gid://shopify/ProductVariant/39461786746941",
            "sku": "VSP-58R-19-X00",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default"
            },
            "available": true,
            "price": 3.7,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/golf-pride-velvet-pro-series-putter?variant=39461786746941"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Brand_Golf Pride, golf pride single grip, golf-pride, putter, putter-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "golf-pride-zero-taper",
    "brand": "Golf Pride",
    "model": "Zero Taper",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "round (zero-taper)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html"
    ],
    "sizes_available": [
      "Large"
    ],
    "manufacturer_size_labels": [
      "Large"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "black-white-red"
    ],
    "weight_g_by_size": {
      "Large": 122.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/golf-pride-zero-taper-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ZT_Blkwhite_Front_view-1800.jpg?v=1771290144",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Large"
        ],
        "format": "single",
        "colors": [
          "black-white-red"
        ],
        "price": 34.99,
        "per_grip_g": 122.5,
        "total_g": 122.4699399,
        "url": "https://www.grips4less.com/products/golf-pride-zero-taper-putter-grip",
        "handle": "golf-pride-zero-taper-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Large",
              "Medium"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61502765498738",
            "gid": "gid://shopify/ProductVariant/61502765498738",
            "sku": "ZTSL-58R-BW4-XA",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Large"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 122.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-zero-taper-putter-grip?variant=61502765498738"
          },
          {
            "id": "61502810521970",
            "gid": "gid://shopify/ProductVariant/61502810521970",
            "sku": "ZTSM-58R-BW4-XA",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Medium"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 122.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-zero-taper-putter-grip?variant=61502810521970"
          },
          {
            "id": "61502810587506",
            "gid": "gid://shopify/ProductVariant/61502810587506",
            "sku": "ZTSM-58R-GW4-XA",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Medium"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 122.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-zero-taper-putter-grip?variant=61502810587506"
          },
          {
            "id": "61502810653042",
            "gid": "gid://shopify/ProductVariant/61502810653042",
            "sku": "ZTSM-58R-GW2-XA",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Medium"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 122.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/golf-pride-zero-taper-putter-grip?variant=61502810653042"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, Counter Balance, evnroll-gravity, fathers-day-gifts, Golf Pride Putter Grip, Golf Pride zero taper, Golf pride zero taper putter grip, golf-grips, golfers-gift-guide, july4-2022, mid-ov-putter-sale, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, singl",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfpride.com/us/en-us/customer-service-hub/grip-advice/grip-specifications.html",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red",
      "Blue"
    ]
  },
  {
    "id": "iomic-17-unit-belly",
    "brand": "Iomic",
    "model": "17\" Unit Belly",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 19.99,
    "price_max": 19.99,
    "single_price_min": 19.99,
    "single_price_max": 19.99,
    "normalized_price_per_grip": 19.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-unit.jpg?v=1752715276",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 19.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip",
        "handle": "iomic-unit-belly-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red",
              "Black / White",
              "Yellow / Green / Yellow",
              "Green / Orange / Green",
              "Orange / Yellow / Orange",
              "Blue / Light Blue / Blue",
              "White / Red / White",
              "Blue",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "322931619",
            "gid": "gid://shopify/ProductVariant/322931619",
            "sku": "GRIP0BR",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip?variant=322931619"
          },
          {
            "id": "13816699486269",
            "gid": "gid://shopify/ProductVariant/13816699486269",
            "sku": "GRIP0BBW",
            "color": "Black / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White"
            },
            "available": false,
            "price": 19,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip?variant=13816699486269"
          },
          {
            "id": "23395001927",
            "gid": "gid://shopify/ProductVariant/23395001927",
            "sku": "GRIP0YGY",
            "color": "Yellow / Green / Yellow",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow / Green / Yellow"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip?variant=23395001927"
          },
          {
            "id": "23395035975",
            "gid": "gid://shopify/ProductVariant/23395035975",
            "sku": "GRIP0GOG",
            "color": "Green / Orange / Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green / Orange / Green"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip?variant=23395035975"
          },
          {
            "id": "23395024391",
            "gid": "gid://shopify/ProductVariant/23395024391",
            "sku": "GRIP0OYO",
            "color": "Orange / Yellow / Orange",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange / Yellow / Orange"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip?variant=23395024391"
          },
          {
            "id": "322931623",
            "gid": "gid://shopify/ProductVariant/322931623",
            "sku": "GRIP0BBSB",
            "color": "Blue / Light Blue / Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / Light Blue / Blue"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip?variant=322931623"
          },
          {
            "id": "322931625",
            "gid": "gid://shopify/ProductVariant/322931625",
            "sku": "GRIP0BWRW",
            "color": "White / Red / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White / Red / White"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip?variant=322931625"
          },
          {
            "id": "322931627",
            "gid": "gid://shopify/ProductVariant/322931627",
            "sku": "GRIP0BU",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip?variant=322931627"
          },
          {
            "id": "14012120327",
            "gid": "gid://shopify/ProductVariant/14012120327",
            "sku": "GRIP0BW",
            "color": "White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-unit-belly-putter-grip?variant=14012120327"
          }
        ],
        "shopify_variant_count": 9,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "17\", 49 under, All Products, belly, golf-grips, infinite-opt-addkit, iomic, long, single-grip, under-150, under-300, uv resistant",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-army-camo-putter-65g",
    "brand": "Iomic",
    "model": "ARMY Camo Putter 65g",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black / Red"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 15.5,
    "price_max": 15.5,
    "single_price_min": 15.5,
    "single_price_max": 15.5,
    "normalized_price_per_grip": 15.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-putter-army-standard-65g-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Screenshot_2026-01-12_at_2.24.43_PM.png?v=1768259064",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black / Red"
        ],
        "price": 15.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-putter-army-standard-65g-grip",
        "handle": "iomic-putter-army-standard-65g-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red",
              "Light Blue / Dark Blue",
              "Light Green / Army Green",
              "Light Pink/ Hot Pink",
              "White/ Grey",
              "Black / Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31806846500925",
            "gid": "gid://shopify/ProductVariant/31806846500925",
            "sku": "PGBKARMYCR",
            "color": "Black / Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-army-standard-65g-grip?variant=31806846500925"
          },
          {
            "id": "39261708681277",
            "gid": "gid://shopify/ProductVariant/39261708681277",
            "sku": "GRIPARMBLU",
            "color": "Light Blue / Dark Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Light Blue / Dark Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-army-standard-65g-grip?variant=39261708681277"
          },
          {
            "id": "61494762865010",
            "gid": "gid://shopify/ProductVariant/61494762865010",
            "sku": "PGARMY65GRN",
            "color": "Light Green / Army Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Light Green / Army Green",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-army-standard-65g-grip?variant=61494762865010"
          },
          {
            "id": "61494762897778",
            "gid": "gid://shopify/ProductVariant/61494762897778",
            "sku": "PGARMY65PK",
            "color": "Light Pink/ Hot Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Light Pink/ Hot Pink",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-army-standard-65g-grip?variant=61494762897778"
          },
          {
            "id": "61494762930546",
            "gid": "gid://shopify/ProductVariant/61494762930546",
            "sku": "GRIPARMGY",
            "color": "White/ Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "White/ Grey",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-army-standard-65g-grip?variant=61494762930546"
          },
          {
            "id": "61494764929394",
            "gid": "gid://shopify/ProductVariant/61494764929394",
            "sku": "PGBKARMYLB",
            "color": "Black / Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Black / Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-army-standard-65g-grip?variant=61494764929394"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, army camo, golf-grips, iomic, iomic army, iomic camo, putter, putter grip, putter-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, uv resistant, uv-resistant-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Red",
      "Light Blue / Dark Blue",
      "Light Green / Army Green",
      "Light Pink/ Hot Pink",
      "White/ Grey"
    ]
  },
  {
    "id": "iomic-absolute",
    "brand": "Iomic",
    "model": "Absolute",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Oversize / Jumbo"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 27,
    "price_max": 27,
    "single_price_min": 27,
    "single_price_max": 27,
    "normalized_price_per_grip": 27,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-absolute-jumbo-putter",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/absolute-jumbo-putter-allcolors.png?v=1752715281",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 27,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-absolute-jumbo-putter",
        "handle": "iomic-absolute-jumbo-putter",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red",
              "Blue",
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize / Jumbo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "297252889",
            "gid": "gid://shopify/ProductVariant/297252889",
            "sku": "GRIP01JAR",
            "color": "Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 27,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-jumbo-putter?variant=297252889"
          },
          {
            "id": "297252903",
            "gid": "gid://shopify/ProductVariant/297252903",
            "sku": "GRIP01JAU",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 27,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-jumbo-putter?variant=297252903"
          },
          {
            "id": "297252905",
            "gid": "gid://shopify/ProductVariant/297252905",
            "sku": "GRIP01JAB",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 27,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-jumbo-putter?variant=297252905"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, golf-grips, iomic, jumbo/oversize, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, single-grip, under-150, under-300, uv resistant, uv-resistant-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red",
      "Blue"
    ]
  },
  {
    "id": "iomic-absolute-x",
    "brand": "Iomic",
    "model": "Absolute X",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Sky Blue"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 15.5,
    "price_max": 15.5,
    "single_price_min": 15.5,
    "single_price_max": 15.5,
    "normalized_price_per_grip": 15.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-absolute-putter",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/abs-x-putter-allcolors_902995b0-3b6f-4462-baed-a8b8f6ac0c00.png?v=1752715284",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Sky Blue"
        ],
        "price": 15.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-absolute-putter",
        "handle": "iomic-absolute-putter",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Sky Blue",
              "Blue",
              "White",
              "Yellow",
              "Mint Green",
              "Orange",
              "Black",
              "Lavender",
              "Pink",
              "Coral Red"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "297252279",
            "gid": "gid://shopify/ProductVariant/297252279",
            "sku": "GRIP0ASB",
            "color": "Sky Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=297252279"
          },
          {
            "id": "297252281",
            "gid": "gid://shopify/ProductVariant/297252281",
            "sku": "GRIP0ABL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=297252281"
          },
          {
            "id": "297252277",
            "gid": "gid://shopify/ProductVariant/297252277",
            "sku": "GRIP0AW",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=297252277"
          },
          {
            "id": "297252273",
            "gid": "gid://shopify/ProductVariant/297252273",
            "sku": "GRIP0AY",
            "color": "Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "Yellow"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=297252273"
          },
          {
            "id": "297252275",
            "gid": "gid://shopify/ProductVariant/297252275",
            "sku": "GRIP0AG",
            "color": "Mint Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Mint Green"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=297252275"
          },
          {
            "id": "297252269",
            "gid": "gid://shopify/ProductVariant/297252269",
            "sku": "GRIP0AO",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=297252269"
          },
          {
            "id": "39420141699133",
            "gid": "gid://shopify/ProductVariant/39420141699133",
            "sku": "GRIP0AB",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=39420141699133"
          },
          {
            "id": "39420141764669",
            "gid": "gid://shopify/ProductVariant/39420141764669",
            "sku": "GRIP0AL",
            "color": "Lavender",
            "size": "Standard",
            "selected_options": {
              "Color": "Lavender"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=39420141764669"
          },
          {
            "id": "39420141797437",
            "gid": "gid://shopify/ProductVariant/39420141797437",
            "sku": "GRIP0ABP",
            "color": "Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Pink"
            },
            "available": false,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=39420141797437"
          },
          {
            "id": "39420141862973",
            "gid": "gid://shopify/ProductVariant/39420141862973",
            "sku": "GRIP0AR",
            "color": "Coral Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Coral Red"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-absolute-putter?variant=39420141862973"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, absolute, All Products, fathers-day-gifts, golf-grips, iomic, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, uv resistant, uv-resistant-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Sky Blue",
      "Blue",
      "White",
      "Yellow",
      "Mint Green",
      "Orange",
      "Black",
      "Lavender",
      "Coral Red"
    ]
  },
  {
    "id": "iomic-i-classic",
    "brand": "Iomic",
    "model": "I-Classic",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Coral Red"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 14,
    "price_max": 14,
    "single_price_min": 14,
    "single_price_max": 14,
    "normalized_price_per_grip": 14,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-iclassic-standard-putter-collection.jpg?v=1752715265",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Coral Red"
        ],
        "price": 14,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip",
        "handle": "iomic-i-classic-standard-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Coral Red",
              "Mint Green",
              "White",
              "Black",
              "Pink",
              "Blue",
              "Lavender",
              "Orange"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "714003341",
            "gid": "gid://shopify/ProductVariant/714003341",
            "sku": "ICLARED",
            "color": "Coral Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Coral Red"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip?variant=714003341"
          },
          {
            "id": "714003361",
            "gid": "gid://shopify/ProductVariant/714003361",
            "sku": "ICLAGRN",
            "color": "Mint Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Mint Green"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip?variant=714003361"
          },
          {
            "id": "714003369",
            "gid": "gid://shopify/ProductVariant/714003369",
            "sku": "ICLAWHT",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip?variant=714003369"
          },
          {
            "id": "714003381",
            "gid": "gid://shopify/ProductVariant/714003381",
            "sku": "ICLABLK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip?variant=714003381"
          },
          {
            "id": "714016461",
            "gid": "gid://shopify/ProductVariant/714016461",
            "sku": "ICLAPINK",
            "color": "Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Pink"
            },
            "available": false,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip?variant=714016461"
          },
          {
            "id": "714017233",
            "gid": "gid://shopify/ProductVariant/714017233",
            "sku": "ICLABLU",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip?variant=714017233"
          },
          {
            "id": "714017445",
            "gid": "gid://shopify/ProductVariant/714017445",
            "sku": "ICLALAV",
            "color": "Lavender",
            "size": "Standard",
            "selected_options": {
              "Color": "Lavender"
            },
            "available": false,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip?variant=714017445"
          },
          {
            "id": "886228058131",
            "gid": "gid://shopify/ProductVariant/886228058131",
            "sku": "ICLAORG",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange"
            },
            "available": true,
            "price": 14,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-standard-putter-grip?variant=886228058131"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, gifts-for-her, golf-grips, iomic, ladies, New for 2014, pistol, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, undersize, undersize-golf-grips, undersize/j",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Coral Red",
      "Mint Green",
      "Orange"
    ]
  },
  {
    "id": "iomic-i-classic-pistol",
    "brand": "Iomic",
    "model": "I-Classic Pistol",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 18,
    "price_max": 18,
    "single_price_min": 18,
    "single_price_max": 18,
    "normalized_price_per_grip": 18,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-i-classic-midsize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-iclassic-midsize-3colors.jpg?v=1752715240",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 18,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-i-classic-midsize-putter-grip",
        "handle": "iomic-i-classic-midsize-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Coral Red",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "35925102215",
            "gid": "gid://shopify/ProductVariant/35925102215",
            "sku": "ICMDBLK",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 18,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-midsize-putter-grip?variant=35925102215"
          },
          {
            "id": "35925102279",
            "gid": "gid://shopify/ProductVariant/35925102279",
            "sku": "ICMDRED",
            "color": "Coral Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Coral Red"
            },
            "available": true,
            "price": 18,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-midsize-putter-grip?variant=35925102279"
          },
          {
            "id": "35965195847",
            "gid": "gid://shopify/ProductVariant/35965195847",
            "sku": "ICMDBLU",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 18,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-i-classic-midsize-putter-grip?variant=35965195847"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, golf-grips, iomic, midsize, midsize-golf-grips, New for 2014, New for 2016, pistol, putter, putter grip, putter-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300, uv resistant, uv-resistant-golf-grips, womens",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Coral Red",
      "Blue"
    ]
  },
  {
    "id": "iomic-opus-1",
    "brand": "Iomic",
    "model": "Opus 1",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 8,
    "price_max": 8,
    "single_price_min": 8,
    "single_price_max": 8,
    "normalized_price_per_grip": 8,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-art-series-opus-putter-midsize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/opus-1-new2.jpg?v=1752715291",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue/White"
        ],
        "price": 8,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-art-series-opus-putter-midsize-grip",
        "handle": "iomic-art-series-opus-putter-midsize-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue/White",
              "Red/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "282841240",
            "gid": "gid://shopify/ProductVariant/282841240",
            "sku": "GRIP1MBW",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": false,
            "price": 8,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-art-series-opus-putter-midsize-grip?variant=282841240"
          },
          {
            "id": "282841236",
            "gid": "gid://shopify/ProductVariant/282841236",
            "sku": "GRIP1MRW",
            "color": "Red/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White"
            },
            "available": false,
            "price": 8,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-art-series-opus-putter-midsize-grip?variant=282841236"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, infinite-opt-addkit, iomic, opus, single-grip, standard, standard-size-golf-grips, under-150, under-300, uv resistant",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "iomic-putter-65g",
    "brand": "Iomic",
    "model": "Putter 65g",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Milk Pink"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 15.5,
    "price_max": 15.5,
    "single_price_min": 15.5,
    "single_price_max": 15.5,
    "normalized_price_per_grip": 15.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/putter_allcolors.png?v=1752715295",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Milk Pink"
        ],
        "price": 15.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1",
        "handle": "iomic-putter-standard-grip-1",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Milk Pink",
              "Blue",
              "Black",
              "Yellow",
              "White",
              "Red",
              "Mint Green",
              "Orange",
              "Sky Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "295076225",
            "gid": "gid://shopify/ProductVariant/295076225",
            "sku": "GRIP0MPMMPK",
            "color": "Milk Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Milk Pink",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1?variant=295076225"
          },
          {
            "id": "210513613",
            "gid": "gid://shopify/ProductVariant/210513613",
            "sku": "GRIP0MBU",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1?variant=210513613"
          },
          {
            "id": "210513583",
            "gid": "gid://shopify/ProductVariant/210513583",
            "sku": "GRIP0MBK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1?variant=210513583"
          },
          {
            "id": "295076499",
            "gid": "gid://shopify/ProductVariant/295076499",
            "sku": "GRIP0MY",
            "color": "Yellow",
            "size": "Standard",
            "selected_options": {
              "Color": "Yellow",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1?variant=295076499"
          },
          {
            "id": "210513609",
            "gid": "gid://shopify/ProductVariant/210513609",
            "sku": "GRIP0MWH",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1?variant=210513609"
          },
          {
            "id": "210513603",
            "gid": "gid://shopify/ProductVariant/210513603",
            "sku": "GRIP0MRD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1?variant=210513603"
          },
          {
            "id": "210513617",
            "gid": "gid://shopify/ProductVariant/210513617",
            "sku": "GRIP0MMG",
            "color": "Mint Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Mint Green",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1?variant=210513617"
          },
          {
            "id": "210513607",
            "gid": "gid://shopify/ProductVariant/210513607",
            "sku": "GRIP0MOR",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1?variant=210513607"
          },
          {
            "id": "295076885",
            "gid": "gid://shopify/ProductVariant/295076885",
            "sku": "GRIP0MSBL",
            "color": "Sky Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Sky Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-standard-grip-1?variant=295076885"
          }
        ],
        "shopify_variant_count": 9,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, asbl-putter-grip-option, golf-grips, iomic, laborday-2022, putter, putter grip, putter-grips, single-grip, standard, standard-size-golf-grips, summer-overstock-2022, under-150, under-300, uv resistant, uv-resistant-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Milk Pink",
      "Black",
      "Yellow",
      "Red",
      "Mint Green",
      "Orange",
      "Sky Blue"
    ]
  },
  {
    "id": "iomic-putter-75g",
    "brand": "Iomic",
    "model": "Putter 75g",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Milk Pink"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 17,
    "price_max": 17,
    "single_price_min": 17,
    "single_price_max": 17,
    "normalized_price_per_grip": 17,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-putter-midsize-75g.jpg?v=1752715292",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Milk Pink"
        ],
        "price": 17,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1",
        "handle": "iomic-putter-midsize-grip-1",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Milk Pink",
              "Blue",
              "Black",
              "Yellow",
              "White",
              "Red",
              "Mint Green",
              "Orange",
              "Sky Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "295074649",
            "gid": "gid://shopify/ProductVariant/295074649",
            "sku": "GRIP0LMP",
            "color": "Milk Pink",
            "size": "Midsize",
            "selected_options": {
              "Color": "Milk Pink",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 17,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1?variant=295074649"
          },
          {
            "id": "282840458",
            "gid": "gid://shopify/ProductVariant/282840458",
            "sku": "GRIP0LBL",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 17,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1?variant=282840458"
          },
          {
            "id": "282840450",
            "gid": "gid://shopify/ProductVariant/282840450",
            "sku": "GRIP0LBK",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 17,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1?variant=282840450"
          },
          {
            "id": "295074169",
            "gid": "gid://shopify/ProductVariant/295074169",
            "sku": "GRIP0LLY",
            "color": "Yellow",
            "size": "Midsize",
            "selected_options": {
              "Color": "Yellow",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 17,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1?variant=295074169"
          },
          {
            "id": "282840456",
            "gid": "gid://shopify/ProductVariant/282840456",
            "sku": "GRIP0LW",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 17,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1?variant=282840456"
          },
          {
            "id": "297241357",
            "gid": "gid://shopify/ProductVariant/297241357",
            "sku": "GRIP0LRD",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 17,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1?variant=297241357"
          },
          {
            "id": "282840460",
            "gid": "gid://shopify/ProductVariant/282840460",
            "sku": "GRIP0LMG",
            "color": "Mint Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Mint Green",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 17,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1?variant=282840460"
          },
          {
            "id": "282840454",
            "gid": "gid://shopify/ProductVariant/282840454",
            "sku": "GRIP0LO",
            "color": "Orange",
            "size": "Midsize",
            "selected_options": {
              "Color": "Orange",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 17,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1?variant=282840454"
          },
          {
            "id": "6942134566973",
            "gid": "gid://shopify/ProductVariant/6942134566973",
            "sku": "GRIP0LSBL",
            "color": "Sky Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Sky Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 17,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-putter-midsize-grip-1?variant=6942134566973"
          }
        ],
        "shopify_variant_count": 9,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, golf-grips, iomic, midsize, midsize-golf-grips, putter, putter grip, putter-grips, single-grip, under-150, under-300, uv resistant, uv-resistant-golf-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Milk Pink",
      "Blue",
      "Black",
      "White",
      "Red",
      "Mint Green",
      "Orange",
      "Sky Blue"
    ]
  },
  {
    "id": "iomic-sticky-putter-60g",
    "brand": "Iomic",
    "model": "Sticky Putter 60g",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "elastomer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.iomicusa.com/products/sticky-1-8"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 15.5,
    "price_max": 15.5,
    "single_price_min": 15.5,
    "single_price_max": 15.5,
    "normalized_price_per_grip": 15.5,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/iomic-sticky-putter-standard-65g-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/iomic-sticky-putter65-allcolors.jpg?v=1752715254",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 15.5,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/iomic-sticky-putter-standard-65g-grip",
        "handle": "iomic-sticky-putter-standard-65g-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Black",
              "Coral Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "18967587271",
            "gid": "gid://shopify/ProductVariant/18967587271",
            "sku": "STPTBL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-putter-standard-65g-grip?variant=18967587271"
          },
          {
            "id": "18967587399",
            "gid": "gid://shopify/ProductVariant/18967587399",
            "sku": "STPTBK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-putter-standard-65g-grip?variant=18967587399"
          },
          {
            "id": "18967587847",
            "gid": "gid://shopify/ProductVariant/18967587847",
            "sku": "STPTRD",
            "color": "Coral Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Coral Red"
            },
            "available": true,
            "price": 15.5,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/iomic-sticky-putter-standard-65g-grip?variant=18967587847"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, golf-grips, iomic, putter, putter grip, single-grip, standard, standard-size-golf-grips, sticky, under-150, under-300, uv resistant",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.iomicusa.com/products/sticky-1-8",
    "last_verified_date": "",
    "manual_notes": "softest/tackiest; tacky in wet",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "Coral Red"
    ]
  },
  {
    "id": "jumbomax-jmx-armlock-21",
    "brand": "JumboMax",
    "model": "JMX ArmLock 21\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-armlock-21-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumbomax-21-armlock-redwhiteblue.jpg?v=1576905050",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red/White/Blue"
        ],
        "price": 29.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-armlock-21-putter-grip",
        "handle": "jumbomax-jmx-armlock-21-putter-grip",
        "shopify_options": [
          {
            "name": "Shape",
            "values": [
              "Pistol",
              "Round"
            ]
          },
          {
            "name": "Color",
            "values": [
              "Red/White/Blue",
              "White/Black/Silver",
              "White/Blue/Silver"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31469117964349",
            "gid": "gid://shopify/ProductVariant/31469117964349",
            "sku": "JMX340-1000",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Shape": "Pistol",
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-armlock-21-putter-grip?variant=31469117964349"
          },
          {
            "id": "31469118029885",
            "gid": "gid://shopify/ProductVariant/31469118029885",
            "sku": "JMX340-3000",
            "color": "White/Black/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Shape": "Pistol",
              "Color": "White/Black/Silver"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-armlock-21-putter-grip?variant=31469118029885"
          },
          {
            "id": "31469118062653",
            "gid": "gid://shopify/ProductVariant/31469118062653",
            "sku": "JMX340-7000",
            "color": "White/Blue/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Shape": "Pistol",
              "Color": "White/Blue/Silver"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-armlock-21-putter-grip?variant=31469118062653"
          },
          {
            "id": "41372047245373",
            "gid": "gid://shopify/ProductVariant/41372047245373",
            "sku": "JMX350-1000",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Shape": "Round",
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-armlock-21-putter-grip?variant=41372047245373"
          },
          {
            "id": "41372047278141",
            "gid": "gid://shopify/ProductVariant/41372047278141",
            "sku": "JMX350-3000",
            "color": "White/Black/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Shape": "Round",
              "Color": "White/Black/Silver"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-armlock-21-putter-grip?variant=41372047278141"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "21\", 49 under, All Products, arm lock, arm lock putter grip, belly, bryson, Counter Balance, golf-grips, JMX 21, jumbo/oversize, jumboflat, jumboflat xl, jumbomax, JumboMax 21, JumboMax Putter, jumbomax xl, long, Long Putter, Long/Belly Putter, Medium, putter, putter grip, putter-grips, rubber, sing",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black/Silver",
      "White/Blue/Silver"
    ]
  },
  {
    "id": "jumbomax-jmx-jumboflat-xl-17",
    "brand": "JumboMax",
    "model": "JMX JUMBOFLAT XL 17\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat-front",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-jumboflat-xl-17-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/jumboflat-teamusa.jpg?v=1720113573",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red/White/Blue"
        ],
        "price": 29.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-jumboflat-xl-17-putter-grip",
        "handle": "jumbomax-jmx-jumboflat-xl-17-putter-grip",
        "shopify_variants": [
          {
            "id": "13992788525117",
            "gid": "gid://shopify/ProductVariant/13992788525117",
            "sku": "JMX330-1000",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-jumboflat-xl-17-putter-grip?variant=13992788525117"
          },
          {
            "id": "31469060915261",
            "gid": "gid://shopify/ProductVariant/31469060915261",
            "sku": "JMX330-1400",
            "color": "Team USA (Red/White/Blue)",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Team USA (Red/White/Blue)"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-jumboflat-xl-17-putter-grip?variant=31469060915261"
          },
          {
            "id": "13992788557885",
            "gid": "gid://shopify/ProductVariant/13992788557885",
            "sku": "JMX330-3000",
            "color": "White/Black/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black/Silver"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-jumboflat-xl-17-putter-grip?variant=13992788557885"
          },
          {
            "id": "31002164854845",
            "gid": "gid://shopify/ProductVariant/31002164854845",
            "sku": "JMX330-4000",
            "color": "Black/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/Silver"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-jumboflat-xl-17-putter-grip?variant=31002164854845"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red/White/Blue",
              "Team USA (Red/White/Blue)",
              "White/Black/Silver",
              "Black/Silver"
            ]
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, arm lock, arm lock putter grip, belly, bryson, Counter Balance, fathers-day-gifts, golf-grips, golfers-gift-guide, jmx 17, july4-2022, jumbo/oversize, jumboflat, jumboflat 17, jumboflat xl, jumbomax, jumbomax 17, JumboMax Putter, jumbomax xl, long, Long Putter, Long/Belly Put",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Team USA (Red/White/Blue)",
      "White/Black/Silver",
      "Black/Silver"
    ]
  },
  {
    "id": "jumbomax-jmx-palmbird-pistol",
    "brand": "JumboMax",
    "model": "JMX Palmbird Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/Silver"
    ],
    "weight_g_by_size": {
      "Unspecified": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 23.99,
    "price_max": 23.99,
    "single_price_min": 23.99,
    "single_price_max": 23.99,
    "normalized_price_per_grip": 23.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-palmbird-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-palmbird-1.jpg?v=1698456534",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/Silver"
        ],
        "price": 23.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-palmbird-pistol-putter-grip",
        "handle": "jumbomax-jmx-palmbird-pistol-putter-grip",
        "shopify_variants": [
          {
            "id": "40825794494525",
            "gid": "gid://shopify/ProductVariant/40825794494525",
            "sku": "JMX380-6000",
            "color": "Black/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/Silver"
            },
            "available": true,
            "price": 23.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-palmbird-pistol-putter-grip?variant=40825794494525"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/Silver"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, jumbo/oversize, jumbomax, JumboMax Non-Tapered, jumbomax palmbird, jumbomax pistol, jumbomax pistol putter, JumboMax Putter, Less Tapered, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize-size-golf-grips, oversize/jumbo, Pistol Claw,",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/Silver"
    ]
  },
  {
    "id": "jumbomax-jmx-pistol",
    "brand": "JumboMax",
    "model": "JMX Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://jumbomax.com/products/tour-series",
      "https://jumbomax.com/pages/sizing"
    ],
    "sizes_available": [
      "Pro"
    ],
    "manufacturer_size_labels": [
      "Pro"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Pro": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 23.99,
    "price_max": 23.99,
    "single_price_min": 23.99,
    "single_price_max": 23.99,
    "normalized_price_per_grip": 23.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-jmx-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-pistol-mid-rwb.jpg?v=1698455057",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Pro"
        ],
        "format": "single",
        "colors": [
          "Red/White/Blue"
        ],
        "price": 23.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-jmx-pistol-putter-grip",
        "handle": "jumbomax-jmx-pistol-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red/White/Blue",
              "Blackout",
              "Black/Lime Green"
            ]
          },
          {
            "name": "Size",
            "values": [
              "Pro",
              "Mid"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40825760088125",
            "gid": "gid://shopify/ProductVariant/40825760088125",
            "sku": "JMX360-8000",
            "color": "Red/White/Blue",
            "size": "Pro",
            "selected_options": {
              "Color": "Red/White/Blue",
              "Size": "Pro"
            },
            "available": true,
            "price": 23.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-pistol-putter-grip?variant=40825760088125"
          },
          {
            "id": "40825784795197",
            "gid": "gid://shopify/ProductVariant/40825784795197",
            "sku": "JMX370-8000",
            "color": "Red/White/Blue",
            "size": "Pro",
            "selected_options": {
              "Color": "Red/White/Blue",
              "Size": "Mid"
            },
            "available": false,
            "price": 23.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-pistol-putter-grip?variant=40825784795197"
          },
          {
            "id": "40825760022589",
            "gid": "gid://shopify/ProductVariant/40825760022589",
            "sku": "JMX360-6000",
            "color": "Blackout",
            "size": "Pro",
            "selected_options": {
              "Color": "Blackout",
              "Size": "Pro"
            },
            "available": true,
            "price": 23.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-pistol-putter-grip?variant=40825760022589"
          },
          {
            "id": "40825784827965",
            "gid": "gid://shopify/ProductVariant/40825784827965",
            "sku": "JMX370-6000",
            "color": "Blackout",
            "size": "Pro",
            "selected_options": {
              "Color": "Blackout",
              "Size": "Mid"
            },
            "available": false,
            "price": 23.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-pistol-putter-grip?variant=40825784827965"
          },
          {
            "id": "40825760055357",
            "gid": "gid://shopify/ProductVariant/40825760055357",
            "sku": "JMX360-2000",
            "color": "Black/Lime Green",
            "size": "Pro",
            "selected_options": {
              "Color": "Black/Lime Green",
              "Size": "Pro"
            },
            "available": true,
            "price": 23.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-pistol-putter-grip?variant=40825760055357"
          },
          {
            "id": "40825784860733",
            "gid": "gid://shopify/ProductVariant/40825784860733",
            "sku": "JMX370-2000",
            "color": "Black/Lime Green",
            "size": "Pro",
            "selected_options": {
              "Color": "Black/Lime Green",
              "Size": "Mid"
            },
            "available": true,
            "price": 23.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-jmx-pistol-putter-grip?variant=40825784860733"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, jumbomax, JumboMax Non-Tapered, jumbomax pistol, jumbomax pistol putter, JumboMax Putter, Less Tapered, midsize, Midsize Pistol Putter, midsize-golf-grips, midsize-size-golf-grips, non-tapered, overstock-mar2024, putter, putter grip, putter-grips, reduced taper, s",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "oversize",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red/White/Blue",
      "Blackout",
      "Black/Lime Green"
    ]
  },
  {
    "id": "jumbomax-st-1-2",
    "brand": "JumboMax",
    "model": "ST/1.2",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "rubber (oversize)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://jumbomax.com/products/tour-series"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/Silver"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 18.99,
    "price_max": 18.99,
    "single_price_min": 18.99,
    "single_price_max": 18.99,
    "normalized_price_per_grip": 18.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-st-1-2-jumbo-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbo-putter-st1-2-black-grey.jpg?v=1758219540",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black/Silver"
        ],
        "price": 18.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-st-1-2-jumbo-putter-grip",
        "handle": "jumbomax-st-1-2-jumbo-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/Silver",
              "Black/Green",
              "Red/White/Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "29515032625213",
            "gid": "gid://shopify/ProductVariant/29515032625213",
            "sku": "JMX315-6000",
            "color": "Black/Silver",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black/Silver"
            },
            "available": true,
            "price": 18.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-st-1-2-jumbo-putter-grip?variant=29515032625213"
          },
          {
            "id": "29515034132541",
            "gid": "gid://shopify/ProductVariant/29515034132541",
            "sku": "JMX315-2000",
            "color": "Black/Green",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black/Green"
            },
            "available": true,
            "price": 18.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-st-1-2-jumbo-putter-grip?variant=29515034132541"
          },
          {
            "id": "29515034394685",
            "gid": "gid://shopify/ProductVariant/29515034394685",
            "sku": "JMX315-1400",
            "color": "Red/White/Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": true,
            "price": 18.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-st-1-2-jumbo-putter-grip?variant=29515034394685"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, jumbo/oversize, jumbomax, JumboMax 1.2, JumboMax Non-Tapered, JumboMax Putter, JumboMax ST 1.2, Less Tapered, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, putter-grips, reduced taper, single-grip, ST/1.2, under-150, under-300, XL",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/Silver",
      "Black/Green",
      "Red/White/Blue"
    ]
  },
  {
    "id": "jumbomax-two-piece-split",
    "brand": "JumboMax",
    "model": "Two Piece Split",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "rubber (oversize)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://jumbomax.com/products/tour-series"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black / Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/jumbomax-two-piece-split-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/jumbomax-two-piece-grip-black-black.jpg?v=1753910267",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black / Black"
        ],
        "price": 29.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/jumbomax-two-piece-split-grip",
        "handle": "jumbomax-two-piece-split-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Black",
              "Blue / Black",
              "Red / Black"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52530793054578",
            "gid": "gid://shopify/ProductVariant/52530793054578",
            "sku": "JMX355-6000",
            "color": "Black / Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-two-piece-split-grip?variant=52530793054578"
          },
          {
            "id": "52530810782066",
            "gid": "gid://shopify/ProductVariant/52530810782066",
            "sku": "JMX355-7000",
            "color": "Blue / Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / Black"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-two-piece-split-grip?variant=52530810782066"
          },
          {
            "id": "52530810814834",
            "gid": "gid://shopify/ProductVariant/52530810814834",
            "sku": "JMX355-5000",
            "color": "Red / Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / Black"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/jumbomax-two-piece-split-grip?variant=52530810814834"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2-pc, 2-piece putter grips, 49 under, All Products, arm lock, arm lock putter grip, belly, Brand_JumboMax, Counter Balance, golf-grips, jumbo/oversize, long, Long Putter, Long/Belly Putter, mid-ov-putter-sale, Model_JumboMax Two Piece Split Grip, putter, putter grip, putter-grips, split, super-strok",
    "source_quality": "manufacturer_family",
    "source_url": "https://jumbomax.com/products/tour-series",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue / Black",
      "Red / Black"
    ]
  },
  {
    "id": "karma-black-velvet-paddle",
    "brand": "Karma",
    "model": "Black Velvet Paddle",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 4.25,
    "price_max": 4.25,
    "single_price_min": 4.25,
    "single_price_max": 4.25,
    "normalized_price_per_grip": 4.25,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/karma-black-velvet-paddle-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/karma-velvet-putter_8a47c1c3-a307-417d-b82f-d649ee15e95f.jpg?v=1636067202",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 4.25,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/karma-black-velvet-paddle-putter-grip",
        "handle": "karma-black-velvet-paddle-putter-grip",
        "shopify_variants": [
          {
            "id": "31695130984509",
            "gid": "gid://shopify/ProductVariant/31695130984509",
            "sku": "KM-RF50-001",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 4.25,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/karma-black-velvet-paddle-putter-grip?variant=31695130984509"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, karma, paddle putter, putter, putter grip, putter-grips, single-grip, standard, standard-size-golf-grips, under-150",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "kent-sports-2-thumb",
    "brand": "Kent Sports",
    "model": "2-Thumb",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Jumbo/Oversize": 99.8
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12.99,
    "price_max": 12.99,
    "single_price_min": 12.99,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 12.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/two-thumb-jumbo-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/new-IMG-5180-two-thumb-700x700.jpg?v=1637098590",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 12.99,
        "per_grip_g": 99.8,
        "total_g": 99.7903214,
        "url": "https://www.grips4less.com/products/two-thumb-jumbo-putter-grip",
        "handle": "two-thumb-jumbo-putter-grip",
        "shopify_variants": [
          {
            "id": "39484794830909",
            "gid": "gid://shopify/ProductVariant/39484794830909",
            "sku": "GRP2T",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 99.8,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/two-thumb-jumbo-putter-grip?variant=39484794830909"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2 thumb, 2Thumb Putter Grip, 49 under, 58 core, added-11162021, All products, iron/wood, jumbo/oversize, kent-sports, medium firm, oversize, oversize-jumbo-golf-grips, oversize/jumbo, paddle putter, putter, putter grip, single-grip, Size_Jumbo/Oversize, Style_Putter Grip, thumb putter, two thumb, un",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-majors-lamkin-sink",
    "brand": "Lamkin",
    "model": "\"Majors\" Lamkin Sink",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "13\" Round - Green/Turquoise"
    ],
    "manufacturer_size_labels": [
      "13\" Round - Green/Turquoise"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "13\" Round - Green/Turquoise": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9.74,
    "price_max": 9.74,
    "single_price_min": 9.74,
    "single_price_max": 9.74,
    "normalized_price_per_grip": 9.74,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-sink-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Putter-SINK-SQD11-Masters-front-700.jpg?v=1636061185",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "13\" Round - Green/Turquoise"
        ],
        "format": "single",
        "colors": [],
        "price": 9.74,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-sink-putter-grip",
        "handle": "limited-edition-masters-lamkin-sink-putter-grip",
        "shopify_options": [
          {
            "name": "Size/Shape",
            "values": [
              "13\" Round - Green/Turquoise",
              "13\" Squared - Orange/Yellow",
              "11\" Round - Green/Turquoise",
              "11\" Squared - Orange/Yellow"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461753323581",
            "gid": "gid://shopify/ProductVariant/39461753323581",
            "sku": "101433",
            "color": "",
            "size": "13\" Round - Green/Turquoise",
            "selected_options": {
              "Size/Shape": "13\" Round - Green/Turquoise"
            },
            "available": true,
            "price": 9.74,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-sink-putter-grip?variant=39461753323581"
          },
          {
            "id": "39461753356349",
            "gid": "gid://shopify/ProductVariant/39461753356349",
            "sku": "101432",
            "color": "",
            "size": "13\" Round - Green/Turquoise",
            "selected_options": {
              "Size/Shape": "13\" Squared - Orange/Yellow"
            },
            "available": true,
            "price": 9.74,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-sink-putter-grip?variant=39461753356349"
          },
          {
            "id": "39461753389117",
            "gid": "gid://shopify/ProductVariant/39461753389117",
            "sku": "101431",
            "color": "",
            "size": "13\" Round - Green/Turquoise",
            "selected_options": {
              "Size/Shape": "11\" Round - Green/Turquoise"
            },
            "available": true,
            "price": 8.44,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-sink-putter-grip?variant=39461753389117"
          },
          {
            "id": "39461753421885",
            "gid": "gid://shopify/ProductVariant/39461753421885",
            "sku": "101430",
            "color": "",
            "size": "13\" Round - Green/Turquoise",
            "selected_options": {
              "Size/Shape": "11\" Squared - Orange/Yellow"
            },
            "available": true,
            "price": 8.44,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/limited-edition-masters-lamkin-sink-putter-grip?variant=39461753421885"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_Lamkin, lamkin, midsize, midsize-golf-grips, New for 2016, putter, single-grip, sink, Size_Midsize, under-150, video=x-_vwLLCmeQ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-deep-etched-full-cord-paddle",
    "brand": "Lamkin",
    "model": "Deep Etched FULL CORD Paddle",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "deep-etched texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "paddle/flat",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.99,
    "price_max": 13.99,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 13.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-deep-etched-full-cord-paddle-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/lamkin-deep-etched-cord-putter.jpg?v=1690422435",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-deep-etched-full-cord-paddle-putter-grip",
        "handle": "lamkin-deep-etched-full-cord-paddle-putter-grip",
        "shopify_variants": [
          {
            "id": "40683357470781",
            "gid": "gid://shopify/ProductVariant/40683357470781",
            "sku": "LG-101407",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-deep-etched-full-cord-paddle-putter-grip?variant=40683357470781"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, cord, cord-golf-grips, full cord, golf-grips, lamkin, Lamkin Putter, putter, putter grip, putter-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-deep-etched-paddle",
    "brand": "Lamkin",
    "model": "Deep Etched Paddle",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber",
    "texture": "deep-etched texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "other",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "paddle/flat",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12.99,
    "price_max": 12.99,
    "single_price_min": 12.99,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 12.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-deep-etched-paddle-putter-std-58",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-deep-etched-putter-grip-4colors.jpg?v=1584739176",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-deep-etched-paddle-putter-std-58",
        "handle": "lamkin-deep-etched-paddle-putter-std-58",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red",
              "Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683358650429",
            "gid": "gid://shopify/ProductVariant/40683358650429",
            "sku": "101401",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-deep-etched-paddle-putter-std-58?variant=40683358650429"
          },
          {
            "id": "40683358683197",
            "gid": "gid://shopify/ProductVariant/40683358683197",
            "sku": "101463",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-deep-etched-paddle-putter-std-58?variant=40683358683197"
          },
          {
            "id": "40683358715965",
            "gid": "gid://shopify/ProductVariant/40683358715965",
            "sku": "101462",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-deep-etched-paddle-putter-std-58?variant=40683358715965"
          },
          {
            "id": "40683358748733",
            "gid": "gid://shopify/ProductVariant/40683358748733",
            "sku": "101464",
            "color": "Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Gray",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-deep-etched-paddle-putter-std-58?variant=40683358748733"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, golf-grips, lamkin, Lamkin Putter, lamkin-2023-spring-promo, overstock-mar2024, putter, putter grip, putter-grips, single-grip, standard, standard-size-golf-grips, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-deep-etched-sink-fit",
    "brand": "Lamkin",
    "model": "Deep Etched Sink Fit",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 18.99,
    "price_max": 18.99,
    "single_price_min": 18.99,
    "single_price_max": 18.99,
    "normalized_price_per_grip": 18.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-deep-etched-sink-fit-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Lamkin_DeepEtchedSINKFit-2colors-1400.jpg?v=1706739452",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 18.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-deep-etched-sink-fit-putter-grip",
        "handle": "lamkin-deep-etched-sink-fit-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Green"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41004060115005",
            "gid": "gid://shopify/ProductVariant/41004060115005",
            "sku": "LG-101549",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 18.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-deep-etched-sink-fit-putter-grip?variant=41004060115005"
          },
          {
            "id": "41004063096893",
            "gid": "gid://shopify/ProductVariant/41004063096893",
            "sku": "LG-101550",
            "color": "Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Green",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 18.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-deep-etched-sink-fit-putter-grip?variant=41004063096893"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2024 new products, 49 under, All Products, asbl-putter-grip-option, golf-grips, lamkin, Lamkin Deep Etched Putter, Lamkin Putter, Lamkin sink fit, lamkin-2023-spring-promo, midsize-golf-grips, Model_Lamkin Sink Fit, putter, putter grip, putter-grips, single-grip, Size_Standard, standard, standard-si",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-e-b-l-3gen-paddle-putter",
    "brand": "Lamkin",
    "model": "E.B.L. 3GEN Paddle Putter",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat-front",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Default"
    ],
    "weight_g_by_size": {
      "Midsize": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 6.56,
    "price_max": 6.56,
    "single_price_min": 6.56,
    "single_price_max": 6.56,
    "normalized_price_per_grip": 6.56,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-ebl-paddle-3gen-whtblk-mid-58r",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Lamkin_EBL_PADDLE_3GEN_White_Black_Midsize_58R_Putter_65bd51ae-538e-4d1a-b416-140e8c726cbe.jpg?v=1735455957",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Default"
        ],
        "price": 6.56,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/lamkin-ebl-paddle-3gen-whtblk-mid-58r",
        "handle": "lamkin-ebl-paddle-3gen-whtblk-mid-58r",
        "shopify_variants": [
          {
            "id": "39461785206845",
            "gid": "gid://shopify/ProductVariant/39461785206845",
            "sku": "100627",
            "color": "Default",
            "size": "Midsize",
            "selected_options": {
              "Color": "Default"
            },
            "available": true,
            "price": 6.56,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-ebl-paddle-3gen-whtblk-mid-58r?variant=39461785206845"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2023-sale, 49 under, All products, bf-nonassembled, Brand_Lamkin, lamkin, mem25, midsize, midsize-golf-grips, prime-2025, putter, putter-grips, single-grip, Size_Midsize, under-150, veterans-sale-2023, video=ZAL33c3v4Fs",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Default"
    ]
  },
  {
    "id": "lamkin-lamkin",
    "brand": "Lamkin",
    "model": "Lamkin",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Default"
    ],
    "manufacturer_size_labels": [
      "Default"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Default": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 8.99,
    "price_max": 8.99,
    "single_price_min": 8.99,
    "single_price_max": 8.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-jumbo-putter-ovr-58",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2015-logo-jumbo-putter_bd00a32b-f24b-47e3-8c3e-40868c6a792b.jpg?v=1636055544",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 8.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-jumbo-putter-ovr-58",
        "handle": "lamkin-jumbo-putter-ovr-58",
        "shopify_variants": [
          {
            "id": "39461784977469",
            "gid": "gid://shopify/ProductVariant/39461784977469",
            "sku": "101402",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": false,
            "price": 8.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-jumbo-putter-ovr-58?variant=39461784977469"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, 58 core, All products, Brand_Lamkin, jumbo/oversize, lamkin, oversize, oversize-jumbo-golf-grips, putter, Putter Length_Standard, single-grip, Size_Jumbo/Oversize, Style_Putter Grip, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink-fit-deep-v",
    "brand": "Lamkin",
    "model": "SINK FIT Deep-V",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue (with Green/White accent)"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5,
      "Standard": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/copy-of-lamkin-sink-fit-deep-v-standard-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/lamkin-sinkfit-deepv-putter.jpg?v=1690422567",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Blue (with Green/White accent)"
        ],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/copy-of-lamkin-sink-fit-deep-v-standard-putter-grip",
        "handle": "copy-of-lamkin-sink-fit-deep-v-standard-putter-grip",
        "shopify_variants": [
          {
            "id": "40683355701309",
            "gid": "gid://shopify/ProductVariant/40683355701309",
            "sku": "LG-101825",
            "color": "Blue (with Green/White accent)",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue (with Green/White accent)",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/copy-of-lamkin-sink-fit-deep-v-standard-putter-grip?variant=40683355701309"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue (with Green/White accent)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blue (with Green/White accent)"
        ],
        "price": 24.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-sink-fit-deep-v-putter-grip",
        "handle": "lamkin-sink-fit-deep-v-putter-grip",
        "shopify_variants": [
          {
            "id": "40683355734077",
            "gid": "gid://shopify/ProductVariant/40683355734077",
            "sku": "LG-101824",
            "color": "Blue (with Green/White accent)",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue (with Green/White accent)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-deep-v-putter-grip?variant=40683355734077"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue (with Green/White accent)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, golf-grips, lamkin, Lamkin Putter, Lamkin SINK FIT, Lamkin Sink Fit Deep V, mid-ov-putter-sale, midsize, midsize-golf-grips, overstock-oct-2023, putter, putter grip, putter-grips, single-grip, Sink fit Deep V, Sinkfit, summer-overstock-2022, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink-fit-polyurethane-pistol-claw-putter-grip",
    "brand": "Lamkin",
    "model": "SINK FIT Polyurethane PISTOL CLAW Putter Grip",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue / Charcoal / Silver"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-pistol-claw-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/sinkfit-pistolclaw-front-700.jpg?v=1602858111",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Blue / Charcoal / Silver"
        ],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-pistol-claw-putter-grip",
        "handle": "lamkin-sink-fit-polyurethane-pistol-claw-putter-grip",
        "shopify_variants": [
          {
            "id": "40683355635773",
            "gid": "gid://shopify/ProductVariant/40683355635773",
            "sku": "LG-101820",
            "color": "Blue / Charcoal / Silver",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue / Charcoal / Silver",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-pistol-claw-putter-grip?variant=40683355635773"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue / Charcoal / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, Claw, fathers-day-gifts, golf-grips, golfers-gift-guide, laborday-2022, lamkin, Lamkin PU, Lamkin Putter, Lamkin SINK FIT, mid-ov-putter-sale, midsize, midsize-golf-grips, overstock-oct-2023, Pistol Claw, putter, putter grip, putter grip gift, putter-grip-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink-fit-polyurethane-pistol-putter-grip",
    "brand": "Lamkin",
    "model": "SINK FIT Polyurethane PISTOL Putter Grip",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue / Charcoal / Silver"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/sinkfit-pistol-front-700.jpg?v=1602858641",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Blue / Charcoal / Silver"
        ],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-pistol-putter-grip",
        "handle": "lamkin-sink-fit-polyurethane-pistol-putter-grip",
        "shopify_variants": [
          {
            "id": "40683355668541",
            "gid": "gid://shopify/ProductVariant/40683355668541",
            "sku": "LG-101823",
            "color": "Blue / Charcoal / Silver",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue / Charcoal / Silver",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-pistol-putter-grip?variant=40683355668541"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue / Charcoal / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, golf-grips, laborday-2022, lamkin, Lamkin PU, Lamkin Putter, Lamkin SINK FIT, mid-ov-putter-sale, midsize, midsize-golf-grips, putter, putter grip, putter-grips, single-grip, Sink fit pistol, Sink fit PU, Sinkfit, Sinkfit Pistol, Sinkfit PU, summer-oversto",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink-fit-polyurethane-square-top-putter-grip",
    "brand": "Lamkin",
    "model": "SINK FIT Polyurethane SQUARE TOP Putter Grip",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue / Charcoal / Silver"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-square-top-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/sinkfit-squaretop-front-700.jpg?v=1602858470",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Blue / Charcoal / Silver"
        ],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-square-top-putter-grip",
        "handle": "lamkin-sink-fit-polyurethane-square-top-putter-grip",
        "shopify_variants": [
          {
            "id": "40683355603005",
            "gid": "gid://shopify/ProductVariant/40683355603005",
            "sku": "LG-101821",
            "color": "Blue / Charcoal / Silver",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue / Charcoal / Silver",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-square-top-putter-grip?variant=40683355603005"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue / Charcoal / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, laborday-2022, lamkin, Lamkin PU, Lamkin Putter, Lamkin SINK FIT, mid-ov-putter-sale, midsize, midsize-golf-grips, overstock-oct-2023, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, single-grip, Sink fit PU, Sink fit Square Top, Sinkfit, S",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink-fit-polyurethane-straight-putter-grip",
    "brand": "Lamkin",
    "model": "SINK FIT Polyurethane STRAIGHT Putter Grip",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue / Charcoal / Silver"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-straight-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/sinkfit-straight-front-700.jpg?v=1602858647",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Blue / Charcoal / Silver"
        ],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-straight-putter-grip",
        "handle": "lamkin-sink-fit-polyurethane-straight-putter-grip",
        "shopify_variants": [
          {
            "id": "40683355570237",
            "gid": "gid://shopify/ProductVariant/40683355570237",
            "sku": "LG-101822",
            "color": "Blue / Charcoal / Silver",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue / Charcoal / Silver",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurethane-straight-putter-grip?variant=40683355570237"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue / Charcoal / Silver"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, golfers-gift-guide, laborday-2022, lamkin, Lamkin PU, Lamkin Putter, Lamkin SINK FIT, Lamkin Straight, mid-ov-putter-sale, midsize, midsize-golf-grips, putter, putter grip, putter-grips, single-grip, Sink fit PU, Sinkfit, Sinkfit PU, summer-overstock-2022, under-1",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink",
    "brand": "Lamkin",
    "model": "Sink",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "11\" Squared - Orange/Yellow"
    ],
    "manufacturer_size_labels": [
      "11\" Squared - Orange/Yellow"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "11\" Squared - Orange/Yellow": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 10.13,
    "price_max": 10.13,
    "single_price_min": 10.13,
    "single_price_max": 10.13,
    "normalized_price_per_grip": 10.13,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sink-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/sink-putter-4colors.jpg?v=1636059504",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "11\" Squared - Orange/Yellow"
        ],
        "format": "single",
        "colors": [],
        "price": 10.13,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-sink-putter-grip",
        "handle": "lamkin-sink-putter-grip",
        "shopify_options": [
          {
            "name": "Size/Shape",
            "values": [
              "11\" Squared - Orange/Yellow",
              "13\" Round - Green/Turquoise",
              "13\" Squared - Orange/Yellow"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461766561853",
            "gid": "gid://shopify/ProductVariant/39461766561853",
            "sku": "101408",
            "color": "",
            "size": "11\" Squared - Orange/Yellow",
            "selected_options": {
              "Size/Shape": "11\" Squared - Orange/Yellow"
            },
            "available": true,
            "price": 10.13,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sink-putter-grip?variant=39461766561853"
          },
          {
            "id": "39461766594621",
            "gid": "gid://shopify/ProductVariant/39461766594621",
            "sku": "101411",
            "color": "",
            "size": "11\" Squared - Orange/Yellow",
            "selected_options": {
              "Size/Shape": "13\" Round - Green/Turquoise"
            },
            "available": true,
            "price": 11.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sink-putter-grip?variant=39461766594621"
          },
          {
            "id": "39461766627389",
            "gid": "gid://shopify/ProductVariant/39461766627389",
            "sku": "101410",
            "color": "",
            "size": "11\" Squared - Orange/Yellow",
            "selected_options": {
              "Size/Shape": "13\" Squared - Orange/Yellow"
            },
            "available": true,
            "price": 11.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sink-putter-grip?variant=39461766627389"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_Lamkin, lamkin, midsize, midsize-golf-grips, putter, single-grip, sink, Size_Midsize, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink-fit-polyurathane-putter-grip",
    "brand": "Lamkin",
    "model": "Sink FIT Polyurathane Putter Grip",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Pistol / Blue/Black"
    ],
    "manufacturer_size_labels": [
      "Pistol / Blue/Black"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Pistol / Blue/Black": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurathane-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/lamkin-sink-fit-pu-allcolors.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Pistol / Blue/Black"
        ],
        "format": "single",
        "colors": [],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurathane-putter-grip",
        "handle": "lamkin-sink-fit-polyurathane-putter-grip",
        "shopify_options": [
          {
            "name": "Size/Shape",
            "values": [
              "Pistol / Blue/Black",
              "Straight / Red/Black"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14025049702461",
            "gid": "gid://shopify/ProductVariant/14025049702461",
            "sku": "LG-101489",
            "color": "",
            "size": "Pistol / Blue/Black",
            "selected_options": {
              "Size/Shape": "Pistol / Blue/Black"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurathane-putter-grip?variant=14025049702461"
          },
          {
            "id": "14025049735229",
            "gid": "gid://shopify/ProductVariant/14025049735229",
            "sku": "LG-101488",
            "color": "",
            "size": "Pistol / Blue/Black",
            "selected_options": {
              "Size/Shape": "Straight / Red/Black"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-polyurathane-putter-grip?variant=14025049735229"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, lamkin, Lamkin pistol, Lamkin Putter, Lamkin sink fit, Lamkin straight, mid-ov-putter-sale, midsize, midsize-golf-grips, polyurethane, putter, single-grip, sink fit, sink fit rubber, sink polyurethane, sink pu, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink-fit-rubber-putter-grip-with-fingerprint-technology",
    "brand": "Lamkin",
    "model": "Sink FIT Rubber Putter Grip (with Fingerprint Technology)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Midsize",
      "Straight / Black/Red"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Straight / Black/Red"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Midsize / Straight"
    ],
    "weight_g_by_size": {
      "Straight / Black/Red": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 19.99,
    "price_max": 19.99,
    "single_price_min": 19.99,
    "single_price_max": 19.99,
    "normalized_price_per_grip": 19.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sink-fit-rubber-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/LG-101490-SinkFit-rubber-Strait-front-blk-red.jpg?v=1644613140",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize",
          "Straight / Black/Red"
        ],
        "format": "single",
        "colors": [
          "Midsize / Straight"
        ],
        "price": 19.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-sink-fit-rubber-putter-grip",
        "handle": "lamkin-sink-fit-rubber-putter-grip",
        "shopify_variants": [
          {
            "id": "40683357339709",
            "gid": "gid://shopify/ProductVariant/40683357339709",
            "sku": "LG-101490",
            "color": "Midsize / Straight",
            "size": "Midsize",
            "selected_options": {
              "Grip Size/Shape": "Straight / Black/Red",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-rubber-putter-grip?variant=40683357339709"
          }
        ],
        "shopify_options": [
          {
            "name": "Grip Size/Shape",
            "values": [
              "Straight / Black/Red"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, golf-grips, lamkin, Lamkin pistol, Lamkin Putter, Lamkin sink fit, Lamkin straight, mid-ov-putter-sale, midsize, midsize-golf-grips, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, single-grip, sink fit, sink fit rubber, sink rubber",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink-fit-rubber-pistol",
    "brand": "Lamkin",
    "model": "Sink Fit Rubber Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black (with Blue Accents)"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 19.99,
    "price_max": 19.99,
    "single_price_min": 19.99,
    "single_price_max": 19.99,
    "normalized_price_per_grip": 19.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sink-fit-rubber-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/LG-101492-1.jpg?v=1706578656",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black (with Blue Accents)"
        ],
        "price": 19.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-sink-fit-rubber-pistol-putter-grip",
        "handle": "lamkin-sink-fit-rubber-pistol-putter-grip",
        "shopify_variants": [
          {
            "id": "40999492714557",
            "gid": "gid://shopify/ProductVariant/40999492714557",
            "sku": "LG-101491",
            "color": "Black (with Blue Accents)",
            "size": "Standard",
            "selected_options": {
              "Color": "Black (with Blue Accents)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-rubber-pistol-putter-grip?variant=40999492714557"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black (with Blue Accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, golf-grips, lamkin, Lamkin Putter, Lamkin SINK FIT, mid-ov-putter-sale, midsize, midsize-golf-grips, midsize-size-golf-grips, overstock-oct-2023, putter, putter grip, putter-grips, single-grip, Sinkfit, Size_Midsize, standard, summer-overstock-2022, u",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-sink-fit-skinny-pistol",
    "brand": "Lamkin",
    "model": "Sink Fit Skinny Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol/straight",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue (with Neon Green Accents)"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 17.99,
    "price_max": 17.99,
    "single_price_min": 17.99,
    "single_price_max": 17.99,
    "normalized_price_per_grip": 17.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-sink-fit-skinny-pistol-rubber-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/LG-101493-main.jpg?v=1706575833",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blue (with Neon Green Accents)"
        ],
        "price": 17.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lamkin-sink-fit-skinny-pistol-rubber-putter-grip",
        "handle": "lamkin-sink-fit-skinny-pistol-rubber-putter-grip",
        "shopify_variants": [
          {
            "id": "40999405518909",
            "gid": "gid://shopify/ProductVariant/40999405518909",
            "sku": "LG-101493",
            "color": "Blue (with Neon Green Accents)",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue (with Neon Green Accents)",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 17.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-sink-fit-skinny-pistol-rubber-putter-grip?variant=40999405518909"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue (with Neon Green Accents)"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, golf-grips, lamkin, Lamkin Putter, Lamkin SINK FIT, Lamkin Sink Fit Deep V, mid-ov-putter-sale, overstock-oct-2023, putter, putter grip, putter-grips, single-grip, Sink fit Deep V, Sinkfit, Size_Standard, standard, standard-size-golf-grips, summer-ove",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-technique",
    "brand": "Lamkin",
    "model": "Technique",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "rubber",
    "texture": "textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "oversize",
    "putter_size_class": "oversize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf"
    ],
    "sizes_available": [
      "Default"
    ],
    "manufacturer_size_labels": [
      "Default"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Default": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 15.59,
    "price_max": 15.59,
    "single_price_min": 15.59,
    "single_price_max": 15.59,
    "normalized_price_per_grip": 15.59,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lamkin-technique-oversize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/technique-putter-ov.jpg?v=1636058443",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 15.59,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/lamkin-technique-oversize-putter-grip",
        "handle": "lamkin-technique-oversize-putter-grip",
        "shopify_variants": [
          {
            "id": "39461769576509",
            "gid": "gid://shopify/ProductVariant/39461769576509",
            "sku": "101510",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 15.59,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/lamkin-technique-oversize-putter-grip?variant=39461769576509"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Brand_Lamkin, lamkin, New for 2015, oversize, oversize-jumbo-golf-grips, putter, single-grip, technique, under-150, video=4TODfIGlyxo",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lamkin-utx-mega-paddle",
    "brand": "Lamkin",
    "model": "UTx Mega Paddle",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "hybrid (ACE 3GEN rubber)",
    "texture": "fingerprint texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "discontinued",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
      "https://www.todays-golfer.com/equipment/best/lamkin-golf-grips/"
    ],
    "sizes_available": [
      "Default"
    ],
    "manufacturer_size_labels": [
      "Default"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Default": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12.99,
    "price_max": 12.99,
    "single_price_min": 12.99,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 12.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/new-lamkin-utx-mega-paddle-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/utx-mega-paddle-putter_3d9f5548-e041-496a-8d54-e8f7b9d03dc8.jpg?v=1636053876",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 12.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/new-lamkin-utx-mega-paddle-putter-grip",
        "handle": "new-lamkin-utx-mega-paddle-putter-grip",
        "shopify_variants": [
          {
            "id": "39461772165181",
            "gid": "gid://shopify/ProductVariant/39461772165181",
            "sku": "101403",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/new-lamkin-utx-mega-paddle-putter-grip?variant=39461772165181"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, 58 core, All products, Brand_Lamkin, lamkin, midsize, midsize-golf-grips, putter, single-grip, Size_Midsize, under-150, UTx",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lamkingrips.com/wp-content/uploads/2024/04/Lamkin-Weight-Spec-Sheet.pdf",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lizard-skins-dsp-pg75-ultra-putter-grip-31-9-mm",
    "brand": "Lizard Skins",
    "model": "DSP PG75 Ultra Putter Grip - 31.9 mm",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polymer (DSP, no rubber)",
    "texture": "micro-dot texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lizardskins.com/golf/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue Scoop"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 27.99,
    "price_max": 27.99,
    "single_price_min": 27.99,
    "single_price_max": 27.99,
    "normalized_price_per_grip": 27.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lizard-skins-dsp-pg75-ultra-standard-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/lizard-skins-putter-pg75-3colors.jpg?v=1740002639",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Blue Scoop"
        ],
        "price": 27.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-pg75-ultra-standard-putter-grip",
        "handle": "lizard-skins-dsp-pg75-ultra-standard-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue Scoop",
              "Four Leaf",
              "Hold'em Black"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51793821761906",
            "gid": "gid://shopify/ProductVariant/51793821761906",
            "sku": "DSPUGPG1BS",
            "color": "Blue Scoop",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue Scoop",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 27.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-pg75-ultra-standard-putter-grip?variant=51793821761906"
          },
          {
            "id": "51804936044914",
            "gid": "gid://shopify/ProductVariant/51804936044914",
            "sku": "DSPUGPG1FL",
            "color": "Four Leaf",
            "size": "Standard",
            "selected_options": {
              "Color": "Four Leaf",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 27.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-pg75-ultra-standard-putter-grip?variant=51804936044914"
          },
          {
            "id": "51804936077682",
            "gid": "gid://shopify/ProductVariant/51804936077682",
            "sku": "DSPUGPG1HB",
            "color": "Hold'em Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Hold'em Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 27.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-pg75-ultra-standard-putter-grip?variant=51804936077682"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, arthritic, arthritic-golf-grips, fathers-day-2021-sale, golf-grips, lizard, lizard skin, lizard skins, putter, putter grip, putter-grips, standard, standard-size-golf-grips, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lizardskins.com/golf/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "lizard-skins-dsp-pg75-ultra-putter-grip-38-4-mm",
    "brand": "Lizard Skins",
    "model": "DSP PG75 Ultra Putter Grip - 38.4 mm",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polymer (DSP, no rubber)",
    "texture": "micro-dot texture",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "oversize",
    "putter_size_class": "oversize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.lizardskins.com/golf/"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue Scoop"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 32.99,
    "price_max": 32.99,
    "single_price_min": 32.99,
    "single_price_max": 32.99,
    "normalized_price_per_grip": 32.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/lizard-skins-dsp-pg75-ultra-oversize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/lizard-skins-putter-pg75-oversize-2colors.jpg?v=1740002263",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Blue Scoop"
        ],
        "price": 32.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/lizard-skins-dsp-pg75-ultra-oversize-putter-grip",
        "handle": "lizard-skins-dsp-pg75-ultra-oversize-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue Scoop",
              "Star Spangled"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Oversize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "51793821860210",
            "gid": "gid://shopify/ProductVariant/51793821860210",
            "sku": "DSPUGPG2BS",
            "color": "Blue Scoop",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue Scoop",
              "Grip Size": "Oversize"
            },
            "available": false,
            "price": 32.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-pg75-ultra-oversize-putter-grip?variant=51793821860210"
          },
          {
            "id": "51804935422322",
            "gid": "gid://shopify/ProductVariant/51804935422322",
            "sku": "DSPUGPG2SS",
            "color": "Star Spangled",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Star Spangled",
              "Grip Size": "Oversize"
            },
            "available": false,
            "price": 32.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/lizard-skins-dsp-pg75-ultra-oversize-putter-grip?variant=51804935422322"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, arthritic, arthritic-golf-grips, fathers-day-2021-sale, golf-grips, jumbo, lizard, lizard skin, lizard skins, oversize, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, putter-grips, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.lizardskins.com/golf/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "loudmouth-black-shagadelic",
    "brand": "LoudMouth",
    "model": "Black Shagadelic",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "oversize",
    "putter_size_class": "oversize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5,
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 19.99,
    "price_max": 24.95,
    "single_price_min": 19.99,
    "single_price_max": 24.95,
    "normalized_price_per_grip": 19.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/loudmouth-black-shagadelic-putter-oversize-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/LoudMouth-Jumbo-Putter-Grip-Shagadelic-1.gif?v=1571438506",
    "fit_tags": [],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 24.95,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/loudmouth-black-shagadelic-putter-oversize-grip",
        "handle": "loudmouth-black-shagadelic-putter-oversize-grip",
        "shopify_variants": [
          {
            "id": "397640817",
            "gid": "gid://shopify/ProductVariant/397640817",
            "sku": "GR9BSOP",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Oversize"
            },
            "available": true,
            "price": 24.95,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/loudmouth-black-shagadelic-putter-oversize-grip?variant=397640817"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Oversize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 19.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/loudmouth-black-shagadelic-putter-grip",
        "handle": "loudmouth-black-shagadelic-putter-grip",
        "shopify_variants": [
          {
            "id": "397640857",
            "gid": "gid://shopify/ProductVariant/397640857",
            "sku": "GR9BSSP",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Standard"
            },
            "available": true,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/loudmouth-black-shagadelic-putter-grip?variant=397640857"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, infinite-opt-addkit, jumbo/oversize, loudmouth, oversize, oversize-jumbo-golf-grips, Shagadelic, single-grip, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "loudmouth-captain-thunderbolt-usa",
    "brand": "LoudMouth",
    "model": "Captain Thunderbolt USA",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "oversize",
    "putter_size_class": "oversize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/loudmouth-captain-thunderbolt-usa-oversize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/LoudMouth-Jumbo-Putter-Grip-Captain-USA.jpg?v=1626964573",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/loudmouth-captain-thunderbolt-usa-oversize-putter-grip",
        "handle": "loudmouth-captain-thunderbolt-usa-oversize-putter-grip",
        "shopify_variants": [
          {
            "id": "397640949",
            "gid": "gid://shopify/ProductVariant/397640949",
            "sku": "GR9CTUOP",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Oversize"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/loudmouth-captain-thunderbolt-usa-oversize-putter-grip?variant=397640949"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Oversize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, infinite-opt-addkit, jumbo/oversize, loudmouth, memsale2022, oversize, oversize-jumbo-golf-grips, single-grip, Thunderbolt, under-150, under-300, usa",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "never-bend-never-bend",
    "brand": "Never Bend",
    "model": "Never Bend",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Midsize": 91,
      "Jumbo/Oversize": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 8.95,
    "price_max": 11.95,
    "single_price_min": 8.95,
    "single_price_max": 11.95,
    "normalized_price_per_grip": 8.95,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/never-bend-midsize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/midsize-2_cc5cd9bb-d267-401f-a244-16fab6486829.jpg?v=1636055785",
    "fit_tags": [],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 8.95,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/never-bend-midsize-putter-grip",
        "handle": "never-bend-midsize-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Copper"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461784485949",
            "gid": "gid://shopify/ProductVariant/39461784485949",
            "sku": "GRNBPMBK",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 8.95,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/never-bend-midsize-putter-grip?variant=39461784485949"
          },
          {
            "id": "39461784518717",
            "gid": "gid://shopify/ProductVariant/39461784518717",
            "sku": "GRNBPMRD",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 8.95,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/never-bend-midsize-putter-grip?variant=39461784518717"
          },
          {
            "id": "39461784551485",
            "gid": "gid://shopify/ProductVariant/39461784551485",
            "sku": "GRNBPMBL",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 8.95,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/never-bend-midsize-putter-grip?variant=39461784551485"
          },
          {
            "id": "39461784584253",
            "gid": "gid://shopify/ProductVariant/39461784584253",
            "sku": "GRNBPMCP",
            "color": "Copper",
            "size": "Midsize",
            "selected_options": {
              "Color": "Copper"
            },
            "available": true,
            "price": 8.95,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/never-bend-midsize-putter-grip?variant=39461784584253"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 11.95,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/never-bend-oversize-putter-grip",
        "handle": "never-bend-oversize-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "271798078",
            "gid": "gid://shopify/ProductVariant/271798078",
            "sku": "GRNBPJBK",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 11.95,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/never-bend-oversize-putter-grip?variant=271798078"
          },
          {
            "id": "271798080",
            "gid": "gid://shopify/ProductVariant/271798080",
            "sku": "GRNBPJRD",
            "color": "Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 11.95,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/never-bend-oversize-putter-grip?variant=271798080"
          },
          {
            "id": "271798082",
            "gid": "gid://shopify/ProductVariant/271798082",
            "sku": "GRNBPJBL",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 11.95,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/never-bend-oversize-putter-grip?variant=271798082"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Ball Pick-Up, midsize, midsize-golf-grips, never-bend, NeverBend, putter, putter-grips, single-grip, Size_Midsize, under-150",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red",
      "Blue",
      "Copper"
    ]
  },
  {
    "id": "never-bend-pro-300",
    "brand": "Never Bend",
    "model": "Pro 300",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 3,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black",
      "Blue",
      "Pink",
      "Red"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13,
    "price_max": 13,
    "single_price_min": 13,
    "single_price_max": 13,
    "normalized_price_per_grip": 13,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/never-bend-pro-300-putter-grip-pink",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/nb-pro300-pink_3f8086e8-01ec-4f08-bf58-4cad44f55205.jpg?v=1636054597",
    "fit_tags": [],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Pink"
        ],
        "price": 13,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/never-bend-pro-300-putter-grip-pink",
        "handle": "never-bend-pro-300-putter-grip-pink",
        "shopify_variants": [
          {
            "id": "24423516423",
            "gid": "gid://shopify/ProductVariant/24423516423",
            "sku": "NB-OSPK",
            "color": "Pink",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Pink"
            },
            "available": true,
            "price": 13,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/never-bend-pro-300-putter-grip-pink?variant=24423516423"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Pink"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 13,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/never-bend-pro-300-putter-grip-blue",
        "handle": "never-bend-pro-300-putter-grip-blue",
        "shopify_variants": [
          {
            "id": "24423484999",
            "gid": "gid://shopify/ProductVariant/24423484999",
            "sku": "NB-OSBU",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 13,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/never-bend-pro-300-putter-grip-blue?variant=24423484999"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 13,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/never-bend-pro-300-putter-grip-red",
        "handle": "never-bend-pro-300-putter-grip-red",
        "shopify_variants": [
          {
            "id": "24423202247",
            "gid": "gid://shopify/ProductVariant/24423202247",
            "sku": "NB-OSRD",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 13,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/never-bend-pro-300-putter-grip-red?variant=24423202247"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/never-bend-pro-300-putter-grip",
        "handle": "never-bend-pro-300-putter-grip",
        "shopify_variants": [
          {
            "id": "24422685511",
            "gid": "gid://shopify/ProductVariant/24422685511",
            "sku": "NB-OSBK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 13,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/never-bend-pro-300-putter-grip?variant=24422685511"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Ball Pick-Up, midsize, midsize-golf-grips, never-bend, NeverBend, oversize, oversize-jumbo-golf-grips, Pick-up tools, putter, putter grip, single-grip, Size_Midsize, under-150, upright-golf",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Pink",
      "Blue",
      "Red",
      "Black"
    ]
  },
  {
    "id": "pure-grips-pure",
    "brand": "Pure Grips",
    "model": "PURE",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber (bonded, tapeless)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "oversize",
    "putter_size_class": "oversize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://puregrips.com/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Oversize / Jumbo"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 136.1,
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.99,
    "price_max": 14.99,
    "single_price_min": 13.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 13.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/pure-oversize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/pure-oversize-putter-grip-6-colors.jpg?v=1605455898",
    "fit_tags": [
      "best_for_arthritis",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 14.99,
        "per_grip_g": 136.1,
        "total_g": 136.077711,
        "url": "https://www.grips4less.com/products/pure-oversize-putter-grip",
        "handle": "pure-oversize-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Purple",
              "Eagle Green",
              "Red",
              "Blue",
              "White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683506794557",
            "gid": "gid://shopify/ProductVariant/40683506794557",
            "sku": "PG-11912",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 14.99,
            "weight_g": 136.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-oversize-putter-grip?variant=40683506794557"
          },
          {
            "id": "40683506827325",
            "gid": "gid://shopify/ProductVariant/40683506827325",
            "sku": "PG-4414",
            "color": "Purple",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 16.99,
            "weight_g": 136.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-oversize-putter-grip?variant=40683506827325"
          },
          {
            "id": "40683506860093",
            "gid": "gid://shopify/ProductVariant/40683506860093",
            "sku": "PG-04416",
            "color": "Eagle Green",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 16.99,
            "weight_g": 136.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-oversize-putter-grip?variant=40683506860093"
          },
          {
            "id": "40683506892861",
            "gid": "gid://shopify/ProductVariant/40683506892861",
            "sku": "PG-31912",
            "color": "Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 16.99,
            "weight_g": 136.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-oversize-putter-grip?variant=40683506892861"
          },
          {
            "id": "40683506925629",
            "gid": "gid://shopify/ProductVariant/40683506925629",
            "sku": "PG-91912",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 16.99,
            "weight_g": 136.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-oversize-putter-grip?variant=40683506925629"
          },
          {
            "id": "40683506958397",
            "gid": "gid://shopify/ProductVariant/40683506958397",
            "sku": "PG-21912",
            "color": "White",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 16.99,
            "weight_g": 136.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-oversize-putter-grip?variant=40683506958397"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-midsize-putter-grip",
        "handle": "pure-midsize-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Purple",
              "Eagle Green",
              "Red",
              "White",
              "Royal Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683506991165",
            "gid": "gid://shopify/ProductVariant/40683506991165",
            "sku": "PG-11812",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-midsize-putter-grip?variant=40683506991165"
          },
          {
            "id": "40683507023933",
            "gid": "gid://shopify/ProductVariant/40683507023933",
            "sku": "PG-4314",
            "color": "Purple",
            "size": "Midsize",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-midsize-putter-grip?variant=40683507023933"
          },
          {
            "id": "40683507056701",
            "gid": "gid://shopify/ProductVariant/40683507056701",
            "sku": "PG-04316",
            "color": "Eagle Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-midsize-putter-grip?variant=40683507056701"
          },
          {
            "id": "40683507089469",
            "gid": "gid://shopify/ProductVariant/40683507089469",
            "sku": "PG-31812",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-midsize-putter-grip?variant=40683507089469"
          },
          {
            "id": "40683507122237",
            "gid": "gid://shopify/ProductVariant/40683507122237",
            "sku": "PG-21812",
            "color": "White",
            "size": "Midsize",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-midsize-putter-grip?variant=40683507122237"
          },
          {
            "id": "40683507155005",
            "gid": "gid://shopify/ProductVariant/40683507155005",
            "sku": "PG-91812",
            "color": "Royal Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Royal Blue"
            },
            "available": false,
            "price": 15.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-midsize-putter-grip?variant=40683507155005"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, fathers-day-2021-sale, golf-grips, july4-2022, jumbo/oversize, laborday-2022, memsale2022, New for 2014, oversize, oversize-jumbo-golf-grips, Pure Putter, pure-grips, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, rubber, soft",
    "source_quality": "manufacturer_family",
    "source_url": "https://puregrips.com/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "pure-grips-pure-classic",
    "brand": "Pure Grips",
    "model": "PURE Classic",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "rubber (bonded, tapeless)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://puregrips.com/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12.99,
    "price_max": 12.99,
    "single_price_min": 12.99,
    "single_price_max": 12.99,
    "normalized_price_per_grip": 12.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/pure-classic-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/pure-classic-putter-golf-grip-allcolors.jpg?v=1571438507",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 12.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/pure-classic-putter-grip",
        "handle": "pure-classic-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Purple",
              "Eagle Green",
              "Titanium Grey",
              "Red",
              "Royal Blue",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40683507187773",
            "gid": "gid://shopify/ProductVariant/40683507187773",
            "sku": "PG-11712",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 12.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-classic-putter-grip?variant=40683507187773"
          },
          {
            "id": "40683507220541",
            "gid": "gid://shopify/ProductVariant/40683507220541",
            "sku": "PG-4214",
            "color": "Purple",
            "size": "Standard",
            "selected_options": {
              "Color": "Purple"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-classic-putter-grip?variant=40683507220541"
          },
          {
            "id": "40683507253309",
            "gid": "gid://shopify/ProductVariant/40683507253309",
            "sku": "PG-04216",
            "color": "Eagle Green",
            "size": "Standard",
            "selected_options": {
              "Color": "Eagle Green"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-classic-putter-grip?variant=40683507253309"
          },
          {
            "id": "40683507286077",
            "gid": "gid://shopify/ProductVariant/40683507286077",
            "sku": "PG-4215",
            "color": "Titanium Grey",
            "size": "Standard",
            "selected_options": {
              "Color": "Titanium Grey"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-classic-putter-grip?variant=40683507286077"
          },
          {
            "id": "40683507318845",
            "gid": "gid://shopify/ProductVariant/40683507318845",
            "sku": "PG-31712",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-classic-putter-grip?variant=40683507318845"
          },
          {
            "id": "40683507351613",
            "gid": "gid://shopify/ProductVariant/40683507351613",
            "sku": "PG-91712",
            "color": "Royal Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Royal Blue"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-classic-putter-grip?variant=40683507351613"
          },
          {
            "id": "40683507384381",
            "gid": "gid://shopify/ProductVariant/40683507384381",
            "sku": "PG-21712",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White"
            },
            "available": false,
            "price": 13.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/pure-classic-putter-grip?variant=40683507384381"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, fathers-day-2021-sale, golf-grips, july4-2022, memsale2022, New for 2014, Pure Putter, pure-grips, putter, putter grip, putter-grips, rubber, standard, standard-size-golf-grips, tacky, under-150, under-300, video=3O4qoMemc-U",
    "source_quality": "manufacturer_family",
    "source_url": "https://puregrips.com/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "secret-grip-secret",
    "brand": "Secret Grip",
    "model": "Secret",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/Green"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 100,
      "Midsize": 100,
      "Unspecified": 100
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 8.99,
    "price_max": 24.99,
    "single_price_min": 8.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/secret-jumbo-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/secret-jumbo_5152f98e-3755-44ca-8e33-f9322b2ca5d1.jpg?v=1636059270",
    "fit_tags": [],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 21.25,
        "per_grip_g": 100,
        "total_g": 100.017117585,
        "url": "https://www.grips4less.com/products/secret-jumbo-putter-grip",
        "handle": "secret-jumbo-putter-grip",
        "shopify_variants": [
          {
            "id": "14720510407",
            "gid": "gid://shopify/ProductVariant/14720510407",
            "sku": "GRSCPMBBJ",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 21.25,
            "weight_g": 99.8,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/secret-jumbo-putter-grip?variant=14720510407"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [],
        "price": 10.49,
        "per_grip_g": 100,
        "total_g": 100.017117585,
        "url": "https://www.grips4less.com/products/secret-midsize-grip",
        "handle": "secret-midsize-grip",
        "shopify_variants": [
          {
            "id": "730974797",
            "gid": "gid://shopify/ProductVariant/730974797",
            "sku": "GRSGV4",
            "color": "",
            "size": "Midsize",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 10.49,
            "weight_g": 99.8,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/secret-midsize-grip?variant=730974797"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black/Green"
        ],
        "price": 24.99,
        "per_grip_g": 100,
        "total_g": 100.017117585,
        "url": "https://www.grips4less.com/products/secret-putter-grip",
        "handle": "secret-putter-grip",
        "shopify_variants": [
          {
            "id": "39461776293949",
            "gid": "gid://shopify/ProductVariant/39461776293949",
            "sku": "GRSCPMBG",
            "color": "Black/Green",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black/Green"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 99.8,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/secret-putter-grip?variant=39461776293949"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/Green"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 8.99,
        "per_grip_g": 100,
        "total_g": 100.017117585,
        "url": "https://www.grips4less.com/products/secret-grip",
        "handle": "secret-grip",
        "shopify_variants": [
          {
            "id": "336549835",
            "gid": "gid://shopify/ProductVariant/336549835",
            "sku": "GRSGV3",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Default Title"
            },
            "available": true,
            "price": 8.99,
            "weight_g": 99.8,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/secret-grip?variant=336549835"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Default Title"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Counter Balance, iron/wood, jumbo/oversize, putter, rubber, secret-grip, single-grip, Size_Jumbo/Oversize, under-150, video=jnpcMoWfaOw",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "silver-diamond-j-series",
    "brand": "Silver Diamond",
    "model": "J Series",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Default"
    ],
    "manufacturer_size_labels": [
      "Default"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Default": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 2.06,
    "price_max": 2.06,
    "single_price_min": 2.06,
    "single_price_max": 2.06,
    "normalized_price_per_grip": 2.06,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/silver-diamond-j-series-junior-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/sd-putter.jpg?v=1735456368",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 2.06,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/silver-diamond-j-series-junior-putter-grip",
        "handle": "silver-diamond-j-series-junior-putter-grip",
        "shopify_variants": [
          {
            "id": "39439014002749",
            "gid": "gid://shopify/ProductVariant/39439014002749",
            "sku": "SD-JPG",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 2.06,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/silver-diamond-j-series-junior-putter-grip?variant=39439014002749"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2023-sale, 49 under, 50 Core, All products, iron/wood, junior, junior-golf-grips, learning-fundamentals, medium firm, putter-grip, silver-diamond, single-grip, Size_Junior, Size_Undersize, under-150, undersize, undersize-golf-grips",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "star-grip-star",
    "brand": "Star Grip",
    "model": "Star",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "EPDM rubber (StarTack)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "dry-biased",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://stargrip.com/products/star-sidewinder-360-grip"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.99,
    "price_max": 13.99,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 13.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/star-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/star-putter-grip-colors.jpg?v=1699893649",
    "fit_tags": [
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/star-putter-grip",
        "handle": "star-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Orange",
              "Pink",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40857488818237",
            "gid": "gid://shopify/ProductVariant/40857488818237",
            "sku": "NST-BLK2111",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-putter-grip?variant=40857488818237"
          },
          {
            "id": "40857488949309",
            "gid": "gid://shopify/ProductVariant/40857488949309",
            "sku": "NST-RED2111",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-putter-grip?variant=40857488949309"
          },
          {
            "id": "40857488982077",
            "gid": "gid://shopify/ProductVariant/40857488982077",
            "sku": "NST-BLU2111",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-putter-grip?variant=40857488982077"
          },
          {
            "id": "40857489014845",
            "gid": "gid://shopify/ProductVariant/40857489014845",
            "sku": "NST-ORN2111",
            "color": "Orange",
            "size": "Standard",
            "selected_options": {
              "Color": "Orange",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-putter-grip?variant=40857489014845"
          },
          {
            "id": "40857491734589",
            "gid": "gid://shopify/ProductVariant/40857491734589",
            "sku": "NST-PNK2111",
            "color": "Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Pink",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 14.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-putter-grip?variant=40857491734589"
          },
          {
            "id": "40857491767357",
            "gid": "gid://shopify/ProductVariant/40857491767357",
            "sku": "NST-WHT2111",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/star-putter-grip?variant=40857491767357"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, fathers-day-2021-sale, golf-grips, july4-2022, memsale2022, New for 2014, overstock-mar2024, pure-grips, putter, putter grip, putter-grips, rubber, standard, standard-size-golf-grips, star putter grip, Star Wrap, star-grip, tacky, under-150, under-300",
    "source_quality": "manufacturer_family",
    "source_url": "https://stargrip.com/products/star-sidewinder-360-grip",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red",
      "Blue",
      "Orange",
      "Pink",
      "White"
    ]
  },
  {
    "id": "stick-grip-camo",
    "brand": "Stick Grip",
    "model": "Camo",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 2,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "CAMO",
      "Camo"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5,
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.49,
    "price_max": 34.95,
    "single_price_min": 13.49,
    "single_price_max": 34.95,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/stick-grip-camo-midsize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ScreenShot2025-03-18at5.36.49PM.png?v=1744323546",
    "fit_tags": [],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Camo"
        ],
        "price": 34.95,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-camo-midsize-putter-grip",
        "handle": "stick-grip-camo-midsize-putter-grip",
        "shopify_variants": [
          {
            "id": "51898777010546",
            "gid": "gid://shopify/ProductVariant/51898777010546",
            "sku": "STG-Putter-Camo",
            "color": "Camo",
            "size": "Midsize",
            "selected_options": {
              "Color": "Camo",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 34.95,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-camo-midsize-putter-grip?variant=51898777010546"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "CAMO"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-camo-standard-grip",
        "handle": "stick-grip-camo-standard-grip",
        "shopify_variants": [
          {
            "id": "51845877399922",
            "gid": "gid://shopify/ProductVariant/51845877399922",
            "sku": "STG-Camo-Grip",
            "color": "CAMO",
            "size": "Standard",
            "selected_options": {
              "Color": "CAMO",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-camo-standard-grip?variant=51845877399922"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "CAMO"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, standard, standard-golf-grips, stick grip, stickgrip",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "CAMO"
    ]
  },
  {
    "id": "stick-grip-palm-swings",
    "brand": "Stick Grip",
    "model": "Palm Swings",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "style_forward",
    "non_black_color_count": 4,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Midsize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Midsize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Ivory",
      "Light Blue",
      "Pink",
      "Teal"
    ],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.49,
    "price_max": 34.95,
    "single_price_min": 13.49,
    "single_price_max": 34.95,
    "normalized_price_per_grip": 13.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/stick-grip-palm-springs-midsize-putter-grip-pink",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Screen_Shot_2025-03-19_at_2.09.04_PM.png?v=1744323543",
    "fit_tags": [],
    "product_count": 4,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Pink"
        ],
        "price": 34.95,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-palm-springs-midsize-putter-grip-pink",
        "handle": "stick-grip-palm-springs-midsize-putter-grip-pink",
        "shopify_variants": [
          {
            "id": "51845881004402",
            "gid": "gid://shopify/ProductVariant/51845881004402",
            "sku": "STG-Putter-Flamingo-Pink",
            "color": "Pink",
            "size": "Standard",
            "selected_options": {
              "Color": "Pink",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 34.95,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-palm-springs-midsize-putter-grip-pink?variant=51845881004402"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Pink"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Light Blue"
        ],
        "price": 34.95,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-palm-springs-midsize-putter-grip-light-blue",
        "handle": "stick-grip-palm-springs-midsize-putter-grip-light-blue",
        "shopify_variants": [
          {
            "id": "51898776945010",
            "gid": "gid://shopify/ProductVariant/51898776945010",
            "sku": "STG-Putter-Flamingo-LightBlue",
            "color": "Light Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Light Blue",
              "Grip Size": "Midsize"
            },
            "available": true,
            "price": 34.95,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-palm-springs-midsize-putter-grip-light-blue?variant=51898776945010"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Light Blue"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Teal"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-palmsprings-standard-grip-teal",
        "handle": "stick-grip-palmsprings-standard-grip-teal",
        "shopify_variants": [
          {
            "id": "51845878382962",
            "gid": "gid://shopify/ProductVariant/51845878382962",
            "sku": "STG-Flamingo-Teal-Grip",
            "color": "Teal",
            "size": "Standard",
            "selected_options": {
              "Color": "Teal",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-palmsprings-standard-grip-teal?variant=51845878382962"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Teal"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Ivory"
        ],
        "price": 13.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/stick-grip-palmsprings-standard-grip-ivory",
        "handle": "stick-grip-palmsprings-standard-grip-ivory",
        "shopify_variants": [
          {
            "id": "51845878350194",
            "gid": "gid://shopify/ProductVariant/51845878350194",
            "sku": "STG-Flamingo-Ivory-Grip",
            "color": "Ivory",
            "size": "Standard",
            "selected_options": {
              "Color": "Ivory",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/stick-grip-palmsprings-standard-grip-ivory?variant=51845878350194"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Ivory"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, standard, standard-golf-grips, stick grip, stickgrip",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Light Blue",
      "Teal",
      "Ivory"
    ]
  },
  {
    "id": "super-stroke-off-the-truck-zenergy-1-0p-17",
    "brand": "Super Stroke",
    "model": "\"Off the Truck\" Zenergy 1.0P 17\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-off-the-truck-zenergy-1-0p-17-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ss-zenergy-offthetruck-17-10pt-black1.jpg?v=1704305181",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 39.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/super-stroke-off-the-truck-zenergy-1-0p-17-putter-grip",
        "handle": "super-stroke-off-the-truck-zenergy-1-0p-17-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black",
              "White/Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40947365740605",
            "gid": "gid://shopify/ProductVariant/40947365740605",
            "sku": "SSG-083700",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-off-the-truck-zenergy-1-0p-17-putter-grip?variant=40947365740605"
          },
          {
            "id": "40947365773373",
            "gid": "gid://shopify/ProductVariant/40947365773373",
            "sku": "SSG-083702",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-off-the-truck-zenergy-1-0p-17-putter-grip?variant=40947365773373"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "17\", 49 under, All Products, arm lock, arm lock putter grip, belly, Brand_Super Stroke, Counter Balance, golf-grips, long, Long Putter, Long/Belly Putter, midsize, Model_Super Stroke Zenergy 17\" Tour, Model_Super Stroke Zenergy Tour, putter, putter grip, putter-grips, super stroke 1.0P, super stroke",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black"
    ]
  },
  {
    "id": "super-stroke-off-the-truck-zenergy-tour-3-0-17",
    "brand": "Super Stroke",
    "model": "\"Off the Truck\" Zenergy Tour 3.0 17\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-zenergy-tour-3-0-17-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Tour3.0-17-allcolors.jpg?v=1691343764",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 39.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/super-stroke-zenergy-tour-3-0-17-putter-grip",
        "handle": "super-stroke-zenergy-tour-3-0-17-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black",
              "White/Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40709438308413",
            "gid": "gid://shopify/ProductVariant/40709438308413",
            "sku": "SSG-083800",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-zenergy-tour-3-0-17-putter-grip?variant=40709438308413"
          },
          {
            "id": "40709438505021",
            "gid": "gid://shopify/ProductVariant/40709438505021",
            "sku": "SSG-083802",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-zenergy-tour-3-0-17-putter-grip?variant=40709438505021"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "17\", 49 under, All Products, arm lock, arm lock putter grip, belly, best-sellers, Brand_Super Stroke, Counter Balance, golf-grips, jumbo/oversize, long, Long Putter, Long/Belly Putter, Model_Super Stroke Zenergy 17\" Tour, Model_Super Stroke Zenergy Tour, putter, putter grip, putter-grips, super stro",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black",
      "White/Red"
    ]
  },
  {
    "id": "super-stroke-skull-series-super-stroke-flatso-1-0",
    "brand": "Super Stroke",
    "model": "\"Skull\" Series Super Stroke Flatso 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "\"Skull\" Series - Black/Green"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-flatso-1-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-skull-diag_grande_1f493833-254f-4457-991d-cd73edcc18e9.jpg?v=1636057123",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "\"Skull\" Series - Black/Green"
        ],
        "price": 21,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-flatso-1-0-putter-grip-with-countercore",
        "handle": "limited-edition-skull-series-super-stroke-flatso-1-0-putter-grip-with-countercore",
        "shopify_variants": [
          {
            "id": "39461759942717",
            "gid": "gid://shopify/ProductVariant/39461759942717",
            "sku": "SSG-S013124",
            "color": "\"Skull\" Series - Black/Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "\"Skull\" Series - Black/Green"
            },
            "available": true,
            "price": 21,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-flatso-1-0-putter-grip-with-countercore?variant=39461759942717"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "\"Skull\" Series - Black/Green"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "1.0, 49 under, All products, Counter Balance, Countercore, Flatso, limited edition, midsize, midsize-golf-grips, New for 2016, non-tapered, putter, single-grip, Size_Midsize, Size_Standard, Skull Series, standard, standard-size-golf-grips, super-stroke, super-stroke-1-0-putter-grips, super-stroke-se",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "\"Skull\" Series - Black/Green"
    ]
  },
  {
    "id": "super-stroke-skull-series-super-stroke-mid-slim-2-0",
    "brand": "Super Stroke",
    "model": "\"Skull\" Series Super Stroke Mid Slim 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "slim pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "\"Skull\" Series - Black/Green"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-mid-slim-2-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-skull-diag_grande_28d0aac4-868b-4afa-aeac-ef00e3fde42a.jpg?v=1636056990",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "\"Skull\" Series - Black/Green"
        ],
        "price": 21,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-mid-slim-2-0-putter-grip-with-countercore",
        "handle": "limited-edition-skull-series-super-stroke-mid-slim-2-0-putter-grip-with-countercore",
        "shopify_variants": [
          {
            "id": "39461760008253",
            "gid": "gid://shopify/ProductVariant/39461760008253",
            "sku": "SSG-S012224",
            "color": "\"Skull\" Series - Black/Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "\"Skull\" Series - Black/Green"
            },
            "available": true,
            "price": 21,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-mid-slim-2-0-putter-grip-with-countercore?variant=39461760008253"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "\"Skull\" Series - Black/Green"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All products, Counter Balance, Countercore, limited edition, Mid Slim, midsize, midsize-golf-grips, New for 2016, non-tapered, putter, single-grip, Size_Midsize, Skull Series, super-stroke, super-stroke-2-0-putter-grips, super-stroke-series-with-counter-core-technology, superstroke, u",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "\"Skull\" Series - Black/Green"
    ]
  },
  {
    "id": "super-stroke-skull-series-super-stroke-pistol-gt-2-0",
    "brand": "Super Stroke",
    "model": "\"Skull\" Series Super Stroke Pistol GT 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "\"Skull\" Series - Black/Green"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-2-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-skull-diag_grande_4eb45c89-545c-4d86-a430-b83036d62d42.jpg?v=1636059390",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "\"Skull\" Series - Black/Green"
        ],
        "price": 21,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-2-0-putter-grip-with-countercore",
        "handle": "super-stroke-pistol-2-0-putter-grip-with-countercore",
        "shopify_variants": [
          {
            "id": "39461766725693",
            "gid": "gid://shopify/ProductVariant/39461766725693",
            "sku": "SSG-S015124",
            "color": "\"Skull\" Series - Black/Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "\"Skull\" Series - Black/Green"
            },
            "available": true,
            "price": 21,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-2-0-putter-grip-with-countercore?variant=39461766725693"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "\"Skull\" Series - Black/Green"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All products, Counter Balance, Countercore, limited edition, midsize, midsize-golf-grips, New for 2016, non-tapered, pistol, Pistol GT, putter, single-grip, Size_Midsize, super-stroke, super-stroke-2-0-putter-grips, super-stroke-pistol-gt-gtr-putter-grips, super-stroke-series-with-cou",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "\"Skull\" Series - Black/Green"
    ]
  },
  {
    "id": "super-stroke-skull-series-super-stroke-pistol-gt-tour",
    "brand": "Super Stroke",
    "model": "\"Skull\" Series Super Stroke Pistol GT Tour",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "\"Skull\" Series - Black/Green"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-pistol-gt-tour-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-skull-diag_grande_83712045-0b5f-4b4a-be56-50865e4c5a7f.jpg?v=1636057008",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "\"Skull\" Series - Black/Green"
        ],
        "price": 21,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-pistol-gt-tour-putter-grip-with-countercore",
        "handle": "limited-edition-skull-series-super-stroke-pistol-gt-tour-putter-grip-with-countercore",
        "shopify_variants": [
          {
            "id": "39461759877181",
            "gid": "gid://shopify/ProductVariant/39461759877181",
            "sku": "SSG-S015024",
            "color": "\"Skull\" Series - Black/Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "\"Skull\" Series - Black/Green"
            },
            "available": true,
            "price": 21,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-pistol-gt-tour-putter-grip-with-countercore?variant=39461759877181"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "\"Skull\" Series - Black/Green"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Counter Balance, Countercore, limited edition, New for 2016, non-tapered, pistol, Pistol GT, putter, putter-grips, single-grip, Size_Standard, Skull Series, standard, standard-size-golf-grips, super-stroke, super-stroke-pistol-gt-gtr-putter-grips, super-stroke-series-with-cou",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "\"Skull\" Series - Black/Green"
    ]
  },
  {
    "id": "super-stroke-skull-series-super-stroke-slim-3-0",
    "brand": "Super Stroke",
    "model": "\"Skull\" Series Super Stroke Slim 3.0",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "\"Skull\" Series - Black/Green"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-slim-3-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-skull-diag_grande_ebf9f8e1-20c4-4da4-9755-7e75cdc5ac0c.jpg?v=1636057110",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "\"Skull\" Series - Black/Green"
        ],
        "price": 21,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-slim-3-0-putter-grip-with-countercore",
        "handle": "limited-edition-skull-series-super-stroke-slim-3-0-putter-grip-with-countercore",
        "shopify_variants": [
          {
            "id": "39461759975485",
            "gid": "gid://shopify/ProductVariant/39461759975485",
            "sku": "SSG-S011324",
            "color": "\"Skull\" Series - Black/Green",
            "size": "Unspecified",
            "selected_options": {
              "Color": "\"Skull\" Series - Black/Green"
            },
            "available": true,
            "price": 21,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/limited-edition-skull-series-super-stroke-slim-3-0-putter-grip-with-countercore?variant=39461759975485"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "\"Skull\" Series - Black/Green"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "3.0, 49 under, All products, Counter Balance, Countercore, jumbo/oversize, limited edition, New for 2016, non-tapered, oversize, oversize-jumbo-golf-grips, putter, single-grip, Size_Jumbo/Oversize, skull series, Slim, super-stroke, super-stroke-3-0-putter-grips, super-stroke-series-with-counter-core",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "\"Skull\" Series - Black/Green"
    ]
  },
  {
    "id": "super-stroke-series-2-0-putter-grip-not-including-50g-weight-13-75",
    "brand": "Super Stroke",
    "model": "+ Series 2.0 Putter Grip (not including 50g weight) - 13.75\"",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-plus-with-counter-core-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/legacy-plus-cc-20-allcolors_ad294a33-4b6a-43f6-b01a-b84c0e71cfa5.jpg?v=1636058178",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 1134,
        "total_g": 1133.980925,
        "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-plus-with-counter-core-putter-grip",
        "handle": "super-stroke-legacy-2-0-plus-with-counter-core-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Yellow"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1028614129",
            "gid": "gid://shopify/ProductVariant/1028614129",
            "sku": "SSG-40701",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 1134,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-plus-with-counter-core-putter-grip?variant=1028614129"
          },
          {
            "id": "1028614149",
            "gid": "gid://shopify/ProductVariant/1028614149",
            "sku": "SSG-40712",
            "color": "Yellow",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 1134,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-plus-with-counter-core-putter-grip?variant=1028614149"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "'+ Series, 2.0, 49 under, 58 core, All products, Brand_Super Stroke, long putter, midsize, midsize-golf-grips, Model_ Super Stroke +Series (XL - 13.75\"), non-tapered, plus series, putter, single-grip, Size_2.0, Size_Jumbo/Oversize, Size_Midsize, Style_Putter Grip, super-stroke, super-stroke-2-0-putt",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-series-3-0-putter-grip-not-including-50g-weight",
    "brand": "Super Stroke",
    "model": "+ Series 3.0 Putter Grip (not including 50g weight)",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 104.3
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-legacy-plus-3-0-with-counter-core-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/legacy-plus-cc-30-allcolors_86250fe2-6dfa-4d77-a0c6-4501dc83a824.jpg?v=1636054231",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 29.99,
        "per_grip_g": 104.3,
        "total_g": 104.3262451,
        "url": "https://www.grips4less.com/products/super-stroke-legacy-plus-3-0-with-counter-core-putter-grip",
        "handle": "super-stroke-legacy-plus-3-0-with-counter-core-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Yellow"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1028614637",
            "gid": "gid://shopify/ProductVariant/1028614637",
            "sku": "SSG-40801",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 104.3,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-plus-3-0-with-counter-core-putter-grip?variant=1028614637"
          },
          {
            "id": "1028614657",
            "gid": "gid://shopify/ProductVariant/1028614657",
            "sku": "SSG-40812",
            "color": "Yellow",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 104.3,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-plus-3-0-with-counter-core-putter-grip?variant=1028614657"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "'+ Series, 3.0, 49 under, 58 core, All products, jumbo/oversize, non-tapered, plus series, putter, single-grip, Size_Jumbo/Oversize, Slim, super-stroke, super-stroke-3-0-putter-grips, under-150, With Counter Core",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Yellow"
    ]
  },
  {
    "id": "super-stroke-series-2-0-countercore-flatso-xl-13-75",
    "brand": "Super Stroke",
    "model": "+Series 2.0 CounterCore Flatso XL (13.75\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 26.99,
    "price_max": 26.99,
    "single_price_min": 26.99,
    "single_price_max": 26.99,
    "normalized_price_per_grip": 26.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-plus-with-counter-core-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/flatso20-plus-with-counter-core-allcolors.jpeg?v=1735456432",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 26.99,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-plus-with-counter-core-putter-grip",
        "handle": "super-stroke-flatso-2-0-plus-with-counter-core-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Yellow"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1028616081",
            "gid": "gid://shopify/ProductVariant/1028616081",
            "sku": "SSG-40901",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 26.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-plus-with-counter-core-putter-grip?variant=1028616081"
          },
          {
            "id": "1028616085",
            "gid": "gid://shopify/ProductVariant/1028616085",
            "sku": "SSG-40912",
            "color": "Yellow",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow"
            },
            "available": false,
            "price": 26.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-plus-with-counter-core-putter-grip?variant=1028616085"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 2023-sale, 49 under, All Products, Counter Balance, Countercore, Flatso, golf-grips, mid-ov-putter-sale, midsize, midsize-golf-grips, non-tapered, Plus XL, Plus XL Series, putter, putter grip, single-golf-grips, single-grip, super-stroke, super-stroke-2-0-putter-grips, super-stroke-plus-xl-seri",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-1-0pt",
    "brand": "Super Stroke",
    "model": "1.0PT",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/Wht"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-1-0pt-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/superstroke-10pt-puttergrip.jpg?v=1594685382",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/Wht"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-1-0pt-putter-grip",
        "handle": "super-stroke-1-0pt-putter-grip",
        "shopify_variants": [
          {
            "id": "31983652143165",
            "gid": "gid://shopify/ProductVariant/31983652143165",
            "sku": "SSG-073001",
            "color": "Black/Wht",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/Wht"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-1-0pt-putter-grip?variant=31983652143165"
          },
          {
            "id": "31983652175933",
            "gid": "gid://shopify/ProductVariant/31983652175933",
            "sku": "SSG-073000",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-1-0pt-putter-grip?variant=31983652175933"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/Wht",
              "Wht/Red/Gry"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "1.0, 1.0 PT, 1.0PT, 49 under, All Products, Counter Balance, Countercore, golf-grips, golfers-gift-guide, laborday-2022, mid-ov-putter-sale, midsize, midsize-golf-grips, new arrivals, non-tapered, pistol, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, summer-overstock-2022, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-17-belly",
    "brand": "Super Stroke",
    "model": "17\" Belly",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black / White"
    ],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 18,
    "price_max": 18,
    "single_price_min": 18,
    "single_price_max": 18,
    "normalized_price_per_grip": 18,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-slim-lite-belly-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-belly-slim2_ff4e5897-04f5-4518-a943-f80635f26121.jpg?v=1636055898",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black / White"
        ],
        "price": 18,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/super-stroke-slim-lite-belly-putter-grip",
        "handle": "super-stroke-slim-lite-belly-putter-grip",
        "shopify_variants": [
          {
            "id": "39461784322109",
            "gid": "gid://shopify/ProductVariant/39461784322109",
            "sku": "SSG-13321",
            "color": "Black / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White"
            },
            "available": true,
            "price": 18,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-slim-lite-belly-putter-grip?variant=39461784322109"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "17\", 49 under, All products, belly, New for 2014, New for 2015, non-tapered, putter, putter-grips, single-grip, super-stroke, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / White"
    ]
  },
  {
    "id": "super-stroke-21-belly",
    "brand": "Super Stroke",
    "model": "21\" Belly",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black / White"
    ],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9.6,
    "price_max": 9.6,
    "single_price_min": 9.6,
    "single_price_max": 9.6,
    "normalized_price_per_grip": 9.6,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-slim-lite-21-belly-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/belly21black.jpg?v=1636053038",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black / White"
        ],
        "price": 9.6,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/super-stroke-slim-lite-21-belly-putter-grip",
        "handle": "super-stroke-slim-lite-21-belly-putter-grip",
        "shopify_variants": [
          {
            "id": "39461776162877",
            "gid": "gid://shopify/ProductVariant/39461776162877",
            "sku": "SSG-13311",
            "color": "Black / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White"
            },
            "available": true,
            "price": 9.6,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-slim-lite-21-belly-putter-grip?variant=39461776162877"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "17\", 49 under, All products, belly, New for 2014, non-tapered, putter, putter-grips, single-grip, super-stroke, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / White"
    ]
  },
  {
    "id": "super-stroke-counter-balance-weight-insert-25g-50g-or-75g",
    "brand": "Super Stroke",
    "model": "Counter Balance Weight Insert - 25g, 50g, or 75g",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "weight_insert",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single",
      "9pc bundle"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 45.4
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 9.99,
    "price_max": 80.92,
    "single_price_min": 9.99,
    "single_price_max": 9.99,
    "normalized_price_per_grip": 8.99,
    "bundle_price_min": 80.92,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-50g-weight",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/weight-insert-3options_1f95e2ff-4e90-4be0-97f4-6a0f10148258.jpg?v=1735455621",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "9pc bundle",
        "colors": [],
        "price": 80.92,
        "per_grip_g": 45.4,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/super-stroke-50g-weight-grip-bundle-set",
        "handle": "super-stroke-50g-weight-grip-bundle-set",
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "25g Weight",
              "50g Weight",
              "75g Weight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "41021968547901",
            "gid": "gid://shopify/ProductVariant/41021968547901",
            "sku": "SET-9xSSG-013710",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "25g Weight"
            },
            "available": true,
            "price": 80.92,
            "weight_g": 408.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-50g-weight-grip-bundle-set?variant=41021968547901"
          },
          {
            "id": "41021968580669",
            "gid": "gid://shopify/ProductVariant/41021968580669",
            "sku": "SET-9xSSG-013702",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "50g Weight"
            },
            "available": true,
            "price": 80.92,
            "weight_g": 571.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-50g-weight-grip-bundle-set?variant=41021968580669"
          },
          {
            "id": "41021968613437",
            "gid": "gid://shopify/ProductVariant/41021968613437",
            "sku": "SET-9xSSG-013711",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "75g Weight"
            },
            "available": true,
            "price": 80.92,
            "weight_g": 816.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-50g-weight-grip-bundle-set?variant=41021968613437"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 9.99,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/super-stroke-50g-weight",
        "handle": "super-stroke-50g-weight",
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "25g Weight",
              "50g Weight",
              "75g Weight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "33384368071",
            "gid": "gid://shopify/ProductVariant/33384368071",
            "sku": "SSG-013710",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "25g Weight"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 45.4,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-50g-weight?variant=33384368071"
          },
          {
            "id": "1028617337",
            "gid": "gid://shopify/ProductVariant/1028617337",
            "sku": "SSG-013702",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "50g Weight"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-50g-weight?variant=1028617337"
          },
          {
            "id": "33384373319",
            "gid": "gid://shopify/ProductVariant/33384373319",
            "sku": "SSG-013711",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "75g Weight"
            },
            "available": true,
            "price": 9.99,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-50g-weight?variant=33384373319"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "All Products, Counter Balance, Countercore, golf-grips, grip bundle, mem25, New for 2016, new-bundle-set, Plus XL, prime-2025, putter, putter-grips, super-stroke, super-stroke-series-with-counter-core-technology, superstroke, under-150, under-300, video=rysDcG2Iuq0, Weight Insert, XL Counter Core",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-deep-etched",
    "brand": "Super Stroke",
    "model": "Deep Etched",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 15.99,
    "price_max": 15.99,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-deep-etched-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/DeepEtched_Black_Front-1600.jpg?v=1753383754",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-deep-etched-putter-grip",
        "handle": "super-stroke-deep-etched-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52514958016882",
            "gid": "gid://shopify/ProductVariant/52514958016882",
            "sku": "SSG-225001",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-deep-etched-putter-grip?variant=52514958016882"
          },
          {
            "id": "52514958049650",
            "gid": "gid://shopify/ProductVariant/52514958049650",
            "sku": "SSG-225000",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-deep-etched-putter-grip?variant=52514958049650"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, lamkin, Lamkin Deep Etched Putter, Lamkin Putter, Model_Super Stroke Deep Etched, putter, putter grip, putter-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, super stroke, super stroke deep etched, Super Stroke Putter Grip, under-150, under-",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "White"
    ]
  },
  {
    "id": "super-stroke-deep-etched-cord",
    "brand": "Super Stroke",
    "model": "Deep Etched CORD",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 19.99,
    "price_max": 19.99,
    "single_price_min": 19.99,
    "single_price_max": 19.99,
    "normalized_price_per_grip": 19.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-deep-etched-cord-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/DeepEtchedCord_Black_Front-1600.jpg?v=1753383766",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 19.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-deep-etched-cord-putter-grip",
        "handle": "super-stroke-deep-etched-cord-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52514957951346",
            "gid": "gid://shopify/ProductVariant/52514957951346",
            "sku": "SSG-225201",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-deep-etched-cord-putter-grip?variant=52514957951346"
          },
          {
            "id": "52514957984114",
            "gid": "gid://shopify/ProductVariant/52514957984114",
            "sku": "SSG-225200",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-deep-etched-cord-putter-grip?variant=52514957984114"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, cord, deep etched cord, golf-grips, lamkin, Lamkin Deep Etched Putter, Lamkin Putter, Model_Super Stroke Deep Etched, putter, putter cord grip, putter grip, putter-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, super stroke, super stroke deep etched, S",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White"
    ]
  },
  {
    "id": "super-stroke-deep-etched-smooth",
    "brand": "Super Stroke",
    "model": "Deep Etched SMOOTH",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Standard": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 15.99,
    "price_max": 15.99,
    "single_price_min": 15.99,
    "single_price_max": 15.99,
    "normalized_price_per_grip": 15.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-deep-etched-smooth-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/DeepEtchedSmooth_Black_Front-1600.jpg?v=1753383742",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-deep-etched-smooth-putter-grip",
        "handle": "super-stroke-deep-etched-smooth-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "White"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "52514958115186",
            "gid": "gid://shopify/ProductVariant/52514958115186",
            "sku": "SSG-225101",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-deep-etched-smooth-putter-grip?variant=52514958115186"
          },
          {
            "id": "52514958147954",
            "gid": "gid://shopify/ProductVariant/52514958147954",
            "sku": "SSG-225100",
            "color": "White",
            "size": "Standard",
            "selected_options": {
              "Color": "White",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 15.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-deep-etched-smooth-putter-grip?variant=52514958147954"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, cord, deep etched smooth, golf-grips, lamkin, Lamkin Deep Etched Putter, Lamkin Putter, Model_Super Stroke Deep Etched, putter, putter cord grip, putter grip, putter-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, super stroke, super stroke deep etched,",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "White"
    ]
  },
  {
    "id": "super-stroke-fatso-5-0-putter-grip-with-countercore-50g-weight",
    "brand": "Super Stroke",
    "model": "Fatso 5.0 Putter Grip with CounterCore 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "round oversize (no-taper)",
    "putter_size": "5.0",
    "putter_size_class": "5.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 104.3
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 31.49,
    "price_max": 31.49,
    "single_price_min": 31.49,
    "single_price_max": 31.49,
    "normalized_price_per_grip": 31.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-fatso-5-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/50-w-cc-allcolors.jpg?v=1735456376",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 31.49,
        "per_grip_g": 104.3,
        "total_g": 104.3262451,
        "url": "https://www.grips4less.com/products/super-stroke-fatso-5-0-putter-grip-with-countercore",
        "handle": "super-stroke-fatso-5-0-putter-grip-with-countercore",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14866431175",
            "gid": "gid://shopify/ProductVariant/14866431175",
            "sku": "SSG-060301",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 104.3,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-fatso-5-0-putter-grip-with-countercore?variant=14866431175"
          },
          {
            "id": "14866431367",
            "gid": "gid://shopify/ProductVariant/14866431367",
            "sku": "SSG-060323",
            "color": "Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue Midnight"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 104.3,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-fatso-5-0-putter-grip-with-countercore?variant=14866431367"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2023-sale, 49 under, 5.0, 58 core, All products, Counter Balance, Countercore, Fatso, jumbo/oversize, New for 2016, non-tapered, oversize, oversize-jumbo-golf-grips, putter, single-grip, Size_Jumbo/Oversize, suoer-stroke-5-0-putter-grips, super-stroke, super-stroke-series-with-counter-core-technolog",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-flatso-1-0",
    "brand": "Super Stroke",
    "model": "Flatso 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 15,
    "price_max": 15,
    "single_price_min": 15,
    "single_price_max": 15,
    "normalized_price_per_grip": 15,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/flatso-10-black_f42909a0-8877-42f5-866c-63ee4826b40f.jpg?v=1636054250",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-putter-grip",
        "handle": "super-stroke-flatso-1-0-putter-grip",
        "shopify_variants": [
          {
            "id": "1028596461",
            "gid": "gid://shopify/ProductVariant/1028596461",
            "sku": "SSG-40401",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-putter-grip?variant=1028596461"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "1.0, 49 under, 58 core, All products, Flatso, Midsize, midsize-golf-grips, New for 2015, non-tapered, putter, single-grip, Size_Midsize, Size_Standard, standard, standard-size-golf-grips, super-stroke, super-stroke-1-0-putter-grips, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "super-stroke-flatso-1-0-putter-grip-with-countercore-50g-weight",
    "brand": "Super Stroke",
    "model": "Flatso 1.0 Putter Grip with CounterCore 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 31.49,
    "price_max": 31.49,
    "single_price_min": 31.49,
    "single_price_max": 31.49,
    "normalized_price_per_grip": 31.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/cc-flatso10-weight.jpg?v=1735456374",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 31.49,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-putter-grip-with-countercore",
        "handle": "super-stroke-flatso-1-0-putter-grip-with-countercore",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14866502855",
            "gid": "gid://shopify/ProductVariant/14866502855",
            "sku": "SSG-060401",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-putter-grip-with-countercore?variant=14866502855"
          },
          {
            "id": "14866563463",
            "gid": "gid://shopify/ProductVariant/14866563463",
            "sku": "SSG-060402",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-putter-grip-with-countercore?variant=14866563463"
          },
          {
            "id": "14866577735",
            "gid": "gid://shopify/ProductVariant/14866577735",
            "sku": "SSG-060403",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-putter-grip-with-countercore?variant=14866577735"
          },
          {
            "id": "14866502919",
            "gid": "gid://shopify/ProductVariant/14866502919",
            "sku": "SSG-060423",
            "color": "Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue Midnight"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-putter-grip-with-countercore?variant=14866502919"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 2023-sale, 49 under, All Products, Counter Balance, Countercore, Countercore (50g) weight included, Flatso, Flatso Countercore, golf-grips, includes weight, mid-ov-putter-sale, midsize, midsize-golf-grips, New for 2016, non-tapered, putter, putter grip, single-grip, standard, standard-size-golf",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-flatso-2-0",
    "brand": "Super Stroke",
    "model": "Flatso 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 15,
    "price_max": 15,
    "single_price_min": 15,
    "single_price_max": 15,
    "normalized_price_per_grip": 15,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/flatso-20-black_8bec5aa7-f21d-4ab2-b893-bbc8af3dd46e.jpg?v=1636054243",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-putter-grip",
        "handle": "super-stroke-flatso-2-0-putter-grip",
        "shopify_variants": [
          {
            "id": "1028596637",
            "gid": "gid://shopify/ProductVariant/1028596637",
            "sku": "SSG-40501",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-putter-grip?variant=1028596637"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All products, Flatso, jumbo/oversize, New for 2015, non-tapered, putter, single-grip, Size_Jumbo/Oversize, super-stroke, super-stroke-2-0-putter-grips, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black"
    ]
  },
  {
    "id": "super-stroke-flatso-2-0-putter-grip-with-countercore-50g-weight",
    "brand": "Super Stroke",
    "model": "Flatso 2.0 Putter Grip with CounterCore 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 31.49,
    "price_max": 31.49,
    "single_price_min": 31.49,
    "single_price_max": 31.49,
    "normalized_price_per_grip": 31.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/cc-flatso20-weight.jpg?v=1735456372",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 31.49,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-putter-grip-with-countercore",
        "handle": "super-stroke-flatso-2-0-putter-grip-with-countercore",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14866782535",
            "gid": "gid://shopify/ProductVariant/14866782535",
            "sku": "SSG-060501",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-putter-grip-with-countercore?variant=14866782535"
          },
          {
            "id": "14866782599",
            "gid": "gid://shopify/ProductVariant/14866782599",
            "sku": "SSG-060502",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-putter-grip-with-countercore?variant=14866782599"
          },
          {
            "id": "14866782727",
            "gid": "gid://shopify/ProductVariant/14866782727",
            "sku": "SSG-060523",
            "color": "Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue Midnight"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-putter-grip-with-countercore?variant=14866782727"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 2023-sale, 49 under, All Products, Counter Balance, Countercore, Countercore (50g) weight included, Flatso, Flatso Countercore, golf-grips, includes weight, Mid Slim, mid-ov-putter-sale, midsize, midsize-golf-grips, New for 2016, non-tapered, putter, putter grip, single-grip, super-stroke, supe",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-flatso-3-0",
    "brand": "Super Stroke",
    "model": "Flatso 3.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 15,
    "price_max": 15,
    "single_price_min": 15,
    "single_price_max": 15,
    "normalized_price_per_grip": 15,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/flatso20-2colors_ed33992b-37e3-41a2-a26a-45ad4a408d09.jpg?v=1636054236",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-putter-grip",
        "handle": "super-stroke-flatso-3-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Black / White Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1028596681",
            "gid": "gid://shopify/ProductVariant/1028596681",
            "sku": "SSG-40601",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-putter-grip?variant=1028596681"
          },
          {
            "id": "40258752007",
            "gid": "gid://shopify/ProductVariant/40258752007",
            "sku": "SSG-40626",
            "color": "Black / White Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White Midnight"
            },
            "available": false,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-putter-grip?variant=40258752007"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "3.0, 49 under, All products, Flatso, jumbo/oversize, New for 2015, non-tapered, putter, single-grip, Size_Jumbo/Oversize, super-stroke, super-stroke-3-0-putter-grips, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-flatso-3-0-putter-grip-with-countercore-50g-weight",
    "brand": "Super Stroke",
    "model": "Flatso 3.0 Putter Grip with CounterCore 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/cc-flatso30-weight.jpg?v=1590526513",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 34.99,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-putter-grip-with-countercore",
        "handle": "super-stroke-flatso-3-0-putter-grip-with-countercore",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14866893191",
            "gid": "gid://shopify/ProductVariant/14866893191",
            "sku": "SSG-060601",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-putter-grip-with-countercore?variant=14866893191"
          },
          {
            "id": "14866893319",
            "gid": "gid://shopify/ProductVariant/14866893319",
            "sku": "SSG-060623",
            "color": "Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue Midnight"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-putter-grip-with-countercore?variant=14866893319"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "3.0, 49 under, All Products, Counter Balance, Countercore, Countercore (50g) weight included, Flatso, Flatso Countercore, golf-grips, includes weight, infinite-opt-addkit, jumbo/oversize, mid-ov-putter-sale, New for 2016, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, single-",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-flatso-ultra-1-1",
    "brand": "Super Stroke",
    "model": "Flatso Ultra 1.1",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12,
    "price_max": 12,
    "single_price_min": 12,
    "single_price_max": 12,
    "normalized_price_per_grip": 12,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-ultra-1-1-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Flatso_ULTRA_Grey_HR.jpg?v=1636052328",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 12,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-ultra-1-1-putter-grip",
        "handle": "super-stroke-flatso-ultra-1-1-putter-grip",
        "shopify_variants": [
          {
            "id": "39461777932349",
            "gid": "gid://shopify/ProductVariant/39461777932349",
            "sku": "SSG-13540",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Style": "Flatso Ultra 1.1 (Gray)"
            },
            "available": true,
            "price": 12,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-ultra-1-1-putter-grip?variant=39461777932349"
          }
        ],
        "shopify_options": [
          {
            "name": "Style",
            "values": [
              "Flatso Ultra 1.1 (Gray)"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Flatso, midsize, midsize-golf-grips, New for 2014, non-tapered, putter, putter-grips, single-grip, Size_Midsize, super-stroke, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-legacy-1-0",
    "brand": "Super Stroke",
    "model": "Legacy 1.0",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12,
    "price_max": 12,
    "single_price_min": 12,
    "single_price_max": 12,
    "normalized_price_per_grip": 12,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-legacy-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/legacy-1.0-4colors_38b044aa-dfe9-43ab-bb21-4560ef60e5e3.jpg?v=1636058208",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 12,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/super-stroke-legacy-1-0-putter-grip",
        "handle": "super-stroke-legacy-1-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Black / White Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1028589565",
            "gid": "gid://shopify/ProductVariant/1028589565",
            "sku": "SSG-40001",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 12,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-1-0-putter-grip?variant=1028589565"
          },
          {
            "id": "1028589573",
            "gid": "gid://shopify/ProductVariant/1028589573",
            "sku": "SSG-40002",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 12,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-1-0-putter-grip?variant=1028589573"
          },
          {
            "id": "1028589577",
            "gid": "gid://shopify/ProductVariant/1028589577",
            "sku": "SSG-40003",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 12,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-1-0-putter-grip?variant=1028589577"
          },
          {
            "id": "40255913095",
            "gid": "gid://shopify/ProductVariant/40255913095",
            "sku": "SSG-40026",
            "color": "Black / White Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White Midnight"
            },
            "available": true,
            "price": 12,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-1-0-putter-grip?variant=40255913095"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All products, Legacy, midsize, midsize-golf-grips, New for 2015, non-tapered, putter, single-grip, Size_Midsize, Size_Standard, standard, standard-size-golf-grips, super-stroke, super-stroke-1-0-putter-grips, Ultra Slim, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red",
      "Blue",
      "Black / White Midnight"
    ]
  },
  {
    "id": "super-stroke-legacy-2-0",
    "brand": "Super Stroke",
    "model": "Legacy 2.0",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 15,
    "price_max": 15,
    "single_price_min": 15,
    "single_price_max": 15,
    "normalized_price_per_grip": 15,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-legacy-20_048e78dd-bd9d-4b20-ac5c-408235d6af66.jpg?v=1636058066",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 15,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-putter-grip",
        "handle": "super-stroke-legacy-2-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Black / Red Midnight",
              "Black / Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1028589373",
            "gid": "gid://shopify/ProductVariant/1028589373",
            "sku": "SSG-40101",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-putter-grip?variant=1028589373"
          },
          {
            "id": "1028589377",
            "gid": "gid://shopify/ProductVariant/1028589377",
            "sku": "SSG-40102",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 15,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-putter-grip?variant=1028589377"
          },
          {
            "id": "1028589381",
            "gid": "gid://shopify/ProductVariant/1028589381",
            "sku": "SSG-40103",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-putter-grip?variant=1028589381"
          },
          {
            "id": "40256383367",
            "gid": "gid://shopify/ProductVariant/40256383367",
            "sku": "SSG-40122",
            "color": "Black / Red Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Red Midnight"
            },
            "available": true,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-putter-grip?variant=40256383367"
          },
          {
            "id": "40256385351",
            "gid": "gid://shopify/ProductVariant/40256385351",
            "sku": "SSG-40123",
            "color": "Black / Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Blue Midnight"
            },
            "available": true,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-2-0-putter-grip?variant=40256385351"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All products, Legacy, Mid Slim, midsize, midsize-golf-grips, New for 2015, non-tapered, putter, single-grip, Size_Midsize, super-stroke, super-stroke-2-0-putter-grips, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Red",
      "Blue",
      "Black / Red Midnight",
      "Black / Blue Midnight"
    ]
  },
  {
    "id": "super-stroke-legacy-3-0",
    "brand": "Super Stroke",
    "model": "Legacy 3.0",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 19,
    "price_max": 19,
    "single_price_min": 19,
    "single_price_max": 19,
    "normalized_price_per_grip": 19,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-legacy-3-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/legacy30-10colors.jpg?v=1636054116",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 19,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-legacy-3-0-putter-grip",
        "handle": "super-stroke-legacy-3-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Yellow",
              "Red",
              "Blue",
              "Black / White Midnight",
              "Black / Red Midnight",
              "Black / Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "16560730823",
            "gid": "gid://shopify/ProductVariant/16560730823",
            "sku": "SSG-40201",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 19,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-3-0-putter-grip?variant=16560730823"
          },
          {
            "id": "39467263688765",
            "gid": "gid://shopify/ProductVariant/39467263688765",
            "sku": "SSG-40212",
            "color": "Yellow",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow"
            },
            "available": false,
            "price": 19,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-3-0-putter-grip?variant=39467263688765"
          },
          {
            "id": "18456626439",
            "gid": "gid://shopify/ProductVariant/18456626439",
            "sku": "SSG-40202",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 19,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-3-0-putter-grip?variant=18456626439"
          },
          {
            "id": "1028589437",
            "gid": "gid://shopify/ProductVariant/1028589437",
            "sku": "SSG-40203",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 19,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-3-0-putter-grip?variant=1028589437"
          },
          {
            "id": "40257843591",
            "gid": "gid://shopify/ProductVariant/40257843591",
            "sku": "SSG-40226",
            "color": "Black / White Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White Midnight"
            },
            "available": false,
            "price": 19,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-3-0-putter-grip?variant=40257843591"
          },
          {
            "id": "40257805639",
            "gid": "gid://shopify/ProductVariant/40257805639",
            "sku": "SSG-40222",
            "color": "Black / Red Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Red Midnight"
            },
            "available": false,
            "price": 19,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-3-0-putter-grip?variant=40257805639"
          },
          {
            "id": "40257831687",
            "gid": "gid://shopify/ProductVariant/40257831687",
            "sku": "SSG-40223",
            "color": "Black / Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Blue Midnight"
            },
            "available": false,
            "price": 19,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-3-0-putter-grip?variant=40257831687"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "3.0, 49 under, All products, jumbo/oversize, Legacy, New for 2015, non-tapered, putter, single-grip, Size_Jumbo/Oversize, Slim, super-stroke, super-stroke-3-0-putter-grips, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-legacy-5-0",
    "brand": "Super Stroke",
    "model": "Legacy 5.0",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "5.0",
    "putter_size_class": "5.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 15,
    "price_max": 15,
    "single_price_min": 15,
    "single_price_max": 15,
    "normalized_price_per_grip": 15,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-legacy-5-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/legacy-50-blue_b6d07e1e-5ca6-4f5c-b3e4-58463a57337a.jpg?v=1636053889",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 15,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-legacy-5-0-putter-grip",
        "handle": "super-stroke-legacy-5-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Black / White Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "1028589257",
            "gid": "gid://shopify/ProductVariant/1028589257",
            "sku": "SSG-40303",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-5-0-putter-grip?variant=1028589257"
          },
          {
            "id": "40258017159",
            "gid": "gid://shopify/ProductVariant/40258017159",
            "sku": "SSG-40326",
            "color": "Black / White Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White Midnight"
            },
            "available": true,
            "price": 15,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-legacy-5-0-putter-grip?variant=40258017159"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, 5.0, All products, Fatso, jumbo/oversize, Legacy, New for 2015, non-tapered, putter, single-grip, Size_Jumbo/Oversize, suoer-stroke-5-0-putter-grips, super-stroke, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "Black / White Midnight"
    ]
  },
  {
    "id": "super-stroke-mid-slim-2-0-putter-grip-with-countercore-50g-weight",
    "brand": "Super Stroke",
    "model": "Mid Slim 2.0 Putter Grip with CounterCore 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "slim pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-mid-slim-2-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/cc-midslim20-weight.jpg?v=1590526514",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 34.99,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-mid-slim-2-0-putter-grip-with-countercore",
        "handle": "super-stroke-mid-slim-2-0-putter-grip-with-countercore",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Lime",
              "Blue Midnight",
              "Yellow Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14866113863",
            "gid": "gid://shopify/ProductVariant/14866113863",
            "sku": "SSG-060101",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-mid-slim-2-0-putter-grip-with-countercore?variant=14866113863"
          },
          {
            "id": "14866275143",
            "gid": "gid://shopify/ProductVariant/14866275143",
            "sku": "SSG-060102",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-mid-slim-2-0-putter-grip-with-countercore?variant=14866275143"
          },
          {
            "id": "14866279431",
            "gid": "gid://shopify/ProductVariant/14866279431",
            "sku": "SSG-060103",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-mid-slim-2-0-putter-grip-with-countercore?variant=14866279431"
          },
          {
            "id": "14866113927",
            "gid": "gid://shopify/ProductVariant/14866113927",
            "sku": "SSG-060104",
            "color": "Lime",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Lime"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-mid-slim-2-0-putter-grip-with-countercore?variant=14866113927"
          },
          {
            "id": "14866282567",
            "gid": "gid://shopify/ProductVariant/14866282567",
            "sku": "SSG-060123",
            "color": "Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue Midnight"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-mid-slim-2-0-putter-grip-with-countercore?variant=14866282567"
          },
          {
            "id": "14866285447",
            "gid": "gid://shopify/ProductVariant/14866285447",
            "sku": "SSG-060128",
            "color": "Yellow Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow Midnight"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-mid-slim-2-0-putter-grip-with-countercore?variant=14866285447"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, Counter Balance, Countercore, Countercore (50g) weight included, Countercore Slim, golf-grips, includes weight, infinite-opt-addkit, Legacy Countercore, Mid Slim, mid-ov-putter-sale, midsize, midsize-golf-grips, New for 2016, non-tapered, putter, putter grip, single-grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-midnight-ultra-slim-1-0",
    "brand": "Super Stroke",
    "model": "Midnight Ultra Slim 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "slim pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black / White"
    ],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12,
    "price_max": 12,
    "single_price_min": 12,
    "single_price_max": 12,
    "normalized_price_per_grip": 12,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-midnight-ultra-slim-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Ultra_Slim_Black_White.jpg?v=1636053044",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black / White"
        ],
        "price": 12,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/super-stroke-midnight-ultra-slim-1-0-putter-grip",
        "handle": "super-stroke-midnight-ultra-slim-1-0-putter-grip",
        "shopify_variants": [
          {
            "id": "39461776097341",
            "gid": "gid://shopify/ProductVariant/39461776097341",
            "sku": "SSG-13008",
            "color": "Black / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White"
            },
            "available": true,
            "price": 12,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-midnight-ultra-slim-1-0-putter-grip?variant=39461776097341"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Midnight, New for 2014, non-tapered, putter, putter-grips, single-grip, Size_Standard, standard, standard-size-golf-grips, super-stroke, super-stroke-1-0-putter-grips, Ultra Slim, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / White"
    ]
  },
  {
    "id": "super-stroke-odyssey-2-0-midslim",
    "brand": "Super Stroke",
    "model": "Odyssey 2.0 Midslim",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "slim pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-odyssey-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/odyssey-20-front_091834d8-7a76-4612-ae71-cce414e1af9f.jpg?v=1636058664",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 29.99,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-odyssey-2-0-putter-grip",
        "handle": "super-stroke-odyssey-2-0-putter-grip",
        "shopify_variants": [
          {
            "id": "1779872193",
            "gid": "gid://shopify/ProductVariant/1779872193",
            "sku": "SSG-13604",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Odyssey 2.0 Midslim Putter Grip"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 190.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-odyssey-2-0-putter-grip?variant=1779872193"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Odyssey 2.0 Midslim Putter Grip"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, Brand_Super Stroke, midsize, midsize-golf-grips, Model_Super Stroke Odyssey, non-tapered, odyssey, putter, single-grip, Size_2.0, Size_Midsize, Style_Putter Grip, super-stroke, super-stroke-2-0-putter-grips, under-150, video=rXTGZKWJHjk",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-odyssey-3-0-slim",
    "brand": "Super Stroke",
    "model": "Odyssey 3.0 Slim",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "SLIVER / BLUE"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-odyssey-3-0-slim-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/odyssey-30-front_6a88e0ad-29d4-4329-ab78-1c7f645c7014.jpg?v=1636058677",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "SLIVER / BLUE"
        ],
        "price": 29.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/super-stroke-odyssey-3-0-slim-putter-grip",
        "handle": "super-stroke-odyssey-3-0-slim-putter-grip",
        "shopify_variants": [
          {
            "id": "39461768265789",
            "gid": "gid://shopify/ProductVariant/39461768265789",
            "sku": "SSG-13602",
            "color": "SLIVER / BLUE",
            "size": "Unspecified",
            "selected_options": {
              "Color": "SLIVER / BLUE"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-odyssey-3-0-slim-putter-grip?variant=39461768265789"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "SLIVER / BLUE"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "3.0, 49 under, All products, Brand_Super Stroke, jumbo/oversize, Model_Super Stroke Odyssey, non-tapered, odyssey, putter, Putter Length_Standard, single-grip, Size_3.0, Size_Jumbo/Oversize, Style_Putter Grip, super-stroke, super-stroke-3-0-putter-grips, under-150, video=rXTGZKWJHjk",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-odyssey-big-t-2-0-3-0",
    "brand": "Super Stroke",
    "model": "Odyssey Big T 2.0/3.0",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "2"
    ],
    "manufacturer_size_labels": [
      "2"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "2": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-odyssey-big-t-2-0-3-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/big-t_a43385bb-6f82-4447-a17e-236827d08210.jpg?v=1636059768",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "2"
        ],
        "format": "single",
        "colors": [],
        "price": 29.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/super-stroke-odyssey-big-t-2-0-3-0-putter-grip",
        "handle": "super-stroke-odyssey-big-t-2-0-3-0-putter-grip",
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "2",
              "3"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "876531810323",
            "gid": "gid://shopify/ProductVariant/876531810323",
            "sku": "SSG-013610",
            "color": "",
            "size": "2",
            "selected_options": {
              "Size": "2"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-odyssey-big-t-2-0-3-0-putter-grip?variant=876531810323"
          },
          {
            "id": "876531843091",
            "gid": "gid://shopify/ProductVariant/876531843091",
            "sku": "SSG-013611",
            "color": "",
            "size": "2",
            "selected_options": {
              "Size": "3"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-odyssey-big-t-2-0-3-0-putter-grip?variant=876531843091"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "3.0, 49 under, All products, Big T, Brand_Super Stroke, jumbo/oversize, Model_Super Stroke Odyssey, New for 2014, New for 2015, New for 2016, New for 2017, non-tapered, odyssey, Odyssey Big T, pistol, putter, single-grip, Size_2.0, Size_3.0, Size_Jumbo/Oversize, Slim, Style_Putter Grip, super-stroke",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-odyssey-tank",
    "brand": "Super Stroke",
    "model": "Odyssey Tank",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-odyssey-tank-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/odyssey-tank.jpg?v=1636058690",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 29.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/super-stroke-odyssey-tank-putter-grip",
        "handle": "super-stroke-odyssey-tank-putter-grip",
        "shopify_variants": [
          {
            "id": "30290543687",
            "gid": "gid://shopify/ProductVariant/30290543687",
            "sku": "SSG-13603",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Odyssey Tank Putter Grip"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-odyssey-tank-putter-grip?variant=30290543687"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Odyssey Tank Putter Grip"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All products, Brand_Super Stroke, midsize, midsize-golf-grips, Model_Super Stroke Odyssey, non-tapered, odyssey, putter, single-grip, Size_Jumbo/Oversize, Size_Midsize, Style_Putter Grip, super-stroke, under-150, video=rysDcG2Iuq0",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-odyssey-tank-cruiser",
    "brand": "Super Stroke",
    "model": "Odyssey Tank Cruiser",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-odyssey-tank-cruiser-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/odyssey-tank-cruiser_657d4243-9697-4607-9d35-bc3723d78f1c.jpg?v=1636056636",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 29.99,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/super-stroke-odyssey-tank-cruiser-putter-grip",
        "handle": "super-stroke-odyssey-tank-cruiser-putter-grip",
        "shopify_variants": [
          {
            "id": "30290868359",
            "gid": "gid://shopify/ProductVariant/30290868359",
            "sku": "SSG-13601",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Title": "Odyssey Tank Cruiser Putter Grip"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-odyssey-tank-cruiser-putter-grip?variant=30290868359"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Odyssey Tank Cruiser Putter Grip"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All products, midsize, midsize-golf-grips, non-tapered, odyssey, putter, single-grip, Size_Midsize, super-stroke, under-150, video=rysDcG2Iuq0",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-pistol-gt-1-0-putter-grip-with-countercore-50g-weight",
    "brand": "Super Stroke",
    "model": "Pistol GT 1.0 Putter Grip with CounterCore 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 31.49,
    "price_max": 31.49,
    "single_price_min": 31.49,
    "single_price_max": 31.49,
    "normalized_price_per_grip": 31.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-1-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/cc-pistolgt10-weight.jpg?v=1735456371",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 31.49,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-1-0-putter-grip-with-countercore",
        "handle": "super-stroke-pistol-1-0-putter-grip-with-countercore",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14867616519",
            "gid": "gid://shopify/ProductVariant/14867616519",
            "sku": "SSG-061201",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-1-0-putter-grip-with-countercore?variant=14867616519"
          },
          {
            "id": "14867616583",
            "gid": "gid://shopify/ProductVariant/14867616583",
            "sku": "SSG-061203",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-1-0-putter-grip-with-countercore?variant=14867616583"
          },
          {
            "id": "14867616647",
            "gid": "gid://shopify/ProductVariant/14867616647",
            "sku": "SSG-061223",
            "color": "Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue Midnight"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-1-0-putter-grip-with-countercore?variant=14867616647"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 2023-sale, 49 under, All Products, Counter Balance, Countercore, Countercore (50g) weight included, golf-grips, infinite-opt-addkit, mid-ov-putter-sale, midsize, midsize-golf-grips, New for 2016, non-tapered, pistol, Pistol GT, Pistol GT Countercore, putter, putter grip, single-grip, standard, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-pistol-gt-2-0-putter-grip-with-countercore-50g-weight",
    "brand": "Super Stroke",
    "model": "Pistol GT 2.0 Putter Grip with CounterCore 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-putter-grip-with-countercore-50g-weight",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/cc-pistolgt20-weight.jpg?v=1571438523",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 34.99,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-putter-grip-with-countercore-50g-weight",
        "handle": "super-stroke-pistol-gt-2-0-putter-grip-with-countercore-50g-weight",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "34972213447",
            "gid": "gid://shopify/ProductVariant/34972213447",
            "sku": "SSG-061301",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-putter-grip-with-countercore-50g-weight?variant=34972213447"
          },
          {
            "id": "34972213575",
            "gid": "gid://shopify/ProductVariant/34972213575",
            "sku": "SSG-061323",
            "color": "Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue Midnight"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-putter-grip-with-countercore-50g-weight?variant=34972213575"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, Counter Balance, Countercore, Countercore (50g) weight included, golf-grips, infinite-opt-addkit, mid-ov-putter-sale, midsize, midsize-golf-grips, Most Popular Midsize, New for 2016, non-tapered, pistol, Pistol GT, Pistol GT Countercore, putter, putter grip, single-grip,",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-pistol-gt-tour-putter-grip-with-countercore-50g-weight",
    "brand": "Super Stroke",
    "model": "Pistol GT Tour Putter Grip with CounterCore 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-tour-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/cc-pistolgttour-weight.jpg?v=1590526516",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 34.99,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-tour-putter-grip-with-countercore",
        "handle": "super-stroke-pistol-tour-putter-grip-with-countercore",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14867281095",
            "gid": "gid://shopify/ProductVariant/14867281095",
            "sku": "SSG-061101",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-tour-putter-grip-with-countercore?variant=14867281095"
          },
          {
            "id": "14867281223",
            "gid": "gid://shopify/ProductVariant/14867281223",
            "sku": "SSG-061103",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-tour-putter-grip-with-countercore?variant=14867281223"
          },
          {
            "id": "14867281287",
            "gid": "gid://shopify/ProductVariant/14867281287",
            "sku": "SSG-061123",
            "color": "Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue Midnight"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-tour-putter-grip-with-countercore?variant=14867281287"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, Counter Balance, Countercore, Countercore (50g) weight included, golf-grips, infinite-opt-addkit, New for 2016, non-tapered, pistol, Pistol GT, Pistol GT Countercore, putter, putter grip, single-grip, standard, standard-size-golf-grips, Super Stroke Pistol GT, super-stroke, s",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue"
    ]
  },
  {
    "id": "super-stroke-pistol-gtr-1-0",
    "brand": "Super Stroke",
    "model": "Pistol GTR 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/pgtr-10-5colors_b74eb433-1b23-402a-9d12-201d645dc683.jpg?v=1636061425",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 24.99,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-1-0-putter-grip",
        "handle": "super-stroke-pistol-gtr-1-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black",
              "White/Red",
              "Black/White Midnight",
              "Black/Red Midnight",
              "Black/Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39172532167",
            "gid": "gid://shopify/ProductVariant/39172532167",
            "sku": "SSG-41201",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-1-0-putter-grip?variant=39172532167"
          },
          {
            "id": "39172532231",
            "gid": "gid://shopify/ProductVariant/39172532231",
            "sku": "SSG-41202",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-1-0-putter-grip?variant=39172532231"
          },
          {
            "id": "39172532295",
            "gid": "gid://shopify/ProductVariant/39172532295",
            "sku": "SSG-41226",
            "color": "Black/White Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White Midnight"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-1-0-putter-grip?variant=39172532295"
          },
          {
            "id": "39172532359",
            "gid": "gid://shopify/ProductVariant/39172532359",
            "sku": "SSG-41222",
            "color": "Black/Red Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/Red Midnight"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-1-0-putter-grip?variant=39172532359"
          },
          {
            "id": "39172532423",
            "gid": "gid://shopify/ProductVariant/39172532423",
            "sku": "SSG-41223",
            "color": "Black/Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/Blue Midnight"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-1-0-putter-grip?variant=39172532423"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All products, Brand_Super Stroke, New for 2016, New for 2017, non-tapered, pistol, Pistol GTR, putter, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Putter Grip, super-stroke, super-stroke-1-0-putter-grips, super-stroke-pistol-gt-gtr-putter-grips, superstroke, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black",
      "White/Red",
      "Black/White Midnight",
      "Black/Red Midnight",
      "Black/Blue Midnight"
    ]
  },
  {
    "id": "super-stroke-pistol-gtr-2-0",
    "brand": "Super Stroke",
    "model": "Pistol GTR 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/pgtr-20-5colors_99f41a0a-7171-484c-b273-b5b8c2450aa3.jpg?v=1636061304",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 24.99,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-2-0-putter-grip",
        "handle": "super-stroke-pistol-gtr-2-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black",
              "White/Red",
              "Black/White Midnight",
              "Black/Red Midnight",
              "Black/Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39172946631",
            "gid": "gid://shopify/ProductVariant/39172946631",
            "sku": "SSG-41301",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-2-0-putter-grip?variant=39172946631"
          },
          {
            "id": "39172946759",
            "gid": "gid://shopify/ProductVariant/39172946759",
            "sku": "SSG-41302",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-2-0-putter-grip?variant=39172946759"
          },
          {
            "id": "39172946823",
            "gid": "gid://shopify/ProductVariant/39172946823",
            "sku": "SSG-41326",
            "color": "Black/White Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White Midnight"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-2-0-putter-grip?variant=39172946823"
          },
          {
            "id": "39172946951",
            "gid": "gid://shopify/ProductVariant/39172946951",
            "sku": "SSG-41322",
            "color": "Black/Red Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/Red Midnight"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-2-0-putter-grip?variant=39172946951"
          },
          {
            "id": "39172947015",
            "gid": "gid://shopify/ProductVariant/39172947015",
            "sku": "SSG-41323",
            "color": "Black/Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/Blue Midnight"
            },
            "available": true,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-2-0-putter-grip?variant=39172947015"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All products, Brand_Super Stroke, New for 2016, New for 2017, non-tapered, pistol, Pistol GTR, putter, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Putter Grip, super-stroke, super-stroke-2-0-putter-grips, super-stroke-pistol-gt-gtr-putter-grips, superstroke, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black",
      "White/Red",
      "Black/White Midnight",
      "Black/Red Midnight",
      "Black/Blue Midnight"
    ]
  },
  {
    "id": "super-stroke-pistol-gtr-tour",
    "brand": "Super Stroke",
    "model": "Pistol GTR Tour",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-tour-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/pgtr-tour-5colors_9752d7f5-977e-4533-9325-be22a178b550.jpg?v=1636061551",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 24.99,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-tour-putter-grip",
        "handle": "super-stroke-pistol-gtr-tour-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black",
              "White/Red",
              "Black/White Midnight",
              "Black/Red Midnight",
              "Black/Blue Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39171258823",
            "gid": "gid://shopify/ProductVariant/39171258823",
            "sku": "SSG-41101",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-tour-putter-grip?variant=39171258823"
          },
          {
            "id": "39171258951",
            "gid": "gid://shopify/ProductVariant/39171258951",
            "sku": "SSG-41102",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-tour-putter-grip?variant=39171258951"
          },
          {
            "id": "39172166023",
            "gid": "gid://shopify/ProductVariant/39172166023",
            "sku": "SSG-41126",
            "color": "Black/White Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White Midnight"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-tour-putter-grip?variant=39172166023"
          },
          {
            "id": "39172179399",
            "gid": "gid://shopify/ProductVariant/39172179399",
            "sku": "SSG-41122",
            "color": "Black/Red Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/Red Midnight"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-tour-putter-grip?variant=39172179399"
          },
          {
            "id": "39172184199",
            "gid": "gid://shopify/ProductVariant/39172184199",
            "sku": "SSG-41123",
            "color": "Black/Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/Blue Midnight"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 190.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gtr-tour-putter-grip?variant=39172184199"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Brand_Super Stroke, New for 2016, New for 2017, non-tapered, pistol, Pistol GTR, putter, single-grip, Size_Standard, standard, standard-size-golf-grips, Style_Putter Grip, super-stroke, super-stroke-pistol-gt-gtr-putter-grips, superstroke, under-150, video=rysDcG2Iuq0",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-replacement-end-cap-grip-not-included",
    "brand": "Super Stroke",
    "model": "Replacement End Cap (Grip Not Included)",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "weight_insert",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {
      "Unspecified": 45.4
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 11.25,
    "price_max": 11.25,
    "single_price_min": 11.25,
    "single_price_max": 11.25,
    "normalized_price_per_grip": 11.25,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-end-cap-grip-cap-only",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-endcap.jpg?v=1648339881",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 11.25,
        "per_grip_g": 45.4,
        "total_g": 45.359237,
        "url": "https://www.grips4less.com/products/super-stroke-end-cap-grip-cap-only",
        "handle": "super-stroke-end-cap-grip-cap-only",
        "shopify_variants": [
          {
            "id": "39846747013181",
            "gid": "gid://shopify/ProductVariant/39846747013181",
            "sku": "SS-ENDCAP-RED",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 11.25,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-end-cap-grip-cap-only?variant=39846747013181"
          },
          {
            "id": "39846747045949",
            "gid": "gid://shopify/ProductVariant/39846747045949",
            "sku": "SS-ENDCAP-BK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 11.25,
            "weight_g": 45.4,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-end-cap-grip-cap-only?variant=39846747045949"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red",
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, Counter Balance, Countercore, golf-grips, New for 2016, putter, putter-grips, single-golf-grips, single-grip, super-stroke, super-stroke-series-with-counter-core-technology, superstroke, under-150, under-300, video=rysDcG2Iuq0, Weight Insert, XL Counter Core",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-replacement-end-cap-grips-not-included",
    "brand": "Super Stroke",
    "model": "Replacement End Cap (Grips Not Included)",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "weight_insert",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "9pc bundle"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {
      "Unspecified": 45.4
    },
    "weight_source": "derived_from_bundle",
    "weight_confidence": "medium",
    "price_min": 91.13,
    "price_max": 91.13,
    "single_price_min": null,
    "single_price_max": null,
    "normalized_price_per_grip": 10.13,
    "bundle_price_min": 91.13,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-end-cap-grip-cap-only-grip-bundle-set",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-endcap_192c9104-ba28-4e1e-abfd-82b707d48a7c.jpg?v=1735455704",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "9pc bundle",
        "colors": [
          "Red"
        ],
        "price": 91.13,
        "per_grip_g": 45.4,
        "total_g": 408.233133,
        "url": "https://www.grips4less.com/products/super-stroke-end-cap-grip-cap-only-grip-bundle-set",
        "handle": "super-stroke-end-cap-grip-cap-only-grip-bundle-set",
        "shopify_variants": [
          {
            "id": "41021954392125",
            "gid": "gid://shopify/ProductVariant/41021954392125",
            "sku": "SET-9xSS-ENDCAP-RED",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 91.13,
            "weight_g": 408.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-end-cap-grip-cap-only-grip-bundle-set?variant=41021954392125"
          },
          {
            "id": "41021954424893",
            "gid": "gid://shopify/ProductVariant/41021954424893",
            "sku": "SET-9xSS-ENDCAP-BK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 91.13,
            "weight_g": 408.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-end-cap-grip-cap-only-grip-bundle-set?variant=41021954424893"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red",
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "All Products, Counter Balance, Countercore, golf-grips, grip bundle, New for 2016, new-bundle-set, putter, putter-grips, single-golf-grips, single-grip, super-stroke, super-stroke-series-with-counter-core-technology, superstroke, under-150, under-300, video=rysDcG2Iuq0, Weight Insert, XL Counter Cor",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-ss2-square",
    "brand": "Super Stroke",
    "model": "SS2 Square",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 15,
    "price_max": 15,
    "single_price_min": 15,
    "single_price_max": 15,
    "normalized_price_per_grip": 15,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-ss2-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/SS2-red.jpg?v=1636053288",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 15,
        "per_grip_g": 191,
        "total_g": 191.007747007,
        "url": "https://www.grips4less.com/products/super-stroke-ss2-putter-grip",
        "handle": "super-stroke-ss2-putter-grip",
        "shopify_variants": [
          {
            "id": "28565183987773",
            "gid": "gid://shopify/ProductVariant/28565183987773",
            "sku": "SSG-41002",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 15,
            "weight_g": 190.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-ss2-putter-grip?variant=28565183987773"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, jumbo/oversize, New for 2015, non-tapered, putter, single-grip, Size_Jumbo/Oversize, Square, SS2, super-stroke, super-stroke-ss2-putter-grip, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red"
    ]
  },
  {
    "id": "super-stroke-slim-3-0-putter-grip-with-countercore-50g-weight",
    "brand": "Super Stroke",
    "model": "Slim 3.0 Putter Grip with CounterCore 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 31.49,
    "price_max": 31.49,
    "single_price_min": 31.49,
    "single_price_max": 31.49,
    "normalized_price_per_grip": 31.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-slim-3-0-putter-grip-with-countercore",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/cc-slim30-weight.jpg?v=1735456377",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 31.49,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-slim-3-0-putter-grip-with-countercore",
        "handle": "super-stroke-slim-3-0-putter-grip-with-countercore",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red",
              "Blue",
              "Lime",
              "Blue Midnight",
              "Yellow Midnight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14866341959",
            "gid": "gid://shopify/ProductVariant/14866341959",
            "sku": "SSG-060201",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-slim-3-0-putter-grip-with-countercore?variant=14866341959"
          },
          {
            "id": "14866342087",
            "gid": "gid://shopify/ProductVariant/14866342087",
            "sku": "SSG-060202",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-slim-3-0-putter-grip-with-countercore?variant=14866342087"
          },
          {
            "id": "14866342151",
            "gid": "gid://shopify/ProductVariant/14866342151",
            "sku": "SSG-060203",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-slim-3-0-putter-grip-with-countercore?variant=14866342151"
          },
          {
            "id": "14866342343",
            "gid": "gid://shopify/ProductVariant/14866342343",
            "sku": "SSG-060204",
            "color": "Lime",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Lime"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-slim-3-0-putter-grip-with-countercore?variant=14866342343"
          },
          {
            "id": "14866342215",
            "gid": "gid://shopify/ProductVariant/14866342215",
            "sku": "SSG-060223",
            "color": "Blue Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue Midnight"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-slim-3-0-putter-grip-with-countercore?variant=14866342215"
          },
          {
            "id": "14866342279",
            "gid": "gid://shopify/ProductVariant/14866342279",
            "sku": "SSG-060228",
            "color": "Yellow Midnight",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Yellow Midnight"
            },
            "available": false,
            "price": 31.49,
            "weight_g": 108.9,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-slim-3-0-putter-grip-with-countercore?variant=14866342279"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2023-sale, 3.0, 49 under, All Products, Counter Balance, Countercore, Countercore (50g) weight included, Countercore Slim, golf-grips, includes weight, jumbo/oversize, Legacy Countercore, mid-ov-putter-sale, New for 2016, non-tapered, oversize, oversize-jumbo-golf-grips, putter grip, single-grip, Sl",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel",
    "brand": "Super Stroke",
    "model": "Special Edition: Super Stroke Zenergy Tour 2.0 Putter Grip (Marvel - \"Hulk\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "special_edition",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Hulk - Green/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-zenergy-tour-2-0-putter-grip-marvel-hulk",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/hulk-web-image-4.jpg?v=1717289423",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Hulk - Green/Black"
        ],
        "price": 39.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-zenergy-tour-2-0-putter-grip-marvel-hulk",
        "handle": "super-stroke-zenergy-tour-2-0-putter-grip-marvel-hulk",
        "shopify_variants": [
          {
            "id": "41432991170621",
            "gid": "gid://shopify/ProductVariant/41432991170621",
            "sku": "SS-D080102",
            "color": "Hulk - Green/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Hulk - Green/Black"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-zenergy-tour-2-0-putter-grip-marvel-hulk?variant=41432991170621"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Hulk - Green/Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 2024 new products, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, golf-grips, hulk, jumbo, jumbo/oversize, marvel hulk, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo-golf-g",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Hulk - Green/Black"
    ]
  },
  {
    "id": "super-stroke-special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel",
    "brand": "Super Stroke",
    "model": "Special Edition: Super Stroke Zenergy Tour 2.0 Putter Grip (Marvel - \"Iron Man\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "special_edition",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Iron Man - Red/Yellow"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel-iron-man",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/iron-man-web-image-5.jpg?v=1717289919",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Iron Man - Red/Yellow"
        ],
        "price": 39.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel-iron-man",
        "handle": "special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel-iron-man",
        "shopify_variants": [
          {
            "id": "41433006833725",
            "gid": "gid://shopify/ProductVariant/41433006833725",
            "sku": "SS-D080101",
            "color": "Iron Man - Red/Yellow",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Iron Man - Red/Yellow"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel-iron-man?variant=41433006833725"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Iron Man - Red/Yellow"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 2024 new products, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, golf-grips, ironman, jumbo, jumbo/oversize, marvel iron man, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Iron Man - Red/Yellow"
    ]
  },
  {
    "id": "super-stroke-special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel",
    "brand": "Super Stroke",
    "model": "Special Edition: Super Stroke Zenergy Tour 2.0 Putter Grip (Marvel - \"Spider-Man\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "special_edition",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Spider-Man - Black/Red/Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel-sider-man",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/spiderman-web-image-4.jpg?v=1717290090",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Spider-Man - Black/Red/Blue"
        ],
        "price": 39.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel-sider-man",
        "handle": "special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel-sider-man",
        "shopify_variants": [
          {
            "id": "41433013977149",
            "gid": "gid://shopify/ProductVariant/41433013977149",
            "sku": "SS-D080100",
            "color": "Spider-Man - Black/Red/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Spider-Man - Black/Red/Blue"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/special-edition-super-stroke-zenergy-tour-2-0-putter-grip-marvel-sider-man?variant=41433013977149"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Spider-Man - Black/Red/Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 2024 new products, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, golf-grips, jumbo, jumbo/oversize, marvel spiderman, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo-golf-gr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-special-edition-super-stroke-zenergy-tour-2-0-putter-grip-darth",
    "brand": "Super Stroke",
    "model": "Special Edition: Super Stroke Zenergy Tour 2.0 Putter Grip - \"Darth Vader\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "special_edition",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Darth Vader - Black/Red/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/special-edition-super-stroke-zenergy-tour-2-0-putter-grip-darth-vader",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/super-stroke-darth-vader-1.jpg?v=1750869291",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Darth Vader - Black/Red/White"
        ],
        "price": 39.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/special-edition-super-stroke-zenergy-tour-2-0-putter-grip-darth-vader",
        "handle": "special-edition-super-stroke-zenergy-tour-2-0-putter-grip-darth-vader",
        "shopify_variants": [
          {
            "id": "52344742707570",
            "gid": "gid://shopify/ProductVariant/52344742707570",
            "sku": "SS-D080109",
            "color": "Darth Vader - Black/Red/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Darth Vader - Black/Red/White"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/special-edition-super-stroke-zenergy-tour-2-0-putter-grip-darth-vader?variant=52344742707570"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Darth Vader - Black/Red/White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 2024 new products, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, darth vader, golf-grips, jumbo, jumbo/oversize, marvel spiderman, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Darth Vader - Black/Red/White"
    ]
  },
  {
    "id": "super-stroke-split",
    "brand": "Super Stroke",
    "model": "Split",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black / White"
    ],
    "weight_g_by_size": {
      "Unspecified": 64
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 12,
    "price_max": 12,
    "single_price_min": 12,
    "single_price_max": 12,
    "normalized_price_per_grip": 12,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-split-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-split.jpg?v=1636059137",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black / White"
        ],
        "price": 12,
        "per_grip_g": 64,
        "total_g": 64.001883407,
        "url": "https://www.grips4less.com/products/super-stroke-split-grip",
        "handle": "super-stroke-split-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / White",
              "Red / White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461767053373",
            "gid": "gid://shopify/ProductVariant/39461767053373",
            "sku": "SSG-013331",
            "color": "Black / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / White"
            },
            "available": true,
            "price": 12,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-split-grip?variant=39461767053373"
          },
          {
            "id": "39461767086141",
            "gid": "gid://shopify/ProductVariant/39461767086141",
            "sku": "SSG-013332",
            "color": "Red / White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / White"
            },
            "available": true,
            "price": 12,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-split-grip?variant=39461767086141"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2-piece, 49 under, All products, belly, long, non-tapered, putter, putter-grips, single-golf-grips, single-grip, Style_Swing Grip, super-stroke, super-stroke-long-putter-grips-1, under-150, video=rXTGZKWJHjk",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / White",
      "Red / White"
    ]
  },
  {
    "id": "super-stroke-tlt-pistol-1-0",
    "brand": "Super Stroke",
    "model": "TLT Pistol 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "(LH Player) White/Red/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Capture_beb06737-28cf-4484-bd1b-25f3e711a60b.jpg?v=1770138820",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "(LH Player) White/Red/Black"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-1-0-putter-grip",
        "handle": "super-stroke-tlt-pistol-1-0-putter-grip",
        "shopify_options": [
          {
            "name": "Hand Size/Color",
            "values": [
              "(LH Player) White/Red/Black",
              "(LH Player) White/Silver",
              "(RH Player) White/Red/Black",
              "(RH Player) White/Silver"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61544221278578",
            "gid": "gid://shopify/ProductVariant/61544221278578",
            "sku": "SS-L085202",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(LH Player) White/Red/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-1-0-putter-grip?variant=61544221278578"
          },
          {
            "id": "61544291139954",
            "gid": "gid://shopify/ProductVariant/61544291139954",
            "sku": "SS-L085240",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(LH Player) White/Silver"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-1-0-putter-grip?variant=61544291139954"
          },
          {
            "id": "61544305361266",
            "gid": "gid://shopify/ProductVariant/61544305361266",
            "sku": "SS-R085202",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(RH Player) White/Red/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-1-0-putter-grip?variant=61544305361266"
          },
          {
            "id": "61544305590642",
            "gid": "gid://shopify/ProductVariant/61544305590642",
            "sku": "SS-R085240",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(RH Player) White/Silver"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-1-0-putter-grip?variant=61544305590642"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, best-sellers, Brand_Super Stroke, golf-grips, new arrivals, non-tapered, putter, putter grip, putter-grips, single-golf-grips, single-grip, Super Stroke Putter Grip, Super Stroke Tilt, Super Stroke TLT, super-stroke, superstroke, TLT Pistol Grip, tlt putter, TLT putter g",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "(LH Player) White/Red/Black"
    ]
  },
  {
    "id": "super-stroke-tlt-pistol-2-0",
    "brand": "Super Stroke",
    "model": "TLT Pistol 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "(LH Player) White/Red/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Capture_beb06737-28cf-4484-bd1b-25f3e711a60b.jpg?v=1770138820",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "(LH Player) White/Red/Black"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip",
        "handle": "super-stroke-tlt-pistol-2-0-putter-grip",
        "shopify_options": [
          {
            "name": "Hand Size/Color",
            "values": [
              "(LH Player) White/Red/Black",
              "(LH Player) White/Silver",
              "(RH Player) White/Red/Black",
              "(RH Player) White/Silver"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61544312439154",
            "gid": "gid://shopify/ProductVariant/61544312439154",
            "sku": "SS-L085302",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(LH Player) White/Red/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip?variant=61544312439154"
          },
          {
            "id": "61544312471922",
            "gid": "gid://shopify/ProductVariant/61544312471922",
            "sku": "SS-L085340",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(LH Player) White/Silver"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip?variant=61544312471922"
          },
          {
            "id": "61544312504690",
            "gid": "gid://shopify/ProductVariant/61544312504690",
            "sku": "SS-R085302",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(RH Player) White/Red/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip?variant=61544312504690"
          },
          {
            "id": "61544312537458",
            "gid": "gid://shopify/ProductVariant/61544312537458",
            "sku": "SS-R085340",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(RH Player) White/Silver"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip?variant=61544312537458"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, best-sellers, Brand_Super Stroke, golf-grips, new arrivals, non-tapered, putter, putter grip, putter-grips, single-golf-grips, single-grip, Super Stroke Putter Grip, Super Stroke Tilt, Super Stroke TLT, super-stroke, superstroke, TLT Pistol Grip, tlt putter, TLT putter g",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "(LH Player) White/Red/Black"
    ]
  },
  {
    "id": "super-stroke-tlt-tour-2-0-xl",
    "brand": "Super Stroke",
    "model": "TLT Tour 2.0 XL",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "(LH Player) White/Red/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip-xl",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Capture_beb06737-28cf-4484-bd1b-25f3e711a60b.jpg?v=1770138820",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "(LH Player) White/Red/Black"
        ],
        "price": 39.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip-xl",
        "handle": "super-stroke-tlt-pistol-2-0-putter-grip-xl",
        "shopify_options": [
          {
            "name": "Hand Size/Color",
            "values": [
              "(LH Player) White/Red/Black",
              "(LH Player) White/Silver",
              "(RH Player) White/Red/Black",
              "(RH Player) White/Silver"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61544314536306",
            "gid": "gid://shopify/ProductVariant/61544314536306",
            "sku": "SS-L085702",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(LH Player) White/Red/Black"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip-xl?variant=61544314536306"
          },
          {
            "id": "61544314569074",
            "gid": "gid://shopify/ProductVariant/61544314569074",
            "sku": "SS-L085740",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(LH Player) White/Silver"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip-xl?variant=61544314569074"
          },
          {
            "id": "61544314601842",
            "gid": "gid://shopify/ProductVariant/61544314601842",
            "sku": "SS-R085702",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(RH Player) White/Red/Black"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip-xl?variant=61544314601842"
          },
          {
            "id": "61544314634610",
            "gid": "gid://shopify/ProductVariant/61544314634610",
            "sku": "SS-R085740",
            "color": "(LH Player) White/Red/Black",
            "size": "Unspecified",
            "selected_options": {
              "Hand Size/Color": "(RH Player) White/Silver"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tlt-pistol-2-0-putter-grip-xl?variant=61544314634610"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, best-sellers, Brand_Super Stroke, golf-grips, new arrivals, putter, putter grip, putter-grips, single-golf-grips, single-grip, super stroke 2.0, Super Stroke Putter Grip, Super Stroke Tilt, Super Stroke TLT, super-stroke, superstroke, superstroke 2.0, TLT Pistol Grip, tl",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "(LH Player) White/Red/Black"
    ]
  },
  {
    "id": "super-stroke-traxion-pistol-gt-1-0",
    "brand": "Super Stroke",
    "model": "TRAXION Pistol GT 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Digi Camo"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/superstroke-traxion-pistol-gt-10-allcolors.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Digi Camo"
        ],
        "price": 29.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-1-0-putter-grip",
        "handle": "super-stroke-traxion-pistol-gt-1-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Digi Camo",
              "Blk/Blue/Wht",
              "Tiff/Grey/White",
              "Black/White",
              "Wht/Red/Gry",
              "Grey/White",
              "Red/White/Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31524722769981",
            "gid": "gid://shopify/ProductVariant/31524722769981",
            "sku": "SSG-071237",
            "color": "Digi Camo",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-1-0-putter-grip?variant=31524722769981"
          },
          {
            "id": "13909775876157",
            "gid": "gid://shopify/ProductVariant/13909775876157",
            "sku": "SSG-071223",
            "color": "Blk/Blue/Wht",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blk/Blue/Wht"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-1-0-putter-grip?variant=13909775876157"
          },
          {
            "id": "31524728340541",
            "gid": "gid://shopify/ProductVariant/31524728340541",
            "sku": "SSG-071220",
            "color": "Tiff/Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Tiff/Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-1-0-putter-grip?variant=31524728340541"
          },
          {
            "id": "13909775843389",
            "gid": "gid://shopify/ProductVariant/13909775843389",
            "sku": "SSG-071201",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-1-0-putter-grip?variant=13909775843389"
          },
          {
            "id": "13909775908925",
            "gid": "gid://shopify/ProductVariant/13909775908925",
            "sku": "SSG-071200",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-1-0-putter-grip?variant=13909775908925"
          },
          {
            "id": "31524724179005",
            "gid": "gid://shopify/ProductVariant/31524724179005",
            "sku": "SSG-071214",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-1-0-putter-grip?variant=31524724179005"
          },
          {
            "id": "31524725325885",
            "gid": "gid://shopify/ProductVariant/31524725325885",
            "sku": "SSG-071230",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-1-0-putter-grip?variant=31524725325885"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, CounterCore, golf-grips, mid-ov-putter-sale, Midsize, midsize-golf-grips, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Traxion, putter, putter grip, putter-grips, standard, standard-size-golf-grips, super stroke 1.0, super stroke traxion, super-",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-pistol-gt-2-0",
    "brand": "Super Stroke",
    "model": "TRAXION Pistol GT 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/superstroke-traxion-pistol-gt-20-allcolors.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-2-0-putter-grip",
        "handle": "super-stroke-traxion-pistol-gt-2-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Red/White/Blue",
              "Blk/Blue/Wht",
              "Wht/Red/Gry",
              "Red/White",
              "Digi Camo",
              "Grey/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13909793144893",
            "gid": "gid://shopify/ProductVariant/13909793144893",
            "sku": "SSG-071301",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-2-0-putter-grip?variant=13909793144893"
          },
          {
            "id": "31552988774461",
            "gid": "gid://shopify/ProductVariant/31552988774461",
            "sku": "SSG-071330",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-2-0-putter-grip?variant=31552988774461"
          },
          {
            "id": "13909793177661",
            "gid": "gid://shopify/ProductVariant/13909793177661",
            "sku": "SSG-071323",
            "color": "Blk/Blue/Wht",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blk/Blue/Wht"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-2-0-putter-grip?variant=13909793177661"
          },
          {
            "id": "13909793210429",
            "gid": "gid://shopify/ProductVariant/13909793210429",
            "sku": "SSG-071300",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-2-0-putter-grip?variant=13909793210429"
          },
          {
            "id": "13909796257853",
            "gid": "gid://shopify/ProductVariant/13909796257853",
            "sku": "SSG-071302",
            "color": "Red/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-2-0-putter-grip?variant=13909796257853"
          },
          {
            "id": "31524731322429",
            "gid": "gid://shopify/ProductVariant/31524731322429",
            "sku": "SSG-071337",
            "color": "Digi Camo",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-2-0-putter-grip?variant=31524731322429"
          },
          {
            "id": "31524773134397",
            "gid": "gid://shopify/ProductVariant/31524773134397",
            "sku": "SSG-071314",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-2-0-putter-grip?variant=31524773134397"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, Pistol GT, Pistol GT Countercore, Pistol GT Traxion, putter, single-grip, super stroke traxion, super-stroke, super-stroke-2-0-putter-grips",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-pistol-gt-tour",
    "brand": "Super Stroke",
    "model": "TRAXION Pistol GT TOUR",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-tour-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-pistolgt-tour-5colors.jpg?v=1580490994",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-tour-putter-grip",
        "handle": "super-stroke-traxion-pistol-gt-tour-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Wht/Red/Gry",
              "Digi Camo",
              "Grey/White",
              "Red/White/Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13909802156093",
            "gid": "gid://shopify/ProductVariant/13909802156093",
            "sku": "SSG-071101",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-tour-putter-grip?variant=13909802156093"
          },
          {
            "id": "13909802221629",
            "gid": "gid://shopify/ProductVariant/13909802221629",
            "sku": "SSG-071100",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-tour-putter-grip?variant=13909802221629"
          },
          {
            "id": "31524712120381",
            "gid": "gid://shopify/ProductVariant/31524712120381",
            "sku": "SSG-071137",
            "color": "Digi Camo",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-tour-putter-grip?variant=31524712120381"
          },
          {
            "id": "31524713431101",
            "gid": "gid://shopify/ProductVariant/31524713431101",
            "sku": "SSG-071114",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-tour-putter-grip?variant=31524713431101"
          },
          {
            "id": "31524714479677",
            "gid": "gid://shopify/ProductVariant/31524714479677",
            "sku": "SSG-071130",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-pistol-gt-tour-putter-grip?variant=31524714479677"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, CounterCore, golf-grips, GT Tour, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Tour, Pistol GT Traxion, putter, putter grip, putter-grips, standard, standard-size-golf-grips, super stroke 1.0, super stroke traxion, super-stroke, super-stroke-pistol-g",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-ss2-square",
    "brand": "Super Stroke",
    "model": "TRAXION SS2 Square",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red / White / Grey"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-ss2-square-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/SS2R-WHT-RED-GRY-Q-turn-100x1000_grande_a4550d5f-cde9-45ce-8666-de205a4da062.jpg?v=1571438546",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red / White / Grey"
        ],
        "price": 29.99,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-ss2-square-putter-grip",
        "handle": "super-stroke-traxion-ss2-square-putter-grip",
        "shopify_variants": [
          {
            "id": "41088042106941",
            "gid": "gid://shopify/ProductVariant/41088042106941",
            "sku": "SSG-071000",
            "color": "Red / White / Grey",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / White / Grey"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 108.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-ss2-square-putter-grip?variant=41088042106941"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / White / Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, golf-grips, laborday-2022, non-tapered, putter, putter grip, putter-grips, Square, SS2, SS2R, SS2R Square, SS2R Square Putter, standard, standard-size-golf-grips, summer-overstock-2022, super stroke traxion, super-stroke, super-stroke-ss2-putter-grip, supe",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-team-usa-ryder-cup-putter-grip-w-counter-core-50g-weight",
    "brand": "Super Stroke",
    "model": "Team USA Ryder Cup Putter Grip w/ Counter Core 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Flatso 1.0 w/ 50g weight"
    ],
    "manufacturer_size_labels": [
      "Flatso 1.0 w/ 50g weight"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/2018-super-stroke-team-usa-ryder-cup-flatso-1-0-putter-grip-with-counter-core-50g-weight",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-2018-Ryderusa-20-Front_f65f3f39-b715-42c5-b697-0b11775fb2e9.jpg?v=1636060116",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Flatso 1.0 w/ 50g weight"
        ],
        "format": "single",
        "colors": [],
        "price": 21,
        "per_grip_g": 907,
        "total_g": 907.003303052,
        "url": "https://www.grips4less.com/products/2018-super-stroke-team-usa-ryder-cup-flatso-1-0-putter-grip-with-counter-core-50g-weight",
        "handle": "2018-super-stroke-team-usa-ryder-cup-flatso-1-0-putter-grip-with-counter-core-50g-weight",
        "shopify_options": [
          {
            "name": "Style and Size",
            "values": [
              "Flatso 1.0 w/ 50g weight",
              "Slim 3.0 w/ 50g weight",
              "Pistol GT 2.0 w/ 50g weight"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "12731337539645",
            "gid": "gid://shopify/ProductVariant/12731337539645",
            "sku": "S093130",
            "color": "",
            "size": "Flatso 1.0 w/ 50g weight",
            "selected_options": {
              "Style and Size": "Flatso 1.0 w/ 50g weight"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2018-super-stroke-team-usa-ryder-cup-flatso-1-0-putter-grip-with-counter-core-50g-weight?variant=12731337539645"
          },
          {
            "id": "12820267827261",
            "gid": "gid://shopify/ProductVariant/12820267827261",
            "sku": "S091330",
            "color": "",
            "size": "Flatso 1.0 w/ 50g weight",
            "selected_options": {
              "Style and Size": "Slim 3.0 w/ 50g weight"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2018-super-stroke-team-usa-ryder-cup-flatso-1-0-putter-grip-with-counter-core-50g-weight?variant=12820267827261"
          },
          {
            "id": "12731364671549",
            "gid": "gid://shopify/ProductVariant/12731364671549",
            "sku": "S095230",
            "color": "",
            "size": "Flatso 1.0 w/ 50g weight",
            "selected_options": {
              "Style and Size": "Pistol GT 2.0 w/ 50g weight"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/2018-super-stroke-team-usa-ryder-cup-flatso-1-0-putter-grip-with-counter-core-50g-weight?variant=12731364671549"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 2.0, 2018 Ryder, 49 under, All products, Commemorative, Counter Balance, CounterCore, flatso, limited edition, midsize, midsize-golf-grips, non-tapered, Pistol GT, putter, ryder, ryder cup, single-grip, Size_Midsize, Size_Standard, slim 3.0, standard, standard-size-golf-grips, super-stroke, sup",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-the-claw",
    "brand": "Super Stroke",
    "model": "The Claw",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat claw",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Unspecified": 91
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9.6,
    "price_max": 9.6,
    "single_price_min": 9.6,
    "single_price_max": 9.6,
    "normalized_price_per_grip": 9.6,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-the-claw-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Black_Claw.jpg?v=1636053049",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [],
        "price": 9.6,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/super-stroke-the-claw-putter-grip",
        "handle": "super-stroke-the-claw-putter-grip",
        "shopify_variants": [
          {
            "id": "39461775999037",
            "gid": "gid://shopify/ProductVariant/39461775999037",
            "sku": "SSG-13350",
            "color": "",
            "size": "Unspecified",
            "selected_options": {
              "Style": "Black"
            },
            "available": true,
            "price": 9.6,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-the-claw-putter-grip?variant=39461775999037"
          }
        ],
        "shopify_options": [
          {
            "name": "Style",
            "values": [
              "Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All products, belly, midsize, midsize-golf-grips, New for 2014, non-tapered, putter, putter-grips, single-grip, Size_Midsize, super-stroke, super-stroke-claw-putter-grips-1, The Claw, under-150",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-2-piece-split",
    "brand": "Super Stroke",
    "model": "Traxion 2-Piece Split",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Red/Grey"
    ],
    "weight_g_by_size": {
      "Unspecified": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-2-piece-split-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-2pc-long-putter-grip.jpg?v=1581718349",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Red/Grey"
        ],
        "price": 34.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/super-stroke-2-piece-split-putter-grip",
        "handle": "super-stroke-2-piece-split-putter-grip",
        "shopify_variants": [
          {
            "id": "31550415765565",
            "gid": "gid://shopify/ProductVariant/31550415765565",
            "sku": "SSG-073200",
            "color": "White/Red/Grey",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red/Grey"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-2-piece-split-putter-grip?variant=31550415765565"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Red/Grey"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2-pc, 2-piece putter grips, 49 under, All Products, arm lock, arm lock putter grip, belly, Counter Balance, golf-grips, jumbo/oversize, long, Long Putter, Long/Belly Putter, mid-ov-putter-sale, putter, single-grip, split, Super Stroke 2-piece Grip, Super Stroke Split Grip, super stroke traxion, supe",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-claw-1-0",
    "brand": "Super Stroke",
    "model": "Traxion CLAW 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat claw",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Wht/Blue/Gry"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-claw-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-traxion-claw-allcolors.jpg?v=1571438540",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Wht/Blue/Gry"
        ],
        "price": 29.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-claw-1-0-putter-grip",
        "handle": "super-stroke-traxion-claw-1-0-putter-grip",
        "shopify_variants": [
          {
            "id": "13909365129277",
            "gid": "gid://shopify/ProductVariant/13909365129277",
            "sku": "SSG-072234",
            "color": "Wht/Blue/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Blue/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-claw-1-0-putter-grip?variant=13909365129277"
          },
          {
            "id": "13909365162045",
            "gid": "gid://shopify/ProductVariant/13909365162045",
            "sku": "SSG-072200",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-claw-1-0-putter-grip?variant=13909365162045"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Wht/Blue/Gry",
              "Wht/Red/Gry"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, Claw, Claw Traxion, Counter Balance, Countercore, golf-grips, golfers-gift-guide, mid-ov-putter-sale, midsize, midsize-golf-grips, new arrivals, non-tapered, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, super stroke 1.0, Super Stroke Claw, supe",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-claw-2-0",
    "brand": "Super Stroke",
    "model": "Traxion CLAW 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat claw",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Wht/Blue/Gry"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-claw-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-traxion-claw-allcolors_f4bd0226-b103-4450-81a3-993fe8ccc2ef.jpg?v=1571438540",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Wht/Blue/Gry"
        ],
        "price": 29.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-claw-2-0-putter-grip",
        "handle": "super-stroke-traxion-claw-2-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Wht/Blue/Gry",
              "Wht/Red/Gry"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13909382758461",
            "gid": "gid://shopify/ProductVariant/13909382758461",
            "sku": "SSG-072334",
            "color": "Wht/Blue/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Blue/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-claw-2-0-putter-grip?variant=13909382758461"
          },
          {
            "id": "13909382791229",
            "gid": "gid://shopify/ProductVariant/13909382791229",
            "sku": "SSG-072300",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-claw-2-0-putter-grip?variant=13909382791229"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, Claw, Claw 2.0, Claw Traxion, Counter Balance, Countercore, golf-grips, mid-ov-putter-sale, midsize, midsize-golf-grips, new arrivals, non-tapered, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, super stroke 2.0, Super Stroke Claw, super-stroke, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-flatso-1-0",
    "brand": "Super Stroke",
    "model": "Traxion FLATSO 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/superstroke-traxion-flatso-10-allcolors.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-1-0-putter-grip",
        "handle": "super-stroke-traxion-flatso-1-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Blk/Blue/Wht",
              "Wht/Red/Gry",
              "Digi Camo",
              "Grey/White",
              "Red/White/Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13909393571901",
            "gid": "gid://shopify/ProductVariant/13909393571901",
            "sku": "SSG-070401",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-1-0-putter-grip?variant=13909393571901"
          },
          {
            "id": "13909393604669",
            "gid": "gid://shopify/ProductVariant/13909393604669",
            "sku": "SSG-070423",
            "color": "Blk/Blue/Wht",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blk/Blue/Wht"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-1-0-putter-grip?variant=13909393604669"
          },
          {
            "id": "13909393637437",
            "gid": "gid://shopify/ProductVariant/13909393637437",
            "sku": "SSG-070400",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-1-0-putter-grip?variant=13909393637437"
          },
          {
            "id": "31524561944637",
            "gid": "gid://shopify/ProductVariant/31524561944637",
            "sku": "SSG-070437",
            "color": "Digi Camo",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-1-0-putter-grip?variant=31524561944637"
          },
          {
            "id": "31524568072253",
            "gid": "gid://shopify/ProductVariant/31524568072253",
            "sku": "SSG-070414",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-1-0-putter-grip?variant=31524568072253"
          },
          {
            "id": "31524577738813",
            "gid": "gid://shopify/ProductVariant/31524577738813",
            "sku": "SSG-070430",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-1-0-putter-grip?variant=31524577738813"
          }
        ],
        "shopify_variant_count": 6,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, CounterCore, Flatso, Flatso Series, flatso traxion, golf-grips, mid-ov-putter-sale, Midsize, midsize-golf-grips, new arrivals, non-tapered, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, standard, standard-size-golf-grips, super stroke 1.0, super",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red/White/Blue"
    ]
  },
  {
    "id": "super-stroke-traxion-flatso-17",
    "brand": "Super Stroke",
    "model": "Traxion FLATSO 17\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Long"
    ],
    "manufacturer_size_labels": [
      "Long"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Long": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-17-long-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-17-flatso-traxion-long-putter-grip.jpg?v=1581717335",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Long"
        ],
        "format": "single",
        "colors": [
          "Red/White/Blue"
        ],
        "price": 34.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-17-long-putter-grip",
        "handle": "super-stroke-traxion-flatso-17-long-putter-grip",
        "shopify_variants": [
          {
            "id": "31550409408573",
            "gid": "gid://shopify/ProductVariant/31550409408573",
            "sku": "SSG-073642",
            "color": "Red/White/Blue",
            "size": "Long",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-17-long-putter-grip?variant=31550409408573"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red/White/Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "17\", 49 under, All Products, arm lock, arm lock putter grip, belly, Counter Balance, Flatso, Flatso Series, flatso traxion, golf-grips, jumbo/oversize, long, Long Putter, Long/Belly Putter, putter, single-grip, Super Stroke 17\", Super Stroke 17\" Putter Grip, super stroke traxion, super-stroke, super",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-flatso-2-0",
    "brand": "Super Stroke",
    "model": "Traxion FLATSO 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-flatso-20-4colors.jpg?v=1580489376",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-2-0-putter-grip",
        "handle": "super-stroke-traxion-flatso-2-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Red/White/Blue",
              "Wht/Red/Gry",
              "Digi Camo",
              "Grey/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13909403828285",
            "gid": "gid://shopify/ProductVariant/13909403828285",
            "sku": "SSG-070501",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-2-0-putter-grip?variant=13909403828285"
          },
          {
            "id": "31552976453693",
            "gid": "gid://shopify/ProductVariant/31552976453693",
            "sku": "SSG-070530",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-2-0-putter-grip?variant=31552976453693"
          },
          {
            "id": "13909403893821",
            "gid": "gid://shopify/ProductVariant/13909403893821",
            "sku": "SSG-070500",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-2-0-putter-grip?variant=13909403893821"
          },
          {
            "id": "31524676108349",
            "gid": "gid://shopify/ProductVariant/31524676108349",
            "sku": "SSG-070537",
            "color": "Digi Camo",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-2-0-putter-grip?variant=31524676108349"
          },
          {
            "id": "31524679974973",
            "gid": "gid://shopify/ProductVariant/31524679974973",
            "sku": "SSG-070514",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-2-0-putter-grip?variant=31524679974973"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, CounterCore, Flatso, Flatso Series, flatso traxion, golf-grips, jumbo/oversize, mid-ov-putter-sale, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, single-grip, super stroke traxion, super-stroke, super-stroke-2-0-putter-grips, super-stroke-series",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red/White/Blue",
      "Digi Camo"
    ]
  },
  {
    "id": "super-stroke-traxion-flatso-3-0",
    "brand": "Super Stroke",
    "model": "Traxion FLATSO 3.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-3-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-flatso-30-4colors.jpg?v=1580489677",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-3-0-putter-grip",
        "handle": "super-stroke-traxion-flatso-3-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Red/White/Blue",
              "Wht/Red/Gry",
              "Digi Camo",
              "Grey/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13909406875709",
            "gid": "gid://shopify/ProductVariant/13909406875709",
            "sku": "SSG-070601",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-3-0-putter-grip?variant=13909406875709"
          },
          {
            "id": "31552977338429",
            "gid": "gid://shopify/ProductVariant/31552977338429",
            "sku": "SSG-070630",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-3-0-putter-grip?variant=31552977338429"
          },
          {
            "id": "13909406908477",
            "gid": "gid://shopify/ProductVariant/13909406908477",
            "sku": "SSG-070600",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-3-0-putter-grip?variant=13909406908477"
          },
          {
            "id": "31524689117245",
            "gid": "gid://shopify/ProductVariant/31524689117245",
            "sku": "SSG-070637",
            "color": "Digi Camo",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-3-0-putter-grip?variant=31524689117245"
          },
          {
            "id": "31524689477693",
            "gid": "gid://shopify/ProductVariant/31524689477693",
            "sku": "SSG-070614",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-3-0-putter-grip?variant=31524689477693"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "3.0, 49 under, All Products, CounterCore, Flatso, Flatso Series, flatso traxion, golf-grips, jumbo/oversize, mid-ov-putter-sale, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, putter-grips, super stroke 3.0, super stroke traxion, super-stroke, super-stroke-3-0-p",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-flatso-xl-2-0-putter-grip-13-75",
    "brand": "Super Stroke",
    "model": "Traxion FLATSO XL+ 2.0 Putter Grip (13.75\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Wht/Red/Gry"
    ],
    "weight_g_by_size": {
      "Unspecified": 86.2
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-xl-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Traxion_Flatso_2.0XL_WHT-RED-GRY-Q.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Wht/Red/Gry"
        ],
        "price": 29.99,
        "per_grip_g": 86.2,
        "total_g": 86.1825503,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-xl-2-0-putter-grip",
        "handle": "super-stroke-traxion-flatso-xl-2-0-putter-grip",
        "shopify_variants": [
          {
            "id": "13909413298237",
            "gid": "gid://shopify/ProductVariant/13909413298237",
            "sku": "SSG-070900",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 86.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-flatso-xl-2-0-putter-grip?variant=13909413298237"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Wht/Red/Gry"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, Counter Balance, CounterCore, Flatso, Flatso Series, flatso traxion, golf-grips, jumbo/oversize, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, single-grip, super stroke traxion, super-stroke, super-stroke-2-0-putter-grips, super-stroke-series-wi",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-tour-xl-2-0-putter-grip-13-75",
    "brand": "Super Stroke",
    "model": "Traxion TOUR XL+ 2.0 Putter Grip (13.75\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Wht/Red/Gry"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-xl-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Traxion_Tour_2.0XL_WHT-RED-GRY-Q.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Wht/Red/Gry"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-xl-2-0-putter-grip",
        "handle": "super-stroke-traxion-xl-2-0-putter-grip",
        "shopify_variants": [
          {
            "id": "13909969272893",
            "gid": "gid://shopify/ProductVariant/13909969272893",
            "sku": "SSG-070700",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-xl-2-0-putter-grip?variant=13909969272893"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Wht/Red/Gry"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, Counter Balance, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, midsize, midsize-golf-grips, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, Plus XL, Plus XL Series, putter, single-grip, super stroke traxion, super-stroke, super-strok",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-tour-xl-3-0-putter-grip-13-75",
    "brand": "Super Stroke",
    "model": "Traxion TOUR XL+ 3.0 Putter Grip (13.75\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Wht/Red/Gry"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-xl-3-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/Traxion_Tour_3.0XL_WHT-RED-GRY-Q.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Wht/Red/Gry"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-xl-3-0-putter-grip",
        "handle": "super-stroke-traxion-xl-3-0-putter-grip",
        "shopify_variants": [
          {
            "id": "13910001713213",
            "gid": "gid://shopify/ProductVariant/13910001713213",
            "sku": "SSG-070800",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-xl-3-0-putter-grip?variant=13910001713213"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Wht/Red/Gry"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "3.0, 49 under, All Products, Counter Balance, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, midsize, midsize-golf-grips, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, Plus XL, Plus XL Series, putter, single-grip, super stroke traxion, super-stroke, super-strok",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-tour-1-0",
    "brand": "Super Stroke",
    "model": "Traxion Tour 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-traxiontour10-5colors.jpg?v=1580439577",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-1-0-putter-grip",
        "handle": "super-stroke-traxion-tour-1-0-putter-grip",
        "shopify_variants": [
          {
            "id": "13909870772285",
            "gid": "gid://shopify/ProductVariant/13909870772285",
            "sku": "SSG-070001",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-1-0-putter-grip?variant=13909870772285"
          },
          {
            "id": "13909870837821",
            "gid": "gid://shopify/ProductVariant/13909870837821",
            "sku": "SSG-070000",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-1-0-putter-grip?variant=13909870837821"
          },
          {
            "id": "31524035133501",
            "gid": "gid://shopify/ProductVariant/31524035133501",
            "sku": "SSG-070037",
            "color": "Digi Camo",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-1-0-putter-grip?variant=31524035133501"
          },
          {
            "id": "31524038213693",
            "gid": "gid://shopify/ProductVariant/31524038213693",
            "sku": "SSG-070030",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-1-0-putter-grip?variant=31524038213693"
          },
          {
            "id": "31524038344765",
            "gid": "gid://shopify/ProductVariant/31524038344765",
            "sku": "SSG-070020",
            "color": "Tiff/Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Tiff/Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-1-0-putter-grip?variant=31524038344765"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Wht/Red/Gry",
              "Digi Camo",
              "Red/White/Blue",
              "Tiff/Grey/White"
            ]
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, asbl-putter-grip-option, golf-grips, new arrivals, non-tapered, putter, putter grip, putter-grips, standard, standard-size-golf-grips, super stroke 1.0, super stroke traxion, super-stroke, super-stroke-1-0-putter-grips, superstroke, superstroke 1.0, Tour Series, Tour Tra",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-tour-2-0",
    "brand": "Super Stroke",
    "model": "Traxion Tour 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/superstroke-traxion-tour-20-allcolors.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip",
        "handle": "super-stroke-traxion-tour-2-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Red/White/Blue",
              "Blk/Blue/Wht",
              "Grey/White",
              "Wht/Red/Gry",
              "Red/White",
              "Digi Color",
              "Tiff/Grey/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13909872803901",
            "gid": "gid://shopify/ProductVariant/13909872803901",
            "sku": "SSG-070101",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip?variant=13909872803901"
          },
          {
            "id": "31552982974525",
            "gid": "gid://shopify/ProductVariant/31552982974525",
            "sku": "SSG-070130",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip?variant=31552982974525"
          },
          {
            "id": "13909873426493",
            "gid": "gid://shopify/ProductVariant/13909873426493",
            "sku": "SSG-070123",
            "color": "Blk/Blue/Wht",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blk/Blue/Wht"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip?variant=13909873426493"
          },
          {
            "id": "13909873492029",
            "gid": "gid://shopify/ProductVariant/13909873492029",
            "sku": "SSG-070114",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip?variant=13909873492029"
          },
          {
            "id": "13909872836669",
            "gid": "gid://shopify/ProductVariant/13909872836669",
            "sku": "SSG-070100",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip?variant=13909872836669"
          },
          {
            "id": "13909876146237",
            "gid": "gid://shopify/ProductVariant/13909876146237",
            "sku": "SSG-070102",
            "color": "Red/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip?variant=13909876146237"
          },
          {
            "id": "31524038705213",
            "gid": "gid://shopify/ProductVariant/31524038705213",
            "sku": "SSG-070137",
            "color": "Digi Color",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Color"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip?variant=31524038705213"
          },
          {
            "id": "31524039721021",
            "gid": "gid://shopify/ProductVariant/31524039721021",
            "sku": "SSG-070120",
            "color": "Tiff/Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Tiff/Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-2-0-putter-grip?variant=31524039721021"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, asbl-putter-grip-option, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, midsize, midsize-golf-grips, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, putter-grips, super stroke 2.0, super stroke traxion, super-stro",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-traxion-tour-3-0",
    "brand": "Super Stroke",
    "model": "Traxion Tour 3.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-3-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/superstroke-traxion-tour-30-allcolors.jpg?v=1571438541",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-3-0-putter-grip",
        "handle": "super-stroke-traxion-tour-3-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Red/White/Blue",
              "Blk/Blue/Wht",
              "Grey/White",
              "Wht/Red/Gry",
              "Red/White",
              "Digi Camo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13909895610429",
            "gid": "gid://shopify/ProductVariant/13909895610429",
            "sku": "SSG-070201",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-3-0-putter-grip?variant=13909895610429"
          },
          {
            "id": "31552983564349",
            "gid": "gid://shopify/ProductVariant/31552983564349",
            "sku": "SSG-070230",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-3-0-putter-grip?variant=31552983564349"
          },
          {
            "id": "13909895643197",
            "gid": "gid://shopify/ProductVariant/13909895643197",
            "sku": "SSG-070223",
            "color": "Blk/Blue/Wht",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blk/Blue/Wht"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-3-0-putter-grip?variant=13909895643197"
          },
          {
            "id": "13909895708733",
            "gid": "gid://shopify/ProductVariant/13909895708733",
            "sku": "SSG-070214",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-3-0-putter-grip?variant=13909895708733"
          },
          {
            "id": "13909895741501",
            "gid": "gid://shopify/ProductVariant/13909895741501",
            "sku": "SSG-070200",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-3-0-putter-grip?variant=13909895741501"
          },
          {
            "id": "13909895807037",
            "gid": "gid://shopify/ProductVariant/13909895807037",
            "sku": "SSG-070202",
            "color": "Red/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-3-0-putter-grip?variant=13909895807037"
          },
          {
            "id": "31524041424957",
            "gid": "gid://shopify/ProductVariant/31524041424957",
            "sku": "SSG-070237",
            "color": "Digi Camo",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": true,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-3-0-putter-grip?variant=31524041424957"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "3.0, 49 under, All Products, asbl-putter-grip-option, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip gift, single-grip, super stroke traxion, super-stroke, super-stroke-3-0-putter-grips, super-st",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Digi Camo"
    ]
  },
  {
    "id": "super-stroke-traxion-tour-5-0",
    "brand": "Super Stroke",
    "model": "Traxion Tour 5.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "5.0",
    "putter_size_class": "5.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-5-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-traxiontour50-3colors.jpg?v=1580440473",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-5-0-putter-grip",
        "handle": "super-stroke-traxion-tour-5-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Red/White/Blue",
              "Wht/Red/Gry",
              "Digi Camo"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "13909948432445",
            "gid": "gid://shopify/ProductVariant/13909948432445",
            "sku": "SSG-070301",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-5-0-putter-grip?variant=13909948432445"
          },
          {
            "id": "31552985137213",
            "gid": "gid://shopify/ProductVariant/31552985137213",
            "sku": "SSG-070330",
            "color": "Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red/White/Blue"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-5-0-putter-grip?variant=31552985137213"
          },
          {
            "id": "13909948530749",
            "gid": "gid://shopify/ProductVariant/13909948530749",
            "sku": "SSG-070300",
            "color": "Wht/Red/Gry",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Wht/Red/Gry"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-5-0-putter-grip?variant=13909948530749"
          },
          {
            "id": "31524042113085",
            "gid": "gid://shopify/ProductVariant/31524042113085",
            "sku": "SSG-070337",
            "color": "Digi Camo",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Digi Camo"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-traxion-tour-5-0-putter-grip?variant=31524042113085"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, 5.0, All Products, asbl-putter-grip-option, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, single-grip, suoer-stroke-5-0-putter-grips, super stroke traxion, super-stroke, super-stroke-series-with-c",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-usa-commemorative-2-0-putter-grip-with-counter-core-50g-weight",
    "brand": "Super Stroke",
    "model": "USA Commemorative 2.0 Putter Grip with Counter Core 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "special_edition",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-legacy-2-0-putter-grip-with-counter-core-50g-weight",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/comm-2-colors_e4eb6d5e-9040-4db6-8f72-acfb22a5fae3.jpg?v=1636054945",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 21,
        "per_grip_g": 907,
        "total_g": 907.003303052,
        "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-legacy-2-0-putter-grip-with-counter-core-50g-weight",
        "handle": "super-stroke-usa-commemorative-legacy-2-0-putter-grip-with-counter-core-50g-weight",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "25323017287",
            "gid": "gid://shopify/ProductVariant/25323017287",
            "sku": "SSG-060150",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-legacy-2-0-putter-grip-with-counter-core-50g-weight?variant=25323017287"
          },
          {
            "id": "25323017351",
            "gid": "gid://shopify/ProductVariant/25323017351",
            "sku": "SSG-060151",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-legacy-2-0-putter-grip-with-counter-core-50g-weight?variant=25323017351"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All products, Commemorative, Counter Balance, CounterCore, limited edition, Mid Slim, midsize, midsize-golf-grips, New for 2016, non-tapered, putter, single-grip, Size_Midsize, super-stroke, super-stroke-2-0-putter-grips, super-stroke-series-with-counter-core-technology, superstroke, ",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "Red"
    ]
  },
  {
    "id": "super-stroke-usa-commemorative-legacy-3-0-putter-grip-with-counter-core-50g-weig",
    "brand": "Super Stroke",
    "model": "USA Commemorative Legacy 3.0 Putter Grip with Counter Core 50g Weight",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "Public product page verified 404 on 2026-07-14",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "special_edition",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-legacy-3-0-putter-grip-with-counter-core-50g-weight",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/comm-2-colors_87e1a52b-6f99-4a7f-9283-49c5e9df1983.jpg?v=1636054836",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 21,
        "per_grip_g": 907,
        "total_g": 907.003303052,
        "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-legacy-3-0-putter-grip-with-counter-core-50g-weight",
        "handle": "super-stroke-usa-commemorative-legacy-3-0-putter-grip-with-counter-core-50g-weight",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "25323116935",
            "gid": "gid://shopify/ProductVariant/25323116935",
            "sku": "SSG-060250",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-legacy-3-0-putter-grip-with-counter-core-50g-weight?variant=25323116935"
          },
          {
            "id": "25323116999",
            "gid": "gid://shopify/ProductVariant/25323116999",
            "sku": "SSG-060251",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-legacy-3-0-putter-grip-with-counter-core-50g-weight?variant=25323116999"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "3.0, 49 under, All products, Commemorative, Counter Balance, CounterCore, jumbo/oversize, Legacy, limited edition, New for 2016, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter-grips, single-grip, Size_Jumbo/Oversize, Slim, super-stroke, super-stroke-3-0-putter-grips, super-stroke-s",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "2026-07-14",
    "manual_notes": "Do not recommend: public storefront product page returns 404 even though an older Shopify variant export marked the variants available.",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "Red"
    ]
  },
  {
    "id": "super-stroke-usa-flatso-1-0-putter-grip-with-counter-core-50g-wt",
    "brand": "Super Stroke",
    "model": "USA Flatso 1.0 Putter Grip with Counter Core 50g Wt",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-flatso-10-countercore-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/comm-2-colors.jpg?v=1636055077",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 21,
        "per_grip_g": 907,
        "total_g": 907.003303052,
        "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-flatso-10-countercore-putter-grip",
        "handle": "super-stroke-usa-commemorative-flatso-10-countercore-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "25322521223",
            "gid": "gid://shopify/ProductVariant/25322521223",
            "sku": "SSG-060450",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-flatso-10-countercore-putter-grip?variant=25322521223"
          },
          {
            "id": "25322521287",
            "gid": "gid://shopify/ProductVariant/25322521287",
            "sku": "SSG-060451",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-flatso-10-countercore-putter-grip?variant=25322521287"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All products, Commemorative, Counter Balance, CounterCore, flatso, limited edition, midsize, midsize-golf-grips, New for 2016, non-tapered, putter, single-grip, Size_Midsize, Size_Standard, standard, standard-size-golf-grips, super-stroke, super-stroke-1-0-putter-grips, super-stroke-s",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "Red"
    ]
  },
  {
    "id": "super-stroke-usa-gt-tour-putter-grip-with-counter-core-50g-wt",
    "brand": "Super Stroke",
    "model": "USA GT Tour Putter Grip with Counter Core 50g Wt",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "polyurethane (synthetic)",
    "texture": "textured",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-gt-tour-putter-grip-with-counter-core-50g-weight",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/comm-2-colors_68b05849-1db0-44bf-a16c-9e341f955291.jpg?v=1636054969",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 21,
        "per_grip_g": 907,
        "total_g": 907.003303052,
        "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-gt-tour-putter-grip-with-counter-core-50g-weight",
        "handle": "super-stroke-usa-commemorative-gt-tour-putter-grip-with-counter-core-50g-weight",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "25322876935",
            "gid": "gid://shopify/ProductVariant/25322876935",
            "sku": "SSG-061150",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-gt-tour-putter-grip-with-counter-core-50g-weight?variant=25322876935"
          },
          {
            "id": "25322876999",
            "gid": "gid://shopify/ProductVariant/25322876999",
            "sku": "SSG-061151",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-gt-tour-putter-grip-with-counter-core-50g-weight?variant=25322876999"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All products, Commemorative, Counter Balance, CounterCore, GT Tour, limited edition, New for 2016, non-tapered, putter, single-grip, Size_Standard, standard, standard-size-golf-grips, super-stroke, super-stroke-series-with-counter-core-technology, superstroke, under-150, video=rysDcG2Iuq0",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "Red"
    ]
  },
  {
    "id": "super-stroke-usa-pistol-gt-1-0-putter-grip-with-counter-core-50g-wt",
    "brand": "Super Stroke",
    "model": "USA Pistol GT 1.0 Putter Grip with Counter Core 50g Wt",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-pistol-gt-1-0-putter-grip-with-counter-core-50g-weight",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/comm-2-colors_8688f759-4863-45dd-a379-d0223198fe79.jpg?v=1636054729",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 21,
        "per_grip_g": 907,
        "total_g": 907.003303052,
        "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-pistol-gt-1-0-putter-grip-with-counter-core-50g-weight",
        "handle": "super-stroke-usa-commemorative-pistol-gt-1-0-putter-grip-with-counter-core-50g-weight",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "25323200071",
            "gid": "gid://shopify/ProductVariant/25323200071",
            "sku": "SSG-061250",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-pistol-gt-1-0-putter-grip-with-counter-core-50g-weight?variant=25323200071"
          },
          {
            "id": "25323200199",
            "gid": "gid://shopify/ProductVariant/25323200199",
            "sku": "SSG-061251",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-pistol-gt-1-0-putter-grip-with-counter-core-50g-weight?variant=25323200199"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All products, Commemorative, Counter Balance, CounterCore, limited edition, midsize, midsize-golf-grips, New for 2016, non-tapered, oversize, oversize-jumbo-golf-grips, pistol, Pistol GT, putter, single-grip, Size_Midsize, Size_Standard, standard, standard-size-golf-grips, super-strok",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "Red"
    ]
  },
  {
    "id": "super-stroke-usa-pistol-gt-2-0-putter-grip-with-countercore-50g-wt",
    "brand": "Super Stroke",
    "model": "USA Pistol GT 2.0 Putter Grip with CounterCore 50g Wt",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue"
    ],
    "weight_g_by_size": {},
    "weight_source": "shopify_single_variant",
    "weight_confidence": "low",
    "price_min": 21,
    "price_max": 21,
    "single_price_min": 21,
    "single_price_max": 21,
    "normalized_price_per_grip": 21,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-pistol-gt-2-0-putter-grip-with-counter-core-50g-weight",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/comm-2-colors_3b4fa989-bf06-4357-ab45-305d3a6370a6.jpg?v=1636054704",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue"
        ],
        "price": 21,
        "per_grip_g": 907,
        "total_g": 907.003303052,
        "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-pistol-gt-2-0-putter-grip-with-counter-core-50g-weight",
        "handle": "super-stroke-usa-commemorative-pistol-gt-2-0-putter-grip-with-counter-core-50g-weight",
        "shopify_variants": [
          {
            "id": "25323264391",
            "gid": "gid://shopify/ProductVariant/25323264391",
            "sku": "SSG-061350",
            "color": "Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-pistol-gt-2-0-putter-grip-with-counter-core-50g-weight?variant=25323264391"
          },
          {
            "id": "25323264455",
            "gid": "gid://shopify/ProductVariant/25323264455",
            "sku": "SSG-061351",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 21,
            "weight_g": 907.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-usa-commemorative-pistol-gt-2-0-putter-grip-with-counter-core-50g-weight?variant=25323264455"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All products, Commemorative, Counter Balance, CounterCore, limited edition, midsize, midsize-golf-grips, New for 2016, non-tapered, pistol, Pistol GT, putter, single-grip, Size_Midsize, super-stroke, super-stroke-2-0-putter-grips, super-stroke-pistol-gt-gtr-putter-grips, super-stroke-",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue",
      "Red"
    ]
  },
  {
    "id": "super-stroke-wristlock-putter-grip-13-75",
    "brand": "Super Stroke",
    "model": "WristLock Putter Grip - 13.75\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "",
    "alignment_type": "unknown",
    "alignment_technology": "unknown",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "wristlock (long)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 77.1
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 29.99,
    "price_max": 29.99,
    "single_price_min": 29.99,
    "single_price_max": 29.99,
    "normalized_price_per_grip": 29.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-wristlock-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/ss-wrist-lock-3colors.jpg?v=1589584247",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 29.99,
        "per_grip_g": 77.1,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/super-stroke-wristlock-putter-grip",
        "handle": "super-stroke-wristlock-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Green/White",
              "Orange/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31807532040253",
            "gid": "gid://shopify/ProductVariant/31807532040253",
            "sku": "SSG-073501",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 77.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-wristlock-putter-grip?variant=31807532040253"
          },
          {
            "id": "31807532073021",
            "gid": "gid://shopify/ProductVariant/31807532073021",
            "sku": "SSG-073511",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 77.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-wristlock-putter-grip?variant=31807532073021"
          },
          {
            "id": "31807570608189",
            "gid": "gid://shopify/ProductVariant/31807570608189",
            "sku": "SSG-073505",
            "color": "Orange/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange/White"
            },
            "available": false,
            "price": 29.99,
            "weight_g": 77.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-wristlock-putter-grip?variant=31807570608189"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, golf-grips, golfers-gift-guide, laborday-2022, Long Putter, mid-ov-putter-sale, midsize, midsize-golf-grips, new arrivals, non-tapered, putter, putter grip, putter-grips, summer-overstock-2022, Super Stroke WristLock, super-stroke, superstroke, superstroke",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-xx-super-stroke-zenergy-tour-3-0-putter-grip-camo-red-white-blue",
    "brand": "Super Stroke",
    "model": "XX Super Stroke Zenergy Tour 3.0 Putter Grip (Camo Red/White/Blue)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Camo Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip-camo-rwb",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_ZENERGY_Tour3.0_RWBCamo_0007_F.jpg?v=1778253463",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Camo Red/White/Blue"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip-camo-rwb",
        "handle": "super-stroke-tour-3-0-zenergy-putter-grip-camo-rwb",
        "shopify_variants": [
          {
            "id": "41040040099901",
            "gid": "gid://shopify/ProductVariant/41040040099901",
            "sku": "SS-080237",
            "color": "Camo Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Camo Red/White/Blue"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip-camo-rwb?variant=41040040099901"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Red/White/Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2024 new products, 3.0, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, fathers-day-gifts, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, pu",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-zenergy-1-0pt",
    "brand": "Super Stroke",
    "model": "Zenergy 1.0PT",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-1-0pt-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/superstroke-1.0pt-allcolors.jpg?v=1692391645",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-1-0pt-zenergy-putter-grip",
        "handle": "super-stroke-1-0pt-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "White/Silver"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495752871997",
            "gid": "gid://shopify/ProductVariant/40495752871997",
            "sku": "SS-083001",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-1-0pt-zenergy-putter-grip?variant=40495752871997"
          },
          {
            "id": "40495752904765",
            "gid": "gid://shopify/ProductVariant/40495752904765",
            "sku": "SS-083040",
            "color": "White/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Silver"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-1-0pt-zenergy-putter-grip?variant=40495752904765"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 1.0 PT, 1.0PT, 49 under, All Products, Brand_Super Stroke, Counter Balance, Countercore, golf-grips, golfers-gift-guide, laborday-2022, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke 1.0PT, new arrivals, non-tapered, pistol, putter, putter grip, putter grip gift, putter-gri",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "White/Silver"
    ]
  },
  {
    "id": "super-stroke-zenergy-2-piece-split",
    "brand": "Super Stroke",
    "model": "Zenergy 2-Piece Split",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-2-piece-split-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-zenergy-2pc-putter-grip.jpg?v=1676663335",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 39.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/super-stroke-2-piece-split-zenergy-putter-grip",
        "handle": "super-stroke-2-piece-split-zenergy-putter-grip",
        "shopify_variants": [
          {
            "id": "40495753035837",
            "gid": "gid://shopify/ProductVariant/40495753035837",
            "sku": "SS-083200",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": false,
            "price": 39.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-2-piece-split-zenergy-putter-grip?variant=40495753035837"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2-pc, 2-piece putter grips, 49 under, All Products, arm lock, arm lock putter grip, belly, Brand_Super Stroke, Counter Balance, golf-grips, jumbo/oversize, long, Long Putter, Long/Belly Putter, mid-ov-putter-sale, Model_Super Stroke Zenergy Split 2pc, putter, putter grip, putter-grips, split, Super ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-zenergy-2-0pt",
    "brand": "Super Stroke",
    "model": "Zenergy 2.0PT",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White / Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-zenergy-2-0pt-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Untitled_Project_1.jpg?v=1770925815",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White / Black"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-zenergy-2-0pt-putter-grip",
        "handle": "super-stroke-zenergy-2-0pt-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White / Black",
              "White / Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61541479252338",
            "gid": "gid://shopify/ProductVariant/61541479252338",
            "sku": "SS-83100",
            "color": "White / Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White / Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-zenergy-2-0pt-putter-grip?variant=61541479252338"
          },
          {
            "id": "61541480366450",
            "gid": "gid://shopify/ProductVariant/61541480366450",
            "sku": "SS-83102",
            "color": "White / Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White / Red"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-zenergy-2-0pt-putter-grip?variant=61541480366450"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 2024 new products, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putte",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-zenergy-claw-1-0",
    "brand": "Super Stroke",
    "model": "Zenergy CLAW 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat claw",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-claw-1-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_Claw1.0_allcolors.jpg?v=1692392099",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-claw-1-0-zenergy-putter-grip",
        "handle": "super-stroke-claw-1-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black",
              "White/Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495755329597",
            "gid": "gid://shopify/ProductVariant/40495755329597",
            "sku": "SS-082200",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-claw-1-0-zenergy-putter-grip?variant=40495755329597"
          },
          {
            "id": "40495755362365",
            "gid": "gid://shopify/ProductVariant/40495755362365",
            "sku": "SS-082202",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-claw-1-0-zenergy-putter-grip?variant=40495755362365"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, Brand_Super Stroke, Claw, Claw Zenergy, Counter Balance, Countercore, golf-grips, golfers-gift-guide, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Claw, Model_Super Stroke Zenergy Claw, new arrivals, non-tapered, putter, putter grip, putter grip gi",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black",
      "White/Red"
    ]
  },
  {
    "id": "super-stroke-zenergy-claw-2-0",
    "brand": "Super Stroke",
    "model": "Zenergy CLAW 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat claw",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-claw-2-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_Claw2.0-allcolors.jpg?v=1692392177",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-claw-2-0-zenergy-putter-grip",
        "handle": "super-stroke-claw-2-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black",
              "White/Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495755264061",
            "gid": "gid://shopify/ProductVariant/40495755264061",
            "sku": "SS-082300",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-claw-2-0-zenergy-putter-grip?variant=40495755264061"
          },
          {
            "id": "40495755296829",
            "gid": "gid://shopify/ProductVariant/40495755296829",
            "sku": "SS-082302",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-claw-2-0-zenergy-putter-grip?variant=40495755296829"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 2023-summer-new-sale, 49 under, All Products, Brand_Super Stroke, Claw, Claw 2.0, Claw Zenergy, Counter Balance, Countercore, golf-grips, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Claw, Model_Super Stroke Zenergy Claw, new arrivals, non-tapered, putter, putter grip, pu",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Red"
    ]
  },
  {
    "id": "super-stroke-zenergy-flatso-1-0",
    "brand": "Super Stroke",
    "model": "Zenergy FLATSO 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_Flatso1.0_allcolors.jpg?v=1774480900",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip",
        "handle": "super-stroke-flatso-1-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Grey/White",
              "Org/Blue/Wht",
              "Purple/White",
              "White/Black",
              "White/Red",
              "White/Silver",
              "Blue/White",
              "Green/White",
              "Orange/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495755001917",
            "gid": "gid://shopify/ProductVariant/40495755001917",
            "sku": "SS-080401",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=40495755001917"
          },
          {
            "id": "40495755034685",
            "gid": "gid://shopify/ProductVariant/40495755034685",
            "sku": "SS-080414",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=40495755034685"
          },
          {
            "id": "40495755067453",
            "gid": "gid://shopify/ProductVariant/40495755067453",
            "sku": "SS-080405",
            "color": "Org/Blue/Wht",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Org/Blue/Wht"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=40495755067453"
          },
          {
            "id": "40495755100221",
            "gid": "gid://shopify/ProductVariant/40495755100221",
            "sku": "SS-080413",
            "color": "Purple/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Purple/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=40495755100221"
          },
          {
            "id": "40495755132989",
            "gid": "gid://shopify/ProductVariant/40495755132989",
            "sku": "SS-080400",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=40495755132989"
          },
          {
            "id": "40495755165757",
            "gid": "gid://shopify/ProductVariant/40495755165757",
            "sku": "SS-080402",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=40495755165757"
          },
          {
            "id": "40495755198525",
            "gid": "gid://shopify/ProductVariant/40495755198525",
            "sku": "SS-080440",
            "color": "White/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Silver"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=40495755198525"
          },
          {
            "id": "40495755231293",
            "gid": "gid://shopify/ProductVariant/40495755231293",
            "sku": "SS-080403",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=40495755231293"
          },
          {
            "id": "61538684600690",
            "gid": "gid://shopify/ProductVariant/61538684600690",
            "sku": "SS-080411",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=61538684600690"
          },
          {
            "id": "61538684633458",
            "gid": "gid://shopify/ProductVariant/61538684633458",
            "sku": "SS-080415",
            "color": "Orange/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip?variant=61538684633458"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, Brand_Super Stroke, CounterCore, Flatso, Flatso Series, flatso Zenergy, golf-grips, mid-ov-putter-sale, Midsize, midsize-golf-grips, Model_Super Stroke Zenergy Flatso, new arrivals, non-tapered, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, stan",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "Grey/White",
      "Org/Blue/Wht",
      "Purple/White",
      "White/Black",
      "White/Red",
      "White/Silver",
      "Blue/White",
      "Green/White",
      "Orange/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-flatso-1-0-putter-grip-camo-red-white-blue",
    "brand": "Super Stroke",
    "model": "Zenergy FLATSO 1.0 Putter Grip (Camo Red/White/Blue)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Camo Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip-camo-rwb",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_ZENERGY_Flatso1.0_RWBCamo_0006_FRQ.jpg?v=1714248995",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Camo Red/White/Blue"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip-camo-rwb",
        "handle": "super-stroke-flatso-1-0-zenergy-putter-grip-camo-rwb",
        "shopify_variants": [
          {
            "id": "41040040132669",
            "gid": "gid://shopify/ProductVariant/41040040132669",
            "sku": "SS-080437",
            "color": "Camo Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Camo Red/White/Blue"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-1-0-zenergy-putter-grip-camo-rwb?variant=41040040132669"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Red/White/Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "1.0, 2024 new products, 49 under, All Products, Brand_Super Stroke, CounterCore, Flatso, Flatso Series, flatso Zenergy, golf-grips, mid-ov-putter-sale, Midsize, midsize-golf-grips, Model_Super Stroke Zenergy Flatso, new arrivals, non-tapered, putter, putter grip, putter grip gift, putter-grip-gifts,",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Camo Red/White/Blue"
    ]
  },
  {
    "id": "super-stroke-zenergy-flatso-17",
    "brand": "Super Stroke",
    "model": "Zenergy FLATSO 17\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Long"
    ],
    "manufacturer_size_labels": [
      "Long"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Long": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 39.99,
    "price_max": 39.99,
    "single_price_min": 39.99,
    "single_price_max": 39.99,
    "normalized_price_per_grip": 39.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-17-long-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ss-flatso17.jpg?v=1692393232",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Long"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 39.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-17-long-zenergy-putter-grip",
        "handle": "super-stroke-flatso-17-long-zenergy-putter-grip",
        "shopify_variants": [
          {
            "id": "40495753068605",
            "gid": "gid://shopify/ProductVariant/40495753068605",
            "sku": "SS-083600",
            "color": "White/Black",
            "size": "Long",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 39.99,
            "weight_g": 127,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-17-long-zenergy-putter-grip?variant=40495753068605"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "17\", 49 under, All Products, arm lock, arm lock putter grip, belly, Brand_Super Stroke, Counter Balance, Flatso, Flatso Series, flatso Zenergy, golf-grips, jumbo/oversize, long, Long Putter, Long/Belly Putter, Model_Super Stroke Zenergy 17\" Flatso, Model_Super Stroke Zenergy Flatso, putter, putter g",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black"
    ]
  },
  {
    "id": "super-stroke-zenergy-flatso-2-0",
    "brand": "Super Stroke",
    "model": "Zenergy FLATSO 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPT_Image_Jan_20_2026_11_23_54_AM.png?v=1769036998",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-zenergy-putter-grip",
        "handle": "super-stroke-flatso-2-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Grey/White",
              "White/Red",
              "Blue/White",
              "Green/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495768207421",
            "gid": "gid://shopify/ProductVariant/40495768207421",
            "sku": "SS-080501",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-zenergy-putter-grip?variant=40495768207421"
          },
          {
            "id": "40495768240189",
            "gid": "gid://shopify/ProductVariant/40495768240189",
            "sku": "SS-080514",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-zenergy-putter-grip?variant=40495768240189"
          },
          {
            "id": "40495768272957",
            "gid": "gid://shopify/ProductVariant/40495768272957",
            "sku": "SS-080502",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-zenergy-putter-grip?variant=40495768272957"
          },
          {
            "id": "40495768305725",
            "gid": "gid://shopify/ProductVariant/40495768305725",
            "sku": "SS-080503",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-zenergy-putter-grip?variant=40495768305725"
          },
          {
            "id": "61538571911538",
            "gid": "gid://shopify/ProductVariant/61538571911538",
            "sku": "SS-080511",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-2-0-zenergy-putter-grip?variant=61538571911538"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, best-sellers, Brand_Super Stroke, CounterCore, Flatso, Flatso Series, flatso Zenergy, golf-grips, jumbo/oversize, mid-ov-putter-sale, Model_Super Stroke Zenergy Flatso, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, putter-grips, sup",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "White/Red",
      "Green/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-flatso-3-0",
    "brand": "Super Stroke",
    "model": "Zenergy FLATSO 3.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPT_Image_Jan_20_2026_11_23_54_AM_b66df8f5-0b75-4c95-8fa7-29002e0d335a.png?v=1769036985",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-zenergy-putter-grip",
        "handle": "super-stroke-flatso-3-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Grey/White",
              "White/Red",
              "Blue/White",
              "Green/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495768076349",
            "gid": "gid://shopify/ProductVariant/40495768076349",
            "sku": "SS-080601",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-zenergy-putter-grip?variant=40495768076349"
          },
          {
            "id": "40495768109117",
            "gid": "gid://shopify/ProductVariant/40495768109117",
            "sku": "SS-080614",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-zenergy-putter-grip?variant=40495768109117"
          },
          {
            "id": "40495768141885",
            "gid": "gid://shopify/ProductVariant/40495768141885",
            "sku": "SS-080602",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-zenergy-putter-grip?variant=40495768141885"
          },
          {
            "id": "40495768174653",
            "gid": "gid://shopify/ProductVariant/40495768174653",
            "sku": "SS-080603",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-zenergy-putter-grip?variant=40495768174653"
          },
          {
            "id": "61538574827890",
            "gid": "gid://shopify/ProductVariant/61538574827890",
            "sku": "SS-080611",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-3-0-zenergy-putter-grip?variant=61538574827890"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "3.0, 49 under, All Products, Brand_Super Stroke, CounterCore, Flatso, Flatso Series, flatso Zenergy, golf-grips, jumbo/oversize, mid-ov-putter-sale, Model_Super Stroke Zenergy Flatso, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, putter-grips, super stroke 3.0,",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "Grey/White",
      "White/Red",
      "Blue/White",
      "Green/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-flatso-xl-2-0-putter-grip-13-75",
    "brand": "Super Stroke",
    "model": "Zenergy FLATSO XL+ 2.0 Putter Grip (13.75\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "flat-front (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 86.2
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-flatso-xl-2-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-zenergy-flatso-xl-20-putter-grip.jpg?v=1676663843",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 34.99,
        "per_grip_g": 86.2,
        "total_g": 86.1825503,
        "url": "https://www.grips4less.com/products/super-stroke-flatso-xl-2-0-zenergy-putter-grip",
        "handle": "super-stroke-flatso-xl-2-0-zenergy-putter-grip",
        "shopify_variants": [
          {
            "id": "40495754969149",
            "gid": "gid://shopify/ProductVariant/40495754969149",
            "sku": "SS-080900",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 86.2,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-flatso-xl-2-0-zenergy-putter-grip?variant=40495754969149"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, Brand_Super Stroke, Counter Balance, CounterCore, Flatso, Flatso Series, flatso Zenergy, golf-grips, jumbo/oversize, Model_Super Stroke Zenergy Flatso, Model_Super Stroke Zenergy XL+Plus, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black"
    ]
  },
  {
    "id": "super-stroke-zenergy-pistol-gt-1-0",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol GT 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPT_Image_Jan_20_2026_11_42_38_AM.png?v=1769037021",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip",
        "handle": "super-stroke-pistol-gt-1-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Grey/White",
              "Org/Blue/Wht",
              "White/Black",
              "White/Red",
              "White/Silver",
              "Blue/White",
              "Sky Blue/White",
              "Green/White",
              "Orange/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495754707005",
            "gid": "gid://shopify/ProductVariant/40495754707005",
            "sku": "SS-081201",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=40495754707005"
          },
          {
            "id": "40495754739773",
            "gid": "gid://shopify/ProductVariant/40495754739773",
            "sku": "SS-081214",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=40495754739773"
          },
          {
            "id": "40495754772541",
            "gid": "gid://shopify/ProductVariant/40495754772541",
            "sku": "SS-081205",
            "color": "Org/Blue/Wht",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Org/Blue/Wht"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=40495754772541"
          },
          {
            "id": "40495754838077",
            "gid": "gid://shopify/ProductVariant/40495754838077",
            "sku": "SS-081200",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=40495754838077"
          },
          {
            "id": "40495754870845",
            "gid": "gid://shopify/ProductVariant/40495754870845",
            "sku": "SS-081202",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=40495754870845"
          },
          {
            "id": "40495754903613",
            "gid": "gid://shopify/ProductVariant/40495754903613",
            "sku": "SS-081240",
            "color": "White/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Silver"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=40495754903613"
          },
          {
            "id": "40495754936381",
            "gid": "gid://shopify/ProductVariant/40495754936381",
            "sku": "SS-081203",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=40495754936381"
          },
          {
            "id": "61538577973618",
            "gid": "gid://shopify/ProductVariant/61538577973618",
            "sku": "SS-081220",
            "color": "Sky Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Sky Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=61538577973618"
          },
          {
            "id": "61538578006386",
            "gid": "gid://shopify/ProductVariant/61538578006386",
            "sku": "SS-081211",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=61538578006386"
          },
          {
            "id": "61538578039154",
            "gid": "gid://shopify/ProductVariant/61538578039154",
            "sku": "SS-081215",
            "color": "Orange/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip?variant=61538578039154"
          }
        ],
        "shopify_variant_count": 10,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, best-sellers, Brand_Super Stroke, CounterCore, golf-grips, mid-ov-putter-sale, Midsize, midsize-golf-grips, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Zenergy, putter, putter grip, putter-grips, standard, sta",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "Org/Blue/Wht",
      "White/Black",
      "White/Red",
      "Blue/White",
      "Sky Blue/White",
      "Green/White",
      "Orange/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-pistol-gt-1-0-putter-grip-camo-red-white-blue",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol GT 1.0 Putter Grip (Camo Red/White/Blue)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Camo Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip-camo-rwb",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_ZENERGY_Pistol1.0_RWBCamo_0000_FLQ.jpg?v=1714248919",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Camo Red/White/Blue"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip-camo-rwb",
        "handle": "super-stroke-pistol-gt-1-0-zenergy-putter-grip-camo-rwb",
        "shopify_variants": [
          {
            "id": "41040040362045",
            "gid": "gid://shopify/ProductVariant/41040040362045",
            "sku": "SS-081237",
            "color": "Camo Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Camo Red/White/Blue"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip-camo-rwb?variant=41040040362045"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Red/White/Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "1.0, 2024 new products, 49 under, All Products, Brand_Super Stroke, CounterCore, golf-grips, mid-ov-putter-sale, Midsize, midsize-golf-grips, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Zenergy, putter, putter grip, putter-grips, standard",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-zenergy-pistol-gt-1-0-putter-grip-pink-white",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol GT 1.0 Putter Grip (Pink/White)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Pink/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip-pink-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_ZENERGY_Pistol1.0_Pink_0000_FRQ.jpg?v=1714249126",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Pink/White"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip-pink-white",
        "handle": "super-stroke-pistol-gt-1-0-zenergy-putter-grip-pink-white",
        "shopify_variants": [
          {
            "id": "41040040329277",
            "gid": "gid://shopify/ProductVariant/41040040329277",
            "sku": "SS-081210",
            "color": "Pink/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Pink/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-1-0-zenergy-putter-grip-pink-white?variant=41040040329277"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Pink/White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "1.0, 2024 new products, 49 under, All Products, Brand_Super Stroke, CounterCore, golf-grips, mid-ov-putter-sale, Midsize, midsize-golf-grips, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Zenergy, putter, putter grip, putter-grips, standard",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Pink/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-pistol-gt-2-0",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol GT 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/superstroke_pistol2_lineup_plus_orange_green.png?v=1769037052",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip",
        "handle": "super-stroke-pistol-gt-2-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Grey/White",
              "White/Black",
              "White/Red",
              "White/Silver",
              "Blue/White",
              "Green/White",
              "Orange/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495754281021",
            "gid": "gid://shopify/ProductVariant/40495754281021",
            "sku": "SS-081301",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip?variant=40495754281021"
          },
          {
            "id": "40495754313789",
            "gid": "gid://shopify/ProductVariant/40495754313789",
            "sku": "SS-081314",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip?variant=40495754313789"
          },
          {
            "id": "40495754412093",
            "gid": "gid://shopify/ProductVariant/40495754412093",
            "sku": "SS-081300",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip?variant=40495754412093"
          },
          {
            "id": "40495754444861",
            "gid": "gid://shopify/ProductVariant/40495754444861",
            "sku": "SS-081302",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip?variant=40495754444861"
          },
          {
            "id": "40495754477629",
            "gid": "gid://shopify/ProductVariant/40495754477629",
            "sku": "SS-081340",
            "color": "White/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Silver"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip?variant=40495754477629"
          },
          {
            "id": "40495754510397",
            "gid": "gid://shopify/ProductVariant/40495754510397",
            "sku": "SS-081303",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip?variant=40495754510397"
          },
          {
            "id": "61538598388082",
            "gid": "gid://shopify/ProductVariant/61538598388082",
            "sku": "SS-081311",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip?variant=61538598388082"
          },
          {
            "id": "61538598420850",
            "gid": "gid://shopify/ProductVariant/61538598420850",
            "sku": "SS-081315",
            "color": "Orange/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip?variant=61538598420850"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, Brand_Super Stroke, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, Pistol GT, Pistol GT Countercore, Pistol GT Zenergy, putter, putter grip, putter-gri",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "Grey/White",
      "White/Black",
      "White/Red",
      "Blue/White",
      "Orange/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-pistol-gt-2-0-putter-grip-camo-red-white-blue",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol GT 2.0 Putter Grip (Camo Red/White/Blue)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Camo Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip-camo-rwb",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_ZENERGY_Pistol2.0_RWBCamo_0000_FRQ.jpg?v=1714249163",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Camo Red/White/Blue"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip-camo-rwb",
        "handle": "super-stroke-pistol-gt-2-0-zenergy-putter-grip-camo-rwb",
        "shopify_variants": [
          {
            "id": "41040040394813",
            "gid": "gid://shopify/ProductVariant/41040040394813",
            "sku": "SS-081337",
            "color": "Camo Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Camo Red/White/Blue"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-2-0-zenergy-putter-grip-camo-rwb?variant=41040040394813"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Red/White/Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 2024 new products, 49 under, All Products, Brand_Super Stroke, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, Pistol GT, Pistol GT Countercore, Pistol GT Zenergy, putter, putt",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "Camo Red/White/Blue"
    ]
  },
  {
    "id": "super-stroke-zenergy-pistol-gt-tour",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol GT TOUR",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPT_Image_Jan_20_2026_12_08_26_PM.png?v=1769037084",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip",
        "handle": "super-stroke-pistol-gt-tour-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Grey/White",
              "Org/Blue/Wht",
              "Purple/White",
              "White/Black",
              "White/Red",
              "White/Silver",
              "Blue/White",
              "Green/White",
              "Orange/White",
              "Sky Blue/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495754018877",
            "gid": "gid://shopify/ProductVariant/40495754018877",
            "sku": "SS-081101",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=40495754018877"
          },
          {
            "id": "40495754051645",
            "gid": "gid://shopify/ProductVariant/40495754051645",
            "sku": "SS-081114",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=40495754051645"
          },
          {
            "id": "40495754084413",
            "gid": "gid://shopify/ProductVariant/40495754084413",
            "sku": "SS-081105",
            "color": "Org/Blue/Wht",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Org/Blue/Wht"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=40495754084413"
          },
          {
            "id": "40495754117181",
            "gid": "gid://shopify/ProductVariant/40495754117181",
            "sku": "SS-081113",
            "color": "Purple/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Purple/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=40495754117181"
          },
          {
            "id": "40495754149949",
            "gid": "gid://shopify/ProductVariant/40495754149949",
            "sku": "SS-081100",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=40495754149949"
          },
          {
            "id": "40495754182717",
            "gid": "gid://shopify/ProductVariant/40495754182717",
            "sku": "SS-081102",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=40495754182717"
          },
          {
            "id": "40495754215485",
            "gid": "gid://shopify/ProductVariant/40495754215485",
            "sku": "SS-081140",
            "color": "White/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Silver"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=40495754215485"
          },
          {
            "id": "40495754248253",
            "gid": "gid://shopify/ProductVariant/40495754248253",
            "sku": "SS-081103",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=40495754248253"
          },
          {
            "id": "61538601042290",
            "gid": "gid://shopify/ProductVariant/61538601042290",
            "sku": "SS-081111",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=61538601042290"
          },
          {
            "id": "61538601075058",
            "gid": "gid://shopify/ProductVariant/61538601075058",
            "sku": "SS-081115",
            "color": "Orange/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=61538601075058"
          },
          {
            "id": "61538601107826",
            "gid": "gid://shopify/ProductVariant/61538601107826",
            "sku": "SS-081120",
            "color": "Sky Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Sky Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip?variant=61538601107826"
          }
        ],
        "shopify_variant_count": 11,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, Brand_Super Stroke, CounterCore, golf-grips, GT Tour, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Tour, Pistol GT Zenergy, putter, putter grip, putter-grips, standard, standard-size-golf-grips, Super Stroke Putter ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "Grey/White",
      "Org/Blue/Wht",
      "Purple/White",
      "White/Black",
      "White/Red",
      "White/Silver",
      "Blue/White",
      "Green/White",
      "Orange/White",
      "Sky Blue/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-pistol-gt-tour-putter-grip-camo-red-white-blue",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol GT TOUR Putter Grip (Camo Red/White/Blue)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Camo Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip-camo-rwb",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_ZENERGY_PistolTour_RWBCamo_0000_FRQ.jpg?v=1714249600",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Camo Red/White/Blue"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip-camo-rwb",
        "handle": "super-stroke-pistol-gt-tour-zenergy-putter-grip-camo-rwb",
        "shopify_variants": [
          {
            "id": "41040040296509",
            "gid": "gid://shopify/ProductVariant/41040040296509",
            "sku": "SS-081137",
            "color": "Camo Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Camo Red/White/Blue"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip-camo-rwb?variant=41040040296509"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Red/White/Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2024 new products, 49 under, All Products, Brand_Super Stroke, CounterCore, golf-grips, GT Tour, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Tour, Pistol GT Zenergy, putter, putter grip, putter-grips, standard, standard-size-golf-grips, S",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Camo Red/White/Blue"
    ]
  },
  {
    "id": "super-stroke-zenergy-pistol-gt-tour-putter-grip-pink-white",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol GT TOUR Putter Grip (Pink/White)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Pink/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip-pink-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_ZENERGY_PistolTour_Pink_0000_FRQ.jpg?v=1714249725",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Pink/White"
        ],
        "price": 34.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip-pink-white",
        "handle": "super-stroke-pistol-gt-tour-zenergy-putter-grip-pink-white",
        "shopify_variants": [
          {
            "id": "41040040198205",
            "gid": "gid://shopify/ProductVariant/41040040198205",
            "sku": "SS-081110",
            "color": "Pink/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Pink/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 68,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-gt-tour-zenergy-putter-grip-pink-white?variant=41040040198205"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Pink/White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2024 new products, 49 under, All Products, Brand_Super Stroke, CounterCore, golf-grips, GT Tour, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Tour, Pistol GT Zenergy, putter, putter grip, putter-grips, standard, standard-size-golf-grips, S",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Pink/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-pistol-lock-1-0",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol Lock 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 37.99,
    "price_max": 37.99,
    "single_price_min": 37.99,
    "single_price_max": 37.99,
    "normalized_price_per_grip": 37.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-lock-1-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPTImageJan20_2026_01_28_49PM.png?v=1768950131",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 37.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-lock-1-0-putter-grip",
        "handle": "super-stroke-pistol-lock-1-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "White/Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61538623947122",
            "gid": "gid://shopify/ProductVariant/61538623947122",
            "sku": "SS-84201",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 37.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-lock-1-0-putter-grip?variant=61538623947122"
          },
          {
            "id": "61538624110962",
            "gid": "gid://shopify/ProductVariant/61538624110962",
            "sku": "SS-84202",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 37.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-lock-1-0-putter-grip?variant=61538624110962"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, best-sellers, Brand_Super Stroke, CounterCore, golf-grips, mid-ov-putter-sale, Midsize, midsize-golf-grips, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Zenergy, Pistol Lock Putter grip, putter, putter grip, pu",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "White/Red"
    ]
  },
  {
    "id": "super-stroke-zenergy-pistol-lock-2-0",
    "brand": "Super Stroke",
    "model": "Zenergy Pistol Lock 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 68
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 37.99,
    "price_max": 37.99,
    "single_price_min": 37.99,
    "single_price_max": 37.99,
    "normalized_price_per_grip": 37.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-pistol-lock-2-0-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPTImageJan20_2026_01_46_22PM.png?v=1768950158",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 37.99,
        "per_grip_g": 68,
        "total_g": 68.0388555,
        "url": "https://www.grips4less.com/products/super-stroke-pistol-lock-2-0-putter-grip",
        "handle": "super-stroke-pistol-lock-2-0-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "White/Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "61538660024690",
            "gid": "gid://shopify/ProductVariant/61538660024690",
            "sku": "SS-84301",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 37.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-lock-2-0-putter-grip?variant=61538660024690"
          },
          {
            "id": "61538660057458",
            "gid": "gid://shopify/ProductVariant/61538660057458",
            "sku": "SS-84302",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 37.99,
            "weight_g": 68,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-pistol-lock-2-0-putter-grip?variant=61538660057458"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, best-sellers, Brand_Super Stroke, CounterCore, golf-grips, mid-ov-putter-sale, Midsize, midsize-golf-grips, Model_Super Stroke Zenergy Pistol, new arrivals, non-tapered, Pistol GT, Pistol GT Countercore, Pistol GT Zenergy, Pistol Lock 2.0 Putter Grip, Pistol Lock Putter ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "White/Red"
    ]
  },
  {
    "id": "super-stroke-zenergy-ss2r-square",
    "brand": "Super Stroke",
    "model": "Zenergy SS2R Square",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "no-taper",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 108.9
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-ss2-square-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/WEB_SS2R_WhiteBlack_RQ-700.jpg?v=1676661979",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 34.99,
        "per_grip_g": 108.9,
        "total_g": 108.8621688,
        "url": "https://www.grips4less.com/products/super-stroke-ss2-square-zenergy-putter-grip",
        "handle": "super-stroke-ss2-square-zenergy-putter-grip",
        "shopify_variants": [
          {
            "id": "40495753101373",
            "gid": "gid://shopify/ProductVariant/40495753101373",
            "sku": "SS-081000",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 108.9,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-ss2-square-zenergy-putter-grip?variant=40495753101373"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, Brand_Super Stroke, golf-grips, laborday-2022, Model_Super Stroke Zenergy SS2R, non-tapered, putter, putter grip, putter-grips, Square, SS2, SS2R, SS2R Square, SS2R Square Putter, standard, standard-size-golf-grips, summer-overstock-2022, Super Stroke Putt",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "super-stroke-zenergy-tour-xl-2-0-putter-grip-13-75",
    "brand": "Super Stroke",
    "model": "Zenergy TOUR XL+ 2.0 Putter Grip (13.75\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-xl-2-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-zenergy-tour-xl-20-putter-grip.jpg?v=1676664025",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-xl-2-0-zenergy-putter-grip",
        "handle": "super-stroke-xl-2-0-zenergy-putter-grip",
        "shopify_variants": [
          {
            "id": "40495753166909",
            "gid": "gid://shopify/ProductVariant/40495753166909",
            "sku": "SS-080700",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-xl-2-0-zenergy-putter-grip?variant=40495753166909"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, Brand_Super Stroke, Counter Balance, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, Model_Super Stroke Zenergy XL+Plus, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, Plus",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black"
    ]
  },
  {
    "id": "super-stroke-zenergy-tour-xl-3-0-putter-grip-13-75",
    "brand": "Super Stroke",
    "model": "Zenergy TOUR XL+ 3.0 Putter Grip (13.75\")",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-xl-3-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/super-stroke-zenergy-tour-xl-30-putter-grip.jpg?v=1676664143",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-xl-3-0-zenergy-putter-grip",
        "handle": "super-stroke-xl-3-0-zenergy-putter-grip",
        "shopify_variants": [
          {
            "id": "40495753134141",
            "gid": "gid://shopify/ProductVariant/40495753134141",
            "sku": "SS-080800",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-xl-3-0-zenergy-putter-grip?variant=40495753134141"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "3.0, 49 under, All Products, Brand_Super Stroke, Counter Balance, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, Model_Super Stroke Zenergy XL+Plus, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, Plus",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black"
    ]
  },
  {
    "id": "super-stroke-zenergy-tour-1-0",
    "brand": "Super Stroke",
    "model": "Zenergy Tour 1.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "1.0",
    "putter_size_class": "1.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tour-1-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/WEB_Tour1.0_allcolors-700.jpg?v=1676662179",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-1-0-zenergy-putter-grip",
        "handle": "super-stroke-tour-1-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Purple/White",
              "White/Red",
              "White/Silver",
              "Blue/White",
              "Pink/White",
              "Sky Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495753855037",
            "gid": "gid://shopify/ProductVariant/40495753855037",
            "sku": "SS-080001",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-1-0-zenergy-putter-grip?variant=40495753855037"
          },
          {
            "id": "40495753887805",
            "gid": "gid://shopify/ProductVariant/40495753887805",
            "sku": "SS-080013",
            "color": "Purple/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Purple/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-1-0-zenergy-putter-grip?variant=40495753887805"
          },
          {
            "id": "40495753920573",
            "gid": "gid://shopify/ProductVariant/40495753920573",
            "sku": "SS-080002",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-1-0-zenergy-putter-grip?variant=40495753920573"
          },
          {
            "id": "40495753953341",
            "gid": "gid://shopify/ProductVariant/40495753953341",
            "sku": "SS-080040",
            "color": "White/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Silver"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-1-0-zenergy-putter-grip?variant=40495753953341"
          },
          {
            "id": "40495753986109",
            "gid": "gid://shopify/ProductVariant/40495753986109",
            "sku": "SS-080003",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-1-0-zenergy-putter-grip?variant=40495753986109"
          },
          {
            "id": "61541389762930",
            "gid": "gid://shopify/ProductVariant/61541389762930",
            "sku": "SS-080010",
            "color": "Pink/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Pink/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-1-0-zenergy-putter-grip?variant=61541389762930"
          },
          {
            "id": "61541476139378",
            "gid": "gid://shopify/ProductVariant/61541476139378",
            "sku": "SS-080020",
            "color": "Sky Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Sky Blue"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-1-0-zenergy-putter-grip?variant=61541476139378"
          }
        ],
        "shopify_variant_count": 7,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "1.0, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, golf-grips, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, putter, putter grip, putter-grips, standard, standard-size-golf-grips, super stroke 1.0, Super Stroke Putter Grip, super stroke zenergy Zenergy, super-str",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "Purple/White",
      "White/Red",
      "White/Silver",
      "Blue/White",
      "Pink/White",
      "Sky Blue"
    ]
  },
  {
    "id": "super-stroke-zenergy-tour-2-0",
    "brand": "Super Stroke",
    "model": "Zenergy Tour 2.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/ChatGPT_Image_Jan_20_2026_12_25_33_PM.png?v=1768943320",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip",
        "handle": "super-stroke-tour-2-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Grey/White",
              "White/Black",
              "White/Red",
              "White/Silver",
              "Blue/White",
              "Green/White",
              "Orange/White",
              "Sky Blue/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495753592893",
            "gid": "gid://shopify/ProductVariant/40495753592893",
            "sku": "SS-080101",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip?variant=40495753592893"
          },
          {
            "id": "40495753625661",
            "gid": "gid://shopify/ProductVariant/40495753625661",
            "sku": "SS-080114",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip?variant=40495753625661"
          },
          {
            "id": "40495753723965",
            "gid": "gid://shopify/ProductVariant/40495753723965",
            "sku": "SS-080100",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip?variant=40495753723965"
          },
          {
            "id": "40495753756733",
            "gid": "gid://shopify/ProductVariant/40495753756733",
            "sku": "SS-080102",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip?variant=40495753756733"
          },
          {
            "id": "40495753789501",
            "gid": "gid://shopify/ProductVariant/40495753789501",
            "sku": "SS-080140",
            "color": "White/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Silver"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip?variant=40495753789501"
          },
          {
            "id": "40495753822269",
            "gid": "gid://shopify/ProductVariant/40495753822269",
            "sku": "SS-080103",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip?variant=40495753822269"
          },
          {
            "id": "61538605433202",
            "gid": "gid://shopify/ProductVariant/61538605433202",
            "sku": "SS-080111",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip?variant=61538605433202"
          },
          {
            "id": "61538605465970",
            "gid": "gid://shopify/ProductVariant/61538605465970",
            "sku": "SS-080115",
            "color": "Orange/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip?variant=61538605465970"
          },
          {
            "id": "61538605498738",
            "gid": "gid://shopify/ProductVariant/61538605498738",
            "sku": "SS-080120",
            "color": "Sky Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Sky Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip?variant=61538605498738"
          }
        ],
        "shopify_variant_count": 9,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2.0, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, putter-grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "Grey/White",
      "White/Black",
      "White/Red",
      "White/Silver",
      "Blue/White",
      "Green/White",
      "Orange/White",
      "Sky Blue/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-tour-2-0-putter-grip-camo-red-white-blue",
    "brand": "Super Stroke",
    "model": "Zenergy Tour 2.0 Putter Grip (Camo Red/White/Blue)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Camo Red/White/Blue"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip-camo-rwb",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_ZENERGY_Tour2.0_RWBCamo_0007_F.jpg?v=1714248661",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Camo Red/White/Blue"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip-camo-rwb",
        "handle": "super-stroke-tour-2-0-zenergy-putter-grip-camo-rwb",
        "shopify_variants": [
          {
            "id": "41040040067133",
            "gid": "gid://shopify/ProductVariant/41040040067133",
            "sku": "SS-080137",
            "color": "Camo Red/White/Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Camo Red/White/Blue"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip-camo-rwb?variant=41040040067133"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Camo Red/White/Blue"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 2024 new products, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putte",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Camo Red/White/Blue"
    ]
  },
  {
    "id": "super-stroke-zenergy-tour-2-0-putter-grip-pink-white",
    "brand": "Super Stroke",
    "model": "Zenergy Tour 2.0 Putter Grip (Pink/White)",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "2.0",
    "putter_size_class": "2.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Pink/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip-pink-white",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/WEB_ZENERGY_Tour2.0_Pink_0007_F.jpg?v=1714248780",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Pink/White"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip-pink-white",
        "handle": "super-stroke-tour-2-0-zenergy-putter-grip-pink-white",
        "shopify_variants": [
          {
            "id": "41040039837757",
            "gid": "gid://shopify/ProductVariant/41040039837757",
            "sku": "SS-080110",
            "color": "Pink/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Pink/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/super-stroke-tour-2-0-zenergy-putter-grip-pink-white?variant=41040039837757"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Pink/White"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2.0, 2024 new products, 49 under, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putte",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Pink/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-tour-3-0",
    "brand": "Super Stroke",
    "model": "Zenergy Tour 3.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "3.0",
    "putter_size_class": "3.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/WEB_Tour2.0_allcolors-700_1878f044-5363-47e5-9c18-302fdf5acb78.jpg?v=1676662521",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip",
        "handle": "super-stroke-tour-3-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Grey/White",
              "White/Black",
              "White/Red",
              "White/Silver",
              "Blue/White",
              "Green/White",
              "Orange/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495753330749",
            "gid": "gid://shopify/ProductVariant/40495753330749",
            "sku": "SS-080201",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip?variant=40495753330749"
          },
          {
            "id": "40495753363517",
            "gid": "gid://shopify/ProductVariant/40495753363517",
            "sku": "SS-080214",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip?variant=40495753363517"
          },
          {
            "id": "40495753461821",
            "gid": "gid://shopify/ProductVariant/40495753461821",
            "sku": "SS-080200",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip?variant=40495753461821"
          },
          {
            "id": "40495753494589",
            "gid": "gid://shopify/ProductVariant/40495753494589",
            "sku": "SS-080202",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip?variant=40495753494589"
          },
          {
            "id": "40495753527357",
            "gid": "gid://shopify/ProductVariant/40495753527357",
            "sku": "SS-080240",
            "color": "White/Silver",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Silver"
            },
            "available": false,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip?variant=40495753527357"
          },
          {
            "id": "40495753560125",
            "gid": "gid://shopify/ProductVariant/40495753560125",
            "sku": "SS-080203",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip?variant=40495753560125"
          },
          {
            "id": "61538620080498",
            "gid": "gid://shopify/ProductVariant/61538620080498",
            "sku": "SS-080211",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip?variant=61538620080498"
          },
          {
            "id": "61538620113266",
            "gid": "gid://shopify/ProductVariant/61538620113266",
            "sku": "SS-080215",
            "color": "Orange/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Orange/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-3-0-zenergy-putter-grip?variant=61538620113266"
          }
        ],
        "shopify_variant_count": 8,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "3.0, 49 under, All Products, asbl-putter-grip-option, best-sellers, Brand_Super Stroke, CounterCore, fathers-day-gifts, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, putter ",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "Grey/White",
      "White/Black",
      "White/Red",
      "Blue/White",
      "Green/White",
      "Orange/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-tour-5-0",
    "brand": "Super Stroke",
    "model": "Zenergy Tour 5.0",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "no_taper",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol (no-taper)",
    "putter_size": "5.0",
    "putter_size_class": "5.0",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
      "https://superstrokeusa.com/pages/spyne%E2%84%A2-technolgy-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black/White"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 34.99,
    "price_max": 34.99,
    "single_price_min": 34.99,
    "single_price_max": 34.99,
    "normalized_price_per_grip": 34.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-tour-5-0-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/five_grips_side_by_side_correct.png?v=1768950113",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black/White"
        ],
        "price": 34.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/super-stroke-tour-5-0-zenergy-putter-grip",
        "handle": "super-stroke-tour-5-0-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black/White",
              "Blue/Whte",
              "Grey/White",
              "White/Red",
              "Green/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495753199677",
            "gid": "gid://shopify/ProductVariant/40495753199677",
            "sku": "SS-080301",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-5-0-zenergy-putter-grip?variant=40495753199677"
          },
          {
            "id": "40495753232445",
            "gid": "gid://shopify/ProductVariant/40495753232445",
            "sku": "SS-080303",
            "color": "Blue/Whte",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/Whte"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-5-0-zenergy-putter-grip?variant=40495753232445"
          },
          {
            "id": "40495753265213",
            "gid": "gid://shopify/ProductVariant/40495753265213",
            "sku": "SS-080314",
            "color": "Grey/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Grey/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-5-0-zenergy-putter-grip?variant=40495753265213"
          },
          {
            "id": "40495753297981",
            "gid": "gid://shopify/ProductVariant/40495753297981",
            "sku": "SS-080302",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-5-0-zenergy-putter-grip?variant=40495753297981"
          },
          {
            "id": "61538622833010",
            "gid": "gid://shopify/ProductVariant/61538622833010",
            "sku": "SS-080311",
            "color": "Green/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Green/White"
            },
            "available": true,
            "price": 34.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-tour-5-0-zenergy-putter-grip?variant=61538622833010"
          }
        ],
        "shopify_variant_count": 5,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, 5.0, All Products, asbl-putter-grip-option, Brand_Super Stroke, CounterCore, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, Model_Super Stroke Zenergy Tour, new arrivals, non-tapered, oversize, oversize-jumbo-golf-grips, putter, putter grip, putter-grips, suoer-stroke-5-0-putter-gr",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.golfworks.com/super-stroke-zenergy-pistol-gt-2-0-putter-grip/p/st0185/",
    "last_verified_date": "2026-07-13",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black/White",
      "Blue/Whte",
      "Grey/White",
      "White/Red",
      "Green/White"
    ]
  },
  {
    "id": "super-stroke-zenergy-wristlock-putter-grip-13-75",
    "brand": "Super Stroke",
    "model": "Zenergy WristLock Putter Grip - 13.75\"",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "polyurethane (synthetic)",
    "texture": "Traxion micro-texture",
    "feel": "firm",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "SPYNE ridge (reminder)",
    "alignment_type": "raised_ridge",
    "alignment_technology": "SPYNE",
    "alignment_description": "Embossed SPYNE ridge along the underside designed to provide enhanced feedback and a repeatable hand-placement reference.",
    "manufacturer_benefit_claims": "Designed to help square the face at impact and promote consistency, stability, accuracy, and feel.",
    "taper_profile": "standard",
    "texture_family": "microtexture",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "firm",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "wristlock (long)",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "White/Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 77.1
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 37.99,
    "price_max": 37.99,
    "single_price_min": 37.99,
    "single_price_max": 37.99,
    "normalized_price_per_grip": 37.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/super-stroke-wristlock-zenergy-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/Untitled_Project.jpg?v=1770917382",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "alignment_aid"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "White/Black"
        ],
        "price": 37.99,
        "per_grip_g": 77.1,
        "total_g": 77.1107029,
        "url": "https://www.grips4less.com/products/super-stroke-wristlock-zenergy-putter-grip",
        "handle": "super-stroke-wristlock-zenergy-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "White/Black",
              "White/Red",
              "Black/White",
              "Blue/White"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40495752970301",
            "gid": "gid://shopify/ProductVariant/40495752970301",
            "sku": "SS-083500",
            "color": "White/Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Black"
            },
            "available": true,
            "price": 37.99,
            "weight_g": 77.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-wristlock-zenergy-putter-grip?variant=40495752970301"
          },
          {
            "id": "40495753003069",
            "gid": "gid://shopify/ProductVariant/40495753003069",
            "sku": "SS-083502",
            "color": "White/Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "White/Red"
            },
            "available": true,
            "price": 37.99,
            "weight_g": 77.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-wristlock-zenergy-putter-grip?variant=40495753003069"
          },
          {
            "id": "40941143392317",
            "gid": "gid://shopify/ProductVariant/40941143392317",
            "sku": "SS-083501",
            "color": "Black/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black/White"
            },
            "available": true,
            "price": 37.99,
            "weight_g": 77.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-wristlock-zenergy-putter-grip?variant=40941143392317"
          },
          {
            "id": "61541514543474",
            "gid": "gid://shopify/ProductVariant/61541514543474",
            "sku": "SS-083503",
            "color": "Blue/White",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue/White"
            },
            "available": false,
            "price": 37.99,
            "weight_g": 77.1,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/super-stroke-wristlock-zenergy-putter-grip?variant=61541514543474"
          }
        ],
        "shopify_variant_count": 4,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-jan-overstock, 49 under, All Products, Brand_Super Stroke, golf-grips, golfers-gift-guide, laborday-2022, Long Putter, mid-ov-putter-sale, midsize, midsize-golf-grips, Model_Super Stroke Zenergy Wristlock, new arrivals, non-tapered, putter, putter grip, putter-grips, summer-overstock-2022, Supe",
    "source_quality": "manufacturer_family",
    "source_url": "https://superstrokeusa.com/products/traxion-pistol-gt-putter-grips",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": [
      "White/Black",
      "White/Red",
      "Black/White"
    ]
  },
  {
    "id": "tourmark-mexico-flag",
    "brand": "TourMark",
    "model": "Mexico Flag",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "oversize",
    "putter_size_class": "oversize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 21.99,
    "price_max": 21.99,
    "single_price_min": 21.99,
    "single_price_max": 21.99,
    "normalized_price_per_grip": 21.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/tourmark-mexico-flag-oversize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/tourmark-putter-mexico-flag.jpg?v=1571438533",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 21.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tourmark-mexico-flag-oversize-putter-grip",
        "handle": "tourmark-mexico-flag-oversize-putter-grip",
        "shopify_variants": [
          {
            "id": "52530396115",
            "gid": "gid://shopify/ProductVariant/52530396115",
            "sku": "TM-JO-MEX",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Oversize"
            },
            "available": false,
            "price": 21.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tourmark-mexico-flag-oversize-putter-grip?variant=52530396115"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Oversize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, jumbo/oversize, Mexico, Mexico Flag, New for 2016, New for 2017, oversize, oversize-jumbo-golf-grips, pistol, putter, putter grip, single-grip, Thunderbolt, tourmark, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "tourmark-rd2",
    "brand": "TourMark",
    "model": "RD2",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 22.46,
    "price_max": 22.46,
    "single_price_min": 22.46,
    "single_price_max": 22.46,
    "normalized_price_per_grip": 22.46,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/tourmark-rd2-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/RD2-allcolors.jpg?v=1735456419",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 22.46,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tourmark-rd2-putter-grip",
        "handle": "tourmark-rd2-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "3589482241",
            "gid": "gid://shopify/ProductVariant/3589482241",
            "sku": "GG-RD2-TM-BLK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 22.46,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tourmark-rd2-putter-grip?variant=3589482241"
          },
          {
            "id": "3589482305",
            "gid": "gid://shopify/ProductVariant/3589482305",
            "sku": "GG-RD2-TM-RED",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 22.46,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tourmark-rd2-putter-grip?variant=3589482305"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2023-sale, 49 under, All Products, golf-grips, infinite-opt-addkit, jumbo/oversize, non-tapered, oversize, oversize-jumbo-golf-grips, putter, RD Reverse Taper, RD2, single-grip, tourmark, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "tourmark-rd3",
    "brand": "TourMark",
    "model": "RD3",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 22.46,
    "price_max": 22.46,
    "single_price_min": 22.46,
    "single_price_max": 22.46,
    "normalized_price_per_grip": 22.46,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/tourmark-rd3-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/RD3-allcolors.jpg?v=1735456420",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 22.46,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tourmark-rd3-putter-grip",
        "handle": "tourmark-rd3-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "3589356097",
            "gid": "gid://shopify/ProductVariant/3589356097",
            "sku": "GG-RD3-TM-BLK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 22.46,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tourmark-rd3-putter-grip?variant=3589356097"
          },
          {
            "id": "3589356161",
            "gid": "gid://shopify/ProductVariant/3589356161",
            "sku": "GG-RD3-TM-RED",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 22.46,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tourmark-rd3-putter-grip?variant=3589356161"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2023-sale, 49 under, All Products, golf-grips, infinite-opt-addkit, jumbo/oversize, non-tapered, oversize, oversize-jumbo-golf-grips, putter, RD Reverse Taper, RD3, single-grip, tourmark, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "tourmark-rd5",
    "brand": "TourMark",
    "model": "RD5",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 22.46,
    "price_max": 22.46,
    "single_price_min": 22.46,
    "single_price_max": 22.46,
    "normalized_price_per_grip": 22.46,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/tourmark-rd5-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/RD5-allcolors.jpg?v=1735456421",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 22.46,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tourmark-rd5-putter-grip",
        "handle": "tourmark-rd5-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "3589069313",
            "gid": "gid://shopify/ProductVariant/3589069313",
            "sku": "GG-RD5-TM-BLK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 22.46,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tourmark-rd5-putter-grip?variant=3589069313"
          },
          {
            "id": "3589154433",
            "gid": "gid://shopify/ProductVariant/3589154433",
            "sku": "GG-RD5-TM-RED",
            "color": "Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 22.46,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/tourmark-rd5-putter-grip?variant=3589154433"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2023-sale, 49 under, All Products, golf-grips, infinite-opt-addkit, jumbo/oversize, non-tapered, oversize, oversize-jumbo-golf-grips, putter, RD Reverse Taper, RD5, single-grip, tourmark, under-150, under-300",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "tourmark-usa-flag",
    "brand": "TourMark",
    "model": "USA Flag",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Standard": 63.5,
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 17.99,
    "price_max": 24.99,
    "single_price_min": 17.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 17.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/tourmark-usa-flag-standard-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/usa-std.jpg?v=1627194149",
    "fit_tags": [],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [],
        "price": 17.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tourmark-usa-flag-standard-putter-grip",
        "handle": "tourmark-usa-flag-standard-putter-grip",
        "shopify_variants": [
          {
            "id": "41088045252669",
            "gid": "gid://shopify/ProductVariant/41088045252669",
            "sku": "TM-SS-USA",
            "color": "",
            "size": "Standard",
            "selected_options": {
              "Title": "Standard"
            },
            "available": false,
            "price": 17.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tourmark-usa-flag-standard-putter-grip?variant=41088045252669"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/tourmark-usa-flag-oversize-putter-grip",
        "handle": "tourmark-usa-flag-oversize-putter-grip",
        "shopify_variants": [
          {
            "id": "30398480391",
            "gid": "gid://shopify/ProductVariant/30398480391",
            "sku": "TM-JO-USA",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Title": "Oversize"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/tourmark-usa-flag-oversize-putter-grip?variant=30398480391"
          }
        ],
        "shopify_options": [
          {
            "name": "Title",
            "values": [
              "Oversize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, golf-grips, memsale2022, overstock-mar2024, pistol, putter, putter grip, putter-grips, single-grip, standard, standard-size-golf-grips, Thunderbolt, tourmark, under-150, under-300, usa, USA Flag",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "tourmark-usa-flag-ball-marker-compatible-with-tourmark-putter-grip",
    "brand": "TourMark",
    "model": "USA Flag BALL MARKER (compatible with TourMark Putter Grip)",
    "type": "putter",
    "spec_confidence": "derived",
    "material": "rubber",
    "texture": "smooth/textured",
    "feel": "medium",
    "tack": "moderate",
    "weather": "dry-biased",
    "alignment": "round (unconfirmed)",
    "alignment_type": "unknown",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "unknown",
    "cord_coverage": "none",
    "recommendation_eligible": "no",
    "exclusion_reason": "accessory",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "moderate",
    "weather_performance": "dry_preferred",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "oversize",
    "putter_size_class": "oversize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9,
    "price_max": 9,
    "single_price_min": 9,
    "single_price_max": 9,
    "normalized_price_per_grip": 9,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/usa-flag-ball-marker-compatible-with-tourmark-oversize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/usa-bm-800.jpg?v=1675446300",
    "fit_tags": [],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [],
        "price": 9,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/usa-flag-ball-marker-compatible-with-tourmark-oversize-putter-grip",
        "handle": "usa-flag-ball-marker-compatible-with-tourmark-oversize-putter-grip",
        "shopify_variants": [
          {
            "id": "41088034930749",
            "gid": "gid://shopify/ProductVariant/41088034930749",
            "sku": "TM-JO-USA-BM",
            "color": "",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Style": "USA Ball Marker (1pc)"
            },
            "available": false,
            "price": 9,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/usa-flag-ball-marker-compatible-with-tourmark-oversize-putter-grip?variant=41088034930749"
          }
        ],
        "shopify_options": [
          {
            "name": "Style",
            "values": [
              "USA Ball Marker (1pc)"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, ball marker, ball markers, golf ball markers, golf-grips, july4-2022, jumbo/oversize, memsale2022, New for 2016, New for 2017, oversize, oversize-jumbo-golf-grips, overstock-mar2024, pistol, putter, putter grip, putter-grips, tourmark, under-150, under-300, usa, USA Flag",
    "source_quality": "shopify_description",
    "source_url": "",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": true,
    "review_reason": "alignment not confirmed against a manufacturer source",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-15-counter-balance",
    "brand": "Winn",
    "model": "15\" Counter Balance",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Long"
    ],
    "manufacturer_size_labels": [
      "Long"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {
      "Long": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 21.39,
    "price_max": 21.39,
    "single_price_min": 21.39,
    "single_price_max": 21.39,
    "normalized_price_per_grip": 21.39,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-15-counter-balance-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/15-pistol-allcolors_7bb158c9-2114-43aa-93a6-b42fa5f622a3.jpeg?v=1740079885",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Long"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 21.39,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-15-counter-balance-putter-grip",
        "handle": "winn-15-counter-balance-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red",
              "Black"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "999721485",
            "gid": "gid://shopify/ProductVariant/999721485",
            "sku": "15P-RD",
            "color": "Red",
            "size": "Long",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 21.39,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-15-counter-balance-putter-grip?variant=999721485"
          },
          {
            "id": "999721493",
            "gid": "gid://shopify/ProductVariant/999721493",
            "sku": "15P-BK",
            "color": "Black",
            "size": "Long",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 21.39,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-15-counter-balance-putter-grip?variant=999721493"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "15\", 49 under, All Products, belly, Counter Balance, Counter Balance Putter, fathers-day-2021-sale, golf-grips, long, Long Putter, Long/Belly Putter, pistol, putter, putter grip, putter-grips, under-150, under-300, winn, Winn 15\", Winn Counter Balance Putter, Winn Long Putter",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red",
      "Black"
    ]
  },
  {
    "id": "winn-2020-vsn",
    "brand": "Winn",
    "model": "2020 VSN",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 11.49,
    "price_max": 11.49,
    "single_price_min": 11.49,
    "single_price_max": 11.49,
    "normalized_price_per_grip": 11.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-2020-vsn-midsize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-2020-vsn-midsize-putter-grips-3colors.jpg?v=1740079825",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 11.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-2020-vsn-midsize-putter-grip",
        "handle": "winn-2020-vsn-midsize-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue / Black",
              "Black / Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31506523553853",
            "gid": "gid://shopify/ProductVariant/31506523553853",
            "sku": "68WV-BK",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 11.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2020-vsn-midsize-putter-grip?variant=31506523553853"
          },
          {
            "id": "31506523586621",
            "gid": "gid://shopify/ProductVariant/31506523586621",
            "sku": "68WV-BLB",
            "color": "Blue / Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue / Black"
            },
            "available": false,
            "price": 15.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2020-vsn-midsize-putter-grip?variant=31506523586621"
          },
          {
            "id": "31506523619389",
            "gid": "gid://shopify/ProductVariant/31506523619389",
            "sku": "68WV-BRD",
            "color": "Black / Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": false,
            "price": 15.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2020-vsn-midsize-putter-grip?variant=31506523619389"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, fathers-day-2021-sale, golf-grips, midsize, midsize-golf-grips, putter, putter grip, putter-grips, under-150, under-300, winn, Winn 2020, Winn VSN Putter Grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-2020-vsn-jumbolite",
    "brand": "Winn",
    "model": "2020 VSN JumboLite",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Blue / Grey"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 18.99,
    "price_max": 18.99,
    "single_price_min": 18.99,
    "single_price_max": 18.99,
    "normalized_price_per_grip": 18.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-2020-vsn-jumbo-lite-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-2020-vsn-jumbolite-putter-grips-3colors.jpg?v=1740079824",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue / Grey"
        ],
        "price": 18.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-2020-vsn-jumbo-lite-putter-grip",
        "handle": "winn-2020-vsn-jumbo-lite-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue / Grey",
              "Red / Grey"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "31506523684925",
            "gid": "gid://shopify/ProductVariant/31506523684925",
            "sku": "J8LWV-BGR",
            "color": "Blue / Grey",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / Grey"
            },
            "available": false,
            "price": 18.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2020-vsn-jumbo-lite-putter-grip?variant=31506523684925"
          },
          {
            "id": "31506523717693",
            "gid": "gid://shopify/ProductVariant/31506523717693",
            "sku": "J8LWV-RGR",
            "color": "Red / Grey",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / Grey"
            },
            "available": false,
            "price": 18.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2020-vsn-jumbo-lite-putter-grip?variant=31506523717693"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, fathers-day-2021-sale, golf-grips, jumbo, oversize, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, putter-grips, under-150, under-300, winn, Winn 2020, Winn VSN Putter Grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-2020-vsn-medallist",
    "brand": "Winn",
    "model": "2020 VSN Medallist",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black / Red"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.99,
    "price_max": 13.99,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 13.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-2020-vsn-medallist-standard-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-2020-vsn-medallist-standard-putter-grip-2colors.jpg?v=1579736855",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black / Red"
        ],
        "price": 13.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-2020-vsn-medallist-standard-putter-grip",
        "handle": "winn-2020-vsn-medallist-standard-putter-grip",
        "shopify_variants": [
          {
            "id": "31506523521085",
            "gid": "gid://shopify/ProductVariant/31506523521085",
            "sku": "M8WV-BRD",
            "color": "Black / Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-2020-vsn-medallist-standard-putter-grip?variant=31506523521085"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black / Red"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, fathers-day-2021-sale, golf-grips, overstock-mar2024, putter, putter grip, putter-grips, standard, standard-size-golf-grips, under-150, under-300, winn, Winn 2020, Winn VSN Putter Grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black / Red"
    ]
  },
  {
    "id": "winn-dri-tac-lite-pistol",
    "brand": "Winn",
    "model": "Dri-Tac LITE Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Dark Gray"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 18.89,
    "price_max": 18.89,
    "single_price_min": 18.89,
    "single_price_max": 18.89,
    "normalized_price_per_grip": 18.89,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-dri-tac-jumbo-lite-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/J8LDT-DG_LEFT-1700.jpg?v=1740079857",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Dark Gray"
        ],
        "price": 18.89,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-jumbo-lite-pistol-putter-grip",
        "handle": "winn-dri-tac-jumbo-lite-pistol-putter-grip",
        "shopify_variants": [
          {
            "id": "897465581587",
            "gid": "gid://shopify/ProductVariant/897465581587",
            "sku": "J8LDT-DG",
            "color": "Dark Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Dark Gray"
            },
            "available": false,
            "price": 18.89,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-jumbo-lite-pistol-putter-grip?variant=897465581587"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, Dri-Tac Putter, dritac jumbo putter, dritac putter, fathers-day-2021-sale, golf-grips, jumbo, jumbo/oversize, Most Popular Oversize Putter Grips, New for 2018, oversize, oversize-jumbo-golf-grips, putter, putter grip, putter-grips, under-150, under-30",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "lighter weight",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-medallist-pistol",
    "brand": "Winn",
    "model": "Dri-Tac Medallist Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Dark Gray"
    ],
    "weight_g_by_size": {
      "Standard": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.39,
    "price_max": 13.39,
    "single_price_min": 13.39,
    "single_price_max": 13.39,
    "normalized_price_per_grip": 13.39,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-dri-tac-medallist-pistol-standard-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/M8DT-DG_LEFT-1700.jpg?v=1740079853",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Dark Gray"
        ],
        "price": 13.39,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-medallist-pistol-standard-putter-grip",
        "handle": "winn-dri-tac-medallist-pistol-standard-putter-grip",
        "shopify_variants": [
          {
            "id": "897465843731",
            "gid": "gid://shopify/ProductVariant/897465843731",
            "sku": "M8DT-DG",
            "color": "Dark Gray",
            "size": "Standard",
            "selected_options": {
              "Color": "Dark Gray",
              "Grip Size": "Standard"
            },
            "available": true,
            "price": 13.39,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-medallist-pistol-standard-putter-grip?variant=897465843731"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Standard"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, Dri-Tac Putter, dritac putter, fathers-day-2021-sale, golf-grips, New for 2018, putter, putter grip, putter-grips, standard, standard-size-golf-grips, under-150, under-300, winn, Winn Dri-Tac Putter, winn dritac, winn dritac putter",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Dark Gray"
    ]
  },
  {
    "id": "winn-dri-tac-pistol",
    "brand": "Winn",
    "model": "Dri-Tac Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Dark Gray"
    ],
    "weight_g_by_size": {
      "Midsize": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.79,
    "price_max": 13.79,
    "single_price_min": 13.79,
    "single_price_max": 13.79,
    "normalized_price_per_grip": 13.79,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-dri-tac-midsize-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/68DT-DG_LEFT-1700.jpg?v=1740079855",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Dark Gray"
        ],
        "price": 13.79,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-midsize-pistol-putter-grip",
        "handle": "winn-dri-tac-midsize-pistol-putter-grip",
        "shopify_variants": [
          {
            "id": "897465745427",
            "gid": "gid://shopify/ProductVariant/897465745427",
            "sku": "68DT-DG",
            "color": "Dark Gray",
            "size": "Midsize",
            "selected_options": {
              "Color": "Dark Gray",
              "Grip Size": "Midsize"
            },
            "available": false,
            "price": 13.79,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-midsize-pistol-putter-grip?variant=897465745427"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Dark Gray"
            ]
          },
          {
            "name": "Grip Size",
            "values": [
              "Midsize"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, asbl-putter-grip-option, Dri-Tac Putter, dritac midsize putter, dritac putter, dritac putter midsize, fathers-day-2021-sale, golf-grips, midsize, midsize-golf-grips, New for 2018, putter, putter grip, putter-grips, under-150, under-300, winn, Winn Dri-Tac Putter, winn dritac,",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-x-lite-pistol",
    "brand": "Winn",
    "model": "Dri-Tac X LITE Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Green / Black"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 14.99,
    "price_max": 14.99,
    "single_price_min": 14.99,
    "single_price_max": 14.99,
    "normalized_price_per_grip": 14.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-dri-tac-x-jumbo-lite-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-dritacx-ov-putter-grnblk_a7488ce3-8228-4a8d-bea6-43f86aecdca0.jpg?v=1675982028",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Green / Black"
        ],
        "price": 14.99,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-x-jumbo-lite-pistol-putter-grip",
        "handle": "winn-dri-tac-x-jumbo-lite-pistol-putter-grip",
        "shopify_variants": [
          {
            "id": "897465221139",
            "gid": "gid://shopify/ProductVariant/897465221139",
            "sku": "J8LDTX-GRB",
            "color": "Green / Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Green / Black"
            },
            "available": false,
            "price": 14.99,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-jumbo-lite-pistol-putter-grip?variant=897465221139"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green / Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, Dri-Tac X Putter, dritac jumbo putter, dritac putter, fathers-day-2021-sale, golf-grips, jumbo, jumbo/oversize, mid-ov-putter-sale, Most Popular Oversize Putter Grips, New for 2018, oversize, oversize-jumbo-golf-grips, putter, single-grip, under-150, under-300, winn, Winn Dri",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "lighter weight",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-x-medallist-pistol",
    "brand": "Winn",
    "model": "Dri-Tac X Medallist Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Green / Black"
    ],
    "weight_g_by_size": {
      "Standard": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 8.48,
    "price_max": 8.48,
    "single_price_min": 8.48,
    "single_price_max": 8.48,
    "normalized_price_per_grip": 8.48,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-dri-tac-x-medallist-pistol-standard-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-dritacx-std-putter-greenblk_bb40dfba-662c-4505-9ddc-ff4146d71d93.jpg?v=1658770889",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Green / Black"
        ],
        "price": 8.48,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-x-medallist-pistol-standard-putter-grip",
        "handle": "winn-dri-tac-x-medallist-pistol-standard-putter-grip",
        "shopify_variants": [
          {
            "id": "897465483283",
            "gid": "gid://shopify/ProductVariant/897465483283",
            "sku": "M8DTX-GRB",
            "color": "Green / Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Green / Black"
            },
            "available": false,
            "price": 8.48,
            "weight_g": 90.7,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-medallist-pistol-standard-putter-grip?variant=897465483283"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green / Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "49 under, All Products, Dri-Tac X Putter, dritac putter, fathers-day-2021-sale, golf-grips, New for 2018, putter, single-grip, standard, standard-size-golf-grips, under-150, under-300, winn, Winn Dri-Tac X Putter, winn dritac, winn dritac putter, Winn Dritac X",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-dri-tac-x-pistol",
    "brand": "Winn",
    "model": "Dri-Tac X Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "high",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "high",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Green / Black"
    ],
    "weight_g_by_size": {
      "Midsize": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 9.49,
    "price_max": 9.49,
    "single_price_min": 9.49,
    "single_price_max": 9.49,
    "normalized_price_per_grip": 9.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-dri-tac-x-midsize-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-dritacx-mid-putter-blu-red-grn_bbcc2d15-05d0-4d1e-8e8a-83c90324d5b5.jpg?v=1571438534",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Green / Black"
        ],
        "price": 9.49,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-dri-tac-x-midsize-pistol-putter-grip",
        "handle": "winn-dri-tac-x-midsize-pistol-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Green / Black",
              "Blue / Black",
              "Red / Black"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "897465352211",
            "gid": "gid://shopify/ProductVariant/897465352211",
            "sku": "68DTX-GRB",
            "color": "Green / Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Green / Black"
            },
            "available": false,
            "price": 9.49,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-midsize-pistol-putter-grip?variant=897465352211"
          },
          {
            "id": "897465384979",
            "gid": "gid://shopify/ProductVariant/897465384979",
            "sku": "68DTX-BLB",
            "color": "Blue / Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue / Black"
            },
            "available": false,
            "price": 9.49,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-midsize-pistol-putter-grip?variant=897465384979"
          },
          {
            "id": "897465417747",
            "gid": "gid://shopify/ProductVariant/897465417747",
            "sku": "68DTX-RDB",
            "color": "Red / Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red / Black"
            },
            "available": false,
            "price": 9.49,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-dri-tac-x-midsize-pistol-putter-grip?variant=897465417747"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, Dri-Tac X Putter, dritac midsize putter, dritac putter, dritac putter midsize, fathers-day-2021-sale, golf-grips, infinite-opt-addkit, mid-ov-putter-sale, midsize, midsize-golf-grips, New for 2018, putter, single-grip, under-150, under-300, winn, Winn Dri-Tac X Putter, winn d",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "shock-absorbing; joint-friendly",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-excel-2-piece-split",
    "brand": "Winn",
    "model": "Excel 2-Piece Split",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer",
    "texture": "textured",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Default"
    ],
    "manufacturer_size_labels": [
      "Default"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Default": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 24.99,
    "price_max": 24.99,
    "single_price_min": 24.99,
    "single_price_max": 24.99,
    "normalized_price_per_grip": 24.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-excel-2-piece-split-long-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/2PWR-BKG-1700.jpg?v=1740079848",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 24.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-excel-2-piece-split-long-putter-grip",
        "handle": "winn-excel-2-piece-split-long-putter-grip",
        "shopify_variants": [
          {
            "id": "13784486182973",
            "gid": "gid://shopify/ProductVariant/13784486182973",
            "sku": "2PWR-BKG",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": false,
            "price": 24.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-excel-2-piece-split-long-putter-grip?variant=13784486182973"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2 piece, 2-pc, 2-piece putter grips, 49 under, All Products, belly, fathers-day-2021-sale, golf-grips, long, Long Putter, Long/Belly Putter, putter, putter grip, putter-grips, split, two piece, under-150, under-300, winn, Winn 2-Piece, Winn Long Putter",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-excel-21-pistol-counterbalance",
    "brand": "Winn",
    "model": "Excel 21\" Pistol / CounterBalance",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer",
    "texture": "textured",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Default"
    ],
    "manufacturer_size_labels": [
      "Default"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Default": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 23.79,
    "price_max": 23.79,
    "single_price_min": 23.79,
    "single_price_max": 23.79,
    "normalized_price_per_grip": 23.79,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-21-pistol-long-counterbalance-belly-putter-red-black",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/62P21-RB-part2-1700.jpg?v=1740079903",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 23.79,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-21-pistol-long-counterbalance-belly-putter-red-black",
        "handle": "winn-21-pistol-long-counterbalance-belly-putter-red-black",
        "shopify_variants": [
          {
            "id": "397708633",
            "gid": "gid://shopify/ProductVariant/397708633",
            "sku": "62P21-RB",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 23.79,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-21-pistol-long-counterbalance-belly-putter-red-black?variant=397708633"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "21, 49 under, All Products, belly, fathers-day-2021-sale, golf-grips, long, Long Putter, Long/Belly Putter, pistol, putter, putter grip, putter-grips, under-150, under-300, winn, Winn 21\", Winn Long Putter",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-excel-tour-pistol",
    "brand": "Winn",
    "model": "Excel Tour Pistol",
    "type": "putter",
    "spec_confidence": "verified_model",
    "material": "WinnDry polymer",
    "texture": "textured",
    "feel": "medium",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "balanced",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "slim/standard",
    "putter_size_class": "slim/standard",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Standard"
    ],
    "manufacturer_size_labels": [
      "Standard"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Red"
    ],
    "weight_g_by_size": {
      "Standard": 90.7
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.39,
    "price_max": 13.39,
    "single_price_min": 13.39,
    "single_price_max": 13.39,
    "normalized_price_per_grip": 13.39,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-excel-tour-pistol-standard-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/excel-tour-pistol-std-allcolors_grande2_981806e2-2c43-4795-b352-42b6f2fd137e.jpg?v=1740079865",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Standard"
        ],
        "format": "single",
        "colors": [
          "Red"
        ],
        "price": 13.39,
        "per_grip_g": 90.7,
        "total_g": 90.718474,
        "url": "https://www.grips4less.com/products/winn-excel-tour-pistol-standard-putter-grip",
        "handle": "winn-excel-tour-pistol-standard-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red",
              "Black",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "11822107719",
            "gid": "gid://shopify/ProductVariant/11822107719",
            "sku": "TPM-RD",
            "color": "Red",
            "size": "Standard",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 13.39,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-excel-tour-pistol-standard-putter-grip?variant=11822107719"
          },
          {
            "id": "11822205767",
            "gid": "gid://shopify/ProductVariant/11822205767",
            "sku": "TPM-BK",
            "color": "Black",
            "size": "Standard",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 13.39,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-excel-tour-pistol-standard-putter-grip?variant=11822205767"
          },
          {
            "id": "11822205895",
            "gid": "gid://shopify/ProductVariant/11822205895",
            "sku": "TPM-BL",
            "color": "Blue",
            "size": "Standard",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 13.39,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-excel-tour-pistol-standard-putter-grip?variant=11822205895"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, excel, Excel Putter, fathers-day-2021-sale, golf-grips, pistol, putter, putter grip, putter-grips, standard, Standard Pistol Putter, standard-size-golf-grips, under-150, under-300, winn, Winn Excel Putter",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-medallist-pistol",
    "brand": "Winn",
    "model": "Medallist Pistol",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 13.99,
    "price_max": 13.99,
    "single_price_min": 13.99,
    "single_price_max": 13.99,
    "normalized_price_per_grip": 13.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-2024-medallist-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/winn-medallist-pistol-putter-grip-allcolors.jpg?v=1740079790",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 13.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-2024-medallist-pistol-putter-grip",
        "handle": "winn-2024-medallist-pistol-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Black / Red",
              "Black / Pink"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40947416498237",
            "gid": "gid://shopify/ProductVariant/40947416498237",
            "sku": "M8-BK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2024-medallist-pistol-putter-grip?variant=40947416498237"
          },
          {
            "id": "40947416531005",
            "gid": "gid://shopify/ProductVariant/40947416531005",
            "sku": "M8-BRD",
            "color": "Black / Red",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Red"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2024-medallist-pistol-putter-grip?variant=40947416531005"
          },
          {
            "id": "40947416563773",
            "gid": "gid://shopify/ProductVariant/40947416563773",
            "sku": "M8-BPK",
            "color": "Black / Pink",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Pink"
            },
            "available": true,
            "price": 13.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2024-medallist-pistol-putter-grip?variant=40947416563773"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, fathers-day-2021-sale, golf-grips, putter, putter grip, putter-grips, standard, standard-size-golf-grips, under-150, under-300, winn, Winn 2024, Winn Pistol Putter Grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Black / Red",
      "Black / Pink"
    ]
  },
  {
    "id": "winn-ntp-1-10",
    "brand": "Winn",
    "model": "NTP 1.10\"",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "midsize",
    "putter_size_class": "midsize",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black"
    ],
    "weight_g_by_size": {
      "Midsize": 127
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 19.99,
    "price_max": 19.99,
    "single_price_min": 19.99,
    "single_price_max": 19.99,
    "normalized_price_per_grip": 19.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-ntp-1-10-midsize-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/winn-ntp-putter-all-colors.jpg?v=1740079844",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 19.99,
        "per_grip_g": 127,
        "total_g": 127.0058636,
        "url": "https://www.grips4less.com/products/winn-ntp-1-10-midsize-putter-grip",
        "handle": "winn-ntp-1-10-midsize-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "14089254305853",
            "gid": "gid://shopify/ProductVariant/14089254305853",
            "sku": "NTP-BK",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-ntp-1-10-midsize-putter-grip?variant=14089254305853"
          },
          {
            "id": "14089264988221",
            "gid": "gid://shopify/ProductVariant/14089264988221",
            "sku": "NTP-BL",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-ntp-1-10-midsize-putter-grip?variant=14089264988221"
          },
          {
            "id": "14089265020989",
            "gid": "gid://shopify/ProductVariant/14089265020989",
            "sku": "NTP-RD",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": false,
            "price": 19.99,
            "weight_g": 127,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-ntp-1-10-midsize-putter-grip?variant=14089265020989"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, excel, Excel Putter, fathers-day-2021-sale, golf-grips, midsize, Midsize Pistol Putter, midsize-golf-grips, New 2019 Golf Grips, non-tapered, NTP, NTP putter, pistol, putter, putter grip, putter-grips, under-150, under-300, winn, Winn Excel Putter, Winn NTP, Winn NTP Putter",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-pistol",
    "brand": "Winn",
    "model": "Pistol",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "moderate",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "jumbo",
    "putter_size_class": "jumbo",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Jumbo/Oversize",
      "Midsize"
    ],
    "manufacturer_size_labels": [
      "Jumbo/Oversize",
      "Midsize"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black",
      "Navy / Gray"
    ],
    "weight_g_by_size": {
      "Jumbo/Oversize": 63.5,
      "Midsize": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 10.65,
    "price_max": 21.39,
    "single_price_min": 10.65,
    "single_price_max": 21.39,
    "normalized_price_per_grip": 10.65,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-2024-jumbo-pistol-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/winn-jumbo-pistol-putter-grip-allcolors.jpg?v=1740079788",
    "fit_tags": [
      "best_for_arthritis",
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 3,
    "variants": [
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 21.39,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-2024-jumbo-pistol-putter-grip",
        "handle": "winn-2024-jumbo-pistol-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40947416694845",
            "gid": "gid://shopify/ProductVariant/40947416694845",
            "sku": "J8L-BK",
            "color": "Black",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 21.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2024-jumbo-pistol-putter-grip?variant=40947416694845"
          },
          {
            "id": "40947416727613",
            "gid": "gid://shopify/ProductVariant/40947416727613",
            "sku": "J8L-BL",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": false,
            "price": 21.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2024-jumbo-pistol-putter-grip?variant=40947416727613"
          },
          {
            "id": "40947416760381",
            "gid": "gid://shopify/ProductVariant/40947416760381",
            "sku": "J8L-RD",
            "color": "Red",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 21.39,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2024-jumbo-pistol-putter-grip?variant=40947416760381"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Midsize"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 16.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-2024-midsize-pistol-putter-grip",
        "handle": "winn-2024-midsize-pistol-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Blue",
              "Red"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "40947416596541",
            "gid": "gid://shopify/ProductVariant/40947416596541",
            "sku": "68-BK",
            "color": "Black",
            "size": "Midsize",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 16.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2024-midsize-pistol-putter-grip?variant=40947416596541"
          },
          {
            "id": "40947416629309",
            "gid": "gid://shopify/ProductVariant/40947416629309",
            "sku": "68-BL",
            "color": "Blue",
            "size": "Midsize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 16.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2024-midsize-pistol-putter-grip?variant=40947416629309"
          },
          {
            "id": "40947416662077",
            "gid": "gid://shopify/ProductVariant/40947416662077",
            "sku": "68-RD",
            "color": "Red",
            "size": "Midsize",
            "selected_options": {
              "Color": "Red"
            },
            "available": true,
            "price": 16.49,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-2024-midsize-pistol-putter-grip?variant=40947416662077"
          }
        ],
        "shopify_variant_count": 3,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Jumbo/Oversize"
        ],
        "format": "single",
        "colors": [
          "Navy / Gray"
        ],
        "price": 10.65,
        "per_grip_g": 91,
        "total_g": 90.990629422,
        "url": "https://www.grips4less.com/products/winn-jumbo-pistol-putter-grip",
        "handle": "winn-jumbo-pistol-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Navy / Gray",
              "Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39461772820541",
            "gid": "gid://shopify/ProductVariant/39461772820541",
            "sku": "J8LWS-NYG",
            "color": "Navy / Gray",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Navy / Gray"
            },
            "available": true,
            "price": 10.65,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-jumbo-pistol-putter-grip?variant=39461772820541"
          },
          {
            "id": "39461772853309",
            "gid": "gid://shopify/ProductVariant/39461772853309",
            "sku": "J8LWS-BL",
            "color": "Blue",
            "size": "Jumbo/Oversize",
            "selected_options": {
              "Color": "Blue"
            },
            "available": true,
            "price": 9.2,
            "weight_g": 90.7,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-jumbo-pistol-putter-grip?variant=39461772853309"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "49 under, All Products, fathers-day-2021-sale, golf-grips, jumbo, oversize, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, putter-grips, under-150, under-300, winn, Winn 2024, Winn Midsize Pistol Putter Grip",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Red",
      "Blue",
      "Navy / Gray"
    ]
  },
  {
    "id": "winn-winndry-17-pistol-counterbalance",
    "brand": "Winn",
    "model": "WinnDry 17\" Pistol CounterBalance /",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "basic",
    "non_black_color_count": 0,
    "durability_level": "unknown",
    "putter_shape": "pistol",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Default"
    ],
    "manufacturer_size_labels": [
      "Default"
    ],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [],
    "weight_g_by_size": {
      "Default": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 22.49,
    "price_max": 22.49,
    "single_price_min": 22.49,
    "single_price_max": 22.49,
    "normalized_price_per_grip": 22.49,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-winndry-17-pistol-counterbalance-long-putter-grip",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/files/17WR-DG-1700.jpg?v=1740079846",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 1,
    "variants": [
      {
        "size": [
          "Default"
        ],
        "format": "single",
        "colors": [],
        "price": 22.49,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-winndry-17-pistol-counterbalance-long-putter-grip",
        "handle": "winn-winndry-17-pistol-counterbalance-long-putter-grip",
        "shopify_variants": [
          {
            "id": "13784580816957",
            "gid": "gid://shopify/ProductVariant/13784580816957",
            "sku": "17WR-DG",
            "color": "",
            "size": "Default",
            "selected_options": {
              "Size": "Default"
            },
            "available": true,
            "price": 22.49,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-winndry-17-pistol-counterbalance-long-putter-grip?variant=13784580816957"
          }
        ],
        "shopify_options": [
          {
            "name": "Size",
            "values": [
              "Default"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "17, 49 under, All Products, belly, Counter Balance, Counter Balance Putter, fathers-day-2021-sale, golf-grips, iron/wood, long, Long Putter, Long/Belly Putter, putter, putter grip, putter-grips, under-150, under-300, winn, Winn 17\", Winn Counter Balance Putter, Winn Long Putter",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": []
  },
  {
    "id": "winn-winnpro-x-1-18",
    "brand": "Winn",
    "model": "WinnPro X 1.18\"",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black",
      "Blue / Cool Gray"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 19.99,
    "price_max": 22.69,
    "single_price_min": 19.99,
    "single_price_max": 22.69,
    "normalized_price_per_grip": 19.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-winnpro-x-1-18-putter-grip-2022-new",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2022-winn-winnprox-1-18.jpg?v=1740079794",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 22.69,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-winnpro-x-1-18-putter-grip-2022-new",
        "handle": "winn-winnpro-x-1-18-putter-grip-2022-new",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Dark Gray"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39773521870909",
            "gid": "gid://shopify/ProductVariant/39773521870909",
            "sku": "WPX18-BK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 22.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-18-putter-grip-2022-new?variant=39773521870909"
          },
          {
            "id": "39773521903677",
            "gid": "gid://shopify/ProductVariant/39773521903677",
            "sku": "WPX18-DG",
            "color": "Dark Gray",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Dark Gray"
            },
            "available": false,
            "price": 22.69,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-18-putter-grip-2022-new?variant=39773521903677"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue / Cool Gray"
        ],
        "price": 19.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-winnpro-x-1-18-putter-grip",
        "handle": "winn-winnpro-x-1-18-putter-grip",
        "shopify_variants": [
          {
            "id": "403386849",
            "gid": "gid://shopify/ProductVariant/403386849",
            "sku": "WPX18-BCG",
            "color": "Blue / Cool Gray",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / Cool Gray"
            },
            "available": true,
            "price": 19.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-18-putter-grip?variant=403386849"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue / Cool Gray"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2022-winn, 49 under, All Products, Excel Putter, fathers-day-2021-sale, golf-grips, midsize, midsize-golf-grips, New for 2014, non-tapered, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, under-150, under-300, winn, Winn WinnPro X, Winn WinnPro X (Excel) Putter, winnpro x, Wi",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Blue / Cool Gray"
    ]
  },
  {
    "id": "winn-winnpro-x-1-32",
    "brand": "Winn",
    "model": "WinnPro X 1.32\"",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black",
      "Red / Gray"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 20.99,
    "price_max": 24.19,
    "single_price_min": 20.99,
    "single_price_max": 24.19,
    "normalized_price_per_grip": 20.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-winnpro-x-1-32-putter-grip-2022-new",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2022-winn-winnprox-1-32.jpg?v=1740079793",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 24.19,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-winnpro-x-1-32-putter-grip-2022-new",
        "handle": "winn-winnpro-x-1-32-putter-grip-2022-new",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Dark Gray"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39773521936445",
            "gid": "gid://shopify/ProductVariant/39773521936445",
            "sku": "WPX32-BK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": false,
            "price": 24.19,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-32-putter-grip-2022-new?variant=39773521936445"
          },
          {
            "id": "39773521969213",
            "gid": "gid://shopify/ProductVariant/39773521969213",
            "sku": "WPX32-DG",
            "color": "Dark Gray",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Dark Gray"
            },
            "available": true,
            "price": 24.19,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-32-putter-grip-2022-new?variant=39773521969213"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Red / Gray"
        ],
        "price": 20.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-winnpro-x-1-32-putter-grip",
        "handle": "winn-winnpro-x-1-32-putter-grip",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Red / Gray",
              "Black / Blue"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "403382465",
            "gid": "gid://shopify/ProductVariant/403382465",
            "sku": "WPX32-RGY",
            "color": "Red / Gray",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Red / Gray"
            },
            "available": false,
            "price": 20.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-32-putter-grip?variant=403382465"
          },
          {
            "id": "403369717",
            "gid": "gid://shopify/ProductVariant/403369717",
            "sku": "WPX32-BKB",
            "color": "Black / Blue",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black / Blue"
            },
            "available": false,
            "price": 20.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-32-putter-grip?variant=403369717"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      }
    ],
    "source_tags": "2022-winn, 49 under, All Products, Excel Putter, fathers-day-2021-sale, golf-grips, jumbo/oversize, midsize, midsize-golf-grips, New for 2014, non-tapered, oversize, oversize-golf-grips, oversize-jumbo-golf-grips, oversize/jumbo, putter, putter grip, putter-grips, Size_Jumbo/Oversize, under-150, und",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Dark Gray"
    ]
  },
  {
    "id": "winn-winnpro-x-1-60",
    "brand": "Winn",
    "model": "WinnPro X 1.60\"",
    "type": "putter",
    "spec_confidence": "verified_brand_default",
    "material": "WinnDry polymer (no cord)",
    "texture": "textured",
    "feel": "soft",
    "tack": "high",
    "weather": "all-weather",
    "alignment": "round",
    "alignment_type": "round",
    "alignment_technology": "none",
    "alignment_description": "",
    "manufacturer_benefit_claims": "",
    "taper_profile": "standard",
    "texture_family": "textured_rubber",
    "cord_coverage": "none",
    "recommendation_eligible": "yes",
    "exclusion_reason": "",
    "feel_profile": "soft",
    "feel_description": "",
    "tack_level": "high",
    "weather_performance": "humid_sweat",
    "cushioning_level": "unknown",
    "vibration_dampening": "unknown",
    "reduced_pressure_support": "low",
    "style_level": "multiple_colors",
    "non_black_color_count": 1,
    "durability_level": "unknown",
    "putter_shape": "unconfirmed",
    "putter_size": "unconfirmed",
    "putter_size_class": "unconfirmed",
    "putter_weight_class": "unknown",
    "wrist_stability_level": "unknown",
    "sources": [
      "https://www.winngrips.com/products/dri-tac/dri-tac-standard/"
    ],
    "sizes_available": [
      "Unspecified"
    ],
    "manufacturer_size_labels": [],
    "live_sizes_available": [],
    "formats_available": [
      "single"
    ],
    "colors_available": [
      "Black",
      "Blue / Black"
    ],
    "weight_g_by_size": {
      "Unspecified": 63.5
    },
    "weight_source": "shopify_single_variant",
    "weight_confidence": "medium",
    "price_min": 23.99,
    "price_max": 26.99,
    "single_price_min": 23.99,
    "single_price_max": 26.99,
    "normalized_price_per_grip": 23.99,
    "bundle_price_min": null,
    "kit_price_min": null,
    "url": "https://www.grips4less.com/products/winn-winnpro-x-1-60-putter-grip-2022-new",
    "image": "https://cdn.shopify.com/s/files/1/0095/7552/products/2022-winn-winnprox-1-60.jpg?v=1740079792",
    "fit_tags": [
      "best_for_sweat",
      "best_for_wet",
      "high_tack",
      "soft_feel"
    ],
    "product_count": 2,
    "variants": [
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Black"
        ],
        "price": 26.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-winnpro-x-1-60-putter-grip-2022-new",
        "handle": "winn-winnpro-x-1-60-putter-grip-2022-new",
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Black",
              "Dark Gray"
            ]
          }
        ],
        "shopify_variants": [
          {
            "id": "39773522001981",
            "gid": "gid://shopify/ProductVariant/39773522001981",
            "sku": "WPX60-BK",
            "color": "Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Black"
            },
            "available": true,
            "price": 26.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-60-putter-grip-2022-new?variant=39773522001981"
          },
          {
            "id": "39773522034749",
            "gid": "gid://shopify/ProductVariant/39773522034749",
            "sku": "WPX60-DG",
            "color": "Dark Gray",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Dark Gray"
            },
            "available": true,
            "price": 26.99,
            "weight_g": 63.5,
            "weight_unit": "POUNDS",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-60-putter-grip-2022-new?variant=39773522034749"
          }
        ],
        "shopify_variant_count": 2,
        "shopify_variant_mapping_source": "_live_variant_details_ALL_765"
      },
      {
        "size": [
          "Unspecified"
        ],
        "format": "single",
        "colors": [
          "Blue / Black"
        ],
        "price": 23.99,
        "per_grip_g": 63.5,
        "total_g": 63.5029318,
        "url": "https://www.grips4less.com/products/winn-winnpro-x-1-60-putter-grip",
        "handle": "winn-winnpro-x-1-60-putter-grip",
        "shopify_variants": [
          {
            "id": "403396197",
            "gid": "gid://shopify/ProductVariant/403396197",
            "sku": "WPX60-BBK",
            "color": "Blue / Black",
            "size": "Unspecified",
            "selected_options": {
              "Color": "Blue / Black"
            },
            "available": false,
            "price": 23.99,
            "weight_g": 63.5,
            "weight_unit": "pounds",
            "url": "https://www.grips4less.com/products/winn-winnpro-x-1-60-putter-grip?variant=403396197"
          }
        ],
        "shopify_options": [
          {
            "name": "Color",
            "values": [
              "Blue / Black"
            ]
          }
        ],
        "shopify_variant_count": 1,
        "shopify_variant_mapping_source": "live_admin_graphql_gap_fill_2026-07-16"
      }
    ],
    "source_tags": "2022-winn, 49 under, All Products, Excel Putter, fathers-day-2021-sale, fathers-day-gifts, golf-grips, jumbo/oversize, non-tapered, putter, putter grip, putter grip gift, putter-grip-gifts, putter-grips, under-150, under-300, winn, Winn WinnPro X (Excel) Putter, WinnPro X",
    "source_quality": "manufacturer_family",
    "source_url": "https://www.winngrips.com/products/dri-tac/dri-tac-standard/",
    "last_verified_date": "",
    "manual_notes": "",
    "needs_review": false,
    "review_reason": "",
    "default_color_by_size": {},
    "live_colors_available": [
      "Black",
      "Dark Gray"
    ]
  }
];